webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(1);
	var http_1 = __webpack_require__(111);
	var platform_browser_dynamic_1 = __webpack_require__(255);
	var app_component_1 = __webpack_require__(349);
	var app_routes_1 = __webpack_require__(1120);
	var forms_1 = __webpack_require__(643);
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.bootstrap(app_component_1.AppComponent, [
	    app_routes_1.APP_ROUTER_PROVIDERS,
	    http_1.HTTP_PROVIDERS,
	    forms_1.disableDeprecatedForms(),
	    forms_1.provideForms()
	]);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var observableBackend_service_1 = __webpack_require__(402);
	var navigation_service_1 = __webpack_require__(403);
	var login_service_1 = __webpack_require__(404);
	var vehicles_service_1 = __webpack_require__(630);
	var bank_service_1 = __webpack_require__(631);
	var contracts_service_1 = __webpack_require__(632);
	var cities_service_1 = __webpack_require__(633);
	var infractions_service_1 = __webpack_require__(634);
	var roles_service_1 = __webpack_require__(635);
	var operators_service_1 = __webpack_require__(636);
	var client_service_1 = __webpack_require__(637);
	var index_component_1 = __webpack_require__(638);
	var home_component_1 = __webpack_require__(855);
	var directives_1 = __webpack_require__(933);
	var vehicle_editor_component_1 = __webpack_require__(935);
	var contract_editor_component_1 = __webpack_require__(938);
	var infraction_editor_component_1 = __webpack_require__(941);
	var config_panel_component_1 = __webpack_require__(944);
	var under_construction_component_1 = __webpack_require__(946);
	__webpack_require__(949);
	__webpack_require__(958);
	__webpack_require__(984);
	__webpack_require__(986);
	var config_banks_component_1 = __webpack_require__(988);
	var bank_editor_component_1 = __webpack_require__(990);
	var config_roles_component_1 = __webpack_require__(994);
	var rol_editor_component_1 = __webpack_require__(997);
	var config_operators_component_1 = __webpack_require__(1000);
	var operator_editor_component_1 = __webpack_require__(1002);
	var client_panel_component_1 = __webpack_require__(1004);
	var payReceipt_component_1 = __webpack_require__(1007);
	var config_infractionTypes_component_1 = __webpack_require__(1011);
	var infractionType_service_1 = __webpack_require__(1024);
	var infractionType_editor_component_1 = __webpack_require__(1027);
	var config_clientDocuments_component_1 = __webpack_require__(1032);
	var clientDocument_service_1 = __webpack_require__(1005);
	var config_mailTemplates_component_1 = __webpack_require__(1035);
	var mailTemplate_service_1 = __webpack_require__(1039);
	var actionTrigger_service_1 = __webpack_require__(1040);
	var mailTemplate_editor_component_1 = __webpack_require__(1043);
	var mailReceiverType_service_1 = __webpack_require__(1044);
	var config_state_component_1 = __webpack_require__(1058);
	var state_editor_component_1 = __webpack_require__(1061);
	var kmHistory_service_1 = __webpack_require__(912);
	var patentPayment_service_1 = __webpack_require__(920);
	var procedure_service_1 = __webpack_require__(916);
	var kmHistory_editor_component_1 = __webpack_require__(1064);
	var patentPayment_editor_component_1 = __webpack_require__(1067);
	var agenda_service_1 = __webpack_require__(924);
	var mailTemplateProperty_service_1 = __webpack_require__(1053);
	var mailTemplateTag_service_1 = __webpack_require__(1054);
	var vehicleBrand_service_1 = __webpack_require__(1099);
	var vehicleBrand_editor_component_1 = __webpack_require__(1100);
	var config_vehicleBrands_component_1 = __webpack_require__(1102);
	var tabSelected_service_1 = __webpack_require__(858);
	var config_clientProcedureDocuments_component_1 = __webpack_require__(1104);
	var config_clientKmDocuments_component_1 = __webpack_require__(1105);
	var config_clientPatentDocuments_component_1 = __webpack_require__(1106);
	var singleProcedures_editor_component_1 = __webpack_require__(1107);
	var procedures_editor_component_1 = __webpack_require__(1110);
	var procedures_new_component_1 = __webpack_require__(1113);
	var requestProcedure_component_1 = __webpack_require__(1116);
	var AppComponent = (function () {
	    function AppComponent(viewContainerRef) {
	        // You need this small hack in order to catch application root view container ref
	        this.viewContainerRef = viewContainerRef;
	    }
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: "\n        <div class=\"container\">\n            <router-outlet></router-outlet>\n        </div>\n    ",
	            directives: [
	                directives_1.FaDirective,
	                router_1.ROUTER_DIRECTIVES
	            ],
	            providers: [
	                navigation_service_1.NavigationService,
	                observableBackend_service_1.ObservableBackendService,
	                login_service_1.LoginService,
	                vehicles_service_1.VehiclesService,
	                infractionType_service_1.InfractionTypeService,
	                bank_service_1.BankService,
	                contracts_service_1.ContractsService,
	                cities_service_1.CitiesService,
	                infractions_service_1.InfractionsService,
	                roles_service_1.RolesService,
	                operators_service_1.OperatorsService,
	                client_service_1.ClientService,
	                clientDocument_service_1.ClientDocumentService,
	                mailTemplate_service_1.MailTemplateService,
	                actionTrigger_service_1.ActionTriggerService,
	                mailReceiverType_service_1.MailReceiverTypeService,
	                kmHistory_service_1.KmHistoryService,
	                patentPayment_service_1.PatentPaymentService,
	                procedure_service_1.ProcedureService,
	                agenda_service_1.AgendaService,
	                mailTemplateProperty_service_1.MailTemplatePropertyService,
	                mailTemplateTag_service_1.MailTemplateTagService,
	                vehicleBrand_service_1.VehicleBrandService,
	                tabSelected_service_1.TabSelectedService
	            ],
	            precompile: [
	                index_component_1.IndexComponent,
	                home_component_1.HomeComponent,
	                vehicle_editor_component_1.VehicleEditorComponent,
	                contract_editor_component_1.ContractEditorComponent,
	                infraction_editor_component_1.InfractionEditorComponent,
	                config_panel_component_1.ConfigPanel,
	                under_construction_component_1.UnderConstruction,
	                config_infractionTypes_component_1.ConfigInfractionTypesComponent,
	                infractionType_editor_component_1.InfractionTypeEditorComponent,
	                config_banks_component_1.ConfigBanksComponent,
	                bank_editor_component_1.BankEditorComponent,
	                config_roles_component_1.ConfigRolesComponent,
	                rol_editor_component_1.RolEditorComponent,
	                config_operators_component_1.ConfigOperatorsComponent,
	                operator_editor_component_1.OperatorEditorComponent,
	                config_clientDocuments_component_1.ConfigClientDocumentsComponent,
	                config_mailTemplates_component_1.ConfigMailTemplatesComponent,
	                mailTemplate_editor_component_1.MailTemplateEditorComponent,
	                client_panel_component_1.ClientPanel,
	                payReceipt_component_1.PayReceiptComponent,
	                config_state_component_1.ConfigStateComponent,
	                state_editor_component_1.StateEditorComponent,
	                kmHistory_editor_component_1.KmHistoryEditorComponent,
	                patentPayment_editor_component_1.PatentPaymentEditorComponent,
	                vehicleBrand_editor_component_1.VehicleBrandEditorComponent,
	                config_vehicleBrands_component_1.ConfigVehicleBrandsComponent,
	                config_clientProcedureDocuments_component_1.ConfigClientProcedureDocumentsComponent,
	                config_clientKmDocuments_component_1.ConfigClientKmDocumentsComponent,
	                config_clientPatentDocuments_component_1.ConfigClientPatentDocumentsComponent,
	                singleProcedures_editor_component_1.SingleProcedureEditorComponent,
	                procedures_editor_component_1.ProcedureEditorComponent,
	                procedures_new_component_1.ProcedureNewComponent,
	                requestProcedure_component_1.RequestProcedureComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [core_1.ViewContainerRef])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var router_link_1 = __webpack_require__(351);
	var router_link_active_1 = __webpack_require__(398);
	var router_outlet_1 = __webpack_require__(399);
	var router_link_2 = __webpack_require__(351);
	exports.RouterLink = router_link_2.RouterLink;
	exports.RouterLinkWithHref = router_link_2.RouterLinkWithHref;
	var router_link_active_2 = __webpack_require__(398);
	exports.RouterLinkActive = router_link_active_2.RouterLinkActive;
	var router_outlet_2 = __webpack_require__(399);
	exports.RouterOutlet = router_outlet_2.RouterOutlet;
	var router_1 = __webpack_require__(352);
	exports.NavigationCancel = router_1.NavigationCancel;
	exports.NavigationEnd = router_1.NavigationEnd;
	exports.NavigationError = router_1.NavigationError;
	exports.NavigationStart = router_1.NavigationStart;
	exports.Router = router_1.Router;
	exports.RoutesRecognized = router_1.RoutesRecognized;
	var router_outlet_map_1 = __webpack_require__(397);
	exports.RouterOutletMap = router_outlet_map_1.RouterOutletMap;
	var router_providers_1 = __webpack_require__(400);
	exports.provideRouter = router_providers_1.provideRouter;
	var router_state_1 = __webpack_require__(390);
	exports.ActivatedRoute = router_state_1.ActivatedRoute;
	exports.ActivatedRouteSnapshot = router_state_1.ActivatedRouteSnapshot;
	exports.RouterState = router_state_1.RouterState;
	exports.RouterStateSnapshot = router_state_1.RouterStateSnapshot;
	var shared_1 = __webpack_require__(384);
	exports.PRIMARY_OUTLET = shared_1.PRIMARY_OUTLET;
	var url_tree_1 = __webpack_require__(385);
	exports.DefaultUrlSerializer = url_tree_1.DefaultUrlSerializer;
	exports.UrlPathWithParams = url_tree_1.UrlPathWithParams;
	exports.UrlSerializer = url_tree_1.UrlSerializer;
	exports.UrlTree = url_tree_1.UrlTree;
	/**
	 * @stable
	 */
	exports.ROUTER_DIRECTIVES = [router_outlet_1.RouterOutlet, router_link_1.RouterLink, router_link_1.RouterLinkWithHref, router_link_active_1.RouterLinkActive];
	//# sourceMappingURL=index.js.map

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var common_1 = __webpack_require__(130);
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(352);
	var router_state_1 = __webpack_require__(390);
	var RouterLink = (function () {
	    /**
	     * @internal
	     */
	    function RouterLink(router, route, locationStrategy) {
	        this.router = router;
	        this.route = route;
	        this.locationStrategy = locationStrategy;
	        this.commands = [];
	    }
	    Object.defineProperty(RouterLink.prototype, "routerLink", {
	        set: function (data) {
	            if (Array.isArray(data)) {
	                this.commands = data;
	            }
	            else {
	                this.commands = [data];
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RouterLink.prototype.onClick = function (button, ctrlKey, metaKey) {
	        if (button !== 0 || ctrlKey || metaKey) {
	            return true;
	        }
	        this.router.navigate(this.commands, { relativeTo: this.route, queryParams: this.queryParams, fragment: this.fragment });
	        return false;
	    };
	    /** @nocollapse */
	    RouterLink.decorators = [
	        { type: core_1.Directive, args: [{ selector: ':not(a)[routerLink]' },] },
	    ];
	    /** @nocollapse */
	    RouterLink.ctorParameters = [
	        { type: router_1.Router, },
	        { type: router_state_1.ActivatedRoute, },
	        { type: common_1.LocationStrategy, },
	    ];
	    /** @nocollapse */
	    RouterLink.propDecorators = {
	        'queryParams': [{ type: core_1.Input },],
	        'fragment': [{ type: core_1.Input },],
	        'routerLink': [{ type: core_1.Input },],
	        'onClick': [{ type: core_1.HostListener, args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey'],] },],
	    };
	    return RouterLink;
	}());
	exports.RouterLink = RouterLink;
	var RouterLinkWithHref = (function () {
	    /**
	     * @internal
	     */
	    function RouterLinkWithHref(router, route, locationStrategy) {
	        this.router = router;
	        this.route = route;
	        this.locationStrategy = locationStrategy;
	        this.commands = [];
	    }
	    Object.defineProperty(RouterLinkWithHref.prototype, "routerLink", {
	        set: function (data) {
	            if (Array.isArray(data)) {
	                this.commands = data;
	            }
	            else {
	                this.commands = [data];
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RouterLinkWithHref.prototype.ngOnChanges = function (changes) { this.updateTargetUrlAndHref(); };
	    RouterLinkWithHref.prototype.onClick = function (button, ctrlKey, metaKey) {
	        if (button !== 0 || ctrlKey || metaKey) {
	            return true;
	        }
	        if (typeof this.target === 'string' && this.target != '_self') {
	            return true;
	        }
	        this.router.navigateByUrl(this.urlTree);
	        return false;
	    };
	    RouterLinkWithHref.prototype.updateTargetUrlAndHref = function () {
	        this.urlTree = this.router.createUrlTree(this.commands, { relativeTo: this.route, queryParams: this.queryParams, fragment: this.fragment });
	        if (this.urlTree) {
	            this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));
	        }
	    };
	    /** @nocollapse */
	    RouterLinkWithHref.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'a[routerLink]' },] },
	    ];
	    /** @nocollapse */
	    RouterLinkWithHref.ctorParameters = [
	        { type: router_1.Router, },
	        { type: router_state_1.ActivatedRoute, },
	        { type: common_1.LocationStrategy, },
	    ];
	    /** @nocollapse */
	    RouterLinkWithHref.propDecorators = {
	        'target': [{ type: core_1.Input },],
	        'queryParams': [{ type: core_1.Input },],
	        'fragment': [{ type: core_1.Input },],
	        'href': [{ type: core_1.HostBinding },],
	        'routerLink': [{ type: core_1.Input },],
	        'onClick': [{ type: core_1.HostListener, args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey'],] },],
	    };
	    return RouterLinkWithHref;
	}());
	exports.RouterLinkWithHref = RouterLinkWithHref;
	//# sourceMappingURL=router_link.js.map

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	__webpack_require__(353);
	__webpack_require__(355);
	__webpack_require__(362);
	__webpack_require__(364);
	__webpack_require__(366);
	__webpack_require__(368);
	__webpack_require__(379);
	var core_1 = __webpack_require__(1);
	var Observable_1 = __webpack_require__(34);
	var Subject_1 = __webpack_require__(33);
	var of_1 = __webpack_require__(382);
	var apply_redirects_1 = __webpack_require__(383);
	var config_1 = __webpack_require__(387);
	var create_router_state_1 = __webpack_require__(388);
	var create_url_tree_1 = __webpack_require__(392);
	var recognize_1 = __webpack_require__(393);
	var resolve_1 = __webpack_require__(394);
	var router_outlet_map_1 = __webpack_require__(397);
	var router_state_1 = __webpack_require__(390);
	var shared_1 = __webpack_require__(384);
	var url_tree_1 = __webpack_require__(385);
	var collection_1 = __webpack_require__(386);
	/**
	 * An event triggered when a navigation starts
	 *
	 * @stable
	 */
	var NavigationStart = (function () {
	    function NavigationStart(id, url) {
	        this.id = id;
	        this.url = url;
	    }
	    NavigationStart.prototype.toString = function () { return "NavigationStart(id: " + this.id + ", url: '" + this.url + "')"; };
	    return NavigationStart;
	}());
	exports.NavigationStart = NavigationStart;
	/**
	 * An event triggered when a navigation ends successfully
	 *
	 * @stable
	 */
	var NavigationEnd = (function () {
	    function NavigationEnd(id, url, urlAfterRedirects) {
	        this.id = id;
	        this.url = url;
	        this.urlAfterRedirects = urlAfterRedirects;
	    }
	    NavigationEnd.prototype.toString = function () {
	        return "NavigationEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "')";
	    };
	    return NavigationEnd;
	}());
	exports.NavigationEnd = NavigationEnd;
	/**
	 * An event triggered when a navigation is canceled
	 *
	 * @stable
	 */
	var NavigationCancel = (function () {
	    function NavigationCancel(id, url) {
	        this.id = id;
	        this.url = url;
	    }
	    NavigationCancel.prototype.toString = function () { return "NavigationCancel(id: " + this.id + ", url: '" + this.url + "')"; };
	    return NavigationCancel;
	}());
	exports.NavigationCancel = NavigationCancel;
	/**
	 * An event triggered when a navigation fails due to unexpected error
	 *
	 * @stable
	 */
	var NavigationError = (function () {
	    function NavigationError(id, url, error) {
	        this.id = id;
	        this.url = url;
	        this.error = error;
	    }
	    NavigationError.prototype.toString = function () {
	        return "NavigationError(id: " + this.id + ", url: '" + this.url + "', error: " + this.error + ")";
	    };
	    return NavigationError;
	}());
	exports.NavigationError = NavigationError;
	/**
	 * An event triggered when routes are recognized
	 *
	 * @stable
	 */
	var RoutesRecognized = (function () {
	    function RoutesRecognized(id, url, urlAfterRedirects, state) {
	        this.id = id;
	        this.url = url;
	        this.urlAfterRedirects = urlAfterRedirects;
	        this.state = state;
	    }
	    RoutesRecognized.prototype.toString = function () {
	        return "RoutesRecognized(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
	    };
	    return RoutesRecognized;
	}());
	exports.RoutesRecognized = RoutesRecognized;
	/**
	 * The `Router` is responsible for mapping URLs to components.
	 *
	 * See {@link RouterConfig) for more details and examples.
	 *
	 * @stable
	 */
	var Router = (function () {
	    /**
	     * Creates the router service.
	     */
	    function Router(rootComponentType, resolver, urlSerializer, outletMap, location, injector, config) {
	        this.rootComponentType = rootComponentType;
	        this.resolver = resolver;
	        this.urlSerializer = urlSerializer;
	        this.outletMap = outletMap;
	        this.location = location;
	        this.injector = injector;
	        this.navigationId = 0;
	        this.resetConfig(config);
	        this.routerEvents = new Subject_1.Subject();
	        this.currentUrlTree = url_tree_1.createEmptyUrlTree();
	        this.currentRouterState = router_state_1.createEmptyState(this.currentUrlTree, this.rootComponentType);
	    }
	    /**
	     * @internal
	     */
	    Router.prototype.initialNavigation = function () {
	        this.setUpLocationChangeListener();
	        this.navigateByUrl(this.location.path(true));
	    };
	    Object.defineProperty(Router.prototype, "routerState", {
	        /**
	         * Returns the current route state.
	         */
	        get: function () { return this.currentRouterState; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Router.prototype, "url", {
	        /**
	         * Returns the current url.
	         */
	        get: function () { return this.serializeUrl(this.currentUrlTree); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Router.prototype, "events", {
	        /**
	         * Returns an observable of route events
	         */
	        get: function () { return this.routerEvents; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Resets the configuration used for navigation and generating links.
	     *
	     * ### Usage
	     *
	     * ```
	     * router.resetConfig([
	     *  { path: 'team/:id', component: TeamCmp, children: [
	     *    { path: 'simple', component: SimpleCmp },
	     *    { path: 'user/:name', component: UserCmp }
	     *  ] }
	     * ]);
	     * ```
	     */
	    Router.prototype.resetConfig = function (config) {
	        config_1.validateConfig(config);
	        this.config = config;
	    };
	    /**
	     * @internal
	     */
	    Router.prototype.dispose = function () { this.locationSubscription.unsubscribe(); };
	    /**
	     * Applies an array of commands to the current url tree and creates
	     * a new url tree.
	     *
	     * When given an activate route, applies the given commands starting from the route.
	     * When not given a route, applies the given command starting from the root.
	     *
	     * ### Usage
	     *
	     * ```
	     * // create /team/33/user/11
	     * router.createUrlTree(['/team', 33, 'user', 11]);
	     *
	     * // create /team/33;expand=true/user/11
	     * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
	     *
	     * // you can collapse static fragments like this
	     * router.createUrlTree(['/team/33/user', userId]);
	     *
	     * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
	     *
	     * // navigate to /team/33/user/11/details
	     * router.createUrlTree(['details'], {relativeTo: route});
	     *
	     * // navigate to /team/33/user/22
	     * router.createUrlTree(['../22'], {relativeTo: route});
	     *
	     * // navigate to /team/44/user/22
	     * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
	     * ```
	     */
	    Router.prototype.createUrlTree = function (commands, _a) {
	        var _b = _a === void 0 ? {} : _a, relativeTo = _b.relativeTo, queryParams = _b.queryParams, fragment = _b.fragment;
	        var a = relativeTo ? relativeTo : this.routerState.root;
	        return create_url_tree_1.createUrlTree(a, this.currentUrlTree, commands, queryParams, fragment);
	    };
	    /**
	     * Navigate based on the provided url. This navigation is always absolute.
	     *
	     * Returns a promise that:
	     * - is resolved with 'true' when navigation succeeds
	     * - is resolved with 'false' when navigation fails
	     * - is rejected when an error happens
	     *
	     * ### Usage
	     *
	     * ```
	     * router.navigateByUrl("/team/33/user/11");
	     * ```
	     */
	    Router.prototype.navigateByUrl = function (url) {
	        if (url instanceof url_tree_1.UrlTree) {
	            return this.scheduleNavigation(url, false);
	        }
	        else {
	            var urlTree = this.urlSerializer.parse(url);
	            return this.scheduleNavigation(urlTree, false);
	        }
	    };
	    /**
	     * Navigate based on the provided array of commands and a starting point.
	     * If no starting route is provided, the navigation is absolute.
	     *
	     * Returns a promise that:
	     * - is resolved with 'true' when navigation succeeds
	     * - is resolved with 'false' when navigation fails
	     * - is rejected when an error happens
	     *
	     * ### Usage
	     *
	     * ```
	     * router.navigate(['team', 33, 'team', '11], {relativeTo: route});
	     * ```
	     */
	    Router.prototype.navigate = function (commands, extras) {
	        if (extras === void 0) { extras = {}; }
	        return this.scheduleNavigation(this.createUrlTree(commands, extras), false);
	    };
	    /**
	     * Serializes a {@link UrlTree} into a string.
	     */
	    Router.prototype.serializeUrl = function (url) { return this.urlSerializer.serialize(url); };
	    /**
	     * Parse a string into a {@link UrlTree}.
	     */
	    Router.prototype.parseUrl = function (url) { return this.urlSerializer.parse(url); };
	    Router.prototype.scheduleNavigation = function (url, preventPushState) {
	        var _this = this;
	        var id = ++this.navigationId;
	        this.routerEvents.next(new NavigationStart(id, this.serializeUrl(url)));
	        return Promise.resolve().then(function (_) { return _this.runNavigate(url, preventPushState, id); });
	    };
	    Router.prototype.setUpLocationChangeListener = function () {
	        var _this = this;
	        this.locationSubscription = this.location.subscribe(function (change) {
	            return _this.scheduleNavigation(_this.urlSerializer.parse(change['url']), change['pop']);
	        });
	    };
	    Router.prototype.runNavigate = function (url, preventPushState, id) {
	        var _this = this;
	        if (id !== this.navigationId) {
	            this.location.go(this.urlSerializer.serialize(this.currentUrlTree));
	            this.routerEvents.next(new NavigationCancel(id, this.serializeUrl(url)));
	            return Promise.resolve(false);
	        }
	        return new Promise(function (resolvePromise, rejectPromise) {
	            var updatedUrl;
	            var state;
	            var navigationIsSuccessful;
	            var preActivation;
	            apply_redirects_1.applyRedirects(url, _this.config)
	                .mergeMap(function (u) {
	                updatedUrl = u;
	                return recognize_1.recognize(_this.rootComponentType, _this.config, updatedUrl, _this.serializeUrl(updatedUrl));
	            })
	                .mergeMap(function (newRouterStateSnapshot) {
	                _this.routerEvents.next(new RoutesRecognized(id, _this.serializeUrl(url), _this.serializeUrl(updatedUrl), newRouterStateSnapshot));
	                return resolve_1.resolve(_this.resolver, newRouterStateSnapshot);
	            })
	                .map(function (routerStateSnapshot) {
	                return create_router_state_1.createRouterState(routerStateSnapshot, _this.currentRouterState);
	            })
	                .map(function (newState) {
	                state = newState;
	                preActivation =
	                    new PreActivation(state.snapshot, _this.currentRouterState.snapshot, _this.injector);
	                preActivation.traverse(_this.outletMap);
	            })
	                .mergeMap(function (_) {
	                return preActivation.checkGuards();
	            })
	                .mergeMap(function (shouldActivate) {
	                if (shouldActivate) {
	                    return preActivation.resolveData().map(function () { return shouldActivate; });
	                }
	                else {
	                    return of_1.of(shouldActivate);
	                }
	            })
	                .forEach(function (shouldActivate) {
	                if (!shouldActivate || id !== _this.navigationId) {
	                    _this.routerEvents.next(new NavigationCancel(id, _this.serializeUrl(url)));
	                    navigationIsSuccessful = false;
	                    return;
	                }
	                new ActivateRoutes(state, _this.currentRouterState).activate(_this.outletMap);
	                _this.currentUrlTree = updatedUrl;
	                _this.currentRouterState = state;
	                if (!preventPushState) {
	                    var path = _this.urlSerializer.serialize(updatedUrl);
	                    if (_this.location.isCurrentPathEqualTo(path)) {
	                        _this.location.replaceState(path);
	                    }
	                    else {
	                        _this.location.go(path);
	                    }
	                }
	                navigationIsSuccessful = true;
	            })
	                .then(function () {
	                _this.routerEvents.next(new NavigationEnd(id, _this.serializeUrl(url), _this.serializeUrl(updatedUrl)));
	                resolvePromise(navigationIsSuccessful);
	            }, function (e) {
	                _this.routerEvents.next(new NavigationError(id, _this.serializeUrl(url), e));
	                rejectPromise(e);
	            });
	        });
	    };
	    return Router;
	}());
	exports.Router = Router;
	/**
	 * @experimental
	 */
	var CanActivate = (function () {
	    function CanActivate(route) {
	        this.route = route;
	    }
	    return CanActivate;
	}());
	/**
	 * @experimental
	 */
	var CanDeactivate = (function () {
	    function CanDeactivate(component, route) {
	        this.component = component;
	        this.route = route;
	    }
	    return CanDeactivate;
	}());
	var PreActivation = (function () {
	    function PreActivation(future, curr, injector) {
	        this.future = future;
	        this.curr = curr;
	        this.injector = injector;
	        this.checks = [];
	    }
	    PreActivation.prototype.traverse = function (parentOutletMap) {
	        var futureRoot = this.future._root;
	        var currRoot = this.curr ? this.curr._root : null;
	        this.traverseChildRoutes(futureRoot, currRoot, parentOutletMap);
	    };
	    PreActivation.prototype.checkGuards = function () {
	        var _this = this;
	        if (this.checks.length === 0)
	            return of_1.of(true);
	        return Observable_1.Observable.from(this.checks)
	            .map(function (s) {
	            if (s instanceof CanActivate) {
	                return _this.runCanActivate(s.route);
	            }
	            else if (s instanceof CanDeactivate) {
	                return _this.runCanDeactivate(s.component, s.route);
	            }
	            else {
	                throw new Error('Cannot be reached');
	            }
	        })
	            .mergeAll()
	            .every(function (result) { return result === true; });
	    };
	    PreActivation.prototype.resolveData = function () {
	        var _this = this;
	        if (this.checks.length === 0)
	            return of_1.of(null);
	        return Observable_1.Observable.from(this.checks)
	            .mergeMap(function (s) {
	            if (s instanceof CanActivate) {
	                return _this.runResolve(s.route);
	            }
	            else {
	                return of_1.of(null);
	            }
	        })
	            .reduce(function (_, __) { return _; });
	    };
	    PreActivation.prototype.traverseChildRoutes = function (futureNode, currNode, outletMap) {
	        var _this = this;
	        var prevChildren = nodeChildrenAsMap(currNode);
	        futureNode.children.forEach(function (c) {
	            _this.traverseRoutes(c, prevChildren[c.value.outlet], outletMap);
	            delete prevChildren[c.value.outlet];
	        });
	        collection_1.forEach(prevChildren, function (v, k) { return _this.deactivateOutletAndItChildren(v, outletMap._outlets[k]); });
	    };
	    PreActivation.prototype.traverseRoutes = function (futureNode, currNode, parentOutletMap) {
	        var future = futureNode.value;
	        var curr = currNode ? currNode.value : null;
	        var outlet = parentOutletMap ? parentOutletMap._outlets[futureNode.value.outlet] : null;
	        // reusing the node
	        if (curr && future._routeConfig === curr._routeConfig) {
	            if (!collection_1.shallowEqual(future.params, curr.params)) {
	                this.checks.push(new CanDeactivate(outlet.component, curr), new CanActivate(future));
	            }
	            // If we have a component, we need to go through an outlet.
	            if (future.component) {
	                this.traverseChildRoutes(futureNode, currNode, outlet ? outlet.outletMap : null);
	            }
	            else {
	                this.traverseChildRoutes(futureNode, currNode, parentOutletMap);
	            }
	        }
	        else {
	            if (curr) {
	                // if we had a normal route, we need to deactivate only that outlet.
	                if (curr.component) {
	                    this.deactivateOutletAndItChildren(curr, outlet);
	                }
	                else {
	                    this.deactivateOutletMap(parentOutletMap);
	                }
	            }
	            this.checks.push(new CanActivate(future));
	            // If we have a component, we need to go through an outlet.
	            if (future.component) {
	                this.traverseChildRoutes(futureNode, null, outlet ? outlet.outletMap : null);
	            }
	            else {
	                this.traverseChildRoutes(futureNode, null, parentOutletMap);
	            }
	        }
	    };
	    PreActivation.prototype.deactivateOutletAndItChildren = function (route, outlet) {
	        if (outlet && outlet.isActivated) {
	            this.deactivateOutletMap(outlet.outletMap);
	            this.checks.push(new CanDeactivate(outlet.component, route));
	        }
	    };
	    PreActivation.prototype.deactivateOutletMap = function (outletMap) {
	        var _this = this;
	        collection_1.forEach(outletMap._outlets, function (v) {
	            if (v.isActivated) {
	                _this.deactivateOutletAndItChildren(v.activatedRoute.snapshot, v);
	            }
	        });
	    };
	    PreActivation.prototype.runCanActivate = function (future) {
	        var _this = this;
	        var canActivate = future._routeConfig ? future._routeConfig.canActivate : null;
	        if (!canActivate || canActivate.length === 0)
	            return of_1.of(true);
	        return Observable_1.Observable.from(canActivate)
	            .map(function (c) {
	            var guard = _this.injector.get(c);
	            if (guard.canActivate) {
	                return wrapIntoObservable(guard.canActivate(future, _this.future));
	            }
	            else {
	                return wrapIntoObservable(guard(future, _this.future));
	            }
	        })
	            .mergeAll()
	            .every(function (result) { return result === true; });
	    };
	    PreActivation.prototype.runCanDeactivate = function (component, curr) {
	        var _this = this;
	        var canDeactivate = curr && curr._routeConfig ? curr._routeConfig.canDeactivate : null;
	        if (!canDeactivate || canDeactivate.length === 0)
	            return of_1.of(true);
	        return Observable_1.Observable.from(canDeactivate)
	            .map(function (c) {
	            var guard = _this.injector.get(c);
	            if (guard.canDeactivate) {
	                return wrapIntoObservable(guard.canDeactivate(component, curr, _this.curr));
	            }
	            else {
	                return wrapIntoObservable(guard(component, curr, _this.curr));
	            }
	        })
	            .mergeAll()
	            .every(function (result) { return result === true; });
	    };
	    PreActivation.prototype.runResolve = function (future) {
	        var resolve = future._resolve;
	        return this.resolveNode(resolve.current, future).map(function (resolvedData) {
	            resolve.resolvedData = resolvedData;
	            future.data = collection_1.merge(future.data, resolve.flattenedResolvedData);
	            return null;
	        });
	    };
	    PreActivation.prototype.resolveNode = function (resolve, future) {
	        var _this = this;
	        var resolvingObs = [];
	        var resolvedData = {};
	        collection_1.forEach(resolve, function (v, k) {
	            var resolver = _this.injector.get(v);
	            var obs = resolver.resolve ? wrapIntoObservable(resolver.resolve(future, _this.future)) :
	                wrapIntoObservable(resolver(future, _this.future));
	            resolvingObs.push(obs.map(function (_) { resolvedData[k] = _; }));
	        });
	        if (resolvingObs.length > 0) {
	            return Observable_1.Observable.forkJoin(resolvingObs).map(function (r) { return resolvedData; });
	        }
	        else {
	            return of_1.of(resolvedData);
	        }
	    };
	    return PreActivation;
	}());
	function wrapIntoObservable(value) {
	    if (value instanceof Observable_1.Observable) {
	        return value;
	    }
	    else {
	        return of_1.of(value);
	    }
	}
	var ActivateRoutes = (function () {
	    function ActivateRoutes(futureState, currState) {
	        this.futureState = futureState;
	        this.currState = currState;
	    }
	    ActivateRoutes.prototype.activate = function (parentOutletMap) {
	        var futureRoot = this.futureState._root;
	        var currRoot = this.currState ? this.currState._root : null;
	        pushQueryParamsAndFragment(this.futureState);
	        router_state_1.advanceActivatedRoute(this.futureState.root);
	        this.activateChildRoutes(futureRoot, currRoot, parentOutletMap);
	    };
	    ActivateRoutes.prototype.activateChildRoutes = function (futureNode, currNode, outletMap) {
	        var _this = this;
	        var prevChildren = nodeChildrenAsMap(currNode);
	        futureNode.children.forEach(function (c) {
	            _this.activateRoutes(c, prevChildren[c.value.outlet], outletMap);
	            delete prevChildren[c.value.outlet];
	        });
	        collection_1.forEach(prevChildren, function (v, k) { return _this.deactivateOutletAndItChildren(outletMap._outlets[k]); });
	    };
	    ActivateRoutes.prototype.activateRoutes = function (futureNode, currNode, parentOutletMap) {
	        var future = futureNode.value;
	        var curr = currNode ? currNode.value : null;
	        // reusing the node
	        if (future === curr) {
	            // advance the route to push the parameters
	            router_state_1.advanceActivatedRoute(future);
	            // If we have a normal route, we need to go through an outlet.
	            if (future.component) {
	                var outlet = getOutlet(parentOutletMap, futureNode.value);
	                this.activateChildRoutes(futureNode, currNode, outlet.outletMap);
	            }
	            else {
	                this.activateChildRoutes(futureNode, currNode, parentOutletMap);
	            }
	        }
	        else {
	            if (curr) {
	                // if we had a normal route, we need to deactivate only that outlet.
	                if (curr.component) {
	                    var outlet = getOutlet(parentOutletMap, futureNode.value);
	                    this.deactivateOutletAndItChildren(outlet);
	                }
	                else {
	                    this.deactivateOutletMap(parentOutletMap);
	                }
	            }
	            // if we have a normal route, we need to advance the route
	            // and place the component into the outlet. After that recurse.
	            if (future.component) {
	                router_state_1.advanceActivatedRoute(future);
	                var outlet = getOutlet(parentOutletMap, futureNode.value);
	                var outletMap = new router_outlet_map_1.RouterOutletMap();
	                this.placeComponentIntoOutlet(outletMap, future, outlet);
	                this.activateChildRoutes(futureNode, null, outletMap);
	            }
	            else {
	                router_state_1.advanceActivatedRoute(future);
	                this.activateChildRoutes(futureNode, null, parentOutletMap);
	            }
	        }
	    };
	    ActivateRoutes.prototype.placeComponentIntoOutlet = function (outletMap, future, outlet) {
	        var resolved = core_1.ReflectiveInjector.resolve([
	            { provide: router_state_1.ActivatedRoute, useValue: future },
	            { provide: router_outlet_map_1.RouterOutletMap, useValue: outletMap }
	        ]);
	        outlet.activate(future, resolved, outletMap);
	    };
	    ActivateRoutes.prototype.deactivateOutletAndItChildren = function (outlet) {
	        if (outlet && outlet.isActivated) {
	            this.deactivateOutletMap(outlet.outletMap);
	            outlet.deactivate();
	        }
	    };
	    ActivateRoutes.prototype.deactivateOutletMap = function (outletMap) {
	        var _this = this;
	        collection_1.forEach(outletMap._outlets, function (v) { return _this.deactivateOutletAndItChildren(v); });
	    };
	    return ActivateRoutes;
	}());
	function pushQueryParamsAndFragment(state) {
	    if (!collection_1.shallowEqual(state.snapshot.queryParams, state.queryParams.value)) {
	        state.queryParams.next(state.snapshot.queryParams);
	    }
	    if (state.snapshot.fragment !== state.fragment.value) {
	        state.fragment.next(state.snapshot.fragment);
	    }
	}
	function nodeChildrenAsMap(node) {
	    return node ? node.children.reduce(function (m, c) {
	        m[c.value.outlet] = c;
	        return m;
	    }, {}) : {};
	}
	function getOutlet(outletMap, route) {
	    var outlet = outletMap._outlets[route.outlet];
	    if (!outlet) {
	        var componentName = route.component.name;
	        if (route.outlet === shared_1.PRIMARY_OUTLET) {
	            throw new Error("Cannot find primary outlet to load '" + componentName + "'");
	        }
	        else {
	            throw new Error("Cannot find the outlet " + route.outlet + " to load '" + componentName + "'");
	        }
	    }
	    return outlet;
	}
	//# sourceMappingURL=router.js.map

/***/ },
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var Observable_1 = __webpack_require__(34);
	var of_1 = __webpack_require__(382);
	var shared_1 = __webpack_require__(384);
	var url_tree_1 = __webpack_require__(385);
	var collection_1 = __webpack_require__(386);
	var NoMatch = (function () {
	    function NoMatch(segment) {
	        if (segment === void 0) { segment = null; }
	        this.segment = segment;
	    }
	    return NoMatch;
	}());
	var GlobalRedirect = (function () {
	    function GlobalRedirect(paths) {
	        this.paths = paths;
	    }
	    return GlobalRedirect;
	}());
	function applyRedirects(urlTree, config) {
	    try {
	        return createUrlTree(urlTree, expandSegment(config, urlTree.root, shared_1.PRIMARY_OUTLET));
	    }
	    catch (e) {
	        if (e instanceof GlobalRedirect) {
	            return createUrlTree(urlTree, new url_tree_1.UrlSegment([], (_a = {}, _a[shared_1.PRIMARY_OUTLET] = new url_tree_1.UrlSegment(e.paths, {}), _a)));
	        }
	        else if (e instanceof NoMatch) {
	            return new Observable_1.Observable(function (obs) {
	                return obs.error(new Error("Cannot match any routes: '" + e.segment + "'"));
	            });
	        }
	        else {
	            return new Observable_1.Observable(function (obs) { return obs.error(e); });
	        }
	    }
	    var _a;
	}
	exports.applyRedirects = applyRedirects;
	function createUrlTree(urlTree, rootCandidate) {
	    var root = rootCandidate.pathsWithParams.length > 0 ?
	        new url_tree_1.UrlSegment([], (_a = {}, _a[shared_1.PRIMARY_OUTLET] = rootCandidate, _a)) :
	        rootCandidate;
	    return of_1.of(new url_tree_1.UrlTree(root, urlTree.queryParams, urlTree.fragment));
	    var _a;
	}
	function expandSegment(routes, segment, outlet) {
	    if (segment.pathsWithParams.length === 0 && segment.hasChildren()) {
	        return new url_tree_1.UrlSegment([], expandSegmentChildren(routes, segment));
	    }
	    else {
	        return expandPathsWithParams(segment, routes, segment.pathsWithParams, outlet, true);
	    }
	}
	function expandSegmentChildren(routes, segment) {
	    return url_tree_1.mapChildren(segment, function (child, childOutlet) { return expandSegment(routes, child, childOutlet); });
	}
	function expandPathsWithParams(segment, routes, paths, outlet, allowRedirects) {
	    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
	        var r = routes_1[_i];
	        try {
	            return expandPathsWithParamsAgainstRoute(segment, routes, r, paths, outlet, allowRedirects);
	        }
	        catch (e) {
	            if (!(e instanceof NoMatch))
	                throw e;
	        }
	    }
	    throw new NoMatch(segment);
	}
	function expandPathsWithParamsAgainstRoute(segment, routes, route, paths, outlet, allowRedirects) {
	    if (getOutlet(route) !== outlet)
	        throw new NoMatch();
	    if (route.redirectTo !== undefined && !allowRedirects)
	        throw new NoMatch();
	    if (route.redirectTo !== undefined) {
	        return expandPathsWithParamsAgainstRouteUsingRedirect(segment, routes, route, paths, outlet);
	    }
	    else {
	        return matchPathsWithParamsAgainstRoute(segment, route, paths);
	    }
	}
	function expandPathsWithParamsAgainstRouteUsingRedirect(segment, routes, route, paths, outlet) {
	    if (route.path === '**') {
	        return expandWildCardWithParamsAgainstRouteUsingRedirect(route);
	    }
	    else {
	        return expandRegularPathWithParamsAgainstRouteUsingRedirect(segment, routes, route, paths, outlet);
	    }
	}
	function expandWildCardWithParamsAgainstRouteUsingRedirect(route) {
	    var newPaths = applyRedirectCommands([], route.redirectTo, {});
	    if (route.redirectTo.startsWith('/')) {
	        throw new GlobalRedirect(newPaths);
	    }
	    else {
	        return new url_tree_1.UrlSegment(newPaths, {});
	    }
	}
	function expandRegularPathWithParamsAgainstRouteUsingRedirect(segment, routes, route, paths, outlet) {
	    var _a = match(segment, route, paths), consumedPaths = _a.consumedPaths, lastChild = _a.lastChild, positionalParamSegments = _a.positionalParamSegments;
	    var newPaths = applyRedirectCommands(consumedPaths, route.redirectTo, positionalParamSegments);
	    if (route.redirectTo.startsWith('/')) {
	        throw new GlobalRedirect(newPaths);
	    }
	    else {
	        return expandPathsWithParams(segment, routes, newPaths.concat(paths.slice(lastChild)), outlet, false);
	    }
	}
	function matchPathsWithParamsAgainstRoute(rawSegment, route, paths) {
	    if (route.path === '**') {
	        return new url_tree_1.UrlSegment(paths, {});
	    }
	    else {
	        var _a = match(rawSegment, route, paths), consumedPaths = _a.consumedPaths, lastChild = _a.lastChild;
	        var childConfig = route.children ? route.children : [];
	        var rawSlicedPath = paths.slice(lastChild);
	        var _b = split(rawSegment, consumedPaths, rawSlicedPath, childConfig), segment = _b.segment, slicedPath = _b.slicedPath;
	        if (slicedPath.length === 0 && segment.hasChildren()) {
	            var children = expandSegmentChildren(childConfig, segment);
	            return new url_tree_1.UrlSegment(consumedPaths, children);
	        }
	        else if (childConfig.length === 0 && slicedPath.length === 0) {
	            return new url_tree_1.UrlSegment(consumedPaths, {});
	        }
	        else {
	            var cs = expandPathsWithParams(segment, childConfig, slicedPath, shared_1.PRIMARY_OUTLET, true);
	            return new url_tree_1.UrlSegment(consumedPaths.concat(cs.pathsWithParams), cs.children);
	        }
	    }
	}
	function match(segment, route, paths) {
	    if (route.path === '') {
	        if ((route.terminal || route.pathMatch === 'full') &&
	            (segment.hasChildren() || paths.length > 0)) {
	            throw new NoMatch();
	        }
	        else {
	            return { consumedPaths: [], lastChild: 0, positionalParamSegments: {} };
	        }
	    }
	    var path = route.path;
	    var parts = path.split('/');
	    var positionalParamSegments = {};
	    var consumedPaths = [];
	    var currentIndex = 0;
	    for (var i = 0; i < parts.length; ++i) {
	        if (currentIndex >= paths.length)
	            throw new NoMatch();
	        var current = paths[currentIndex];
	        var p = parts[i];
	        var isPosParam = p.startsWith(':');
	        if (!isPosParam && p !== current.path)
	            throw new NoMatch();
	        if (isPosParam) {
	            positionalParamSegments[p.substring(1)] = current;
	        }
	        consumedPaths.push(current);
	        currentIndex++;
	    }
	    if (route.terminal && (segment.hasChildren() || currentIndex < paths.length)) {
	        throw new NoMatch();
	    }
	    return { consumedPaths: consumedPaths, lastChild: currentIndex, positionalParamSegments: positionalParamSegments };
	}
	function applyRedirectCommands(paths, redirectTo, posParams) {
	    var r = redirectTo.startsWith('/') ? redirectTo.substring(1) : redirectTo;
	    if (r === '') {
	        return [];
	    }
	    else {
	        return createPaths(redirectTo, r.split('/'), paths, posParams);
	    }
	}
	function createPaths(redirectTo, parts, segments, posParams) {
	    return parts.map(function (p) { return p.startsWith(':') ? findPosParam(p, posParams, redirectTo) :
	        findOrCreatePath(p, segments); });
	}
	function findPosParam(part, posParams, redirectTo) {
	    var paramName = part.substring(1);
	    var pos = posParams[paramName];
	    if (!pos)
	        throw new Error("Cannot redirect to '" + redirectTo + "'. Cannot find '" + part + "'.");
	    return pos;
	}
	function findOrCreatePath(part, paths) {
	    var idx = 0;
	    for (var _i = 0, paths_1 = paths; _i < paths_1.length; _i++) {
	        var s = paths_1[_i];
	        if (s.path === part) {
	            paths.splice(idx);
	            return s;
	        }
	        idx++;
	    }
	    return new url_tree_1.UrlPathWithParams(part, {});
	}
	function split(segment, consumedPaths, slicedPath, config) {
	    if (slicedPath.length > 0 &&
	        containsEmptyPathRedirectsWithNamedOutlets(segment, slicedPath, config)) {
	        var s = new url_tree_1.UrlSegment(consumedPaths, createChildrenForEmptyPaths(config, new url_tree_1.UrlSegment(slicedPath, segment.children)));
	        return { segment: mergeTrivialChildren(s), slicedPath: [] };
	    }
	    else if (slicedPath.length === 0 && containsEmptyPathRedirects(segment, slicedPath, config)) {
	        var s = new url_tree_1.UrlSegment(segment.pathsWithParams, addEmptyPathsToChildrenIfNeeded(segment, slicedPath, config, segment.children));
	        return { segment: mergeTrivialChildren(s), slicedPath: slicedPath };
	    }
	    else {
	        return { segment: segment, slicedPath: slicedPath };
	    }
	}
	function mergeTrivialChildren(s) {
	    if (s.numberOfChildren === 1 && s.children[shared_1.PRIMARY_OUTLET]) {
	        var c = s.children[shared_1.PRIMARY_OUTLET];
	        return new url_tree_1.UrlSegment(s.pathsWithParams.concat(c.pathsWithParams), c.children);
	    }
	    else {
	        return s;
	    }
	}
	function addEmptyPathsToChildrenIfNeeded(segment, slicedPath, routes, children) {
	    var res = {};
	    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
	        var r = routes_2[_i];
	        if (emptyPathRedirect(segment, slicedPath, r) && !children[getOutlet(r)]) {
	            res[getOutlet(r)] = new url_tree_1.UrlSegment([], {});
	        }
	    }
	    return collection_1.merge(children, res);
	}
	function createChildrenForEmptyPaths(routes, primarySegment) {
	    var res = {};
	    res[shared_1.PRIMARY_OUTLET] = primarySegment;
	    for (var _i = 0, routes_3 = routes; _i < routes_3.length; _i++) {
	        var r = routes_3[_i];
	        if (r.path === '') {
	            res[getOutlet(r)] = new url_tree_1.UrlSegment([], {});
	        }
	    }
	    return res;
	}
	function containsEmptyPathRedirectsWithNamedOutlets(segment, slicedPath, routes) {
	    return routes
	        .filter(function (r) { return emptyPathRedirect(segment, slicedPath, r) && getOutlet(r) !== shared_1.PRIMARY_OUTLET; })
	        .length > 0;
	}
	function containsEmptyPathRedirects(segment, slicedPath, routes) {
	    return routes.filter(function (r) { return emptyPathRedirect(segment, slicedPath, r); }).length > 0;
	}
	function emptyPathRedirect(segment, slicedPath, r) {
	    if ((segment.hasChildren() || slicedPath.length > 0) && (r.terminal || r.pathMatch === 'full'))
	        return false;
	    return r.path === '' && r.redirectTo !== undefined;
	}
	function getOutlet(route) {
	    return route.outlet ? route.outlet : shared_1.PRIMARY_OUTLET;
	}
	//# sourceMappingURL=apply_redirects.js.map

/***/ },
/* 384 */
/***/ function(module, exports) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	/**
	 * Name of the primary outlet.
	 * @type {string}
	 *
	 * @experimental
	 */
	exports.PRIMARY_OUTLET = 'PRIMARY_OUTLET';
	//# sourceMappingURL=shared.js.map

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var shared_1 = __webpack_require__(384);
	var collection_1 = __webpack_require__(386);
	function createEmptyUrlTree() {
	    return new UrlTree(new UrlSegment([], {}), {}, null);
	}
	exports.createEmptyUrlTree = createEmptyUrlTree;
	function containsTree(container, containee, exact) {
	    if (exact) {
	        return equalSegments(container.root, containee.root);
	    }
	    else {
	        return containsSegment(container.root, containee.root);
	    }
	}
	exports.containsTree = containsTree;
	function equalSegments(container, containee) {
	    if (!equalPath(container.pathsWithParams, containee.pathsWithParams))
	        return false;
	    if (container.numberOfChildren !== containee.numberOfChildren)
	        return false;
	    for (var c in containee.children) {
	        if (!container.children[c])
	            return false;
	        if (!equalSegments(container.children[c], containee.children[c]))
	            return false;
	    }
	    return true;
	}
	function containsSegment(container, containee) {
	    return containsSegmentHelper(container, containee, containee.pathsWithParams);
	}
	function containsSegmentHelper(container, containee, containeePaths) {
	    if (container.pathsWithParams.length > containeePaths.length) {
	        var current = container.pathsWithParams.slice(0, containeePaths.length);
	        if (!equalPath(current, containeePaths))
	            return false;
	        if (containee.hasChildren())
	            return false;
	        return true;
	    }
	    else if (container.pathsWithParams.length === containeePaths.length) {
	        if (!equalPath(container.pathsWithParams, containeePaths))
	            return false;
	        for (var c in containee.children) {
	            if (!container.children[c])
	                return false;
	            if (!containsSegment(container.children[c], containee.children[c]))
	                return false;
	        }
	        return true;
	    }
	    else {
	        var current = containeePaths.slice(0, container.pathsWithParams.length);
	        var next = containeePaths.slice(container.pathsWithParams.length);
	        if (!equalPath(container.pathsWithParams, current))
	            return false;
	        if (!container.children[shared_1.PRIMARY_OUTLET])
	            return false;
	        return containsSegmentHelper(container.children[shared_1.PRIMARY_OUTLET], containee, next);
	    }
	}
	/**
	 * A URL in the tree form.
	 *
	 * @stable
	 */
	var UrlTree = (function () {
	    /**
	     * @internal
	     */
	    function UrlTree(root, queryParams, fragment) {
	        this.root = root;
	        this.queryParams = queryParams;
	        this.fragment = fragment;
	    }
	    UrlTree.prototype.toString = function () { return new DefaultUrlSerializer().serialize(this); };
	    return UrlTree;
	}());
	exports.UrlTree = UrlTree;
	/**
	 * @stable
	 */
	var UrlSegment = (function () {
	    function UrlSegment(pathsWithParams, children) {
	        var _this = this;
	        this.pathsWithParams = pathsWithParams;
	        this.children = children;
	        this.parent = null;
	        collection_1.forEach(children, function (v, k) { return v.parent = _this; });
	    }
	    /**
	     * Return true if the segment has child segments
	     */
	    UrlSegment.prototype.hasChildren = function () { return this.numberOfChildren > 0; };
	    Object.defineProperty(UrlSegment.prototype, "numberOfChildren", {
	        /**
	         * Returns the number of child sements.
	         */
	        get: function () { return Object.keys(this.children).length; },
	        enumerable: true,
	        configurable: true
	    });
	    UrlSegment.prototype.toString = function () { return serializePaths(this); };
	    return UrlSegment;
	}());
	exports.UrlSegment = UrlSegment;
	/**
	 * @stable
	 */
	var UrlPathWithParams = (function () {
	    function UrlPathWithParams(path, parameters) {
	        this.path = path;
	        this.parameters = parameters;
	    }
	    UrlPathWithParams.prototype.toString = function () { return serializePath(this); };
	    return UrlPathWithParams;
	}());
	exports.UrlPathWithParams = UrlPathWithParams;
	function equalPathsWithParams(a, b) {
	    if (a.length !== b.length)
	        return false;
	    for (var i = 0; i < a.length; ++i) {
	        if (a[i].path !== b[i].path)
	            return false;
	        if (!collection_1.shallowEqual(a[i].parameters, b[i].parameters))
	            return false;
	    }
	    return true;
	}
	exports.equalPathsWithParams = equalPathsWithParams;
	function equalPath(a, b) {
	    if (a.length !== b.length)
	        return false;
	    for (var i = 0; i < a.length; ++i) {
	        if (a[i].path !== b[i].path)
	            return false;
	    }
	    return true;
	}
	exports.equalPath = equalPath;
	function mapChildren(segment, fn) {
	    var newChildren = {};
	    collection_1.forEach(segment.children, function (child, childOutlet) {
	        if (childOutlet === shared_1.PRIMARY_OUTLET) {
	            newChildren[childOutlet] = fn(child, childOutlet);
	        }
	    });
	    collection_1.forEach(segment.children, function (child, childOutlet) {
	        if (childOutlet !== shared_1.PRIMARY_OUTLET) {
	            newChildren[childOutlet] = fn(child, childOutlet);
	        }
	    });
	    return newChildren;
	}
	exports.mapChildren = mapChildren;
	function mapChildrenIntoArray(segment, fn) {
	    var res = [];
	    collection_1.forEach(segment.children, function (child, childOutlet) {
	        if (childOutlet === shared_1.PRIMARY_OUTLET) {
	            res = res.concat(fn(child, childOutlet));
	        }
	    });
	    collection_1.forEach(segment.children, function (child, childOutlet) {
	        if (childOutlet !== shared_1.PRIMARY_OUTLET) {
	            res = res.concat(fn(child, childOutlet));
	        }
	    });
	    return res;
	}
	exports.mapChildrenIntoArray = mapChildrenIntoArray;
	/**
	 * Defines a way to serialize/deserialize a url tree.
	 *
	 * @experimental
	 */
	var UrlSerializer = (function () {
	    function UrlSerializer() {
	    }
	    return UrlSerializer;
	}());
	exports.UrlSerializer = UrlSerializer;
	/**
	 * A default implementation of the serialization.
	 *
	 * @experimental
	 */
	var DefaultUrlSerializer = (function () {
	    function DefaultUrlSerializer() {
	    }
	    DefaultUrlSerializer.prototype.parse = function (url) {
	        var p = new UrlParser(url);
	        return new UrlTree(p.parseRootSegment(), p.parseQueryParams(), p.parseFragment());
	    };
	    DefaultUrlSerializer.prototype.serialize = function (tree) {
	        var segment = "/" + serializeSegment(tree.root, true);
	        var query = serializeQueryParams(tree.queryParams);
	        var fragment = tree.fragment !== null ? "#" + tree.fragment : '';
	        return "" + segment + query + fragment;
	    };
	    return DefaultUrlSerializer;
	}());
	exports.DefaultUrlSerializer = DefaultUrlSerializer;
	function serializePaths(segment) {
	    return segment.pathsWithParams.map(function (p) { return serializePath(p); }).join('/');
	}
	exports.serializePaths = serializePaths;
	function serializeSegment(segment, root) {
	    if (segment.children[shared_1.PRIMARY_OUTLET] && root) {
	        var primary = serializeSegment(segment.children[shared_1.PRIMARY_OUTLET], false);
	        var children_1 = [];
	        collection_1.forEach(segment.children, function (v, k) {
	            if (k !== shared_1.PRIMARY_OUTLET) {
	                children_1.push(k + ":" + serializeSegment(v, false));
	            }
	        });
	        if (children_1.length > 0) {
	            return primary + "(" + children_1.join('//') + ")";
	        }
	        else {
	            return "" + primary;
	        }
	    }
	    else if (segment.hasChildren() && !root) {
	        var children = mapChildrenIntoArray(segment, function (v, k) {
	            if (k === shared_1.PRIMARY_OUTLET) {
	                return [serializeSegment(segment.children[shared_1.PRIMARY_OUTLET], false)];
	            }
	            else {
	                return [(k + ":" + serializeSegment(v, false))];
	            }
	        });
	        return serializePaths(segment) + "/(" + children.join('//') + ")";
	    }
	    else {
	        return serializePaths(segment);
	    }
	}
	function serializePath(path) {
	    return "" + path.path + serializeParams(path.parameters);
	}
	exports.serializePath = serializePath;
	function serializeParams(params) {
	    return pairs(params).map(function (p) { return (";" + p.first + "=" + p.second); }).join('');
	}
	function serializeQueryParams(params) {
	    var strs = pairs(params).map(function (p) { return (p.first + "=" + p.second); });
	    return strs.length > 0 ? "?" + strs.join("&") : '';
	}
	var Pair = (function () {
	    function Pair(first, second) {
	        this.first = first;
	        this.second = second;
	    }
	    return Pair;
	}());
	function pairs(obj) {
	    var res = [];
	    for (var prop in obj) {
	        if (obj.hasOwnProperty(prop)) {
	            res.push(new Pair(prop, obj[prop]));
	        }
	    }
	    return res;
	}
	var SEGMENT_RE = /^[^\/\(\)\?;=&#]+/;
	function matchPathWithParams(str) {
	    SEGMENT_RE.lastIndex = 0;
	    var match = SEGMENT_RE.exec(str);
	    return match ? match[0] : '';
	}
	var QUERY_PARAM_RE = /^[^=\?&#]+/;
	function matchQueryParams(str) {
	    QUERY_PARAM_RE.lastIndex = 0;
	    var match = SEGMENT_RE.exec(str);
	    return match ? match[0] : '';
	}
	var QUERY_PARAM_VALUE_RE = /^[^\?&#]+/;
	function matchUrlQueryParamValue(str) {
	    QUERY_PARAM_VALUE_RE.lastIndex = 0;
	    var match = QUERY_PARAM_VALUE_RE.exec(str);
	    return match ? match[0] : '';
	}
	var UrlParser = (function () {
	    function UrlParser(remaining) {
	        this.remaining = remaining;
	    }
	    UrlParser.prototype.peekStartsWith = function (str) { return this.remaining.startsWith(str); };
	    UrlParser.prototype.capture = function (str) {
	        if (!this.remaining.startsWith(str)) {
	            throw new Error("Expected \"" + str + "\".");
	        }
	        this.remaining = this.remaining.substring(str.length);
	    };
	    UrlParser.prototype.parseRootSegment = function () {
	        if (this.remaining.startsWith('/')) {
	            this.capture('/');
	        }
	        if (this.remaining === '' || this.remaining.startsWith('?')) {
	            return new UrlSegment([], {});
	        }
	        else {
	            return new UrlSegment([], this.parseSegmentChildren());
	        }
	    };
	    UrlParser.prototype.parseSegmentChildren = function () {
	        if (this.remaining.length == 0) {
	            return {};
	        }
	        if (this.peekStartsWith('/')) {
	            this.capture('/');
	        }
	        var paths = [this.parsePathWithParams()];
	        while (this.peekStartsWith('/') && !this.peekStartsWith('//') && !this.peekStartsWith('/(')) {
	            this.capture('/');
	            paths.push(this.parsePathWithParams());
	        }
	        var children = {};
	        if (this.peekStartsWith('/(')) {
	            this.capture('/');
	            children = this.parseParens(true);
	        }
	        var res = {};
	        if (this.peekStartsWith('(')) {
	            res = this.parseParens(false);
	        }
	        res[shared_1.PRIMARY_OUTLET] = new UrlSegment(paths, children);
	        return res;
	    };
	    UrlParser.prototype.parsePathWithParams = function () {
	        var path = matchPathWithParams(this.remaining);
	        if (path === '' && this.peekStartsWith(';')) {
	            throw new Error("Empty path url segment cannot have parameters: '" + this.remaining + "'.");
	        }
	        this.capture(path);
	        var matrixParams = {};
	        if (this.peekStartsWith(';')) {
	            matrixParams = this.parseMatrixParams();
	        }
	        return new UrlPathWithParams(path, matrixParams);
	    };
	    UrlParser.prototype.parseQueryParams = function () {
	        var params = {};
	        if (this.peekStartsWith('?')) {
	            this.capture('?');
	            this.parseQueryParam(params);
	            while (this.remaining.length > 0 && this.peekStartsWith('&')) {
	                this.capture('&');
	                this.parseQueryParam(params);
	            }
	        }
	        return params;
	    };
	    UrlParser.prototype.parseFragment = function () {
	        if (this.peekStartsWith('#')) {
	            return this.remaining.substring(1);
	        }
	        else {
	            return null;
	        }
	    };
	    UrlParser.prototype.parseMatrixParams = function () {
	        var params = {};
	        while (this.remaining.length > 0 && this.peekStartsWith(';')) {
	            this.capture(';');
	            this.parseParam(params);
	        }
	        return params;
	    };
	    UrlParser.prototype.parseParam = function (params) {
	        var key = matchPathWithParams(this.remaining);
	        if (!key) {
	            return;
	        }
	        this.capture(key);
	        var value = 'true';
	        if (this.peekStartsWith('=')) {
	            this.capture('=');
	            var valueMatch = matchPathWithParams(this.remaining);
	            if (valueMatch) {
	                value = valueMatch;
	                this.capture(value);
	            }
	        }
	        params[key] = value;
	    };
	    UrlParser.prototype.parseQueryParam = function (params) {
	        var key = matchQueryParams(this.remaining);
	        if (!key) {
	            return;
	        }
	        this.capture(key);
	        var value = 'true';
	        if (this.peekStartsWith('=')) {
	            this.capture('=');
	            var valueMatch = matchUrlQueryParamValue(this.remaining);
	            if (valueMatch) {
	                value = valueMatch;
	                this.capture(value);
	            }
	        }
	        params[key] = value;
	    };
	    UrlParser.prototype.parseParens = function (allowPrimary) {
	        var segments = {};
	        this.capture('(');
	        while (!this.peekStartsWith(')') && this.remaining.length > 0) {
	            var path = matchPathWithParams(this.remaining);
	            var outletName = void 0;
	            if (path.indexOf(':') > -1) {
	                outletName = path.substr(0, path.indexOf(':'));
	                this.capture(outletName);
	                this.capture(':');
	            }
	            else if (allowPrimary) {
	                outletName = shared_1.PRIMARY_OUTLET;
	            }
	            var children = this.parseSegmentChildren();
	            segments[outletName] = Object.keys(children).length === 1 ? children[shared_1.PRIMARY_OUTLET] :
	                new UrlSegment([], children);
	            if (this.peekStartsWith('//')) {
	                this.capture('//');
	            }
	        }
	        this.capture(')');
	        return segments;
	    };
	    return UrlParser;
	}());
	//# sourceMappingURL=url_tree.js.map

/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	function shallowEqualArrays(a, b) {
	    if (a.length !== b.length)
	        return false;
	    for (var i = 0; i < a.length; ++i) {
	        if (!shallowEqual(a[i], b[i]))
	            return false;
	    }
	    return true;
	}
	exports.shallowEqualArrays = shallowEqualArrays;
	function shallowEqual(a, b) {
	    var k1 = Object.keys(a);
	    var k2 = Object.keys(b);
	    if (k1.length != k2.length) {
	        return false;
	    }
	    var key;
	    for (var i = 0; i < k1.length; i++) {
	        key = k1[i];
	        if (a[key] !== b[key]) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.shallowEqual = shallowEqual;
	function flatten(a) {
	    var target = [];
	    for (var i = 0; i < a.length; ++i) {
	        for (var j = 0; j < a[i].length; ++j) {
	            target.push(a[i][j]);
	        }
	    }
	    return target;
	}
	exports.flatten = flatten;
	function first(a) {
	    return a.length > 0 ? a[0] : null;
	}
	exports.first = first;
	function last(a) {
	    return a.length > 0 ? a[a.length - 1] : null;
	}
	exports.last = last;
	function and(bools) {
	    return bools.reduce(function (a, b) { return a && b; }, true);
	}
	exports.and = and;
	function merge(m1, m2) {
	    var m = {};
	    for (var attr in m1) {
	        if (m1.hasOwnProperty(attr)) {
	            m[attr] = m1[attr];
	        }
	    }
	    for (var attr in m2) {
	        if (m2.hasOwnProperty(attr)) {
	            m[attr] = m2[attr];
	        }
	    }
	    return m;
	}
	exports.merge = merge;
	function forEach(map, callback) {
	    for (var prop in map) {
	        if (map.hasOwnProperty(prop)) {
	            callback(map[prop], prop);
	        }
	    }
	}
	exports.forEach = forEach;
	//# sourceMappingURL=collection.js.map

/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	function validateConfig(config) {
	    config.forEach(validateNode);
	}
	exports.validateConfig = validateConfig;
	function validateNode(route) {
	    if (!!route.redirectTo && !!route.children) {
	        throw new Error("Invalid configuration of route '" + route.path + "': redirectTo and children cannot be used together");
	    }
	    if (!!route.redirectTo && !!route.component) {
	        throw new Error("Invalid configuration of route '" + route.path + "': redirectTo and component cannot be used together");
	    }
	    if (route.redirectTo === undefined && !route.component && !route.children) {
	        throw new Error("Invalid configuration of route '" + route.path + "': component, redirectTo, children must be provided");
	    }
	    if (route.path === undefined) {
	        throw new Error("Invalid route configuration: routes must have path specified");
	    }
	    if (route.path.startsWith('/')) {
	        throw new Error("Invalid route configuration of route '" + route.path + "': path cannot start with a slash");
	    }
	    if (route.path === '' && route.redirectTo !== undefined &&
	        (route.terminal === undefined && route.pathMatch === undefined)) {
	        var exp = "The default value of 'pathMatch' is 'prefix', but often the intent is to use 'full'.";
	        throw new Error("Invalid route configuration of route '{path: \"" + route.path + "\", redirectTo: \"" + route.redirectTo + "\"}': please provide 'pathMatch'. " + exp);
	    }
	}
	//# sourceMappingURL=config.js.map

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var BehaviorSubject_1 = __webpack_require__(389);
	var router_state_1 = __webpack_require__(390);
	var tree_1 = __webpack_require__(391);
	function createRouterState(curr, prevState) {
	    var root = createNode(curr._root, prevState ? prevState._root : undefined);
	    var queryParams = prevState ? prevState.queryParams : new BehaviorSubject_1.BehaviorSubject(curr.queryParams);
	    var fragment = prevState ? prevState.fragment : new BehaviorSubject_1.BehaviorSubject(curr.fragment);
	    return new router_state_1.RouterState(root, queryParams, fragment, curr);
	}
	exports.createRouterState = createRouterState;
	function createNode(curr, prevState) {
	    if (prevState && equalRouteSnapshots(prevState.value.snapshot, curr.value)) {
	        var value = prevState.value;
	        value._futureSnapshot = curr.value;
	        var children = createOrReuseChildren(curr, prevState);
	        return new tree_1.TreeNode(value, children);
	    }
	    else {
	        var value = createActivatedRoute(curr.value);
	        var children = curr.children.map(function (c) { return createNode(c); });
	        return new tree_1.TreeNode(value, children);
	    }
	}
	function createOrReuseChildren(curr, prevState) {
	    return curr.children.map(function (child) {
	        for (var _i = 0, _a = prevState.children; _i < _a.length; _i++) {
	            var p = _a[_i];
	            if (equalRouteSnapshots(p.value.snapshot, child.value)) {
	                return createNode(child, p);
	            }
	        }
	        return createNode(child);
	    });
	}
	function createActivatedRoute(c) {
	    return new router_state_1.ActivatedRoute(new BehaviorSubject_1.BehaviorSubject(c.url), new BehaviorSubject_1.BehaviorSubject(c.params), new BehaviorSubject_1.BehaviorSubject(c.data), c.outlet, c.component, c);
	}
	function equalRouteSnapshots(a, b) {
	    return a._routeConfig === b._routeConfig;
	}
	//# sourceMappingURL=create_router_state.js.map

/***/ },
/* 389 */,
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var BehaviorSubject_1 = __webpack_require__(389);
	var shared_1 = __webpack_require__(384);
	var url_tree_1 = __webpack_require__(385);
	var collection_1 = __webpack_require__(386);
	var tree_1 = __webpack_require__(391);
	/**
	 * The state of the router.
	 *
	 * ### Usage
	 *
	 * ```
	 * class MyComponent {
	 *   constructor(router: Router) {
	 *     const state = router.routerState;
	 *     const id: Observable<string> = state.firstChild(state.root).params.map(p => p.id);
	 *     const isDebug: Observable<string> = state.queryParams.map(q => q.debug);
	 *   }
	 * }
	 * ```
	 *
	 * @stable
	 */
	var RouterState = (function (_super) {
	    __extends(RouterState, _super);
	    /**
	     * @internal
	     */
	    function RouterState(root, queryParams, fragment, snapshot) {
	        _super.call(this, root);
	        this.queryParams = queryParams;
	        this.fragment = fragment;
	        this.snapshot = snapshot;
	    }
	    RouterState.prototype.toString = function () { return this.snapshot.toString(); };
	    return RouterState;
	}(tree_1.Tree));
	exports.RouterState = RouterState;
	function createEmptyState(urlTree, rootComponent) {
	    var snapshot = createEmptyStateSnapshot(urlTree, rootComponent);
	    var emptyUrl = new BehaviorSubject_1.BehaviorSubject([new url_tree_1.UrlPathWithParams('', {})]);
	    var emptyParams = new BehaviorSubject_1.BehaviorSubject({});
	    var emptyData = new BehaviorSubject_1.BehaviorSubject({});
	    var emptyQueryParams = new BehaviorSubject_1.BehaviorSubject({});
	    var fragment = new BehaviorSubject_1.BehaviorSubject('');
	    var activated = new ActivatedRoute(emptyUrl, emptyParams, emptyData, shared_1.PRIMARY_OUTLET, rootComponent, snapshot.root);
	    activated.snapshot = snapshot.root;
	    return new RouterState(new tree_1.TreeNode(activated, []), emptyQueryParams, fragment, snapshot);
	}
	exports.createEmptyState = createEmptyState;
	function createEmptyStateSnapshot(urlTree, rootComponent) {
	    var emptyParams = {};
	    var emptyData = {};
	    var emptyQueryParams = {};
	    var fragment = '';
	    var activated = new ActivatedRouteSnapshot([], emptyParams, emptyData, shared_1.PRIMARY_OUTLET, rootComponent, null, urlTree.root, -1, InheritedResolve.empty);
	    return new RouterStateSnapshot('', new tree_1.TreeNode(activated, []), emptyQueryParams, fragment);
	}
	/**
	 * Contains the information about a component loaded in an outlet. The information is provided
	 * through the params, urlSegments, and data observables.
	 *
	 * ### Usage
	 *
	 * ```
	 * class MyComponent {
	 *   constructor(route: ActivatedRoute) {
	 *     const id: Observable<string> = route.params.map(p => p.id);
	 *     const data = route.data.map(d => d.user); //includes `data` and `resolve`
	 *   }
	 * }
	 * ```
	 *
	 * @stable
	 */
	var ActivatedRoute = (function () {
	    /**
	     * @internal
	     */
	    function ActivatedRoute(url, params, data, outlet, component, futureSnapshot) {
	        this.url = url;
	        this.params = params;
	        this.data = data;
	        this.outlet = outlet;
	        this.component = component;
	        this._futureSnapshot = futureSnapshot;
	    }
	    ActivatedRoute.prototype.toString = function () {
	        return this.snapshot ? this.snapshot.toString() : "Future(" + this._futureSnapshot + ")";
	    };
	    return ActivatedRoute;
	}());
	exports.ActivatedRoute = ActivatedRoute;
	/**
	 * @internal
	 */
	var InheritedResolve = (function () {
	    function InheritedResolve(parent, current) {
	        this.parent = parent;
	        this.current = current;
	        /**
	         * @internal
	         */
	        this.resolvedData = {};
	    }
	    Object.defineProperty(InheritedResolve.prototype, "flattenedResolvedData", {
	        /**
	         * @internal
	         */
	        get: function () {
	            return this.parent ? collection_1.merge(this.parent.flattenedResolvedData, this.resolvedData) :
	                this.resolvedData;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InheritedResolve, "empty", {
	        get: function () { return new InheritedResolve(null, {}); },
	        enumerable: true,
	        configurable: true
	    });
	    return InheritedResolve;
	}());
	exports.InheritedResolve = InheritedResolve;
	/**
	 * Contains the information about a component loaded in an outlet at a particular moment in time.
	 *
	 * ### Usage
	 *
	 * ```
	 * class MyComponent {
	 *   constructor(route: ActivatedRoute) {
	 *     const id: string = route.snapshot.params.id;
	 *     const data = route.snapshot.data;
	 *   }
	 * }
	 * ```
	 *
	 * @stable
	 */
	var ActivatedRouteSnapshot = (function () {
	    /**
	     * @internal
	     */
	    function ActivatedRouteSnapshot(url, params, data, outlet, component, routeConfig, urlSegment, lastPathIndex, resolve) {
	        this.url = url;
	        this.params = params;
	        this.data = data;
	        this.outlet = outlet;
	        this.component = component;
	        this._routeConfig = routeConfig;
	        this._urlSegment = urlSegment;
	        this._lastPathIndex = lastPathIndex;
	        this._resolve = resolve;
	    }
	    ActivatedRouteSnapshot.prototype.toString = function () {
	        var url = this.url.map(function (s) { return s.toString(); }).join('/');
	        var matched = this._routeConfig ? this._routeConfig.path : '';
	        return "Route(url:'" + url + "', path:'" + matched + "')";
	    };
	    return ActivatedRouteSnapshot;
	}());
	exports.ActivatedRouteSnapshot = ActivatedRouteSnapshot;
	/**
	 * The state of the router at a particular moment in time.
	 *
	 * ### Usage
	 *
	 * ```
	 * class MyComponent {
	 *   constructor(router: Router) {
	 *     const snapshot = router.routerState.snapshot;
	 *   }
	 * }
	 * ```
	 *
	 * @stable
	 */
	var RouterStateSnapshot = (function (_super) {
	    __extends(RouterStateSnapshot, _super);
	    /**
	     * @internal
	     */
	    function RouterStateSnapshot(url, root, queryParams, fragment) {
	        _super.call(this, root);
	        this.url = url;
	        this.queryParams = queryParams;
	        this.fragment = fragment;
	    }
	    RouterStateSnapshot.prototype.toString = function () { return serializeNode(this._root); };
	    return RouterStateSnapshot;
	}(tree_1.Tree));
	exports.RouterStateSnapshot = RouterStateSnapshot;
	function serializeNode(node) {
	    var c = node.children.length > 0 ? " { " + node.children.map(serializeNode).join(", ") + " } " : '';
	    return "" + node.value + c;
	}
	/**
	 * The expectation is that the activate route is created with the right set of parameters.
	 * So we push new values into the observables only when they are not the initial values.
	 * And we detect that by checking if the snapshot field is set.
	 */
	function advanceActivatedRoute(route) {
	    if (route.snapshot) {
	        if (!collection_1.shallowEqual(route.snapshot.params, route._futureSnapshot.params)) {
	            route.params.next(route._futureSnapshot.params);
	            route.data.next(route._futureSnapshot.data);
	        }
	        if (!collection_1.shallowEqualArrays(route.snapshot.url, route._futureSnapshot.url)) {
	            route.url.next(route._futureSnapshot.url);
	        }
	        route.snapshot = route._futureSnapshot;
	    }
	    else {
	        route.snapshot = route._futureSnapshot;
	        route.data.next(route._futureSnapshot.data);
	    }
	}
	exports.advanceActivatedRoute = advanceActivatedRoute;
	//# sourceMappingURL=router_state.js.map

/***/ },
/* 391 */
/***/ function(module, exports) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var Tree = (function () {
	    function Tree(root) {
	        this._root = root;
	    }
	    Object.defineProperty(Tree.prototype, "root", {
	        get: function () { return this._root.value; },
	        enumerable: true,
	        configurable: true
	    });
	    Tree.prototype.parent = function (t) {
	        var p = this.pathFromRoot(t);
	        return p.length > 1 ? p[p.length - 2] : null;
	    };
	    Tree.prototype.children = function (t) {
	        var n = findNode(t, this._root);
	        return n ? n.children.map(function (t) { return t.value; }) : [];
	    };
	    Tree.prototype.firstChild = function (t) {
	        var n = findNode(t, this._root);
	        return n && n.children.length > 0 ? n.children[0].value : null;
	    };
	    Tree.prototype.siblings = function (t) {
	        var p = findPath(t, this._root, []);
	        if (p.length < 2)
	            return [];
	        var c = p[p.length - 2].children.map(function (c) { return c.value; });
	        return c.filter(function (cc) { return cc !== t; });
	    };
	    Tree.prototype.pathFromRoot = function (t) { return findPath(t, this._root, []).map(function (s) { return s.value; }); };
	    Tree.prototype.contains = function (tree) { return contains(this._root, tree._root); };
	    return Tree;
	}());
	exports.Tree = Tree;
	function findNode(expected, c) {
	    if (expected === c.value)
	        return c;
	    for (var _i = 0, _a = c.children; _i < _a.length; _i++) {
	        var cc = _a[_i];
	        var r = findNode(expected, cc);
	        if (r)
	            return r;
	    }
	    return null;
	}
	function findPath(expected, c, collected) {
	    collected.push(c);
	    if (expected === c.value)
	        return collected;
	    for (var _i = 0, _a = c.children; _i < _a.length; _i++) {
	        var cc = _a[_i];
	        var cloned = collected.slice(0);
	        var r = findPath(expected, cc, cloned);
	        if (r)
	            return r;
	    }
	    return [];
	}
	function contains(tree, subtree) {
	    if (tree.value !== subtree.value)
	        return false;
	    var _loop_1 = function(subtreeNode) {
	        var s = tree.children.filter(function (child) { return child.value === subtreeNode.value; });
	        if (s.length === 0)
	            return { value: false };
	        if (!contains(s[0], subtreeNode))
	            return { value: false };
	    };
	    for (var _i = 0, _a = subtree.children; _i < _a.length; _i++) {
	        var subtreeNode = _a[_i];
	        var state_1 = _loop_1(subtreeNode);
	        if (typeof state_1 === "object") return state_1.value;
	    }
	    return true;
	}
	var TreeNode = (function () {
	    function TreeNode(value, children) {
	        this.value = value;
	        this.children = children;
	    }
	    TreeNode.prototype.toString = function () { return "TreeNode(" + this.value + ")"; };
	    return TreeNode;
	}());
	exports.TreeNode = TreeNode;
	//# sourceMappingURL=tree.js.map

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var shared_1 = __webpack_require__(384);
	var url_tree_1 = __webpack_require__(385);
	var collection_1 = __webpack_require__(386);
	function createUrlTree(route, urlTree, commands, queryParams, fragment) {
	    if (commands.length === 0) {
	        return tree(urlTree.root, urlTree.root, urlTree, queryParams, fragment);
	    }
	    var normalizedCommands = normalizeCommands(commands);
	    if (navigateToRoot(normalizedCommands)) {
	        return tree(urlTree.root, new url_tree_1.UrlSegment([], {}), urlTree, queryParams, fragment);
	    }
	    var startingPosition = findStartingPosition(normalizedCommands, urlTree, route);
	    var segment = startingPosition.processChildren ?
	        updateSegmentChildren(startingPosition.segment, startingPosition.index, normalizedCommands.commands) :
	        updateSegment(startingPosition.segment, startingPosition.index, normalizedCommands.commands);
	    return tree(startingPosition.segment, segment, urlTree, queryParams, fragment);
	}
	exports.createUrlTree = createUrlTree;
	function tree(oldSegment, newSegment, urlTree, queryParams, fragment) {
	    var q = queryParams ? stringify(queryParams) : urlTree.queryParams;
	    var f = fragment ? fragment : urlTree.fragment;
	    if (urlTree.root === oldSegment) {
	        return new url_tree_1.UrlTree(newSegment, q, f);
	    }
	    else {
	        return new url_tree_1.UrlTree(replaceSegment(urlTree.root, oldSegment, newSegment), q, f);
	    }
	}
	function replaceSegment(current, oldSegment, newSegment) {
	    var children = {};
	    collection_1.forEach(current.children, function (c, outletName) {
	        if (c === oldSegment) {
	            children[outletName] = newSegment;
	        }
	        else {
	            children[outletName] = replaceSegment(c, oldSegment, newSegment);
	        }
	    });
	    return new url_tree_1.UrlSegment(current.pathsWithParams, children);
	}
	function navigateToRoot(normalizedChange) {
	    return normalizedChange.isAbsolute && normalizedChange.commands.length === 1 &&
	        normalizedChange.commands[0] == '/';
	}
	var NormalizedNavigationCommands = (function () {
	    function NormalizedNavigationCommands(isAbsolute, numberOfDoubleDots, commands) {
	        this.isAbsolute = isAbsolute;
	        this.numberOfDoubleDots = numberOfDoubleDots;
	        this.commands = commands;
	    }
	    return NormalizedNavigationCommands;
	}());
	function normalizeCommands(commands) {
	    if ((typeof commands[0] === 'string') && commands.length === 1 && commands[0] == '/') {
	        return new NormalizedNavigationCommands(true, 0, commands);
	    }
	    var numberOfDoubleDots = 0;
	    var isAbsolute = false;
	    var res = [];
	    for (var i = 0; i < commands.length; ++i) {
	        var c = commands[i];
	        if (!(typeof c === 'string')) {
	            res.push(c);
	            continue;
	        }
	        var parts = c.split('/');
	        for (var j = 0; j < parts.length; ++j) {
	            var cc = parts[j];
	            // first exp is treated in a special way
	            if (i == 0) {
	                if (j == 0 && cc == '.') {
	                }
	                else if (j == 0 && cc == '') {
	                    isAbsolute = true;
	                }
	                else if (cc == '..') {
	                    numberOfDoubleDots++;
	                }
	                else if (cc != '') {
	                    res.push(cc);
	                }
	            }
	            else {
	                if (cc != '') {
	                    res.push(cc);
	                }
	            }
	        }
	    }
	    return new NormalizedNavigationCommands(isAbsolute, numberOfDoubleDots, res);
	}
	var Position = (function () {
	    function Position(segment, processChildren, index) {
	        this.segment = segment;
	        this.processChildren = processChildren;
	        this.index = index;
	    }
	    return Position;
	}());
	function findStartingPosition(normalizedChange, urlTree, route) {
	    if (normalizedChange.isAbsolute) {
	        return new Position(urlTree.root, true, 0);
	    }
	    else if (route.snapshot._lastPathIndex === -1) {
	        return new Position(route.snapshot._urlSegment, true, 0);
	    }
	    else if (route.snapshot._lastPathIndex + 1 - normalizedChange.numberOfDoubleDots >= 0) {
	        return new Position(route.snapshot._urlSegment, false, route.snapshot._lastPathIndex + 1 - normalizedChange.numberOfDoubleDots);
	    }
	    else {
	        throw new Error('Invalid number of \'../\'');
	    }
	}
	function getPath(command) {
	    if (!(typeof command === 'string'))
	        return command.toString();
	    var parts = command.toString().split(':');
	    return parts.length > 1 ? parts[1] : command;
	}
	function getOutlet(commands) {
	    if (!(typeof commands[0] === 'string'))
	        return shared_1.PRIMARY_OUTLET;
	    var parts = commands[0].toString().split(':');
	    return parts.length > 1 ? parts[0] : shared_1.PRIMARY_OUTLET;
	}
	function updateSegment(segment, startIndex, commands) {
	    if (!segment) {
	        segment = new url_tree_1.UrlSegment([], {});
	    }
	    if (segment.pathsWithParams.length === 0 && segment.hasChildren()) {
	        return updateSegmentChildren(segment, startIndex, commands);
	    }
	    var m = prefixedWith(segment, startIndex, commands);
	    var slicedCommands = commands.slice(m.lastIndex);
	    if (m.match && slicedCommands.length === 0) {
	        return new url_tree_1.UrlSegment(segment.pathsWithParams, {});
	    }
	    else if (m.match && !segment.hasChildren()) {
	        return createNewSegment(segment, startIndex, commands);
	    }
	    else if (m.match) {
	        return updateSegmentChildren(segment, 0, slicedCommands);
	    }
	    else {
	        return createNewSegment(segment, startIndex, commands);
	    }
	}
	function updateSegmentChildren(segment, startIndex, commands) {
	    if (commands.length === 0) {
	        return new url_tree_1.UrlSegment(segment.pathsWithParams, {});
	    }
	    else {
	        var outlet_1 = getOutlet(commands);
	        var children_1 = {};
	        children_1[outlet_1] = updateSegment(segment.children[outlet_1], startIndex, commands);
	        collection_1.forEach(segment.children, function (child, childOutlet) {
	            if (childOutlet !== outlet_1) {
	                children_1[childOutlet] = child;
	            }
	        });
	        return new url_tree_1.UrlSegment(segment.pathsWithParams, children_1);
	    }
	}
	function prefixedWith(segment, startIndex, commands) {
	    var currentCommandIndex = 0;
	    var currentPathIndex = startIndex;
	    var noMatch = { match: false, lastIndex: 0 };
	    while (currentPathIndex < segment.pathsWithParams.length) {
	        if (currentCommandIndex >= commands.length)
	            return noMatch;
	        var path = segment.pathsWithParams[currentPathIndex];
	        var curr = getPath(commands[currentCommandIndex]);
	        var next = currentCommandIndex < commands.length - 1 ? commands[currentCommandIndex + 1] : null;
	        if (curr && next && (typeof next === 'object')) {
	            if (!compare(curr, next, path))
	                return noMatch;
	            currentCommandIndex += 2;
	        }
	        else {
	            if (!compare(curr, {}, path))
	                return noMatch;
	            currentCommandIndex++;
	        }
	        currentPathIndex++;
	    }
	    return { match: true, lastIndex: currentCommandIndex };
	}
	function createNewSegment(segment, startIndex, commands) {
	    var paths = segment.pathsWithParams.slice(0, startIndex);
	    var i = 0;
	    while (i < commands.length) {
	        // if we start with an object literal, we need to reuse the path part from the segment
	        if (i === 0 && (typeof commands[0] === 'object')) {
	            var p = segment.pathsWithParams[startIndex];
	            paths.push(new url_tree_1.UrlPathWithParams(p.path, commands[0]));
	            i++;
	            continue;
	        }
	        var curr = getPath(commands[i]);
	        var next = (i < commands.length - 1) ? commands[i + 1] : null;
	        if (curr && next && (typeof next === 'object')) {
	            paths.push(new url_tree_1.UrlPathWithParams(curr, stringify(next)));
	            i += 2;
	        }
	        else {
	            paths.push(new url_tree_1.UrlPathWithParams(curr, {}));
	            i++;
	        }
	    }
	    return new url_tree_1.UrlSegment(paths, {});
	}
	function stringify(params) {
	    var res = {};
	    collection_1.forEach(params, function (v, k) { return res[k] = "" + v; });
	    return res;
	}
	function compare(path, params, pathWithParams) {
	    return path == pathWithParams.path && collection_1.shallowEqual(params, pathWithParams.parameters);
	}
	//# sourceMappingURL=create_url_tree.js.map

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var Observable_1 = __webpack_require__(34);
	var of_1 = __webpack_require__(382);
	var router_state_1 = __webpack_require__(390);
	var shared_1 = __webpack_require__(384);
	var url_tree_1 = __webpack_require__(385);
	var collection_1 = __webpack_require__(386);
	var tree_1 = __webpack_require__(391);
	var NoMatch = (function () {
	    function NoMatch(segment) {
	        if (segment === void 0) { segment = null; }
	        this.segment = segment;
	    }
	    return NoMatch;
	}());
	var InheritedFromParent = (function () {
	    function InheritedFromParent(parent, params, data, resolve) {
	        this.parent = parent;
	        this.params = params;
	        this.data = data;
	        this.resolve = resolve;
	    }
	    Object.defineProperty(InheritedFromParent.prototype, "allParams", {
	        get: function () {
	            return this.parent ? collection_1.merge(this.parent.allParams, this.params) : this.params;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InheritedFromParent.prototype, "allData", {
	        get: function () { return this.parent ? collection_1.merge(this.parent.allData, this.data) : this.data; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InheritedFromParent, "empty", {
	        get: function () {
	            return new InheritedFromParent(null, {}, {}, new router_state_1.InheritedResolve(null, {}));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return InheritedFromParent;
	}());
	function recognize(rootComponentType, config, urlTree, url) {
	    try {
	        var children = processSegment(config, urlTree.root, InheritedFromParent.empty, shared_1.PRIMARY_OUTLET);
	        var root = new router_state_1.ActivatedRouteSnapshot([], {}, {}, shared_1.PRIMARY_OUTLET, rootComponentType, null, urlTree.root, -1, router_state_1.InheritedResolve.empty);
	        var rootNode = new tree_1.TreeNode(root, children);
	        return of_1.of(new router_state_1.RouterStateSnapshot(url, rootNode, urlTree.queryParams, urlTree.fragment));
	    }
	    catch (e) {
	        if (e instanceof NoMatch) {
	            return new Observable_1.Observable(function (obs) {
	                return obs.error(new Error("Cannot match any routes: '" + e.segment + "'"));
	            });
	        }
	        else {
	            return new Observable_1.Observable(function (obs) { return obs.error(e); });
	        }
	    }
	}
	exports.recognize = recognize;
	function processSegment(config, segment, inherited, outlet) {
	    if (segment.pathsWithParams.length === 0 && segment.hasChildren()) {
	        return processSegmentChildren(config, segment, inherited);
	    }
	    else {
	        return processPathsWithParams(config, segment, 0, segment.pathsWithParams, inherited, outlet);
	    }
	}
	function processSegmentChildren(config, segment, inherited) {
	    var children = url_tree_1.mapChildrenIntoArray(segment, function (child, childOutlet) { return processSegment(config, child, inherited, childOutlet); });
	    checkOutletNameUniqueness(children);
	    sortActivatedRouteSnapshots(children);
	    return children;
	}
	function sortActivatedRouteSnapshots(nodes) {
	    nodes.sort(function (a, b) {
	        if (a.value.outlet === shared_1.PRIMARY_OUTLET)
	            return -1;
	        if (b.value.outlet === shared_1.PRIMARY_OUTLET)
	            return 1;
	        return a.value.outlet.localeCompare(b.value.outlet);
	    });
	}
	function processPathsWithParams(config, segment, pathIndex, paths, inherited, outlet) {
	    for (var _i = 0, config_1 = config; _i < config_1.length; _i++) {
	        var r = config_1[_i];
	        try {
	            return processPathsWithParamsAgainstRoute(r, segment, pathIndex, paths, inherited, outlet);
	        }
	        catch (e) {
	            if (!(e instanceof NoMatch))
	                throw e;
	        }
	    }
	    throw new NoMatch(segment);
	}
	function processPathsWithParamsAgainstRoute(route, rawSegment, pathIndex, paths, inherited, outlet) {
	    if (route.redirectTo)
	        throw new NoMatch();
	    if ((route.outlet ? route.outlet : shared_1.PRIMARY_OUTLET) !== outlet)
	        throw new NoMatch();
	    var newInheritedResolve = new router_state_1.InheritedResolve(inherited.resolve, getResolve(route));
	    if (route.path === '**') {
	        var params = paths.length > 0 ? collection_1.last(paths).parameters : {};
	        var snapshot_1 = new router_state_1.ActivatedRouteSnapshot(paths, collection_1.merge(inherited.allParams, params), collection_1.merge(inherited.allData, getData(route)), outlet, route.component, route, getSourceSegment(rawSegment), getPathIndexShift(rawSegment) - 1, newInheritedResolve);
	        return [new tree_1.TreeNode(snapshot_1, [])];
	    }
	    var _a = match(rawSegment, route, paths), consumedPaths = _a.consumedPaths, parameters = _a.parameters, lastChild = _a.lastChild;
	    var rawSlicedPath = paths.slice(lastChild);
	    var childConfig = route.children ? route.children : [];
	    var newInherited = route.component ?
	        InheritedFromParent.empty :
	        new InheritedFromParent(inherited, parameters, getData(route), newInheritedResolve);
	    var _b = split(rawSegment, consumedPaths, rawSlicedPath, childConfig), segment = _b.segment, slicedPath = _b.slicedPath;
	    var snapshot = new router_state_1.ActivatedRouteSnapshot(consumedPaths, collection_1.merge(inherited.allParams, parameters), collection_1.merge(inherited.allData, getData(route)), outlet, route.component, route, getSourceSegment(rawSegment), getPathIndexShift(rawSegment) + pathIndex + lastChild - 1, newInheritedResolve);
	    if (slicedPath.length === 0 && segment.hasChildren()) {
	        var children = processSegmentChildren(childConfig, segment, newInherited);
	        return [new tree_1.TreeNode(snapshot, children)];
	    }
	    else if (childConfig.length === 0 && slicedPath.length === 0) {
	        return [new tree_1.TreeNode(snapshot, [])];
	    }
	    else {
	        var children = processPathsWithParams(childConfig, segment, pathIndex + lastChild, slicedPath, newInherited, shared_1.PRIMARY_OUTLET);
	        return [new tree_1.TreeNode(snapshot, children)];
	    }
	}
	function match(segment, route, paths) {
	    if (route.path === '') {
	        if ((route.terminal || route.pathMatch === 'full') &&
	            (segment.hasChildren() || paths.length > 0)) {
	            throw new NoMatch();
	        }
	        else {
	            return { consumedPaths: [], lastChild: 0, parameters: {} };
	        }
	    }
	    var path = route.path;
	    var parts = path.split('/');
	    var posParameters = {};
	    var consumedPaths = [];
	    var currentIndex = 0;
	    for (var i = 0; i < parts.length; ++i) {
	        if (currentIndex >= paths.length)
	            throw new NoMatch();
	        var current = paths[currentIndex];
	        var p = parts[i];
	        var isPosParam = p.startsWith(':');
	        if (!isPosParam && p !== current.path)
	            throw new NoMatch();
	        if (isPosParam) {
	            posParameters[p.substring(1)] = current.path;
	        }
	        consumedPaths.push(current);
	        currentIndex++;
	    }
	    if ((route.terminal || route.pathMatch === 'full') &&
	        (segment.hasChildren() || currentIndex < paths.length)) {
	        throw new NoMatch();
	    }
	    var parameters = collection_1.merge(posParameters, consumedPaths[consumedPaths.length - 1].parameters);
	    return { consumedPaths: consumedPaths, lastChild: currentIndex, parameters: parameters };
	}
	function checkOutletNameUniqueness(nodes) {
	    var names = {};
	    nodes.forEach(function (n) {
	        var routeWithSameOutletName = names[n.value.outlet];
	        if (routeWithSameOutletName) {
	            var p = routeWithSameOutletName.url.map(function (s) { return s.toString(); }).join('/');
	            var c = n.value.url.map(function (s) { return s.toString(); }).join('/');
	            throw new Error("Two segments cannot have the same outlet name: '" + p + "' and '" + c + "'.");
	        }
	        names[n.value.outlet] = n.value;
	    });
	}
	function getSourceSegment(segment) {
	    var s = segment;
	    while (s._sourceSegment) {
	        s = s._sourceSegment;
	    }
	    return s;
	}
	function getPathIndexShift(segment) {
	    var s = segment;
	    var res = 0;
	    while (s._sourceSegment) {
	        s = s._sourceSegment;
	        res += segment._pathIndexShift;
	    }
	    return res;
	}
	function split(segment, consumedPaths, slicedPath, config) {
	    if (slicedPath.length > 0 &&
	        containsEmptyPathMatchesWithNamedOutlets(segment, slicedPath, config)) {
	        var s = new url_tree_1.UrlSegment(consumedPaths, createChildrenForEmptyPaths(segment, consumedPaths, config, new url_tree_1.UrlSegment(slicedPath, segment.children)));
	        s._sourceSegment = segment;
	        s._pathIndexShift = 0;
	        return { segment: s, slicedPath: [] };
	    }
	    else if (slicedPath.length === 0 && containsEmptyPathMatches(segment, slicedPath, config)) {
	        var s = new url_tree_1.UrlSegment(segment.pathsWithParams, addEmptyPathsToChildrenIfNeeded(segment, slicedPath, config, segment.children));
	        s._sourceSegment = segment;
	        s._pathIndexShift = 0;
	        return { segment: s, slicedPath: slicedPath };
	    }
	    else {
	        return { segment: segment, slicedPath: slicedPath };
	    }
	}
	function addEmptyPathsToChildrenIfNeeded(segment, slicedPath, routes, children) {
	    var res = {};
	    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
	        var r = routes_1[_i];
	        if (emptyPathMatch(segment, slicedPath, r) && !children[getOutlet(r)]) {
	            var s = new url_tree_1.UrlSegment([], {});
	            s._sourceSegment = segment;
	            s._pathIndexShift = segment.pathsWithParams.length;
	            res[getOutlet(r)] = s;
	        }
	    }
	    return collection_1.merge(children, res);
	}
	function createChildrenForEmptyPaths(segment, consumedPaths, routes, primarySegment) {
	    var res = {};
	    res[shared_1.PRIMARY_OUTLET] = primarySegment;
	    primarySegment._sourceSegment = segment;
	    primarySegment._pathIndexShift = consumedPaths.length;
	    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
	        var r = routes_2[_i];
	        if (r.path === '') {
	            var s = new url_tree_1.UrlSegment([], {});
	            s._sourceSegment = segment;
	            s._pathIndexShift = consumedPaths.length;
	            res[getOutlet(r)] = s;
	        }
	    }
	    return res;
	}
	function containsEmptyPathMatchesWithNamedOutlets(segment, slicedPath, routes) {
	    return routes
	        .filter(function (r) { return emptyPathMatch(segment, slicedPath, r) && getOutlet(r) !== shared_1.PRIMARY_OUTLET; })
	        .length > 0;
	}
	function containsEmptyPathMatches(segment, slicedPath, routes) {
	    return routes.filter(function (r) { return emptyPathMatch(segment, slicedPath, r); }).length > 0;
	}
	function emptyPathMatch(segment, slicedPath, r) {
	    if ((segment.hasChildren() || slicedPath.length > 0) && (r.terminal || r.pathMatch === 'full'))
	        return false;
	    return r.path === '' && r.redirectTo === undefined;
	}
	function getOutlet(route) {
	    return route.outlet ? route.outlet : shared_1.PRIMARY_OUTLET;
	}
	function getData(route) {
	    return route.data ? route.data : {};
	}
	function getResolve(route) {
	    return route.resolve ? route.resolve : {};
	}
	//# sourceMappingURL=recognize.js.map

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	__webpack_require__(353);
	__webpack_require__(395);
	var forkJoin_1 = __webpack_require__(380);
	var fromPromise_1 = __webpack_require__(396);
	function resolve(resolver, state) {
	    return resolveNode(resolver, state._root).map(function (_) { return state; });
	}
	exports.resolve = resolve;
	function resolveNode(resolver, node) {
	    if (node.children.length === 0) {
	        return fromPromise_1.fromPromise(resolveComponent(resolver, node.value).then(function (factory) {
	            node.value._resolvedComponentFactory = factory;
	            return node.value;
	        }));
	    }
	    else {
	        var c = node.children.map(function (c) { return resolveNode(resolver, c).toPromise(); });
	        return forkJoin_1.forkJoin(c).map(function (_) { return resolveComponent(resolver, node.value).then(function (factory) {
	            node.value._resolvedComponentFactory = factory;
	            return node.value;
	        }); });
	    }
	}
	function resolveComponent(resolver, snapshot) {
	    // TODO: vsavkin change to typeof snapshot.component === 'string' in beta2
	    if (snapshot.component && snapshot._routeConfig) {
	        return resolver.resolveComponent(snapshot.component);
	    }
	    else {
	        return Promise.resolve(null);
	    }
	}
	//# sourceMappingURL=resolve.js.map

/***/ },
/* 395 */,
/* 396 */,
/* 397 */
/***/ function(module, exports) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	/**
	 * @stable
	 */
	var RouterOutletMap = (function () {
	    function RouterOutletMap() {
	        /** @internal */
	        this._outlets = {};
	    }
	    RouterOutletMap.prototype.registerOutlet = function (name, outlet) { this._outlets[name] = outlet; };
	    return RouterOutletMap;
	}());
	exports.RouterOutletMap = RouterOutletMap;
	//# sourceMappingURL=router_outlet_map.js.map

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(352);
	var url_tree_1 = __webpack_require__(385);
	var router_link_1 = __webpack_require__(351);
	var RouterLinkActive = (function () {
	    /**
	     * @internal
	     */
	    function RouterLinkActive(router, element, renderer) {
	        var _this = this;
	        this.router = router;
	        this.element = element;
	        this.renderer = renderer;
	        this.classes = [];
	        this.routerLinkActiveOptions = { exact: false };
	        this.subscription = router.events.subscribe(function (s) {
	            if (s instanceof router_1.NavigationEnd) {
	                _this.update();
	            }
	        });
	    }
	    RouterLinkActive.prototype.ngAfterContentInit = function () {
	        var _this = this;
	        this.links.changes.subscribe(function (s) { return _this.update(); });
	        this.linksWithHrefs.changes.subscribe(function (s) { return _this.update(); });
	        this.update();
	    };
	    Object.defineProperty(RouterLinkActive.prototype, "routerLinkActive", {
	        set: function (data) {
	            if (Array.isArray(data)) {
	                this.classes = data;
	            }
	            else {
	                this.classes = data.split(' ');
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RouterLinkActive.prototype.ngOnChanges = function (changes) { this.update(); };
	    RouterLinkActive.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
	    RouterLinkActive.prototype.update = function () {
	        var _this = this;
	        if (!this.links || !this.linksWithHrefs)
	            return;
	        var currentUrlTree = this.router.parseUrl(this.router.url);
	        var isActiveLinks = this.reduceList(currentUrlTree, this.links);
	        var isActiveLinksWithHrefs = this.reduceList(currentUrlTree, this.linksWithHrefs);
	        this.classes.forEach(function (c) { return _this.renderer.setElementClass(_this.element.nativeElement, c, isActiveLinks || isActiveLinksWithHrefs); });
	    };
	    RouterLinkActive.prototype.reduceList = function (currentUrlTree, q) {
	        var _this = this;
	        return q.reduce(function (res, link) {
	            return res || url_tree_1.containsTree(currentUrlTree, link.urlTree, _this.routerLinkActiveOptions.exact);
	        }, false);
	    };
	    /** @nocollapse */
	    RouterLinkActive.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[routerLinkActive]' },] },
	    ];
	    /** @nocollapse */
	    RouterLinkActive.ctorParameters = [
	        { type: router_1.Router, },
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	    ];
	    /** @nocollapse */
	    RouterLinkActive.propDecorators = {
	        'links': [{ type: core_1.ContentChildren, args: [router_link_1.RouterLink,] },],
	        'linksWithHrefs': [{ type: core_1.ContentChildren, args: [router_link_1.RouterLinkWithHref,] },],
	        'routerLinkActiveOptions': [{ type: core_1.Input },],
	        'routerLinkActive': [{ type: core_1.Input },],
	    };
	    return RouterLinkActive;
	}());
	exports.RouterLinkActive = RouterLinkActive;
	//# sourceMappingURL=router_link_active.js.map

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var router_outlet_map_1 = __webpack_require__(397);
	var shared_1 = __webpack_require__(384);
	var RouterOutlet = (function () {
	    /**
	     * @internal
	     */
	    function RouterOutlet(parentOutletMap, location, componentFactoryResolver, name) {
	        this.location = location;
	        this.componentFactoryResolver = componentFactoryResolver;
	        parentOutletMap.registerOutlet(name ? name : shared_1.PRIMARY_OUTLET, this);
	    }
	    Object.defineProperty(RouterOutlet.prototype, "isActivated", {
	        get: function () { return !!this.activated; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RouterOutlet.prototype, "component", {
	        get: function () {
	            if (!this.activated)
	                throw new Error('Outlet is not activated');
	            return this.activated.instance;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RouterOutlet.prototype, "activatedRoute", {
	        get: function () {
	            if (!this.activated)
	                throw new Error('Outlet is not activated');
	            return this._activatedRoute;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RouterOutlet.prototype.deactivate = function () {
	        if (this.activated) {
	            this.activated.destroy();
	            this.activated = null;
	        }
	    };
	    RouterOutlet.prototype.activate = function (activatedRoute, providers, outletMap) {
	        this.outletMap = outletMap;
	        this._activatedRoute = activatedRoute;
	        var snapshot = activatedRoute._futureSnapshot;
	        var component = snapshot._routeConfig.component;
	        var factory;
	        try {
	            factory = typeof component === 'string' ?
	                snapshot._resolvedComponentFactory :
	                this.componentFactoryResolver.resolveComponentFactory(component);
	        }
	        catch (e) {
	            if (!(e instanceof core_1.NoComponentFactoryError))
	                throw e;
	            var componentName = component ? component.name : null;
	            console.warn("'" + componentName + "' not found in precompile array.  To ensure all components referred to by the RouterConfig are compiled, you must add '" + componentName + "' to the 'precompile' array of your application component. This will be required in a future release of the router.");
	            factory = snapshot._resolvedComponentFactory;
	        }
	        var inj = core_1.ReflectiveInjector.fromResolvedProviders(providers, this.location.parentInjector);
	        this.activated = this.location.createComponent(factory, this.location.length, inj, []);
	    };
	    /** @nocollapse */
	    RouterOutlet.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'router-outlet' },] },
	    ];
	    /** @nocollapse */
	    RouterOutlet.ctorParameters = [
	        { type: router_outlet_map_1.RouterOutletMap, },
	        { type: core_1.ViewContainerRef, },
	        { type: core_1.ComponentFactoryResolver, },
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['name',] },] },
	    ];
	    return RouterOutlet;
	}());
	exports.RouterOutlet = RouterOutlet;
	//# sourceMappingURL=router_outlet.js.map

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var common_1 = __webpack_require__(130);
	var platform_browser_1 = __webpack_require__(128);
	var common_router_providers_1 = __webpack_require__(401);
	/**
	 * A list of {@link Provider}s. To use the router, you must add this to your application.
	 *
	 * ### Example
	 *
	 * ```
	 * @Component({directives: [ROUTER_DIRECTIVES]})
	 * class AppCmp {
	 *   // ...
	 * }
	 *
	 * const router = [
	 *   {path: 'home', component: Home}
	 * ];
	 *
	 * bootstrap(AppCmp, [provideRouter(router, {enableTracing: true})]);
	 * ```
	 *
	 * @experimental
	 */
	function provideRouter(config, opts) {
	    if (opts === void 0) { opts = {}; }
	    return [
	        { provide: common_1.PlatformLocation, useClass: platform_browser_1.BrowserPlatformLocation }
	    ].concat(common_router_providers_1.provideRouter(config, opts));
	}
	exports.provideRouter = provideRouter;
	//# sourceMappingURL=router_providers.js.map

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var common_1 = __webpack_require__(130);
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(352);
	var router_outlet_map_1 = __webpack_require__(397);
	var router_state_1 = __webpack_require__(390);
	var url_tree_1 = __webpack_require__(385);
	exports.ROUTER_CONFIG = new core_1.OpaqueToken('ROUTER_CONFIG');
	exports.ROUTER_OPTIONS = new core_1.OpaqueToken('ROUTER_OPTIONS');
	function setupRouter(ref, resolver, urlSerializer, outletMap, location, injector, config, opts) {
	    if (ref.componentTypes.length == 0) {
	        throw new Error('Bootstrap at least one component before injecting Router.');
	    }
	    var componentType = ref.componentTypes[0];
	    var r = new router_1.Router(componentType, resolver, urlSerializer, outletMap, location, injector, config);
	    ref.registerDisposeListener(function () { return r.dispose(); });
	    if (opts.enableTracing) {
	        r.events.subscribe(function (e) {
	            console.group("Router Event: " + e.constructor.name);
	            console.log(e.toString());
	            console.log(e);
	            console.groupEnd();
	        });
	    }
	    return r;
	}
	exports.setupRouter = setupRouter;
	function setupRouterInitializer(injector) {
	    // https://github.com/angular/angular/issues/9101
	    // Delay the router instantiation to avoid circular dependency (ApplicationRef ->
	    // APP_INITIALIZER -> Router)
	    setTimeout(function () {
	        var appRef = injector.get(core_1.ApplicationRef);
	        if (appRef.componentTypes.length == 0) {
	            appRef.registerBootstrapListener(function () { injector.get(router_1.Router).initialNavigation(); });
	        }
	        else {
	            injector.get(router_1.Router).initialNavigation();
	        }
	    }, 0);
	    return function () { return null; };
	}
	exports.setupRouterInitializer = setupRouterInitializer;
	/**
	 * An array of {@link Provider}s. To use the router, you must add this to your application.
	 *
	 * ### Example
	 *
	 * ```
	 * @Component({directives: [ROUTER_DIRECTIVES]})
	 * class AppCmp {
	 *   // ...
	 * }
	 *
	 * const config = [
	 *   {path: 'home', component: Home}
	 * ];
	 *
	 * bootstrap(AppCmp, [provideRouter(config)]);
	 * ```
	 *
	 * @stable
	 */
	function provideRouter(_config, _opts) {
	    return [
	        { provide: exports.ROUTER_CONFIG, useValue: _config }, { provide: exports.ROUTER_OPTIONS, useValue: _opts },
	        common_1.Location, { provide: common_1.LocationStrategy, useClass: common_1.PathLocationStrategy },
	        { provide: url_tree_1.UrlSerializer, useClass: url_tree_1.DefaultUrlSerializer },
	        {
	            provide: router_1.Router,
	            useFactory: setupRouter,
	            deps: [
	                core_1.ApplicationRef, core_1.ComponentResolver, url_tree_1.UrlSerializer, router_outlet_map_1.RouterOutletMap, common_1.Location, core_1.Injector,
	                exports.ROUTER_CONFIG, exports.ROUTER_OPTIONS
	            ]
	        },
	        router_outlet_map_1.RouterOutletMap,
	        { provide: router_state_1.ActivatedRoute, useFactory: function (r) { return r.routerState.root; }, deps: [router_1.Router] },
	        // Trigger initial navigation
	        { provide: core_1.APP_INITIALIZER, multi: true, useFactory: setupRouterInitializer, deps: [core_1.Injector] }
	    ];
	}
	exports.provideRouter = provideRouter;
	//# sourceMappingURL=common_router_providers.js.map

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var http_1 = __webpack_require__(111);
	var ObservableBackendService = (function () {
	    function ObservableBackendService(http) {
	        this.http = http;
	    }
	    ObservableBackendService.prototype.post = function (uri, data, headers) {
	        return this.http.post(uri, data, headers).map(this.mapResult);
	    };
	    ObservableBackendService.prototype.get = function (uri, data) {
	        var config = {};
	        //config.headers = headers;
	        if (data != null) {
	            config.search = data;
	        }
	        console.log("URL:" + uri);
	        return this.http.get(uri, config).map(this.mapResult);
	    };
	    ObservableBackendService.prototype.getAttachment = function (uri, data) {
	        var config = {};
	        if (data != null) {
	            config.search = data;
	        }
	        return this.http.get(uri, config).map(this.mapResultAttachment);
	    };
	    ObservableBackendService.prototype.put = function (uri, data, headers) {
	        return this.http.put(uri, data, headers).map(this.mapResult);
	    };
	    ObservableBackendService.prototype.delete = function (uri, data, headers) {
	        return this.http.delete(uri, data).map(this.mapResult);
	    };
	    ObservableBackendService.prototype.mapResult = function (res) {
	        if (res.url != null && res.url.endsWith('index.html')) {
	            location.href = '/login?sessionExpired';
	        }
	        return (res) ? res.json() : res;
	    };
	    ObservableBackendService.prototype.mapResultAttachment = function (res) {
	        if (res.url != null && res.url.endsWith('index.html')) {
	            location.href = '/login?sessionExpired';
	        }
	        return res;
	    };
	    ObservableBackendService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], ObservableBackendService);
	    return ObservableBackendService;
	}());
	exports.ObservableBackendService = ObservableBackendService;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var NavigationService = (function () {
	    function NavigationService() {
	    }
	    NavigationService.prototype.setBackParameters = function (backParameters) {
	        this.backParameters = backParameters;
	    };
	    NavigationService.prototype.getBackParameters = function () {
	        var parameters = this.backParameters;
	        this.backParameters = null;
	        return parameters;
	    };
	    NavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], NavigationService);
	    return NavigationService;
	}());
	exports.NavigationService = NavigationService;


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var rxjs_1 = __webpack_require__(405);
	var observableBackend_service_1 = __webpack_require__(402);
	var my_request_options_1 = __webpack_require__(629);
	var http_1 = __webpack_require__(111);
	var LoginService = (function () {
	    function LoginService(backendService) {
	        this.backendService = backendService;
	        this.loginUrl = 'login';
	        this.loginClientUrl = 'clientLogin';
	        this.loginOut = 'logout';
	        this.userLoggedSubject = new rxjs_1.Subject();
	        this.userLoggedSubject = new rxjs_1.Subject();
	    }
	    LoginService.prototype.authenticate = function (data) {
	        this.userLogged = null;
	        var creds = "username=" + data.username + "&password=" + data.password;
	        var headers = new my_request_options_1.MyRequestOptions();
	        headers.append('Content-Type', 'application/x-www-form-urlencoded');
	        return this.backendService.post(this.loginUrl, creds, headers);
	    };
	    LoginService.prototype.authenticateClient = function (data) {
	        this.userLogged = null;
	        data.isPatent = !data.isCuit;
	        return this.backendService.post(this.loginClientUrl, data, null);
	    };
	    LoginService.prototype.getUserCredentials = function (bankId) {
	        if (bankId === void 0) { bankId = null; }
	        var params = null;
	        if (bankId) {
	            params = new http_1.URLSearchParams();
	            params.set('bankId', String(bankId));
	        }
	        return this.backendService.get("getUserLoggedIn", params);
	    };
	    LoginService.prototype.getUserCredentialsByBank = function (bankId) {
	        var params = new http_1.URLSearchParams();
	        params.set('bankId', String(bankId));
	        return this.backendService.get("getUserLoggedInByBankId", params);
	    };
	    LoginService.prototype.setUserLogged = function (userLogged) {
	        this.userLogged = userLogged;
	        if (this.userLoggedSubject) {
	            this.userLoggedSubject.next(userLogged);
	        }
	    };
	    LoginService.prototype.getUserLogged = function () {
	        return this.userLogged;
	    };
	    LoginService.prototype.getUserLoggedSubject = function () {
	        if (!this.userLoggedSubject) {
	            this.userLoggedSubject = new rxjs_1.Subject();
	        }
	        return this.userLoggedSubject;
	    };
	    LoginService.prototype.logout = function () {
	        return this.backendService.post(this.loginOut, null, null);
	    };
	    LoginService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], LoginService);
	    return LoginService;
	}());
	exports.LoginService = LoginService;


/***/ },
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var http_1 = __webpack_require__(111);
	var MyRequestOptions = (function (_super) {
	    __extends(MyRequestOptions, _super);
	    function MyRequestOptions() {
	        _super.call(this);
	        this.append('X-Requested-With', 'XMLHttpRequest');
	        this.append('X-XSRF-TOKEN', this.getCookie('XSRF-TOKEN'));
	    }
	    MyRequestOptions.prototype.getCookie = function (name) {
	        var value = "; " + document.cookie;
	        var parts = value.split("; " + name + "=");
	        if (parts.length == 2)
	            return parts.pop().split(";").shift();
	    };
	    MyRequestOptions.prototype.append = function (name, value) {
	        this.headers.append(name, value);
	    };
	    return MyRequestOptions;
	}(http_1.BaseRequestOptions));
	exports.MyRequestOptions = MyRequestOptions;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var VehiclesService = (function () {
	    function VehiclesService(backendService) {
	        this.backendService = backendService;
	    }
	    VehiclesService.prototype.findVehicles = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("vehicles", params);
	    };
	    VehiclesService.prototype.downloadFilterVehicles = function (filter, page, itemsPerPage) {
	        return this.backendService.getAttachment("vehiclesReport", VehiclesService.setParams(filter, page, itemsPerPage));
	    };
	    VehiclesService.getURLFilterVehicles = function (filter, page, itemsPerPage) {
	        return "/vehiclesReport?" + VehiclesService.setParams(filter, page, itemsPerPage).toString();
	    };
	    VehiclesService.getURLVehicleBulkload = function (documentId) {
	        return "/vehiclesBulkloadDocument/" + documentId;
	    };
	    VehiclesService.prototype.downloadFilterVehiclesForIE = function (filter, page, itemsPerPage) {
	        return window.location.origin + '/vehiclesReport?' + VehiclesService.setParams(filter, page, itemsPerPage).toString();
	    };
	    VehiclesService.setParams = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return params;
	    };
	    VehiclesService.prototype.save = function (vehicle) {
	        return vehicle.id != null
	            ? this.backendService.post("vehicle", vehicle, null)
	            : this.backendService.put("vehicle", vehicle, null);
	    };
	    VehiclesService.prototype.delete = function (contractId, vehicleId) {
	        return this.backendService.delete("vehicle/" + contractId + "/" + vehicleId, null, null);
	    };
	    VehiclesService.prototype.getVehiclesType = function () {
	        return this.backendService.get("vehiclesType", null);
	    };
	    VehiclesService.prototype.getVehiclesBrand = function () {
	        return this.backendService.get("vehiclesBrand", null);
	    };
	    VehiclesService.prototype.getVehicle = function (contractId, vehicleId) {
	        return this.backendService.get("vehicle/" + contractId + "/" + vehicleId, null);
	    };
	    VehiclesService.prototype.getVehicleByPatent = function (patent) {
	        return this.backendService.get("vehicle/" + patent, null);
	    };
	    VehiclesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], VehiclesService);
	    return VehiclesService;
	}());
	exports.VehiclesService = VehiclesService;


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var BankService = (function () {
	    function BankService(backendService) {
	        this.backendService = backendService;
	    }
	    BankService.prototype.getBanks = function () {
	        return this.backendService.get("banks", null);
	    };
	    BankService.prototype.getBanksNoAuth = function () {
	        return this.backendService.get("banksNoAuth", null);
	    };
	    BankService.prototype.findBanks = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter) {
	            params.set('filter', filter);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("findBanks", params);
	    };
	    BankService.prototype.listBanks = function (page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("listBanks", params);
	    };
	    BankService.prototype.getBank = function (bankId) {
	        return this.backendService.get("bank/" + bankId, null);
	    };
	    BankService.prototype.save = function (bank) {
	        if (bank.id != null) {
	            return this.backendService.post("bank", bank, null);
	        }
	        else {
	            return this.backendService.put("bank", bank, null);
	        }
	    };
	    BankService.prototype.delete = function (bankId) {
	        return this.backendService.delete("bank/" + bankId, null, null);
	    };
	    BankService.prototype.generateBankTempId = function () {
	        return this.backendService.get("bank/generateTempId", null);
	    };
	    BankService.prototype.deleteTempBankDocument = function (bankId) {
	        return this.backendService.delete("bank/" + bankId + "/documentTemp/", null, null);
	    };
	    BankService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], BankService);
	    return BankService;
	}());
	exports.BankService = BankService;


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var ContractsService = (function () {
	    function ContractsService(backendService) {
	        this.backendService = backendService;
	    }
	    ContractsService.prototype.downloadFilterContracts = function (filter, page, itemsPerPage) {
	        return this.backendService.getAttachment("contractsReport", ContractsService.setParams(filter, page, itemsPerPage));
	    };
	    ContractsService.getURLFilterContracts = function (filter, page, itemsPerPage) {
	        return "/contractsReport?" + ContractsService.setParams(filter, page, itemsPerPage).toString();
	    };
	    ContractsService.getURLContractBulkload = function (documentId) {
	        return "/contractsBulkloadDocument/" + documentId;
	    };
	    ContractsService.prototype.downloadFilterContractsForIE = function (filter, page, itemsPerPage) {
	        return window.location.origin + '/contractsReport?' + ContractsService.setParams(filter, page, itemsPerPage).toString();
	    };
	    ContractsService.setParams = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return params;
	    };
	    ContractsService.prototype.findContracts = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("contracts", params);
	    };
	    ContractsService.prototype.save = function (contract) {
	        if (contract.id != null) {
	            return this.backendService.post("contract", contract, null);
	        }
	        else {
	            return this.backendService.put("contract", contract, null);
	        }
	    };
	    ContractsService.prototype.delete = function (contractId) {
	        return this.backendService.delete("contract/" + contractId, null, null);
	    };
	    ContractsService.prototype.getContract = function (contractId) {
	        return this.backendService.get("contract/" + contractId, null);
	    };
	    ContractsService.prototype.getVehicles = function (contractId, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (page && itemsPerPage) {
	            params.set('length', String(itemsPerPage));
	            params.set('pageNumber', String(page));
	            return this.backendService.get("contract/" + contractId + "/vehiclesPage", params);
	        }
	        return this.backendService.get("contract/" + contractId + "/vehicles", params);
	    };
	    ContractsService.prototype.getContractByContractNumberAndBank = function (contractNumber, bankId) {
	        return this.backendService.get("contract/" + bankId + "/" + contractNumber, null);
	    };
	    ContractsService.prototype.getContractByContractNumber = function (contractNumber) {
	        return this.backendService.get("contract/" + contractNumber, null);
	    };
	    ContractsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], ContractsService);
	    return ContractsService;
	}());
	exports.ContractsService = ContractsService;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var CitiesService = (function () {
	    function CitiesService(backendService) {
	        this.backendService = backendService;
	    }
	    CitiesService.prototype.getCities = function (stateId) {
	        return this.backendService.get("cities/" + stateId, null);
	    };
	    CitiesService.prototype.saveCity = function (city) {
	        if (city.id != null) {
	            return this.backendService.post("city", city, null);
	        }
	        else {
	            return this.backendService.put("city", city, null);
	        }
	    };
	    CitiesService.prototype.getCitiesByName = function (filter) {
	        return this.backendService.get("citiesByName/" + filter, null);
	    };
	    CitiesService.prototype.deleteCity = function (id) {
	        return this.backendService.delete("city/" + id, null, null);
	    };
	    CitiesService.prototype.getStates = function () {
	        return this.backendService.get("states", null);
	    };
	    CitiesService.prototype.saveState = function (state) {
	        if (state.id != null) {
	            return this.backendService.post("state", state, null);
	        }
	        else {
	            return this.backendService.put("state", state, null);
	        }
	    };
	    CitiesService.prototype.deleteState = function (id) {
	        return this.backendService.delete("state/" + id, null, null);
	    };
	    CitiesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], CitiesService);
	    return CitiesService;
	}());
	exports.CitiesService = CitiesService;


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var InfractionsService = (function () {
	    function InfractionsService(backendService) {
	        this.backendService = backendService;
	    }
	    InfractionsService.prototype.findInfractions = function (filter, page, itemsPerPage) {
	        return this.backendService.get("infractions", InfractionsService.setParams(filter, page, itemsPerPage));
	    };
	    InfractionsService.prototype.downloadFilterInfractions = function (filter, page, itemsPerPage, withActs) {
	        return this.backendService.getAttachment("/infractionsReport?", InfractionsService.setParams(filter, page, itemsPerPage, withActs));
	    };
	    InfractionsService.getURLFilterInfractions = function (filter, page, itemsPerPage, withActs) {
	        return "/infractionsReport?" + InfractionsService.setParams(filter, page, itemsPerPage, withActs).toString();
	    };
	    InfractionsService.getURLInfractionBulkload = function (documentId) {
	        return "/infractionsBulkloadDocument/" + documentId;
	    };
	    InfractionsService.prototype.persistUpdateInfractionDocuments = function () {
	        return this.backendService.get("persistUpdateInfractionDocuments", null);
	    };
	    InfractionsService.prototype.downloadFilterInfractionsForIE = function (filter, page, itemsPerPage, withActs) {
	        return window.location.origin + '/infractionsReport?' + InfractionsService.setParams(filter, page, itemsPerPage, withActs).toString();
	    };
	    InfractionsService.setParams = function (filter, page, itemsPerPage, withActs) {
	        var params = new http_1.URLSearchParams();
	        if (filter.vehicle && filter.actNumber) {
	            params.set('actNumber', filter.actNumber);
	        }
	        if (filter.vehicle && filter.vehicle.patent) {
	            params.set('vehicle.patent', filter.vehicle.patent);
	        }
	        if (filter.vehicle && filter.vehicle.contract.bank && filter.vehicle.contract.bank.id !== '') {
	            params.set('vehicle.contract.bank.id', filter.vehicle.contract.bank.id);
	        }
	        if (filter.vehicle && filter.vehicle.contract.contractNumber) {
	            params.set('vehicle.contract.contractNumber', filter.vehicle.contract.contractNumber);
	        }
	        if (filter.vehicle && filter.vehicle.contract.cuit) {
	            params.set('vehicle.contract.cuit', filter.vehicle.contract.cuit);
	        }
	        if (filter.address && filter.address.city && filter.address.city.id) {
	            params.set('address.city.id', filter.address.city.id);
	        }
	        if (filter.creationDateSince && filter.creationDateUntil) {
	            params.set('creationDateSince', filter.creationDateSince);
	            params.set('creationDateUntil', filter.creationDateUntil);
	        }
	        if (filter.state.id !== '') {
	            params.set('state.id', filter.state.id);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        /*Opcional: descarga de imágenes de actas*/
	        params.set('withActs', String(withActs));
	        return params;
	    };
	    InfractionsService.prototype.save = function (infraction) {
	        if (infraction.id != null) {
	            return this.backendService.post("infraction", infraction, null);
	        }
	        else {
	            return this.backendService.put("infraction", infraction, null);
	        }
	    };
	    InfractionsService.prototype.delete = function (id) {
	        return this.backendService.delete("infraction/" + id, null, null);
	    };
	    InfractionsService.prototype.getInfraction = function (id) {
	        return this.backendService.get("infraction/" + id, null);
	    };
	    InfractionsService.prototype.getInfractionStates = function () {
	        return this.backendService.get("infractionStates", null);
	    };
	    InfractionsService.prototype.getInfractionTypes = function () {
	        return this.backendService.get("infractionTypes", null);
	    };
	    InfractionsService.prototype.generateInfractionTempId = function () {
	        return this.backendService.get("infraction/generateTempId", null);
	    };
	    InfractionsService.prototype.deleteTempInfractionDocument = function (infractionId, documentType) {
	        return this.backendService.delete("infraction/" + infractionId + "/documentTemp/" + documentType, null, null);
	    };
	    InfractionsService.prototype.sendMail = function (infraction) {
	        return this.backendService.post("infraction/sendMail", infraction, null);
	    };
	    InfractionsService.prototype.getInfractionByActNumberAndState = function (actNumber, stateId) {
	        return this.backendService.get("infraction/" + actNumber + "/" + stateId, null);
	    };
	    /**
	     * MIGRACION
	     */
	    InfractionsService.prototype.migrateActs = function () {
	        return this.backendService.post("infraction/migration", null, null);
	    };
	    InfractionsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], InfractionsService);
	    return InfractionsService;
	}());
	exports.InfractionsService = InfractionsService;


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var RolesService = (function () {
	    function RolesService(backendService) {
	        this.backendService = backendService;
	    }
	    RolesService.prototype.findRoles = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter) {
	            params.set('name', filter);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("roles", params);
	    };
	    RolesService.prototype.getRol = function (rolId) {
	        return this.backendService.get("rol/" + rolId, null);
	    };
	    RolesService.prototype.getNewRol = function () {
	        return this.backendService.get("rol/new", null);
	    };
	    RolesService.prototype.getRoles = function () {
	        return this.backendService.get("listRoles/", null);
	    };
	    RolesService.prototype.save = function (rol) {
	        return rol.id != null
	            ? this.backendService.post("rol", rol, null)
	            : this.backendService.put("rol", rol, null);
	    };
	    RolesService.prototype.delete = function (rolId) {
	        return this.backendService.delete("rol/" + rolId, null, null);
	    };
	    RolesService.prototype.getActionsAllowed = function (appSection) {
	        return this.backendService.get("rol/actionsAllowed/" + appSection, null);
	    };
	    RolesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], RolesService);
	    return RolesService;
	}());
	exports.RolesService = RolesService;


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var OperatorsService = (function () {
	    function OperatorsService(backendService) {
	        this.backendService = backendService;
	    }
	    OperatorsService.prototype.findUsers = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter) {
	            params.set('searchParam', filter);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("users", params);
	    };
	    OperatorsService.prototype.getUser = function (userId) {
	        return this.backendService.get("user/" + userId, null);
	    };
	    OperatorsService.prototype.getUserByUsername = function (username) {
	        return this.backendService.get("user/validate/" + username, null);
	    };
	    OperatorsService.prototype.getNewUser = function () {
	        return this.backendService.get("user/new", null);
	    };
	    OperatorsService.prototype.save = function (user) {
	        if (user.id != null) {
	            return this.backendService.post("user", user, null);
	        }
	        else {
	            return this.backendService.put("user", user, null);
	        }
	    };
	    OperatorsService.prototype.delete = function (userId) {
	        return this.backendService.delete("user/" + userId, null, null);
	    };
	    OperatorsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], OperatorsService);
	    return OperatorsService;
	}());
	exports.OperatorsService = OperatorsService;


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var ClientService = (function () {
	    function ClientService(backendService) {
	        this.backendService = backendService;
	    }
	    ClientService.prototype.sendRequestProcedure = function (form) {
	        return this.backendService.post("client/sendRequestProcedure", form, null);
	    };
	    ClientService.prototype.deleteTempRequestProcedure = function (procedureId, documentType) {
	        return this.backendService.delete("client/" + procedureId + "/documentTemp/" + documentType, null, null);
	    };
	    ClientService.prototype.deleteTempActPayReceipt = function () {
	        return this.backendService.delete('client/actPayReceipt', null, null);
	    };
	    ClientService.prototype.sendActPayReceipt = function (form) {
	        return this.backendService.post("client/sendActPayReceipt", form, null);
	    };
	    ClientService.prototype.sendContactInfo = function (form) {
	        return this.backendService.post("sendContactInfo", form, null);
	    };
	    ClientService.prototype.getInfractionActNumbers = function () {
	        return this.backendService.post("infraction/getInfractionActNumbers", null, null);
	    };
	    ClientService.prototype.getVehiclesByCUIT = function (cuitNumber) {
	        return this.backendService.post("vehicle/getVehiclesByCUIT", cuitNumber, null);
	    };
	    ClientService.prototype.isPayReceiptActive = function () {
	        return this.backendService.get("isPayReceiptActive", null);
	    };
	    ClientService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], ClientService);
	    return ClientService;
	}());
	exports.ClientService = ClientService;


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var operatorLogin_component_1 = __webpack_require__(639);
	var clientLogin_component_1 = __webpack_require__(642);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var forms_1 = __webpack_require__(643);
	var validators_1 = __webpack_require__(849);
	var contactInfo_1 = __webpack_require__(850);
	var client_service_1 = __webpack_require__(637);
	var IndexComponent = (function () {
	    function IndexComponent(clientService) {
	        this.clientService = clientService;
	        this.init();
	    }
	    IndexComponent.prototype.init = function () {
	        this.itemMenuSelected = 'home';
	        this.contactInfo = new contactInfo_1.ContactInfo();
	        this.loading = false;
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        var group = {};
	        group['name'] = new forms_1.FormControl('', [forms_1.Validators.required]);
	        group['surname'] = new forms_1.FormControl('', [forms_1.Validators.required]);
	        group['phone'] = new forms_1.FormControl('', [forms_1.Validators.required]);
	        group['email'] = new forms_1.FormControl('', [validators_1.EMAIL_VALIDATOR]);
	        group['comments'] = new forms_1.FormControl();
	        this.form = new forms_1.FormGroup(group);
	    };
	    IndexComponent.prototype.sendContactInfo = function () {
	        var _this = this;
	        this.loading = true;
	        this.clientService.sendContactInfo(this.contactInfo).subscribe(function () {
	            _this.loading = false;
	            _this.successMessage = 'La consulta se envió con éxito.';
	            _this.contactInfo = new contactInfo_1.ContactInfo();
	        }, function () {
	            _this.bindError('Ocurrió un error al enviar la consulta.');
	        });
	    };
	    IndexComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    IndexComponent = __decorate([
	        core_1.Component({
	            selector: 'index',
	            template: __webpack_require__(851),
	            styles: [__webpack_require__(854)],
	            directives: [
	                operatorLogin_component_1.OperatorLoginComponent,
	                clientLogin_component_1.ClientLoginComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            providers: [forms_1.FORM_PROVIDERS]
	        }), 
	        __metadata('design:paramtypes', [client_service_1.ClientService])
	    ], IndexComponent);
	    return IndexComponent;
	}());
	exports.IndexComponent = IndexComponent;


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var userCredentials_1 = __webpack_require__(640);
	var login_service_1 = __webpack_require__(404);
	var OperatorLoginComponent = (function () {
	    function OperatorLoginComponent(router, loginService) {
	        this.router = router;
	        this.loginService = loginService;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    OperatorLoginComponent.prototype.init = function () {
	        this.credentials = new userCredentials_1.UserCredentials(null);
	    };
	    OperatorLoginComponent.prototype.ngOnInit = function () {
	    };
	    OperatorLoginComponent.prototype.authenticate = function () {
	        var _this = this;
	        this.loginService.authenticate(this.credentials)
	            .subscribe(function () {
	            if (_this.modal) {
	                _this.modal.hide();
	            }
	            _this.goToHome();
	        }, function (error) {
	            if (error.status == '401') {
	                _this.errorMessage = 'Usuario o password inválido';
	            }
	            else {
	                _this.bindError('Ocurrió un error.');
	                _this.errorMessage = 'Ocurrió un error.';
	            }
	        });
	    };
	    OperatorLoginComponent.prototype.goToHome = function () {
	        this.router.navigate(['app/home']);
	    };
	    OperatorLoginComponent.prototype.bindError = function (messageError) {
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OperatorLoginComponent.prototype, "modal", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], OperatorLoginComponent.prototype, "close", void 0);
	    OperatorLoginComponent = __decorate([
	        core_1.Component({
	            selector: 'operator-loggin',
	            template: __webpack_require__(641)
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, login_service_1.LoginService])
	    ], OperatorLoginComponent);
	    return OperatorLoginComponent;
	}());
	exports.OperatorLoginComponent = OperatorLoginComponent;


/***/ },
/* 640 */
/***/ function(module, exports) {

	"use strict";
	var UserCredentials = (function () {
	    function UserCredentials(user) {
	        this.isPatent = false;
	        this.isCuit = false;
	        this.isUser = true;
	        if (user !== null) {
	            this.username = user.username;
	            this.password = user.password;
	            this.authorities = user.authorities;
	            this.isCuit = user.isCuit;
	            this.isPatent = user.isPatent;
	            this.isUser = user.isUser;
	            this.bankId = user.bankId;
	        }
	    }
	    UserCredentials.prototype.getRol = function () {
	        return this.authorities[0].authority;
	    };
	    return UserCredentials;
	}());
	exports.UserCredentials = UserCredentials;


/***/ },
/* 641 */
/***/ function(module, exports) {

	module.exports = "<form role=\"form\" (ngSubmit)=\"authenticate()\">\n    <div class=\"form-group col-md-12\">\n        <div class=\"col-md-4\">\n            <label for=\"operador\">Nombre de Usuario</label>\n        </div>\n        <div class=\"col-md-6\">\n            <input id=\"operador\" type=\"text\" name=\"username\" [(ngModel)]=\"credentials.username\" ngControl=\"username\"\n                   placeholder=\"Nombre de usuario\" required>\n        </div>\n    </div>\n    <div class=\"form-group col-md-12\">\n        <div class=\"col-md-4\">\n            <label for=\"pass\">Contrase&ntilde;a</label>\n        </div>\n        <div class=\"col-md-6\">\n            <input id=\"pass\" type=\"password\" name=\"password\" [(ngModel)]=\"credentials.password\" ngControl=\"password\"\n                   placeholder=\"Password\" required>\n        </div>\n    </div>\n    <div class=\"form-group col-md-12\">\n        <div *ngIf=\"errorMessage\" class=\"alert alert-danger\">{{errorMessage}}</div>\n    </div>\n    <div class=\"form-group form-group-sm\">\n        <div class=\"text-center\">\n            <button type=\"submit\" class=\"btn btn-primary\">Login</button>\n        </div>\n    </div>\n</form>\n                   ";

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var router_1 = __webpack_require__(350);
	var userCredentials_1 = __webpack_require__(640);
	var login_service_1 = __webpack_require__(404);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var user_1 = __webpack_require__(844);
	var bankSelector_component_1 = __webpack_require__(845);
	var bank_service_1 = __webpack_require__(631);
	var ClientLoginComponent = (function () {
	    function ClientLoginComponent(router, loginService, bankService) {
	        this.router = router;
	        this.loginService = loginService;
	        this.bankService = bankService;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    ClientLoginComponent.prototype.init = function () {
	        this.credentials = new userCredentials_1.UserCredentials(null);
	        this.credentials.isCuit = true;
	        this.typeLogin = "cuit";
	        var group = {};
	        group['type'] = new forms_1.FormControl('', [forms_1.Validators.required]);
	        group['patent'] = new forms_1.FormControl('', [this.validateRequiredPatent.bind(this)]);
	        group['cuit'] = new forms_1.FormControl('', [this.validateRequiredCuit.bind(this)]);
	        this.form = new forms_1.FormGroup(group);
	    };
	    ClientLoginComponent.prototype.validateRequiredPatent = function (group) {
	        if (this.typeLogin == "patent" && !this.patent) {
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    ClientLoginComponent.prototype.validateRequiredCuit = function (group) {
	        if (this.typeLogin == "cuit" && !this.cuit) {
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    ClientLoginComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.bankService.getBanksNoAuth().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los bancos.');
	        });
	    };
	    ClientLoginComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	    };
	    ClientLoginComponent.prototype.showBankSelector = function () {
	        this.bankSelectorModal.show();
	    };
	    ClientLoginComponent.prototype.authenticate = function () {
	        var _this = this;
	        if (this.typeLogin == 'cuit') {
	            this.credentials.username = this.cuit;
	            this.credentials.isCuit = true;
	        }
	        else {
	            this.credentials.username = this.patent;
	            this.credentials.isCuit = false;
	        }
	        this.credentials.bankId = this.selectedBank.id;
	        this.loginService.authenticateClient(this.credentials).subscribe(function () {
	            _this.goToHome();
	        }, function (error) {
	            if (error.status == '401') {
	                _this.errorMessage = 'CUIT o patente inválido';
	            }
	            else {
	                _this.bindError('Ocurrió un error');
	            }
	        });
	    };
	    ClientLoginComponent.prototype.goToHome = function () {
	        var _this = this;
	        this.loginService.getUserCredentialsByBank(this.credentials.bankId).subscribe(function (user) {
	            _this.userLogged = new user_1.User(user);
	            _this.loginService.setUserLogged(_this.userLogged);
	            _this.updateUserLogged();
	            if (_this.bankSelectorModal) {
	                _this.bankSelectorModal.hide();
	            }
	            if (_this.selectedBank.id.toString() === _this.loggedUserBankId && _this.selectedBank.id.toString() != "") {
	                _this.router.navigate(['app/home/client/home']);
	            }
	            // TODO: Testear bien si es necesario que este IGUAL al home component
	            // (en principio no, porque solo entraria a este metodo si entra por patente)
	        }, function () {
	            //Do Nothing.
	        });
	        // event.preventDefault();
	        // this.router.navigate(['app/home/client/bankSelector']);
	        //this.bankSelectorModal.show();
	    };
	    ClientLoginComponent.prototype.updateUserLogged = function () {
	        if (this.userLogged.rol && this.userLogged.rol.client && this.userLogged.bank && this.userLogged.bank.id) {
	            this.loggedUserBankId = this.userLogged.bank.id.toString();
	        }
	    };
	    ClientLoginComponent.prototype.clearInputs = function () {
	        //Se hace esta negrada para que vuelve a ejecutar los validators
	        this.patent = (this.patent == '') ? null : '';
	        this.cuit = (this.cuit == '') ? null : '';
	    };
	    ClientLoginComponent.prototype.bindError = function (messageError) {
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ClientLoginComponent.prototype, "close", void 0);
	    __decorate([
	        core_1.ViewChild('bankSelectorModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], ClientLoginComponent.prototype, "bankSelectorModal", void 0);
	    ClientLoginComponent = __decorate([
	        core_1.Component({
	            selector: 'client-loggin',
	            template: __webpack_require__(847),
	            styles: [__webpack_require__(848)],
	            directives: [
	                bankSelector_component_1.BankSelectorComponent,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.MODAL_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS]
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, login_service_1.LoginService, bank_service_1.BankService])
	    ], ClientLoginComponent);
	    return ClientLoginComponent;
	}());
	exports.ClientLoginComponent = ClientLoginComponent;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(644));
	//# sourceMappingURL=index.js.map

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	/**
	 * @module
	 * @description
	 * This module is used for handling user input, by defining and building a {@link FormGroup} that
	 * consists of
	 * {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl} objects can then
	 * be used
	 * to read information
	 * from the form DOM elements.
	 *
	 * Forms providers are not included in default providers; you must import these providers
	 * explicitly.
	 */
	var directives_1 = __webpack_require__(645);
	exports.FORM_DIRECTIVES = directives_1.FORM_DIRECTIVES;
	exports.REACTIVE_FORM_DIRECTIVES = directives_1.REACTIVE_FORM_DIRECTIVES;
	var abstract_control_directive_1 = __webpack_require__(656);
	exports.AbstractControlDirective = abstract_control_directive_1.AbstractControlDirective;
	var checkbox_value_accessor_1 = __webpack_require__(646);
	exports.CheckboxControlValueAccessor = checkbox_value_accessor_1.CheckboxControlValueAccessor;
	var control_container_1 = __webpack_require__(668);
	exports.ControlContainer = control_container_1.ControlContainer;
	var control_value_accessor_1 = __webpack_require__(647);
	exports.NG_VALUE_ACCESSOR = control_value_accessor_1.NG_VALUE_ACCESSOR;
	var default_value_accessor_1 = __webpack_require__(648);
	exports.DefaultValueAccessor = default_value_accessor_1.DefaultValueAccessor;
	var ng_control_1 = __webpack_require__(651);
	exports.NgControl = ng_control_1.NgControl;
	var ng_control_status_1 = __webpack_require__(650);
	exports.NgControlStatus = ng_control_status_1.NgControlStatus;
	var ng_form_1 = __webpack_require__(657);
	exports.NgForm = ng_form_1.NgForm;
	var ng_model_1 = __webpack_require__(669);
	exports.NgModel = ng_model_1.NgModel;
	var ng_model_group_1 = __webpack_require__(670);
	exports.NgModelGroup = ng_model_group_1.NgModelGroup;
	var form_array_name_1 = __webpack_require__(672);
	exports.FormArrayName = form_array_name_1.FormArrayName;
	var form_control_directive_1 = __webpack_require__(673);
	exports.FormControlDirective = form_control_directive_1.FormControlDirective;
	var form_control_name_1 = __webpack_require__(674);
	exports.FormControlName = form_control_name_1.FormControlName;
	var form_group_directive_1 = __webpack_require__(675);
	exports.FormGroupDirective = form_group_directive_1.FormGroupDirective;
	var form_group_name_1 = __webpack_require__(676);
	exports.FormGroupName = form_group_name_1.FormGroupName;
	var select_control_value_accessor_1 = __webpack_require__(666);
	exports.NgSelectOption = select_control_value_accessor_1.NgSelectOption;
	exports.SelectControlValueAccessor = select_control_value_accessor_1.SelectControlValueAccessor;
	var validators_1 = __webpack_require__(677);
	exports.MaxLengthValidator = validators_1.MaxLengthValidator;
	exports.MinLengthValidator = validators_1.MinLengthValidator;
	exports.PatternValidator = validators_1.PatternValidator;
	exports.RequiredValidator = validators_1.RequiredValidator;
	var form_builder_1 = __webpack_require__(678);
	exports.FormBuilder = form_builder_1.FormBuilder;
	var model_1 = __webpack_require__(660);
	exports.AbstractControl = model_1.AbstractControl;
	exports.FormArray = model_1.FormArray;
	exports.FormControl = model_1.FormControl;
	exports.FormGroup = model_1.FormGroup;
	var validators_2 = __webpack_require__(662);
	exports.NG_ASYNC_VALIDATORS = validators_2.NG_ASYNC_VALIDATORS;
	exports.NG_VALIDATORS = validators_2.NG_VALIDATORS;
	exports.Validators = validators_2.Validators;
	__export(__webpack_require__(679));
	//# sourceMappingURL=forms.js.map

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var checkbox_value_accessor_1 = __webpack_require__(646);
	var default_value_accessor_1 = __webpack_require__(648);
	var ng_control_status_1 = __webpack_require__(650);
	var ng_form_1 = __webpack_require__(657);
	var ng_model_1 = __webpack_require__(669);
	var ng_model_group_1 = __webpack_require__(670);
	var number_value_accessor_1 = __webpack_require__(664);
	var radio_control_value_accessor_1 = __webpack_require__(665);
	var form_array_name_1 = __webpack_require__(672);
	var form_control_directive_1 = __webpack_require__(673);
	var form_control_name_1 = __webpack_require__(674);
	var form_group_directive_1 = __webpack_require__(675);
	var form_group_name_1 = __webpack_require__(676);
	var select_control_value_accessor_1 = __webpack_require__(666);
	var select_multiple_control_value_accessor_1 = __webpack_require__(667);
	var validators_1 = __webpack_require__(677);
	var checkbox_value_accessor_2 = __webpack_require__(646);
	exports.CheckboxControlValueAccessor = checkbox_value_accessor_2.CheckboxControlValueAccessor;
	var default_value_accessor_2 = __webpack_require__(648);
	exports.DefaultValueAccessor = default_value_accessor_2.DefaultValueAccessor;
	var ng_control_1 = __webpack_require__(651);
	exports.NgControl = ng_control_1.NgControl;
	var ng_control_status_2 = __webpack_require__(650);
	exports.NgControlStatus = ng_control_status_2.NgControlStatus;
	var ng_form_2 = __webpack_require__(657);
	exports.NgForm = ng_form_2.NgForm;
	var ng_model_2 = __webpack_require__(669);
	exports.NgModel = ng_model_2.NgModel;
	var ng_model_group_2 = __webpack_require__(670);
	exports.NgModelGroup = ng_model_group_2.NgModelGroup;
	var number_value_accessor_2 = __webpack_require__(664);
	exports.NumberValueAccessor = number_value_accessor_2.NumberValueAccessor;
	var radio_control_value_accessor_2 = __webpack_require__(665);
	exports.RadioControlValueAccessor = radio_control_value_accessor_2.RadioControlValueAccessor;
	var form_array_name_2 = __webpack_require__(672);
	exports.FormArrayName = form_array_name_2.FormArrayName;
	var form_control_directive_2 = __webpack_require__(673);
	exports.FormControlDirective = form_control_directive_2.FormControlDirective;
	var form_control_name_2 = __webpack_require__(674);
	exports.FormControlName = form_control_name_2.FormControlName;
	var form_group_directive_2 = __webpack_require__(675);
	exports.FormGroupDirective = form_group_directive_2.FormGroupDirective;
	var form_group_name_2 = __webpack_require__(676);
	exports.FormGroupName = form_group_name_2.FormGroupName;
	var select_control_value_accessor_2 = __webpack_require__(666);
	exports.NgSelectOption = select_control_value_accessor_2.NgSelectOption;
	exports.SelectControlValueAccessor = select_control_value_accessor_2.SelectControlValueAccessor;
	var select_multiple_control_value_accessor_2 = __webpack_require__(667);
	exports.NgSelectMultipleOption = select_multiple_control_value_accessor_2.NgSelectMultipleOption;
	exports.SelectMultipleControlValueAccessor = select_multiple_control_value_accessor_2.SelectMultipleControlValueAccessor;
	var validators_2 = __webpack_require__(677);
	exports.MaxLengthValidator = validators_2.MaxLengthValidator;
	exports.MinLengthValidator = validators_2.MinLengthValidator;
	exports.PatternValidator = validators_2.PatternValidator;
	exports.RequiredValidator = validators_2.RequiredValidator;
	/**
	 *
	 * A list of all the form directives used as part of a `@Component` annotation.
	 *
	 *  This is a shorthand for importing them each individually.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * @Component({
	 *   selector: 'my-app',
	 *   directives: [FORM_DIRECTIVES]
	 * })
	 * class MyApp {}
	 * ```
	 * @experimental
	 */
	exports.FORM_DIRECTIVES = [
	    ng_model_1.NgModel, ng_model_group_1.NgModelGroup, ng_form_1.NgForm,
	    select_control_value_accessor_1.NgSelectOption, select_multiple_control_value_accessor_1.NgSelectMultipleOption, default_value_accessor_1.DefaultValueAccessor, number_value_accessor_1.NumberValueAccessor,
	    checkbox_value_accessor_1.CheckboxControlValueAccessor, select_control_value_accessor_1.SelectControlValueAccessor, select_multiple_control_value_accessor_1.SelectMultipleControlValueAccessor,
	    radio_control_value_accessor_1.RadioControlValueAccessor, ng_control_status_1.NgControlStatus,
	    validators_1.RequiredValidator, validators_1.MinLengthValidator, validators_1.MaxLengthValidator, validators_1.PatternValidator
	];
	/**
	 * @experimental
	 */
	exports.REACTIVE_FORM_DIRECTIVES = 
	/*@ts2dart_const*/ [
	    form_control_directive_1.FormControlDirective, form_group_directive_1.FormGroupDirective, form_control_name_1.FormControlName, form_group_name_1.FormGroupName, form_array_name_1.FormArrayName
	];
	//# sourceMappingURL=directives.js.map

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var control_value_accessor_1 = __webpack_require__(647);
	exports.CHECKBOX_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return CheckboxControlValueAccessor; }),
	    multi: true
	};
	var CheckboxControlValueAccessor = (function () {
	    function CheckboxControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
	    };
	    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    CheckboxControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
	                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
	                    providers: [exports.CHECKBOX_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    CheckboxControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return CheckboxControlValueAccessor;
	}());
	exports.CheckboxControlValueAccessor = CheckboxControlValueAccessor;
	//# sourceMappingURL=checkbox_value_accessor.js.map

/***/ },
/* 647 */
164,
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var lang_1 = __webpack_require__(649);
	var control_value_accessor_1 = __webpack_require__(647);
	exports.DEFAULT_VALUE_ACCESSOR = 
	/* @ts2dart_Provider */ {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return DefaultValueAccessor; }),
	    multi: true
	};
	var DefaultValueAccessor = (function () {
	    function DefaultValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    DefaultValueAccessor.prototype.writeValue = function (value) {
	        var normalizedValue = lang_1.isBlank(value) ? '' : value;
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	    };
	    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    DefaultValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
	                    // TODO: vsavkin replace the above selector with the one below it once
	                    // https://github.com/angular/angular/issues/3011 is implemented
	                    // selector: '[ngControl],[ngModel],[ngFormControl]',
	                    host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                    providers: [exports.DEFAULT_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    DefaultValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return DefaultValueAccessor;
	}());
	exports.DefaultValueAccessor = DefaultValueAccessor;
	//# sourceMappingURL=default_value_accessor.js.map

/***/ },
/* 649 */
5,
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var lang_1 = __webpack_require__(649);
	var ng_control_1 = __webpack_require__(651);
	var NgControlStatus = (function () {
	    function NgControlStatus(cd) {
	        this._cd = cd;
	    }
	    Object.defineProperty(NgControlStatus.prototype, "ngClassUntouched", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.untouched : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassTouched", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.touched : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassPristine", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.pristine : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassDirty", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.dirty : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassValid", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? this._cd.control.valid : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControlStatus.prototype, "ngClassInvalid", {
	        get: function () {
	            return lang_1.isPresent(this._cd.control) ? !this._cd.control.valid : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    NgControlStatus.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[formControlName],[ngModel],[formControl]',
	                    host: {
	                        '[class.ng-untouched]': 'ngClassUntouched',
	                        '[class.ng-touched]': 'ngClassTouched',
	                        '[class.ng-pristine]': 'ngClassPristine',
	                        '[class.ng-dirty]': 'ngClassDirty',
	                        '[class.ng-valid]': 'ngClassValid',
	                        '[class.ng-invalid]': 'ngClassInvalid'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    NgControlStatus.ctorParameters = [
	        { type: ng_control_1.NgControl, decorators: [{ type: core_1.Self },] },
	    ];
	    return NgControlStatus;
	}());
	exports.NgControlStatus = NgControlStatus;
	//# sourceMappingURL=ng_control_status.js.map

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var exceptions_1 = __webpack_require__(652);
	var abstract_control_directive_1 = __webpack_require__(656);
	/**
	 * A base class that all control directive extend.
	 * It binds a {@link Control} object to a DOM element.
	 *
	 * Used internally by Angular forms.
	 *
	 * @experimental
	 */
	var NgControl = (function (_super) {
	    __extends(NgControl, _super);
	    function NgControl() {
	        _super.apply(this, arguments);
	        this.name = null;
	        this.valueAccessor = null;
	    }
	    Object.defineProperty(NgControl.prototype, "validator", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgControl.prototype, "asyncValidator", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    return NgControl;
	}(abstract_control_directive_1.AbstractControlDirective));
	exports.NgControl = NgControl;
	//# sourceMappingURL=ng_control.js.map

/***/ },
/* 652 */
[1394, 653, 654, 654],
/* 653 */
17,
/* 654 */
[1395, 653, 655, 649],
/* 655 */
[1396, 649],
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var exceptions_1 = __webpack_require__(652);
	var lang_1 = __webpack_require__(649);
	/**
	 * Base class for control directives.
	 *
	 * Only used internally in the forms module.
	 *
	 * @experimental
	 */
	var AbstractControlDirective = (function () {
	    function AbstractControlDirective() {
	    }
	    Object.defineProperty(AbstractControlDirective.prototype, "control", {
	        get: function () { return exceptions_1.unimplemented(); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "value", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.value : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.valid : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.errors : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.pristine : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.dirty : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.touched : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
	        get: function () { return lang_1.isPresent(this.control) ? this.control.untouched : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.statusChanges : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
	        get: function () {
	            return lang_1.isPresent(this.control) ? this.control.valueChanges : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControlDirective.prototype, "path", {
	        get: function () { return null; },
	        enumerable: true,
	        configurable: true
	    });
	    return AbstractControlDirective;
	}());
	exports.AbstractControlDirective = AbstractControlDirective;
	//# sourceMappingURL=abstract_control_directive.js.map

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(1);
	var async_1 = __webpack_require__(658);
	var collection_1 = __webpack_require__(655);
	var lang_1 = __webpack_require__(649);
	var model_1 = __webpack_require__(660);
	var validators_1 = __webpack_require__(662);
	var control_container_1 = __webpack_require__(668);
	var shared_1 = __webpack_require__(661);
	exports.formDirectiveProvider = 
	/*@ts2dart_const*/ { provide: control_container_1.ControlContainer, useExisting: core_1.forwardRef(function () { return NgForm; }) };
	var NgForm = (function (_super) {
	    __extends(NgForm, _super);
	    function NgForm(validators, asyncValidators) {
	        _super.call(this);
	        this._submitted = false;
	        this.ngSubmit = new async_1.EventEmitter();
	        this.form = new model_1.FormGroup({}, null, shared_1.composeValidators(validators), shared_1.composeAsyncValidators(asyncValidators));
	    }
	    Object.defineProperty(NgForm.prototype, "submitted", {
	        get: function () { return this._submitted; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "formDirective", {
	        get: function () { return this; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgForm.prototype, "controls", {
	        get: function () { return this.form.controls; },
	        enumerable: true,
	        configurable: true
	    });
	    NgForm.prototype.addControl = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            dir._control = container.registerControl(dir.name, dir.control);
	            shared_1.setUpControl(dir.control, dir);
	            dir.control.updateValueAndValidity({ emitEvent: false });
	        });
	    };
	    NgForm.prototype.getControl = function (dir) { return this.form.find(dir.path); };
	    NgForm.prototype.removeControl = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            if (lang_1.isPresent(container)) {
	                container.removeControl(dir.name);
	            }
	        });
	    };
	    NgForm.prototype.addFormGroup = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            var group = new model_1.FormGroup({});
	            shared_1.setUpFormContainer(group, dir);
	            container.registerControl(dir.name, group);
	            group.updateValueAndValidity({ emitEvent: false });
	        });
	    };
	    NgForm.prototype.removeFormGroup = function (dir) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var container = _this._findContainer(dir.path);
	            if (lang_1.isPresent(container)) {
	                container.removeControl(dir.name);
	            }
	        });
	    };
	    NgForm.prototype.getFormGroup = function (dir) { return this.form.find(dir.path); };
	    NgForm.prototype.updateModel = function (dir, value) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () {
	            var ctrl = _this.form.find(dir.path);
	            ctrl.updateValue(value);
	        });
	    };
	    NgForm.prototype.onSubmit = function () {
	        this._submitted = true;
	        async_1.ObservableWrapper.callEmit(this.ngSubmit, null);
	        return false;
	    };
	    /** @internal */
	    NgForm.prototype._findContainer = function (path) {
	        path.pop();
	        return collection_1.ListWrapper.isEmpty(path) ? this.form : this.form.find(path);
	    };
	    /** @nocollapse */
	    NgForm.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
	                    providers: [exports.formDirectiveProvider],
	                    host: {
	                        '(submit)': 'onSubmit()',
	                    },
	                    outputs: ['ngSubmit'],
	                    exportAs: 'ngForm'
	                },] },
	    ];
	    /** @nocollapse */
	    NgForm.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    return NgForm;
	}(control_container_1.ControlContainer));
	exports.NgForm = NgForm;
	//# sourceMappingURL=ng_form.js.map

/***/ },
/* 658 */
[1397, 649, 659],
/* 659 */
54,
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var shared_1 = __webpack_require__(661);
	var async_1 = __webpack_require__(658);
	var collection_1 = __webpack_require__(655);
	var lang_1 = __webpack_require__(649);
	/**
	 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
	 */
	exports.VALID = 'VALID';
	/**
	 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
	 */
	exports.INVALID = 'INVALID';
	/**
	 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
	 * errors are not yet available for the input value.
	 */
	exports.PENDING = 'PENDING';
	function isControl(control) {
	    return control instanceof AbstractControl;
	}
	exports.isControl = isControl;
	function _find(control, path) {
	    if (lang_1.isBlank(path))
	        return null;
	    if (!(path instanceof Array)) {
	        path = path.split('/');
	    }
	    if (path instanceof Array && collection_1.ListWrapper.isEmpty(path))
	        return null;
	    return path.reduce(function (v, name) {
	        if (v instanceof FormGroup) {
	            return lang_1.isPresent(v.controls[name]) ? v.controls[name] : null;
	        }
	        else if (v instanceof FormArray) {
	            var index = name;
	            return lang_1.isPresent(v.at(index)) ? v.at(index) : null;
	        }
	        else {
	            return null;
	        }
	    }, control);
	}
	function toObservable(r) {
	    return lang_1.isPromise(r) ? async_1.ObservableWrapper.fromPromise(r) : r;
	}
	function coerceToValidator(validator) {
	    return Array.isArray(validator) ? shared_1.composeValidators(validator) : validator;
	}
	function coerceToAsyncValidator(asyncValidator) {
	    return Array.isArray(asyncValidator) ? shared_1.composeAsyncValidators(asyncValidator) : asyncValidator;
	}
	/**
	 * @experimental
	 */
	var AbstractControl = (function () {
	    function AbstractControl(validator, asyncValidator) {
	        this.validator = validator;
	        this.asyncValidator = asyncValidator;
	        this._pristine = true;
	        this._touched = false;
	    }
	    Object.defineProperty(AbstractControl.prototype, "value", {
	        get: function () { return this._value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "status", {
	        get: function () { return this._status; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "valid", {
	        get: function () { return this._status === exports.VALID; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "errors", {
	        /**
	         * Returns the errors of this control.
	         */
	        get: function () { return this._errors; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "pristine", {
	        get: function () { return this._pristine; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "dirty", {
	        get: function () { return !this.pristine; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "touched", {
	        get: function () { return this._touched; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "untouched", {
	        get: function () { return !this._touched; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
	        get: function () { return this._valueChanges; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
	        get: function () { return this._statusChanges; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractControl.prototype, "pending", {
	        get: function () { return this._status == exports.PENDING; },
	        enumerable: true,
	        configurable: true
	    });
	    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
	        this.asyncValidator = coerceToAsyncValidator(newValidator);
	    };
	    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
	    AbstractControl.prototype.setValidators = function (newValidator) {
	        this.validator = coerceToValidator(newValidator);
	    };
	    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
	    AbstractControl.prototype.markAsTouched = function () { this._touched = true; };
	    AbstractControl.prototype.markAsDirty = function (_a) {
	        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        this._pristine = false;
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.markAsDirty({ onlySelf: onlySelf });
	        }
	    };
	    AbstractControl.prototype.markAsPending = function (_a) {
	        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        this._status = exports.PENDING;
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.markAsPending({ onlySelf: onlySelf });
	        }
	    };
	    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
	    AbstractControl.prototype.updateValueAndValidity = function (_a) {
	        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	        onlySelf = lang_1.normalizeBool(onlySelf);
	        emitEvent = lang_1.isPresent(emitEvent) ? emitEvent : true;
	        this._updateValue();
	        this._errors = this._runValidator();
	        this._status = this._calculateStatus();
	        if (this._status == exports.VALID || this._status == exports.PENDING) {
	            this._runAsyncValidator(emitEvent);
	        }
	        if (emitEvent) {
	            async_1.ObservableWrapper.callEmit(this._valueChanges, this._value);
	            async_1.ObservableWrapper.callEmit(this._statusChanges, this._status);
	        }
	        if (lang_1.isPresent(this._parent) && !onlySelf) {
	            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        }
	    };
	    AbstractControl.prototype._runValidator = function () {
	        return lang_1.isPresent(this.validator) ? this.validator(this) : null;
	    };
	    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
	        var _this = this;
	        if (lang_1.isPresent(this.asyncValidator)) {
	            this._status = exports.PENDING;
	            this._cancelExistingSubscription();
	            var obs = toObservable(this.asyncValidator(this));
	            this._asyncValidationSubscription = async_1.ObservableWrapper.subscribe(obs, function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); });
	        }
	    };
	    AbstractControl.prototype._cancelExistingSubscription = function () {
	        if (lang_1.isPresent(this._asyncValidationSubscription)) {
	            async_1.ObservableWrapper.dispose(this._asyncValidationSubscription);
	        }
	    };
	    /**
	     * Sets errors on a form control.
	     *
	     * This is used when validations are run not automatically, but manually by the user.
	     *
	     * Calling `setErrors` will also update the validity of the parent control.
	     *
	     * ## Usage
	     *
	     * ```
	     * var login = new FormControl("someLogin");
	     * login.setErrors({
	     *   "notUnique": true
	     * });
	     *
	     * expect(login.valid).toEqual(false);
	     * expect(login.errors).toEqual({"notUnique": true});
	     *
	     * login.updateValue("someOtherLogin");
	     *
	     * expect(login.valid).toEqual(true);
	     * ```
	     */
	    AbstractControl.prototype.setErrors = function (errors, _a) {
	        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
	        emitEvent = lang_1.isPresent(emitEvent) ? emitEvent : true;
	        this._errors = errors;
	        this._updateControlsErrors(emitEvent);
	    };
	    AbstractControl.prototype.find = function (path) { return _find(this, path); };
	    AbstractControl.prototype.getError = function (errorCode, path) {
	        if (path === void 0) { path = null; }
	        var control = lang_1.isPresent(path) && !collection_1.ListWrapper.isEmpty(path) ? this.find(path) : this;
	        if (lang_1.isPresent(control) && lang_1.isPresent(control._errors)) {
	            return collection_1.StringMapWrapper.get(control._errors, errorCode);
	        }
	        else {
	            return null;
	        }
	    };
	    AbstractControl.prototype.hasError = function (errorCode, path) {
	        if (path === void 0) { path = null; }
	        return lang_1.isPresent(this.getError(errorCode, path));
	    };
	    Object.defineProperty(AbstractControl.prototype, "root", {
	        get: function () {
	            var x = this;
	            while (lang_1.isPresent(x._parent)) {
	                x = x._parent;
	            }
	            return x;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
	        this._status = this._calculateStatus();
	        if (emitEvent) {
	            async_1.ObservableWrapper.callEmit(this._statusChanges, this._status);
	        }
	        if (lang_1.isPresent(this._parent)) {
	            this._parent._updateControlsErrors(emitEvent);
	        }
	    };
	    /** @internal */
	    AbstractControl.prototype._initObservables = function () {
	        this._valueChanges = new async_1.EventEmitter();
	        this._statusChanges = new async_1.EventEmitter();
	    };
	    AbstractControl.prototype._calculateStatus = function () {
	        if (lang_1.isPresent(this._errors))
	            return exports.INVALID;
	        if (this._anyControlsHaveStatus(exports.PENDING))
	            return exports.PENDING;
	        if (this._anyControlsHaveStatus(exports.INVALID))
	            return exports.INVALID;
	        return exports.VALID;
	    };
	    return AbstractControl;
	}());
	exports.AbstractControl = AbstractControl;
	/**
	 * Defines a part of a form that cannot be divided into other controls. `FormControl`s have values
	 * and
	 * validation state, which is determined by an optional validation function.
	 *
	 * `FormControl` is one of the three fundamental building blocks used to define forms in Angular,
	 * along
	 * with {@link FormGroup} and {@link FormArray}.
	 *
	 * ## Usage
	 *
	 * By default, a `FormControl` is created for every `<input>` or other form component.
	 * With {@link FormControlDirective} or {@link FormGroupDirective} an existing {@link FormControl}
	 * can be bound to a DOM element instead. This `FormControl` can be configured with a custom
	 * validation function.
	 *
	 * @experimental
	 */
	var FormControl = (function (_super) {
	    __extends(FormControl, _super);
	    function FormControl(value, validator, asyncValidator) {
	        if (value === void 0) { value = null; }
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
	        /** @internal */
	        this._onChange = [];
	        this._value = value;
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        this._initObservables();
	    }
	    /**
	     * Set the value of the form control to `value`.
	     *
	     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	     * and not its parent component. If `emitEvent` is `true`, this change will cause a
	     * `valueChanges` event on the `FormControl` to be emitted. Both of these options default to
	     * `false`.
	     *
	     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	     * specified.
	     */
	    FormControl.prototype.updateValue = function (value, _a) {
	        var _this = this;
	        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange;
	        emitModelToViewChange = lang_1.isPresent(emitModelToViewChange) ? emitModelToViewChange : true;
	        this._value = value;
	        if (this._onChange.length && emitModelToViewChange) {
	            this._onChange.forEach(function (changeFn) { return changeFn(_this._value); });
	        }
	        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	    };
	    /**
	     * @internal
	     */
	    FormControl.prototype._updateValue = function () { };
	    /**
	     * @internal
	     */
	    FormControl.prototype._anyControlsHaveStatus = function (status) { return false; };
	    /**
	     * Register a listener for change events.
	     */
	    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
	    return FormControl;
	}(AbstractControl));
	exports.FormControl = FormControl;
	/**
	 * Defines a part of a form, of fixed length, that can contain other controls.
	 *
	 * A `FormGroup` aggregates the values of each {@link FormControl} in the group.
	 * The status of a `FormGroup` depends on the status of its children.
	 * If one of the controls in a group is invalid, the entire group is invalid.
	 * Similarly, if a control changes its value, the entire group changes as well.
	 *
	 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
	 * along with {@link FormControl} and {@link FormArray}. {@link FormArray} can also contain other
	 * controls, but is of variable length.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
	 *
	 * @experimental
	 */
	var FormGroup = (function (_super) {
	    __extends(FormGroup, _super);
	    function FormGroup(controls, optionals, validator, asyncValidator) {
	        if (optionals === void 0) { optionals = null; }
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, validator, asyncValidator);
	        this.controls = controls;
	        this._optionals = lang_1.isPresent(optionals) ? optionals : {};
	        this._initObservables();
	        this._setParentForControls();
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	    }
	    /**
	     * Register a control with the group's list of controls.
	     */
	    FormGroup.prototype.registerControl = function (name, control) {
	        if (this.controls[name])
	            return this.controls[name];
	        this.controls[name] = control;
	        control.setParent(this);
	        return control;
	    };
	    /**
	     * Add a control to this group.
	     */
	    FormGroup.prototype.addControl = function (name, control) {
	        this.registerControl(name, control);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Remove a control from this group.
	     */
	    FormGroup.prototype.removeControl = function (name) {
	        collection_1.StringMapWrapper.delete(this.controls, name);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Mark the named control as non-optional.
	     */
	    FormGroup.prototype.include = function (controlName) {
	        collection_1.StringMapWrapper.set(this._optionals, controlName, true);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Mark the named control as optional.
	     */
	    FormGroup.prototype.exclude = function (controlName) {
	        collection_1.StringMapWrapper.set(this._optionals, controlName, false);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Check whether there is a control with the given name in the group.
	     */
	    FormGroup.prototype.contains = function (controlName) {
	        var c = collection_1.StringMapWrapper.contains(this.controls, controlName);
	        return c && this._included(controlName);
	    };
	    /** @internal */
	    FormGroup.prototype._setParentForControls = function () {
	        var _this = this;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) { control.setParent(_this); });
	    };
	    /** @internal */
	    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
	    /** @internal */
	    FormGroup.prototype._anyControlsHaveStatus = function (status) {
	        var _this = this;
	        var res = false;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
	            res = res || (_this.contains(name) && control.status == status);
	        });
	        return res;
	    };
	    /** @internal */
	    FormGroup.prototype._reduceValue = function () {
	        return this._reduceChildren({}, function (acc, control, name) {
	            acc[name] = control.value;
	            return acc;
	        });
	    };
	    /** @internal */
	    FormGroup.prototype._reduceChildren = function (initValue, fn) {
	        var _this = this;
	        var res = initValue;
	        collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
	            if (_this._included(name)) {
	                res = fn(res, control, name);
	            }
	        });
	        return res;
	    };
	    /** @internal */
	    FormGroup.prototype._included = function (controlName) {
	        var isOptional = collection_1.StringMapWrapper.contains(this._optionals, controlName);
	        return !isOptional || collection_1.StringMapWrapper.get(this._optionals, controlName);
	    };
	    return FormGroup;
	}(AbstractControl));
	exports.FormGroup = FormGroup;
	/**
	 * Defines a part of a form, of variable length, that can contain other controls.
	 *
	 * A `FormArray` aggregates the values of each {@link FormControl} in the group.
	 * The status of a `FormArray` depends on the status of its children.
	 * If one of the controls in a group is invalid, the entire array is invalid.
	 * Similarly, if a control changes its value, the entire array changes as well.
	 *
	 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
	 * along with {@link FormControl} and {@link FormGroup}. {@link FormGroup} can also contain
	 * other controls, but is of fixed length.
	 *
	 * ## Adding or removing controls
	 *
	 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
	 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
	 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
	 * the `FormArray` directly, as that will result in strange and unexpected behavior such
	 * as broken change detection.
	 *
	 * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
	 *
	 * @experimental
	 */
	var FormArray = (function (_super) {
	    __extends(FormArray, _super);
	    function FormArray(controls, validator, asyncValidator) {
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        _super.call(this, validator, asyncValidator);
	        this.controls = controls;
	        this._initObservables();
	        this._setParentForControls();
	        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	    }
	    /**
	     * Get the {@link AbstractControl} at the given `index` in the array.
	     */
	    FormArray.prototype.at = function (index) { return this.controls[index]; };
	    /**
	     * Insert a new {@link AbstractControl} at the end of the array.
	     */
	    FormArray.prototype.push = function (control) {
	        this.controls.push(control);
	        control.setParent(this);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Insert a new {@link AbstractControl} at the given `index` in the array.
	     */
	    FormArray.prototype.insert = function (index, control) {
	        collection_1.ListWrapper.insert(this.controls, index, control);
	        control.setParent(this);
	        this.updateValueAndValidity();
	    };
	    /**
	     * Remove the control at the given `index` in the array.
	     */
	    FormArray.prototype.removeAt = function (index) {
	        collection_1.ListWrapper.removeAt(this.controls, index);
	        this.updateValueAndValidity();
	    };
	    Object.defineProperty(FormArray.prototype, "length", {
	        /**
	         * Length of the control array.
	         */
	        get: function () { return this.controls.length; },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    FormArray.prototype._updateValue = function () { this._value = this.controls.map(function (control) { return control.value; }); };
	    /** @internal */
	    FormArray.prototype._anyControlsHaveStatus = function (status) {
	        return this.controls.some(function (c) { return c.status == status; });
	    };
	    /** @internal */
	    FormArray.prototype._setParentForControls = function () {
	        var _this = this;
	        this.controls.forEach(function (control) { control.setParent(_this); });
	    };
	    return FormArray;
	}(AbstractControl));
	exports.FormArray = FormArray;
	//# sourceMappingURL=model.js.map

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var collection_1 = __webpack_require__(655);
	var exceptions_1 = __webpack_require__(652);
	var lang_1 = __webpack_require__(649);
	var validators_1 = __webpack_require__(662);
	var checkbox_value_accessor_1 = __webpack_require__(646);
	var default_value_accessor_1 = __webpack_require__(648);
	var normalize_validator_1 = __webpack_require__(663);
	var number_value_accessor_1 = __webpack_require__(664);
	var radio_control_value_accessor_1 = __webpack_require__(665);
	var select_control_value_accessor_1 = __webpack_require__(666);
	var select_multiple_control_value_accessor_1 = __webpack_require__(667);
	function controlPath(name, parent) {
	    var p = collection_1.ListWrapper.clone(parent.path);
	    p.push(name);
	    return p;
	}
	exports.controlPath = controlPath;
	function setUpControl(control, dir) {
	    if (lang_1.isBlank(control))
	        _throwError(dir, 'Cannot find control');
	    if (lang_1.isBlank(dir.valueAccessor))
	        _throwError(dir, 'No value accessor for');
	    control.validator = validators_1.Validators.compose([control.validator, dir.validator]);
	    control.asyncValidator = validators_1.Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	    dir.valueAccessor.writeValue(control.value);
	    // view -> model
	    dir.valueAccessor.registerOnChange(function (newValue) {
	        dir.viewToModelUpdate(newValue);
	        control.updateValue(newValue, { emitModelToViewChange: false });
	        control.markAsDirty();
	    });
	    // model -> view
	    control.registerOnChange(function (newValue) { return dir.valueAccessor.writeValue(newValue); });
	    // touched
	    dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
	}
	exports.setUpControl = setUpControl;
	function setUpFormContainer(control, dir) {
	    if (lang_1.isBlank(control))
	        _throwError(dir, 'Cannot find control');
	    control.validator = validators_1.Validators.compose([control.validator, dir.validator]);
	    control.asyncValidator = validators_1.Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	}
	exports.setUpFormContainer = setUpFormContainer;
	function _throwError(dir, message) {
	    var path = dir.path.join(' -> ');
	    throw new exceptions_1.BaseException(message + " '" + path + "'");
	}
	function composeValidators(validators) {
	    return lang_1.isPresent(validators) ? validators_1.Validators.compose(validators.map(normalize_validator_1.normalizeValidator)) : null;
	}
	exports.composeValidators = composeValidators;
	function composeAsyncValidators(validators) {
	    return lang_1.isPresent(validators) ? validators_1.Validators.composeAsync(validators.map(normalize_validator_1.normalizeAsyncValidator)) :
	        null;
	}
	exports.composeAsyncValidators = composeAsyncValidators;
	function isPropertyUpdated(changes, viewModel) {
	    if (!collection_1.StringMapWrapper.contains(changes, 'model'))
	        return false;
	    var change = changes['model'];
	    if (change.isFirstChange())
	        return true;
	    return !lang_1.looseIdentical(viewModel, change.currentValue);
	}
	exports.isPropertyUpdated = isPropertyUpdated;
	// TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
	function selectValueAccessor(dir, valueAccessors) {
	    if (lang_1.isBlank(valueAccessors))
	        return null;
	    var defaultAccessor;
	    var builtinAccessor;
	    var customAccessor;
	    valueAccessors.forEach(function (v) {
	        if (lang_1.hasConstructor(v, default_value_accessor_1.DefaultValueAccessor)) {
	            defaultAccessor = v;
	        }
	        else if (lang_1.hasConstructor(v, checkbox_value_accessor_1.CheckboxControlValueAccessor) || lang_1.hasConstructor(v, number_value_accessor_1.NumberValueAccessor) ||
	            lang_1.hasConstructor(v, select_control_value_accessor_1.SelectControlValueAccessor) ||
	            lang_1.hasConstructor(v, select_multiple_control_value_accessor_1.SelectMultipleControlValueAccessor) ||
	            lang_1.hasConstructor(v, radio_control_value_accessor_1.RadioControlValueAccessor)) {
	            if (lang_1.isPresent(builtinAccessor))
	                _throwError(dir, 'More than one built-in value accessor matches');
	            builtinAccessor = v;
	        }
	        else {
	            if (lang_1.isPresent(customAccessor))
	                _throwError(dir, 'More than one custom value accessor matches');
	            customAccessor = v;
	        }
	    });
	    if (lang_1.isPresent(customAccessor))
	        return customAccessor;
	    if (lang_1.isPresent(builtinAccessor))
	        return builtinAccessor;
	    if (lang_1.isPresent(defaultAccessor))
	        return defaultAccessor;
	    _throwError(dir, 'No valid value accessor for');
	    return null;
	}
	exports.selectValueAccessor = selectValueAccessor;
	//# sourceMappingURL=shared.js.map

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var async_1 = __webpack_require__(658);
	var collection_1 = __webpack_require__(655);
	var lang_1 = __webpack_require__(649);
	var promise_1 = __webpack_require__(659);
	/**
	 * Providers for validators to be used for {@link FormControl}s in a form.
	 *
	 * Provide this using `multi: true` to add validators.
	 *
	 * ### Example
	 *
	 * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
	 * @experimental
	 */
	exports.NG_VALIDATORS = new core_1.OpaqueToken('NgValidators');
	/**
	 * Providers for asynchronous validators to be used for {@link FormControl}s
	 * in a form.
	 *
	 * Provide this using `multi: true` to add validators.
	 *
	 * See {@link NG_VALIDATORS} for more details.
	 *
	 * @experimental
	 */
	exports.NG_ASYNC_VALIDATORS = 
	/*@ts2dart_const*/ new core_1.OpaqueToken('NgAsyncValidators');
	/**
	 * Provides a set of validators used by form controls.
	 *
	 * A validator is a function that processes a {@link FormControl} or collection of
	 * controls and returns a map of errors. A null map means that validation has passed.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * var loginControl = new FormControl("", Validators.required)
	 * ```
	 *
	 * @experimental
	 */
	var Validators = (function () {
	    function Validators() {
	    }
	    /**
	     * Validator that requires controls to have a non-empty value.
	     */
	    Validators.required = function (control) {
	        return lang_1.isBlank(control.value) || (lang_1.isString(control.value) && control.value == '') ?
	            { 'required': true } :
	            null;
	    };
	    /**
	     * Validator that requires controls to have a value of a minimum length.
	     */
	    Validators.minLength = function (minLength) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var v = control.value;
	            return v.length < minLength ?
	                { 'minlength': { 'requiredLength': minLength, 'actualLength': v.length } } :
	                null;
	        };
	    };
	    /**
	     * Validator that requires controls to have a value of a maximum length.
	     */
	    Validators.maxLength = function (maxLength) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var v = control.value;
	            return v.length > maxLength ?
	                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': v.length } } :
	                null;
	        };
	    };
	    /**
	     * Validator that requires a control to match a regex to its value.
	     */
	    Validators.pattern = function (pattern) {
	        return function (control) {
	            if (lang_1.isPresent(Validators.required(control)))
	                return null;
	            var regex = new RegExp("^" + pattern + "$");
	            var v = control.value;
	            return regex.test(v) ? null :
	                { 'pattern': { 'requiredPattern': "^" + pattern + "$", 'actualValue': v } };
	        };
	    };
	    /**
	     * No-op validator.
	     */
	    Validators.nullValidator = function (c) { return null; };
	    /**
	     * Compose multiple validators into a single function that returns the union
	     * of the individual error maps.
	     */
	    Validators.compose = function (validators) {
	        if (lang_1.isBlank(validators))
	            return null;
	        var presentValidators = validators.filter(lang_1.isPresent);
	        if (presentValidators.length == 0)
	            return null;
	        return function (control) {
	            return _mergeErrors(_executeValidators(control, presentValidators));
	        };
	    };
	    Validators.composeAsync = function (validators) {
	        if (lang_1.isBlank(validators))
	            return null;
	        var presentValidators = validators.filter(lang_1.isPresent);
	        if (presentValidators.length == 0)
	            return null;
	        return function (control) {
	            var promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
	            return promise_1.PromiseWrapper.all(promises).then(_mergeErrors);
	        };
	    };
	    return Validators;
	}());
	exports.Validators = Validators;
	function _convertToPromise(obj) {
	    return lang_1.isPromise(obj) ? obj : async_1.ObservableWrapper.toPromise(obj);
	}
	function _executeValidators(control, validators) {
	    return validators.map(function (v) { return v(control); });
	}
	function _executeAsyncValidators(control, validators) {
	    return validators.map(function (v) { return v(control); });
	}
	function _mergeErrors(arrayOfErrors) {
	    var res = arrayOfErrors.reduce(function (res, errors) {
	        return lang_1.isPresent(errors) ? collection_1.StringMapWrapper.merge(res, errors) : res;
	    }, {});
	    return collection_1.StringMapWrapper.isEmpty(res) ? null : res;
	}
	//# sourceMappingURL=validators.js.map

/***/ },
/* 663 */
176,
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var lang_1 = __webpack_require__(649);
	var control_value_accessor_1 = __webpack_require__(647);
	exports.NUMBER_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return NumberValueAccessor; }),
	    multi: true
	};
	var NumberValueAccessor = (function () {
	    function NumberValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    NumberValueAccessor.prototype.writeValue = function (value) {
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', value);
	    };
	    NumberValueAccessor.prototype.registerOnChange = function (fn) {
	        this.onChange = function (value) { fn(value == '' ? null : lang_1.NumberWrapper.parseFloat(value)); };
	    };
	    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @nocollapse */
	    NumberValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
	                    host: {
	                        '(change)': 'onChange($event.target.value)',
	                        '(input)': 'onChange($event.target.value)',
	                        '(blur)': 'onTouched()'
	                    },
	                    providers: [exports.NUMBER_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    NumberValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return NumberValueAccessor;
	}());
	exports.NumberValueAccessor = NumberValueAccessor;
	//# sourceMappingURL=number_value_accessor.js.map

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var collection_1 = __webpack_require__(655);
	var exceptions_1 = __webpack_require__(652);
	var lang_1 = __webpack_require__(649);
	var control_value_accessor_1 = __webpack_require__(647);
	var ng_control_1 = __webpack_require__(651);
	exports.RADIO_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return RadioControlValueAccessor; }),
	    multi: true
	};
	var RadioControlRegistry = (function () {
	    function RadioControlRegistry() {
	        this._accessors = [];
	    }
	    RadioControlRegistry.prototype.add = function (control, accessor) {
	        this._accessors.push([control, accessor]);
	    };
	    RadioControlRegistry.prototype.remove = function (accessor) {
	        var indexToRemove = -1;
	        for (var i = 0; i < this._accessors.length; ++i) {
	            if (this._accessors[i][1] === accessor) {
	                indexToRemove = i;
	            }
	        }
	        collection_1.ListWrapper.removeAt(this._accessors, indexToRemove);
	    };
	    RadioControlRegistry.prototype.select = function (accessor) {
	        var _this = this;
	        this._accessors.forEach(function (c) {
	            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
	                c[1].fireUncheck(accessor.value);
	            }
	        });
	    };
	    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
	        if (!controlPair[0].control)
	            return false;
	        return controlPair[0].control.root === accessor._control.control.root &&
	            controlPair[1].name === accessor.name;
	    };
	    /** @nocollapse */
	    RadioControlRegistry.decorators = [
	        { type: core_1.Injectable },
	    ];
	    return RadioControlRegistry;
	}());
	exports.RadioControlRegistry = RadioControlRegistry;
	var RadioControlValueAccessor = (function () {
	    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this._registry = _registry;
	        this._injector = _injector;
	        this.onChange = function () { };
	        this.onTouched = function () { };
	    }
	    RadioControlValueAccessor.prototype.ngOnInit = function () {
	        this._control = this._injector.get(ng_control_1.NgControl);
	        this._checkName();
	        this._registry.add(this._control, this);
	    };
	    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
	    RadioControlValueAccessor.prototype.writeValue = function (value) {
	        this._state = value === this.value;
	        if (lang_1.isPresent(value)) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
	        }
	    };
	    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this._fn = fn;
	        this.onChange = function () {
	            fn(_this.value);
	            _this._registry.select(_this);
	        };
	    };
	    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
	    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    RadioControlValueAccessor.prototype._checkName = function () {
	        if (this.name && this.formControlName && this.name !== this.formControlName) {
	            this._throwNameError();
	        }
	        if (!this.name && this.formControlName)
	            this.name = this.formControlName;
	    };
	    RadioControlValueAccessor.prototype._throwNameError = function () {
	        throw new exceptions_1.BaseException("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
	    };
	    /** @nocollapse */
	    RadioControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
	                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
	                    providers: [exports.RADIO_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    RadioControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	        { type: RadioControlRegistry, },
	        { type: core_1.Injector, },
	    ];
	    /** @nocollapse */
	    RadioControlValueAccessor.propDecorators = {
	        'name': [{ type: core_1.Input },],
	        'formControlName': [{ type: core_1.Input },],
	        'value': [{ type: core_1.Input },],
	    };
	    return RadioControlValueAccessor;
	}());
	exports.RadioControlValueAccessor = RadioControlValueAccessor;
	//# sourceMappingURL=radio_control_value_accessor.js.map

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var collection_1 = __webpack_require__(655);
	var lang_1 = __webpack_require__(649);
	var control_value_accessor_1 = __webpack_require__(647);
	exports.SELECT_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return SelectControlValueAccessor; }),
	    multi: true
	};
	function _buildValueString(id, value) {
	    if (lang_1.isBlank(id))
	        return "" + value;
	    if (!lang_1.isPrimitive(value))
	        value = 'Object';
	    return lang_1.StringWrapper.slice(id + ": " + value, 0, 50);
	}
	function _extractId(valueString) {
	    return valueString.split(':')[0];
	}
	var SelectControlValueAccessor = (function () {
	    function SelectControlValueAccessor(_renderer, _elementRef) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        /** @internal */
	        this._optionMap = new Map();
	        /** @internal */
	        this._idCounter = 0;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    SelectControlValueAccessor.prototype.writeValue = function (value) {
	        this.value = value;
	        var valueString = _buildValueString(this._getOptionId(value), value);
	        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
	    };
	    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this.onChange = function (valueString) {
	            _this.value = valueString;
	            fn(_this._getOptionValue(valueString));
	        };
	    };
	    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @internal */
	    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
	    /** @internal */
	    SelectControlValueAccessor.prototype._getOptionId = function (value) {
	        for (var _i = 0, _a = collection_1.MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
	            var id = _a[_i];
	            if (lang_1.looseIdentical(this._optionMap.get(id), value))
	                return id;
	        }
	        return null;
	    };
	    /** @internal */
	    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
	        var value = this._optionMap.get(_extractId(valueString));
	        return lang_1.isPresent(value) ? value : valueString;
	    };
	    /** @nocollapse */
	    SelectControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
	                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                    providers: [exports.SELECT_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    SelectControlValueAccessor.ctorParameters = [
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return SelectControlValueAccessor;
	}());
	exports.SelectControlValueAccessor = SelectControlValueAccessor;
	var NgSelectOption = (function () {
	    function NgSelectOption(_element, _renderer, _select) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this._select = _select;
	        if (lang_1.isPresent(this._select))
	            this.id = this._select._registerOption();
	    }
	    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
	        set: function (value) {
	            if (this._select == null)
	                return;
	            this._select._optionMap.set(this.id, value);
	            this._setElementValue(_buildValueString(this.id, value));
	            this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgSelectOption.prototype, "value", {
	        set: function (value) {
	            this._setElementValue(value);
	            if (lang_1.isPresent(this._select))
	                this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    NgSelectOption.prototype._setElementValue = function (value) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	    };
	    NgSelectOption.prototype.ngOnDestroy = function () {
	        if (lang_1.isPresent(this._select)) {
	            this._select._optionMap.delete(this.id);
	            this._select.writeValue(this._select.value);
	        }
	    };
	    /** @nocollapse */
	    NgSelectOption.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'option' },] },
	    ];
	    /** @nocollapse */
	    NgSelectOption.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	        { type: SelectControlValueAccessor, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	    ];
	    /** @nocollapse */
	    NgSelectOption.propDecorators = {
	        'ngValue': [{ type: core_1.Input, args: ['ngValue',] },],
	        'value': [{ type: core_1.Input, args: ['value',] },],
	    };
	    return NgSelectOption;
	}());
	exports.NgSelectOption = NgSelectOption;
	//# sourceMappingURL=select_control_value_accessor.js.map

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var collection_1 = __webpack_require__(655);
	var lang_1 = __webpack_require__(649);
	var control_value_accessor_1 = __webpack_require__(647);
	var SELECT_MULTIPLE_VALUE_ACCESSOR = {
	    provide: control_value_accessor_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return SelectMultipleControlValueAccessor; }),
	    multi: true
	};
	function _buildValueString(id, value) {
	    if (lang_1.isBlank(id))
	        return "" + value;
	    if (lang_1.isString(value))
	        value = "'" + value + "'";
	    if (!lang_1.isPrimitive(value))
	        value = 'Object';
	    return lang_1.StringWrapper.slice(id + ": " + value, 0, 50);
	}
	function _extractId(valueString) {
	    return valueString.split(':')[0];
	}
	/** Mock interface for HTMLCollection */
	var HTMLCollection = (function () {
	    function HTMLCollection() {
	    }
	    return HTMLCollection;
	}());
	var SelectMultipleControlValueAccessor = (function () {
	    function SelectMultipleControlValueAccessor() {
	        /** @internal */
	        this._optionMap = new Map();
	        /** @internal */
	        this._idCounter = 0;
	        this.onChange = function (_) { };
	        this.onTouched = function () { };
	    }
	    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
	        var _this = this;
	        this.value = value;
	        if (value == null)
	            return;
	        var values = value;
	        // convert values to ids
	        var ids = values.map(function (v) { return _this._getOptionId(v); });
	        this._optionMap.forEach(function (opt, o) { opt._setSelected(ids.indexOf(o.toString()) > -1); });
	    };
	    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
	        var _this = this;
	        this.onChange = function (_) {
	            var selected = [];
	            if (_.hasOwnProperty('selectedOptions')) {
	                var options = _.selectedOptions;
	                for (var i = 0; i < options.length; i++) {
	                    var opt = options.item(i);
	                    var val = _this._getOptionValue(opt.value);
	                    selected.push(val);
	                }
	            }
	            else {
	                var options = _.options;
	                for (var i = 0; i < options.length; i++) {
	                    var opt = options.item(i);
	                    if (opt.selected) {
	                        var val = _this._getOptionValue(opt.value);
	                        selected.push(val);
	                    }
	                }
	            }
	            fn(selected);
	        };
	    };
	    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
	        var id = (this._idCounter++).toString();
	        this._optionMap.set(id, value);
	        return id;
	    };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
	        for (var _i = 0, _a = collection_1.MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
	            var id = _a[_i];
	            if (lang_1.looseIdentical(this._optionMap.get(id)._value, value))
	                return id;
	        }
	        return null;
	    };
	    /** @internal */
	    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
	        var opt = this._optionMap.get(_extractId(valueString));
	        return lang_1.isPresent(opt) ? opt._value : valueString;
	    };
	    /** @nocollapse */
	    SelectMultipleControlValueAccessor.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
	                    host: { '(input)': 'onChange($event.target)', '(blur)': 'onTouched()' },
	                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    SelectMultipleControlValueAccessor.ctorParameters = [];
	    return SelectMultipleControlValueAccessor;
	}());
	exports.SelectMultipleControlValueAccessor = SelectMultipleControlValueAccessor;
	var NgSelectMultipleOption = (function () {
	    function NgSelectMultipleOption(_element, _renderer, _select) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this._select = _select;
	        if (lang_1.isPresent(this._select)) {
	            this.id = this._select._registerOption(this);
	        }
	    }
	    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
	        set: function (value) {
	            if (this._select == null)
	                return;
	            this._value = value;
	            this._setElementValue(_buildValueString(this.id, value));
	            this._select.writeValue(this._select.value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
	        set: function (value) {
	            if (lang_1.isPresent(this._select)) {
	                this._value = value;
	                this._setElementValue(_buildValueString(this.id, value));
	                this._select.writeValue(this._select.value);
	            }
	            else {
	                this._setElementValue(value);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internal */
	    NgSelectMultipleOption.prototype._setElementValue = function (value) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	    };
	    /** @internal */
	    NgSelectMultipleOption.prototype._setSelected = function (selected) {
	        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
	    };
	    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
	        if (lang_1.isPresent(this._select)) {
	            this._select._optionMap.delete(this.id);
	            this._select.writeValue(this._select.value);
	        }
	    };
	    /** @nocollapse */
	    NgSelectMultipleOption.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'option' },] },
	    ];
	    /** @nocollapse */
	    NgSelectMultipleOption.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	        { type: SelectMultipleControlValueAccessor, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	    ];
	    /** @nocollapse */
	    NgSelectMultipleOption.propDecorators = {
	        'ngValue': [{ type: core_1.Input, args: ['ngValue',] },],
	        'value': [{ type: core_1.Input, args: ['value',] },],
	    };
	    return NgSelectMultipleOption;
	}());
	exports.NgSelectMultipleOption = NgSelectMultipleOption;
	exports.SELECT_DIRECTIVES = [SelectMultipleControlValueAccessor, NgSelectMultipleOption];
	//# sourceMappingURL=select_multiple_control_value_accessor.js.map

/***/ },
/* 668 */
[1399, 656],
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(1);
	var async_1 = __webpack_require__(658);
	var exceptions_1 = __webpack_require__(652);
	var model_1 = __webpack_require__(660);
	var validators_1 = __webpack_require__(662);
	var control_container_1 = __webpack_require__(668);
	var control_value_accessor_1 = __webpack_require__(647);
	var ng_control_1 = __webpack_require__(651);
	var shared_1 = __webpack_require__(661);
	exports.formControlBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return NgModel; })
	};
	var NgModel = (function (_super) {
	    __extends(NgModel, _super);
	    function NgModel(_parent, _validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._parent = _parent;
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        /** @internal */
	        this._control = new model_1.FormControl();
	        /** @internal */
	        this._registered = false;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    NgModel.prototype.ngOnChanges = function (changes) {
	        this._checkName();
	        if (!this._registered)
	            this._setUpControl();
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this._updateValue(this.model);
	            this.viewModel = this.model;
	        }
	    };
	    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
	    Object.defineProperty(NgModel.prototype, "control", {
	        get: function () { return this._control; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "path", {
	        get: function () {
	            return this._parent ? shared_1.controlPath(this.name, this._parent) : [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "formDirective", {
	        get: function () { return this._parent ? this._parent.formDirective : null; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(NgModel.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NgModel.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    NgModel.prototype._setUpControl = function () {
	        this._isStandalone() ? this._setUpStandalone() :
	            this.formDirective.addControl(this);
	        this._registered = true;
	    };
	    NgModel.prototype._isStandalone = function () {
	        return !this._parent || (this.options && this.options.standalone);
	    };
	    NgModel.prototype._setUpStandalone = function () {
	        shared_1.setUpControl(this._control, this);
	        this._control.updateValueAndValidity({ emitEvent: false });
	    };
	    NgModel.prototype._checkName = function () {
	        if (this.options && this.options.name)
	            this.name = this.options.name;
	        if (!this._isStandalone() && !this.name) {
	            throw new exceptions_1.BaseException("If ngModel is used within a form tag, either the name attribute must be set\n                      or the form control must be defined as 'standalone' in ngModelOptions.\n\n                      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n                      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">\n                   ");
	        }
	    };
	    NgModel.prototype._updateValue = function (value) {
	        var _this = this;
	        async_1.PromiseWrapper.scheduleMicrotask(function () { _this.control.updateValue(value); });
	    };
	    /** @nocollapse */
	    NgModel.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[ngModel]:not([formControlName]):not([formControl])',
	                    providers: [exports.formControlBinding],
	                    exportAs: 'ngModel'
	                },] },
	    ];
	    /** @nocollapse */
	    NgModel.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Optional }, { type: core_1.Host },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    NgModel.propDecorators = {
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'name': [{ type: core_1.Input },],
	        'options': [{ type: core_1.Input, args: ['ngModelOptions',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return NgModel;
	}(ng_control_1.NgControl));
	exports.NgModel = NgModel;
	//# sourceMappingURL=ng_model.js.map

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(1);
	var validators_1 = __webpack_require__(662);
	var abstract_form_group_directive_1 = __webpack_require__(671);
	var control_container_1 = __webpack_require__(668);
	exports.modelGroupProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return NgModelGroup; })
	};
	var NgModelGroup = (function (_super) {
	    __extends(NgModelGroup, _super);
	    function NgModelGroup(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    /** @nocollapse */
	    NgModelGroup.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[ngModelGroup]', providers: [exports.modelGroupProvider], exportAs: 'ngModelGroup' },] },
	    ];
	    /** @nocollapse */
	    NgModelGroup.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    NgModelGroup.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['ngModelGroup',] },],
	    };
	    return NgModelGroup;
	}(abstract_form_group_directive_1.AbstractFormGroupDirective));
	exports.NgModelGroup = NgModelGroup;
	//# sourceMappingURL=ng_model_group.js.map

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var control_container_1 = __webpack_require__(668);
	var shared_1 = __webpack_require__(661);
	/**
	  This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
	 */
	var AbstractFormGroupDirective = (function (_super) {
	    __extends(AbstractFormGroupDirective, _super);
	    function AbstractFormGroupDirective() {
	        _super.apply(this, arguments);
	    }
	    AbstractFormGroupDirective.prototype.ngOnInit = function () { this.formDirective.addFormGroup(this); };
	    AbstractFormGroupDirective.prototype.ngOnDestroy = function () { this.formDirective.removeFormGroup(this); };
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
	        /**
	         * Get the {@link FormGroup} backing this binding.
	         */
	        get: function () { return this.formDirective.getFormGroup(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
	        /**
	         * Get the path to this control group.
	         */
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
	        /**
	         * Get the {@link Form} to which this group belongs.
	         */
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
	        get: function () { return shared_1.composeAsyncValidators(this._asyncValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    return AbstractFormGroupDirective;
	}(control_container_1.ControlContainer));
	exports.AbstractFormGroupDirective = AbstractFormGroupDirective;
	//# sourceMappingURL=abstract_form_group_directive.js.map

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(1);
	var validators_1 = __webpack_require__(662);
	var control_container_1 = __webpack_require__(668);
	var shared_1 = __webpack_require__(661);
	exports.formArrayNameProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormArrayName; })
	};
	var FormArrayName = (function (_super) {
	    __extends(FormArrayName, _super);
	    function FormArrayName(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    FormArrayName.prototype.ngOnInit = function () { this.formDirective.addFormArray(this); };
	    FormArrayName.prototype.ngOnDestroy = function () { this.formDirective.removeFormArray(this); };
	    Object.defineProperty(FormArrayName.prototype, "control", {
	        get: function () { return this.formDirective.getFormArray(this); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "formDirective", {
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "path", {
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
	        get: function () { return shared_1.composeAsyncValidators(this._asyncValidators); },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    FormArrayName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formArrayName]', providers: [exports.formArrayNameProvider] },] },
	    ];
	    /** @nocollapse */
	    FormArrayName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormArrayName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formArrayName',] },],
	    };
	    return FormArrayName;
	}(control_container_1.ControlContainer));
	exports.FormArrayName = FormArrayName;
	//# sourceMappingURL=form_array_name.js.map

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(1);
	var async_1 = __webpack_require__(658);
	var collection_1 = __webpack_require__(655);
	var validators_1 = __webpack_require__(662);
	var control_value_accessor_1 = __webpack_require__(647);
	var ng_control_1 = __webpack_require__(651);
	var shared_1 = __webpack_require__(661);
	exports.formControlBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return FormControlDirective; })
	};
	var FormControlDirective = (function (_super) {
	    __extends(FormControlDirective, _super);
	    function FormControlDirective(_validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    FormControlDirective.prototype.ngOnChanges = function (changes) {
	        if (this._isControlChanged(changes)) {
	            shared_1.setUpControl(this.form, this);
	            this.form.updateValueAndValidity({ emitEvent: false });
	        }
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this.form.updateValue(this.model);
	            this.viewModel = this.model;
	        }
	    };
	    Object.defineProperty(FormControlDirective.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlDirective.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    FormControlDirective.prototype._isControlChanged = function (changes) {
	        return collection_1.StringMapWrapper.contains(changes, 'form');
	    };
	    /** @nocollapse */
	    FormControlDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formControl]', providers: [exports.formControlBinding], exportAs: 'ngForm' },] },
	    ];
	    /** @nocollapse */
	    FormControlDirective.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    FormControlDirective.propDecorators = {
	        'form': [{ type: core_1.Input, args: ['formControl',] },],
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return FormControlDirective;
	}(ng_control_1.NgControl));
	exports.FormControlDirective = FormControlDirective;
	//# sourceMappingURL=form_control_directive.js.map

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(1);
	var async_1 = __webpack_require__(658);
	var validators_1 = __webpack_require__(662);
	var control_container_1 = __webpack_require__(668);
	var control_value_accessor_1 = __webpack_require__(647);
	var ng_control_1 = __webpack_require__(651);
	var shared_1 = __webpack_require__(661);
	exports.controlNameBinding = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: ng_control_1.NgControl,
	    useExisting: core_1.forwardRef(function () { return FormControlName; })
	};
	var FormControlName = (function (_super) {
	    __extends(FormControlName, _super);
	    function FormControlName(_parent, _validators, _asyncValidators, valueAccessors) {
	        _super.call(this);
	        this._parent = _parent;
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this._added = false;
	        this.update = new async_1.EventEmitter();
	        this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
	    }
	    FormControlName.prototype.ngOnChanges = function (changes) {
	        if (!this._added) {
	            this.formDirective.addControl(this);
	            this._added = true;
	        }
	        if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
	            this.viewModel = this.model;
	            this.formDirective.updateModel(this, this.model);
	        }
	    };
	    FormControlName.prototype.ngOnDestroy = function () { this.formDirective.removeControl(this); };
	    FormControlName.prototype.viewToModelUpdate = function (newValue) {
	        this.viewModel = newValue;
	        async_1.ObservableWrapper.callEmit(this.update, newValue);
	    };
	    Object.defineProperty(FormControlName.prototype, "path", {
	        get: function () { return shared_1.controlPath(this.name, this._parent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "formDirective", {
	        get: function () { return this._parent.formDirective; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "validator", {
	        get: function () { return shared_1.composeValidators(this._validators); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
	        get: function () {
	            return shared_1.composeAsyncValidators(this._asyncValidators);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormControlName.prototype, "control", {
	        get: function () { return this.formDirective.getControl(this); },
	        enumerable: true,
	        configurable: true
	    });
	    /** @nocollapse */
	    FormControlName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formControlName]', providers: [exports.controlNameBinding] },] },
	    ];
	    /** @nocollapse */
	    FormControlName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [control_value_accessor_1.NG_VALUE_ACCESSOR,] },] },
	    ];
	    /** @nocollapse */
	    FormControlName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formControlName',] },],
	        'model': [{ type: core_1.Input, args: ['ngModel',] },],
	        'update': [{ type: core_1.Output, args: ['ngModelChange',] },],
	    };
	    return FormControlName;
	}(ng_control_1.NgControl));
	exports.FormControlName = FormControlName;
	//# sourceMappingURL=form_control_name.js.map

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(1);
	var async_1 = __webpack_require__(658);
	var collection_1 = __webpack_require__(655);
	var exceptions_1 = __webpack_require__(652);
	var lang_1 = __webpack_require__(649);
	var validators_1 = __webpack_require__(662);
	var control_container_1 = __webpack_require__(668);
	var shared_1 = __webpack_require__(661);
	exports.formDirectiveProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormGroupDirective; })
	};
	var FormGroupDirective = (function (_super) {
	    __extends(FormGroupDirective, _super);
	    function FormGroupDirective(_validators, _asyncValidators) {
	        _super.call(this);
	        this._validators = _validators;
	        this._asyncValidators = _asyncValidators;
	        this._submitted = false;
	        this.directives = [];
	        this.form = null;
	        this.ngSubmit = new async_1.EventEmitter();
	    }
	    FormGroupDirective.prototype.ngOnChanges = function (changes) {
	        this._checkFormPresent();
	        if (collection_1.StringMapWrapper.contains(changes, 'form')) {
	            var sync = shared_1.composeValidators(this._validators);
	            this.form.validator = validators_1.Validators.compose([this.form.validator, sync]);
	            var async = shared_1.composeAsyncValidators(this._asyncValidators);
	            this.form.asyncValidator = validators_1.Validators.composeAsync([this.form.asyncValidator, async]);
	            this.form.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        this._updateDomValue();
	    };
	    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
	        get: function () { return this._submitted; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
	        get: function () { return this; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "control", {
	        get: function () { return this.form; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FormGroupDirective.prototype, "path", {
	        get: function () { return []; },
	        enumerable: true,
	        configurable: true
	    });
	    FormGroupDirective.prototype.addControl = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpControl(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	        this.directives.push(dir);
	    };
	    FormGroupDirective.prototype.getControl = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.removeControl = function (dir) { collection_1.ListWrapper.remove(this.directives, dir); };
	    FormGroupDirective.prototype.addFormGroup = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpFormContainer(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	    };
	    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
	    FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.addFormArray = function (dir) {
	        var ctrl = this.form.find(dir.path);
	        shared_1.setUpFormContainer(ctrl, dir);
	        ctrl.updateValueAndValidity({ emitEvent: false });
	    };
	    FormGroupDirective.prototype.removeFormArray = function (dir) { };
	    FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.find(dir.path); };
	    FormGroupDirective.prototype.updateModel = function (dir, value) {
	        var ctrl = this.form.find(dir.path);
	        ctrl.updateValue(value);
	    };
	    FormGroupDirective.prototype.onSubmit = function () {
	        this._submitted = true;
	        async_1.ObservableWrapper.callEmit(this.ngSubmit, null);
	        return false;
	    };
	    /** @internal */
	    FormGroupDirective.prototype._updateDomValue = function () {
	        var _this = this;
	        this.directives.forEach(function (dir) {
	            var ctrl = _this.form.find(dir.path);
	            dir.valueAccessor.writeValue(ctrl.value);
	        });
	    };
	    FormGroupDirective.prototype._checkFormPresent = function () {
	        if (lang_1.isBlank(this.form)) {
	            throw new exceptions_1.BaseException("formGroup expects a FormGroup instance. Please pass one in.\n           Example: <form [formGroup]=\"myFormGroup\">\n      ");
	        }
	    };
	    /** @nocollapse */
	    FormGroupDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[formGroup]',
	                    providers: [exports.formDirectiveProvider],
	                    host: { '(submit)': 'onSubmit()' },
	                    exportAs: 'ngForm'
	                },] },
	    ];
	    /** @nocollapse */
	    FormGroupDirective.ctorParameters = [
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormGroupDirective.propDecorators = {
	        'form': [{ type: core_1.Input, args: ['formGroup',] },],
	        'ngSubmit': [{ type: core_1.Output },],
	    };
	    return FormGroupDirective;
	}(control_container_1.ControlContainer));
	exports.FormGroupDirective = FormGroupDirective;
	//# sourceMappingURL=form_group_directive.js.map

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(1);
	var validators_1 = __webpack_require__(662);
	var abstract_form_group_directive_1 = __webpack_require__(671);
	var control_container_1 = __webpack_require__(668);
	exports.formGroupNameProvider = 
	/*@ts2dart_const*/ /* @ts2dart_Provider */ {
	    provide: control_container_1.ControlContainer,
	    useExisting: core_1.forwardRef(function () { return FormGroupName; })
	};
	var FormGroupName = (function (_super) {
	    __extends(FormGroupName, _super);
	    function FormGroupName(parent, validators, asyncValidators) {
	        _super.call(this);
	        this._parent = parent;
	        this._validators = validators;
	        this._asyncValidators = asyncValidators;
	    }
	    /** @nocollapse */
	    FormGroupName.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[formGroupName]', providers: [exports.formGroupNameProvider] },] },
	    ];
	    /** @nocollapse */
	    FormGroupName.ctorParameters = [
	        { type: control_container_1.ControlContainer, decorators: [{ type: core_1.Host }, { type: core_1.SkipSelf },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_VALIDATORS,] },] },
	        { type: Array, decorators: [{ type: core_1.Optional }, { type: core_1.Self }, { type: core_1.Inject, args: [validators_1.NG_ASYNC_VALIDATORS,] },] },
	    ];
	    /** @nocollapse */
	    FormGroupName.propDecorators = {
	        'name': [{ type: core_1.Input, args: ['formGroupName',] },],
	    };
	    return FormGroupName;
	}(abstract_form_group_directive_1.AbstractFormGroupDirective));
	exports.FormGroupName = FormGroupName;
	//# sourceMappingURL=form_group_name.js.map

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var lang_1 = __webpack_require__(649);
	var validators_1 = __webpack_require__(662);
	var REQUIRED = validators_1.Validators.required;
	exports.REQUIRED_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useValue: REQUIRED,
	    multi: true
	};
	var RequiredValidator = (function () {
	    function RequiredValidator() {
	    }
	    /** @nocollapse */
	    RequiredValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[required][formControlName],[required][formControl],[required][ngModel]',
	                    providers: [exports.REQUIRED_VALIDATOR]
	                },] },
	    ];
	    return RequiredValidator;
	}());
	exports.RequiredValidator = RequiredValidator;
	/**
	 * Provivder which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
	 *
	 * ## Example:
	 *
	 * {@example common/forms/ts/validators/validators.ts region='min'}
	 */
	exports.MIN_LENGTH_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return MinLengthValidator; }),
	    multi: true
	};
	var MinLengthValidator = (function () {
	    function MinLengthValidator(minLength) {
	        this._validator = validators_1.Validators.minLength(lang_1.NumberWrapper.parseInt(minLength, 10));
	    }
	    MinLengthValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    MinLengthValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
	                    providers: [exports.MIN_LENGTH_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    MinLengthValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['minlength',] },] },
	    ];
	    return MinLengthValidator;
	}());
	exports.MinLengthValidator = MinLengthValidator;
	/**
	 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
	 *
	 * ## Example:
	 *
	 * {@example common/forms/ts/validators/validators.ts region='max'}
	 */
	exports.MAX_LENGTH_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return MaxLengthValidator; }),
	    multi: true
	};
	var MaxLengthValidator = (function () {
	    function MaxLengthValidator(maxLength) {
	        this._validator = validators_1.Validators.maxLength(lang_1.NumberWrapper.parseInt(maxLength, 10));
	    }
	    MaxLengthValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    MaxLengthValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
	                    providers: [exports.MAX_LENGTH_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    MaxLengthValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['maxlength',] },] },
	    ];
	    return MaxLengthValidator;
	}());
	exports.MaxLengthValidator = MaxLengthValidator;
	exports.PATTERN_VALIDATOR = {
	    provide: validators_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return PatternValidator; }),
	    multi: true
	};
	var PatternValidator = (function () {
	    function PatternValidator(pattern) {
	        this._validator = validators_1.Validators.pattern(pattern);
	    }
	    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
	    /** @nocollapse */
	    PatternValidator.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
	                    providers: [exports.PATTERN_VALIDATOR]
	                },] },
	    ];
	    /** @nocollapse */
	    PatternValidator.ctorParameters = [
	        { type: undefined, decorators: [{ type: core_1.Attribute, args: ['pattern',] },] },
	    ];
	    return PatternValidator;
	}());
	exports.PatternValidator = PatternValidator;
	//# sourceMappingURL=validators.js.map

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var core_1 = __webpack_require__(1);
	var collection_1 = __webpack_require__(655);
	var lang_1 = __webpack_require__(649);
	var model_1 = __webpack_require__(660);
	var FormBuilder = (function () {
	    function FormBuilder() {
	    }
	    /**
	     * Construct a new {@link FormGroup} with the given map of configuration.
	     * Valid keys for the `extra` parameter map are `optionals` and `validator`.
	     *
	     * See the {@link FormGroup} constructor for more details.
	     */
	    FormBuilder.prototype.group = function (controlsConfig, extra) {
	        if (extra === void 0) { extra = null; }
	        var controls = this._reduceControls(controlsConfig);
	        var optionals = (lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'optionals') : null);
	        var validator = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'validator') : null;
	        var asyncValidator = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, 'asyncValidator') : null;
	        return new model_1.FormGroup(controls, optionals, validator, asyncValidator);
	    };
	    /**
	     * Construct a new {@link FormControl} with the given `value`,`validator`, and `asyncValidator`.
	     */
	    FormBuilder.prototype.control = function (value, validator, asyncValidator) {
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        return new model_1.FormControl(value, validator, asyncValidator);
	    };
	    /**
	     * Construct an array of {@link FormControl}s from the given `controlsConfig` array of
	     * configuration, with the given optional `validator` and `asyncValidator`.
	     */
	    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
	        var _this = this;
	        if (validator === void 0) { validator = null; }
	        if (asyncValidator === void 0) { asyncValidator = null; }
	        var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
	        return new model_1.FormArray(controls, validator, asyncValidator);
	    };
	    /** @internal */
	    FormBuilder.prototype._reduceControls = function (controlsConfig) {
	        var _this = this;
	        var controls = {};
	        collection_1.StringMapWrapper.forEach(controlsConfig, function (controlConfig, controlName) {
	            controls[controlName] = _this._createControl(controlConfig);
	        });
	        return controls;
	    };
	    /** @internal */
	    FormBuilder.prototype._createControl = function (controlConfig) {
	        if (controlConfig instanceof model_1.FormControl || controlConfig instanceof model_1.FormGroup ||
	            controlConfig instanceof model_1.FormArray) {
	            return controlConfig;
	        }
	        else if (lang_1.isArray(controlConfig)) {
	            var value = controlConfig[0];
	            var validator = controlConfig.length > 1 ? controlConfig[1] : null;
	            var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
	            return this.control(value, validator, asyncValidator);
	        }
	        else {
	            return this.control(controlConfig);
	        }
	    };
	    /** @nocollapse */
	    FormBuilder.decorators = [
	        { type: core_1.Injectable },
	    ];
	    return FormBuilder;
	}());
	exports.FormBuilder = FormBuilder;
	//# sourceMappingURL=form_builder.js.map

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	var common_1 = __webpack_require__(130);
	var compiler_1 = __webpack_require__(256);
	var core_1 = __webpack_require__(1);
	var directives_1 = __webpack_require__(645);
	var radio_control_value_accessor_1 = __webpack_require__(665);
	var collection_1 = __webpack_require__(655);
	var form_builder_1 = __webpack_require__(678);
	/**
	 * Shorthand set of providers used for building Angular forms.
	 *
	 * ### Example
	 *
	 * ```typescript
	 * bootstrap(MyApp, [FORM_PROVIDERS]);
	 * ```
	 *
	 * @experimental
	 */
	exports.FORM_PROVIDERS = [form_builder_1.FormBuilder, radio_control_value_accessor_1.RadioControlRegistry];
	function flatten(platformDirectives) {
	    var flattenedDirectives = [];
	    platformDirectives.forEach(function (directives) {
	        if (Array.isArray(directives)) {
	            flattenedDirectives = flattenedDirectives.concat(directives);
	        }
	        else {
	            flattenedDirectives.push(directives);
	        }
	    });
	    return flattenedDirectives;
	}
	/**
	 * @experimental
	 */
	function disableDeprecatedForms() {
	    return [{
	            provide: compiler_1.CompilerConfig,
	            useFactory: function (platformDirectives, platformPipes) {
	                var flattenedDirectives = flatten(platformDirectives);
	                collection_1.ListWrapper.remove(flattenedDirectives, common_1.FORM_DIRECTIVES);
	                return new compiler_1.CompilerConfig({ platformDirectives: flattenedDirectives, platformPipes: platformPipes });
	            },
	            deps: [core_1.PLATFORM_DIRECTIVES, core_1.PLATFORM_PIPES]
	        }];
	}
	exports.disableDeprecatedForms = disableDeprecatedForms;
	/**
	 * @experimental
	 */
	function provideForms() {
	    return [
	        { provide: core_1.PLATFORM_DIRECTIVES, useValue: directives_1.FORM_DIRECTIVES, multi: true }, exports.FORM_PROVIDERS
	    ];
	}
	exports.provideForms = provideForms;
	//# sourceMappingURL=form_providers.js.map

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var accordion_1 = __webpack_require__(681);
	var alert_1 = __webpack_require__(686);
	var buttons_1 = __webpack_require__(688);
	var carousel_1 = __webpack_require__(691);
	var collapse_1 = __webpack_require__(684);
	var datepicker_1 = __webpack_require__(695);
	var dropdown_1 = __webpack_require__(807);
	var modal_1 = __webpack_require__(812);
	var pagination_1 = __webpack_require__(818);
	var progressbar_1 = __webpack_require__(821);
	var rating_1 = __webpack_require__(825);
	var tabs_1 = __webpack_require__(827);
	var timepicker_1 = __webpack_require__(832);
	var tooltip_1 = __webpack_require__(834);
	var typeahead_1 = __webpack_require__(838);
	var components_helper_service_1 = __webpack_require__(816);
	__export(__webpack_require__(681));
	__export(__webpack_require__(686));
	__export(__webpack_require__(688));
	__export(__webpack_require__(691));
	__export(__webpack_require__(684));
	__export(__webpack_require__(695));
	__export(__webpack_require__(812));
	__export(__webpack_require__(807));
	__export(__webpack_require__(818));
	__export(__webpack_require__(821));
	__export(__webpack_require__(825));
	__export(__webpack_require__(827));
	__export(__webpack_require__(832));
	__export(__webpack_require__(834));
	__export(__webpack_require__(838));
	__export(__webpack_require__(697));
	__export(__webpack_require__(830));
	__export(__webpack_require__(694));
	exports.BS_VIEW_PROVIDERS = [{ provide: components_helper_service_1.ComponentsHelper, useClass: components_helper_service_1.ComponentsHelper }];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    directives: [
	        alert_1.AlertComponent,
	        accordion_1.ACCORDION_DIRECTIVES,
	        buttons_1.BUTTON_DIRECTIVES,
	        carousel_1.CAROUSEL_DIRECTIVES,
	        collapse_1.CollapseDirective,
	        datepicker_1.DATEPICKER_DIRECTIVES,
	        dropdown_1.DROPDOWN_DIRECTIVES,
	        modal_1.MODAL_DIRECTIVES,
	        pagination_1.PAGINATION_DIRECTIVES,
	        progressbar_1.PROGRESSBAR_DIRECTIVES,
	        rating_1.RatingComponent,
	        tabs_1.TAB_DIRECTIVES,
	        timepicker_1.TimepickerComponent,
	        tooltip_1.TOOLTIP_DIRECTIVES,
	        typeahead_1.TYPEAHEAD_DIRECTIVES
	    ],
	    providers: [
	        components_helper_service_1.ComponentsHelper
	    ]
	};


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var accordion_component_1 = __webpack_require__(682);
	var accordion_group_component_1 = __webpack_require__(683);
	var accordion_component_2 = __webpack_require__(682);
	exports.AccordionComponent = accordion_component_2.AccordionComponent;
	var accordion_group_component_2 = __webpack_require__(683);
	exports.AccordionPanelComponent = accordion_group_component_2.AccordionPanelComponent;
	exports.ACCORDION_DIRECTIVES = [accordion_component_1.AccordionComponent, accordion_group_component_1.AccordionPanelComponent];


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	// todo: support template url
	var AccordionComponent = (function () {
	    function AccordionComponent() {
	        /* tslint:disable:no-unused-variable */
	        this.addClass = true;
	        /* tslint:enable:no-unused-variable */
	        this.groups = [];
	    }
	    AccordionComponent.prototype.closeOtherPanels = function (openGroup) {
	        if (!this.closeOthers) {
	            return;
	        }
	        this.groups.forEach(function (group) {
	            if (group !== openGroup) {
	                group.isOpen = false;
	            }
	        });
	    };
	    AccordionComponent.prototype.addGroup = function (group) {
	        this.groups.push(group);
	    };
	    AccordionComponent.prototype.removeGroup = function (group) {
	        var index = this.groups.indexOf(group);
	        if (index !== -1) {
	            this.groups.splice(index, 1);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AccordionComponent.prototype, "closeOthers", void 0);
	    __decorate([
	        core_1.HostBinding('class.panel-group'), 
	        __metadata('design:type', Boolean)
	    ], AccordionComponent.prototype, "addClass", void 0);
	    AccordionComponent = __decorate([
	        core_1.Component({
	            selector: 'accordion',
	            template: "<ng-content></ng-content>"
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AccordionComponent);
	    return AccordionComponent;
	}());
	exports.AccordionComponent = AccordionComponent;


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var collapse_1 = __webpack_require__(684);
	var accordion_component_1 = __webpack_require__(682);
	/* tslint:disable:component-selector-name */
	var AccordionPanelComponent = (function () {
	    function AccordionPanelComponent(accordion) {
	        this.accordion = accordion;
	    }
	    Object.defineProperty(AccordionPanelComponent.prototype, "isOpen", {
	        // Questionable, maybe .panel-open should be on child div.panel element?
	        get: function () {
	            return this._isOpen;
	        },
	        set: function (value) {
	            this._isOpen = value;
	            if (value) {
	                this.accordion.closeOtherPanels(this);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AccordionPanelComponent.prototype.ngOnInit = function () {
	        this.panelClass = this.panelClass || 'panel-default';
	        this.accordion.addGroup(this);
	    };
	    AccordionPanelComponent.prototype.ngOnDestroy = function () {
	        this.accordion.removeGroup(this);
	    };
	    AccordionPanelComponent.prototype.toggleOpen = function (event) {
	        event.preventDefault();
	        if (!this.isDisabled) {
	            this.isOpen = !this.isOpen;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AccordionPanelComponent.prototype, "heading", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AccordionPanelComponent.prototype, "panelClass", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AccordionPanelComponent.prototype, "isDisabled", void 0);
	    __decorate([
	        core_1.HostBinding('class.panel-open'),
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AccordionPanelComponent.prototype, "isOpen", null);
	    AccordionPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'accordion-group, accordion-panel',
	            directives: [collapse_1.CollapseDirective, common_1.NgClass],
	            template: "\n    <div class=\"panel\" [ngClass]=\"panelClass\">\n      <div class=\"panel-heading\" (click)=\"toggleOpen($event)\">\n        <h4 class=\"panel-title\">\n          <a href tabindex=\"0\" class=\"accordion-toggle\">\n            <span *ngIf=\"heading\" [ngClass]=\"{'text-muted': isDisabled}\">{{heading}}</span>\n            <ng-content select=\"[accordion-heading]\"></ng-content>\n          </a>\n        </h4>\n      </div>\n      <div class=\"panel-collapse collapse\" [collapse]=\"!isOpen\">\n        <div class=\"panel-body\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n  "
	        }),
	        __param(0, core_1.Inject(accordion_component_1.AccordionComponent)), 
	        __metadata('design:paramtypes', [accordion_component_1.AccordionComponent])
	    ], AccordionPanelComponent);
	    return AccordionPanelComponent;
	}());
	exports.AccordionPanelComponent = AccordionPanelComponent;


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var collapse_directive_1 = __webpack_require__(685);
	exports.CollapseDirective = collapse_directive_1.CollapseDirective;


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// FIX: in order to update to rc.1 had to disable animation, sorry
	var core_1 = __webpack_require__(1);
	// import {AnimationBuilder} from '@angular/platform-browser/src/animate/animation_builder';
	// import {animation, style, animate, state, transition} from '@angular/core';
	/*@Directive({
	  selector: '[collapse]',
	  // templateUrl: 'app/panel.html',
	  // styleUrls: ['app/panel.css'],
	  animations: [
	    animation('active', [
	      state('void', style({ height: 0 })),
	      state('closed', style({ height: 0 })),
	      state('open', style({ height: '*' })),
	      transition('void => closed', [ animate(0) ]),
	      transition('closed => open', [ animate('350ms ease-out') ]),
	      transition('open => closed', [ animate('350ms ease-out') ])
	    ])
	  ]
	})*/
	// fix: replace with // '@angular/animate';
	// when https://github.com/angular/angular/issues/5984 will be fixed
	// TODO: remove ElementRef
	// TODO: add on change
	// TODO: #576 add callbacks: expanding, expanded, collapsing, collapsed
	var CollapseDirective = (function () {
	    function CollapseDirective(/*_ab:AnimationBuilder, */ _el, _renderer) {
	        // shown
	        this.isExpanded = true;
	        // hidden
	        this.isCollapsed = false;
	        // stale state
	        this.isCollapse = true;
	        // animation state
	        this.isCollapsing = false;
	        // this._ab = _ab;
	        this._el = _el;
	        this._renderer = _renderer;
	    }
	    Object.defineProperty(CollapseDirective.prototype, "collapse", {
	        get: function () {
	            return this.isExpanded;
	        },
	        // @Input() private transitionDuration:number = 500; // Duration in ms
	        set: function (value) {
	            this.isExpanded = value;
	            this.toggle();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CollapseDirective.prototype.ngOnInit = function () {
	        // this.animation = this._ab.css();
	        // this.animation.setDuration(this.transitionDuration);
	    };
	    CollapseDirective.prototype.toggle = function () {
	        // this.open = !this.open;
	        if (this.isExpanded) {
	            this.hide();
	        }
	        else {
	            this.show();
	        }
	    };
	    CollapseDirective.prototype.hide = function () {
	        this.isCollapse = false;
	        this.isCollapsing = true;
	        this.isExpanded = false;
	        this.isCollapsed = true;
	        this.isCollapse = true;
	        this.isCollapsing = false;
	        this.display = 'none';
	        /*  setTimeout(() => {
	              // this.height = '0';
	              // this.isCollapse = true;
	              // this.isCollapsing = false;
	              this.animation
	                .setFromStyles({
	                  height: this._el.nativeElement.scrollHeight + 'px'
	                })
	                .setToStyles({
	                  height: '0',
	                  overflow: 'hidden'
	                });
	    
	              this.animation.start(this._el.nativeElement)
	                .onComplete(() => {
	                  if (this._el.nativeElement.offsetHeight === 0) {
	                    this.display = 'none';
	                  }
	    
	                  this.isCollapse = true;
	                  this.isCollapsing = false;
	                });
	            }, 4);*/
	    };
	    CollapseDirective.prototype.show = function () {
	        this.isCollapse = false;
	        this.isCollapsing = true;
	        this.isExpanded = true;
	        this.isCollapsed = false;
	        this.display = 'block';
	        // this.height = 'auto';
	        this.isCollapse = true;
	        this.isCollapsing = false;
	        this._renderer.setElementStyle(this._el.nativeElement, 'overflow', 'visible');
	        this._renderer.setElementStyle(this._el.nativeElement, 'height', 'auto');
	        /*setTimeout(() => {
	            // this.height = 'auto';
	            // this.isCollapse = true;
	            // this.isCollapsing = false;
	            this.animation
	              .setFromStyles({
	                height: this._el.nativeElement.offsetHeight,
	                overflow: 'hidden'
	              })
	              .setToStyles({
	                height: this._el.nativeElement.scrollHeight + 'px'
	              });
	    
	            this.animation.start(this._el.nativeElement)
	              .onComplete(() => {
	                this.isCollapse = true;
	                this.isCollapsing = false;
	                this._renderer.setElementStyle(this._el.nativeElement, 'overflow', 'visible');
	                this._renderer.setElementStyle(this._el.nativeElement, 'height', 'auto');
	              });
	          }, 4);*/
	    };
	    __decorate([
	        core_1.HostBinding('style.display'), 
	        __metadata('design:type', String)
	    ], CollapseDirective.prototype, "display", void 0);
	    __decorate([
	        core_1.HostBinding('class.in'),
	        core_1.HostBinding('attr.aria-expanded'), 
	        __metadata('design:type', Boolean)
	    ], CollapseDirective.prototype, "isExpanded", void 0);
	    __decorate([
	        core_1.HostBinding('attr.aria-hidden'), 
	        __metadata('design:type', Boolean)
	    ], CollapseDirective.prototype, "isCollapsed", void 0);
	    __decorate([
	        core_1.HostBinding('class.collapse'), 
	        __metadata('design:type', Boolean)
	    ], CollapseDirective.prototype, "isCollapse", void 0);
	    __decorate([
	        core_1.HostBinding('class.collapsing'), 
	        __metadata('design:type', Boolean)
	    ], CollapseDirective.prototype, "isCollapsing", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean), 
	        __metadata('design:paramtypes', [Boolean])
	    ], CollapseDirective.prototype, "collapse", null);
	    CollapseDirective = __decorate([
	        core_1.Directive({ selector: '[collapse]' }), 
	        __metadata('design:paramtypes', [core_1.ElementRef, core_1.Renderer])
	    ], CollapseDirective);
	    return CollapseDirective;
	}());
	exports.CollapseDirective = CollapseDirective;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var alert_component_1 = __webpack_require__(687);
	exports.AlertComponent = alert_component_1.AlertComponent;


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var ALERT_TEMPLATE = "\n  <div class=\"alert\" role=\"alert\" [ngClass]=\"classes\" *ngIf=\"!closed\">\n    <button *ngIf=\"dismissible\" type=\"button\" class=\"close\" (click)=\"onClose()\" (touch)=\"onClose()\">\n      <span aria-hidden=\"true\">&times;</span>\n      <span class=\"sr-only\">Close</span>\n    </button>\n    <ng-content></ng-content>\n  </div>\n  ";
	// TODO: templateUrl
	var AlertComponent = (function () {
	    function AlertComponent() {
	        this.type = 'warning';
	        this.close = new core_1.EventEmitter(false);
	        this.classes = [];
	    }
	    AlertComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.classes[0] = "alert-" + this.type;
	        if (this.dismissible) {
	            this.classes[1] = 'alert-dismissible';
	        }
	        else {
	            this.classes.length = 1;
	        }
	        if (this.dismissOnTimeout) {
	            setTimeout(function () { return _this.onClose(); }, this.dismissOnTimeout);
	        }
	    };
	    // todo: mouse event + touch + pointer
	    AlertComponent.prototype.onClose = function () {
	        this.closed = true;
	        this.close.emit(this);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AlertComponent.prototype, "type", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AlertComponent.prototype, "dismissible", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], AlertComponent.prototype, "dismissOnTimeout", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], AlertComponent.prototype, "close", void 0);
	    AlertComponent = __decorate([
	        core_1.Component({
	            selector: 'alert',
	            directives: [common_1.NgIf, common_1.NgClass],
	            template: ALERT_TEMPLATE
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AlertComponent);
	    return AlertComponent;
	}());
	exports.AlertComponent = AlertComponent;


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var button_checkbox_directive_1 = __webpack_require__(689);
	var button_radio_directive_1 = __webpack_require__(690);
	var button_checkbox_directive_2 = __webpack_require__(689);
	exports.ButtonCheckboxDirective = button_checkbox_directive_2.ButtonCheckboxDirective;
	var button_radio_directive_2 = __webpack_require__(690);
	exports.ButtonRadioDirective = button_radio_directive_2.ButtonRadioDirective;
	exports.BUTTON_DIRECTIVES = [button_checkbox_directive_1.ButtonCheckboxDirective, button_radio_directive_1.ButtonRadioDirective];


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	// TODO: config: activeClass - Class to apply to the checked buttons.
	var ButtonCheckboxDirective = (function () {
	    function ButtonCheckboxDirective(cd) {
	        this.state = false;
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this.cd = cd;
	        // hack !
	        cd.valueAccessor = this;
	    }
	    // view -> model
	    ButtonCheckboxDirective.prototype.onClick = function () {
	        this.toggle(!this.state);
	        this.cd.viewToModelUpdate(this.value);
	    };
	    ButtonCheckboxDirective.prototype.ngOnInit = function () {
	        this.toggle(this.trueValue === this.value);
	    };
	    Object.defineProperty(ButtonCheckboxDirective.prototype, "trueValue", {
	        get: function () {
	            return typeof this.btnCheckboxTrue !== 'undefined'
	                ? this.btnCheckboxTrue
	                : true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ButtonCheckboxDirective.prototype, "falseValue", {
	        get: function () {
	            return typeof this.btnCheckboxFalse !== 'undefined'
	                ? this.btnCheckboxFalse
	                : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ButtonCheckboxDirective.prototype.toggle = function (state) {
	        this.state = state;
	        this.value = this.state ? this.trueValue : this.falseValue;
	    };
	    // ControlValueAccessor
	    // model -> view
	    ButtonCheckboxDirective.prototype.writeValue = function (value) {
	        this.state = this.trueValue === value;
	        this.value = value;
	    };
	    ButtonCheckboxDirective.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    ButtonCheckboxDirective.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ButtonCheckboxDirective.prototype, "btnCheckboxTrue", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ButtonCheckboxDirective.prototype, "btnCheckboxFalse", void 0);
	    __decorate([
	        core_1.HostBinding('class.active'), 
	        __metadata('design:type', Boolean)
	    ], ButtonCheckboxDirective.prototype, "state", void 0);
	    __decorate([
	        core_1.HostListener('click'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], ButtonCheckboxDirective.prototype, "onClick", null);
	    ButtonCheckboxDirective = __decorate([
	        core_1.Directive({ selector: '[btnCheckbox][ngModel]' }),
	        __param(0, core_1.Self()), 
	        __metadata('design:paramtypes', [forms_1.NgModel])
	    ], ButtonCheckboxDirective);
	    return ButtonCheckboxDirective;
	}());
	exports.ButtonCheckboxDirective = ButtonCheckboxDirective;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	// TODO: if uncheckable, null should be set to ngModel
	// if disabled, button should not be checkable
	var ButtonRadioDirective = (function () {
	    function ButtonRadioDirective(cd, el) {
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        // hack!
	        this.cd = cd;
	        this.el = el;
	        cd.valueAccessor = this;
	    }
	    Object.defineProperty(ButtonRadioDirective.prototype, "isActive", {
	        get: function () {
	            return this.btnRadio === this.value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ButtonRadioDirective.prototype.onClick = function () {
	        if (this.uncheckable && this.btnRadio === this.value) {
	            return this.cd.viewToModelUpdate(void 0);
	        }
	        this.cd.viewToModelUpdate(this.btnRadio);
	    };
	    ButtonRadioDirective.prototype.ngOnInit = function () {
	        this.uncheckable = typeof this.uncheckable !== 'undefined';
	    };
	    Object.defineProperty(ButtonRadioDirective.prototype, "value", {
	        // hack view model!
	        get: function () {
	            return this.cd.viewModel;
	        },
	        set: function (value) {
	            this.cd.viewModel = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // ControlValueAccessor
	    // model -> view
	    ButtonRadioDirective.prototype.writeValue = function (value) {
	        this.value = value;
	    };
	    ButtonRadioDirective.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    ButtonRadioDirective.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], ButtonRadioDirective.prototype, "btnRadio", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ButtonRadioDirective.prototype, "uncheckable", void 0);
	    __decorate([
	        core_1.HostBinding('class.active'), 
	        __metadata('design:type', Boolean)
	    ], ButtonRadioDirective.prototype, "isActive", null);
	    __decorate([
	        core_1.HostListener('click'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], ButtonRadioDirective.prototype, "onClick", null);
	    ButtonRadioDirective = __decorate([
	        core_1.Directive({ selector: '[btnRadio][ngModel]' }),
	        __param(0, core_1.Self()), 
	        __metadata('design:paramtypes', [forms_1.NgModel, core_1.ElementRef])
	    ], ButtonRadioDirective);
	    return ButtonRadioDirective;
	}());
	exports.ButtonRadioDirective = ButtonRadioDirective;


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var slide_component_1 = __webpack_require__(692);
	var carousel_component_1 = __webpack_require__(693);
	var slide_component_2 = __webpack_require__(692);
	exports.SlideComponent = slide_component_2.SlideComponent;
	var carousel_component_2 = __webpack_require__(693);
	exports.CarouselComponent = carousel_component_2.CarouselComponent;
	exports.CAROUSEL_DIRECTIVES = [carousel_component_1.CarouselComponent, slide_component_1.SlideComponent];


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var carousel_component_1 = __webpack_require__(693);
	var SlideComponent = (function () {
	    function SlideComponent(carousel) {
	        this.addClass = true;
	        this.carousel = carousel;
	    }
	    SlideComponent.prototype.ngOnInit = function () {
	        this.carousel.addSlide(this);
	    };
	    SlideComponent.prototype.ngOnDestroy = function () {
	        this.carousel.removeSlide(this);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], SlideComponent.prototype, "index", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], SlideComponent.prototype, "direction", void 0);
	    __decorate([
	        core_1.HostBinding('class.active'),
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], SlideComponent.prototype, "active", void 0);
	    __decorate([
	        core_1.HostBinding('class.item'),
	        core_1.HostBinding('class.carousel-item'), 
	        __metadata('design:type', Boolean)
	    ], SlideComponent.prototype, "addClass", void 0);
	    SlideComponent = __decorate([
	        core_1.Component({
	            selector: 'slide',
	            template: "\n    <div [class.active]=\"active\" class=\"item text-center\">\n      <ng-content></ng-content>\n    </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [carousel_component_1.CarouselComponent])
	    ], SlideComponent);
	    return SlideComponent;
	}());
	exports.SlideComponent = SlideComponent;


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	// todo: add animate
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var ng2_bootstrap_config_1 = __webpack_require__(694);
	(function (Direction) {
	    Direction[Direction["UNKNOWN"] = 0] = "UNKNOWN";
	    Direction[Direction["NEXT"] = 1] = "NEXT";
	    Direction[Direction["PREV"] = 2] = "PREV";
	})(exports.Direction || (exports.Direction = {}));
	var Direction = exports.Direction;
	var NAVIGATION = (_a = {},
	    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4] = "\n    <a class=\"left carousel-control\" (click)=\"prev()\" *ngIf=\"slides.length\">\n      <span class=\"icon-prev\" aria-hidden=\"true\"></span>\n      <span class=\"sr-only\">Previous</span>\n    </a>\n    <a class=\"right carousel-control\" (click)=\"next()\" *ngIf=\"slides.length\">\n      <span class=\"icon-next\" aria-hidden=\"true\"></span>\n      <span class=\"sr-only\">Next</span>\n    </a>\n  ",
	    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS3] = "\n    <a class=\"left carousel-control\" (click)=\"prev()\" *ngIf=\"slides.length\">\n      <span class=\"glyphicon glyphicon-chevron-left\"></span>\n    </a>\n    <a class=\"right carousel-control\" (click)=\"next()\" *ngIf=\"slides.length\">\n      <span class=\"glyphicon glyphicon-chevron-right\"></span>\n    </a>\n  ",
	    _a
	);
	// todo:
	// (ng-swipe-right)="prev()" (ng-swipe-left)="next()"
	var CarouselComponent = (function () {
	    function CarouselComponent() {
	        this.slides = [];
	        this.destroyed = false;
	    }
	    Object.defineProperty(CarouselComponent.prototype, "interval", {
	        get: function () {
	            return this._interval;
	        },
	        set: function (value) {
	            this._interval = value;
	            this.restartTimer();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CarouselComponent.prototype.ngOnDestroy = function () {
	        this.destroyed = true;
	    };
	    CarouselComponent.prototype.select = function (nextSlide, direction) {
	        if (direction === void 0) { direction = Direction.UNKNOWN; }
	        var nextIndex = nextSlide.index;
	        if (direction === Direction.UNKNOWN) {
	            direction = nextIndex > this.getCurrentIndex()
	                ? Direction.NEXT
	                : Direction.PREV;
	        }
	        // Prevent this user-triggered transition from occurring if there is
	        // already one in progress
	        if (nextSlide && nextSlide !== this.currentSlide) {
	            this.goNext(nextSlide, direction);
	        }
	    };
	    CarouselComponent.prototype.play = function () {
	        if (!this.isPlaying) {
	            this.isPlaying = true;
	            this.restartTimer();
	        }
	    };
	    CarouselComponent.prototype.pause = function () {
	        if (!this.noPause) {
	            this.isPlaying = false;
	            this.resetTimer();
	        }
	    };
	    CarouselComponent.prototype.next = function () {
	        var newIndex = (this.getCurrentIndex() + 1) % this.slides.length;
	        if (newIndex === 0 && this.noWrap) {
	            this.pause();
	            return;
	        }
	        return this.select(this.getSlideByIndex(newIndex), Direction.NEXT);
	    };
	    CarouselComponent.prototype.prev = function () {
	        var newIndex = this.getCurrentIndex() - 1 < 0
	            ? this.slides.length - 1
	            : this.getCurrentIndex() - 1;
	        if (this.noWrap && newIndex === this.slides.length - 1) {
	            this.pause();
	            return;
	        }
	        return this.select(this.getSlideByIndex(newIndex), Direction.PREV);
	    };
	    CarouselComponent.prototype.addSlide = function (slide) {
	        slide.index = this.slides.length;
	        this.slides.push(slide);
	        if (this.slides.length === 1 || slide.active) {
	            this.select(this.slides[this.slides.length - 1]);
	            if (this.slides.length === 1) {
	                this.play();
	            }
	        }
	        else {
	            slide.active = false;
	        }
	    };
	    CarouselComponent.prototype.removeSlide = function (slide) {
	        this.slides.splice(slide.index, 1);
	        if (this.slides.length === 0) {
	            this.currentSlide = void 0;
	            return;
	        }
	        for (var i = 0; i < this.slides.length; i++) {
	            this.slides[i].index = i;
	        }
	    };
	    CarouselComponent.prototype.goNext = function (slide, direction) {
	        if (this.destroyed) {
	            return;
	        }
	        slide.direction = direction;
	        slide.active = true;
	        if (this.currentSlide) {
	            this.currentSlide.direction = direction;
	            this.currentSlide.active = false;
	        }
	        this.currentSlide = slide;
	        // every time you change slides, reset the timer
	        this.restartTimer();
	    };
	    CarouselComponent.prototype.getSlideByIndex = function (index) {
	        var len = this.slides.length;
	        for (var i = 0; i < len; ++i) {
	            if (this.slides[i].index === index) {
	                return this.slides[i];
	            }
	        }
	        return void 0;
	    };
	    CarouselComponent.prototype.getCurrentIndex = function () {
	        return !this.currentSlide ? 0 : this.currentSlide.index;
	    };
	    CarouselComponent.prototype.restartTimer = function () {
	        var _this = this;
	        this.resetTimer();
	        var interval = +this.interval;
	        if (!isNaN(interval) && interval > 0) {
	            this.currentInterval = setInterval(function () {
	                var nInterval = +_this.interval;
	                if (_this.isPlaying && !isNaN(_this.interval) && nInterval > 0 && _this.slides.length) {
	                    _this.next();
	                }
	                else {
	                    _this.pause();
	                }
	            }, interval);
	        }
	    };
	    CarouselComponent.prototype.resetTimer = function () {
	        if (this.currentInterval) {
	            clearInterval(this.currentInterval);
	            this.currentInterval = void 0;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], CarouselComponent.prototype, "noWrap", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], CarouselComponent.prototype, "noPause", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], CarouselComponent.prototype, "noTransition", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], CarouselComponent.prototype, "interval", null);
	    CarouselComponent = __decorate([
	        core_1.Component({
	            selector: 'carousel',
	            directives: [common_1.NgFor],
	            template: "\n    <div (mouseenter)=\"pause()\" (mouseleave)=\"play()\" class=\"carousel slide\">\n      <ol class=\"carousel-indicators\" *ngIf=\"slides.length > 1\">\n         <li *ngFor=\"let slidez of slides\" [class.active]=\"slidez.active === true\" (click)=\"select(slidez)\"></li>\n      </ol>\n      <div class=\"carousel-inner\"><ng-content></ng-content></div>\n      " + NAVIGATION[ng2_bootstrap_config_1.Ng2BootstrapConfig.theme] + "\n    </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CarouselComponent);
	    return CarouselComponent;
	}());
	exports.CarouselComponent = CarouselComponent;
	var _a;


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var lang_1 = __webpack_require__(5);
	(function (Ng2BootstrapTheme) {
	    Ng2BootstrapTheme[Ng2BootstrapTheme["BS3"] = 1] = "BS3";
	    Ng2BootstrapTheme[Ng2BootstrapTheme["BS4"] = 2] = "BS4";
	})(exports.Ng2BootstrapTheme || (exports.Ng2BootstrapTheme = {}));
	var Ng2BootstrapTheme = exports.Ng2BootstrapTheme;
	var Ng2BootstrapConfig = (function () {
	    function Ng2BootstrapConfig() {
	    }
	    Object.defineProperty(Ng2BootstrapConfig, "theme", {
	        get: function () {
	            // hack as for now
	            if (lang_1.global && lang_1.global.__theme === 'bs4') {
	                return Ng2BootstrapTheme.BS4;
	            }
	            return (this._theme || Ng2BootstrapTheme.BS3);
	        },
	        set: function (v) {
	            this._theme = v;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Ng2BootstrapConfig;
	}());
	exports.Ng2BootstrapConfig = Ng2BootstrapConfig;


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 todo: general:
	 1. Popup
	 2. Keyboard support
	 3. custom-class attribute support
	 4. date-disabled attribute support
	 5. template-url attribute support
	 */
	var datepicker_popup_component_1 = __webpack_require__(696);
	var datepicker_component_1 = __webpack_require__(698);
	var datepicker_popup_component_2 = __webpack_require__(696);
	exports.DatePickerPopupDirective = datepicker_popup_component_2.DatePickerPopupDirective;
	var datepicker_component_2 = __webpack_require__(698);
	exports.DatePickerComponent = datepicker_component_2.DatePickerComponent;
	exports.DATEPICKER_DIRECTIVES = [datepicker_component_1.DatePickerComponent, datepicker_popup_component_1.DatePickerPopupDirective];


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var position_1 = __webpack_require__(697);
	var datepicker_component_1 = __webpack_require__(698);
	// import {DatePickerInner} from './datepicker-inner';
	// import {DayPicker} from './daypicker';
	// import {MonthPicker} from './monthpicker';
	// import {YearPicker} from './yearpicker';
	var PopupOptions = (function () {
	    function PopupOptions(options) {
	        Object.assign(this, options);
	    }
	    return PopupOptions;
	}());
	var datePickerPopupConfig = {
	    datepickerPopup: 'YYYY-MM-dd',
	    currentText: 'Today',
	    clearText: 'Clear',
	    closeText: 'Done',
	    closeOnDateSelection: true,
	    showButtonBar: true,
	    onOpenFocus: true
	};
	var PopupContainerComponent = (function () {
	    function PopupContainerComponent(element, options) {
	        // false positive
	        /* tslint:disable:no-unused-variable */
	        this.showButtonBar = true;
	        this.update1 = new core_1.EventEmitter(false);
	        this.element = element;
	        Object.assign(this, options);
	        this.classMap = { 'in': false };
	        this.classMap[options.placement] = true;
	    }
	    PopupContainerComponent.prototype.onUpdate = function ($event) {
	        console.log('update', $event);
	        if ($event) {
	            if ($event.toString() !== '[object Date]') {
	                $event = new Date($event);
	            }
	            this.popupComp.activeDate = $event;
	        }
	    };
	    PopupContainerComponent.prototype.position = function (hostEl) {
	        this.display = 'block';
	        this.top = '0px';
	        this.left = '0px';
	        var p = position_1.positionService
	            .positionElements(hostEl.nativeElement, this.element.nativeElement.children[0], this.placement, false);
	        this.top = p.top + 'px';
	    };
	    PopupContainerComponent.prototype.getText = function (key) {
	        return this[key + 'Text'] || datePickerPopupConfig[key + 'Text'];
	    };
	    PopupContainerComponent.prototype.isDisabled = function () {
	        return false;
	    };
	    PopupContainerComponent = __decorate([
	        core_1.Component({
	            selector: 'popup-container',
	            events: ['update1'],
	            template: "\n    <ul class=\"dropdown-menu\"\n        style=\"display: block\"\n        [ngStyle]=\"{top: top, left: left, display: display}\"\n        [ngClass]=\"classMap\">\n        <li>\n             <datepicker (cupdate)=\"onUpdate($event)\" *ngIf=\"popupComp\" [(ngModel)]=\"popupComp.cd.model\" [show-weeks]=\"true\"></datepicker>\n        </li>\n        <li *ngIf=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n            <span class=\"btn-group pull-left\">\n                 <button type=\"button\" class=\"btn btn-sm btn-info\" (click)=\"select('today')\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n                 <button type=\"button\" class=\"btn btn-sm btn-danger\" (click)=\"select(null)\">{{ getText('clear') }}</button>\n            </span>\n            <button type=\"button\" class=\"btn btn-sm btn-success pull-right\" (click)=\"close()\">{{ getText('close') }}</button>\n        </li>\n    </ul>",
	            directives: [common_1.NgClass, common_1.NgStyle, datepicker_component_1.DatePickerComponent, forms_1.FORM_DIRECTIVES, common_1.CORE_DIRECTIVES],
	            encapsulation: core_1.ViewEncapsulation.None
	        }), 
	        __metadata('design:paramtypes', [core_1.ElementRef, PopupOptions])
	    ], PopupContainerComponent);
	    return PopupContainerComponent;
	}());
	var DatePickerPopupDirective = (function () {
	    function DatePickerPopupDirective(cd, viewContainerRef, renderer, loader) {
	        this._isOpen = false;
	        this.placement = 'bottom';
	        this.cd = cd;
	        this.viewContainerRef = viewContainerRef;
	        this.renderer = renderer;
	        this.loader = loader;
	        this.activeDate = cd.model;
	    }
	    Object.defineProperty(DatePickerPopupDirective.prototype, "activeDate", {
	        get: function () {
	            return this._activeDate;
	        },
	        set: function (value) {
	            this._activeDate = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DatePickerPopupDirective.prototype, "isOpen", {
	        get: function () {
	            return this._isOpen;
	        },
	        set: function (value) {
	            var _this = this;
	            var fn = function () {
	                _this._isOpen = value;
	            };
	            if (value === true) {
	                this.show(fn);
	            }
	            if (value === false) {
	                this.hide(fn);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DatePickerPopupDirective.prototype.hide = function (cb) {
	        if (this.popup) {
	            this.popup.then(function (componentRef) {
	                componentRef.destroy();
	                cb();
	                return componentRef;
	            });
	        }
	        else {
	            cb();
	        }
	    };
	    DatePickerPopupDirective.prototype.show = function (cb) {
	        var _this = this;
	        var options = new PopupOptions({
	            placement: this.placement
	        });
	        var binding = core_1.ReflectiveInjector.resolve([
	            core_1.provide(PopupOptions, { useValue: options })
	        ]);
	        this.popup = this.loader
	            .loadNextToLocation(PopupContainerComponent, this.viewContainerRef, binding)
	            .then(function (componentRef) {
	            componentRef.instance.position(_this.viewContainerRef);
	            componentRef.instance.popupComp = _this;
	            /*componentRef.instance.update1.observer({
	             next: (newVal) => {
	             setProperty(this.renderer, this.elementRef, 'value', newVal);
	             }
	             });*/
	            cb();
	            return componentRef;
	        });
	    };
	    DatePickerPopupDirective = __decorate([
	        core_1.Directive({
	            selector: '[datepickerPopup][ngModel]',
	            // prop -> datepickerPopup - format
	            properties: ['datepickerPopup', 'isOpen'] /*,
	             host: {'(cupdate)': 'onUpdate1($event)'}*/
	        }),
	        __param(0, core_1.Self()), 
	        __metadata('design:paramtypes', [forms_1.NgModel, core_1.ViewContainerRef, core_1.Renderer, core_1.DynamicComponentLoader])
	    ], DatePickerPopupDirective);
	    return DatePickerPopupDirective;
	}());
	exports.DatePickerPopupDirective = DatePickerPopupDirective;


/***/ },
/* 697 */
/***/ function(module, exports) {

	"use strict";
	var PositionService = (function () {
	    function PositionService() {
	    }
	    /**
	     * Provides read-only equivalent of jQuery's position function:
	     * http://api.jquery.com/position/
	     */
	    PositionService.prototype.position = function (nativeEl) {
	        var elBCR = this.offset(nativeEl);
	        var offsetParentBCR = { top: 0, left: 0 };
	        var offsetParentEl = this.parentOffsetEl(nativeEl);
	        if (offsetParentEl !== this.document) {
	            offsetParentBCR = this.offset(offsetParentEl);
	            offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	            offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	        }
	        var boundingClientRect = nativeEl.getBoundingClientRect();
	        return {
	            width: boundingClientRect.width || nativeEl.offsetWidth,
	            height: boundingClientRect.height || nativeEl.offsetHeight,
	            top: elBCR.top - offsetParentBCR.top,
	            left: elBCR.left - offsetParentBCR.left
	        };
	    };
	    /**
	     * Provides read-only equivalent of jQuery's offset function:
	     * http://api.jquery.com/offset/
	     */
	    PositionService.prototype.offset = function (nativeEl) {
	        var boundingClientRect = nativeEl.getBoundingClientRect();
	        return {
	            width: boundingClientRect.width || nativeEl.offsetWidth,
	            height: boundingClientRect.height || nativeEl.offsetHeight,
	            top: boundingClientRect.top + (this.window.pageYOffset || this.document.documentElement.scrollTop),
	            left: boundingClientRect.left + (this.window.pageXOffset || this.document.documentElement.scrollLeft)
	        };
	    };
	    /**
	     * Provides coordinates for the targetEl in relation to hostEl
	     */
	    PositionService.prototype.positionElements = function (hostEl, targetEl, positionStr, appendToBody) {
	        var positionStrParts = positionStr.split('-');
	        var pos0 = positionStrParts[0];
	        var pos1 = positionStrParts[1] || 'center';
	        var hostElPos = appendToBody ?
	            this.offset(hostEl) :
	            this.position(hostEl);
	        var targetElWidth = targetEl.offsetWidth;
	        var targetElHeight = targetEl.offsetHeight;
	        var shiftWidth = {
	            center: function () {
	                return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	            },
	            left: function () {
	                return hostElPos.left;
	            },
	            right: function () {
	                return hostElPos.left + hostElPos.width;
	            }
	        };
	        var shiftHeight = {
	            center: function () {
	                return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	            },
	            top: function () {
	                return hostElPos.top;
	            },
	            bottom: function () {
	                return hostElPos.top + hostElPos.height;
	            }
	        };
	        var targetElPos;
	        switch (pos0) {
	            case 'right':
	                targetElPos = {
	                    top: shiftHeight[pos1](),
	                    left: shiftWidth[pos0]()
	                };
	                break;
	            case 'left':
	                targetElPos = {
	                    top: shiftHeight[pos1](),
	                    left: hostElPos.left - targetElWidth
	                };
	                break;
	            case 'bottom':
	                targetElPos = {
	                    top: shiftHeight[pos0](),
	                    left: shiftWidth[pos1]()
	                };
	                break;
	            default:
	                targetElPos = {
	                    top: hostElPos.top - targetElHeight,
	                    left: shiftWidth[pos1]()
	                };
	                break;
	        }
	        return targetElPos;
	    };
	    Object.defineProperty(PositionService.prototype, "window", {
	        get: function () {
	            return window;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PositionService.prototype, "document", {
	        get: function () {
	            return window.document;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PositionService.prototype.getStyle = function (nativeEl, cssProp) {
	        // IE
	        if (nativeEl.currentStyle) {
	            return nativeEl.currentStyle[cssProp];
	        }
	        if (this.window.getComputedStyle) {
	            return this.window.getComputedStyle(nativeEl)[cssProp];
	        }
	        // finally try and get inline style
	        return nativeEl.style[cssProp];
	    };
	    /**
	     * Checks if a given element is statically positioned
	     * @param nativeEl - raw DOM element
	     */
	    PositionService.prototype.isStaticPositioned = function (nativeEl) {
	        return (this.getStyle(nativeEl, 'position') || 'static') === 'static';
	    };
	    /**
	     * returns the closest, non-statically positioned parentOffset of a given
	     * element
	     * @param nativeEl
	     */
	    PositionService.prototype.parentOffsetEl = function (nativeEl) {
	        var offsetParent = nativeEl.offsetParent || this.document;
	        while (offsetParent && offsetParent !== this.document &&
	            this.isStaticPositioned(offsetParent)) {
	            offsetParent = offsetParent.offsetParent;
	        }
	        return offsetParent || this.document;
	    };
	    ;
	    return PositionService;
	}());
	exports.PositionService = PositionService;
	exports.positionService = new PositionService();


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var datepicker_inner_component_1 = __webpack_require__(699);
	var daypicker_component_1 = __webpack_require__(804);
	var monthpicker_component_1 = __webpack_require__(805);
	var yearpicker_component_1 = __webpack_require__(806);
	// import {DatePickerPopup} from './datepicker-popup';
	/* tslint:disable:component-selector-name component-selector-type */
	var DatePickerComponent = (function () {
	    function DatePickerComponent(cd) {
	        this.selectionDone = new core_1.EventEmitter(undefined);
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this._now = new Date();
	        this.cd = cd;
	        // hack
	        cd.valueAccessor = this;
	    }
	    Object.defineProperty(DatePickerComponent.prototype, "activeDate", {
	        get: function () {
	            return this._activeDate || this._now;
	        },
	        set: function (value) {
	            this._activeDate = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DatePickerComponent.prototype.onUpdate = function (event) {
	        this.writeValue(event);
	        this.cd.viewToModelUpdate(event);
	    };
	    DatePickerComponent.prototype.onSelectionDone = function (event) {
	        this.selectionDone.emit(event);
	    };
	    // todo: support null value
	    DatePickerComponent.prototype.writeValue = function (value) {
	        // todo: fix something sends here new date all the time
	        // if (value) {
	        //  if (typeof value !== 'Date') {
	        //    value = new Date(value);
	        //  }
	        //
	        //  this.activeDate = value;
	        // }
	        if (value === this._activeDate) {
	            return;
	        }
	        if (value && value instanceof Date) {
	            this.activeDate = value;
	            return;
	        }
	        this.activeDate = value ? new Date(value) : void 0;
	    };
	    DatePickerComponent.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    DatePickerComponent.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "datepickerMode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], DatePickerComponent.prototype, "initDate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], DatePickerComponent.prototype, "minDate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], DatePickerComponent.prototype, "maxDate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "minMode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "maxMode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DatePickerComponent.prototype, "showWeeks", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "formatDay", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "formatMonth", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "formatYear", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "formatDayHeader", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "formatDayTitle", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerComponent.prototype, "formatMonthTitle", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], DatePickerComponent.prototype, "startingDay", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], DatePickerComponent.prototype, "yearRange", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DatePickerComponent.prototype, "onlyCurrentMonth", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DatePickerComponent.prototype, "shortcutPropagation", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], DatePickerComponent.prototype, "customClass", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DatePickerComponent.prototype, "dateDisabled", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], DatePickerComponent.prototype, "selectionDone", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], DatePickerComponent.prototype, "activeDate", null);
	    DatePickerComponent = __decorate([
	        core_1.Component({
	            selector: 'datepicker[ngModel]',
	            template: "\n    <datepicker-inner [activeDate]=\"activeDate\"\n                      (update)=\"onUpdate($event)\"\n                      [datepickerMode]=\"datepickerMode\"\n                      [initDate]=\"initDate\"\n                      [minDate]=\"minDate\"\n                      [maxDate]=\"maxDate\"\n                      [minMode]=\"minMode\"\n                      [maxMode]=\"maxMode\"\n                      [showWeeks]=\"showWeeks\"\n                      [formatDay]=\"formatDay\"\n                      [formatMonth]=\"formatMonth\"\n                      [formatYear]=\"formatYear\"\n                      [formatDayHeader]=\"formatDayHeader\"\n                      [formatDayTitle]=\"formatDayTitle\"\n                      [formatMonthTitle]=\"formatMonthTitle\"\n                      [startingDay]=\"startingDay\"\n                      [yearRange]=\"yearRange\"\n                      [customClass]=\"customClass\"\n                      [dateDisabled]=\"dateDisabled\"\n                      [templateUrl]=\"templateUrl\"\n                      [onlyCurrentMonth]=\"onlyCurrentMonth\"\n                      [shortcutPropagation]=\"shortcutPropagation\"\n                      (selectionDone)=\"onSelectionDone($event)\">\n      <daypicker tabindex=\"0\"></daypicker>\n      <monthpicker tabindex=\"0\"></monthpicker>\n      <yearpicker tabindex=\"0\"></yearpicker>\n    </datepicker-inner>\n    ",
	            directives: [datepicker_inner_component_1.DatePickerInnerComponent, daypicker_component_1.DayPickerComponent, monthpicker_component_1.MonthPickerComponent, yearpicker_component_1.YearPickerComponent,
	                forms_1.FORM_DIRECTIVES, common_1.CORE_DIRECTIVES]
	        }),
	        __param(0, core_1.Self()), 
	        __metadata('design:paramtypes', [forms_1.NgModel])
	    ], DatePickerComponent);
	    return DatePickerComponent;
	}());
	exports.DatePickerComponent = DatePickerComponent;


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var date_formatter_1 = __webpack_require__(700);
	var FORMAT_DAY = 'DD';
	var FORMAT_MONTH = 'MMMM';
	var FORMAT_YEAR = 'YYYY';
	var FORMAT_DAY_HEADER = 'dd';
	var FORMAT_DAY_TITLE = 'MMMM YYYY';
	var FORMAT_MONTH_TITLE = 'YYYY';
	var DATEPICKER_MODE = 'day';
	var MIN_MODE = 'day';
	var MAX_MODE = 'year';
	var SHOW_WEEKS = true;
	var ONLY_CURRENT_MONTH = false;
	var STARTING_DAY = 0;
	var YEAR_RANGE = 20;
	// const MIN_DATE:Date = void 0;
	// const MAX_DATE:Date = void 0;
	var SHORTCUT_PROPAGATION = false;
	// const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	/*
	 const KEYS = {
	 13: 'enter',
	 32: 'space',
	 33: 'pageup',
	 34: 'pagedown',
	 35: 'end',
	 36: 'home',
	 37: 'left',
	 38: 'up',
	 39: 'right',
	 40: 'down'
	 };
	 */
	var DatePickerInnerComponent = (function () {
	    function DatePickerInnerComponent() {
	        this.selectionDone = new core_1.EventEmitter(undefined);
	        this.stepDay = {};
	        this.stepMonth = {};
	        this.stepYear = {};
	        this.modes = ['day', 'month', 'year'];
	        this.dateFormatter = new date_formatter_1.DateFormatter();
	        this.update = new core_1.EventEmitter(false);
	    }
	    Object.defineProperty(DatePickerInnerComponent.prototype, "activeDate", {
	        get: function () {
	            return this._activeDate;
	        },
	        set: function (value) {
	            this._activeDate = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // todo: add formatter value to Date object
	    DatePickerInnerComponent.prototype.ngOnInit = function () {
	        this.formatDay = this.formatDay || FORMAT_DAY;
	        this.formatMonth = this.formatMonth || FORMAT_MONTH;
	        this.formatYear = this.formatYear || FORMAT_YEAR;
	        this.formatDayHeader = this.formatDayHeader || FORMAT_DAY_HEADER;
	        this.formatDayTitle = this.formatDayTitle || FORMAT_DAY_TITLE;
	        this.formatMonthTitle = this.formatMonthTitle || FORMAT_MONTH_TITLE;
	        this.showWeeks = (this.showWeeks === undefined
	            ? SHOW_WEEKS
	            : this.showWeeks);
	        this.onlyCurrentMonth = (this.onlyCurrentMonth === undefined
	            ? ONLY_CURRENT_MONTH
	            : this.onlyCurrentMonth);
	        this.startingDay = this.startingDay || STARTING_DAY;
	        this.yearRange = this.yearRange || YEAR_RANGE;
	        this.shortcutPropagation = this.shortcutPropagation || SHORTCUT_PROPAGATION;
	        this.datepickerMode = this.datepickerMode || DATEPICKER_MODE;
	        this.minMode = this.minMode || MIN_MODE;
	        this.maxMode = this.maxMode || MAX_MODE;
	        // todo: use date for unique value
	        this.uniqueId = 'datepicker-' + '-' + Math.floor(Math.random() * 10000);
	        if (this.initDate) {
	            this.activeDate = this.initDate;
	            this.selectedDate = new Date(this.activeDate.valueOf());
	            this.update.emit(this.activeDate);
	        }
	        else if (this.activeDate === undefined) {
	            this.activeDate = new Date();
	        }
	    };
	    // this.refreshView should be called here to reflect the changes on the fly
	    DatePickerInnerComponent.prototype.ngOnChanges = function () {
	        this.refreshView();
	    };
	    DatePickerInnerComponent.prototype.setCompareHandler = function (handler, type) {
	        if (type === 'day') {
	            this.compareHandlerDay = handler;
	        }
	        if (type === 'month') {
	            this.compareHandlerMonth = handler;
	        }
	        if (type === 'year') {
	            this.compareHandlerYear = handler;
	        }
	    };
	    DatePickerInnerComponent.prototype.compare = function (date1, date2) {
	        if (date1 === undefined || date2 === undefined) {
	            return undefined;
	        }
	        if (this.datepickerMode === 'day' && this.compareHandlerDay) {
	            return this.compareHandlerDay(date1, date2);
	        }
	        if (this.datepickerMode === 'month' && this.compareHandlerMonth) {
	            return this.compareHandlerMonth(date1, date2);
	        }
	        if (this.datepickerMode === 'year' && this.compareHandlerYear) {
	            return this.compareHandlerYear(date1, date2);
	        }
	        return void 0;
	    };
	    DatePickerInnerComponent.prototype.setRefreshViewHandler = function (handler, type) {
	        if (type === 'day') {
	            this.refreshViewHandlerDay = handler;
	        }
	        if (type === 'month') {
	            this.refreshViewHandlerMonth = handler;
	        }
	        if (type === 'year') {
	            this.refreshViewHandlerYear = handler;
	        }
	    };
	    DatePickerInnerComponent.prototype.refreshView = function () {
	        if (this.datepickerMode === 'day' && this.refreshViewHandlerDay) {
	            this.refreshViewHandlerDay();
	        }
	        if (this.datepickerMode === 'month' && this.refreshViewHandlerMonth) {
	            this.refreshViewHandlerMonth();
	        }
	        if (this.datepickerMode === 'year' && this.refreshViewHandlerYear) {
	            this.refreshViewHandlerYear();
	        }
	    };
	    DatePickerInnerComponent.prototype.dateFilter = function (date, format) {
	        return this.dateFormatter.format(date, format);
	    };
	    DatePickerInnerComponent.prototype.isActive = function (dateObject) {
	        if (this.compare(dateObject.date, this.activeDate) === 0) {
	            this.activeDateId = dateObject.uid;
	            return true;
	        }
	        return false;
	    };
	    DatePickerInnerComponent.prototype.createDateObject = function (date, format) {
	        var dateObject = {};
	        dateObject.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	        dateObject.label = this.dateFilter(date, format);
	        dateObject.selected = this.compare(date, this.selectedDate) === 0;
	        dateObject.disabled = this.isDisabled(date);
	        dateObject.current = this.compare(date, new Date()) === 0;
	        dateObject.customClass = this.getCustomClassForDate(dateObject.date);
	        return dateObject;
	    };
	    DatePickerInnerComponent.prototype.split = function (arr, size) {
	        var arrays = [];
	        while (arr.length > 0) {
	            arrays.push(arr.splice(0, size));
	        }
	        return arrays;
	    };
	    // Fix a hard-reproducible bug with timezones
	    // The bug depends on OS, browser, current timezone and current date
	    // i.e.
	    // var date = new Date(2014, 0, 1);
	    // console.log(date.getFullYear(), date.getMonth(), date.getDate(),
	    // date.getHours()); can result in "2013 11 31 23" because of the bug.
	    DatePickerInnerComponent.prototype.fixTimeZone = function (date) {
	        var hours = date.getHours();
	        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours === 23 ? hours + 2 : 0);
	    };
	    DatePickerInnerComponent.prototype.select = function (date) {
	        if (this.datepickerMode === this.minMode) {
	            if (!this.activeDate) {
	                this.activeDate = new Date(0, 0, 0, 0, 0, 0, 0);
	            }
	            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	            this.selectionDone.emit(this.activeDate);
	        }
	        else {
	            this.activeDate = date;
	            this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) - 1];
	        }
	        this.selectedDate = new Date(this.activeDate.valueOf());
	        this.update.emit(this.activeDate);
	        this.refreshView();
	    };
	    DatePickerInnerComponent.prototype.move = function (direction) {
	        var expectedStep;
	        if (this.datepickerMode === 'day') {
	            expectedStep = this.stepDay;
	        }
	        if (this.datepickerMode === 'month') {
	            expectedStep = this.stepMonth;
	        }
	        if (this.datepickerMode === 'year') {
	            expectedStep = this.stepYear;
	        }
	        if (expectedStep) {
	            var year = this.activeDate.getFullYear() + direction * (expectedStep.years || 0);
	            var month = this.activeDate.getMonth() + direction * (expectedStep.months || 0);
	            this.activeDate = new Date(year, month, 1);
	            this.refreshView();
	        }
	    };
	    DatePickerInnerComponent.prototype.toggleMode = function (direction) {
	        direction = direction || 1;
	        if ((this.datepickerMode === this.maxMode && direction === 1) ||
	            (this.datepickerMode === this.minMode && direction === -1)) {
	            return;
	        }
	        this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) + direction];
	        this.refreshView();
	    };
	    DatePickerInnerComponent.prototype.getCustomClassForDate = function (date) {
	        var _this = this;
	        if (!this.customClass) {
	            return '';
	        }
	        // todo: build a hash of custom classes, it will work faster
	        var customClassObject = this.customClass
	            .find(function (customClass) {
	            return customClass.date.valueOf() === date.valueOf() &&
	                customClass.mode === _this.datepickerMode;
	        }, this);
	        return customClassObject === undefined ? '' : customClassObject.clazz;
	    };
	    DatePickerInnerComponent.prototype.isDisabled = function (date) {
	        // todo: implement dateDisabled attribute
	        return ((this.minDate && this.compare(date, this.minDate) < 0) ||
	            (this.maxDate && this.compare(date, this.maxDate) > 0));
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "datepickerMode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], DatePickerInnerComponent.prototype, "startingDay", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], DatePickerInnerComponent.prototype, "yearRange", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], DatePickerInnerComponent.prototype, "minDate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], DatePickerInnerComponent.prototype, "maxDate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "minMode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "maxMode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DatePickerInnerComponent.prototype, "showWeeks", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "formatDay", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "formatMonth", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "formatYear", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "formatDayHeader", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "formatDayTitle", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DatePickerInnerComponent.prototype, "formatMonthTitle", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DatePickerInnerComponent.prototype, "onlyCurrentMonth", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DatePickerInnerComponent.prototype, "shortcutPropagation", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], DatePickerInnerComponent.prototype, "customClass", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DatePickerInnerComponent.prototype, "dateDisabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], DatePickerInnerComponent.prototype, "initDate", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], DatePickerInnerComponent.prototype, "selectionDone", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], DatePickerInnerComponent.prototype, "activeDate", null);
	    DatePickerInnerComponent = __decorate([
	        core_1.Component({
	            selector: 'datepicker-inner',
	            events: ['update'],
	            template: "\n    <div *ngIf=\"datepickerMode\" class=\"well well-sm bg-faded p-a card\" role=\"application\" ><!--&lt;!&ndash;ng-keydown=\"keydown($event)\"&ndash;&gt;-->\n      <ng-content></ng-content>\n    </div>\n  ",
	            directives: [forms_1.FORM_DIRECTIVES, common_1.CORE_DIRECTIVES, common_1.NgClass, forms_1.NgModel]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DatePickerInnerComponent);
	    return DatePickerInnerComponent;
	}());
	exports.DatePickerInnerComponent = DatePickerInnerComponent;


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(701);
	var DateFormatter = (function () {
	    function DateFormatter() {
	    }
	    DateFormatter.prototype.format = function (date, format) {
	        return moment(date.getTime()).format(format);
	    };
	    return DateFormatter;
	}());
	exports.DateFormatter = DateFormatter;


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.14.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        return Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        var k;
	        for (k in obj) {
	            // even if its not own property I'd still call it non-empty
	            return false;
	        }
	        return true;
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        ordinalParse: defaultOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(702)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, parentConfig = baseConfig;
	            // MERGE
	            if (locales[name] != null) {
	                parentConfig = locales[name]._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function locale_locales__listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(matchOffset, this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIOROITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = stringGet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = stringSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.14.1';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)(module)))

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 703,
		"./af.js": 703,
		"./ar": 704,
		"./ar-ma": 705,
		"./ar-ma.js": 705,
		"./ar-sa": 706,
		"./ar-sa.js": 706,
		"./ar-tn": 707,
		"./ar-tn.js": 707,
		"./ar.js": 704,
		"./az": 708,
		"./az.js": 708,
		"./be": 709,
		"./be.js": 709,
		"./bg": 710,
		"./bg.js": 710,
		"./bn": 711,
		"./bn.js": 711,
		"./bo": 712,
		"./bo.js": 712,
		"./br": 713,
		"./br.js": 713,
		"./bs": 714,
		"./bs.js": 714,
		"./ca": 715,
		"./ca.js": 715,
		"./cs": 716,
		"./cs.js": 716,
		"./cv": 717,
		"./cv.js": 717,
		"./cy": 718,
		"./cy.js": 718,
		"./da": 719,
		"./da.js": 719,
		"./de": 720,
		"./de-at": 721,
		"./de-at.js": 721,
		"./de.js": 720,
		"./dv": 722,
		"./dv.js": 722,
		"./el": 723,
		"./el.js": 723,
		"./en-au": 724,
		"./en-au.js": 724,
		"./en-ca": 725,
		"./en-ca.js": 725,
		"./en-gb": 726,
		"./en-gb.js": 726,
		"./en-ie": 727,
		"./en-ie.js": 727,
		"./en-nz": 728,
		"./en-nz.js": 728,
		"./eo": 729,
		"./eo.js": 729,
		"./es": 730,
		"./es-do": 731,
		"./es-do.js": 731,
		"./es.js": 730,
		"./et": 732,
		"./et.js": 732,
		"./eu": 733,
		"./eu.js": 733,
		"./fa": 734,
		"./fa.js": 734,
		"./fi": 735,
		"./fi.js": 735,
		"./fo": 736,
		"./fo.js": 736,
		"./fr": 737,
		"./fr-ca": 738,
		"./fr-ca.js": 738,
		"./fr-ch": 739,
		"./fr-ch.js": 739,
		"./fr.js": 737,
		"./fy": 740,
		"./fy.js": 740,
		"./gd": 741,
		"./gd.js": 741,
		"./gl": 742,
		"./gl.js": 742,
		"./he": 743,
		"./he.js": 743,
		"./hi": 744,
		"./hi.js": 744,
		"./hr": 745,
		"./hr.js": 745,
		"./hu": 746,
		"./hu.js": 746,
		"./hy-am": 747,
		"./hy-am.js": 747,
		"./id": 748,
		"./id.js": 748,
		"./is": 749,
		"./is.js": 749,
		"./it": 750,
		"./it.js": 750,
		"./ja": 751,
		"./ja.js": 751,
		"./jv": 752,
		"./jv.js": 752,
		"./ka": 753,
		"./ka.js": 753,
		"./kk": 754,
		"./kk.js": 754,
		"./km": 755,
		"./km.js": 755,
		"./ko": 756,
		"./ko.js": 756,
		"./ky": 757,
		"./ky.js": 757,
		"./lb": 758,
		"./lb.js": 758,
		"./lo": 759,
		"./lo.js": 759,
		"./lt": 760,
		"./lt.js": 760,
		"./lv": 761,
		"./lv.js": 761,
		"./me": 762,
		"./me.js": 762,
		"./mk": 763,
		"./mk.js": 763,
		"./ml": 764,
		"./ml.js": 764,
		"./mr": 765,
		"./mr.js": 765,
		"./ms": 766,
		"./ms-my": 767,
		"./ms-my.js": 767,
		"./ms.js": 766,
		"./my": 768,
		"./my.js": 768,
		"./nb": 769,
		"./nb.js": 769,
		"./ne": 770,
		"./ne.js": 770,
		"./nl": 771,
		"./nl.js": 771,
		"./nn": 772,
		"./nn.js": 772,
		"./pa-in": 773,
		"./pa-in.js": 773,
		"./pl": 774,
		"./pl.js": 774,
		"./pt": 775,
		"./pt-br": 776,
		"./pt-br.js": 776,
		"./pt.js": 775,
		"./ro": 777,
		"./ro.js": 777,
		"./ru": 778,
		"./ru.js": 778,
		"./se": 779,
		"./se.js": 779,
		"./si": 780,
		"./si.js": 780,
		"./sk": 781,
		"./sk.js": 781,
		"./sl": 782,
		"./sl.js": 782,
		"./sq": 783,
		"./sq.js": 783,
		"./sr": 784,
		"./sr-cyrl": 785,
		"./sr-cyrl.js": 785,
		"./sr.js": 784,
		"./ss": 786,
		"./ss.js": 786,
		"./sv": 787,
		"./sv.js": 787,
		"./sw": 788,
		"./sw.js": 788,
		"./ta": 789,
		"./ta.js": 789,
		"./te": 790,
		"./te.js": 790,
		"./th": 791,
		"./th.js": 791,
		"./tl-ph": 792,
		"./tl-ph.js": 792,
		"./tlh": 793,
		"./tlh.js": 793,
		"./tr": 794,
		"./tr.js": 794,
		"./tzl": 795,
		"./tzl.js": 795,
		"./tzm": 796,
		"./tzm-latn": 797,
		"./tzm-latn.js": 797,
		"./tzm.js": 796,
		"./uk": 798,
		"./uk.js": 798,
		"./uz": 799,
		"./uz.js": 799,
		"./vi": 800,
		"./vi.js": 800,
		"./x-pseudo": 801,
		"./x-pseudo.js": 801,
		"./zh-cn": 802,
		"./zh-cn.js": 802,
		"./zh-tw": 803,
		"./zh-tw.js": 803
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 702;


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	}));

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_ie;
	
	}));

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_nz;
	
	}));

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es_do = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es_do;
	
	}));

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr_ch;
	
	}));

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	}));

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        ordinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	}));

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	}));

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	}));

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?|MMMM?(\[[^\[\]]*\]|\s+)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jjupiter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var pa_in = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return pa_in;
	
	}));

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	}));

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swazi [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	}));

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	}));

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	}));

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	}));

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	}));

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var x_pseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return x_pseudo;
	
	}));

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(701)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_config_1 = __webpack_require__(694);
	var datepicker_inner_component_1 = __webpack_require__(699);
	// write an interface for template options
	var TEMPLATE_OPTIONS = (_a = {},
	    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4] = {
	        DAY_TITLE: "\n        <th *ngFor=\"let labelz of labels\" class=\"text-xs-center\"><small aria-label=\"labelz.full\"><b>{{labelz.abbr}}</b></small></th>\n    ",
	        WEEK_ROW: "\n        <td *ngIf=\"datePicker.showWeeks\" class=\"text-xs-center h6\"><em>{{ weekNumbers[index] }}</em></td>\n        <td *ngFor=\"let dtz of rowz\" class=\"text-xs-center\" role=\"gridcell\" [id]=\"dtz.uid\">\n          <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-sm {{dtz.customClass}}\"\n                  *ngIf=\"!(datePicker.onlyCurrentMonth && dtz.secondary)\"\n                  [ngClass]=\"{'btn-secondary': !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected, disabled: dtz.disabled}\"\n                  [disabled]=\"dtz.disabled\"\n                  (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n            <span [ngClass]=\"{'text-muted': dtz.secondary || dtz.current}\">{{dtz.label}}</span>\n          </button>\n        </td>\n    ",
	        ARROW_LEFT: '&lt;',
	        ARROW_RIGHT: '&gt;'
	    },
	    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS3] = {
	        DAY_TITLE: "\n        <th *ngFor=\"let labelz of labels\" class=\"text-center\"><small aria-label=\"labelz.full\"><b>{{labelz.abbr}}</b></small></th>\n    ",
	        WEEK_ROW: "\n        <td *ngIf=\"datePicker.showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[index] }}</em></td>\n        <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" [id]=\"dtz.uid\">\n          <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm {{dtz.customClass}}\"\n                  *ngIf=\"!(datePicker.onlyCurrentMonth && dtz.secondary)\"\n                  [ngClass]=\"{'btn-info': dtz.selected, active: datePicker.isActive(dtz), disabled: dtz.disabled}\"\n                  [disabled]=\"dtz.disabled\"\n                  (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n            <span [ngClass]=\"{'text-muted': dtz.secondary, 'text-info': dtz.current}\">{{dtz.label}}</span>\n          </button>\n        </td>\n    ",
	        ARROW_LEFT: "\n    <i class=\"glyphicon glyphicon-chevron-left\"></i>\n    ",
	        ARROW_RIGHT: "\n    <i class=\"glyphicon glyphicon-chevron-right\"></i>\n    "
	    },
	    _a
	);
	var CURRENT_THEME_TEMPLATE = TEMPLATE_OPTIONS[ng2_bootstrap_config_1.Ng2BootstrapConfig.theme || ng2_bootstrap_config_1.Ng2BootstrapTheme.BS3];
	var DayPickerComponent = (function () {
	    function DayPickerComponent(datePicker) {
	        this.labels = [];
	        this.rows = [];
	        this.weekNumbers = [];
	        this.datePicker = datePicker;
	    }
	    /*private getDaysInMonth(year:number, month:number) {
	     return ((month === 1) && (year % 4 === 0) &&
	     ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
	     }*/
	    DayPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepDay = { months: 1 };
	        this.datePicker.setRefreshViewHandler(function () {
	            var year = this.activeDate.getFullYear();
	            var month = this.activeDate.getMonth();
	            var firstDayOfMonth = new Date(year, month, 1);
	            var difference = this.startingDay - firstDayOfMonth.getDay();
	            var numDisplayedFromPreviousMonth = (difference > 0)
	                ? 7 - difference
	                : -difference;
	            var firstDate = new Date(firstDayOfMonth.getTime());
	            if (numDisplayedFromPreviousMonth > 0) {
	                firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	            }
	            // 42 is the number of days on a six-week calendar
	            var _days = self.getDates(firstDate, 42);
	            var days = [];
	            for (var i = 0; i < 42; i++) {
	                var _dateObject = this.createDateObject(_days[i], this.formatDay);
	                _dateObject.secondary = _days[i].getMonth() !== month;
	                _dateObject.uid = this.uniqueId + '-' + i;
	                days[i] = _dateObject;
	            }
	            self.labels = [];
	            for (var j = 0; j < 7; j++) {
	                self.labels[j] = {};
	                self.labels[j].abbr = this.dateFilter(days[j].date, this.formatDayHeader);
	                self.labels[j].full = this.dateFilter(days[j].date, 'EEEE');
	            }
	            self.title = this.dateFilter(this.activeDate, this.formatDayTitle);
	            self.rows = this.split(days, 7);
	            if (this.showWeeks) {
	                self.weekNumbers = [];
	                var thursdayIndex = (4 + 7 - this.startingDay) % 7;
	                var numWeeks = self.rows.length;
	                for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	                    self.weekNumbers.push(self.getISO8601WeekNumber(self.rows[curWeek][thursdayIndex].date));
	                }
	            }
	        }, 'day');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            var d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	            var d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	            return d1.getTime() - d2.getTime();
	        }, 'day');
	        this.datePicker.refreshView();
	    };
	    DayPickerComponent.prototype.getDates = function (startDate, n) {
	        var dates = new Array(n);
	        var current = new Date(startDate.getTime());
	        var i = 0;
	        var date;
	        while (i < n) {
	            date = new Date(current.getTime());
	            date = this.datePicker.fixTimeZone(date);
	            dates[i++] = date;
	            current = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1);
	        }
	        return dates;
	    };
	    DayPickerComponent.prototype.getISO8601WeekNumber = function (date) {
	        var checkDate = new Date(date.getTime());
	        // Thursday
	        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
	        var time = checkDate.getTime();
	        // Compare with Jan 1
	        checkDate.setMonth(0);
	        checkDate.setDate(1);
	        return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
	    };
	    DayPickerComponent = __decorate([
	        core_1.Component({
	            selector: 'daypicker',
	            template: "\n<table *ngIf=\"datePicker.datepickerMode==='day'\" role=\"grid\" aria-labelledby=\"uniqueId+'-title'\" aria-activedescendant=\"activeDateId\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-secondary btn-sm pull-left\" (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n        " + CURRENT_THEME_TEMPLATE.ARROW_LEFT + "\n        </button>\n      </th>\n      <th [attr.colspan]=\"5 + datePicker.showWeeks\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-secondary btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-secondary btn-sm pull-right\" (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n        " + CURRENT_THEME_TEMPLATE.ARROW_RIGHT + "\n        </button>\n      </th>\n    </tr>\n    <tr>\n      <th *ngIf=\"datePicker.showWeeks\"></th>\n      " + CURRENT_THEME_TEMPLATE.DAY_TITLE + "\n    </tr>\n  </thead>\n  <tbody>\n    <template ngFor [ngForOf]=\"rows\" let-rowz=\"$implicit\" let-index=\"index\">\n      <tr *ngIf=\"!(datePicker.onlyCurrentMonth && rowz[0].secondary && rowz[6].secondary)\">\n        " + CURRENT_THEME_TEMPLATE.WEEK_ROW + "\n      </tr>\n    </template>\n  </tbody>\n</table>\n  ",
	            directives: [forms_1.FORM_DIRECTIVES, common_1.CORE_DIRECTIVES, common_1.NgClass]
	        }), 
	        __metadata('design:paramtypes', [datepicker_inner_component_1.DatePickerInnerComponent])
	    ], DayPickerComponent);
	    return DayPickerComponent;
	}());
	exports.DayPickerComponent = DayPickerComponent;
	var _a;


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var datepicker_inner_component_1 = __webpack_require__(699);
	var ng2_bootstrap_config_1 = __webpack_require__(694);
	// write an interface for template options
	var TEMPLATE_OPTIONS = {
	    bs4: {
	        MONTH_BUTTON: "\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-info': dtz.selected, 'btn-link': !dtz.selected && !datePicker.isActive(dtz), 'btn-info': !dtz.selected && datePicker.isActive(dtz), disabled: dtz.disabled}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\"><span [ngClass]=\"{'text-success': dtz.current}\">{{dtz.label}}</span></button>\n    "
	    },
	    bs3: {
	        MONTH_BUTTON: "\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-info': dtz.selected, active: datePicker.isActive(dtz), disabled: dtz.disabled}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\"><span [ngClass]=\"{'text-info': dtz.current}\">{{dtz.label}}</span></button>\n    "
	    }
	};
	var CURRENT_THEME_TEMPLATE = TEMPLATE_OPTIONS[ng2_bootstrap_config_1.Ng2BootstrapConfig.theme] || TEMPLATE_OPTIONS.bs3;
	var MonthPickerComponent = (function () {
	    function MonthPickerComponent(datePicker) {
	        this.rows = [];
	        this.datePicker = datePicker;
	    }
	    MonthPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepMonth = { years: 1 };
	        this.datePicker.setRefreshViewHandler(function () {
	            var months = new Array(12);
	            var year = this.activeDate.getFullYear();
	            var date;
	            for (var i = 0; i < 12; i++) {
	                date = new Date(year, i, 1);
	                date = this.fixTimeZone(date);
	                months[i] = this.createDateObject(date, this.formatMonth);
	                months[i].uid = this.uniqueId + '-' + i;
	            }
	            self.title = this.dateFilter(this.activeDate, this.formatMonthTitle);
	            self.rows = this.split(months, 3);
	        }, 'month');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            var d1 = new Date(date1.getFullYear(), date1.getMonth());
	            var d2 = new Date(date2.getFullYear(), date2.getMonth());
	            return d1.getTime() - d2.getTime();
	        }, 'month');
	        this.datePicker.refreshView();
	    };
	    MonthPickerComponent = __decorate([
	        core_1.Component({
	            selector: 'monthpicker',
	            template: "\n<table *ngIf=\"datePicker.datepickerMode==='month'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button></th>\n      <th>\n        <button [id]=\"uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" id=\"{{dtz.uid}}\" [ngClass]=\"dtz.customClass\">\n        " + CURRENT_THEME_TEMPLATE.MONTH_BUTTON + "\n      </td>\n    </tr>\n  </tbody>\n</table>\n  ",
	            directives: [forms_1.FORM_DIRECTIVES, common_1.CORE_DIRECTIVES, common_1.NgClass]
	        }), 
	        __metadata('design:paramtypes', [datepicker_inner_component_1.DatePickerInnerComponent])
	    ], MonthPickerComponent);
	    return MonthPickerComponent;
	}());
	exports.MonthPickerComponent = MonthPickerComponent;


/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_config_1 = __webpack_require__(694);
	var datepicker_inner_component_1 = __webpack_require__(699);
	// write an interface for template options
	var TEMPLATE_OPTIONS = {
	    bs4: {
	        YEAR_BUTTON: "\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-info': dtz.selected, 'btn-link': !dtz.selected && !datePicker.isActive(dtz), 'btn-info': !dtz.selected && datePicker.isActive(dtz), disabled: dtz.disabled}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': dtz.current}\">{{dtz.label}}</span>\n        </button>\n    "
	    },
	    bs3: {
	        YEAR_BUTTON: "\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-info': dtz.selected, active: datePicker.isActive(dtz), disabled: dtz.disabled}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-info': dtz.current}\">{{dtz.label}}</span>\n        </button>\n    "
	    }
	};
	var CURRENT_THEME_TEMPLATE = TEMPLATE_OPTIONS[ng2_bootstrap_config_1.Ng2BootstrapConfig.theme] || TEMPLATE_OPTIONS.bs3;
	var YearPickerComponent = (function () {
	    function YearPickerComponent(datePicker) {
	        this.rows = [];
	        this.datePicker = datePicker;
	    }
	    YearPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepYear = { years: this.datePicker.yearRange };
	        this.datePicker.setRefreshViewHandler(function () {
	            var years = new Array(this.yearRange);
	            var date;
	            var start = self.getStartingYear(this.activeDate.getFullYear());
	            for (var i = 0; i < this.yearRange; i++) {
	                date = new Date(start + i, 0, 1);
	                date = this.fixTimeZone(date);
	                years[i] = this.createDateObject(date, this.formatYear);
	                years[i].uid = this.uniqueId + '-' + i;
	            }
	            self.title = [years[0].label,
	                years[this.yearRange - 1].label].join(' - ');
	            self.rows = this.split(years, 5);
	        }, 'year');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            return date1.getFullYear() - date2.getFullYear();
	        }, 'year');
	        this.datePicker.refreshView();
	    };
	    YearPickerComponent.prototype.getStartingYear = function (year) {
	        // todo: parseInt
	        return ((year - 1) / this.datePicker.yearRange) * this.datePicker.yearRange + 1;
	    };
	    YearPickerComponent = __decorate([
	        core_1.Component({
	            selector: 'yearpicker',
	            template: "\n<table *ngIf=\"datePicker.datepickerMode==='year'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button>\n      </th>\n      <th colspan=\"3\">\n        <button [id]=\"uniqueId + '-title'\" role=\"heading\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\">\n      " + CURRENT_THEME_TEMPLATE.YEAR_BUTTON + "\n      </td>\n    </tr>\n  </tbody>\n</table>\n  ",
	            directives: [forms_1.FORM_DIRECTIVES, common_1.CORE_DIRECTIVES, common_1.NgClass]
	        }), 
	        __metadata('design:paramtypes', [datepicker_inner_component_1.DatePickerInnerComponent])
	    ], YearPickerComponent);
	    return YearPickerComponent;
	}());
	exports.YearPickerComponent = YearPickerComponent;


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var dropdown_directive_1 = __webpack_require__(808);
	var dropdown_menu_directive_1 = __webpack_require__(810);
	var dropdown_toggle_directive_1 = __webpack_require__(811);
	var dropdown_directive_2 = __webpack_require__(808);
	exports.DropdownDirective = dropdown_directive_2.DropdownDirective;
	var dropdown_menu_directive_2 = __webpack_require__(810);
	exports.DropdownMenuDirective = dropdown_menu_directive_2.DropdownMenuDirective;
	var dropdown_toggle_directive_2 = __webpack_require__(811);
	exports.DropdownToggleDirective = dropdown_toggle_directive_2.DropdownToggleDirective;
	exports.DROPDOWN_DIRECTIVES = [dropdown_directive_1.DropdownDirective, dropdown_toggle_directive_1.DropdownToggleDirective, dropdown_menu_directive_1.DropdownMenuDirective];


/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var dropdown_service_1 = __webpack_require__(809);
	var DropdownDirective = (function () {
	    function DropdownDirective(el, ref) {
	        this.onToggle = new core_1.EventEmitter(false);
	        this.isOpenChange = new core_1.EventEmitter(false);
	        this.addClass = true;
	        // @Query('dropdownMenu', {descendants: false})
	        // dropdownMenuList:QueryList<ElementRef>) {
	        this.el = el;
	        this._changeDetector = ref;
	        // todo: bind to route change event
	    }
	    Object.defineProperty(DropdownDirective.prototype, "isOpen", {
	        get: function () {
	            return this._isOpen;
	        },
	        set: function (value) {
	            this._isOpen = !!value;
	            // todo: implement after porting position
	            // if (this.appendToBody && this.menuEl) {
	            //
	            // }
	            // todo: $animate open<->close transitions, as soon as ng2Animate will be
	            // ready
	            if (this.isOpen) {
	                this.focusToggleElement();
	                dropdown_service_1.dropdownService.open(this);
	            }
	            else {
	                dropdown_service_1.dropdownService.close(this);
	                this.selectedOption = void 0;
	            }
	            this.onToggle.emit(this.isOpen);
	            this.isOpenChange.emit(this.isOpen);
	            this._changeDetector.markForCheck();
	            // todo: implement call to setIsOpen if set and function
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownDirective.prototype.ngOnInit = function () {
	        this.autoClose = this.autoClose || dropdown_service_1.NONINPUT;
	        if (this.isOpen) {
	        }
	    };
	    DropdownDirective.prototype.ngOnDestroy = function () {
	        if (this.appendToBody && this.menuEl) {
	            this.menuEl.nativeElement.remove();
	        }
	    };
	    Object.defineProperty(DropdownDirective.prototype, "dropDownMenu", {
	        set: function (dropdownMenu) {
	            // init drop down menu
	            this.menuEl = dropdownMenu.el;
	            if (this.appendToBody) {
	                window.document.body.appendChild(this.menuEl.nativeElement);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DropdownDirective.prototype, "dropDownToggle", {
	        set: function (dropdownToggle) {
	            // init toggle element
	            this.toggleEl = dropdownToggle.el;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownDirective.prototype.toggle = function (open) {
	        return this.isOpen = arguments.length ? !!open : !this.isOpen;
	    };
	    DropdownDirective.prototype.focusDropdownEntry = function (keyCode) {
	        // If append to body is used.
	        var hostEl = this.menuEl ?
	            this.menuEl.nativeElement :
	            this.el.nativeElement.getElementsByTagName('ul')[0];
	        if (!hostEl) {
	            // todo: throw exception?
	            return;
	        }
	        var elems = hostEl.getElementsByTagName('a');
	        if (!elems || !elems.length) {
	            // todo: throw exception?
	            return;
	        }
	        // todo: use parseInt to detect isNumber?
	        // todo: or implement selectedOption as a get\set pair with parseInt on set
	        switch (keyCode) {
	            case (40):
	                if (typeof this.selectedOption !== 'number') {
	                    this.selectedOption = 0;
	                    break;
	                }
	                if (this.selectedOption === elems.length - 1) {
	                    break;
	                }
	                this.selectedOption++;
	                break;
	            case (38):
	                if (typeof this.selectedOption !== 'number') {
	                    return;
	                }
	                if (this.selectedOption === 0) {
	                    // todo: return?
	                    break;
	                }
	                this.selectedOption--;
	                break;
	            default:
	                break;
	        }
	        elems[this.selectedOption].focus();
	    };
	    DropdownDirective.prototype.focusToggleElement = function () {
	        if (this.toggleEl) {
	            this.toggleEl.nativeElement.focus();
	        }
	    };
	    __decorate([
	        core_1.HostBinding('class.open'),
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DropdownDirective.prototype, "isOpen", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], DropdownDirective.prototype, "autoClose", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DropdownDirective.prototype, "keyboardNav", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DropdownDirective.prototype, "appendToBody", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], DropdownDirective.prototype, "onToggle", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], DropdownDirective.prototype, "isOpenChange", void 0);
	    __decorate([
	        core_1.HostBinding('class.dropdown'), 
	        __metadata('design:type', Boolean)
	    ], DropdownDirective.prototype, "addClass", void 0);
	    DropdownDirective = __decorate([
	        core_1.Directive({ selector: '[dropdown]' }), 
	        __metadata('design:paramtypes', [core_1.ElementRef, core_1.ChangeDetectorRef])
	    ], DropdownDirective);
	    return DropdownDirective;
	}());
	exports.DropdownDirective = DropdownDirective;


/***/ },
/* 809 */
/***/ function(module, exports) {

	"use strict";
	exports.ALWAYS = 'always';
	exports.DISABLED = 'disabled';
	exports.OUTSIDECLICK = 'outsideClick';
	exports.NONINPUT = 'nonInput';
	var DropdownService = (function () {
	    function DropdownService() {
	        this.closeDropdownBind = this.closeDropdown.bind(this);
	        this.keybindFilterBind = this.keybindFilter.bind(this);
	    }
	    DropdownService.prototype.open = function (dropdownScope) {
	        if (!this.openScope) {
	            window.document.addEventListener('click', this.closeDropdownBind, true);
	            window.document.addEventListener('keydown', this.keybindFilterBind);
	        }
	        if (this.openScope && this.openScope !== dropdownScope) {
	            this.openScope.isOpen = false;
	        }
	        this.openScope = dropdownScope;
	    };
	    DropdownService.prototype.close = function (dropdownScope) {
	        if (this.openScope !== dropdownScope) {
	            return;
	        }
	        this.openScope = void 0;
	        window.document.removeEventListener('click', this.closeDropdownBind, true);
	        window.document.removeEventListener('keydown', this.keybindFilterBind);
	    };
	    DropdownService.prototype.closeDropdown = function (event) {
	        if (!this.openScope) {
	            return;
	        }
	        if (event && this.openScope.autoClose === exports.DISABLED) {
	            return;
	        }
	        if (event && this.openScope.toggleEl &&
	            this.openScope.toggleEl.nativeElement === event.target) {
	            return;
	        }
	        if (event && this.openScope.autoClose === exports.NONINPUT &&
	            this.openScope.menuEl &&
	            /input|textarea/i.test(event.target.tagName) &&
	            this.openScope.menuEl.nativeElement.contains(event.target)) {
	            return;
	        }
	        if (event && this.openScope.autoClose === exports.OUTSIDECLICK &&
	            this.openScope.menuEl &&
	            this.openScope.menuEl.nativeElement.contains(event.target)) {
	            return;
	        }
	        this.openScope.isOpen = false;
	    };
	    DropdownService.prototype.keybindFilter = function (event) {
	        if (event.which === 27) {
	            this.openScope.focusToggleElement();
	            this.closeDropdown(void 0);
	            return;
	        }
	        if (this.openScope.keyboardNav && this.openScope.isOpen &&
	            (event.which === 38 || event.which === 40)) {
	            event.preventDefault();
	            event.stopPropagation();
	            this.openScope.focusDropdownEntry(event.which);
	        }
	    };
	    return DropdownService;
	}());
	exports.DropdownService = DropdownService;
	exports.dropdownService = new DropdownService();


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var dropdown_directive_1 = __webpack_require__(808);
	var DropdownMenuDirective = (function () {
	    /* tslint:enable:no-unused-variable */
	    function DropdownMenuDirective(dropdown, el) {
	        /* tslint:disable:no-unused-variable */
	        this.addClass = true;
	        this.dropdown = dropdown;
	        this.el = el;
	    }
	    DropdownMenuDirective.prototype.ngOnInit = function () {
	        this.dropdown.dropDownMenu = this;
	    };
	    __decorate([
	        core_1.HostBinding('class.dropdown-menu'), 
	        __metadata('design:type', Boolean)
	    ], DropdownMenuDirective.prototype, "addClass", void 0);
	    DropdownMenuDirective = __decorate([
	        core_1.Directive({ selector: '[dropdownMenu]' }),
	        __param(0, core_1.Host()), 
	        __metadata('design:paramtypes', [dropdown_directive_1.DropdownDirective, core_1.ElementRef])
	    ], DropdownMenuDirective);
	    return DropdownMenuDirective;
	}());
	exports.DropdownMenuDirective = DropdownMenuDirective;


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var dropdown_directive_1 = __webpack_require__(808);
	var lang_1 = __webpack_require__(5);
	/* tslint:disable */
	var MouseEvent = lang_1.global.MouseEvent;
	/* tslint:enable */
	var DropdownToggleDirective = (function () {
	    function DropdownToggleDirective(dropdown, el) {
	        this.isDisabled = false;
	        this.addClass = true;
	        this.dropdown = dropdown;
	        this.el = el;
	    }
	    DropdownToggleDirective.prototype.ngOnInit = function () {
	        this.dropdown.dropDownToggle = this;
	    };
	    Object.defineProperty(DropdownToggleDirective.prototype, "isOpen", {
	        get: function () {
	            return this.dropdown.isOpen;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownToggleDirective.prototype.toggleDropdown = function (event) {
	        event.stopPropagation();
	        if (!this.isDisabled) {
	            this.dropdown.toggle();
	        }
	        return false;
	    };
	    __decorate([
	        core_1.HostBinding('class.disabled'),
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DropdownToggleDirective.prototype, "isDisabled", void 0);
	    __decorate([
	        core_1.HostBinding('class.dropdown-toggle'),
	        core_1.HostBinding('attr.aria-haspopup'), 
	        __metadata('design:type', Boolean)
	    ], DropdownToggleDirective.prototype, "addClass", void 0);
	    __decorate([
	        core_1.HostBinding('attr.aria-expanded'), 
	        __metadata('design:type', Boolean)
	    ], DropdownToggleDirective.prototype, "isOpen", null);
	    __decorate([
	        core_1.HostListener('click', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', Boolean)
	    ], DropdownToggleDirective.prototype, "toggleDropdown", null);
	    DropdownToggleDirective = __decorate([
	        core_1.Directive({ selector: '[dropdownToggle]' }),
	        __param(0, core_1.Host()), 
	        __metadata('design:paramtypes', [dropdown_directive_1.DropdownDirective, core_1.ElementRef])
	    ], DropdownToggleDirective);
	    return DropdownToggleDirective;
	}());
	exports.DropdownToggleDirective = DropdownToggleDirective;


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(813));
	__export(__webpack_require__(814));
	__export(__webpack_require__(815));
	var modal_backdrop_component_2 = __webpack_require__(813);
	var modal_component_2 = __webpack_require__(815);
	exports.MODAL_DIRECTIVES = [
	    modal_component_2.ModalDirective, modal_backdrop_component_2.ModalBackdropComponent
	];


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var modal_options_class_1 = __webpack_require__(814);
	var ModalBackdropOptions = (function () {
	    function ModalBackdropOptions(options) {
	        this.animate = true;
	        Object.assign(this, options);
	    }
	    return ModalBackdropOptions;
	}());
	exports.ModalBackdropOptions = ModalBackdropOptions;
	var ModalBackdropComponent = (function () {
	    function ModalBackdropComponent(options, element, renderer) {
	        this._isShown = false;
	        this.element = element;
	        this.renderer = renderer;
	        this.isAnimated = options.animate !== false;
	    }
	    Object.defineProperty(ModalBackdropComponent.prototype, "isAnimated", {
	        get: function () {
	            return this._isAnimated;
	        },
	        set: function (value) {
	            this._isAnimated = value;
	            this.renderer.setElementClass(this.element.nativeElement, "" + modal_options_class_1.ClassName.FADE, value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ModalBackdropComponent.prototype, "isShown", {
	        get: function () {
	            return this._isShown;
	        },
	        set: function (value) {
	            this._isShown = value;
	            this.renderer.setElementClass(this.element.nativeElement, "" + modal_options_class_1.ClassName.IN, value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ModalBackdropComponent = __decorate([
	        core_1.Component({
	            selector: 'bs-modal-backdrop',
	            template: '',
	            host: { 'class': "" + modal_options_class_1.ClassName.BACKDROP }
	        }), 
	        __metadata('design:paramtypes', [ModalBackdropOptions, core_1.ElementRef, core_1.Renderer])
	    ], ModalBackdropComponent);
	    return ModalBackdropComponent;
	}());
	exports.ModalBackdropComponent = ModalBackdropComponent;


/***/ },
/* 814 */
/***/ function(module, exports) {

	"use strict";
	exports.modalConfigDefaults = {
	    backdrop: true,
	    keyboard: true,
	    focus: true,
	    show: true,
	    ignoreBackdropClick: false
	};
	exports.ClassName = {
	    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
	    BACKDROP: 'modal-backdrop',
	    OPEN: 'modal-open',
	    FADE: 'fade',
	    IN: 'in'
	};
	exports.Selector = {
	    DIALOG: '.modal-dialog',
	    DATA_TOGGLE: '[data-toggle="modal"]',
	    DATA_DISMISS: '[data-dismiss="modal"]',
	    FIXED_CONTENT: '.navbar-fixed-top, .navbar-fixed-bottom, .is-fixed'
	};


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	// todo: should we support enforce focus in?
	// todo: in original bs there are was a way to prevent modal from showing
	// todo: original modal had resize events
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var lang_1 = __webpack_require__(5);
	var modal_backdrop_component_1 = __webpack_require__(813);
	var modal_options_class_1 = __webpack_require__(814);
	var components_helper_service_1 = __webpack_require__(816);
	var utils_class_1 = __webpack_require__(817);
	var TRANSITION_DURATION = 300;
	var BACKDROP_TRANSITION_DURATION = 150;
	var ModalDirective = (function () {
	    function ModalDirective(element, renderer, componentsHelper) {
	        this.onShow = new core_1.EventEmitter();
	        this.onShown = new core_1.EventEmitter();
	        this.onHide = new core_1.EventEmitter();
	        this.onHidden = new core_1.EventEmitter();
	        // seems like an Options
	        this.isAnimated = true;
	        this._isShown = false;
	        this.isBodyOverflowing = false;
	        this.originalBodyPadding = 0;
	        this.scrollbarWidth = 0;
	        this.element = element;
	        this.renderer = renderer;
	        this.componentsHelper = componentsHelper;
	    }
	    Object.defineProperty(ModalDirective.prototype, "config", {
	        get: function () {
	            return this._config;
	        },
	        set: function (conf) {
	            this._config = this.getConfig(conf);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    Object.defineProperty(ModalDirective.prototype, "isShown", {
	        get: function () {
	            return this._isShown;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ModalDirective.prototype, "document", {
	        get: function () {
	            return this.componentsHelper.getDocument();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    /** Host element manipulations */
	    // @HostBinding(`class.${ClassName.IN}`) private _addClassIn:boolean;
	    ModalDirective.prototype.onClick = function (event) {
	        if (this.config.ignoreBackdropClick || this.config.backdrop === 'static' || event.target !== this.element.nativeElement) {
	            return;
	        }
	        this.hide(event);
	    };
	    // todo: consider preventing default and stopping propagation
	    ModalDirective.prototype.onEsc = function () {
	        if (this.config.keyboard) {
	            this.hide();
	        }
	    };
	    ModalDirective.prototype.ngOnDestroy = function () {
	        this.config = void 0;
	        // this._element             = null
	        // this._dialog              = null
	        // this._backdrop            = null
	        this._isShown = void 0;
	        this.isBodyOverflowing = void 0;
	        this.originalBodyPadding = void 0;
	        this.scrollbarWidth = void 0;
	    };
	    ModalDirective.prototype.ngAfterViewInit = function () {
	        this._config = this._config || this.getConfig();
	    };
	    /** Public methods */
	    ModalDirective.prototype.toggle = function () {
	        return this._isShown ? this.hide() : this.show();
	    };
	    ModalDirective.prototype.show = function () {
	        var _this = this;
	        this.onShow.emit(this);
	        if (this._isShown) {
	            return;
	        }
	        this._isShown = true;
	        this.checkScrollbar();
	        this.setScrollbar();
	        if (this.document && this.document.body) {
	            this.renderer.setElementClass(this.document.body, modal_options_class_1.ClassName.OPEN, true);
	        }
	        this.showBackdrop(function () {
	            _this.showElement();
	        });
	    };
	    ModalDirective.prototype.hide = function (event) {
	        var _this = this;
	        if (event) {
	            event.preventDefault();
	        }
	        this.onHide.emit(this);
	        // todo: add an option to prevent hiding
	        if (!this._isShown) {
	            return;
	        }
	        this._isShown = false;
	        this.renderer.setElementClass(this.element.nativeElement, modal_options_class_1.ClassName.IN, false);
	        // this._addClassIn = false;
	        if (this.isAnimated) {
	            setTimeout(function () { return _this.hideModal(); }, TRANSITION_DURATION);
	        }
	        else {
	            this.hideModal();
	        }
	    };
	    /** Private methods */
	    ModalDirective.prototype.getConfig = function (config) {
	        return Object.assign({}, modal_options_class_1.modalConfigDefaults, config);
	    };
	    /**
	     *  Show dialog
	     */
	    ModalDirective.prototype.showElement = function () {
	        var _this = this;
	        // todo: replace this with component helper usage `add to root`
	        if (!this.element.nativeElement.parentNode ||
	            (this.element.nativeElement.parentNode.nodeType !== Node.ELEMENT_NODE)) {
	            // don't move modals dom position
	            if (this.document && this.document.body) {
	                this.document.body.appendChild(this.element.nativeElement);
	            }
	        }
	        this.renderer.setElementAttribute(this.element.nativeElement, 'aria-hidden', 'false');
	        this.renderer.setElementStyle(this.element.nativeElement, 'display', 'block');
	        this.renderer.setElementProperty(this.element.nativeElement, 'scrollTop', 0);
	        if (this.isAnimated) {
	            utils_class_1.Utils.reflow(this.element.nativeElement);
	        }
	        // this._addClassIn = true;
	        this.renderer.setElementClass(this.element.nativeElement, modal_options_class_1.ClassName.IN, true);
	        this.onShown.emit(this);
	        var transitionComplete = function () {
	            if (_this._config.focus) {
	                _this.element.nativeElement.focus();
	            }
	            _this.onShown.emit(_this);
	        };
	        if (this.isAnimated) {
	            setTimeout(transitionComplete, TRANSITION_DURATION);
	        }
	        else {
	            transitionComplete();
	        }
	    };
	    ModalDirective.prototype.hideModal = function () {
	        var _this = this;
	        this.renderer.setElementAttribute(this.element.nativeElement, 'aria-hidden', 'true');
	        this.renderer.setElementStyle(this.element.nativeElement, 'display', 'none');
	        this.showBackdrop(function () {
	            if (_this.document && _this.document.body) {
	                _this.renderer.setElementClass(_this.document.body, modal_options_class_1.ClassName.OPEN, false);
	            }
	            _this.resetAdjustments();
	            _this.resetScrollbar();
	            _this.onHidden.emit(_this);
	        });
	    };
	    // todo: original show was calling a callback when done, but we can use promise
	    ModalDirective.prototype.showBackdrop = function (callback) {
	        var _this = this;
	        if (this._isShown && this.config.backdrop) {
	            this.backdrop = this.componentsHelper
	                .appendNextToRoot(modal_backdrop_component_1.ModalBackdropComponent, modal_backdrop_component_1.ModalBackdropOptions, new modal_backdrop_component_1.ModalBackdropOptions({ animate: false }));
	            this.backdrop.then(function (backdrop) {
	                if (_this.isAnimated) {
	                    backdrop.instance.isAnimated = _this.isAnimated;
	                    utils_class_1.Utils.reflow(backdrop.instance.element.nativeElement);
	                }
	                backdrop.instance.isShown = true;
	                if (!callback) {
	                    return;
	                }
	                if (!_this.isAnimated) {
	                    callback();
	                    return;
	                }
	                setTimeout(callback, BACKDROP_TRANSITION_DURATION);
	            });
	        }
	        else if (!this._isShown && this.backdrop) {
	            this.backdrop.then(function (backdrop) {
	                backdrop.instance.isShown = false;
	                var callbackRemove = function () {
	                    _this.removeBackdrop();
	                    if (callback) {
	                        callback();
	                    }
	                };
	                if (backdrop.instance.isAnimated) {
	                    setTimeout(callbackRemove, BACKDROP_TRANSITION_DURATION);
	                }
	                else {
	                    callbackRemove();
	                }
	            });
	        }
	        else if (callback) {
	            callback();
	        }
	    };
	    ModalDirective.prototype.removeBackdrop = function () {
	        var _this = this;
	        if (this.backdrop) {
	            this.backdrop.then(function (backdrop) {
	                backdrop.destroy();
	                _this.backdrop = void 0;
	            });
	        }
	    };
	    /** Events tricks */
	    // no need for it
	    // private setEscapeEvent():void {
	    //   if (this._isShown && this._config.keyboard) {
	    //     $(this._element).on(Event.KEYDOWN_DISMISS, (event) => {
	    //       if (event.which === 27) {
	    //         this.hide()
	    //       }
	    //     })
	    //
	    //   } else if (!this._isShown) {
	    //     $(this._element).off(Event.KEYDOWN_DISMISS)
	    //   }
	    // }
	    // private setResizeEvent():void {
	    // console.log(this.renderer.listenGlobal('', Event.RESIZE));
	    // if (this._isShown) {
	    //   $(window).on(Event.RESIZE, $.proxy(this._handleUpdate, this))
	    // } else {
	    //   $(window).off(Event.RESIZE)
	    // }
	    // }
	    ModalDirective.prototype.resetAdjustments = function () {
	        this.renderer.setElementStyle(this.element.nativeElement, 'paddingLeft', '');
	        this.renderer.setElementStyle(this.element.nativeElement, 'paddingRight', '');
	    };
	    /** Scroll bar tricks */
	    ModalDirective.prototype.checkScrollbar = function () {
	        // this._isBodyOverflowing = document.body.clientWidth < window.innerWidth
	        this.isBodyOverflowing = this.document.body.clientWidth < lang_1.global.innerWidth;
	        this.scrollbarWidth = this.getScrollbarWidth();
	    };
	    ModalDirective.prototype.setScrollbar = function () {
	        if (!this.document) {
	            return;
	        }
	        var fixedEl = this.document.querySelector(modal_options_class_1.Selector.FIXED_CONTENT);
	        if (!fixedEl) {
	            return;
	        }
	        var bodyPadding = parseInt(utils_class_1.Utils.getStyles(fixedEl).paddingRight || 0, 10);
	        this.originalBodyPadding = parseInt(this.document.body.style.paddingRight || 0, 10);
	        if (this.isBodyOverflowing) {
	            this.document.body.style.paddingRight = (bodyPadding + this.scrollbarWidth) + "px";
	        }
	    };
	    ModalDirective.prototype.resetScrollbar = function () {
	        this.document.body.style.paddingRight = this.originalBodyPadding;
	    };
	    // thx d.walsh
	    ModalDirective.prototype.getScrollbarWidth = function () {
	        var scrollDiv = this.renderer.createElement(this.document.body, 'div', void 0);
	        scrollDiv.className = modal_options_class_1.ClassName.SCROLLBAR_MEASURER;
	        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	        this.document.body.removeChild(scrollDiv);
	        return scrollbarWidth;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object), 
	        __metadata('design:paramtypes', [Object])
	    ], ModalDirective.prototype, "config", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], ModalDirective.prototype, "onShow", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], ModalDirective.prototype, "onShown", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], ModalDirective.prototype, "onHide", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], ModalDirective.prototype, "onHidden", void 0);
	    __decorate([
	        core_1.HostListener('click', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], ModalDirective.prototype, "onClick", null);
	    __decorate([
	        core_1.HostListener('keydown.esc'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], ModalDirective.prototype, "onEsc", null);
	    ModalDirective = __decorate([
	        core_1.Directive({
	            selector: '[bsModal]',
	            exportAs: 'bs-modal'
	        }),
	        __param(2, core_1.Inject(components_helper_service_1.ComponentsHelper)), 
	        __metadata('design:paramtypes', [core_1.ElementRef, core_1.Renderer, components_helper_service_1.ComponentsHelper])
	    ], ModalDirective);
	    return ModalDirective;
	}());
	exports.ModalDirective = ModalDirective;


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var platform_browser_1 = __webpack_require__(128);
	/**
	 * Components helper class to easily work with
	 * allows to:
	 * - get application root view container ref
	 */
	var ComponentsHelper = (function () {
	    function ComponentsHelper(applicationRef, componentResolver, injector) {
	        this.applicationRef = applicationRef;
	        this.componentResolver = componentResolver;
	        this.injector = injector;
	    }
	    ComponentsHelper.prototype.getDocument = function () {
	        return this.injector.get(platform_browser_1.DOCUMENT);
	    };
	    /**
	     * This is a name conventional class to get application root view component ref
	     * to made this method working you need to add:
	     * ```typescript
	     *  @Component({
	     *   selector: 'my-app',
	     *   ...
	     *   })
	     *  export class MyApp {
	     *    constructor(viewContainerRef: ViewContainerRef) {
	     *        // A Default view container ref, usually the app root container ref.
	     *        // Has to be set manually until we can find a way to get it automatically.
	     *        this.viewContainerRef = viewContainerRef;
	     *      }
	     *  }
	     * ```
	     * @returns {ViewContainerRef} - application root view component ref
	     */
	    ComponentsHelper.prototype.getRootViewContainerRef = function () {
	        // The only way for now (by @mhevery)
	        // https://github.com/angular/angular/issues/6446#issuecomment-173459525
	        // this is a class of application bootstrap component (like my-app)
	        var classOfRootComponent = this.applicationRef.componentTypes[0];
	        // this is an instance of application bootstrap component
	        var appInstance = this.injector.get(classOfRootComponent);
	        return appInstance.viewContainerRef;
	    };
	    /**
	     * Helper methods to add ComponentClass(like modal backdrop) with options
	     * of type ComponentOptionsClass to element next to application root
	     * or next to provided instance of view container
	     * @param ComponentClass - @Component class
	     * @param ComponentOptionsClass - options class
	     * @param options - instance of options
	     * @param _viewContainerRef - optional instance of ViewContainerRef
	     * @returns {Promise<ComponentRef<T>>} - returns a promise with ComponentRef<T>
	     */
	    ComponentsHelper.prototype.appendNextToRoot = function (ComponentClass, ComponentOptionsClass, options, _viewContainerRef) {
	        var _this = this;
	        return this.componentResolver
	            .resolveComponent(ComponentClass)
	            .then(function (componentFactory) {
	            var viewContainerRef = _viewContainerRef || _this.getRootViewContainerRef();
	            var bindings = core_1.ReflectiveInjector.resolve([
	                new core_1.Provider(ComponentOptionsClass, { useValue: options })
	            ]);
	            var ctxInjector = viewContainerRef.parentInjector;
	            var childInjector = Array.isArray(bindings) && bindings.length > 0 ?
	                core_1.ReflectiveInjector.fromResolvedProviders(bindings, ctxInjector) : ctxInjector;
	            return viewContainerRef.createComponent(componentFactory, viewContainerRef.length, childInjector);
	        });
	    };
	    ComponentsHelper = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [core_1.ApplicationRef, core_1.ComponentResolver, core_1.Injector])
	    ], ComponentsHelper);
	    return ComponentsHelper;
	}());
	exports.ComponentsHelper = ComponentsHelper;


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var lang_1 = __webpack_require__(5);
	var Utils = (function () {
	    function Utils() {
	    }
	    Utils.reflow = function (element) {
	        new Function('bs', 'return bs')(element.offsetHeight);
	    };
	    // source: https://github.com/jquery/jquery/blob/master/src/css/var/getStyles.js
	    Utils.getStyles = function (elem) {
	        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
	        // IE throws on elements created in popups
	        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
	        var view = elem.ownerDocument.defaultView;
	        if (!view || !view.opener) {
	            view = lang_1.global;
	        }
	        return view.getComputedStyle(elem);
	    };
	    return Utils;
	}());
	exports.Utils = Utils;


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var pagination_component_1 = __webpack_require__(819);
	var pager_component_1 = __webpack_require__(820);
	var pagination_component_2 = __webpack_require__(819);
	exports.PaginationComponent = pagination_component_2.PaginationComponent;
	var pager_component_2 = __webpack_require__(820);
	exports.PagerComponent = pager_component_2.PagerComponent;
	exports.PAGINATION_DIRECTIVES = [pagination_component_1.PaginationComponent, pager_component_1.PagerComponent];


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var paginationConfig = {
	    maxSize: void 0,
	    itemsPerPage: 10,
	    boundaryLinks: false,
	    directionLinks: true,
	    firstText: 'First',
	    previousText: 'Previous',
	    nextText: 'Next',
	    lastText: 'Last',
	    rotate: true
	};
	var PAGINATION_TEMPLATE = "\n  <ul class=\"pagination\" [ngClass]=\"classMap\">\n    <li class=\"pagination-first page-item\"\n        *ngIf=\"boundaryLinks\"\n        [class.disabled]=\"noPrevious()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(1, $event)\" [innerHTML]=\"getText('first')\"></a>\n    </li>\n\n    <li class=\"pagination-prev page-item\"\n        *ngIf=\"directionLinks\"\n        [class.disabled]=\"noPrevious()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(page - 1, $event)\" [innerHTML]=\"getText('previous')\"></a>\n      </li>\n\n    <li *ngFor=\"let pg of pages\"\n        [class.active]=\"pg.active\"\n        [class.disabled]=\"disabled&&!pg.active\"\n        class=\"pagination-page page-item\">\n      <a class=\"page-link\" href (click)=\"selectPage(pg.number, $event)\" [innerHTML]=\"pg.text\"></a>\n    </li>\n\n    <li class=\"pagination-next page-item\"\n        *ngIf=\"directionLinks\"\n        [class.disabled]=\"noNext()\">\n      <a class=\"page-link\" href (click)=\"selectPage(page + 1, $event)\" [innerHTML]=\"getText('next')\"></a></li>\n\n    <li class=\"pagination-last page-item\"\n        *ngIf=\"boundaryLinks\"\n        [class.disabled]=\"noNext()\">\n      <a class=\"page-link\" href (click)=\"selectPage(totalPages, $event)\" [innerHTML]=\"getText('last')\"></a></li>\n  </ul>\n  ";
	/* tslint:disable */
	var PaginationComponent = (function () {
	    function PaginationComponent(cd, renderer, elementRef) {
	        this.numPages = new core_1.EventEmitter(false);
	        this.pageChanged = new core_1.EventEmitter(false);
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this.inited = false;
	        this.cd = cd;
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        cd.valueAccessor = this;
	        this.config = this.config || paginationConfig;
	    }
	    Object.defineProperty(PaginationComponent.prototype, "itemsPerPage", {
	        get: function () {
	            return this._itemsPerPage;
	        },
	        set: function (v) {
	            this._itemsPerPage = v;
	            this.totalPages = this.calculateTotalPages();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "totalItems", {
	        get: function () {
	            return this._totalItems;
	        },
	        set: function (v) {
	            this._totalItems = v;
	            this.totalPages = this.calculateTotalPages();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "totalPages", {
	        get: function () {
	            return this._totalPages;
	        },
	        set: function (v) {
	            this._totalPages = v;
	            this.numPages.emit(v);
	            if (this.inited) {
	                this.selectPage(this.page);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "page", {
	        get: function () {
	            return this._page;
	        },
	        set: function (value) {
	            var _previous = this._page;
	            this._page = (value > this.totalPages) ? this.totalPages : (value || 1);
	            if (_previous === this._page || typeof _previous === 'undefined') {
	                return;
	            }
	            this.pageChanged.emit({
	                page: this._page,
	                itemsPerPage: this.itemsPerPage
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PaginationComponent.prototype.ngOnInit = function () {
	        this.classMap = this.elementRef.nativeElement.getAttribute('class') || '';
	        // watch for maxSize
	        this.maxSize = typeof this.maxSize !== 'undefined'
	            ? this.maxSize
	            : paginationConfig.maxSize;
	        this.rotate = typeof this.rotate !== 'undefined'
	            ? this.rotate
	            : paginationConfig.rotate;
	        this.boundaryLinks = typeof this.boundaryLinks !== 'undefined'
	            ? this.boundaryLinks
	            : paginationConfig.boundaryLinks;
	        this.directionLinks = typeof this.directionLinks !== 'undefined'
	            ? this.directionLinks
	            : paginationConfig.directionLinks;
	        // base class
	        this.itemsPerPage = typeof this.itemsPerPage !== 'undefined'
	            ? this.itemsPerPage
	            : paginationConfig.itemsPerPage;
	        this.totalPages = this.calculateTotalPages();
	        // this class
	        this.pages = this.getPages(this.page, this.totalPages);
	        this.page = this.cd.value;
	        this.inited = true;
	    };
	    PaginationComponent.prototype.writeValue = function (value) {
	        this.page = value;
	        this.pages = this.getPages(this.page, this.totalPages);
	    };
	    PaginationComponent.prototype.getText = function (key) {
	        return this[key + 'Text'] || paginationConfig[key + 'Text'];
	    };
	    PaginationComponent.prototype.noPrevious = function () {
	        return this.page === 1;
	    };
	    PaginationComponent.prototype.noNext = function () {
	        return this.page === this.totalPages;
	    };
	    PaginationComponent.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    PaginationComponent.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    PaginationComponent.prototype.selectPage = function (page, event) {
	        if (event) {
	            event.preventDefault();
	        }
	        if (!this.disabled) {
	            if (event && event.target) {
	                var target = event.target;
	                target.blur();
	            }
	            this.writeValue(page);
	            this.cd.viewToModelUpdate(this.page);
	        }
	    };
	    // Create page object used in template
	    PaginationComponent.prototype.makePage = function (num, text, isActive) {
	        return {
	            number: num,
	            text: text,
	            active: isActive
	        };
	    };
	    PaginationComponent.prototype.getPages = function (currentPage, totalPages) {
	        var pages = [];
	        // Default page limits
	        var startPage = 1;
	        var endPage = totalPages;
	        var isMaxSized = typeof this.maxSize !== 'undefined' && this.maxSize < totalPages;
	        // recompute if maxSize
	        if (isMaxSized) {
	            if (this.rotate) {
	                // Current page is displayed in the middle of the visible ones
	                startPage = Math.max(currentPage - Math.floor(this.maxSize / 2), 1);
	                endPage = startPage + this.maxSize - 1;
	                // Adjust if limit is exceeded
	                if (endPage > totalPages) {
	                    endPage = totalPages;
	                    startPage = endPage - this.maxSize + 1;
	                }
	            }
	            else {
	                // Visible pages are paginated with maxSize
	                startPage = ((Math.ceil(currentPage / this.maxSize) - 1) * this.maxSize) + 1;
	                // Adjust last page if limit is exceeded
	                endPage = Math.min(startPage + this.maxSize - 1, totalPages);
	            }
	        }
	        // Add page number links
	        for (var num = startPage; num <= endPage; num++) {
	            var page = this.makePage(num, num.toString(), num === currentPage);
	            pages.push(page);
	        }
	        // Add links to move between page sets
	        if (isMaxSized && !this.rotate) {
	            if (startPage > 1) {
	                var previousPageSet = this.makePage(startPage - 1, '...', false);
	                pages.unshift(previousPageSet);
	            }
	            if (endPage < totalPages) {
	                var nextPageSet = this.makePage(endPage + 1, '...', false);
	                pages.push(nextPageSet);
	            }
	        }
	        return pages;
	    };
	    // base class
	    PaginationComponent.prototype.calculateTotalPages = function () {
	        var totalPages = this.itemsPerPage < 1
	            ? 1
	            : Math.ceil(this.totalItems / this.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], PaginationComponent.prototype, "maxSize", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PaginationComponent.prototype, "boundaryLinks", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PaginationComponent.prototype, "directionLinks", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], PaginationComponent.prototype, "firstText", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], PaginationComponent.prototype, "previousText", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], PaginationComponent.prototype, "nextText", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], PaginationComponent.prototype, "lastText", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PaginationComponent.prototype, "rotate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PaginationComponent.prototype, "disabled", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], PaginationComponent.prototype, "numPages", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], PaginationComponent.prototype, "pageChanged", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], PaginationComponent.prototype, "itemsPerPage", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], PaginationComponent.prototype, "totalItems", null);
	    PaginationComponent = __decorate([
	        core_1.Component({
	            selector: 'pagination[ngModel]',
	            template: PAGINATION_TEMPLATE,
	            directives: [common_1.NgFor, common_1.NgIf]
	        }),
	        __param(0, core_1.Self()), 
	        __metadata('design:paramtypes', [forms_1.NgModel, core_1.Renderer, core_1.ElementRef])
	    ], PaginationComponent);
	    return PaginationComponent;
	}());
	exports.PaginationComponent = PaginationComponent;


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var pagination_component_1 = __webpack_require__(819);
	var pagerConfig = {
	    itemsPerPage: 10,
	    previousText: '« Previous',
	    nextText: 'Next »',
	    align: true
	};
	var PAGER_TEMPLATE = "\n    <ul class=\"pager\">\n      <li [class.disabled]=\"noPrevious()\" [class.previous]=\"align\" [ngClass]=\"{'pull-right': align}\">\n        <a href (click)=\"selectPage(page - 1, $event)\">{{getText('previous')}}</a>\n      </li>\n      <li [class.disabled]=\"noNext()\" [class.next]=\"align\" [ngClass]=\"{'pull-right': align}\">\n        <a href (click)=\"selectPage(page + 1, $event)\">{{getText('next')}}</a>\n      </li>\n  </ul>\n";
	/* tslint:disable */
	var PagerComponent = (function (_super) {
	    __extends(PagerComponent, _super);
	    function PagerComponent(cd, renderer, elementRef) {
	        _super.call(this, cd, renderer, elementRef);
	        this.config = pagerConfig;
	    }
	    PagerComponent = __decorate([
	        core_1.Component({
	            selector: 'pager[ngModel]',
	            template: PAGER_TEMPLATE,
	            directives: [common_1.NgClass],
	            inputs: [
	                'align',
	                'totalItems', 'itemsPerPage',
	                'previousText', 'nextText',
	            ]
	        }),
	        __param(0, core_1.Self()), 
	        __metadata('design:paramtypes', [forms_1.NgModel, core_1.Renderer, core_1.ElementRef])
	    ], PagerComponent);
	    return PagerComponent;
	}(pagination_component_1.PaginationComponent));
	exports.PagerComponent = PagerComponent;


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var progress_directive_1 = __webpack_require__(822);
	var bar_component_1 = __webpack_require__(823);
	var progressbar_component_1 = __webpack_require__(824);
	var progress_directive_2 = __webpack_require__(822);
	exports.ProgressDirective = progress_directive_2.ProgressDirective;
	var bar_component_2 = __webpack_require__(823);
	exports.BarComponent = bar_component_2.BarComponent;
	var progressbar_component_2 = __webpack_require__(824);
	exports.ProgressbarComponent = progressbar_component_2.ProgressbarComponent;
	exports.PROGRESSBAR_DIRECTIVES = [progress_directive_1.ProgressDirective, bar_component_1.BarComponent, progressbar_component_1.ProgressbarComponent];


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var progressConfig = {
	    animate: true,
	    max: 100
	};
	// todo: progress element conflict with bootstrap.css
	// todo: need hack: replace host element with div
	/* tslint:disable */
	var ProgressDirective = (function () {
	    function ProgressDirective() {
	        this.addClass = true;
	        this.bars = [];
	    }
	    Object.defineProperty(ProgressDirective.prototype, "max", {
	        get: function () {
	            return this._max;
	        },
	        set: function (v) {
	            this._max = v;
	            this.bars.forEach(function (bar) {
	                bar.recalculatePercentage();
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProgressDirective.prototype.ngOnInit = function () {
	        this.animate = this.animate !== false;
	        this.max = typeof this.max === 'number' ? this.max : progressConfig.max;
	    };
	    ProgressDirective.prototype.addBar = function (bar) {
	        if (!this.animate) {
	            bar.transition = 'none';
	        }
	        this.bars.push(bar);
	    };
	    ProgressDirective.prototype.removeBar = function (bar) {
	        this.bars.splice(this.bars.indexOf(bar), 1);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ProgressDirective.prototype, "animate", void 0);
	    __decorate([
	        core_1.HostBinding('attr.max'),
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], ProgressDirective.prototype, "max", null);
	    __decorate([
	        core_1.HostBinding('class.progress'), 
	        __metadata('design:type', Boolean)
	    ], ProgressDirective.prototype, "addClass", void 0);
	    ProgressDirective = __decorate([
	        core_1.Directive({ selector: 'bs-progress, [progress]' }), 
	        __metadata('design:paramtypes', [])
	    ], ProgressDirective);
	    return ProgressDirective;
	}());
	exports.ProgressDirective = ProgressDirective;


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var progress_directive_1 = __webpack_require__(822);
	// todo: number pipe
	// todo: use query from progress?
	var BarComponent = (function () {
	    function BarComponent(progress) {
	        this.percent = 0;
	        this.progress = progress;
	    }
	    Object.defineProperty(BarComponent.prototype, "value", {
	        get: function () {
	            return this._value;
	        },
	        set: function (v) {
	            if (!v && v !== 0) {
	                return;
	            }
	            this._value = v;
	            this.recalculatePercentage();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BarComponent.prototype.ngOnInit = function () {
	        this.progress.addBar(this);
	    };
	    BarComponent.prototype.ngOnDestroy = function () {
	        this.progress.removeBar(this);
	    };
	    BarComponent.prototype.recalculatePercentage = function () {
	        this.percent = +(100 * this.value / this.progress.max).toFixed(2);
	        var totalPercentage = this.progress.bars.reduce(function (total, bar) {
	            return total + bar.percent;
	        }, 0);
	        if (totalPercentage > 100) {
	            this.percent -= totalPercentage - 100;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], BarComponent.prototype, "type", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], BarComponent.prototype, "value", null);
	    BarComponent = __decorate([
	        core_1.Component({
	            selector: 'bar',
	            directives: [common_1.NgClass, common_1.NgStyle],
	            template: "\n  <div class=\"progress-bar\"\n    style=\"min-width: 0;\"\n    role=\"progressbar\"\n    [ngClass]=\"type && 'progress-bar-' + type\"\n    [ngStyle]=\"{width: (percent < 100 ? percent : 100) + '%', transition: transition}\"\n    aria-valuemin=\"0\"\n    [attr.aria-valuenow]=\"value\"\n    [attr.aria-valuetext]=\"percent.toFixed(0) + '%'\"\n    [attr.aria-valuemax]=\"max\"><ng-content></ng-content></div>\n"
	        }),
	        __param(0, core_1.Host()), 
	        __metadata('design:paramtypes', [progress_directive_1.ProgressDirective])
	    ], BarComponent);
	    return BarComponent;
	}());
	exports.BarComponent = BarComponent;


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var progress_directive_1 = __webpack_require__(822);
	var bar_component_1 = __webpack_require__(823);
	var ProgressbarComponent = (function () {
	    function ProgressbarComponent() {
	    }
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ProgressbarComponent.prototype, "animate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], ProgressbarComponent.prototype, "max", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], ProgressbarComponent.prototype, "type", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], ProgressbarComponent.prototype, "value", void 0);
	    ProgressbarComponent = __decorate([
	        core_1.Component({
	            selector: 'progressbar',
	            directives: [progress_directive_1.ProgressDirective, bar_component_1.BarComponent],
	            template: "\n    <div progress [animate]=\"animate\" [max]=\"max\">\n      <bar [type]=\"type\" [value]=\"value\">\n          <ng-content></ng-content>\n      </bar>\n    </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProgressbarComponent);
	    return ProgressbarComponent;
	}());
	exports.ProgressbarComponent = ProgressbarComponent;


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var rating_component_1 = __webpack_require__(826);
	exports.RatingComponent = rating_component_1.RatingComponent;


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	var lang_1 = __webpack_require__(5);
	/* tslint:disable */
	var KeyboardEvent = lang_1.global.KeyboardEvent;
	/* tslint:enable */
	var RatingComponent = (function () {
	    function RatingComponent(cd) {
	        this.onHover = new core_1.EventEmitter(false);
	        this.onLeave = new core_1.EventEmitter(false);
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this.cd = cd;
	        cd.valueAccessor = this;
	    }
	    RatingComponent.prototype.onKeydown = function (event) {
	        if ([37, 38, 39, 40].indexOf(event.which) === -1) {
	            return;
	        }
	        event.preventDefault();
	        event.stopPropagation();
	        var sign = event.which === 38 || event.which === 39 ? 1 : -1;
	        this.rate(this.value + sign);
	    };
	    RatingComponent.prototype.ngOnInit = function () {
	        this.max = typeof this.max !== 'undefined' ? this.max : 5;
	        this.readonly = this.readonly === true;
	        this.stateOn = typeof this.stateOn !== 'undefined'
	            ? this.stateOn
	            : 'glyphicon-star';
	        this.stateOff = typeof this.stateOff !== 'undefined'
	            ? this.stateOff
	            : 'glyphicon-star-empty';
	        this.titles = typeof this.titles !== 'undefined' && this.titles.length > 0
	            ? this.titles
	            : ['one', 'two', 'three', 'four', 'five'];
	        this.range = this.buildTemplateObjects(this.ratingStates, this.max);
	    };
	    // model -> view
	    RatingComponent.prototype.writeValue = function (value) {
	        if (value % 1 !== value) {
	            this.value = Math.round(value);
	            this.preValue = value;
	            return;
	        }
	        this.preValue = value;
	        this.value = value;
	    };
	    RatingComponent.prototype.enter = function (value) {
	        if (!this.readonly) {
	            this.value = value;
	            this.onHover.emit(value);
	        }
	    };
	    RatingComponent.prototype.reset = function () {
	        this.value = this.preValue;
	        this.onLeave.emit(this.value);
	    };
	    RatingComponent.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    RatingComponent.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    RatingComponent.prototype.buildTemplateObjects = function (ratingStates, max) {
	        ratingStates = ratingStates || [];
	        var count = ratingStates.length || max;
	        var result = [];
	        for (var i = 0; i < count; i++) {
	            result.push(Object.assign({
	                index: i,
	                stateOn: this.stateOn,
	                stateOff: this.stateOff,
	                title: this.titles[i] || i + 1
	            }, ratingStates[i] || {}));
	        }
	        return result;
	    };
	    RatingComponent.prototype.rate = function (value) {
	        if (!this.readonly && value >= 0 && value <= this.range.length) {
	            this.writeValue(value);
	            this.cd.viewToModelUpdate(value);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], RatingComponent.prototype, "max", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], RatingComponent.prototype, "stateOn", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], RatingComponent.prototype, "stateOff", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], RatingComponent.prototype, "readonly", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], RatingComponent.prototype, "titles", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], RatingComponent.prototype, "ratingStates", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], RatingComponent.prototype, "onHover", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], RatingComponent.prototype, "onLeave", void 0);
	    __decorate([
	        core_1.HostListener('keydown', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], RatingComponent.prototype, "onKeydown", null);
	    RatingComponent = __decorate([
	        core_1.Component({
	            /* tslint:disable */
	            selector: 'rating[ngModel]',
	            /* tslint:enable */
	            directives: [common_1.NgFor],
	            template: "\n    <span (mouseleave)=\"reset()\" (keydown)=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" [attr.aria-valuemax]=\"range.length\" [attr.aria-valuenow]=\"value\">\n      <template ngFor let-r [ngForOf]=\"range\" let-index=\"index\">\n        <span class=\"sr-only\">({{ index < value ? '*' : ' ' }})</span>\n        <i (mouseenter)=\"enter(index + 1)\" (click)=\"rate(index + 1)\" class=\"glyphicon\" [ngClass]=\"index < value ? r.stateOn : r.stateOff\" [title]=\"r.title\" ></i>\n      </template>\n    </span>\n  "
	        }),
	        __param(0, core_1.Self()), 
	        __metadata('design:paramtypes', [forms_1.NgModel])
	    ], RatingComponent);
	    return RatingComponent;
	}());
	exports.RatingComponent = RatingComponent;


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var tab_directive_1 = __webpack_require__(828);
	var tabset_component_1 = __webpack_require__(829);
	var tab_heading_directive_1 = __webpack_require__(831);
	var tab_directive_2 = __webpack_require__(828);
	exports.TabDirective = tab_directive_2.TabDirective;
	var tabset_component_2 = __webpack_require__(829);
	exports.TabsetComponent = tabset_component_2.TabsetComponent;
	var tab_heading_directive_2 = __webpack_require__(831);
	exports.TabHeadingDirective = tab_heading_directive_2.TabHeadingDirective;
	exports.TAB_DIRECTIVES = [tab_directive_1.TabDirective, tab_heading_directive_1.TabHeadingDirective, tabset_component_1.TabsetComponent];


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var tabset_component_1 = __webpack_require__(829);
	/* tslint:disable */
	var TabDirective = (function () {
	    function TabDirective(tabset) {
	        this.select = new core_1.EventEmitter(false);
	        this.deselect = new core_1.EventEmitter(false);
	        this.removed = new core_1.EventEmitter(false);
	        this.addClass = true;
	        this.tabset = tabset;
	        this.tabset.addTab(this);
	    }
	    Object.defineProperty(TabDirective.prototype, "active", {
	        /** tab active state toggle */
	        get: function () {
	            return this._active;
	        },
	        set: function (active) {
	            var _this = this;
	            if (this.disabled && active || !active) {
	                if (!active) {
	                    this._active = active;
	                }
	                this.deselect.emit(this);
	                return;
	            }
	            this._active = active;
	            this.select.emit(this);
	            this.tabset.tabs.forEach(function (tab) {
	                if (tab !== _this) {
	                    tab.active = false;
	                }
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TabDirective.prototype.ngOnInit = function () { this.removable = !!this.removable; };
	    TabDirective.prototype.ngOnDestroy = function () {
	        this.tabset.removeTab(this);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], TabDirective.prototype, "heading", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TabDirective.prototype, "disabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TabDirective.prototype, "removable", void 0);
	    __decorate([
	        core_1.HostBinding('class.active'),
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TabDirective.prototype, "active", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], TabDirective.prototype, "select", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], TabDirective.prototype, "deselect", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], TabDirective.prototype, "removed", void 0);
	    __decorate([
	        core_1.HostBinding('class.tab-pane'), 
	        __metadata('design:type', Boolean)
	    ], TabDirective.prototype, "addClass", void 0);
	    TabDirective = __decorate([
	        core_1.Directive({ selector: 'tab, [tab]' }), 
	        __metadata('design:paramtypes', [tabset_component_1.TabsetComponent])
	    ], TabDirective);
	    return TabDirective;
	}());
	exports.TabDirective = TabDirective;


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var common_2 = __webpack_require__(830);
	// todo: add active event to tab
	// todo: fix? mixing static and dynamic tabs position tabs in order of creation
	var TabsetComponent = (function () {
	    function TabsetComponent() {
	        this.clazz = true;
	        this.tabs = [];
	        this.classMap = {};
	    }
	    Object.defineProperty(TabsetComponent.prototype, "vertical", {
	        get: function () { return this._vertical; },
	        set: function (value) {
	            this._vertical = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    Object.defineProperty(TabsetComponent.prototype, "justified", {
	        get: function () { return this._justified; },
	        set: function (value) {
	            this._justified = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    Object.defineProperty(TabsetComponent.prototype, "type", {
	        get: function () { return this._type; },
	        set: function (value) {
	            this._type = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    TabsetComponent.prototype.ngOnInit = function () {
	        this.type = this.type !== 'undefined' ? this.type : 'tabs';
	    };
	    TabsetComponent.prototype.ngOnDestroy = function () {
	        this.isDestroyed = true;
	    };
	    TabsetComponent.prototype.addTab = function (tab) {
	        this.tabs.push(tab);
	        tab.active = this.tabs.length === 1 && tab.active !== false;
	    };
	    TabsetComponent.prototype.removeTab = function (tab) {
	        var index = this.tabs.indexOf(tab);
	        if (index === -1 || this.isDestroyed) {
	            return;
	        }
	        // Select a new tab if the tab to be removed is selected and not destroyed
	        if (tab.active && this.hasAvailableTabs(index)) {
	            var newActiveIndex = this.getClosestTabIndex(index);
	            this.tabs[newActiveIndex].active = true;
	        }
	        tab.removed.emit(tab);
	        this.tabs.splice(index, 1);
	    };
	    TabsetComponent.prototype.getClosestTabIndex = function (index) {
	        var tabsLength = this.tabs.length;
	        if (!tabsLength) {
	            return -1;
	        }
	        for (var step = 1; step <= tabsLength; step += 1) {
	            var prevIndex = index - step;
	            var nextIndex = index + step;
	            if (this.tabs[prevIndex] && !this.tabs[prevIndex].disabled) {
	                return prevIndex;
	            }
	            if (this.tabs[nextIndex] && !this.tabs[nextIndex].disabled) {
	                return nextIndex;
	            }
	        }
	        return -1;
	    };
	    TabsetComponent.prototype.hasAvailableTabs = function (index) {
	        var tabsLength = this.tabs.length;
	        if (!tabsLength) {
	            return false;
	        }
	        for (var i = 0; i < tabsLength; i += 1) {
	            if (!this.tabs[i].disabled && i !== index) {
	                return true;
	            }
	        }
	        return false;
	    };
	    TabsetComponent.prototype.setClassMap = function () {
	        this.classMap = (_a = {
	                'nav-stacked': this.vertical,
	                'nav-justified': this.justified
	            },
	            _a['nav-' + (this.type || 'tabs')] = true,
	            _a
	        );
	        var _a;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TabsetComponent.prototype, "vertical", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TabsetComponent.prototype, "justified", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], TabsetComponent.prototype, "type", null);
	    __decorate([
	        core_1.HostBinding('class.tab-container'), 
	        __metadata('design:type', Boolean)
	    ], TabsetComponent.prototype, "clazz", void 0);
	    TabsetComponent = __decorate([
	        core_1.Component({
	            selector: 'tabset',
	            directives: [common_1.NgClass, common_2.NgTranscludeDirective],
	            template: "\n    <ul class=\"nav\" [ngClass]=\"classMap\" (click)=\"$event.preventDefault()\">\n        <li *ngFor=\"let tabz of tabs\" class=\"nav-item\"\n          [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\">\n          <a href class=\"nav-link\"\n            [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\"\n            (click)=\"tabz.active = true\">\n            <span [ngTransclude]=\"tabz.headingRef\">{{tabz.heading}}</span>\n            <span *ngIf=\"tabz.removable\">\n              <span (click)=\"$event.preventDefault(); removeTab(tabz);\" class=\"glyphicon glyphicon-remove-circle\"></span>\n            </span>\n          </a>\n        </li>\n    </ul>\n    <div class=\"tab-content\">\n      <ng-content></ng-content>\n    </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TabsetComponent);
	    return TabsetComponent;
	}());
	exports.TabsetComponent = TabsetComponent;


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var NgTranscludeDirective = (function () {
	    function NgTranscludeDirective(_viewRef) {
	        this.viewRef = _viewRef;
	    }
	    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
	        get: function () {
	            return this._ngTransclude;
	        },
	        set: function (templateRef) {
	            this._ngTransclude = templateRef;
	            if (templateRef) {
	                this.viewRef.createEmbeddedView(templateRef);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NgTranscludeDirective = __decorate([
	        core_1.Directive({
	            selector: '[ngTransclude]',
	            properties: ['ngTransclude']
	        }),
	        __param(0, core_1.Inject(core_1.ViewContainerRef)), 
	        __metadata('design:paramtypes', [core_1.ViewContainerRef])
	    ], NgTranscludeDirective);
	    return NgTranscludeDirective;
	}());
	exports.NgTranscludeDirective = NgTranscludeDirective;


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var tab_directive_1 = __webpack_require__(828);
	var TabHeadingDirective = (function () {
	    function TabHeadingDirective(templateRef, tab) {
	        tab.headingRef = templateRef;
	    }
	    TabHeadingDirective = __decorate([
	        core_1.Directive({ selector: '[tabHeading]' }), 
	        __metadata('design:paramtypes', [core_1.TemplateRef, tab_directive_1.TabDirective])
	    ], TabHeadingDirective);
	    return TabHeadingDirective;
	}());
	exports.TabHeadingDirective = TabHeadingDirective;


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var timepicker_component_1 = __webpack_require__(833);
	exports.TimepickerComponent = timepicker_component_1.TimepickerComponent;


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var forms_1 = __webpack_require__(643);
	// todo: implement global configuration via DI
	// todo: refactor directive has to many functions! (extract to stateless helper)
	// todo: use moment js?
	// todo: implement `time` validator
	// todo: replace increment/decrement blockers with getters, or extract
	// todo: unify work with selected
	exports.timepickerConfig = {
	    hourStep: 1,
	    minuteStep: 1,
	    showMeridian: true,
	    meridians: void 0,
	    readonlyInput: false,
	    mousewheel: true,
	    arrowkeys: true,
	    showSpinners: true,
	    min: void 0,
	    max: void 0
	};
	function isDefined(value) {
	    return typeof value !== 'undefined';
	}
	function def(value, fn, defaultValue) {
	    return fn(value) ? value : defaultValue;
	}
	function addMinutes(date, minutes) {
	    var dt = new Date(date.getTime() + minutes * 60000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes());
	    return newDate;
	}
	var TimepickerComponent = (function () {
	    function TimepickerComponent(cd) {
	        this.meridians = ['AM', 'PM']; // ??
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        // result value
	        this._selected = new Date();
	        this.cd = cd;
	        cd.valueAccessor = this;
	    }
	    Object.defineProperty(TimepickerComponent.prototype, "showMeridian", {
	        get: function () {
	            return this._showMeridian;
	        },
	        set: function (value) {
	            this._showMeridian = value;
	            // || !this.$error.time
	            // if (true) {
	            this.updateTemplate();
	            return;
	            // }
	            // Evaluate from template
	            /*let hours = this.getHoursFromTemplate();
	             let minutes = this.getMinutesFromTemplate();
	             if (isDefined(hours) && isDefined(minutes)) {
	             this.selected.setHours(hours);
	             this.refresh();
	             }*/
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimepickerComponent.prototype, "selected", {
	        get: function () {
	            return this._selected;
	        },
	        set: function (v) {
	            if (v) {
	                this._selected = v;
	                this.updateTemplate();
	                this.cd.viewToModelUpdate(this.selected);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // todo: add formatter value to Date object
	    TimepickerComponent.prototype.ngOnInit = function () {
	        // todo: take in account $locale.DATETIME_FORMATS.AMPMS;
	        this.meridians = def(this.meridians, isDefined, exports.timepickerConfig.meridians) || ['AM',
	            'PM'];
	        this.mousewheel = def(this.mousewheel, isDefined, exports.timepickerConfig.mousewheel);
	        if (this.mousewheel) {
	        }
	        this.arrowkeys = def(this.arrowkeys, isDefined, exports.timepickerConfig.arrowkeys);
	        if (this.arrowkeys) {
	        }
	        this.readonlyInput = def(this.readonlyInput, isDefined, exports.timepickerConfig.readonlyInput);
	        // this.setupInputEvents();
	        this.hourStep = def(this.hourStep, isDefined, exports.timepickerConfig.hourStep);
	        this.minuteStep = def(this.minuteStep, isDefined, exports.timepickerConfig.minuteStep);
	        this.min = def(this.min, isDefined, exports.timepickerConfig.min);
	        this.max = def(this.max, isDefined, exports.timepickerConfig.max);
	        // 12H / 24H mode
	        this.showMeridian = def(this.showMeridian, isDefined, exports.timepickerConfig.showMeridian);
	        this.showSpinners = def(this.showSpinners, isDefined, exports.timepickerConfig.showSpinners);
	    };
	    TimepickerComponent.prototype.writeValue = function (v) {
	        if (v === this.selected) {
	            return;
	        }
	        if (v && v instanceof Date) {
	            this.selected = v;
	            return;
	        }
	        this.selected = v ? new Date(v) : void 0;
	    };
	    TimepickerComponent.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	    TimepickerComponent.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	    TimepickerComponent.prototype.updateHours = function () {
	        if (this.readonlyInput) {
	            return;
	        }
	        var hours = this.getHoursFromTemplate();
	        var minutes = this.getMinutesFromTemplate();
	        this.invalidHours = !isDefined(hours);
	        this.invalidMinutes = !isDefined(minutes);
	        if (this.invalidHours || this.invalidMinutes) {
	            // TODO: needed a validation functionality.
	            return;
	        }
	        this.selected.setHours(hours);
	        this.invalidHours = (this.selected < this.min || this.selected > this.max);
	        if (this.invalidHours) {
	            // todo: validation?
	            // invalidate(true);
	            return;
	        }
	        else {
	            this.refresh();
	        }
	    };
	    TimepickerComponent.prototype.hoursOnBlur = function () {
	        if (this.readonlyInput) {
	            return;
	        }
	        // todo: binded with validation
	        if (!this.invalidHours && parseInt(this.hours, 10) < 10) {
	            this.hours = this.pad(this.hours);
	        }
	    };
	    TimepickerComponent.prototype.updateMinutes = function () {
	        if (this.readonlyInput) {
	            return;
	        }
	        var minutes = this.getMinutesFromTemplate();
	        var hours = this.getHoursFromTemplate();
	        this.invalidMinutes = !isDefined(minutes);
	        this.invalidHours = !isDefined(hours);
	        if (this.invalidMinutes || this.invalidHours) {
	            // TODO: needed a validation functionality.
	            return;
	        }
	        this.selected.setMinutes(minutes);
	        this.invalidMinutes = (this.selected < this.min || this.selected > this.max);
	        if (this.invalidMinutes) {
	            // todo: validation
	            // invalidate(undefined, true);
	            return;
	        }
	        else {
	            this.refresh();
	        }
	    };
	    TimepickerComponent.prototype.minutesOnBlur = function () {
	        if (this.readonlyInput) {
	            return;
	        }
	        if (!this.invalidMinutes && parseInt(this.minutes, 10) < 10) {
	            this.minutes = this.pad(this.minutes);
	        }
	    };
	    TimepickerComponent.prototype.incrementHours = function () {
	        if (!this.noIncrementHours()) {
	            this.addMinutesToSelected(this.hourStep * 60);
	        }
	    };
	    TimepickerComponent.prototype.decrementHours = function () {
	        if (!this.noDecrementHours()) {
	            this.addMinutesToSelected(-this.hourStep * 60);
	        }
	    };
	    TimepickerComponent.prototype.incrementMinutes = function () {
	        if (!this.noIncrementMinutes()) {
	            this.addMinutesToSelected(this.minuteStep);
	        }
	    };
	    TimepickerComponent.prototype.decrementMinutes = function () {
	        if (!this.noDecrementMinutes()) {
	            this.addMinutesToSelected(-this.minuteStep);
	        }
	    };
	    TimepickerComponent.prototype.toggleMeridian = function () {
	        if (!this.noToggleMeridian()) {
	            var sign = this.selected.getHours() < 12 ? 1 : -1;
	            this.addMinutesToSelected(12 * 60 * sign);
	        }
	    };
	    TimepickerComponent.prototype.refresh = function () {
	        // this.makeValid();
	        this.updateTemplate();
	        this.cd.viewToModelUpdate(this.selected);
	    };
	    TimepickerComponent.prototype.updateTemplate = function () {
	        var hours = this.selected.getHours();
	        var minutes = this.selected.getMinutes();
	        if (this.showMeridian) {
	            // Convert 24 to 12 hour system
	            hours = (hours === 0 || hours === 12) ? 12 : hours % 12;
	        }
	        // this.hours = keyboardChange === 'h' ? hours : this.pad(hours);
	        // if (keyboardChange !== 'm') {
	        //  this.minutes = this.pad(minutes);
	        // }
	        this.hours = this.pad(hours);
	        this.minutes = this.pad(minutes);
	        this.meridian = this.selected.getHours() < 12
	            ? this.meridians[0]
	            : this.meridians[1];
	    };
	    TimepickerComponent.prototype.getHoursFromTemplate = function () {
	        var hours = parseInt(this.hours, 10);
	        var valid = this.showMeridian
	            ? (hours > 0 && hours < 13)
	            : (hours >= 0 && hours < 24);
	        if (!valid) {
	            return void 0;
	        }
	        if (this.showMeridian) {
	            if (hours === 12) {
	                hours = 0;
	            }
	            if (this.meridian === this.meridians[1]) {
	                hours = hours + 12;
	            }
	        }
	        return hours;
	    };
	    TimepickerComponent.prototype.getMinutesFromTemplate = function () {
	        var minutes = parseInt(this.minutes, 10);
	        return (minutes >= 0 && minutes < 60) ? minutes : undefined;
	    };
	    TimepickerComponent.prototype.pad = function (value) {
	        return (isDefined(value) && value.toString().length < 2)
	            ? '0' + value
	            : value.toString();
	    };
	    TimepickerComponent.prototype.noIncrementHours = function () {
	        var incrementedSelected = addMinutes(this.selected, this.hourStep * 60);
	        return incrementedSelected > this.max ||
	            (incrementedSelected < this.selected && incrementedSelected < this.min);
	    };
	    TimepickerComponent.prototype.noDecrementHours = function () {
	        var decrementedSelected = addMinutes(this.selected, -this.hourStep * 60);
	        return decrementedSelected < this.min ||
	            (decrementedSelected > this.selected && decrementedSelected > this.max);
	    };
	    TimepickerComponent.prototype.noIncrementMinutes = function () {
	        var incrementedSelected = addMinutes(this.selected, this.minuteStep);
	        return incrementedSelected > this.max ||
	            (incrementedSelected < this.selected && incrementedSelected < this.min);
	    };
	    TimepickerComponent.prototype.noDecrementMinutes = function () {
	        var decrementedSelected = addMinutes(this.selected, -this.minuteStep);
	        return decrementedSelected < this.min ||
	            (decrementedSelected > this.selected && decrementedSelected > this.max);
	    };
	    TimepickerComponent.prototype.addMinutesToSelected = function (minutes) {
	        this.selected = addMinutes(this.selected, minutes);
	        this.refresh();
	    };
	    TimepickerComponent.prototype.noToggleMeridian = function () {
	        if (this.selected.getHours() < 13) {
	            return addMinutes(this.selected, 12 * 60) > this.max;
	        }
	        else {
	            return addMinutes(this.selected, -12 * 60) < this.min;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], TimepickerComponent.prototype, "hourStep", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], TimepickerComponent.prototype, "minuteStep", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TimepickerComponent.prototype, "readonlyInput", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TimepickerComponent.prototype, "mousewheel", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TimepickerComponent.prototype, "arrowkeys", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TimepickerComponent.prototype, "showSpinners", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], TimepickerComponent.prototype, "min", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Date)
	    ], TimepickerComponent.prototype, "max", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], TimepickerComponent.prototype, "meridians", void 0);
	    __decorate([
	        // ??
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TimepickerComponent.prototype, "showMeridian", null);
	    TimepickerComponent = __decorate([
	        core_1.Component({
	            /* tslint:disable */
	            selector: 'timepicker[ngModel]',
	            /* tslint:enable */
	            directives: [common_1.NgClass],
	            template: "\n    <table>\n      <tbody>\n        <tr class=\"text-center\" [ngClass]=\"{hidden: !showSpinners}\">\n          <td><a (click)=\"incrementHours()\" [ngClass]=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n          <td>&nbsp;</td>\n          <td><a (click)=\"incrementMinutes()\" [ngClass]=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"></td>\n        </tr>\n        <tr>\n          <td class=\"form-group\" [ngClass]=\"{'has-error': invalidHours}\">\n            <input style=\"width:50px;\" type=\"text\" [(ngModel)]=\"hours\" (change)=\"updateHours()\" class=\"form-control text-center\" [readonly]=\"readonlyInput\" (blur)=\"hoursOnBlur($event)\" maxlength=\"2\">\n          </td>\n          <td>:</td>\n          <td class=\"form-group\" [ngClass]=\"{'has-error': invalidMinutes}\">\n            <input style=\"width:50px;\" type=\"text\" [(ngModel)]=\"minutes\" (change)=\"updateMinutes()\" class=\"form-control text-center\" [readonly]=\"readonlyInput\" (blur)=\"minutesOnBlur($event)\" maxlength=\"2\">\n          </td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"><button type=\"button\" [ngClass]=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" (click)=\"toggleMeridian()\">{{meridian}}</button></td>\n        </tr>\n        <tr class=\"text-center\" [ngClass]=\"{hidden: !showSpinners}\">\n          <td><a (click)=\"decrementHours()\" [ngClass]=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n          <td>&nbsp;</td>\n          <td><a (click)=\"decrementMinutes()\" [ngClass]=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"></td>\n        </tr>\n      </tbody>\n    </table>\n  "
	        }),
	        __param(0, core_1.Self()), 
	        __metadata('design:paramtypes', [forms_1.NgModel])
	    ], TimepickerComponent);
	    return TimepickerComponent;
	}());
	exports.TimepickerComponent = TimepickerComponent;


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var tooltip_directive_1 = __webpack_require__(835);
	var tooltip_container_component_1 = __webpack_require__(837);
	var tooltip_directive_2 = __webpack_require__(835);
	exports.TooltipDirective = tooltip_directive_2.TooltipDirective;
	var tooltip_container_component_2 = __webpack_require__(837);
	exports.TooltipContainerComponent = tooltip_container_component_2.TooltipContainerComponent;
	exports.TOOLTIP_DIRECTIVES = [tooltip_directive_1.TooltipDirective, tooltip_container_component_1.TooltipContainerComponent];


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var tooltip_options_class_1 = __webpack_require__(836);
	var tooltip_container_component_1 = __webpack_require__(837);
	/* tslint:disable */
	var TooltipDirective = (function () {
	    function TooltipDirective(viewContainerRef, loader) {
	        this.placement = 'top';
	        this.enable = true;
	        this.animation = true;
	        this.visible = false;
	        this.viewContainerRef = viewContainerRef;
	        this.loader = loader;
	    }
	    // todo: filter triggers
	    // params: event, target
	    TooltipDirective.prototype.show = function () {
	        if (this.visible || !this.enable) {
	            return;
	        }
	        this.visible = true;
	        var options = new tooltip_options_class_1.TooltipOptions({
	            content: this.content,
	            htmlContent: this.htmlContent,
	            placement: this.placement,
	            animation: this.animation,
	            hostEl: this.viewContainerRef.element,
	            popupClass: this.popupClass
	        });
	        var binding = core_1.ReflectiveInjector.resolve([
	            new core_1.Provider(tooltip_options_class_1.TooltipOptions, { useValue: options })
	        ]);
	        this.tooltip = this.loader
	            .loadNextToLocation(tooltip_container_component_1.TooltipContainerComponent, this.viewContainerRef, binding)
	            .then(function (componentRef) {
	            return componentRef;
	        });
	    };
	    // params event, target
	    TooltipDirective.prototype.hide = function () {
	        if (!this.visible) {
	            return;
	        }
	        this.visible = false;
	        this.tooltip.then(function (componentRef) {
	            componentRef.destroy();
	            return componentRef;
	        });
	    };
	    __decorate([
	        core_1.Input('tooltip'), 
	        __metadata('design:type', String)
	    ], TooltipDirective.prototype, "content", void 0);
	    __decorate([
	        core_1.Input('tooltipHtml'), 
	        __metadata('design:type', String)
	    ], TooltipDirective.prototype, "htmlContent", void 0);
	    __decorate([
	        core_1.Input('tooltipPlacement'), 
	        __metadata('design:type', String)
	    ], TooltipDirective.prototype, "placement", void 0);
	    __decorate([
	        core_1.Input('tooltipIsOpen'), 
	        __metadata('design:type', Boolean)
	    ], TooltipDirective.prototype, "isOpen", void 0);
	    __decorate([
	        core_1.Input('tooltipEnable'), 
	        __metadata('design:type', Boolean)
	    ], TooltipDirective.prototype, "enable", void 0);
	    __decorate([
	        core_1.Input('tooltipAnimation'), 
	        __metadata('design:type', Boolean)
	    ], TooltipDirective.prototype, "animation", void 0);
	    __decorate([
	        core_1.Input('tooltipAppendToBody'), 
	        __metadata('design:type', Boolean)
	    ], TooltipDirective.prototype, "appendToBody", void 0);
	    __decorate([
	        core_1.Input('tooltipClass'), 
	        __metadata('design:type', String)
	    ], TooltipDirective.prototype, "popupClass", void 0);
	    __decorate([
	        core_1.HostListener('focusin', ['$event', '$target']),
	        core_1.HostListener('mouseenter', ['$event', '$target']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], TooltipDirective.prototype, "show", null);
	    __decorate([
	        core_1.HostListener('focusout', ['$event', '$target']),
	        core_1.HostListener('mouseleave', ['$event', '$target']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], TooltipDirective.prototype, "hide", null);
	    TooltipDirective = __decorate([
	        core_1.Directive({ selector: '[tooltip], [tooltipHtml]' }), 
	        __metadata('design:paramtypes', [core_1.ViewContainerRef, core_1.DynamicComponentLoader])
	    ], TooltipDirective);
	    return TooltipDirective;
	}());
	exports.TooltipDirective = TooltipDirective;


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var TooltipOptions = (function () {
	    function TooltipOptions(options) {
	        Object.assign(this, options);
	    }
	    TooltipOptions = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [Object])
	    ], TooltipOptions);
	    return TooltipOptions;
	}());
	exports.TooltipOptions = TooltipOptions;


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var position_1 = __webpack_require__(697);
	var tooltip_options_class_1 = __webpack_require__(836);
	var TooltipContainerComponent = (function () {
	    function TooltipContainerComponent(element, cdr, options) {
	        this.top = '-1000px';
	        this.left = '-1000px';
	        this.display = 'block';
	        this.element = element;
	        this.cdr = cdr;
	        Object.assign(this, options);
	        this.classMap = { 'in': false, 'fade': false };
	        this.classMap[options.placement] = true;
	        this.classMap['tooltip-' + options.placement] = true;
	    }
	    TooltipContainerComponent.prototype.ngAfterViewInit = function () {
	        var p = position_1.positionService
	            .positionElements(this.hostEl.nativeElement, this.element.nativeElement.children[0], this.placement, this.appendToBody);
	        this.top = p.top + 'px';
	        this.left = p.left + 'px';
	        this.classMap.in = true;
	        if (this.animation) {
	            this.classMap.fade = true;
	        }
	        if (this.popupClass) {
	            this.classMap[this.popupClass] = true;
	        }
	        this.cdr.detectChanges();
	    };
	    TooltipContainerComponent = __decorate([
	        core_1.Component({
	            selector: 'tooltip-container',
	            directives: [common_1.NgClass, common_1.NgStyle],
	            // changeDetection: ChangeDetectionStrategy.OnPush,
	            template: "<div class=\"tooltip\" role=\"tooltip\"\n     [ngStyle]=\"{top: top, left: left, display: display}\"\n     [ngClass]=\"classMap\">\n      <div class=\"tooltip-arrow\"></div>\n      <div class=\"tooltip-inner\"\n           *ngIf=\"htmlContent\" \n           innerHtml=\"{{htmlContent}}\">\n      </div>\n      <div class=\"tooltip-inner\"\n           *ngIf=\"content\">\n        {{content}}\n      </div>\n    </div>"
	        }),
	        __param(2, core_1.Inject(tooltip_options_class_1.TooltipOptions)), 
	        __metadata('design:paramtypes', [core_1.ElementRef, core_1.ChangeDetectorRef, tooltip_options_class_1.TooltipOptions])
	    ], TooltipContainerComponent);
	    return TooltipContainerComponent;
	}());
	exports.TooltipContainerComponent = TooltipContainerComponent;


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var typeahead_directive_1 = __webpack_require__(839);
	var typeahead_container_component_1 = __webpack_require__(842);
	var typeahead_directive_2 = __webpack_require__(839);
	exports.TypeaheadDirective = typeahead_directive_2.TypeaheadDirective;
	var typeahead_container_component_2 = __webpack_require__(842);
	exports.TypeaheadContainerComponent = typeahead_container_component_2.TypeaheadContainerComponent;
	var typeahead_options_class_1 = __webpack_require__(843);
	exports.TypeaheadOptions = typeahead_options_class_1.TypeaheadOptions;
	exports.TYPEAHEAD_DIRECTIVES = [typeahead_directive_1.TypeaheadDirective, typeahead_container_component_1.TypeaheadContainerComponent];


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var typeahead_utils_1 = __webpack_require__(840);
	var typeahead_container_component_1 = __webpack_require__(842);
	var typeahead_options_class_1 = __webpack_require__(843);
	var Observable_1 = __webpack_require__(34);
	__webpack_require__(368);
	__webpack_require__(498);
	__webpack_require__(512);
	__webpack_require__(353);
	__webpack_require__(355);
	__webpack_require__(611);
	var lang_1 = __webpack_require__(5);
	/* tslint:disable */
	var KeyboardEvent = lang_1.global.KeyboardEvent;
	/* tslint:enable */
	var TypeaheadDirective = (function () {
	    function TypeaheadDirective(control, viewContainerRef, element, renderer, loader) {
	        this.typeaheadLoading = new core_1.EventEmitter(false);
	        this.typeaheadNoResults = new core_1.EventEmitter(false);
	        this.typeaheadOnSelect = new core_1.EventEmitter(false);
	        this.typeaheadMinLength = void 0;
	        this.typeaheadAsync = void 0;
	        this.typeaheadLatinize = true;
	        this.typeaheadSingleWords = true;
	        this.typeaheadWordDelimiters = ' ';
	        this.typeaheadPhraseDelimiters = '\'"';
	        this.isTypeaheadOptionsListActive = false;
	        this.keyUpEventEmitter = new core_1.EventEmitter();
	        this.placement = 'bottom-left';
	        this.element = element;
	        this.ngControl = control;
	        this.viewContainerRef = viewContainerRef;
	        this.renderer = renderer;
	        this.loader = loader;
	    }
	    TypeaheadDirective.prototype.onChange = function (e) {
	        if (this.container) {
	            // esc
	            if (e.keyCode === 27) {
	                this.hide();
	                return;
	            }
	            // up
	            if (e.keyCode === 38) {
	                this.container.prevActiveMatch();
	                return;
	            }
	            // down
	            if (e.keyCode === 40) {
	                this.container.nextActiveMatch();
	                return;
	            }
	            // enter
	            if (e.keyCode === 13) {
	                this.container.selectActiveMatch();
	                return;
	            }
	        }
	        if (e.target.value.trim().length >= this.typeaheadMinLength) {
	            this.typeaheadLoading.emit(true);
	            this.keyUpEventEmitter.emit(e.target.value);
	        }
	        else {
	            this.typeaheadLoading.emit(false);
	            this.typeaheadNoResults.emit(false);
	            this.hide();
	        }
	    };
	    TypeaheadDirective.prototype.onFocus = function () {
	        if (this.typeaheadMinLength === 0) {
	            this.typeaheadLoading.emit(true);
	            this.keyUpEventEmitter.emit('');
	        }
	    };
	    TypeaheadDirective.prototype.onBlur = function () {
	        if (this.container && !this.container.isFocused) {
	            this.hide();
	        }
	    };
	    TypeaheadDirective.prototype.onKeydown = function (e) {
	        // no container - no problems
	        if (!this.container) {
	            return;
	        }
	        // if items is visible - prevent form submition
	        if (e.keyCode === 13) {
	            e.preventDefault();
	            return;
	        }
	        // if tab default browser behavior will select next input field, and therefore we should close the items list
	        if (e.keyCode === 9) {
	            this.hide();
	            return;
	        }
	    };
	    TypeaheadDirective.prototype.ngOnInit = function () {
	        this.typeaheadOptionsLimit = this.typeaheadOptionsLimit || 20;
	        this.typeaheadMinLength = this.typeaheadMinLength === void 0 ? 1 : this.typeaheadMinLength;
	        this.typeaheadWaitMs = this.typeaheadWaitMs || 0;
	        // async should be false in case of array
	        if (this.typeaheadAsync === undefined && !(this.typeahead instanceof Observable_1.Observable)) {
	            this.typeaheadAsync = false;
	        }
	        if (this.typeahead instanceof Observable_1.Observable) {
	            this.typeaheadAsync = true;
	        }
	        if (this.typeaheadAsync) {
	            this.asyncActions();
	        }
	        else {
	            this.syncActions();
	        }
	    };
	    TypeaheadDirective.prototype.changeModel = function (value) {
	        var valueStr = ((typeof value === 'object' && this.typeaheadOptionField)
	            ? value[this.typeaheadOptionField]
	            : value).toString();
	        this.ngControl.viewToModelUpdate(valueStr);
	        this.ngControl.control.updateValue(valueStr);
	        this.hide();
	    };
	    Object.defineProperty(TypeaheadDirective.prototype, "matches", {
	        get: function () {
	            return this._matches;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TypeaheadDirective.prototype.show = function (matches) {
	        var _this = this;
	        var options = new typeahead_options_class_1.TypeaheadOptions({
	            typeaheadRef: this,
	            placement: this.placement,
	            animation: false
	        });
	        var binding = core_1.ReflectiveInjector.resolve([
	            core_1.provide(typeahead_options_class_1.TypeaheadOptions, { useValue: options })
	        ]);
	        this.popup = this.loader
	            .loadNextToLocation(typeahead_container_component_1.TypeaheadContainerComponent, this.viewContainerRef, binding)
	            .then(function (componentRef) {
	            componentRef.instance.position(_this.viewContainerRef.element);
	            _this.container = componentRef.instance;
	            _this.container.parent = _this;
	            // This improves the speedas it won't have to be done for each list item
	            var normalizedQuery = (_this.typeaheadLatinize
	                ? typeahead_utils_1.TypeaheadUtils.latinize(_this.ngControl.control.value)
	                : _this.ngControl.control.value).toString()
	                .toLowerCase();
	            _this.container.query = _this.typeaheadSingleWords
	                ? typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, _this.typeaheadWordDelimiters, _this.typeaheadPhraseDelimiters)
	                : normalizedQuery;
	            _this.container.matches = matches;
	            _this.container.field = _this.typeaheadOptionField;
	            _this.element.nativeElement.focus();
	            return componentRef;
	        });
	    };
	    TypeaheadDirective.prototype.hide = function () {
	        var _this = this;
	        if (this.container) {
	            this.popup.then(function (componentRef) {
	                componentRef.destroy();
	                _this.container = void 0;
	                return componentRef;
	            });
	        }
	    };
	    TypeaheadDirective.prototype.asyncActions = function () {
	        var _this = this;
	        this.keyUpEventEmitter
	            .debounceTime(this.typeaheadWaitMs)
	            .mergeMap(function () { return _this.typeahead; })
	            .subscribe(function (matches) {
	            _this._matches = matches.slice(0, _this.typeaheadOptionsLimit);
	            _this.finalizeAsyncCall();
	        }, function (err) {
	            console.error(err);
	        });
	    };
	    TypeaheadDirective.prototype.syncActions = function () {
	        var _this = this;
	        this.keyUpEventEmitter
	            .debounceTime(this.typeaheadWaitMs)
	            .mergeMap(function (value) {
	            var normalizedQuery = _this.normalizeQuery(value);
	            return Observable_1.Observable.from(_this.typeahead)
	                .filter(function (option) {
	                return option && _this.testMatch(_this.prepareOption(option).toLowerCase(), normalizedQuery);
	            })
	                .toArray();
	        })
	            .subscribe(function (matches) {
	            _this._matches = matches.slice(0, _this.typeaheadOptionsLimit);
	            _this.finalizeAsyncCall();
	        }, function (err) {
	            console.error(err);
	        });
	    };
	    TypeaheadDirective.prototype.prepareOption = function (option) {
	        var match;
	        if (typeof option === 'object' &&
	            option[this.typeaheadOptionField]) {
	            match = this.typeaheadLatinize ?
	                typeahead_utils_1.TypeaheadUtils.latinize(option[this.typeaheadOptionField].toString()) :
	                option[this.typeaheadOptionField].toString();
	        }
	        if (typeof option === 'string') {
	            match = this.typeaheadLatinize ?
	                typeahead_utils_1.TypeaheadUtils.latinize(option.toString()) :
	                option.toString();
	        }
	        return match;
	    };
	    TypeaheadDirective.prototype.normalizeQuery = function (value) {
	        // If singleWords, break model here to not be doing extra work on each iteration
	        var normalizedQuery = (this.typeaheadLatinize ? typeahead_utils_1.TypeaheadUtils.latinize(value) : value)
	            .toString()
	            .toLowerCase();
	        normalizedQuery = this.typeaheadSingleWords ?
	            typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters) :
	            normalizedQuery;
	        return normalizedQuery;
	    };
	    TypeaheadDirective.prototype.testMatch = function (match, test) {
	        var spaceLength;
	        if (typeof test === 'object') {
	            spaceLength = test.length;
	            for (var i = 0; i < spaceLength; i += 1) {
	                if (test[i].length > 0 && match.indexOf(test[i]) < 0) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        else {
	            return match.indexOf(test) >= 0;
	        }
	    };
	    TypeaheadDirective.prototype.finalizeAsyncCall = function () {
	        this.typeaheadLoading.emit(false);
	        this.typeaheadNoResults.emit(this.matches.length <= 0);
	        if (this._matches.length <= 0) {
	            this.hide();
	            return;
	        }
	        if (this.container && this._matches.length > 0) {
	            // This improves the speedas it won't have to be done for each list item
	            var normalizedQuery = (this.typeaheadLatinize
	                ? typeahead_utils_1.TypeaheadUtils.latinize(this.ngControl.control.value)
	                : this.ngControl.control.value).toString()
	                .toLowerCase();
	            this.container.query = this.typeaheadSingleWords
	                ? typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
	                : normalizedQuery;
	            this.container.matches = this._matches;
	        }
	        if (!this.container && this._matches.length > 0) {
	            this.show(this._matches);
	        }
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], TypeaheadDirective.prototype, "typeaheadLoading", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], TypeaheadDirective.prototype, "typeaheadNoResults", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], TypeaheadDirective.prototype, "typeaheadOnSelect", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], TypeaheadDirective.prototype, "typeahead", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], TypeaheadDirective.prototype, "typeaheadMinLength", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], TypeaheadDirective.prototype, "typeaheadWaitMs", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], TypeaheadDirective.prototype, "typeaheadOptionsLimit", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], TypeaheadDirective.prototype, "typeaheadOptionField", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TypeaheadDirective.prototype, "typeaheadAsync", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TypeaheadDirective.prototype, "typeaheadLatinize", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TypeaheadDirective.prototype, "typeaheadSingleWords", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], TypeaheadDirective.prototype, "typeaheadWordDelimiters", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], TypeaheadDirective.prototype, "typeaheadPhraseDelimiters", void 0);
	    __decorate([
	        core_1.HostListener('keyup', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], TypeaheadDirective.prototype, "onChange", null);
	    __decorate([
	        core_1.HostListener('focus', ['$event.target']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], TypeaheadDirective.prototype, "onFocus", null);
	    __decorate([
	        core_1.HostListener('blur'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], TypeaheadDirective.prototype, "onBlur", null);
	    __decorate([
	        core_1.HostListener('keydown', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], TypeaheadDirective.prototype, "onKeydown", null);
	    TypeaheadDirective = __decorate([
	        core_1.Directive({
	            /* tslint:disable */
	            selector: '[typeahead][ngModel],[typeahead][formControlName]'
	        }), 
	        __metadata('design:paramtypes', [forms_1.NgControl, core_1.ViewContainerRef, core_1.ElementRef, core_1.Renderer, core_1.DynamicComponentLoader])
	    ], TypeaheadDirective);
	    return TypeaheadDirective;
	}());
	exports.TypeaheadDirective = TypeaheadDirective;


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var latin_map_1 = __webpack_require__(841);
	var TypeaheadUtils = (function () {
	    function TypeaheadUtils() {
	    }
	    TypeaheadUtils.latinize = function (str) {
	        if (!str) {
	            return '';
	        }
	        return str.replace(/[^A-Za-z0-9\[\] ]/g, function (a) {
	            return TypeaheadUtils.latinMap[a] || a;
	        });
	    };
	    TypeaheadUtils.escapeRegexp = function (queryToEscape) {
	        // Regex: capture the whole query string and replace it with the string
	        // that will be used to match the results, for example if the capture is
	        // 'a' the result will be \a
	        return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    };
	    /* tslint:disable */
	    TypeaheadUtils.tokenize = function (str, wordRegexDelimiters, phraseRegexDelimiters) {
	        if (wordRegexDelimiters === void 0) { wordRegexDelimiters = ' '; }
	        if (phraseRegexDelimiters === void 0) { phraseRegexDelimiters = ''; }
	        /* tslint:enable */
	        var regexStr = '(?:[' + phraseRegexDelimiters + '])([^' + phraseRegexDelimiters + ']+)(?:[' + phraseRegexDelimiters + '])|([^' + wordRegexDelimiters + ']+)';
	        var preTokenized = str.split(new RegExp(regexStr, 'g'));
	        var result = [];
	        var preTokenizedLength = preTokenized.length;
	        var token;
	        var replacePhraseDelimiters = new RegExp('[' + phraseRegexDelimiters + ']+', 'g');
	        for (var i = 0; i < preTokenizedLength; i += 1) {
	            token = preTokenized[i];
	            if (token && token.length && token !== wordRegexDelimiters) {
	                result.push(token.replace(replacePhraseDelimiters, ''));
	            }
	        }
	        return result;
	    };
	    TypeaheadUtils.latinMap = latin_map_1.latinMap;
	    return TypeaheadUtils;
	}());
	exports.TypeaheadUtils = TypeaheadUtils;


/***/ },
/* 841 */
/***/ function(module, exports) {

	"use strict";
	exports.latinMap = {
	    'Á': 'A',
	    'Ă': 'A',
	    'Ắ': 'A',
	    'Ặ': 'A',
	    'Ằ': 'A',
	    'Ẳ': 'A',
	    'Ẵ': 'A',
	    'Ǎ': 'A',
	    'Â': 'A',
	    'Ấ': 'A',
	    'Ậ': 'A',
	    'Ầ': 'A',
	    'Ẩ': 'A',
	    'Ẫ': 'A',
	    'Ä': 'A',
	    'Ǟ': 'A',
	    'Ȧ': 'A',
	    'Ǡ': 'A',
	    'Ạ': 'A',
	    'Ȁ': 'A',
	    'À': 'A',
	    'Ả': 'A',
	    'Ȃ': 'A',
	    'Ā': 'A',
	    'Ą': 'A',
	    'Å': 'A',
	    'Ǻ': 'A',
	    'Ḁ': 'A',
	    'Ⱥ': 'A',
	    'Ã': 'A',
	    'Ꜳ': 'AA',
	    'Æ': 'AE',
	    'Ǽ': 'AE',
	    'Ǣ': 'AE',
	    'Ꜵ': 'AO',
	    'Ꜷ': 'AU',
	    'Ꜹ': 'AV',
	    'Ꜻ': 'AV',
	    'Ꜽ': 'AY',
	    'Ḃ': 'B',
	    'Ḅ': 'B',
	    'Ɓ': 'B',
	    'Ḇ': 'B',
	    'Ƀ': 'B',
	    'Ƃ': 'B',
	    'Ć': 'C',
	    'Č': 'C',
	    'Ç': 'C',
	    'Ḉ': 'C',
	    'Ĉ': 'C',
	    'Ċ': 'C',
	    'Ƈ': 'C',
	    'Ȼ': 'C',
	    'Ď': 'D',
	    'Ḑ': 'D',
	    'Ḓ': 'D',
	    'Ḋ': 'D',
	    'Ḍ': 'D',
	    'Ɗ': 'D',
	    'Ḏ': 'D',
	    'ǲ': 'D',
	    'ǅ': 'D',
	    'Đ': 'D',
	    'Ƌ': 'D',
	    'Ǳ': 'DZ',
	    'Ǆ': 'DZ',
	    'É': 'E',
	    'Ĕ': 'E',
	    'Ě': 'E',
	    'Ȩ': 'E',
	    'Ḝ': 'E',
	    'Ê': 'E',
	    'Ế': 'E',
	    'Ệ': 'E',
	    'Ề': 'E',
	    'Ể': 'E',
	    'Ễ': 'E',
	    'Ḙ': 'E',
	    'Ë': 'E',
	    'Ė': 'E',
	    'Ẹ': 'E',
	    'Ȅ': 'E',
	    'È': 'E',
	    'Ẻ': 'E',
	    'Ȇ': 'E',
	    'Ē': 'E',
	    'Ḗ': 'E',
	    'Ḕ': 'E',
	    'Ę': 'E',
	    'Ɇ': 'E',
	    'Ẽ': 'E',
	    'Ḛ': 'E',
	    'Ꝫ': 'ET',
	    'Ḟ': 'F',
	    'Ƒ': 'F',
	    'Ǵ': 'G',
	    'Ğ': 'G',
	    'Ǧ': 'G',
	    'Ģ': 'G',
	    'Ĝ': 'G',
	    'Ġ': 'G',
	    'Ɠ': 'G',
	    'Ḡ': 'G',
	    'Ǥ': 'G',
	    'Ḫ': 'H',
	    'Ȟ': 'H',
	    'Ḩ': 'H',
	    'Ĥ': 'H',
	    'Ⱨ': 'H',
	    'Ḧ': 'H',
	    'Ḣ': 'H',
	    'Ḥ': 'H',
	    'Ħ': 'H',
	    'Í': 'I',
	    'Ĭ': 'I',
	    'Ǐ': 'I',
	    'Î': 'I',
	    'Ï': 'I',
	    'Ḯ': 'I',
	    'İ': 'I',
	    'Ị': 'I',
	    'Ȉ': 'I',
	    'Ì': 'I',
	    'Ỉ': 'I',
	    'Ȋ': 'I',
	    'Ī': 'I',
	    'Į': 'I',
	    'Ɨ': 'I',
	    'Ĩ': 'I',
	    'Ḭ': 'I',
	    'Ꝺ': 'D',
	    'Ꝼ': 'F',
	    'Ᵹ': 'G',
	    'Ꞃ': 'R',
	    'Ꞅ': 'S',
	    'Ꞇ': 'T',
	    'Ꝭ': 'IS',
	    'Ĵ': 'J',
	    'Ɉ': 'J',
	    'Ḱ': 'K',
	    'Ǩ': 'K',
	    'Ķ': 'K',
	    'Ⱪ': 'K',
	    'Ꝃ': 'K',
	    'Ḳ': 'K',
	    'Ƙ': 'K',
	    'Ḵ': 'K',
	    'Ꝁ': 'K',
	    'Ꝅ': 'K',
	    'Ĺ': 'L',
	    'Ƚ': 'L',
	    'Ľ': 'L',
	    'Ļ': 'L',
	    'Ḽ': 'L',
	    'Ḷ': 'L',
	    'Ḹ': 'L',
	    'Ⱡ': 'L',
	    'Ꝉ': 'L',
	    'Ḻ': 'L',
	    'Ŀ': 'L',
	    'Ɫ': 'L',
	    'ǈ': 'L',
	    'Ł': 'L',
	    'Ǉ': 'LJ',
	    'Ḿ': 'M',
	    'Ṁ': 'M',
	    'Ṃ': 'M',
	    'Ɱ': 'M',
	    'Ń': 'N',
	    'Ň': 'N',
	    'Ņ': 'N',
	    'Ṋ': 'N',
	    'Ṅ': 'N',
	    'Ṇ': 'N',
	    'Ǹ': 'N',
	    'Ɲ': 'N',
	    'Ṉ': 'N',
	    'Ƞ': 'N',
	    'ǋ': 'N',
	    'Ñ': 'N',
	    'Ǌ': 'NJ',
	    'Ó': 'O',
	    'Ŏ': 'O',
	    'Ǒ': 'O',
	    'Ô': 'O',
	    'Ố': 'O',
	    'Ộ': 'O',
	    'Ồ': 'O',
	    'Ổ': 'O',
	    'Ỗ': 'O',
	    'Ö': 'O',
	    'Ȫ': 'O',
	    'Ȯ': 'O',
	    'Ȱ': 'O',
	    'Ọ': 'O',
	    'Ő': 'O',
	    'Ȍ': 'O',
	    'Ò': 'O',
	    'Ỏ': 'O',
	    'Ơ': 'O',
	    'Ớ': 'O',
	    'Ợ': 'O',
	    'Ờ': 'O',
	    'Ở': 'O',
	    'Ỡ': 'O',
	    'Ȏ': 'O',
	    'Ꝋ': 'O',
	    'Ꝍ': 'O',
	    'Ō': 'O',
	    'Ṓ': 'O',
	    'Ṑ': 'O',
	    'Ɵ': 'O',
	    'Ǫ': 'O',
	    'Ǭ': 'O',
	    'Ø': 'O',
	    'Ǿ': 'O',
	    'Õ': 'O',
	    'Ṍ': 'O',
	    'Ṏ': 'O',
	    'Ȭ': 'O',
	    'Ƣ': 'OI',
	    'Ꝏ': 'OO',
	    'Ɛ': 'E',
	    'Ɔ': 'O',
	    'Ȣ': 'OU',
	    'Ṕ': 'P',
	    'Ṗ': 'P',
	    'Ꝓ': 'P',
	    'Ƥ': 'P',
	    'Ꝕ': 'P',
	    'Ᵽ': 'P',
	    'Ꝑ': 'P',
	    'Ꝙ': 'Q',
	    'Ꝗ': 'Q',
	    'Ŕ': 'R',
	    'Ř': 'R',
	    'Ŗ': 'R',
	    'Ṙ': 'R',
	    'Ṛ': 'R',
	    'Ṝ': 'R',
	    'Ȑ': 'R',
	    'Ȓ': 'R',
	    'Ṟ': 'R',
	    'Ɍ': 'R',
	    'Ɽ': 'R',
	    'Ꜿ': 'C',
	    'Ǝ': 'E',
	    'Ś': 'S',
	    'Ṥ': 'S',
	    'Š': 'S',
	    'Ṧ': 'S',
	    'Ş': 'S',
	    'Ŝ': 'S',
	    'Ș': 'S',
	    'Ṡ': 'S',
	    'Ṣ': 'S',
	    'Ṩ': 'S',
	    'Ť': 'T',
	    'Ţ': 'T',
	    'Ṱ': 'T',
	    'Ț': 'T',
	    'Ⱦ': 'T',
	    'Ṫ': 'T',
	    'Ṭ': 'T',
	    'Ƭ': 'T',
	    'Ṯ': 'T',
	    'Ʈ': 'T',
	    'Ŧ': 'T',
	    'Ɐ': 'A',
	    'Ꞁ': 'L',
	    'Ɯ': 'M',
	    'Ʌ': 'V',
	    'Ꜩ': 'TZ',
	    'Ú': 'U',
	    'Ŭ': 'U',
	    'Ǔ': 'U',
	    'Û': 'U',
	    'Ṷ': 'U',
	    'Ü': 'U',
	    'Ǘ': 'U',
	    'Ǚ': 'U',
	    'Ǜ': 'U',
	    'Ǖ': 'U',
	    'Ṳ': 'U',
	    'Ụ': 'U',
	    'Ű': 'U',
	    'Ȕ': 'U',
	    'Ù': 'U',
	    'Ủ': 'U',
	    'Ư': 'U',
	    'Ứ': 'U',
	    'Ự': 'U',
	    'Ừ': 'U',
	    'Ử': 'U',
	    'Ữ': 'U',
	    'Ȗ': 'U',
	    'Ū': 'U',
	    'Ṻ': 'U',
	    'Ų': 'U',
	    'Ů': 'U',
	    'Ũ': 'U',
	    'Ṹ': 'U',
	    'Ṵ': 'U',
	    'Ꝟ': 'V',
	    'Ṿ': 'V',
	    'Ʋ': 'V',
	    'Ṽ': 'V',
	    'Ꝡ': 'VY',
	    'Ẃ': 'W',
	    'Ŵ': 'W',
	    'Ẅ': 'W',
	    'Ẇ': 'W',
	    'Ẉ': 'W',
	    'Ẁ': 'W',
	    'Ⱳ': 'W',
	    'Ẍ': 'X',
	    'Ẋ': 'X',
	    'Ý': 'Y',
	    'Ŷ': 'Y',
	    'Ÿ': 'Y',
	    'Ẏ': 'Y',
	    'Ỵ': 'Y',
	    'Ỳ': 'Y',
	    'Ƴ': 'Y',
	    'Ỷ': 'Y',
	    'Ỿ': 'Y',
	    'Ȳ': 'Y',
	    'Ɏ': 'Y',
	    'Ỹ': 'Y',
	    'Ź': 'Z',
	    'Ž': 'Z',
	    'Ẑ': 'Z',
	    'Ⱬ': 'Z',
	    'Ż': 'Z',
	    'Ẓ': 'Z',
	    'Ȥ': 'Z',
	    'Ẕ': 'Z',
	    'Ƶ': 'Z',
	    'Ĳ': 'IJ',
	    'Œ': 'OE',
	    'ᴀ': 'A',
	    'ᴁ': 'AE',
	    'ʙ': 'B',
	    'ᴃ': 'B',
	    'ᴄ': 'C',
	    'ᴅ': 'D',
	    'ᴇ': 'E',
	    'ꜰ': 'F',
	    'ɢ': 'G',
	    'ʛ': 'G',
	    'ʜ': 'H',
	    'ɪ': 'I',
	    'ʁ': 'R',
	    'ᴊ': 'J',
	    'ᴋ': 'K',
	    'ʟ': 'L',
	    'ᴌ': 'L',
	    'ᴍ': 'M',
	    'ɴ': 'N',
	    'ᴏ': 'O',
	    'ɶ': 'OE',
	    'ᴐ': 'O',
	    'ᴕ': 'OU',
	    'ᴘ': 'P',
	    'ʀ': 'R',
	    'ᴎ': 'N',
	    'ᴙ': 'R',
	    'ꜱ': 'S',
	    'ᴛ': 'T',
	    'ⱻ': 'E',
	    'ᴚ': 'R',
	    'ᴜ': 'U',
	    'ᴠ': 'V',
	    'ᴡ': 'W',
	    'ʏ': 'Y',
	    'ᴢ': 'Z',
	    'á': 'a',
	    'ă': 'a',
	    'ắ': 'a',
	    'ặ': 'a',
	    'ằ': 'a',
	    'ẳ': 'a',
	    'ẵ': 'a',
	    'ǎ': 'a',
	    'â': 'a',
	    'ấ': 'a',
	    'ậ': 'a',
	    'ầ': 'a',
	    'ẩ': 'a',
	    'ẫ': 'a',
	    'ä': 'a',
	    'ǟ': 'a',
	    'ȧ': 'a',
	    'ǡ': 'a',
	    'ạ': 'a',
	    'ȁ': 'a',
	    'à': 'a',
	    'ả': 'a',
	    'ȃ': 'a',
	    'ā': 'a',
	    'ą': 'a',
	    'ᶏ': 'a',
	    'ẚ': 'a',
	    'å': 'a',
	    'ǻ': 'a',
	    'ḁ': 'a',
	    'ⱥ': 'a',
	    'ã': 'a',
	    'ꜳ': 'aa',
	    'æ': 'ae',
	    'ǽ': 'ae',
	    'ǣ': 'ae',
	    'ꜵ': 'ao',
	    'ꜷ': 'au',
	    'ꜹ': 'av',
	    'ꜻ': 'av',
	    'ꜽ': 'ay',
	    'ḃ': 'b',
	    'ḅ': 'b',
	    'ɓ': 'b',
	    'ḇ': 'b',
	    'ᵬ': 'b',
	    'ᶀ': 'b',
	    'ƀ': 'b',
	    'ƃ': 'b',
	    'ɵ': 'o',
	    'ć': 'c',
	    'č': 'c',
	    'ç': 'c',
	    'ḉ': 'c',
	    'ĉ': 'c',
	    'ɕ': 'c',
	    'ċ': 'c',
	    'ƈ': 'c',
	    'ȼ': 'c',
	    'ď': 'd',
	    'ḑ': 'd',
	    'ḓ': 'd',
	    'ȡ': 'd',
	    'ḋ': 'd',
	    'ḍ': 'd',
	    'ɗ': 'd',
	    'ᶑ': 'd',
	    'ḏ': 'd',
	    'ᵭ': 'd',
	    'ᶁ': 'd',
	    'đ': 'd',
	    'ɖ': 'd',
	    'ƌ': 'd',
	    'ı': 'i',
	    'ȷ': 'j',
	    'ɟ': 'j',
	    'ʄ': 'j',
	    'ǳ': 'dz',
	    'ǆ': 'dz',
	    'é': 'e',
	    'ĕ': 'e',
	    'ě': 'e',
	    'ȩ': 'e',
	    'ḝ': 'e',
	    'ê': 'e',
	    'ế': 'e',
	    'ệ': 'e',
	    'ề': 'e',
	    'ể': 'e',
	    'ễ': 'e',
	    'ḙ': 'e',
	    'ë': 'e',
	    'ė': 'e',
	    'ẹ': 'e',
	    'ȅ': 'e',
	    'è': 'e',
	    'ẻ': 'e',
	    'ȇ': 'e',
	    'ē': 'e',
	    'ḗ': 'e',
	    'ḕ': 'e',
	    'ⱸ': 'e',
	    'ę': 'e',
	    'ᶒ': 'e',
	    'ɇ': 'e',
	    'ẽ': 'e',
	    'ḛ': 'e',
	    'ꝫ': 'et',
	    'ḟ': 'f',
	    'ƒ': 'f',
	    'ᵮ': 'f',
	    'ᶂ': 'f',
	    'ǵ': 'g',
	    'ğ': 'g',
	    'ǧ': 'g',
	    'ģ': 'g',
	    'ĝ': 'g',
	    'ġ': 'g',
	    'ɠ': 'g',
	    'ḡ': 'g',
	    'ᶃ': 'g',
	    'ǥ': 'g',
	    'ḫ': 'h',
	    'ȟ': 'h',
	    'ḩ': 'h',
	    'ĥ': 'h',
	    'ⱨ': 'h',
	    'ḧ': 'h',
	    'ḣ': 'h',
	    'ḥ': 'h',
	    'ɦ': 'h',
	    'ẖ': 'h',
	    'ħ': 'h',
	    'ƕ': 'hv',
	    'í': 'i',
	    'ĭ': 'i',
	    'ǐ': 'i',
	    'î': 'i',
	    'ï': 'i',
	    'ḯ': 'i',
	    'ị': 'i',
	    'ȉ': 'i',
	    'ì': 'i',
	    'ỉ': 'i',
	    'ȋ': 'i',
	    'ī': 'i',
	    'į': 'i',
	    'ᶖ': 'i',
	    'ɨ': 'i',
	    'ĩ': 'i',
	    'ḭ': 'i',
	    'ꝺ': 'd',
	    'ꝼ': 'f',
	    'ᵹ': 'g',
	    'ꞃ': 'r',
	    'ꞅ': 's',
	    'ꞇ': 't',
	    'ꝭ': 'is',
	    'ǰ': 'j',
	    'ĵ': 'j',
	    'ʝ': 'j',
	    'ɉ': 'j',
	    'ḱ': 'k',
	    'ǩ': 'k',
	    'ķ': 'k',
	    'ⱪ': 'k',
	    'ꝃ': 'k',
	    'ḳ': 'k',
	    'ƙ': 'k',
	    'ḵ': 'k',
	    'ᶄ': 'k',
	    'ꝁ': 'k',
	    'ꝅ': 'k',
	    'ĺ': 'l',
	    'ƚ': 'l',
	    'ɬ': 'l',
	    'ľ': 'l',
	    'ļ': 'l',
	    'ḽ': 'l',
	    'ȴ': 'l',
	    'ḷ': 'l',
	    'ḹ': 'l',
	    'ⱡ': 'l',
	    'ꝉ': 'l',
	    'ḻ': 'l',
	    'ŀ': 'l',
	    'ɫ': 'l',
	    'ᶅ': 'l',
	    'ɭ': 'l',
	    'ł': 'l',
	    'ǉ': 'lj',
	    'ſ': 's',
	    'ẜ': 's',
	    'ẛ': 's',
	    'ẝ': 's',
	    'ḿ': 'm',
	    'ṁ': 'm',
	    'ṃ': 'm',
	    'ɱ': 'm',
	    'ᵯ': 'm',
	    'ᶆ': 'm',
	    'ń': 'n',
	    'ň': 'n',
	    'ņ': 'n',
	    'ṋ': 'n',
	    'ȵ': 'n',
	    'ṅ': 'n',
	    'ṇ': 'n',
	    'ǹ': 'n',
	    'ɲ': 'n',
	    'ṉ': 'n',
	    'ƞ': 'n',
	    'ᵰ': 'n',
	    'ᶇ': 'n',
	    'ɳ': 'n',
	    'ñ': 'n',
	    'ǌ': 'nj',
	    'ó': 'o',
	    'ŏ': 'o',
	    'ǒ': 'o',
	    'ô': 'o',
	    'ố': 'o',
	    'ộ': 'o',
	    'ồ': 'o',
	    'ổ': 'o',
	    'ỗ': 'o',
	    'ö': 'o',
	    'ȫ': 'o',
	    'ȯ': 'o',
	    'ȱ': 'o',
	    'ọ': 'o',
	    'ő': 'o',
	    'ȍ': 'o',
	    'ò': 'o',
	    'ỏ': 'o',
	    'ơ': 'o',
	    'ớ': 'o',
	    'ợ': 'o',
	    'ờ': 'o',
	    'ở': 'o',
	    'ỡ': 'o',
	    'ȏ': 'o',
	    'ꝋ': 'o',
	    'ꝍ': 'o',
	    'ⱺ': 'o',
	    'ō': 'o',
	    'ṓ': 'o',
	    'ṑ': 'o',
	    'ǫ': 'o',
	    'ǭ': 'o',
	    'ø': 'o',
	    'ǿ': 'o',
	    'õ': 'o',
	    'ṍ': 'o',
	    'ṏ': 'o',
	    'ȭ': 'o',
	    'ƣ': 'oi',
	    'ꝏ': 'oo',
	    'ɛ': 'e',
	    'ᶓ': 'e',
	    'ɔ': 'o',
	    'ᶗ': 'o',
	    'ȣ': 'ou',
	    'ṕ': 'p',
	    'ṗ': 'p',
	    'ꝓ': 'p',
	    'ƥ': 'p',
	    'ᵱ': 'p',
	    'ᶈ': 'p',
	    'ꝕ': 'p',
	    'ᵽ': 'p',
	    'ꝑ': 'p',
	    'ꝙ': 'q',
	    'ʠ': 'q',
	    'ɋ': 'q',
	    'ꝗ': 'q',
	    'ŕ': 'r',
	    'ř': 'r',
	    'ŗ': 'r',
	    'ṙ': 'r',
	    'ṛ': 'r',
	    'ṝ': 'r',
	    'ȑ': 'r',
	    'ɾ': 'r',
	    'ᵳ': 'r',
	    'ȓ': 'r',
	    'ṟ': 'r',
	    'ɼ': 'r',
	    'ᵲ': 'r',
	    'ᶉ': 'r',
	    'ɍ': 'r',
	    'ɽ': 'r',
	    'ↄ': 'c',
	    'ꜿ': 'c',
	    'ɘ': 'e',
	    'ɿ': 'r',
	    'ś': 's',
	    'ṥ': 's',
	    'š': 's',
	    'ṧ': 's',
	    'ş': 's',
	    'ŝ': 's',
	    'ș': 's',
	    'ṡ': 's',
	    'ṣ': 's',
	    'ṩ': 's',
	    'ʂ': 's',
	    'ᵴ': 's',
	    'ᶊ': 's',
	    'ȿ': 's',
	    'ɡ': 'g',
	    'ᴑ': 'o',
	    'ᴓ': 'o',
	    'ᴝ': 'u',
	    'ť': 't',
	    'ţ': 't',
	    'ṱ': 't',
	    'ț': 't',
	    'ȶ': 't',
	    'ẗ': 't',
	    'ⱦ': 't',
	    'ṫ': 't',
	    'ṭ': 't',
	    'ƭ': 't',
	    'ṯ': 't',
	    'ᵵ': 't',
	    'ƫ': 't',
	    'ʈ': 't',
	    'ŧ': 't',
	    'ᵺ': 'th',
	    'ɐ': 'a',
	    'ᴂ': 'ae',
	    'ǝ': 'e',
	    'ᵷ': 'g',
	    'ɥ': 'h',
	    'ʮ': 'h',
	    'ʯ': 'h',
	    'ᴉ': 'i',
	    'ʞ': 'k',
	    'ꞁ': 'l',
	    'ɯ': 'm',
	    'ɰ': 'm',
	    'ᴔ': 'oe',
	    'ɹ': 'r',
	    'ɻ': 'r',
	    'ɺ': 'r',
	    'ⱹ': 'r',
	    'ʇ': 't',
	    'ʌ': 'v',
	    'ʍ': 'w',
	    'ʎ': 'y',
	    'ꜩ': 'tz',
	    'ú': 'u',
	    'ŭ': 'u',
	    'ǔ': 'u',
	    'û': 'u',
	    'ṷ': 'u',
	    'ü': 'u',
	    'ǘ': 'u',
	    'ǚ': 'u',
	    'ǜ': 'u',
	    'ǖ': 'u',
	    'ṳ': 'u',
	    'ụ': 'u',
	    'ű': 'u',
	    'ȕ': 'u',
	    'ù': 'u',
	    'ủ': 'u',
	    'ư': 'u',
	    'ứ': 'u',
	    'ự': 'u',
	    'ừ': 'u',
	    'ử': 'u',
	    'ữ': 'u',
	    'ȗ': 'u',
	    'ū': 'u',
	    'ṻ': 'u',
	    'ų': 'u',
	    'ᶙ': 'u',
	    'ů': 'u',
	    'ũ': 'u',
	    'ṹ': 'u',
	    'ṵ': 'u',
	    'ᵫ': 'ue',
	    'ꝸ': 'um',
	    'ⱴ': 'v',
	    'ꝟ': 'v',
	    'ṿ': 'v',
	    'ʋ': 'v',
	    'ᶌ': 'v',
	    'ⱱ': 'v',
	    'ṽ': 'v',
	    'ꝡ': 'vy',
	    'ẃ': 'w',
	    'ŵ': 'w',
	    'ẅ': 'w',
	    'ẇ': 'w',
	    'ẉ': 'w',
	    'ẁ': 'w',
	    'ⱳ': 'w',
	    'ẘ': 'w',
	    'ẍ': 'x',
	    'ẋ': 'x',
	    'ᶍ': 'x',
	    'ý': 'y',
	    'ŷ': 'y',
	    'ÿ': 'y',
	    'ẏ': 'y',
	    'ỵ': 'y',
	    'ỳ': 'y',
	    'ƴ': 'y',
	    'ỷ': 'y',
	    'ỿ': 'y',
	    'ȳ': 'y',
	    'ẙ': 'y',
	    'ɏ': 'y',
	    'ỹ': 'y',
	    'ź': 'z',
	    'ž': 'z',
	    'ẑ': 'z',
	    'ʑ': 'z',
	    'ⱬ': 'z',
	    'ż': 'z',
	    'ẓ': 'z',
	    'ȥ': 'z',
	    'ẕ': 'z',
	    'ᵶ': 'z',
	    'ᶎ': 'z',
	    'ʐ': 'z',
	    'ƶ': 'z',
	    'ɀ': 'z',
	    'ﬀ': 'ff',
	    'ﬃ': 'ffi',
	    'ﬄ': 'ffl',
	    'ﬁ': 'fi',
	    'ﬂ': 'fl',
	    'ĳ': 'ij',
	    'œ': 'oe',
	    'ﬆ': 'st',
	    'ₐ': 'a',
	    'ₑ': 'e',
	    'ᵢ': 'i',
	    'ⱼ': 'j',
	    'ₒ': 'o',
	    'ᵣ': 'r',
	    'ᵤ': 'u',
	    'ᵥ': 'v',
	    'ₓ': 'x'
	};


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(130);
	var typeahead_utils_1 = __webpack_require__(840);
	var typeahead_options_class_1 = __webpack_require__(843);
	var position_1 = __webpack_require__(697);
	var ng2_bootstrap_config_1 = __webpack_require__(694);
	var TEMPLATE = (_a = {},
	    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4] = "\n  <div class=\"dropdown-menu\"\n       style=\"display: block\"\n      [ngStyle]=\"{top: top, left: left, display: display}\"\n      (mouseleave)=\"focusLost()\">\n      <a href=\"#\"\n         *ngFor=\"let match of matches\"\n         class=\"dropdown-item\"\n         (click)=\"selectMatch(match, $event)\"\n         (mouseenter)=\"selectActive(match)\"\n         [class.active]=\"isActive(match)\"\n         [innerHtml]=\"hightlight(match, query)\"></a>\n  </div>\n  ",
	    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS3] = "\n  <ul class=\"dropdown-menu\"\n      style=\"display: block\"\n      [ngStyle]=\"{top: top, left: left, display: display}\"\n      (mouseleave)=\"focusLost()\">\n    <li *ngFor=\"let match of matches\"\n        [class.active]=\"isActive(match)\"\n        (mouseenter)=\"selectActive(match)\">\n        <a href=\"#\" (click)=\"selectMatch(match, $event)\" tabindex=\"-1\" [innerHtml]=\"hightlight(match, query)\"></a>\n    </li>\n  </ul>\n  ",
	    _a
	);
	var TypeaheadContainerComponent = (function () {
	    function TypeaheadContainerComponent(element, options) {
	        this.isFocused = false;
	        this._matches = [];
	        this.element = element;
	        Object.assign(this, options);
	    }
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "matches", {
	        get: function () {
	            return this._matches;
	        },
	        set: function (value) {
	            this._matches = value;
	            if (this._matches.length > 0) {
	                this._active = this._matches[0];
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "field", {
	        set: function (value) {
	            this._field = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TypeaheadContainerComponent.prototype.position = function (hostEl) {
	        this.display = 'block';
	        this.top = '0px';
	        this.left = '0px';
	        var p = position_1.positionService
	            .positionElements(hostEl.nativeElement, this.element.nativeElement.children[0], this.placement, false);
	        this.top = p.top + 'px';
	        this.left = p.left + 'px';
	    };
	    TypeaheadContainerComponent.prototype.selectActiveMatch = function () {
	        this.selectMatch(this._active);
	    };
	    TypeaheadContainerComponent.prototype.prevActiveMatch = function () {
	        var index = this.matches.indexOf(this._active);
	        this._active = this.matches[index - 1 < 0
	            ? this.matches.length - 1
	            : index - 1];
	    };
	    TypeaheadContainerComponent.prototype.nextActiveMatch = function () {
	        var index = this.matches.indexOf(this._active);
	        this._active = this.matches[index + 1 > this.matches.length - 1
	            ? 0
	            : index + 1];
	    };
	    TypeaheadContainerComponent.prototype.selectActive = function (value) {
	        this.isFocused = true;
	        this._active = value;
	    };
	    TypeaheadContainerComponent.prototype.hightlight = function (item, query) {
	        var itemStr = (typeof item === 'object' && this._field
	            ? item[this._field]
	            : item).toString();
	        var itemStrHelper = (this.parent.typeaheadLatinize
	            ? typeahead_utils_1.TypeaheadUtils.latinize(itemStr)
	            : itemStr).toLowerCase();
	        var startIdx;
	        var tokenLen;
	        // Replaces the capture string with the same string inside of a "strong" tag
	        if (typeof query === 'object') {
	            var queryLen = query.length;
	            for (var i = 0; i < queryLen; i += 1) {
	                // query[i] is already latinized and lower case
	                startIdx = itemStrHelper.indexOf(query[i]);
	                tokenLen = query[i].length;
	                if (startIdx >= 0 && tokenLen > 0) {
	                    itemStr = itemStr.substring(0, startIdx) + '<strong>' + itemStr.substring(startIdx, startIdx + tokenLen) + '</strong>' + itemStr.substring(startIdx + tokenLen);
	                    itemStrHelper = itemStrHelper.substring(0, startIdx) + '        ' + ' '.repeat(tokenLen) + '         ' + itemStrHelper.substring(startIdx + tokenLen);
	                }
	            }
	        }
	        else if (query) {
	            // query is already latinized and lower case
	            startIdx = itemStrHelper.indexOf(query);
	            tokenLen = query.length;
	            if (startIdx >= 0 && tokenLen > 0) {
	                itemStr = itemStr.substring(0, startIdx) + '<strong>' + itemStr.substring(startIdx, startIdx + tokenLen) + '</strong>' + itemStr.substring(startIdx + tokenLen);
	            }
	        }
	        return itemStr;
	    };
	    TypeaheadContainerComponent.prototype.focusLost = function () {
	        this.isFocused = false;
	    };
	    TypeaheadContainerComponent.prototype.isActive = function (value) {
	        return this._active === value;
	    };
	    TypeaheadContainerComponent.prototype.selectMatch = function (value, e) {
	        var _this = this;
	        if (e === void 0) { e = void 0; }
	        if (e) {
	            e.stopPropagation();
	            e.preventDefault();
	        }
	        this.parent.changeModel(value);
	        setTimeout(function () {
	            return _this.parent.typeaheadOnSelect.emit({
	                item: value
	            });
	        }, 0);
	        return false;
	    };
	    TypeaheadContainerComponent = __decorate([
	        core_1.Component({
	            selector: 'typeahead-container',
	            directives: [common_1.CORE_DIRECTIVES],
	            template: TEMPLATE[ng2_bootstrap_config_1.Ng2BootstrapConfig.theme],
	            encapsulation: core_1.ViewEncapsulation.None
	        }), 
	        __metadata('design:paramtypes', [core_1.ElementRef, typeahead_options_class_1.TypeaheadOptions])
	    ], TypeaheadContainerComponent);
	    return TypeaheadContainerComponent;
	}());
	exports.TypeaheadContainerComponent = TypeaheadContainerComponent;
	var _a;


/***/ },
/* 843 */
/***/ function(module, exports) {

	"use strict";
	var TypeaheadOptions = (function () {
	    function TypeaheadOptions(options) {
	        Object.assign(this, options);
	    }
	    return TypeaheadOptions;
	}());
	exports.TypeaheadOptions = TypeaheadOptions;


/***/ },
/* 844 */
/***/ function(module, exports) {

	"use strict";
	var User = (function () {
	    function User(other) {
	        this.enabled = false;
	        if (other) {
	            this.id = other.id;
	            this.username = other.username;
	            this.name = other.name;
	            this.surname = other.surname;
	            this.email = other.email;
	            this.bank = other.bank;
	            this.rol = other.rol;
	            this.enabled = other.enabled;
	            this.cuit = other.cuit;
	            this.patent = other.patent;
	            this.client = other.client;
	        }
	    }
	    User.prototype.isAdmin = function () {
	        return (this.rol) ? this.rol.admin : false;
	    };
	    User.prototype.isClient = function () {
	        return (this.rol) ? this.rol.client : false;
	    };
	    User.prototype.isPatent = function () {
	        return this.patent;
	    };
	    User.prototype.isGaliciaBank = function () {
	        return this.bank.name === 'BANCO GALICIA';
	    };
	    User.prototype.canViewSection = function (appSection) {
	        if (this.isAdmin()) {
	            return true;
	        }
	        if (this.rol.permissions) {
	            var res = this.rol.permissions.filter(function (perm) { return perm.appSection.id === appSection; });
	            if (res.length > 0) {
	                return res[0].visible;
	            }
	        }
	        return false;
	    };
	    User.prototype.isActionAllowed = function (appSection, action, appSubSection) {
	        if (this.isAdmin()) {
	            return true;
	        }
	        if (this.rol.permissions) {
	            var res = this.rol.permissions.filter(function (perm) { return perm.appSection.id === appSection; });
	            if (res.length > 0 && res[0].actions.length > 0) {
	                var foundSection = res[0].actions.filter(function (act) { return act.action === action && act.appSection === appSubSection; });
	                if (foundSection.length > 0) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    return User;
	}());
	exports.User = User;


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var login_service_1 = __webpack_require__(404);
	var bank_service_1 = __webpack_require__(631);
	var BankSelectorComponent = (function () {
	    function BankSelectorComponent(router, loginService, bankService) {
	        this.router = router;
	        this.loginService = loginService;
	        this.bankService = bankService;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    BankSelectorComponent.prototype.init = function () {
	        this.getUser();
	    };
	    BankSelectorComponent.prototype.ngOnInit = function () {
	    };
	    BankSelectorComponent.prototype.getUser = function () {
	        var _this = this;
	        this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	            _this.user = userLogged;
	            _this.updateUserLogged();
	            _this.bankService.getBanksNoAuth().subscribe(_this.setBanks.bind(_this), function () {
	                _this.bindError('Ocurrió un error al obtener los bancos.');
	            });
	        }, function () {
	            //Do Nothing.
	        });
	    };
	    BankSelectorComponent.prototype.updateUserLogged = function () {
	        if (this.user.rol && this.user.rol.client && this.user.bank && this.user.bank.id) {
	            this.loggedUserBankId = this.user.bank.id.toString();
	        }
	    };
	    BankSelectorComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	    };
	    BankSelectorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    BankSelectorComponent.prototype.authenticateBank = function () {
	        if (this.modal) {
	            this.modal.hide();
	        }
	        if (this.selectedBank.id.toString() === this.loggedUserBankId && this.selectedBank.id.toString() != "") {
	            this.router.navigate(['app/home/client']);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], BankSelectorComponent.prototype, "modal", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], BankSelectorComponent.prototype, "close", void 0);
	    BankSelectorComponent = __decorate([
	        core_1.Component({
	            selector: 'bank-selector',
	            template: __webpack_require__(846)
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, login_service_1.LoginService, bank_service_1.BankService])
	    ], BankSelectorComponent);
	    return BankSelectorComponent;
	}());
	exports.BankSelectorComponent = BankSelectorComponent;


/***/ },
/* 846 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <form role=\"form\" (ngSubmit)=\"authenticateBank()\">\n        <h2>Elige el banco con el cual operar</h2>\n        <div>\n            <div>\n                <div class=\"form-group form-group-sm\">\n                    <label for=\"bankFilter\">Banco</label>\n                    <select class=\"form-control\" id=\"bankFilter\" [(ngModel)]=\"selectedBank\" name=\"selectedBank\">\n                        <option *ngFor=\"let selectedBank of banks\" [ngValue]=\"selectedBank\">{{selectedBank.name}}\n                        </option>\n                    </select>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group col-md-12\">\n            <div class=\"form-group form-group-sm\">\n                <div class=\"text-left\">\n                    <button type=\"submit\" class=\"btn btn-primary\" [disabled]=\"!selectedBank\">Confirmar</button>\n                </div>\n            </div>\n        </div>\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n    </form>\n</div>";

/***/ },
/* 847 */
/***/ function(module, exports) {

	module.exports = "<form role=\"form\" (ngSubmit)=\"showBankSelector()\" [formGroup]=\"form\">\n     <div class=\"form-group form-group-sm\">\n        <label for=\"name\"><input type=\"radio\" value=\"cuit\" name=\"type\" formControlName=\"type\" [(ngModel)]=\"typeLogin\" (change)=\"clearInputs()\"> CUIT</label>\n\t\t <div class=\"input-group\">\n             <!--<span class=\"input-group-addon\"><i class=\"fa fa-user\"></i></span>-->\n             <span class=\"input-group-addon user\"><img></span><!-- src=\"../../assets/icon/ie-icons/input-login-fa-user.png\"-->\n\t\t      <input type=\"text\" name=\"username\" [(ngModel)]=\"cuit\" formControlName=\"cuit\" placeholder=\"CUIT\"\n\t        \tclass=\"form-control\" [disabled]=\"typeLogin=='patent'\">\n\t\t  </div>\n     </div>\n     <div class=\"form-group form-group-sm\">\n         <label for=\"name\"><input type=\"radio\" value=\"patent\" name=\"type\" formControlName=\"type\" [(ngModel)]=\"typeLogin\" (change)=\"clearInputs()\"> Patente</label>\n         <div class=\"input-group\">\n             <!--<span class=\"input-group-addon\"><i class=\"fa fa-car\"></i></span>-->\n             <span class=\"input-group-addon car\"><img></span>\n\t\t      <input type=\"text\" type=\"text\" name=\"username\" [(ngModel)]=\"patent\" formControlName=\"patent\" placeholder=\"Patente\"\n\t        \tclass=\"form-control\" [disabled]=\"typeLogin=='cuit'\">\n\t\t  </div>\n     </div>\n     <div *ngIf=\"errorMessage\" class=\"alert alert-danger\">{{errorMessage}}</div>\n     <div class=\"form-group form-group-sm\">\n     \t<div class=\"text-center\">\n      \t<button type=\"submit\" class=\"btn btn-primary\" [disabled]=\"!form.valid\">Login</button>\n     \t</div>\n     </div>\n </form>\n<div bsModal #bankSelectorModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-md\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"bankSelectorModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Elegir Banco</h4>\n            </div>\n            <div class=\"modal-body\">\n                <div>\n                    <form role=\"form\" (ngSubmit)=\"authenticate()\">\n                        <h2>Elige el banco con el cual operar</h2>\n                        <div>\n                            <div>\n                                <div class=\"form-group form-group-sm\">\n                                    <label for=\"bankFilter\">Banco</label>\n                                    <select class=\"form-control\" id=\"bankFilter\" [(ngModel)]=\"selectedBank\" name=\"selectedBank\">\n                                        <option *ngFor=\"let selectedBank of banks\" [ngValue]=\"selectedBank\">{{selectedBank.name}}\n                                        </option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group col-md-12\">\n                            <div class=\"form-group form-group-sm\">\n                                <div class=\"text-left\">\n                                    <button type=\"submit\" class=\"btn btn-primary\" [disabled]=\"!selectedBank\">Confirmar</button>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 848 */
/***/ function(module, exports) {

	module.exports = ".acceso {\n\tfloat: left;\n\tcolor: #4D749C;\n\tfont-size: 16px;\n\tmargin-top: 5px;\n\theight: 30px;\n}\n\n.error {\n    color: red;\n    padding-top: 50px;\n}\n\nimg.login {\n\tmargin-top: 0px;\n\tmargin-bottom: 0px;\n}\n\ndiv.acceso p {\n\tmargin: 0 0 7px;\n}\n\ninput[type=\"password\"].login_input {\n\twidth: 100px;\n\tfont-size: 10px;\n\tborder: 1px solid #e4e2dc;\n\tbackground-color: #003871;\n\tcolor: #e4e2dc;\n\t-webkit-border-radius: 0;\n\tborder-radius: 0;\n\tbehavior: url(/PIE.htc);\n}\n\ninput[type=\"text\"].login_input {\n\twidth: 100px;\n\tfont-size: 10px;\n\tborder: 1px solid #e4e2dc;\n\tbackground-color: #003871;\n\tcolor: #e4e2dc;\n\t-webkit-border-radius: 0;\n\tborder-radius: 0px;\n\tbehavior: url(/PIE.htc);\n}\n\n.acceso_enviar{\n/* \tfloat:right; */\n\theight:18px;\n\tfont-size:14px;\n\tcolor:#4d749c;\n\tfont-weight: normal;\n\tborder:1px solid;\n\tbackground-color:#003871;\n\tmargin-top:5px;\n}\n\n#enviar_button{\n\theight:33px;\n\tmargin-top:5px;\n\tfont-size:20px;\n\tcolor:#003871;\n\tfont-weight: normal;\n\tfloat:right;\n\tborder:0;\n\tbackground-color:white;\n\tcursor:pointer;\n\ttext-decoration: none;\n}\n\n.modal-body {\n    padding-bottom: 60px;\n}"

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var forms_1 = __webpack_require__(643);
	var core_1 = __webpack_require__(1);
	exports.PATENT_VALIDATOR_AUTO_PATTERN = '^[A-Z]{3}[0-9]{3}$|^[A-Z]{2}[0-9]{3}[A-Z]{2}$';
	exports.PATENT_VALIDATOR_MOTO_PATTERN = '^[0-9]{3}[A-Z]{3}$|^[A-Z]{1}[0-9]{3}[A-Z]{3}$';
	exports.PATENT_VALIDATOR_AUTO = forms_1.Validators.pattern(exports.PATENT_VALIDATOR_AUTO_PATTERN);
	exports.PATENT_VALIDATOR_MOTO = forms_1.Validators.pattern(exports.PATENT_VALIDATOR_MOTO_PATTERN);
	exports.CUIT_VALIDATOR = forms_1.Validators.pattern('[0-9]{11}');
	exports.YEAR_VALIDATOR = forms_1.Validators.pattern('[0-9]{4}');
	exports.INTEGER_VALIDATOR = forms_1.Validators.pattern('[0-9]+');
	exports.AMOUNT_VALIDATOR = forms_1.Validators.pattern('[0-9]+(\.[0-9][0-9]?)?');
	exports.EMAIL_VALIDATOR = forms_1.Validators.pattern('^([_a-zA-Z0-9-]{2,4})([_a-zA-Z0-9-](.[_a-zA-Z0-9-]+))*@([a-zA-Z0-9-]{2,})+(.[a-zA-Z0-9-]+)*(.[a-zA-Z]{2,4})$');
	exports.DATE_VALIDATOR = forms_1.Validators.pattern('(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9]))|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96))');
	exports.DATE_VALID_CHARACTERS = forms_1.Validators.pattern('[0-9][0-9][\/][0-9][0-9][\/][0-9][0-9][0-9][0-9]');
	exports.DEFAULT_ERROR_MESSAGES = {
	    required: 'Campo requerido.',
	    invalidPattern: 'Formato inválido.',
	    groupEmailPattern: 'Formato inválido. Los emails se deben separarse con un espacio.',
	    invalidAmount: 'Formato inválido. No se permiten mas de dos decimales.',
	    invalidDate: 'Formato inválido. Utilice el siguiente patrón de fecha: dd/MM/yyyy',
	    requiredDate: 'Campo requerido para el rango de fechas.',
	    invalidCuit: 'Debe contener once (11) digitos.'
	};
	var AmountFormat = (function () {
	    function AmountFormat() {
	    }
	    AmountFormat.prototype.transform = function (value, currencySign, decimalLength, chunkDelimiter, decimalDelimiter, chunkLength) {
	        if (currencySign === void 0) { currencySign = '$'; }
	        if (decimalLength === void 0) { decimalLength = 2; }
	        if (chunkDelimiter === void 0) { chunkDelimiter = '.'; }
	        if (decimalDelimiter === void 0) { decimalDelimiter = ','; }
	        if (chunkLength === void 0) { chunkLength = 3; }
	        var result = '\\d(?=(\\d{' + chunkLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
	        if (value != null) {
	            var num = value.toFixed(Math.max(0, ~~decimalLength));
	            return currencySign + (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(result, 'g'), '$&' + chunkDelimiter);
	        }
	        return currencySign + '0' + decimalDelimiter + '00'; //NULL -> $0,00
	    };
	    AmountFormat = __decorate([
	        core_1.Pipe({
	            name: 'amountFormat'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AmountFormat);
	    return AmountFormat;
	}());
	exports.AmountFormat = AmountFormat;
	var KmFormat = (function () {
	    function KmFormat() {
	    }
	    KmFormat.prototype.transform = function (value, decimalLength, chunkDelimiter, decimalDelimiter, chunkLength) {
	        if (decimalLength === void 0) { decimalLength = 0; }
	        if (chunkDelimiter === void 0) { chunkDelimiter = '.'; }
	        if (decimalDelimiter === void 0) { decimalDelimiter = ','; }
	        if (chunkLength === void 0) { chunkLength = 3; }
	        var result = '\\d(?=(\\d{' + chunkLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
	        if (value != null) {
	            var num = value.toFixed(Math.max(0, ~~decimalLength));
	            return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(result, 'g'), '$&' + chunkDelimiter) + ' km.';
	        }
	        return 'SIN KM CARGADOS';
	    };
	    KmFormat = __decorate([
	        core_1.Pipe({
	            name: 'kmFormat'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], KmFormat);
	    return KmFormat;
	}());
	exports.KmFormat = KmFormat;
	var IsExpirated = (function () {
	    function IsExpirated() {
	    }
	    IsExpirated.prototype.transform = function (value, date) {
	        if (value) {
	            return 'RESUELTO';
	        }
	        var todayDate = new Date(Date.parse(Date()));
	        var expiratedDateStr;
	        var expiratedDate;
	        if (date !== undefined && date !== null) {
	            if (date.includes('/')) {
	                expiratedDateStr = date.split('/');
	                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
	            }
	            else if (date.includes('-')) {
	                expiratedDateStr = date.split('-');
	                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
	            }
	        }
	        return expiratedDate > todayDate ? 'A VENCER' : 'VENCIDO';
	    };
	    IsExpirated = __decorate([
	        core_1.Pipe({
	            name: 'isExpirated'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], IsExpirated);
	    return IsExpirated;
	}());
	exports.IsExpirated = IsExpirated;
	exports.VALID_MIME_TYPES = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	    'image/jpeg', 'image/gif', 'image/png', 'image/bmp', 'image/x-windows-bmp', 'application/msword', 'application/pdf',
	    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/zip',
	    'application/x-rar-compressed', 'application/octet-stream'];
	exports.FILE_MAX_SIZE = 10485760; //10 MB


/***/ },
/* 850 */
/***/ function(module, exports) {

	"use strict";
	var ContactInfo = (function () {
	    function ContactInfo(other) {
	        this.comments = '';
	        if (other) {
	            this.name = other.name;
	            this.surname = other.surname;
	            this.phone = other.phone;
	            this.email = other.email;
	            this.comments = other.comments;
	        }
	    }
	    return ContactInfo;
	}());
	exports.ContactInfo = ContactInfo;


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"container\">\n    <div id=\"header\">\n        <div id=\"logo\">\n            <img src=\"" + __webpack_require__(852) + "\" alt=\"Servileasing\">\n        </div>\n    </div>\n\n    <div id=\"body\">\n        <div class=\"row espacio\">\n            <div class=\"col-md-2 col-xs-2 bs-docs-sidebar\">\n                <div id=\"nav-menu\">\n                    <ul class=\"nav nav-list bs-docs-sidenav affix\">\n                        <li id=\"comienzo_menu\"></li>\n                        <li [ngClass]=\"{'active': itemMenuSelected == 'home'}\">\n                            <a href=\"javascript:void(0);\" (click)=\"itemMenuSelected = 'home'\">HOME</a>\n                        </li>\n                        <li [ngClass]=\"{'active': itemMenuSelected == 'howWork'}\">\n                            <img src=\"" + __webpack_require__(853) + "\" alt=\"-\">\n                            <a href=\"javascript:void(0);\" (click)=\"itemMenuSelected = 'howWork'\">C&Oacute;MO\n                                TRABAJAMOS</a>\n                        </li>\n                        <li [ngClass]=\"{'active': itemMenuSelected == 'services'}\">\n                            <img src=\"" + __webpack_require__(853) + "\" alt=\"-\">\n                            <a href=\"javascript:void(0);\" (click)=\"itemMenuSelected = 'services'\">SERVICIOS</a>\n                        </li>\n                        <li [ngClass]=\"{'active': itemMenuSelected == 'clients'}\">\n                            <img src=\"" + __webpack_require__(853) + "\" alt=\"-\">\n                            <a href=\"javascript:void(0);\" (click)=\"itemMenuSelected = 'clients'\">CLIENTES</a>\n                        </li>\n                        <li [ngClass]=\"{'active': itemMenuSelected == 'contact'}\">\n                            <img src=\"" + __webpack_require__(853) + "\" alt=\"-\">\n                            <a href=\"javascript:void(0);\" (click)=\"itemMenuSelected = 'contact'\">CONTACTO</a>\n                        </li>\n                        <li [ngClass]=\"{'active': itemMenuSelected == 'operators'}\">\n                            <img src=\"" + __webpack_require__(853) + "\" alt=\"-\">\n                            <a href=\"javascript:void(0);\" (click)=\"loginOperators.show()\">OPERADORES</a>\n                        </li>\n                        <li id=\"fin_menu\"></li>\n                    </ul>\n                </div>\n            </div>\n            <div id=\"canvas\" class=\"col-md-8 col-xs-8 col-md-offset-4 col-xs-offset-4 not_overflow\">\n                <div class=\"texto\" *ngIf=\"itemMenuSelected == 'home'\">\n                    <div class=\"row\">\n                        <div class=\"col-md-8\">\n                            <p>\n                                <b>Servileasing S.A</b> presta servicios con un profundo nivel de compromiso y de alta\n                                calidad en las &aacute;reas de consultor&iacute;a, administraci&oacute;n y gesti&oacute;n.\n                            </p>\n                            <p>\n                                Constituida por un grupo de profesionales altamente calificados, dedicados al desarrollo\n                                de las actividades vinculadas al campo de Leasing, nuestro objetivo es optimizar costos\n                                y reducir los tiempos.\n                                Proponemos una soluci&oacute;n hecha a medida bajo un sistema de calidad superior. Las\n                                distintas &aacute;reas de la empresa proveen de soluciones concretas, pr&aacute;cticas y\n                                resolutorias que dan respuesta a las demandas de nuestros clientes.\n                            </p>\n                            <p>\n                                Adaptamos nuestra propuesta a las necesidades espec&iacute;ficas de su operaci&oacute;n.\n                            </p>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"text-center\"><strong>Acceso Clientes</strong></div>\n                            <div class=\"panel panel-default\">\n                                <div class=\"panel-body\">\n                                    <client-loggin></client-loggin>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"texto\" *ngIf=\"itemMenuSelected == 'howWork'\">\n                    <p>\n                        Brindamos una variedad de servicios bajo un estricto control, ofreciendo un completo paquete log&iacute;stico\n                        manejado por profesionales. Maximizamos en cada proceso la utilizaci&oacute;n del intangible m&aacute;s\n                        importante: el tiempo.\n                    </p>\n                    <p>\n                        Asumimos el compromiso en la ejecuci&oacute;n y el seguimiento de toda la operatoria brindando\n                        soluciones puerta a puerta. Para ello contamos con experiencia, un amplio know-how, innovaci&oacute;n,\n                        eficiencia en el cumplimiento de nuestra labor y t&eacute;cnicos capacitados para ejecutar cada\n                        operaci&oacute;n.\n                    </p>\n                </div>\n                <div class=\"texto\" *ngIf=\"itemMenuSelected == 'services'\">\n                    <p></p>\n                    <h3>Gestiones administrativas para nuestros clientes</h3>\n                    <p></p>\n                    <p>\n                        <b>Servicio de Gestor&iacute;a</b>\n                    </p>\n                    <p>\n                        Contamos con mandatarios matriculados id&oacute;neos en el manejo de todo el &aacute;mbito\n                        registral. Nuestras oficinas centrales est&aacute;n ubicadas en el centro de la ciudad de Buenos\n                        Aires, permiti&eacute;ndonos la cercan&iacute;a con los principales puntos de contacto\n                        del &aacute;mbito de nuestra actividad.\n                    </p>\n                    <p>\n                        <b>Servicio de gestor&iacute;a en el interior del pa&iacute;s</b>\n                    </p>\n                    <p>\n                        Contamos con una red de gestores en el interior del pa&iacute;s para satisfacer las necesidades\n                        de nuestros clientes.\n                    </p>\n                    <p>\n                        <b>Informe de Antecedentes Personales</b>\n                    </p>\n                    <p>\n                        Realizamos el pedido de informe nominal obtenemos los resultados en el mismo d&iacute;a.\n                    </p>\n                    <p></p>\n                    <h3>Servicio web de gesti&oacute;n en la opci&oacute;n de compra</h3>\n                    <p></p>\n                    <p>\n                        <b>Gesti&oacute;n y contacto con el cliente.</b>\n                    </p>\n                    <p>\n                        Notificaci&oacute;n a los tomadores de leasing v&iacute;a mail y/o tel&eacute;fono adjuntando\n                        los archivos pertinentes y explicando procedimientos registrales para continuar el tr&aacute;mite.\n                    </p>\n                    <p>\n                        Seguimiento personalizado de cada caso. (Cada legajo tendr&aacute; un archivo electr&oacute;nico\n                        donde se guardar&aacute;n mails, seguimiento y observaciones).\n                    </p>\n                    <p>\n                        En caso de no tener respuesta cumplidos los cuarenta y cinco d&iacute;as Servileasing S.A.\n                        enviar&aacute; la conveniente Carta Documento haciendo pedido de la documentaci&oacute;n.\n                    </p>\n                    <p>\n                        Env&iacute;o a los oficiales de cuenta correspondientes el informe de expedici&oacute;n de Carta\n                        Documento con vencimientos e instructivos.\n                    </p>\n                    <p>\n                        Al recibir la documentaci&oacute;n t&eacute;cnica registral, Servileasing S.A. controlar&aacute;\n                        que est&eacute; correctamente integrada. En caso de que la documentaci&oacute;n se encuentre\n                        incompleta o mal confeccionada, se dar&aacute; aviso de esta situaci&oacute;n v&iacute;a correo\n                        electr&oacute;nico y/o telef&oacute;nica al tomador, y a la entidad financiera.\n                    </p>\n                    <p>\n                        Una vez recibida la totalidad de la documentaci&oacute;n demandada al cliente, Servileasing S.A.\n                        notificar&aacute; a la entidad financiera para que se efect&uacute;e el d&eacute;bito de la opci&oacute;n\n                        de compra en la cuenta del tomador.\n                    </p>\n                    <p>\n                        El seguimiento se podr&aacute; efectuar con una clave de acceso desde la web de Servileasing\n                        S.A.\n                    </p>\n                    <p></p>\n                    <h3>Servicio web de gesti&oacute;n en la opci&oacute;n de compra</h3>\n                    <p></p>\n                    <p>\n                        Es un sistema integral de administraci&oacute;n y control de infracciones de tr&aacute;nsito de\n                        cualquier tipo de flota de veh&iacute;culos. Disponemos de una base de datos para el vuelco y\n                        seguimiento de las gestiones en curso, cualquiera sea su situaci&oacute;n.\n                    </p>\n                    <p>\n                        <b>Retiro de multas, para efectuar el control.</b>\n                    </p>\n                    <p>\n                        Digitalizaci&oacute;n de im&aacute;genes y/o informaci&oacute;n (permite visualizar la infracci&oacute;n\n                        de tr&aacute;nsito o la imagen del acta).\n                    </p>\n                    <p>\n                        Escaneo de infracciones (permite visualizar la infracci&oacute;n de tr&aacute;nsito o la imagen\n                        del acta). Alta de datos de infracciones.\n                    </p>\n                    <p>Carga de datos con informaci&oacute;n detallada de la infracci&oacute;n.</p>\n                    <p>\n                        Brindamos un sistema de control y seguimiento que permite su uso como medio de prueba a trav&eacute;s\n                        del cual el usuario puede acceder al mismo.\n                    </p>\n                    <p>\n                        Notificaci&oacute;n al cliente de infracciones realizadas mediante contacto de e-mail en el\n                        momento de reconocer la infracci&oacute;n.\n                    </p>\n                    <p>\n                        Aviso al usuario de infracciones realizadas mediante contacto de e-mail y telef&oacute;nicamente\n                        en el momento de reconocer la infracci&oacute;n.\n                    </p>\n                    <p>\n                        Reportes permanentes de aviso al cliente, con la informaci&oacute;n actualizada de la situaci&oacute;n\n                        solicitada.\n                    </p>\n                    <p>\n                        Reportes estad&iacute;sticos de: veh&iacute;culos, cantidades de infracciones, montos a pagar,\n                        montos totales y otros.\n                    </p>\n                    <p></p>\n                    <h3>Aviso de ca&iacute;da de leasing o vencimientos prendarios</h3>\n                    <p></p>\n                    <p>\n                        Es un mecanismo de control y aviso de los vencimientos de los productos financiados, que\n                        mediante contactos v&iacute;a e-mail y telef&oacute;nicamente se notifica al cliente y al\n                        usuario de que se aproxima el vencimiento. Los avisos se realizan faltando tres meses\n                        consecutivamente hasta el vencimiento de la operaci&oacute;n.\n                    </p>\n                    <p></p>\n                    <h3>Personal In Plant.</h3>\n                    <p></p>\n                    <p>\n                        Apuntamos a satisfacer la demanda de nuestros clientes en un mercado cada vez m&aacute;s\n                        competitivo y en continua transformaci&oacute;n.\n                    </p>\n                    <p>Brindamos el apoyo necesario para el cumplimiento de los objetivos de nuestros clientes.</p>\n                    <p>Ponemos en contacto al candidato m&aacute;s adecuado para cada puesto de trabajo.</p>\n                    <p>Aportamos soluciones eficaces y competitivas a medida de las necesidades de cada cliente.</p>\n                    <p>\n                        Nuestro staff est&aacute; compuesto por graduados universitarios o estudiantes avanzados a\n                        quienes fomentamos el desarrollo de las mejores pr&aacute;cticas y de desarrollarse\n                        profesionalmente.\n                    </p>\n                </div>\n                <div class=\"texto\" *ngIf=\"itemMenuSelected == 'clients'\">\n                    <h2>Clientes</h2>\n                    <p></p>\n                    <p>\n                        Nuestros clientes son empresas de primer nivel, de origen nacional e internacional, que confÃ­an\n                        en la excelencia de los servicios que ofrecemos.\n                    </p>\n                    <p>Algunos de ellos son:</p>\n                    <b>\n\t\t\t\t\t\t<li>INDUSTRIAL AND COMMERCIAL BANK OF CHINA S.A.</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>BANCO SUPERVIELLE S.A.</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>BBVA BANCO FRANCÃ‰S S.A.</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>PSA COMPAÃ‘Ã�A FINANCIERA S.A.</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>BANCO DE COMERCIO S.A</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>VOLKSWAGEN COMPAÃ‘Ã�A FINANCIERA S A</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>BANCO DE LA CIUDAD DE BUENOS AIRES</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>CITIBANK</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>BANCO MACRO S.A.</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>BANCO DE GALICIA Y BUENOS AIRES S A U</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>HSBC BANK ARGENTINA SA</li>\n\t\t\t\t\t</b>\n\t\t\t\t\t<b>\n\t\t\t\t\t\t<li>BANCO INDUSTRIAL S.A.</li>\n\t\t\t\t\t</b>\n                </div>\n                <div id=\"contacto_panel\" *ngIf=\"itemMenuSelected == 'contact'\">\n                    <h4>CONTACTO</h4>\n                    <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\n                        <button class=\"close\" data-dismiss=\"alert\" aria-label=\"close\"\n                                (click)=\"errorMessage=null\">&times;</button>\n                        <span class=\"input-sm\">{{errorMessage}}</span>\n                    </div>\n                    <div class=\"alert alert-success\" *ngIf=\"successMessage\">\n                        <button class=\"close\" data-dismiss=\"alert\" aria-label=\"close\"\n                                (click)=\"successMessage=null\">&times;</button>\n                        <span class=\"input-sm\">{{successMessage}}</span>\n                    </div>\n                    <form id=\"contact-form\" method=\"post\" novalidate=\"novalidate\" role=\"form\" class=\"form-horizontal\"\n                          [formGroup]=\"form\" (ngSubmit)=\"sendContactInfo()\">\n                        <div class=\"form-group\">\n                            <label class=\"contacto control-label col-sm-2\" for=\"nombres\">NOMBRES</label>\n                            <div class=\"col-sm-10\">\n                                <input type=\"text\" id=\"nombres\" name=\"name\" class=\"form-control input-sm\"\n                                       [(ngModel)]=\"contactInfo.name\" formControlName=\"name\">\n                            </div>\n                            <div class=\"col-sm-12 input-sm\" *ngIf=\"!form.controls.name.valid\">\n                                <div *ngIf=\"form.controls.name.errors.required\" class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"contacto control-label col-sm-2\" for=\"apellidos\">APELLIDOS</label>\n                            <div class=\"col-sm-10\">\n                                <input type=\"text\" id=\"apellidos\" name=\"surname\" class=\"form-control input-sm\"\n                                       [(ngModel)]=\"contactInfo.surname\" formControlName=\"surname\">\n                            </div>\n                            <div class=\"col-sm-12 input-sm\" *ngIf=\"!form.controls.surname.valid\">\n                                <div *ngIf=\"form.controls.surname.errors.required\" class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"contacto control-label col-sm-2\" for=\"telefono\">TEL&Eacute;FONO</label>\n                            <div class=\"col-sm-10\">\n                                <input type=\"text\" id=\"telefono\" name=\"phone\" class=\"form-control input-sm\"\n                                       [(ngModel)]=\"contactInfo.phone\" formControlName=\"phone\">\n                            </div>\n                            <div class=\"col-sm-12 input-sm\" *ngIf=\"!form.controls.phone.valid\">\n                                <div *ngIf=\"form.controls.phone.errors.required\" class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"contacto control-label col-sm-2\" for=\"mail\">e-MAIL</label>\n                            <div class=\"col-sm-10\">\n                                <input type=\"text\" id=\"mail\" name=\"email\" class=\"form-control input-sm\"\n                                       [(ngModel)]=\"contactInfo.email\" formControlName=\"email\">\n                            </div>\n                            <div class=\"col-sm-12 input-sm\" *ngIf=\"!form.controls.email.valid\">\n                                <div *ngIf=\"form.controls.email.errors.required\" class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                                <div *ngIf=\"form.controls.email.errors.pattern\" class=\"alert-danger\">\n                                    {{errorMessages.invalidPattern}}\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"contacto control-label col-sm-2\" for=\"comments\">CONSULTA</label>\n                            <div class=\"col-sm-10\">\n\t\t\t\t\t\t\t    <textarea id=\"comments\" name=\"comments\" class=\"form-control input-sm\"\n                                          [(ngModel)]=\"contactInfo.comments\" name=\"comments\"\n                                          [value]=\"contactInfo.comments\"></textarea>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <div class=\"col-sm-8\">\n                                <h3>Servileasing S.A.</h3>\n                                <h3>info@servileasing.com.ar</h3>\n                            </div>\n                            <div class=\"col-sm-4\" id=\"enviar\">\n                                <button type=\"submit\" class=\"btn btn-default btn-sm\"\n                                        [disabled]=\"loading || !form.valid\">ENVIAR\n                                    <!--<i class=\"glyphicon glyphicon-envelope\"></i>-->\n                                    <span class=\"envelope\"><img></span>\n                                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\" *ngIf=\"loading\"></i>\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n\n\n    <div id=\"footer\" class=\"not_overflow_footer\">\n        <p>- ( 0 1 1 ) 4 3 7 1 - 1 7 5 1 - ( 0 1 1 ) 4 3 7 2 - 1 2 3 3 - </p>\n    </div>\n</div>\n<div bsModal #loginOperators=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-md\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"loginOperators.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Acceso Operadores</h4>\n            </div>\n            <div class=\"modal-body\">\n                <operator-loggin [modal]=\"loginOperators\"></operator-loggin>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/servileasing_web2.268b22d1e88594351a6dbfbdbdf20f4f.png";

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/linea1.9ba4665f946773563b2ab6e05398d292.png";

/***/ },
/* 854 */
/***/ function(module, exports) {

	module.exports = "/****Generales**************/\nb {\n    font-weight: normal;\n    color: #003871;\n}\n\nh2 {\n    margin: 0;\n    color: #003871;\n    font-weight: normal;\n}\n\nh3 {\n    margin: 0;\n    color: #003871;\n    font-weight: normal;\n}\n\nh4 {\n    margin-top: 0;\n    font-size: 24px;\n    color: #003871;\n    font-weight: normal;\n}\n\n#body {\n    height: 460px;\n    margin-left: 13px;\n    border: 1px solid #003871;\n    border-left-width: 0px;\n    -webkit-box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    -moz-box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    background: white;\n    behavior: url(/PIE.htc);\n}\n\n#body .row {\n    width: 100%\n}\n\n#container {\n    /*background-image: url('../images/home2.png');*/\n    background-size: 997px 665px;\n    background-repeat: no-repeat;\n    height: 665px;\n    width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n#cuadro {\n    height: 600px;\n    width: 990px;\n}\n\n#container_ie7 {\n    background-image: url('../images/home2.png');\n    background-size: 997px 665px;\n    background-repeat: no-repeat;\n    height: 665px;\n    width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n#canvas {\n    float: left;\n    overflow: auto;\n    padding: 5px;\n    font-size: 18px;\n}\n\n.not_overflow {\n    height: 400px;\n}\n\n.overflow {\n    margin-top: -15px;\n    height: 420px;\n}\n\n#footer {\n    color: white;\n    font-size: 17px;\n    text-align: center;\n    height: 25px !important;\n}\n\ndiv #footer > p {\n    margin-top: 10px;\n    height: 25px;\n    margin-left: 13px;\n    background-color: #003871;\n    -webkit-box-shadow: 0px 0px 1px rgba(0, 56, 113, 0.8);\n    -moz-box-shadow: 0px 0px 1px rgba(0, 56, 113, 0.8);\n    box-shadow: 0px 0px 1px rgba(0, 56, 113, 0.8);\n    behavior: url(/PIE.htc);\n}\n\nlabel.error {\n    float: left;\n    color: red;\n    padding-left: .5em;\n    vertical-align: top;\n}\n\n/*match placeholder/watermark padding to border+padding for input element*/\nlabel.placeholder {\n    cursor: text;\n    padding: 4px 6px;\n    font-size: 10px;\n    color: #E4E2DC;\n}\n\n/* html5 placeholder support */\ninput::-webkit-input-placeholder {\n    color: #E4E2DC;\n}\n\n:-moz-placeholder {\n    color: #E4E2DC;\n}\n\ninput:placeholder {\n    color: #E4E2DC;\n}\n\n.hasPlaceholder {\n    line-height: normal;\n    cursor: text;\n    padding: 4px 4px 4px 4px;\n    font-size: 10px;\n    color: #E4E2DC;\n    vertical-align: middle;\n}\n\n/***Pop over****/\nbutton.close {\n    margin-right: 5px;\n}\n\n.popover-content {\n    font-size: 16px;\n}\n\n.popover-inner h3 {\n    padding: 5px 14px;\n    font-size: 16px;\n}\n\n#spinner {\n    margin-top: 40px;\n    margin-left: 50px;\n}\n\n/*===*/\n\n/*****Menu*****/\n#nav-menu {\n    margin-left: 0px;\n}\n\n.espacio {\n    margin-top: 50px;\n}\n\n.bs-docs-sidenav.affix {\n    position: absolute;\n}\n\n.bs-docs-sidenav {\n    width: 270px;\n    padding: 0;\n    background-color: #003871;\n    -webkit-border-radius: 6px 6px 0 0;\n    -moz-border-radius: 6px 6px 0 0;\n    border-radius: 6px 6px 0px 0px;\n    -webkit-box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    -moz-box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    behavior: url(/PIE.htc);\n}\n\n.bs-docs-sidenav > li > a {\n    display: block;\n    margin: 0 0 -1px;\n    padding: 8px 30px;\n    /*height: 20px;*/\n    font-size: 18px;\n}\n\n.bs-docs-sidenav > li:first-child > a {\n    -webkit-border-radius: 6px 6px 0 0;\n    -moz-border-radius: 6px 6px 0 0;\n    border-radius: 6px 6px 0px 0px;\n    behavior: url(/PIE.htc);\n}\n\n.bs-docs-sidenav > .active > a {\n    color: white;\n    font-weight: bold;\n    position: relative;\n    z-index: 2;\n    padding: 10px 30px;\n    border: 0;\n    text-shadow: 0 1px 0 rgba(0, 0, 0, .15);\n    -webkit-box-shadow: inset 1px 0 0 rgba(0, 0, 0, .1), inset -1px 0 0 rgba(0, 0, 0, .1);\n    -moz-box-shadow: inset 1px 0 0 rgba(0, 0, 0, .1), inset -1px 0 0 rgba(0, 0, 0, .1);\n    box-shadow: inset 1px 0 0 rgba(0, 0, 0, .1), inset -1px 0 0 rgba(0, 0, 0, .1);\n    behavior: url(/PIE.htc);\n}\n\n#nav-menu .nav-list > .active > a, .nav-list > .active > a:hover {\n    background-color: #809cb8;\n    text-shadow: none;\n    color: white;\n}\n\n#nav-menu .nav-list > li > a, .nav-list .nav-header {\n    text-shadow: none;\n    color: #4D749C;\n}\n\n#nav-menu .nav > li > a:hover {\n    color: #003871;\n}\n\n#nav-menu .separador {\n    height: 1px;\n    border-bottom: 1px solid #4d749c;\n    margin: 0 auto;\n    width: 90%;\n}\n\n#comienzo_menu {\n    -webkit-border-top-left-radius: 6px;\n    -webkit-border-top-right-radius: 6px;\n    -moz-border-radius-topleft: 6px;\n    -moz-border-radius-topright: 6px;\n    border-radius: 6px 6px 0px 0px;\n    background-color: #003871;\n    height: 10px;\n    behavior: url(/PIE.htc);\n}\n\n#fin_menu {\n    background-color: #003871;\n    height: 10px;\n}\n\n#nav-menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n/*****=======Fin menu========*****/\n\n/***********Header**********/\n#header {\n    margin-left: 13px;\n    height: 104px;\n    line-height: 5px;\n    background-color: #003871;\n    -webkit-border-top-left-radius: 30px;\n    -webkit-border-top-right-radius: 30px;\n    -moz-border-radius-topleft: 30px;\n    -moz-border-radius-topright: 30px;\n    border-radius: 30px 30px 0px 0px;\n    -webkit-box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    -moz-box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    box-shadow: 7px 7px 7px rgba(0, 0, 0, .2);\n    behavior: url(/PIE.htc);\n}\n\nimg {\n    width: 100%;\n}\n\n.line img {\n    margin-top: 10px;\n}\n\n#logo {\n    width: 375px;\n    float: left;\n    margin-top: 30px;\n}\n\n#logo img {\n    width: 375px;\n}\n\n.espacio_topmargen {\n    height: 18px;\n}\n\n/***********Login**********/\n#acceso_operadores {\n    float: right;\n    margin-top: 20px;\n    width: 300px;\n    height: 50px;\n}\n\n#acceso_usuarios {\n    float: right;\n    margin-top: 20px;\n    width: 250px;\n    height: 50px;\n}\n\ndiv .acceso_separador {\n    float: left;\n    height: 63px;\n    width: 15px;\n}\n\n.acceso {\n    float: left;\n    color: #4D749C;\n    font-size: 16px;\n    margin-top: 5px;\n    height: 30px;\n}\n\nimg.login {\n    margin-top: 0px;\n    margin-bottom: 0px;\n}\n\ndiv.acceso p {\n    margin: 0 0 7px;\n}\n\ninput[type=\"password\"].login_input {\n    width: 100px;\n    font-size: 10px;\n    border: 1px solid #e4e2dc;\n    background-color: #003871;\n    color: #e4e2dc;\n    -webkit-border-radius: 0;\n    border-radius: 0;\n    behavior: url(/PIE.htc);\n}\n\ninput[type=\"text\"].login_input {\n    width: 100px;\n    font-size: 10px;\n    border: 1px solid #e4e2dc;\n    background-color: #003871;\n    color: #e4e2dc;\n    -webkit-border-radius: 0;\n    border-radius: 0px;\n    behavior: url(/PIE.htc);\n}\n\n/*****=======Fin header========*****/\n\n/****************Contactos*****************/\n#contacto_panel {\n    width: 600px;\n}\n\n.contacto_row {\n    height: 30px;\n    margin-bottom: 10px;\n}\n\n.contacto {\n    -webkit-border-top-left-radius: 6px;\n    -webkit-border-top-right-radius: 6px;\n    -moz-border-radius-topleft: 6px;\n    -moz-border-radius-topright: 6px;\n    border-radius: 6px 6px 0px 0px;\n    background-color: #003871;\n    color: white;\n    height: 25px;\n    /* \twidth: 130px; */\n    padding-top: 5px;\n    padding-left: 10px;\n    font-weight: bold;\n    font-size: 14px;\n    float: left;\n    behavior: url(/PIE.htc);\n}\n\ninput[type=\"text\"].contacto_input, textarea.contacto_input {\n    float: left;\n    margin-left: 5px;\n    width: 300px;\n    height: 20px;\n    background-color: white;\n    border: 1px solid;\n    border-color: rgba(08, 29, 88, 0.5);\n    opacity: 0.5;\n    color: #081d58;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0px;\n    behavior: url(/PIE.htc);\n}\n\ndiv #enviar {\n    height: 35px;\n}\n\ndiv #enviar img {\n    float: right;\n    /* \tmargin-right: 140px; */\n    padding-top: 0px;\n    width: 52px;\n}\n\n/*===============Fin contactos==============*/\n\n/****************Para validacion*****************/\nlabel.valid {\n    width: 24px;\n    height: 24px;\n    color: green;\n    background: url(/images/valid.png) center center no-repeat;\n    display: inline-block;\n    text-indent: -9999px;\n}\n\nlabel.error {\n    font-weight: bold;\n    color: red;\n    padding: 2px 8px;\n    margin-top: 2px;\n    /*font-size:12px;*/\n}\n\n.acceso_enviar {\n    float: right;\n    height: 18px;\n    font-size: 14px;\n    color: #4d749c;\n    font-weight: normal;\n    border: 1px solid;\n    background-color: #003871;\n    margin-top: 5px;\n}\n\n#enviar_button {\n    height: 33px;\n    margin-top: 5px;\n    font-size: 20px;\n    color: #003871;\n    font-weight: normal;\n    float: right;\n    border: 0;\n    background-color: white;\n    cursor: pointer;\n    text-decoration: none;\n}"

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var login_service_1 = __webpack_require__(404);
	var home_panel_component_1 = __webpack_require__(856);
	var user_1 = __webpack_require__(844);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var HomeComponent = (function () {
	    function HomeComponent(router, loginService) {
	        this.router = router;
	        this.loginService = loginService;
	        this.init();
	    }
	    HomeComponent.prototype.init = function () {
	        this.showLefNavbar = false;
	        this.userIsAdmin = false;
	        this.userIsClient = false;
	    };
	    HomeComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.loginService.getUserCredentials().subscribe(function (user) {
	            _this.userLogged = new user_1.User(user);
	            _this.userIsAdmin = _this.userLogged.isAdmin();
	            _this.userIsClient = _this.userLogged.isClient();
	            if (_this.userLogged.bank && _this.userLogged.bank.id && _this.userLogged.bank.logo && _this.userLogged.bank.logo.id) {
	                _this.logoUrl = "/bank/" + _this.userLogged.bank.id + "/download";
	            }
	            _this.loginService.setUserLogged(_this.userLogged);
	            if (_this.userLogged && _this.userLogged.rol && _this.userLogged.rol.name) {
	                if (_this.userLogged.rol.name === "OPERADOR DE BANCO" || _this.userLogged.rol.name === "Operador Banco Con Trámite") {
	                    _this.userIsBank = true;
	                }
	            }
	        }, function () {
	            //Do Nothing.
	        });
	    };
	    HomeComponent.prototype.goToHome = function () {
	        this.showLefNavbar = false;
	        this.router.navigate(['app/home/adminHome']);
	    };
	    HomeComponent.prototype.goToReports = function () {
	        this.showLefNavbar = false;
	    };
	    HomeComponent.prototype.goToConfig = function () {
	        this.router.navigate(['app/home/config']);
	    };
	    HomeComponent.prototype.goToConfigMails = function () {
	        this.showLefNavbar = false;
	        this.router.navigate(['app/home/mailTemplateConfig']);
	    };
	    HomeComponent = __decorate([
	        core_1.Component({
	            selector: 'home',
	            template: __webpack_require__(930),
	            styles: [__webpack_require__(932)],
	            directives: [
	                router_1.ROUTER_DIRECTIVES,
	                ng2_bootstrap_1.DROPDOWN_DIRECTIVES
	            ],
	            precompile: [home_panel_component_1.HomePanel]
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, login_service_1.LoginService])
	    ], HomeComponent);
	    return HomeComponent;
	}());
	exports.HomeComponent = HomeComponent;


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var tabs_component_1 = __webpack_require__(857);
	var tab_component_1 = __webpack_require__(859);
	var vehicles_panel_component_1 = __webpack_require__(860);
	var contracts_panel_component_1 = __webpack_require__(898);
	var infractions_panel_component_1 = __webpack_require__(901);
	var kmHistory_panel_component_1 = __webpack_require__(911);
	var navigation_service_1 = __webpack_require__(403);
	var login_service_1 = __webpack_require__(404);
	var procedures_panel_component_1 = __webpack_require__(915);
	var patentPayment_panel_component_1 = __webpack_require__(919);
	var agenda_panel_component_1 = __webpack_require__(923);
	var pendingProcedures_panel_component_1 = __webpack_require__(927);
	var HomePanel = (function () {
	    function HomePanel(navigationService, loginService) {
	        this.navigationService = navigationService;
	        this.loginService = loginService;
	        this.init();
	        var backParameters = navigationService.getBackParameters();
	        if (backParameters && backParameters.tabSelected) {
	            this.tabSelected = backParameters.tabSelected;
	        }
	    }
	    HomePanel.prototype.init = function () {
	        this.showVehicles = false;
	        this.showContracts = false;
	        this.showInfractions = false;
	        this.showKmHistory = false;
	        this.showProcedures = false;
	        this.showPendingProcedures = false;
	        this.showPatentPayment = false;
	        this.showAgenda = false;
	    };
	    HomePanel.prototype.checkActive = function (tabName) {
	        if (this.tabSelected) {
	            return tabName === this.tabSelected;
	        }
	        if (this.showVehicles) {
	            return tabName === 'vehicles';
	        }
	        else if (this.showInfractions) {
	            return tabName === 'infractions';
	        }
	        else if (this.showKmHistory) {
	            return tabName === 'km_history';
	        }
	        else if (this.showProcedures) {
	            return tabName === 'procedures';
	        }
	        else if (this.showPatentPayment) {
	            return tabName === 'patentPayment';
	        }
	        else if (this.showPendingProcedures) {
	            return tabName === 'pendingProcedures';
	        }
	        else {
	            return tabName === 'agenda';
	        }
	    };
	    HomePanel.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        if (!this.userLogged) {
	            this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	                _this.userLogged = userLogged;
	                _this.updateUserLogged();
	            }, function () {
	                //Do Nothing.
	            });
	        }
	        else {
	            this.updateUserLogged();
	        }
	    };
	    HomePanel.prototype.updateUserLogged = function () {
	        this.showVehicles = this.userLogged.canViewSection('VEHICLES');
	        this.showContracts = this.userLogged.canViewSection('CONTRACTS');
	        this.showInfractions = this.userLogged.canViewSection('INFRACTIONS');
	        this.showKmHistory = this.userLogged.canViewSection('KM_HISTORY');
	        this.showProcedures = this.userLogged.canViewSection('PROCEDURES');
	        this.showPendingProcedures = this.userLogged.canViewSection('AGENDA'); // TODO: Definir quienes podrian ver esta pestaña, ahora solo los que pueden ver agenda y admins
	        this.showPatentPayment = this.userLogged.canViewSection('PATENT_PAYMENT');
	        this.showAgenda = this.userLogged.canViewSection('AGENDA');
	    };
	    HomePanel = __decorate([
	        core_1.Component({
	            selector: 'home-panel',
	            template: "\n        <tabs>\n            <tab [tabTitle]=\"'Veh&iacute;culos'\" [tabName]=\"'vehicles'\" [active]=\"checkActive('vehicles')\"\n                 *ngIf=\"showVehicles\">\n                <vehicles-panel></vehicles-panel>\n            </tab>\n            <tab [tabTitle]=\"'Contratos'\" [tabName]=\"'contracts'\" [active]=\"checkActive('contracts')\"\n                 *ngIf=\"showContracts\">\n                <contracts-panel></contracts-panel>\n            </tab>\n            <tab [tabTitle]=\"'Infracciones'\" [tabName]=\"'infractions'\" [active]=\"checkActive('infractions')\"\n                 *ngIf=\"showInfractions\">\n                <infractions-panel></infractions-panel>\n            </tab>\n            <tab [tabTitle]=\"'Hist\u00F3rico de km'\" [tabName]=\"'kmHistory'\" [active]=\"checkActive('km_history')\"\n                 *ngIf=\"showKmHistory\">\n                <kmHistory-panel></kmHistory-panel>\n            </tab>\n            <tab [tabTitle]=\"'Tr\u00E1mites'\" [tabName]=\"'procedures'\" [active]=\"checkActive('procedures')\"\n                 *ngIf=\"showProcedures\">\n                <procedures-panel></procedures-panel>\n            </tab>\n            <tab [tabTitle]=\"'Tr\u00E1mites pendientes'\" [tabName]=\"'pendingProcedures'\"\n                 [active]=\"checkActive('pendingProcedures')\"\n                 *ngIf=\"showPendingProcedures\">\n                <pendingProcedures-panel></pendingProcedures-panel>\n            </tab>\n            <tab [tabTitle]=\"'Pago de patentes'\" [tabName]=\"'patentPayment'\" [active]=\"checkActive('patentPayment')\"\n                 *ngIf=\"showPatentPayment\">\n                <patentPayment-panel></patentPayment-panel>\n            </tab>\n            <tab [tabTitle]=\"'Agenda'\" [tabName]=\"'agenda'\" [active]=\"checkActive('agenda')\"\n                 *ngIf=\"showAgenda\">\n                <agenda-panel></agenda-panel>\n            </tab>\n        </tabs>\n    ",
	            directives: [
	                tabs_component_1.Tabs,
	                tab_component_1.Tab,
	                vehicles_panel_component_1.VehiclesPanelComponent,
	                contracts_panel_component_1.ContractsPanelComponent,
	                infractions_panel_component_1.InfractionsPanelComponent,
	                kmHistory_panel_component_1.KmHistoryPanelComponent,
	                procedures_panel_component_1.ProceduresPanelComponent,
	                pendingProcedures_panel_component_1.PendingProceduresPanelComponent,
	                patentPayment_panel_component_1.PatentPaymentPanelComponent,
	                agenda_panel_component_1.AgendaPanelComponent
	            ],
	        }), 
	        __metadata('design:paramtypes', [navigation_service_1.NavigationService, login_service_1.LoginService])
	    ], HomePanel);
	    return HomePanel;
	}());
	exports.HomePanel = HomePanel;


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var navigation_service_1 = __webpack_require__(403);
	var tabSelected_service_1 = __webpack_require__(858);
	var Tabs = (function () {
	    function Tabs(navigationService, tabSelectedService) {
	        this.navigationService = navigationService;
	        this.tabSelectedService = tabSelectedService;
	        this.tabs = [];
	    }
	    Tabs.prototype.selectTab = function (tab) {
	        _deactivateAllTabs(this.tabs);
	        tab.active = true;
	        //        this.tabSelectedService.setActiveTab(tab.name);
	        function _deactivateAllTabs(tabs) {
	            tabs.forEach(function (tab) { return tab.active = false; });
	        }
	    };
	    Tabs.prototype.ngAfterContentChecked = function () {
	        this.tabSelectedService.setActiveTab(this.getActiveTab());
	    };
	    Tabs.prototype.getActiveTab = function () {
	        for (var _i = 0, _a = this.tabs; _i < _a.length; _i++) {
	            var t = _a[_i];
	            if (t.active)
	                return t.name;
	        }
	    };
	    Tabs.prototype.selectTabByName = function (tabName) {
	        var selected = this.tabs.filter(function (tab) { return tab.name === tabName; });
	        if (selected && selected.length > 0) {
	            this.selectTab(selected[0]);
	        }
	    };
	    /*_deactivateAllTabs() {
	     this.tabs.forEach((tab)=>tab.active = false);
	     }*/
	    Tabs.prototype.addTab = function (tab) {
	        if (this.tabs.length === 0)
	            tab.active = true;
	        this.tabs.push(tab);
	    };
	    Tabs = __decorate([
	        core_1.Component({
	            selector: 'tabs',
	            template: "\n    <ul class=\"nav nav-tabs\">\n      <li *ngFor=\"let tab of tabs\" (click)=\"selectTab(tab)\" [class.active]=\"tab.active\">\n        <a href=\"javascript:void(0)\">{{tab.title}}</a>\n      </li>\n    </ul>\n    <ng-content></ng-content>\n  ",
	            styles: ["\n    .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {\n        background-color: #31708f !important;\n        color: #fff !important;\n    }\n  "],
	            directives: []
	        }), 
	        __metadata('design:paramtypes', [navigation_service_1.NavigationService, tabSelected_service_1.TabSelectedService])
	    ], Tabs);
	    return Tabs;
	}());
	exports.Tabs = Tabs;


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var TabSelectedService = (function () {
	    function TabSelectedService(backendService) {
	        this.backendService = backendService;
	    }
	    TabSelectedService.prototype.setActiveTab = function (tabName) {
	        this.activeTab = tabName;
	    };
	    TabSelectedService.prototype.getActiveTab = function () {
	        return this.activeTab;
	    };
	    TabSelectedService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], TabSelectedService);
	    return TabSelectedService;
	}());
	exports.TabSelectedService = TabSelectedService;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var tabs_component_1 = __webpack_require__(857);
	var Tab = (function () {
	    function Tab(tabs) {
	        this.tabs = tabs;
	        this.active = this.active || false;
	        tabs.addTab(this);
	    }
	    Tab = __decorate([
	        core_1.Component({
	            selector: 'tab',
	            inputs: [
	                'title:tabTitle',
	                'name:tabName',
	                'active'
	            ],
	            styles: ["\n    .pane{\n      padding: 1em;\n    }\n  "],
	            template: "\n    <div [hidden]=\"!active\" class=\"pane\">\n      <ng-content></ng-content>\n    </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [tabs_component_1.Tabs])
	    ], Tab);
	    return Tab;
	}());
	exports.Tab = Tab;


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var vehicles_service_1 = __webpack_require__(630);
	var bank_service_1 = __webpack_require__(631);
	var vehicle_1 = __webpack_require__(873);
	var bank_1 = __webpack_require__(875);
	var login_service_1 = __webpack_require__(404);
	var ng2_file_upload_1 = __webpack_require__(889);
	var validators_1 = __webpack_require__(849);
	var VehiclesPanelComponent = (function () {
	    function VehiclesPanelComponent(router, vehiclesService, bankService, loginService) {
	        var _this = this;
	        this.router = router;
	        this.vehiclesService = vehiclesService;
	        this.bankService = bankService;
	        this.loginService = loginService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los bancos.');
	        });
	        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
	        /*this.form.valueChanges
	         .debounceTime(400)
	         .subscribe(this.find.bind(this));*/
	    }
	    VehiclesPanelComponent.prototype.init = function () {
	        this.data = [];
	        this.banks = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        this.canEditVehicle = false;
	        this.canDeleteVehicle = false;
	        this.canViewVehicle = false;
	        this.canEditContract = false;
	        this.canDeleteContract = false;
	        this.canViewContract = false;
	        this.showFilters = false;
	        this.errorsBulkLoad = [];
	        this.createUploaderBulkLoad();
	        this.filter = new vehicle_1.Vehicle();
	        this.form = new forms_1.FormGroup({
	            patent: new forms_1.FormControl(),
	            bank: new forms_1.FormControl(),
	            contractNumber: new forms_1.FormControl(),
	            cuit: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl()
	        });
	        if (!this.filter.contract.bank.id) {
	            this.filter.contract.bank = this.bankTodos;
	        }
	        this.oneClickBulkLoad = false;
	    };
	    VehiclesPanelComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.filter.contract.bank = banks[0];
	        }
	    };
	    VehiclesPanelComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    VehiclesPanelComponent.prototype.filterEmpty = function () {
	        return !(this.filter.patent || this.filter.contract.contractNumber ||
	            this.filter.contract.cuit || (this.filter.contract.bank && this.filter.contract.bank.id != ''));
	    };
	    VehiclesPanelComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.vehiclesService.findVehicles(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	                _this.refreshData(data);
	                _this.page = page;
	            }, function () {
	                _this.bindError('Ocurrió un error al buscar los vehículos.');
	            });
	        }
	    };
	    VehiclesPanelComponent.prototype.refreshData = function (page) {
	        this.data = page.content;
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    VehiclesPanelComponent.prototype.removeItem = function (deleteModal) {
	        var _this = this;
	        this.error = null;
	        this.vehiclesService.delete(this.vehicleSelected.contract.id, this.vehicleSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeItemFromView(_this.vehicleSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el vehículo.');
	        });
	    };
	    VehiclesPanelComponent.prototype.removeItemFromView = function (vehicle) {
	        var index = this.data.indexOf(vehicle);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.vehicleSelected = null;
	    };
	    VehiclesPanelComponent.prototype.editItem = function (item) {
	        this.router.navigate(['app/home/editVehicle', item.contract.id, item.id, false]);
	    };
	    VehiclesPanelComponent.prototype.createVehicle = function () {
	        this.router.navigate(['app/home/createVehicle']);
	    };
	    VehiclesPanelComponent.prototype.downloadFilterVehicles = function () {
	        this.error = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.reportMessage = 'Creando reporte...';
	            /*
	             * Se exportan todos los vehículos que cumplan con el filtro.
	             * Sólo los vehículos de la página actual se descargan.
	             */
	            var url = window.location.origin +
	                vehicles_service_1.VehiclesService.getURLFilterVehicles(this.filter, this.page, this.itemsPerPage);
	            window.location.href = url;
	            this.loading = false;
	        }
	    };
	    VehiclesPanelComponent.prototype.close = function (saved) {
	        if (saved) {
	            this.find();
	        }
	    };
	    VehiclesPanelComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    VehiclesPanelComponent.prototype.viewContract = function (item) {
	        this.router.navigate(['app/home/editContract', item.contract.id]);
	    };
	    VehiclesPanelComponent.prototype.ngOnInit = function () {
	        this.userLogged = this.loginService.getUserLogged();
	        this.canEditVehicle = this.userLogged.isActionAllowed('VEHICLES', 'EDIT', 'VEHICLES');
	        this.canDeleteVehicle = this.userLogged.isActionAllowed('VEHICLES', 'DELETE', 'VEHICLES');
	        this.canViewVehicle = this.userLogged.isActionAllowed('VEHICLES', 'VIEW', 'VEHICLES');
	        this.canEditContract = this.userLogged.isActionAllowed('VEHICLES', 'EDIT', 'CONTRACTS');
	        this.canDeleteContract = this.userLogged.isActionAllowed('VEHICLES', 'DELETE', 'CONTRACTS');
	        this.canViewContract = this.userLogged.isActionAllowed('VEHICLES', 'VIEW', 'CONTRACTS');
	        if (this.userLogged.rol.client) {
	            if (this.userLogged.cuit) {
	                this.filter.contract.cuit = this.userLogged.username;
	            }
	            else {
	                this.filter.patent = this.userLogged.username;
	            }
	            this.filter.contract.bank.id = this.userLogged.bank.id;
	            this.showFilters = false;
	        }
	        else {
	            this.showFilters = true;
	        }
	    };
	    VehiclesPanelComponent.prototype.createUploaderBulkLoad = function () {
	        var _this = this;
	        this.uploaderBulkLoad = new ng2_file_upload_1.FileUploader({
	            url: 'vehicle/bulkLoad',
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.hasBulkLoadDropZoneOver = false;
	        this.uploaderBulkLoad.onCompleteItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 200) {
	                var message = response.split("|");
	                _this.errorsBulkLoad = [];
	                _this.errorsBulkLoad[0] = message[0];
	                if (message.length > 1) {
	                    window.location.href = window.location.origin +
	                        vehicles_service_1.VehiclesService.getURLVehicleBulkload(message[1]);
	                }
	            }
	            else if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de vehículos no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        vehicles_service_1.VehiclesService.getURLVehicleBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de vehículos cancelada.");
	                }
	            }
	            _this.showBulkLoadModal();
	            _this.oneClickBulkLoad = false;
	        };
	    };
	    VehiclesPanelComponent.prototype.fileOverBulkLoad = function (e) {
	        this.hasBulkLoadDropZoneOver = e;
	    };
	    /**
	     * Se busca que no exista ningún archivo excel en la cola,
	     * previo a ingresar un nuevo excel.
	     * */
	    /*public checkDuplicatedExcel():boolean {
	     let existExcelInQueue = false;
	     if (this.uploaderBulkLoad.queue.length > 0) {
	     this.uploaderBulkLoad.queue.map((aFile) => {
	     let extensionFile = aFile.file.name.substr(aFile.file.name.lastIndexOf('.') + 1).toLowerCase();
	     if (extensionFile == 'xls' || extensionFile == 'xlsx') {
	     existExcelInQueue = true;
	     }
	     });
	     }
	     return existExcelInQueue;
	     }*/
	    VehiclesPanelComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        /*Limpieza de inputs al agregar a la cola el archivo*/
	        this.uploaderBulkLoad.onAfterAddingFile = (function (item) {
	            _this.bulkLoad.nativeElement.value = '';
	            _this.reportMessage = null;
	        });
	    };
	    VehiclesPanelComponent.prototype.showBulkLoadModal = function () {
	        this.bulkLoadModal.show();
	        this.disableLoading();
	    };
	    VehiclesPanelComponent.prototype.hideBulkLoadModal = function () {
	        this.bulkLoadModal.hide();
	        this.errorsBulkLoad = [];
	    };
	    VehiclesPanelComponent.prototype.disableLoading = function () {
	        this.loading = false;
	        this.oneClickBulkLoad = false;
	    };
	    VehiclesPanelComponent.prototype.enableLoading = function () {
	        this.loading = true;
	    };
	    VehiclesPanelComponent.prototype.enableOneClickBulkload = function () {
	        this.oneClickBulkLoad = true;
	    };
	    VehiclesPanelComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.ViewChild('bulkLoadVehicle'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], VehiclesPanelComponent.prototype, "bulkLoad", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadVehicleModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], VehiclesPanelComponent.prototype, "bulkLoadModal", void 0);
	    VehiclesPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'vehicles-panel',
	            template: __webpack_require__(896),
	            styles: [__webpack_require__(897)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                /*DATEPICKER_DIRECTIVES,*/
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, vehicles_service_1.VehiclesService, bank_service_1.BankService, login_service_1.LoginService])
	    ], VehiclesPanelComponent);
	    return VehiclesPanelComponent;
	}());
	exports.VehiclesPanelComponent = VehiclesPanelComponent;


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	var dataTable_directive = __webpack_require__(862);
	var defaultSorter_directive = __webpack_require__(864);
	var paginator_component = __webpack_require__(865);
	var bootstrapPaginator_component = __webpack_require__(866);
	
	exports.DataTable = dataTable_directive.DataTable;
	exports.DataEvent = dataTable_directive.DataEvent;
	exports.PageEvent = dataTable_directive.PageEvent;
	exports.SortEvent = dataTable_directive.SortEvent;
	exports.DefaultSorter = defaultSorter_directive.DefaultSorter;
	exports.Paginator = paginator_component.Paginator;
	exports.BootstrapPaginator = bootstrapPaginator_component.BootstrapPaginator;
	
	exports.DataTableDirectives = [
	    dataTable_directive.DataTable,
	    defaultSorter_directive.DefaultSorter,
	    paginator_component.Paginator,
	    bootstrapPaginator_component.BootstrapPaginator
	];

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var _ = __webpack_require__(863);
	var DataTable = (function () {
	    function DataTable() {
	        this.inputData = [];
	        this.sortBy = "";
	        this.sortOrder = "asc";
	        this.rowsOnPage = 1000;
	        this.activePage = 1;
	        this.mustRecalculateData = false;
	        this.onDataChange = new core_1.EventEmitter();
	        this.onSortChange = new core_1.EventEmitter();
	        this.onPageChange = new core_1.EventEmitter();
	    }
	    DataTable.prototype.getSort = function () {
	        return { sortBy: this.sortBy, sortOrder: this.sortOrder };
	    };
	    DataTable.prototype.setSort = function (sortBy, sortOrder) {
	        if (this.sortBy !== sortBy || this.sortOrder !== sortOrder) {
	            this.sortBy = sortBy;
	            this.sortOrder = sortOrder;
	            this.mustRecalculateData = true;
	            this.onSortChange.emit({ sortBy: sortBy, sortOrder: sortOrder });
	        }
	    };
	    DataTable.prototype.getPage = function () {
	        return { activePage: this.activePage, rowsOnPage: this.rowsOnPage, dataLength: this.inputData.length };
	    };
	    DataTable.prototype.setPage = function (activePage, rowsOnPage) {
	        if (this.rowsOnPage !== rowsOnPage || this.activePage !== activePage) {
	            this.activePage = this.activePage !== activePage ? activePage : this.calculateNewActivePage(this.rowsOnPage, rowsOnPage);
	            this.rowsOnPage = rowsOnPage;
	            this.mustRecalculateData = true;
	            this.onPageChange.emit({ activePage: this.activePage, rowsOnPage: this.rowsOnPage, dataLength: this.inputData.length });
	        }
	    };
	    DataTable.prototype.calculateNewActivePage = function (previousRowsOnPage, currentRowsOnPage) {
	        var firstRowOnPage = (this.activePage - 1) * previousRowsOnPage + 1;
	        var newActivePage = Math.ceil(firstRowOnPage / currentRowsOnPage);
	        return newActivePage;
	    };
	    DataTable.prototype.ngOnChanges = function (changes) {
	        if (changes["inputData"]) {
	            this.inputData = this.inputData || [];
	            this.onPageChange.emit({
	                activePage: this.activePage,
	                rowsOnPage: this.rowsOnPage,
	                dataLength: this.inputData.length
	            });
	            this.mustRecalculateData = true;
	        }
	    };
	    DataTable.prototype.ngDoCheck = function () {
	        if (this.mustRecalculateData) {
	            this.fillData();
	            this.mustRecalculateData = false;
	        }
	    };
	    DataTable.prototype.fillData = function () {
	        this.activePage = this.activePage;
	        this.rowsOnPage = this.rowsOnPage;
	        var offset = (this.activePage - 1) * this.rowsOnPage;
	        var data = this.inputData;
	        data = _.orderBy(data, [this.sortBy], [this.sortOrder]);
	        data = _.slice(data, offset, offset + this.rowsOnPage);
	        this.data = data;
	    };
	    __decorate([
	        core_1.Input("mfData"), 
	        __metadata('design:type', Array)
	    ], DataTable.prototype, "inputData", void 0);
	    __decorate([
	        core_1.Input("mfRowsOnPage"), 
	        __metadata('design:type', Object)
	    ], DataTable.prototype, "rowsOnPage", void 0);
	    __decorate([
	        core_1.Input("mfActivePage"), 
	        __metadata('design:type', Object)
	    ], DataTable.prototype, "activePage", void 0);
	    DataTable = __decorate([
	        core_1.Directive({
	            selector: 'table[mfData]',
	            exportAs: 'mfDataTable'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DataTable);
	    return DataTable;
	}());
	exports.DataTable = DataTable;
	//# sourceMappingURL=DataTable.js.map

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.15.0';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for function metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', ARY_FLAG],
	    ['bind', BIND_FLAG],
	    ['bindKey', BIND_KEY_FLAG],
	    ['curry', CURRY_FLAG],
	    ['curryRight', CURRY_RIGHT_FLAG],
	    ['flip', FLIP_FLAG],
	    ['partial', PARTIAL_FLAG],
	    ['partialRight', PARTIAL_RIGHT_FLAG],
	    ['rearg', REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array ? array.length : 0;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array ? array.length : 0;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array ? array.length : 0;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return baseFindIndex(array, baseIsNaN, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a cache value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to stub `Date#getTime` use in `_.now`.
	   * var stubbed = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': stubGetTime };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        iteratorSymbol = Symbol ? Symbol.iterator : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /* Used to set `toString` methods. */
	    var defineProperty = (function() {
	      var func = getNative(Object, 'defineProperty'),
	          name = getNative.name;
	
	      return (name && name.length > 2) ? func : undefined;
	    }());
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	    var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      return getMapData(this, key)['delete'](key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      getMapData(this, key).set(key, value);
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      this.__data__ = new ListCache(entries);
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      return this.__data__['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var cache = this.__data__;
	      if (cache instanceof ListCache) {
	        var pairs = cache.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          return this;
	        }
	        cache = this.__data__ = new MapCache(pairs);
	      }
	      cache.set(key, value);
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	      // Safari 9 makes `arguments.length` enumerable in strict mode.
	      var result = (isArray(value) || isArguments(value))
	        ? baseTimes(value.length, String)
	        : [];
	
	      var length = result.length,
	          skipIndexes = !!length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (!isArr) {
	        var props = isFull ? getAllKeys(value) : keys(value);
	      }
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      return objectToString.call(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      if (!(isArray(source) || isTypedArray(source))) {
	        var props = baseKeysIn(source);
	      }
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return basePickBy(object, props, function(value, key) {
	        return key in object;
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick from.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, props, predicate) {
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var result = new buffer.constructor(buffer.length);
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        assignValue(object, key, newValue === undefined ? source[key] : newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return baseRest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return baseRest(function(iteratees) {
	        iteratees = (iteratees.length == 1 && isArray(iteratees[0]))
	          ? arrayMap(iteratees[0], baseUnary(getIteratee()))
	          : arrayMap(baseFlatten(iteratees, 1), baseUnary(getIteratee()));
	
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!seen.has(othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	                  return seen.add(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11,
	    // for data views in Edge < 14, and promises in Node.js.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var result,
	          index = -1,
	          length = path.length;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result) {
	        return result;
	      }
	      var length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length,
	          lastIndex = length - 1;
	
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return defineProperty(wrapper, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
	      });
	    };
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoize(function(string) {
	      string = toString(string);
	
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length,
	          args = Array(length ? length - 1 : 0),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return length
	        ? arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1))
	        : [];
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. Result values
	     * are chosen from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order of result values is determined by the
	     * order they occur in the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. Result values are chosen from the first array.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. Result values are chosen
	     * from the first array. The comparator is invoked with two arguments:
	     * (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (
	          index < 0
	            ? nativeMax(length + index, 0)
	            : nativeMin(index, length - 1)
	        ) + 1;
	      }
	      if (value !== value) {
	        return baseFindIndex(array, baseIsNaN, index - 1, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = baseRest(function(array, indexes) {
	      indexes = baseFlatten(indexes, 1);
	
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each
	     * element is kept.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = baseRest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = baseClamp(toInteger(n), 0, length);
	      }
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one or more milliseconds.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = baseRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = baseRest(function(func, indexes) {
	      return createWrap(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' ||
	            typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (nonEnumShadows || isPrototype(value)) {
	        return !nativeKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8-9 which returns 'object' for typed array and other constructors.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error('This method is not supported with core-js. Try https://github.com/es-shims.');
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = baseRest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = baseRest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = baseRest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getAllKeysIn(object), getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the
	     * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = baseRest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        key = toKey(key);
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36)(module)))

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var DataTable_1 = __webpack_require__(862);
	var DefaultSorter = (function () {
	    function DefaultSorter(mfTable) {
	        var _this = this;
	        this.mfTable = mfTable;
	        this.isSortedByMeAsc = false;
	        this.isSortedByMeDesc = false;
	        mfTable.onSortChange.subscribe(function (event) {
	            _this.isSortedByMeAsc = (event.sortBy === _this.sortBy && event.sortOrder === "asc");
	            _this.isSortedByMeDesc = (event.sortBy === _this.sortBy && event.sortOrder === "desc");
	        });
	    }
	    DefaultSorter.prototype.sort = function () {
	        if (this.isSortedByMeAsc) {
	            this.mfTable.setSort(this.sortBy, "desc");
	        }
	        else {
	            this.mfTable.setSort(this.sortBy, "asc");
	        }
	    };
	    __decorate([
	        core_1.Input("by"), 
	        __metadata('design:type', String)
	    ], DefaultSorter.prototype, "sortBy", void 0);
	    DefaultSorter = __decorate([
	        core_1.Component({
	            selector: "mfDefaultSorter",
	            template: "\n        <a style=\"cursor: pointer\" (click)=\"sort()\" class=\"text-nowrap\">\n            <ng-content></ng-content>\n            <span *ngIf=\"isSortedByMeAsc\" class=\"glyphicon glyphicon-triangle-top\" aria-hidden=\"true\"></span>\n            <span *ngIf=\"isSortedByMeDesc\" class=\"glyphicon glyphicon-triangle-bottom\" aria-hidden=\"true\"></span>\n        </a>"
	        }), 
	        __metadata('design:paramtypes', [DataTable_1.DataTable])
	    ], DefaultSorter);
	    return DefaultSorter;
	}());
	exports.DefaultSorter = DefaultSorter;
	//# sourceMappingURL=DefaultSorter.js.map

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var DataTable_1 = __webpack_require__(862);
	var Paginator = (function () {
	    function Paginator(injectMfTable) {
	        var _this = this;
	        this.injectMfTable = injectMfTable;
	        this.dataLength = 0;
	        this.onPageChangeSubscriber = function (event) {
	            _this.activePage = event.activePage;
	            _this.rowsOnPage = event.rowsOnPage;
	            _this.dataLength = event.dataLength;
	            _this.lastPage = Math.ceil(_this.dataLength / _this.rowsOnPage);
	        };
	    }
	    Paginator.prototype.ngOnChanges = function (changes) {
	        this.mfTable = this.inputMfTable || this.injectMfTable;
	        this.onPageChangeSubscriber(this.mfTable.getPage());
	        this.mfTable.onPageChange.subscribe(this.onPageChangeSubscriber);
	    };
	    Paginator.prototype.setPage = function (pageNumber) {
	        this.mfTable.setPage(pageNumber, this.rowsOnPage);
	    };
	    Paginator.prototype.setRowsOnPage = function (rowsOnPage) {
	        this.mfTable.setPage(this.activePage, rowsOnPage);
	    };
	    __decorate([
	        core_1.Input("mfTable"), 
	        __metadata('design:type', DataTable_1.DataTable)
	    ], Paginator.prototype, "inputMfTable", void 0);
	    Paginator = __decorate([
	        core_1.Component({
	            selector: "mfPaginator",
	            template: "<ng-content></ng-content>"
	        }),
	        __param(0, core_1.Optional()), 
	        __metadata('design:paramtypes', [DataTable_1.DataTable])
	    ], Paginator);
	    return Paginator;
	}());
	exports.Paginator = Paginator;
	//# sourceMappingURL=Paginator.js.map

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var DataTable_1 = __webpack_require__(862);
	var Paginator_1 = __webpack_require__(865);
	var _ = __webpack_require__(863);
	var BootstrapPaginator = (function () {
	    function BootstrapPaginator() {
	        this.rowsOnPageSet = [];
	        this.minRowsOnPage = 0;
	    }
	    BootstrapPaginator.prototype.ngOnChanges = function (changes) {
	        if (changes.rowsOnPageSet) {
	            this.minRowsOnPage = _.min(this.rowsOnPageSet);
	        }
	    };
	    __decorate([
	        core_1.Input("rowsOnPageSet"), 
	        __metadata('design:type', Object)
	    ], BootstrapPaginator.prototype, "rowsOnPageSet", void 0);
	    __decorate([
	        core_1.Input("mfTable"), 
	        __metadata('design:type', DataTable_1.DataTable)
	    ], BootstrapPaginator.prototype, "mfTable", void 0);
	    BootstrapPaginator = __decorate([
	        core_1.Component({
	            selector: "mfBootstrapPaginator",
	            template: "\n    <mfPaginator #p [mfTable]=\"mfTable\">\n        <nav class=\"pagination\" *ngIf=\"p.dataLength > p.rowsOnPage\">\n            <li [class.disabled]=\"p.activePage <= 1\" (click)=\"p.setPage(1)\">\n                <a style=\"cursor: pointer\">&laquo;</a>\n            </li>\n            <li *ngIf=\"p.activePage > 4 && p.activePage + 1 > p.lastPage\" (click)=\"p.setPage(p.activePage - 4)\">\n                <a style=\"cursor: pointer\">{{p.activePage-4}}</a>\n            </li>\n            <li *ngIf=\"p.activePage > 3 && p.activePage + 2 > p.lastPage\" (click)=\"p.setPage(p.activePage - 3)\">\n                <a style=\"cursor: pointer\">{{p.activePage-3}}</a>\n            </li>\n            <li *ngIf=\"p.activePage > 2\" (click)=\"p.setPage(p.activePage - 2)\">\n                <a style=\"cursor: pointer\">{{p.activePage-2}}</a>\n            </li>\n            <li *ngIf=\"p.activePage > 1\" (click)=\"p.setPage(p.activePage - 1)\">\n                <a style=\"cursor: pointer\">{{p.activePage-1}}</a>\n            </li>\n            <li class=\"active\">\n                <a style=\"cursor: pointer\">{{p.activePage}}</a>\n            </li>\n            <li *ngIf=\"p.activePage + 1 <= p.lastPage\" (click)=\"p.setPage(p.activePage + 1)\">\n                <a style=\"cursor: pointer\">{{p.activePage+1}}</a>\n            </li>\n            <li *ngIf=\"p.activePage + 2 <= p.lastPage\" (click)=\"p.setPage(p.activePage + 2)\">\n                <a style=\"cursor: pointer\">{{p.activePage+2}}</a>\n            </li>\n            <li *ngIf=\"p.activePage + 3 <= p.lastPage && p.activePage < 3\" (click)=\"p.setPage(p.activePage + 3)\">\n                <a style=\"cursor: pointer\">{{p.activePage+3}}</a>\n            </li>\n            <li *ngIf=\"p.activePage + 4 <= p.lastPage && p.activePage < 2\" (click)=\"p.setPage(p.activePage + 4)\">\n                <a style=\"cursor: pointer\">{{p.activePage+4}}</a>\n            </li>\n            <li [class.disabled]=\"p.activePage >= p.lastPage\" (click)=\"p.setPage(p.lastPage)\">\n                <a style=\"cursor: pointer\">&raquo;</a>\n            </li>\n        </nav>\n        <nav class=\"pagination pull-right\" *ngIf=\"p.dataLength > minRowsOnPage\">\n            <li *ngFor=\"let rows of rowsOnPageSet\" [class.active]=\"p.rowsOnPage===rows\" (click)=\"p.setRowsOnPage(rows)\">\n                <a style=\"cursor: pointer\">{{rows}}</a>\n            </li>\n        </nav>\n    </mfPaginator>\n    ",
	            directives: [Paginator_1.Paginator]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BootstrapPaginator);
	    return BootstrapPaginator;
	}());
	exports.BootstrapPaginator = BootstrapPaginator;
	//# sourceMappingURL=BootstrapPaginator.js.map

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(868));


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var paginate_pipe_1 = __webpack_require__(869);
	exports.PaginatePipe = paginate_pipe_1.PaginatePipe;
	var pagination_service_1 = __webpack_require__(870);
	exports.PaginationService = pagination_service_1.PaginationService;
	var pagination_controls_cmp_1 = __webpack_require__(871);
	exports.PaginationControlsCmp = pagination_controls_cmp_1.PaginationControlsCmp;


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var pagination_service_1 = __webpack_require__(870);
	var LARGE_NUMBER = Number.MAX_SAFE_INTEGER;
	var PaginatePipe = (function () {
	    function PaginatePipe(service) {
	        this.service = service;
	        // store the values from the last time the pipe was invoked
	        this.state = {};
	    }
	    PaginatePipe.prototype.transform = function (collection, args) {
	        // When an observable is passed through the AsyncPipe, it will output
	        // `null` until the subscription resolves. In this case, we want to
	        // use the cached data from the `state` object to prevent the NgFor
	        // from flashing empty until the real values arrive.
	        if (args instanceof Array) {
	            // compatible with angular2 before beta16
	            args = args[0];
	        }
	        if (!(collection instanceof Array)) {
	            var _id = args.id || this.service.defaultId;
	            if (this.state[_id]) {
	                return this.state[_id].slice;
	            }
	            else {
	                return collection;
	            }
	        }
	        var serverSideMode = args.totalItems !== undefined;
	        var instance = this.createInstance(collection, args);
	        var id = instance.id;
	        var start, end;
	        var perPage = instance.itemsPerPage;
	        this.service.register(instance);
	        if (!serverSideMode && collection instanceof Array) {
	            perPage = perPage || LARGE_NUMBER;
	            start = (instance.currentPage - 1) * perPage;
	            end = start + perPage;
	            var isIdentical = this.stateIsIdentical(id, collection, start, end);
	            if (isIdentical) {
	                return this.state[id].slice;
	            }
	            else {
	                var slice = collection.slice(start, end);
	                this.saveState(id, collection, slice, start, end);
	                this.service.change.emit(id);
	                return slice;
	            }
	        }
	        // save the state for server-side collection to avoid null
	        // flash as new data loads.
	        this.saveState(id, collection, collection, start, end);
	        return collection;
	    };
	    /**
	     * Create an IPaginationInstance object, using defaults for any optional properties not supplied.
	     */
	    PaginatePipe.prototype.createInstance = function (collection, args) {
	        var config = args;
	        this.checkConfig(config);
	        return {
	            id: config.id || this.service.defaultId,
	            itemsPerPage: config.itemsPerPage || 0,
	            currentPage: config.currentPage || 1,
	            totalItems: config.totalItems || collection.length
	        };
	    };
	    /**
	     * Ensure the argument passed to the filter contains the required properties.
	     */
	    PaginatePipe.prototype.checkConfig = function (config) {
	        var required = ['itemsPerPage', 'currentPage'];
	        var missing = required.filter(function (prop) { return !config.hasOwnProperty(prop); });
	        if (0 < missing.length) {
	            throw new Error("PaginatePipe: Argument is missing the following required properties: " + missing.join(', '));
	        }
	    };
	    /**
	     * To avoid returning a brand new array each time the pipe is run, we store the state of the sliced
	     * array for a given id. This means that the next time the pipe is run on this collection & id, we just
	     * need to check that the collection, start and end points are all identical, and if so, return the
	     * last sliced array.
	     */
	    PaginatePipe.prototype.saveState = function (id, collection, slice, start, end) {
	        this.state[id] = {
	            collection: collection,
	            size: collection.length,
	            slice: slice,
	            start: start,
	            end: end
	        };
	    };
	    /**
	     * For a given id, returns true if the collection, size, start and end values are identical.
	     */
	    PaginatePipe.prototype.stateIsIdentical = function (id, collection, start, end) {
	        var state = this.state[id];
	        if (!state) {
	            return false;
	        }
	        var isMetaDataIdentical = state.size === collection.length &&
	            state.start === start &&
	            state.end === end;
	        if (!isMetaDataIdentical) {
	            return false;
	        }
	        return state.slice.every(function (element, index) { return element === collection[start + index]; });
	    };
	    PaginatePipe = __decorate([
	        core_1.Pipe({
	            name: 'paginate',
	            pure: false
	        }), 
	        __metadata('design:paramtypes', [pagination_service_1.PaginationService])
	    ], PaginatePipe);
	    return PaginatePipe;
	}());
	exports.PaginatePipe = PaginatePipe;


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(1);
	var PaginationService = (function () {
	    function PaginationService() {
	        this.change = new core_1.EventEmitter();
	        this.instances = {};
	        this.DEFAULT_ID = 'DEFAULT_PAGINATION_ID';
	    }
	    Object.defineProperty(PaginationService.prototype, "defaultId", {
	        get: function () { return this.DEFAULT_ID; },
	        enumerable: true,
	        configurable: true
	    });
	    PaginationService.prototype.register = function (instance) {
	        if (!instance.id) {
	            instance.id = this.DEFAULT_ID;
	        }
	        if (!this.instances[instance.id]) {
	            this.instances[instance.id] = instance;
	            this.change.emit(instance.id);
	        }
	        else {
	            var changed = this.updateInstance(instance);
	            if (changed) {
	                this.change.emit(instance.id);
	            }
	        }
	    };
	    /**
	     * Check each property of the instance and update any that have changed. Return
	     * true if any changes were made, else return false.
	     */
	    PaginationService.prototype.updateInstance = function (instance) {
	        var changed = false;
	        for (var prop in this.instances[instance.id]) {
	            if (instance[prop] !== this.instances[instance.id][prop]) {
	                this.instances[instance.id][prop] = instance[prop];
	                changed = true;
	            }
	        }
	        return changed;
	    };
	    /**
	     * Returns the current page number.
	     */
	    PaginationService.prototype.getCurrentPage = function (id) {
	        if (this.instances[id]) {
	            return this.instances[id].currentPage;
	        }
	    };
	    /**
	     * Sets the current page number.
	     */
	    PaginationService.prototype.setCurrentPage = function (id, page) {
	        if (this.instances[id]) {
	            var instance = this.instances[id];
	            var maxPage = Math.ceil(instance.totalItems / instance.itemsPerPage);
	            if (page <= maxPage && 1 <= page) {
	                this.instances[id].currentPage = page;
	                this.change.emit(id);
	            }
	        }
	    };
	    /**
	     * Sets the value of instance.totalItems
	     */
	    PaginationService.prototype.setTotalItems = function (id, totalItems) {
	        if (this.instances[id] && 0 <= totalItems) {
	            this.instances[id].totalItems = totalItems;
	            this.change.emit(id);
	        }
	    };
	    /**
	     * Sets the value of instance.itemsPerPage.
	     */
	    PaginationService.prototype.setItemsPerPage = function (id, itemsPerPage) {
	        if (this.instances[id]) {
	            this.instances[id].itemsPerPage = itemsPerPage;
	            this.change.emit(id);
	        }
	    };
	    /**
	     * Returns a clone of the pagination instance object matching the id. If no
	     * id specified, returns the instance corresponding to the default id.
	     */
	    PaginationService.prototype.getInstance = function (id) {
	        if (id === void 0) { id = this.DEFAULT_ID; }
	        if (this.instances[id]) {
	            return this.clone(this.instances[id]);
	        }
	        return {};
	    };
	    /**
	     * Perform a shallow clone of an object.
	     */
	    PaginationService.prototype.clone = function (obj) {
	        var target = {};
	        for (var i in obj) {
	            if (obj.hasOwnProperty(i)) {
	                target[i] = obj[i];
	            }
	        }
	        return target;
	    };
	    return PaginationService;
	}());
	exports.PaginationService = PaginationService;


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var pagination_service_1 = __webpack_require__(870);
	var template_1 = __webpack_require__(872);
	var PaginationControlsCmp = (function () {
	    function PaginationControlsCmp(service, changeDetectorRef) {
	        var _this = this;
	        this.service = service;
	        this.changeDetectorRef = changeDetectorRef;
	        this.maxSize = 7;
	        this.pageChange = new core_1.EventEmitter();
	        this.pages = [];
	        this.hasTemplate = false;
	        this._directionLinks = true;
	        this._autoHide = false;
	        this.changeSub = this.service.change
	            .subscribe(function (id) {
	            if (_this.id === id) {
	                _this.updatePageLinks();
	                _this.changeDetectorRef.markForCheck();
	            }
	        });
	    }
	    Object.defineProperty(PaginationControlsCmp.prototype, "directionLinks", {
	        get: function () {
	            return this._directionLinks;
	        },
	        set: function (value) {
	            this._directionLinks = !!value && value !== 'false';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationControlsCmp.prototype, "autoHide", {
	        get: function () {
	            return this._autoHide;
	        },
	        set: function (value) {
	            this._autoHide = !!value && value !== 'false';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PaginationControlsCmp.prototype.ngOnInit = function () {
	        if (this.id === undefined) {
	            this.id = this.service.defaultId;
	        }
	        this.updatePageLinks();
	    };
	    PaginationControlsCmp.prototype.ngOnChanges = function () {
	        this.updatePageLinks();
	    };
	    PaginationControlsCmp.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        if (this.template && 0 < this.template.nativeElement.children.length) {
	            this.hasTemplate = true;
	            setTimeout(function () { return _this.changeDetectorRef.markForCheck(); });
	        }
	    };
	    PaginationControlsCmp.prototype.ngOnDestroy = function () {
	        this.changeSub.unsubscribe();
	    };
	    /**
	     * Go to the previous page
	     */
	    PaginationControlsCmp.prototype.previous = function () {
	        this.setCurrent(this.getCurrent() - 1);
	    };
	    /**
	     * Go to the next page
	     */
	    PaginationControlsCmp.prototype.next = function () {
	        this.setCurrent(this.getCurrent() + 1);
	    };
	    /**
	     * Returns true if current page is first page
	     */
	    PaginationControlsCmp.prototype.isFirstPage = function () {
	        return this.getCurrent() === 1;
	    };
	    /**
	     * Returns true if current page is last page
	     */
	    PaginationControlsCmp.prototype.isLastPage = function () {
	        return this.getLastPage() === this.getCurrent();
	    };
	    /**
	     * Set the current page number.
	     */
	    PaginationControlsCmp.prototype.setCurrent = function (page) {
	        this.pageChange.emit(page);
	    };
	    /**
	     * Get the current page number.
	     */
	    PaginationControlsCmp.prototype.getCurrent = function () {
	        return this.service.getCurrentPage(this.id);
	    };
	    /**
	     * Returns the last page number
	     */
	    PaginationControlsCmp.prototype.getLastPage = function () {
	        var inst = this.service.getInstance(this.id);
	        if (inst.totalItems < 1) {
	            // when there are 0 or fewer (an error case) items, there are no "pages" as such,
	            // but it makes sense to consider a single, empty page as the last page.
	            return 1;
	        }
	        return Math.ceil(inst.totalItems / inst.itemsPerPage);
	    };
	    /**
	     * Updates the page links and checks that the current page is valid. Should run whenever the
	     * PaginationService.change stream emits a value matching the current ID, or when any of the
	     * input values changes.
	     */
	    PaginationControlsCmp.prototype.updatePageLinks = function () {
	        var inst = this.service.getInstance(this.id);
	        this.pages = this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, this.maxSize);
	        var correctedCurrentPage = this.outOfBoundCorrection(inst);
	        if (correctedCurrentPage !== inst.currentPage) {
	            this.setCurrent(correctedCurrentPage);
	        }
	    };
	    /**
	     * Checks that the instance.currentPage property is within bounds for the current page range.
	     * If not, return a correct value for currentPage, or the current value if OK.
	     */
	    PaginationControlsCmp.prototype.outOfBoundCorrection = function (instance) {
	        var totalPages = Math.ceil(instance.totalItems / instance.itemsPerPage);
	        if (totalPages < instance.currentPage && 0 < totalPages) {
	            return totalPages;
	        }
	        else if (instance.currentPage < 1) {
	            return 1;
	        }
	        return instance.currentPage;
	    };
	    /**
	     * Returns an array of IPage objects to use in the pagination controls.
	     */
	    PaginationControlsCmp.prototype.createPageArray = function (currentPage, itemsPerPage, totalItems, paginationRange) {
	        // paginationRange could be a string if passed from attribute, so cast to number.
	        paginationRange = +paginationRange;
	        var pages = [];
	        var totalPages = Math.ceil(totalItems / itemsPerPage);
	        var halfWay = Math.ceil(paginationRange / 2);
	        var isStart = currentPage <= halfWay;
	        var isEnd = totalPages - halfWay < currentPage;
	        var isMiddle = !isStart && !isEnd;
	        var ellipsesNeeded = paginationRange < totalPages;
	        var i = 1;
	        while (i <= totalPages && i <= paginationRange) {
	            var label = void 0;
	            var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
	            var openingEllipsesNeeded = (i === 2 && (isMiddle || isEnd));
	            var closingEllipsesNeeded = (i === paginationRange - 1 && (isMiddle || isStart));
	            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
	                label = '...';
	            }
	            else {
	                label = pageNumber;
	            }
	            pages.push({
	                label: label,
	                value: pageNumber
	            });
	            i++;
	        }
	        return pages;
	    };
	    /**
	     * Given the position in the sequence of pagination links [i],
	     * figure out what page number corresponds to that position.
	     */
	    PaginationControlsCmp.prototype.calculatePageNumber = function (i, currentPage, paginationRange, totalPages) {
	        var halfWay = Math.ceil(paginationRange / 2);
	        if (i === paginationRange) {
	            return totalPages;
	        }
	        else if (i === 1) {
	            return i;
	        }
	        else if (paginationRange < totalPages) {
	            if (totalPages - halfWay < currentPage) {
	                return totalPages - paginationRange + i;
	            }
	            else if (halfWay < currentPage) {
	                return currentPage - halfWay + i;
	            }
	            else {
	                return i;
	            }
	        }
	        else {
	            return i;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], PaginationControlsCmp.prototype, "id", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], PaginationControlsCmp.prototype, "maxSize", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PaginationControlsCmp.prototype, "directionLinks", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PaginationControlsCmp.prototype, "autoHide", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], PaginationControlsCmp.prototype, "pageChange", void 0);
	    __decorate([
	        core_1.ViewChild('template'), 
	        __metadata('design:type', Object)
	    ], PaginationControlsCmp.prototype, "template", void 0);
	    PaginationControlsCmp = __decorate([
	        core_1.Component({
	            selector: 'pagination-controls',
	            template: template_1.DEFAULT_TEMPLATE,
	            styles: [template_1.DEFAULT_STYLES],
	            changeDetection: core_1.ChangeDetectionStrategy.OnPush
	        }), 
	        __metadata('design:paramtypes', [pagination_service_1.PaginationService, core_1.ChangeDetectorRef])
	    ], PaginationControlsCmp);
	    return PaginationControlsCmp;
	}());
	exports.PaginationControlsCmp = PaginationControlsCmp;


/***/ },
/* 872 */
/***/ function(module, exports) {

	/**
	 * The default template and styles for the pagination links are borrowed directly
	 * from Zurb Foundation 6: http://foundation.zurb.com/sites/docs/pagination.html
	 */
	"use strict";
	exports.DEFAULT_TEMPLATE = "\n    <div #template>\n        <ng-content></ng-content>\n    </div>\n    <ul class=\"ng2-pagination\" \n        role=\"navigation\" \n        aria-label=\"Pagination\" \n        *ngIf=\"!hasTemplate && !(autoHide && pages.length <= 1)\">\n\n        <li class=\"pagination-previous\" [class.disabled]=\"isFirstPage()\" *ngIf=\"directionLinks\"> \n            <a *ngIf=\"1 < getCurrent()\" (click)=\"previous()\" aria-label=\"Next page\">\n                Previous <span class=\"show-for-sr\">page</span>\n            </a>\n            <span *ngIf=\"isFirstPage()\">Previous <span class=\"show-for-sr\">page</span></span>\n        </li>\n\n        <li [class.current]=\"getCurrent() === page.value\" *ngFor=\"let page of pages\">\n            <a (click)=\"setCurrent(page.value)\" *ngIf=\"getCurrent() !== page.value\">\n                <span class=\"show-for-sr\">Page</span>\n                <span>{{ page.label }}</span>\n            </a>\n            <div *ngIf=\"getCurrent() === page.value\">\n                <span class=\"show-for-sr\">You're on page</span>\n                <span>{{ page.label }}</span> \n            </div>\n        </li>\n\n        <li class=\"pagination-next\" [class.disabled]=\"isLastPage()\" *ngIf=\"directionLinks\">\n            <a *ngIf=\"!isLastPage()\" (click)=\"next()\" aria-label=\"Next page\">\n                Next <span class=\"show-for-sr\">page</span>\n            </a>\n            <span *ngIf=\"isLastPage()\">Next <span class=\"show-for-sr\">page</span></span>\n        </li>\n\n    </ul>\n    ";
	exports.DEFAULT_STYLES = "\n.ng2-pagination {\n  margin-left: 0;\n  margin-bottom: 1rem; }\n  .ng2-pagination::before, .ng2-pagination::after {\n    content: ' ';\n    display: table; }\n  .ng2-pagination::after {\n    clear: both; }\n  .ng2-pagination li {\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    font-size: 0.875rem;\n    margin-right: 0.0625rem;\n    border-radius: 0; }\n  .ng2-pagination li {\n    display: inline-block; }\n  .ng2-pagination a,\n  .ng2-pagination button {\n    color: #0a0a0a; \n    display: block;\n    padding: 0.1875rem 0.625rem;\n    border-radius: 0; }\n    .ng2-pagination a:hover,\n    .ng2-pagination button:hover {\n      background: #e6e6e6; }\n  .ng2-pagination .current {\n    padding: 0.1875rem 0.625rem;\n    background: #2199e8;\n    color: #fefefe;\n    cursor: default; }\n  .ng2-pagination .disabled {\n    padding: 0.1875rem 0.625rem;\n    color: #cacaca;\n    cursor: default; } \n    .ng2-pagination .disabled:hover {\n      background: transparent; }\n  .ng2-pagination .ellipsis::after {\n    content: '\u2026';\n    padding: 0.1875rem 0.625rem;\n    color: #0a0a0a; }\n\n.ng2-pagination .pagination-previous a::before,\n.ng2-pagination .pagination-previous.disabled::before { \n  content: '\u00AB';\n  display: inline-block;\n  margin-right: 0.5rem; }\n\n.ng2-pagination .pagination-next a::after,\n.ng2-pagination .pagination-next.disabled::after {\n  content: '\u00BB';\n  display: inline-block;\n  margin-left: 0.5rem; }\n\n.ng2-pagination .show-for-sr {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0); }";


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var contract_1 = __webpack_require__(874);
	var vehicleBrand_1 = __webpack_require__(882);
	var vehicleType_1 = __webpack_require__(883);
	var kmHistory_1 = __webpack_require__(884);
	var procedure_1 = __webpack_require__(885);
	var Vehicle = (function () {
	    function Vehicle(other) {
	        this.type = new vehicleType_1.VehicleType();
	        this.brand = new vehicleBrand_1.VehicleBrand();
	        this.registrable = true;
	        this.contract = new contract_1.Contract(null);
	        this.kmHistory = new kmHistory_1.KmHistory(null);
	        this.kmHistories = [];
	        this.procedures = [];
	        this.procedure = new procedure_1.Procedure(null);
	        this.patentPayment = new procedure_1.Procedure(null);
	        if (other) {
	            this.id = other.id;
	            this.patent = other.patent;
	            this.type = new vehicleType_1.VehicleType(other.type);
	            this.brand = new vehicleBrand_1.VehicleBrand(other.brand);
	            this.version = other.version;
	            this.model = other.model;
	            this.year = other.year;
	            this.engineNumber = other.engineNumber;
	            this.registrable = other.registrable;
	            this.center = other.center;
	            this.contract = new contract_1.Contract(other.contract);
	            this.purchaseOrderEntryDate = other.purchaseOrderEntryDate;
	            this.purchaseOrderAmount = other.purchaseOrderAmount;
	            this.purchaseOrderDueDate = other.purchaseOrderDueDate;
	            this.kmHistory = new kmHistory_1.KmHistory(other.kmHistory);
	            this.kmHistories = other.kmHistories.map(function (kmHistory) { return new kmHistory_1.KmHistory(kmHistory); });
	            this.procedures = other.procedures.map(function (procedure) { return new procedure_1.Procedure(procedure); });
	            this.procedure = new procedure_1.Procedure(other.procedure);
	            this.patentPayment = new procedure_1.Procedure(other.patentPayment);
	        }
	    }
	    return Vehicle;
	}());
	exports.Vehicle = Vehicle;


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var bank_1 = __webpack_require__(875);
	var address_1 = __webpack_require__(876);
	var Contract = (function () {
	    function Contract(other) {
	        this.bank = new bank_1.Bank();
	        this.address = new address_1.Address(null);
	        this.contacts = [];
	        if (other) {
	            this.id = other.id;
	            this.contractNumber = other.contractNumber;
	            this.bank = other.bank;
	            this.businessName = other.businessName;
	            this.cuit = other.cuit;
	            this.phone = other.phone;
	            this.address = new address_1.Address(other.address);
	            this.contacts = other.contacts;
	        }
	    }
	    Contract.prototype.getContact = function () {
	        if (this.contacts && this.contacts.length > 0) {
	            return this.contacts[0];
	        }
	        return null;
	    };
	    return Contract;
	}());
	exports.Contract = Contract;


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var address_1 = __webpack_require__(876);
	var contact_1 = __webpack_require__(879);
	var lookAndFeelBank_1 = __webpack_require__(880);
	var bankDocument_1 = __webpack_require__(881);
	var Bank = (function () {
	    function Bank(other) {
	        this.address = new address_1.Address(null);
	        this.contacts = [];
	        this.lookAndFeelData = new lookAndFeelBank_1.LookAndFeelBank(null);
	        if (other) {
	            this.id = other.id;
	            this.tempId = other.tempId;
	            this.name = other.name;
	            this.phone = other.phone;
	            this.address = new address_1.Address(other.address);
	            this.contacts = other.contacts.map(function (contact) { return new contact_1.Contact(contact); });
	            this.lookAndFeelData = new lookAndFeelBank_1.LookAndFeelBank(other.lookAndFeelData);
	            this.logo = new bankDocument_1.BankDocument(other.logo);
	        }
	    }
	    return Bank;
	}());
	exports.Bank = Bank;


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var city_1 = __webpack_require__(877);
	var Address = (function () {
	    function Address(other) {
	        this.city = new city_1.City(null);
	        if (other) {
	            this.street = other.street;
	            this.number = other.number;
	            this.floor = other.floor;
	            this.department = other.department;
	            this.zipCode = other.zipCode;
	            this.city = other.city;
	        }
	    }
	    Address.prototype.toString = function () {
	        var address = this.street ? this.street.trim() : '';
	        var conector = [' ', ', Piso: ', ', Dpto: ', ', CP: ', ', ', ', '];
	        address = address.concat(this.number ? (address == '' ? '' : conector[0]) + this.number.trim() : '');
	        address = address.concat(this.floor ? (address == '' ? '' : conector[1]) + this.floor.trim() : '');
	        address = address.concat(this.department ? (address == '' ? '' : conector[2]) + this.department.trim() : '');
	        address = address.concat(this.zipCode ? (address == '' ? '' : conector[3]) + this.zipCode.trim() : '');
	        address = address.concat((this.city && this.city.name) ? (address == '' ? '' : conector[4]) + this.city.name.trim() : '');
	        address = address.concat((this.city && this.city.state && this.city.state.name) ? (address == '' ? '' : conector[5]) + this.city.state.name.trim() : '');
	        return address;
	    };
	    return Address;
	}());
	exports.Address = Address;


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var state_1 = __webpack_require__(878);
	var City = (function () {
	    function City(other) {
	        this.state = new state_1.State(null);
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	            this.state = other.state;
	            this.completeName = this.name + (!this.state) ? '' : ' - ' + this.state.name;
	        }
	    }
	    return City;
	}());
	exports.City = City;


/***/ },
/* 878 */
/***/ function(module, exports) {

	"use strict";
	var State = (function () {
	    function State(other) {
	        if (other) {
	            this.name = other.name;
	        }
	    }
	    return State;
	}());
	exports.State = State;


/***/ },
/* 879 */
/***/ function(module, exports) {

	"use strict";
	var Contact = (function () {
	    function Contact(other) {
	        if (other) {
	            this.name = other.name;
	            this.phone = other.phone;
	            this.email = other.email;
	        }
	    }
	    return Contact;
	}());
	exports.Contact = Contact;


/***/ },
/* 880 */
/***/ function(module, exports) {

	"use strict";
	/**
	 *
	 * Created by jlado on 19/8/16.
	 */
	var LookAndFeelBank = (function () {
	    function LookAndFeelBank(other) {
	        if (other) {
	            this.font = other.font;
	            this.fontColor = other.fontColor;
	            this.backgroundColor = other.backgroundColor;
	        }
	    }
	    return LookAndFeelBank;
	}());
	exports.LookAndFeelBank = LookAndFeelBank;


/***/ },
/* 881 */
/***/ function(module, exports) {

	"use strict";
	/**
	 *
	 * Created by jlado on 26/8/16.
	 */
	var BankDocument = (function () {
	    function BankDocument(other) {
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	            this.contentType = other.contentType;
	        }
	    }
	    return BankDocument;
	}());
	exports.BankDocument = BankDocument;


/***/ },
/* 882 */
/***/ function(module, exports) {

	"use strict";
	var VehicleBrand = (function () {
	    function VehicleBrand(other) {
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	        }
	    }
	    VehicleBrand.prototype.toString = function () {
	        return this.name;
	    };
	    return VehicleBrand;
	}());
	exports.VehicleBrand = VehicleBrand;


/***/ },
/* 883 */
/***/ function(module, exports) {

	"use strict";
	var VehicleType = (function () {
	    function VehicleType(other) {
	        if (other) {
	            this.id = other.id;
	            this.description = other.description;
	        }
	    }
	    VehicleType.prototype.toString = function () {
	        return this.description;
	    };
	    return VehicleType;
	}());
	exports.VehicleType = VehicleType;


/***/ },
/* 884 */
/***/ function(module, exports) {

	"use strict";
	var KmHistory = (function () {
	    function KmHistory(other) {
	        if (other) {
	            this.id = other.id;
	            this.creationDate = other.creationDate;
	            this.loadDate = other.loadDate;
	            this.km = other.km;
	            this.service = other.service;
	            this.comments = other.comments;
	            this.loadDateSince = other.loadDateSince;
	            this.loadDateUntil = other.loadDateUntil;
	        }
	    }
	    return KmHistory;
	}());
	exports.KmHistory = KmHistory;


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var procedureType_1 = __webpack_require__(886);
	var ProcedureDocument_1 = __webpack_require__(887);
	var AddPatentPayment_1 = __webpack_require__(888);
	var Procedure = (function () {
	    function Procedure(other) {
	        this.type = new procedureType_1.ProcedureType(null);
	        this.patentPayment = new AddPatentPayment_1.AddPatentPayment(null);
	        this.sent = false;
	        this.withSendMail = false;
	        if (other) {
	            this.id = other.id;
	            this.tempId = other.tempId;
	            this.creationDate = other.creationDate;
	            this.type = new procedureType_1.ProcedureType(other.type);
	            this.expirationType = other.expirationType;
	            this.customDate = other.customDate;
	            this.expirationDateSince = other.expirationDateSince;
	            this.expirationDateUntil = other.expirationDateUntil;
	            this.description = other.description;
	            this.comment = other.comment;
	            this.done = other.done;
	            this.patentPayment = new AddPatentPayment_1.AddPatentPayment(other.patentPayment);
	            this.vehicle = other.vehicle;
	            this.document = new ProcedureDocument_1.ProcedureDocument(other.document);
	            this.withSendMail = other.withSendMail;
	            this.sent = other.sent;
	        }
	    }
	    return Procedure;
	}());
	exports.Procedure = Procedure;


/***/ },
/* 886 */
/***/ function(module, exports) {

	"use strict";
	var ProcedureType = (function () {
	    function ProcedureType(other) {
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	            this.description = other.description;
	        }
	    }
	    ProcedureType.prototype.toString = function () {
	        return this.description;
	    };
	    return ProcedureType;
	}());
	exports.ProcedureType = ProcedureType;


/***/ },
/* 887 */
/***/ function(module, exports) {

	"use strict";
	var ProcedureDocument = (function () {
	    function ProcedureDocument(other) {
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	            this.contentType = other.contentType;
	            this.documentType = other.documentType;
	            this.entryDate = other.entryDate;
	        }
	    }
	    return ProcedureDocument;
	}());
	exports.ProcedureDocument = ProcedureDocument;


/***/ },
/* 888 */
/***/ function(module, exports) {

	"use strict";
	var AddPatentPayment = (function () {
	    function AddPatentPayment(other) {
	        if (other) {
	            this.solicitudePerson = other.solicitudePerson;
	            this.solicitudeDate = other.solicitudeDate;
	        }
	    }
	    return AddPatentPayment;
	}());
	exports.AddPatentPayment = AddPatentPayment;


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(890));
	__export(__webpack_require__(895));
	__export(__webpack_require__(891));
	var file_select_directive_2 = __webpack_require__(890);
	var file_drop_directive_2 = __webpack_require__(895);
	exports.FILE_UPLOAD_DIRECTIVES = [file_select_directive_2.FileSelectDirective, file_drop_directive_2.FileDropDirective];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    directives: [
	        exports.FILE_UPLOAD_DIRECTIVES
	    ]
	};


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var file_uploader_class_1 = __webpack_require__(891);
	// todo: filters
	var FileSelectDirective = (function () {
	    function FileSelectDirective(element) {
	        this.element = element;
	    }
	    FileSelectDirective.prototype.getOptions = function () {
	        return this.uploader.options;
	    };
	    FileSelectDirective.prototype.getFilters = function () {
	        return void 0;
	    };
	    FileSelectDirective.prototype.isEmptyAfterSelection = function () {
	        return !!this.element.nativeElement.attributes.multiple;
	    };
	    FileSelectDirective.prototype.onChange = function () {
	        // let files = this.uploader.isHTML5 ? this.element.nativeElement[0].files : this.element.nativeElement[0];
	        var files = this.element.nativeElement.files;
	        var options = this.getOptions();
	        var filters = this.getFilters();
	        // if(!this.uploader.isHTML5) this.destroy();
	        this.uploader.addToQueue(files, options, filters);
	        if (this.isEmptyAfterSelection()) {
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', file_uploader_class_1.FileUploader)
	    ], FileSelectDirective.prototype, "uploader", void 0);
	    __decorate([
	        core_1.HostListener('change'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', Object)
	    ], FileSelectDirective.prototype, "onChange", null);
	    FileSelectDirective = __decorate([
	        core_1.Directive({ selector: '[ng2FileSelect]' }), 
	        __metadata('design:paramtypes', [core_1.ElementRef])
	    ], FileSelectDirective);
	    return FileSelectDirective;
	}());
	exports.FileSelectDirective = FileSelectDirective;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var file_like_object_class_1 = __webpack_require__(892);
	var file_item_class_1 = __webpack_require__(893);
	var file_type_class_1 = __webpack_require__(894);
	function isFile(value) {
	    return (File && value instanceof File);
	}
	var FileUploader = (function () {
	    function FileUploader(options) {
	        this.isUploading = false;
	        this.queue = [];
	        this.progress = 0;
	        this._nextIndex = 0;
	        this.options = {
	            autoUpload: false,
	            isHTML5: true,
	            filters: [],
	            removeAfterUpload: false
	        };
	        this.setOptions(options);
	    }
	    FileUploader.prototype.setOptions = function (options) {
	        this.options = Object.assign(this.options, options);
	        this.authToken = options.authToken;
	        this.autoUpload = options.autoUpload;
	        this.options.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
	        if (this.options.maxFileSize) {
	            this.options.filters.unshift({ name: 'fileSize', fn: this._fileSizeFilter });
	        }
	        if (this.options.allowedFileType) {
	            this.options.filters.unshift({ name: 'fileType', fn: this._fileTypeFilter });
	        }
	        if (this.options.allowedMimeType) {
	            this.options.filters.unshift({ name: 'mimeType', fn: this._mimeTypeFilter });
	        }
	        // this.options.filters.unshift({name: 'folder', fn: this._folderFilter});
	    };
	    FileUploader.prototype.addToQueue = function (files, options, filters) {
	        var _this = this;
	        var list = [];
	        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
	            var file = files_1[_i];
	            list.push(file);
	        }
	        var arrayOfFilters = this._getFilters(filters);
	        var count = this.queue.length;
	        var addedFileItems = [];
	        list.map(function (some) {
	            if (!options) {
	                options = _this.options;
	            }
	            var temp = new file_like_object_class_1.FileLikeObject(some);
	            if (_this._isValidFile(temp, arrayOfFilters, options)) {
	                var fileItem = new file_item_class_1.FileItem(_this, some, options);
	                addedFileItems.push(fileItem);
	                _this.queue.push(fileItem);
	                _this._onAfterAddingFile(fileItem);
	            }
	            else {
	                var filter = arrayOfFilters[_this._failFilterIndex];
	                _this._onWhenAddingFileFailed(temp, filter, options);
	            }
	        });
	        if (this.queue.length !== count) {
	            this._onAfterAddingAll(addedFileItems);
	            this.progress = this._getTotalProgress();
	        }
	        this._render();
	        if (this.options.autoUpload) {
	            this.uploadAll();
	        }
	    };
	    FileUploader.prototype.removeFromQueue = function (value) {
	        var index = this.getIndexOfItem(value);
	        var item = this.queue[index];
	        if (item.isUploading) {
	            item.cancel();
	        }
	        this.queue.splice(index, 1);
	        this.progress = this._getTotalProgress();
	    };
	    FileUploader.prototype.clearQueue = function () {
	        while (this.queue.length) {
	            this.queue[0].remove();
	        }
	        this.progress = 0;
	    };
	    FileUploader.prototype.uploadItem = function (value) {
	        var index = this.getIndexOfItem(value);
	        var item = this.queue[index];
	        var transport = this.options.isHTML5 ? '_xhrTransport' : '_iframeTransport';
	        item._prepareToUploading();
	        if (this.isUploading) {
	            return;
	        }
	        this.isUploading = true;
	        this[transport](item);
	    };
	    FileUploader.prototype.cancelItem = function (value) {
	        var index = this.getIndexOfItem(value);
	        var item = this.queue[index];
	        var prop = this.options.isHTML5 ? '_xhr' : '_form';
	        if (item && item.isUploading) {
	            item[prop].abort();
	        }
	    };
	    FileUploader.prototype.uploadAll = function () {
	        var items = this.getNotUploadedItems().filter(function (item) { return !item.isUploading; });
	        if (!items.length) {
	            return;
	        }
	        items.map(function (item) { return item._prepareToUploading(); });
	        items[0].upload();
	    };
	    FileUploader.prototype.cancelAll = function () {
	        var items = this.getNotUploadedItems();
	        items.map(function (item) { return item.cancel(); });
	    };
	    FileUploader.prototype.isFile = function (value) {
	        return isFile(value);
	    };
	    FileUploader.prototype.isFileLikeObject = function (value) {
	        return value instanceof file_like_object_class_1.FileLikeObject;
	    };
	    FileUploader.prototype.getIndexOfItem = function (value) {
	        return typeof value === 'number' ? value : this.queue.indexOf(value);
	    };
	    FileUploader.prototype.getNotUploadedItems = function () {
	        return this.queue.filter(function (item) { return !item.isUploaded; });
	    };
	    FileUploader.prototype.getReadyItems = function () {
	        return this.queue
	            .filter(function (item) { return (item.isReady && !item.isUploading); })
	            .sort(function (item1, item2) { return item1.index - item2.index; });
	    };
	    FileUploader.prototype.destroy = function () {
	        return void 0;
	        /*forEach(this._directives, (key) => {
	         forEach(this._directives[key], (object) => {
	         object.destroy();
	         });
	         });*/
	    };
	    FileUploader.prototype.onAfterAddingAll = function (fileItems) {
	        return { fileItems: fileItems };
	    };
	    FileUploader.prototype.onBuildItemForm = function (fileItem, form) {
	        return { fileItem: fileItem, form: form };
	    };
	    FileUploader.prototype.onAfterAddingFile = function (fileItem) {
	        return { fileItem: fileItem };
	    };
	    FileUploader.prototype.onWhenAddingFileFailed = function (item, filter, options) {
	        return { item: item, filter: filter, options: options };
	    };
	    FileUploader.prototype.onBeforeUploadItem = function (fileItem) {
	        return { fileItem: fileItem };
	    };
	    FileUploader.prototype.onProgressItem = function (fileItem, progress) {
	        return { fileItem: fileItem, progress: progress };
	    };
	    FileUploader.prototype.onProgressAll = function (progress) {
	        return { progress: progress };
	    };
	    FileUploader.prototype.onSuccessItem = function (item, response, status, headers) {
	        return { item: item, response: response, status: status, headers: headers };
	    };
	    FileUploader.prototype.onErrorItem = function (item, response, status, headers) {
	        return { item: item, response: response, status: status, headers: headers };
	    };
	    FileUploader.prototype.onCancelItem = function (item, response, status, headers) {
	        return { item: item, response: response, status: status, headers: headers };
	    };
	    FileUploader.prototype.onCompleteItem = function (item, response, status, headers) {
	        return { item: item, response: response, status: status, headers: headers };
	    };
	    FileUploader.prototype.onCompleteAll = function () {
	        return void 0;
	    };
	    FileUploader.prototype._mimeTypeFilter = function (item) {
	        return !(this.options.allowedMimeType && this.options.allowedMimeType.indexOf(item.type) === -1);
	    };
	    FileUploader.prototype._fileSizeFilter = function (item) {
	        return !(this.options.maxFileSize && item.size > this.options.maxFileSize);
	    };
	    FileUploader.prototype._fileTypeFilter = function (item) {
	        return !(this.options.allowedFileType &&
	            this.options.allowedFileType.indexOf(file_type_class_1.FileType.getMimeClass(item)) === -1);
	    };
	    FileUploader.prototype._onErrorItem = function (item, response, status, headers) {
	        item._onError(response, status, headers);
	        this.onErrorItem(item, response, status, headers);
	    };
	    FileUploader.prototype._onCompleteItem = function (item, response, status, headers) {
	        item._onComplete(response, status, headers);
	        this.onCompleteItem(item, response, status, headers);
	        var nextItem = this.getReadyItems()[0];
	        this.isUploading = false;
	        if (nextItem) {
	            nextItem.upload();
	            return;
	        }
	        this.onCompleteAll();
	        this.progress = this._getTotalProgress();
	        this._render();
	    };
	    FileUploader.prototype._headersGetter = function (parsedHeaders) {
	        return function (name) {
	            if (name) {
	                return parsedHeaders[name.toLowerCase()] || void 0;
	            }
	            return parsedHeaders;
	        };
	    };
	    FileUploader.prototype._xhrTransport = function (item) {
	        var _this = this;
	        var xhr = item._xhr = new XMLHttpRequest();
	        var form = new FormData();
	        this._onBeforeUploadItem(item);
	        // todo
	        /*item.formData.map(obj => {
	         obj.map((value, key) => {
	         form.append(key, value);
	         });
	         });*/
	        if (typeof item._file.size !== 'number') {
	            throw new TypeError('The file specified is no longer valid');
	        }
	        this._onBuildItemForm(item, form);
	        form.append(item.alias, item._file, item.file.name);
	        xhr.upload.onprogress = function (event) {
	            var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
	            _this._onProgressItem(item, progress);
	        };
	        xhr.onload = function () {
	            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
	            var response = _this._transformResponse(xhr.response, headers);
	            var gist = _this._isSuccessCode(xhr.status) ? 'Success' : 'Error';
	            var method = '_on' + gist + 'Item';
	            _this[method](item, response, xhr.status, headers);
	            _this._onCompleteItem(item, response, xhr.status, headers);
	        };
	        xhr.onerror = function () {
	            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
	            var response = _this._transformResponse(xhr.response, headers);
	            _this._onErrorItem(item, response, xhr.status, headers);
	            _this._onCompleteItem(item, response, xhr.status, headers);
	        };
	        xhr.onabort = function () {
	            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
	            var response = _this._transformResponse(xhr.response, headers);
	            _this._onCancelItem(item, response, xhr.status, headers);
	            _this._onCompleteItem(item, response, xhr.status, headers);
	        };
	        xhr.open(item.method, item.url, true);
	        xhr.withCredentials = item.withCredentials;
	        // todo
	        /*item.headers.map((value, name) => {
	         xhr.setRequestHeader(name, value);
	         });*/
	        if (this.options.headers) {
	            for (var _i = 0, _a = this.options.headers; _i < _a.length; _i++) {
	                var header = _a[_i];
	                xhr.setRequestHeader(header.name, header.value);
	            }
	        }
	        if (this.authToken) {
	            xhr.setRequestHeader('Authorization', this.authToken);
	        }
	        xhr.send(form);
	        this._render();
	    };
	    FileUploader.prototype._getTotalProgress = function (value) {
	        if (value === void 0) { value = 0; }
	        if (this.options.removeAfterUpload) {
	            return value;
	        }
	        var notUploaded = this.getNotUploadedItems().length;
	        var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
	        var ratio = 100 / this.queue.length;
	        var current = value * ratio / 100;
	        return Math.round(uploaded * ratio + current);
	    };
	    FileUploader.prototype._getFilters = function (filters) {
	        if (!filters) {
	            return this.options.filters;
	        }
	        if (Array.isArray(filters)) {
	            return filters;
	        }
	        if (typeof filters === 'string') {
	            var names_1 = filters.match(/[^\s,]+/g);
	            return this.options.filters
	                .filter(function (filter) { return names_1.indexOf(filter.name) !== -1; });
	        }
	        return this.options.filters;
	    };
	    FileUploader.prototype._render = function () {
	        return void 0;
	        // todo: ?
	    };
	    // private _folderFilter(item:any):boolean {
	    //   return !!(item.size || item.type);
	    // }
	    FileUploader.prototype._queueLimitFilter = function () {
	        return this.options.queueLimit === undefined || this.queue.length < this.options.queueLimit;
	    };
	    FileUploader.prototype._isValidFile = function (file, filters, options) {
	        var _this = this;
	        this._failFilterIndex = -1;
	        return !filters.length ? true : filters.every(function (filter) {
	            _this._failFilterIndex++;
	            return filter.fn.call(_this, file, options);
	        });
	    };
	    FileUploader.prototype._isSuccessCode = function (status) {
	        return (status >= 200 && status < 300) || status === 304;
	    };
	    /* tslint:disable */
	    FileUploader.prototype._transformResponse = function (response, headers) {
	        // todo: ?
	        /*var headersGetter = this._headersGetter(headers);
	         forEach($http.defaults.transformResponse, (transformFn) => {
	         response = transformFn(response, headersGetter);
	         });*/
	        return response;
	    };
	    /* tslint:enable */
	    FileUploader.prototype._parseHeaders = function (headers) {
	        var parsed = {};
	        var key;
	        var val;
	        var i;
	        if (!headers) {
	            return parsed;
	        }
	        headers.split('\n').map(function (line) {
	            i = line.indexOf(':');
	            key = line.slice(0, i).trim().toLowerCase();
	            val = line.slice(i + 1).trim();
	            if (key) {
	                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	            }
	        });
	        return parsed;
	    };
	    /*private _iframeTransport(item:any) {
	     // todo: implement it later
	     }*/
	    FileUploader.prototype._onWhenAddingFileFailed = function (item, filter, options) {
	        this.onWhenAddingFileFailed(item, filter, options);
	    };
	    FileUploader.prototype._onAfterAddingFile = function (item) {
	        this.onAfterAddingFile(item);
	    };
	    FileUploader.prototype._onAfterAddingAll = function (items) {
	        this.onAfterAddingAll(items);
	    };
	    FileUploader.prototype._onBeforeUploadItem = function (item) {
	        item._onBeforeUpload();
	        this.onBeforeUploadItem(item);
	    };
	    FileUploader.prototype._onBuildItemForm = function (item, form) {
	        item._onBuildForm(form);
	        this.onBuildItemForm(item, form);
	    };
	    FileUploader.prototype._onProgressItem = function (item, progress) {
	        var total = this._getTotalProgress(progress);
	        this.progress = total;
	        item._onProgress(progress);
	        this.onProgressItem(item, progress);
	        this.onProgressAll(total);
	        this._render();
	    };
	    /* tslint:disable */
	    FileUploader.prototype._onSuccessItem = function (item, response, status, headers) {
	        item._onSuccess(response, status, headers);
	        this.onSuccessItem(item, response, status, headers);
	    };
	    /* tslint:enable */
	    FileUploader.prototype._onCancelItem = function (item, response, status, headers) {
	        item._onCancel(response, status, headers);
	        this.onCancelItem(item, response, status, headers);
	    };
	    return FileUploader;
	}());
	exports.FileUploader = FileUploader;


/***/ },
/* 892 */
/***/ function(module, exports) {

	"use strict";
	function isElement(node) {
	    return !!(node && (node.nodeName || node.prop && node.attr && node.find));
	}
	var FileLikeObject = (function () {
	    function FileLikeObject(fileOrInput) {
	        var isInput = isElement(fileOrInput);
	        var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
	        var postfix = typeof fakePathOrObject === 'string' ? 'FakePath' : 'Object';
	        var method = '_createFrom' + postfix;
	        this[method](fakePathOrObject);
	    }
	    FileLikeObject.prototype._createFromFakePath = function (path) {
	        this.lastModifiedDate = void 0;
	        this.size = void 0;
	        this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
	        this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
	    };
	    FileLikeObject.prototype._createFromObject = function (object) {
	        // this.lastModifiedDate = copy(object.lastModifiedDate);
	        this.size = object.size;
	        this.type = object.type;
	        this.name = object.name;
	    };
	    return FileLikeObject;
	}());
	exports.FileLikeObject = FileLikeObject;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(1);
	var file_like_object_class_1 = __webpack_require__(892);
	var FileItem = (function () {
	    function FileItem(uploader, some, options) {
	        this.alias = 'file';
	        this.url = '/';
	        this.method = 'POST';
	        this.headers = [];
	        this.withCredentials = true;
	        this.formData = [];
	        this.isReady = false;
	        this.isUploading = false;
	        this.isUploaded = false;
	        this.isSuccess = false;
	        this.isCancel = false;
	        this.isError = false;
	        this.progress = 0;
	        this.index = void 0;
	        this.uploader = uploader;
	        this.some = some;
	        this.options = options;
	        this.file = new file_like_object_class_1.FileLikeObject(some);
	        this._file = some;
	        this.url = uploader.options.url;
	        this._zone = new core_1.NgZone({ enableLongStackTrace: false });
	    }
	    FileItem.prototype.upload = function () {
	        try {
	            this.uploader.uploadItem(this);
	        }
	        catch (e) {
	            this.uploader._onCompleteItem(this, '', 0, []);
	            this.uploader._onErrorItem(this, '', 0, []);
	        }
	    };
	    FileItem.prototype.cancel = function () {
	        this.uploader.cancelItem(this);
	    };
	    FileItem.prototype.remove = function () {
	        this.uploader.removeFromQueue(this);
	    };
	    FileItem.prototype.onBeforeUpload = function () {
	        return void 0;
	    };
	    FileItem.prototype.onBuildForm = function (form) {
	        return { form: form };
	    };
	    FileItem.prototype.onProgress = function (progress) {
	        return { progress: progress };
	    };
	    FileItem.prototype.onSuccess = function (response, status, headers) {
	        return { response: response, status: status, headers: headers };
	    };
	    FileItem.prototype.onError = function (response, status, headers) {
	        return { response: response, status: status, headers: headers };
	    };
	    FileItem.prototype.onCancel = function (response, status, headers) {
	        return { response: response, status: status, headers: headers };
	    };
	    FileItem.prototype.onComplete = function (response, status, headers) {
	        return { response: response, status: status, headers: headers };
	    };
	    FileItem.prototype._onBeforeUpload = function () {
	        this.isReady = true;
	        this.isUploading = true;
	        this.isUploaded = false;
	        this.isSuccess = false;
	        this.isCancel = false;
	        this.isError = false;
	        this.progress = 0;
	        this.onBeforeUpload();
	    };
	    FileItem.prototype._onBuildForm = function (form) {
	        this.onBuildForm(form);
	    };
	    FileItem.prototype._onProgress = function (progress) {
	        var _this = this;
	        this._zone.run(function () {
	            _this.progress = progress;
	        });
	        this.onProgress(progress);
	    };
	    FileItem.prototype._onSuccess = function (response, status, headers) {
	        this.isReady = false;
	        this.isUploading = false;
	        this.isUploaded = true;
	        this.isSuccess = true;
	        this.isCancel = false;
	        this.isError = false;
	        this.progress = 100;
	        this.index = void 0;
	        this.onSuccess(response, status, headers);
	    };
	    FileItem.prototype._onError = function (response, status, headers) {
	        this.isReady = false;
	        this.isUploading = false;
	        this.isUploaded = true;
	        this.isSuccess = false;
	        this.isCancel = false;
	        this.isError = true;
	        this.progress = 0;
	        this.index = void 0;
	        this.onError(response, status, headers);
	    };
	    FileItem.prototype._onCancel = function (response, status, headers) {
	        this.isReady = false;
	        this.isUploading = false;
	        this.isUploaded = false;
	        this.isSuccess = false;
	        this.isCancel = true;
	        this.isError = false;
	        this.progress = 0;
	        this.index = void 0;
	        this.onCancel(response, status, headers);
	    };
	    FileItem.prototype._onComplete = function (response, status, headers) {
	        this.onComplete(response, status, headers);
	        if (this.uploader.options.removeAfterUpload) {
	            this.remove();
	        }
	    };
	    FileItem.prototype._prepareToUploading = function () {
	        this.index = this.index || ++this.uploader._nextIndex;
	        this.isReady = true;
	    };
	    return FileItem;
	}());
	exports.FileItem = FileItem;


/***/ },
/* 894 */
/***/ function(module, exports) {

	"use strict";
	var FileType = (function () {
	    function FileType() {
	    }
	    FileType.getMimeClass = function (file) {
	        var mimeClass = 'application';
	        if (this.mime_psd.indexOf(file.type) !== -1) {
	            mimeClass = 'image';
	        }
	        else if (file.type.match('image.*')) {
	            mimeClass = 'image';
	        }
	        else if (file.type.match('video.*')) {
	            mimeClass = 'video';
	        }
	        else if (file.type.match('audio.*')) {
	            mimeClass = 'audio';
	        }
	        else if (file.type === 'application/pdf') {
	            mimeClass = 'pdf';
	        }
	        else if (this.mime_compress.indexOf(file.type) !== -1) {
	            mimeClass = 'compress';
	        }
	        else if (this.mime_doc.indexOf(file.type) !== -1) {
	            mimeClass = 'doc';
	        }
	        else if (this.mime_xsl.indexOf(file.type) !== -1) {
	            mimeClass = 'xls';
	        }
	        else if (this.mime_ppt.indexOf(file.type) !== -1) {
	            mimeClass = 'ppt';
	        }
	        if (mimeClass === 'application') {
	            mimeClass = this.fileTypeDetection(file.name);
	        }
	        return mimeClass;
	    };
	    FileType.fileTypeDetection = function (inputFilename) {
	        var types = {
	            'jpg': 'image',
	            'jpeg': 'image',
	            'tif': 'image',
	            'psd': 'image',
	            'bmp': 'image',
	            'png': 'image',
	            'nef': 'image',
	            'tiff': 'image',
	            'cr2': 'image',
	            'dwg': 'image',
	            'cdr': 'image',
	            'ai': 'image',
	            'indd': 'image',
	            'pin': 'image',
	            'cdp': 'image',
	            'skp': 'image',
	            'stp': 'image',
	            '3dm': 'image',
	            'mp3': 'audio',
	            'wav': 'audio',
	            'wma': 'audio',
	            'mod': 'audio',
	            'm4a': 'audio',
	            'compress': 'compress',
	            'rar': 'compress',
	            '7z': 'compress',
	            'lz': 'compress',
	            'z01': 'compress',
	            'pdf': 'pdf',
	            'xls': 'xls',
	            'xlsx': 'xls',
	            'ods': 'xls',
	            'mp4': 'video',
	            'avi': 'video',
	            'wmv': 'video',
	            'mpg': 'video',
	            'mts': 'video',
	            'flv': 'video',
	            '3gp': 'video',
	            'vob': 'video',
	            'm4v': 'video',
	            'mpeg': 'video',
	            'm2ts': 'video',
	            'mov': 'video',
	            'doc': 'doc',
	            'docx': 'doc',
	            'eps': 'doc',
	            'txt': 'doc',
	            'odt': 'doc',
	            'rtf': 'doc',
	            'ppt': 'ppt',
	            'pptx': 'ppt',
	            'pps': 'ppt',
	            'ppsx': 'ppt',
	            'odp': 'ppt'
	        };
	        var chunks = inputFilename.split('.');
	        if (chunks.length < 2) {
	            return 'application';
	        }
	        var extension = chunks[chunks.length - 1].toLowerCase();
	        if (types[extension] === undefined) {
	            return 'application';
	        }
	        else {
	            return types[extension];
	        }
	    };
	    /*  MS office  */
	    FileType.mime_doc = [
	        'application/msword',
	        'application/msword',
	        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
	        'application/vnd.ms-word.document.macroEnabled.12',
	        'application/vnd.ms-word.template.macroEnabled.12'
	    ];
	    FileType.mime_xsl = [
	        'application/vnd.ms-excel',
	        'application/vnd.ms-excel',
	        'application/vnd.ms-excel',
	        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
	        'application/vnd.ms-excel.sheet.macroEnabled.12',
	        'application/vnd.ms-excel.template.macroEnabled.12',
	        'application/vnd.ms-excel.addin.macroEnabled.12',
	        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
	    ];
	    FileType.mime_ppt = [
	        'application/vnd.ms-powerpoint',
	        'application/vnd.ms-powerpoint',
	        'application/vnd.ms-powerpoint',
	        'application/vnd.ms-powerpoint',
	        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	        'application/vnd.openxmlformats-officedocument.presentationml.template',
	        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
	        'application/vnd.ms-powerpoint.addin.macroEnabled.12',
	        'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
	        'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
	        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
	    ];
	    /* PSD */
	    FileType.mime_psd = [
	        'image/photoshop',
	        'image/x-photoshop',
	        'image/psd',
	        'application/photoshop',
	        'application/psd',
	        'zz-application/zz-winassoc-psd'
	    ];
	    /* Compressed files */
	    FileType.mime_compress = [
	        'application/x-gtar',
	        'application/x-gcompress',
	        'application/compress',
	        'application/x-tar',
	        'application/x-rar-compressed',
	        'application/octet-stream'
	    ];
	    return FileType;
	}());
	exports.FileType = FileType;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var file_uploader_class_1 = __webpack_require__(891);
	var FileDropDirective = (function () {
	    function FileDropDirective(element) {
	        this.fileOver = new core_1.EventEmitter();
	        this.onFileDrop = new core_1.EventEmitter();
	        this.element = element;
	    }
	    FileDropDirective.prototype.getOptions = function () {
	        return this.uploader.options;
	    };
	    FileDropDirective.prototype.getFilters = function () {
	        return {};
	    };
	    FileDropDirective.prototype.onDrop = function (event) {
	        var transfer = this._getTransfer(event);
	        if (!transfer) {
	            return;
	        }
	        var options = this.getOptions();
	        var filters = this.getFilters();
	        this._preventAndStop(event);
	        this.uploader.addToQueue(transfer.files, options, filters);
	        this.fileOver.emit(false);
	        this.onFileDrop.emit(transfer.files);
	    };
	    FileDropDirective.prototype.onDragOver = function (event) {
	        var transfer = this._getTransfer(event);
	        if (!this._haveFiles(transfer.types)) {
	            return;
	        }
	        transfer.dropEffect = 'copy';
	        this._preventAndStop(event);
	        this.fileOver.emit(true);
	    };
	    FileDropDirective.prototype.onDragLeave = function (event) {
	        if (event.currentTarget === this.element[0]) {
	            return;
	        }
	        this._preventAndStop(event);
	        this.fileOver.emit(false);
	    };
	    FileDropDirective.prototype._getTransfer = function (event) {
	        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
	    };
	    FileDropDirective.prototype._preventAndStop = function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	    };
	    FileDropDirective.prototype._haveFiles = function (types) {
	        if (!types) {
	            return false;
	        }
	        if (types.indexOf) {
	            return types.indexOf('Files') !== -1;
	        }
	        else if (types.contains) {
	            return types.contains('Files');
	        }
	        else {
	            return false;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', file_uploader_class_1.FileUploader)
	    ], FileDropDirective.prototype, "uploader", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], FileDropDirective.prototype, "fileOver", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], FileDropDirective.prototype, "onFileDrop", void 0);
	    __decorate([
	        core_1.HostListener('drop', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], FileDropDirective.prototype, "onDrop", null);
	    __decorate([
	        core_1.HostListener('dragover', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], FileDropDirective.prototype, "onDragOver", null);
	    __decorate([
	        core_1.HostListener('dragleave', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', Object)
	    ], FileDropDirective.prototype, "onDragLeave", null);
	    FileDropDirective = __decorate([
	        core_1.Directive({ selector: '[ng2FileDrop]' }), 
	        __metadata('design:paramtypes', [core_1.ElementRef])
	    ], FileDropDirective);
	    return FileDropDirective;
	}());
	exports.FileDropDirective = FileDropDirective;


/***/ },
/* 896 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n        <form class=\"form\" [formGroup]=\"form\">\n            <!--Descomentar si se quiere filtrar en cuanto el formulario cambie (ngSubmit)=\"find()\"-->\n            <div class=\"panel panel-default\" *ngIf=\"showFilters\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"patentFilter\">Patente</label>\n                            <input type=\"text\" class=\"form-control\" id=\"patentFilter\"\n                                   formControlName=\"patent\" [(ngModel)]=\"filter.patent\" name=\"patent\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\"\n                                    [(ngModel)]=\"filter.contract.bank\" name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"contractFilter\">Nro. de Contrato</label>\n                            <input type=\"text\" class=\"form-control\" id=\"contractFilter\" placeholder=\"\"\n                                   formControlName=\"contractNumber\" [(ngModel)]=\"filter.contract.contractNumber\"\n                                   name=\"contractNumber\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cuitFilter\">CUIT</label>\n                            <input type=\"text\" class=\"form-control\" id=\"cuitFilter\" placeholder=\"\"\n                                   formControlName=\"cuit\" [(ngModel)]=\"filter.contract.cuit\" name=\"cuit\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\"\n                                [disabled]=\"!form.valid || filterEmpty()\" style=\"margin-top: 23px\">\n                            <!--<span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span>-->\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div class=\"col-xs-12\" *ngIf=\"filterEmpty()\">\n                        <div class=\"alert alert-info\">Ingrese alg&uacute;n filtro de b&uacute;squeda</div>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <legend>Descarga de Vehículos</legend>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\" *ngIf=\"reportMessage\">\n                            <div class=\"alert alert-info\">{{reportMessage}}</div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <div class=\"form-group form-group-sm\">\n                                <div class=\"col-xs-3\">\n                                    <button type=\"button\" class=\"btn btn-primary\" (click)=\"downloadFilterVehicles()\"\n                                            [disabled]=\"!form.valid || filterEmpty() || data.length == 0\"\n                                            style=\"margin-top: 23px\">\n                                        <!--<span class=\"glyphicon glyphicon-download-alt\" aria-hidden=\"true\"> Descargar</span>-->\n                                        <span class=\"download-alt\"><img>Descargar</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n\n        <div class=\"panel panel-default\">\n            <div class=\"panel-body table-responsive\">\n                <table class=\"table table-striped\">\n                    <thead>\n                    <tr>\n                        <th style=\"width: 10%\"></th>\n                        <th style=\"width: 10%\">\n                            Patente\n                        </th>\n                        <th style=\"width: 10%\">\n                            Tipo\n                        </th>\n                        <th style=\"width: 10%\">\n                            Marca\n                        </th>\n                        <th style=\"width: 10%\">\n                            Modelo\n                        </th>\n                        <th style=\"width: 10%\">\n                            A&ntilde;o\n                        </th>\n                        <th style=\"width: 10%\">\n                            CUIT\n                        </th>\n                        <th style=\"width: 10%\">\n                            Nro. de Contrato\n                        </th>\n                        <th style=\"width: 10%\">\n                            Banco\n                        </th>\n                        <th style=\"width: 10%\">\n                            Acciones\n                        </th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                        <td>\n                            <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"editItem(item)\"\n                                    *ngIf=\"canEditVehicle\">\n                                <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                                <span class=\"pencil\"><img></span>\n                            </button>\n                            <button class=\"btn btn-primary\" title=\"Ver\" (click)=\"editItem(item)\"\n                                    *ngIf=\"!canEditVehicle && canViewVehicle\">\n                                <!--<span class=\"glyphicon glyphicon-eye-open\"></span>-->\n                                <span class=\"eye-open\"><img></span>\n                            </button>\n                        </td>\n                        <td>{{item.patent}}</td>\n                        <td>{{item.type.description}}</td>\n                        <td>{{item.brand.name}}</td>\n                        <td>{{item.model}}</td>\n                        <td>{{item.year}}</td>\n                        <td>{{item.contract.cuit}}</td>\n                        <td>{{item.contract.contractNumber}}</td>\n                        <td>{{item.contract.bank.name}}</td>\n                        <td>\n                            <button *ngIf=\"canDeleteVehicle\" class=\"btn btn-danger\" title=\"Eliminar\"\n                                    (click)=\"vehicleSelected=item;deleteModal.show();\">\n                                <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                                <span class=\"remove\"><img></span>\n                            </button>\n                            <button class=\"btn btn-primary\" title=\"Ver Contrato\" (click)=\"viewContract(item)\"\n                                    *ngIf=\"canViewContract\">\n                                <!--<span class=\"glyphicon glyphicon-file\"></span>-->\n                                <span class=\"file-icon\"><img></span>\n                            </button>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan=\"10\">\n                            <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"canEditVehicle\">\n        <div class=\"row\">\n            <div class=\"col-xs-2\" id=\"newEntity\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"createVehicle()\">\n                    <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n                    <span class=\"plus\"><img></span> Nuevo\n                </button>\n            </div>\n            <fieldset id=\"bulkLoadContainer\">\n                <legend>Carga masiva de vehículos</legend>\n                <div class=\"col-xs-4\">\n                    <!--<label for=\"bulkLoad\" class=\"hidden\">Carga Masiva (Excel)</label>-->\n                    <div ng2FileDrop\n                         [ngClass]=\"{'nv-file-over': hasBulkLoadDropZoneOver}\"\n                         (fileOver)=\"fileOverBulkLoad($event)\"\n                         [uploader]=\"uploaderBulkLoad\"\n                         class=\"well my-drop-zone\">Arrastre el Excel de vehículos aquí\n                    </div>\n                    <label for=\"bulkLoadVehicle\" class=\"custom-file-upload\">\n                        <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                        <!--<i class=\"fa fa-cloud-upload\"></i> -->\n                    </label>\n                    <input #bulkLoadVehicle type=\"file\" id=\"bulkLoadVehicle\" ng2FileSelect\n                           [uploader]=\"uploaderBulkLoad\"/><!--[disabled]=\"checkDuplicatedExcel()-->\n                </div>\n                <div class=\"col-xs-1 spinLoading\">\n                    <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                        <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                    </div>\n                </div>\n            </fieldset>\n        </div>\n        <div class=\"row uploaderQueue\">\n            <div class=\"col-xs-12\" *ngIf=\"uploaderBulkLoad.queue?.length > 0\">\n                <div class=\"col-md-12 noPadding\">\n                    <table class=\"table\">\n                        <thead>\n                        <tr>\n                            <th width=\"50%\">Nombre</th>\n                            <th>Progreso</th>\n                            <!--<th>Estado</th>-->\n                            <th *ngIf=\"isBeforeUpload\">Eliminar</th><!--<th>Acciones</th>-->\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr *ngFor=\"let aFile of uploaderBulkLoad.queue\">\n                            <td>\n                                <strong>{{aFile.file.name}}</strong>\n                            </td>\n                            <td>\n                                <div class=\"progress\" style=\"margin-bottom: 0;\">\n                                    <div class=\"progress-bar\" role=\"progressbar\"\n                                         [ngStyle]=\"{ 'width': aFile.progress + '%' }\"></div>\n                                </div>\n                            </td>\n                            <!--<td class=\"text-center\">\n                                &lt;!&ndash;<span *ngIf=\"aFile.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>&ndash;&gt;\n                                <span class=\"ok-icon\" *ngIf=\"aFile.isSuccess\"><img></span>\n                                &lt;!&ndash;<span *ngIf=\"aFile.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>&ndash;&gt;\n                                <span class=\"ban-circle\" *ngIf=\"aFile.isCancel\"><img></span>\n                                &lt;!&ndash;<span *ngIf=\"aFile.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>&ndash;&gt;\n                                <span class=\"remove\" *ngIf=\"aFile.isError\"><img></span>\n                            </td>-->\n                            <td nowrap *ngIf=\"isBeforeUpload\">\n                                <!--<button type=\"button\" class=\"btn btn-success btn-xs btn-vehicle\"\n                                        (click)=\"setLoading(); aFile.upload()\"\n                                        [disabled]=\"aFile.isReady || aFile.isUploading || aFile.isSuccess\">\n                                    &lt;!&ndash;<span class=\"glyphicon glyphicon-upload\"></span>&ndash;&gt;\n                                    <span class=\"upload-icon\"><img></span> Subir\n                                </button>\n                                <button type=\"button\" class=\"btn btn-warning btn-xs btn-vehicle\"\n                                        (click)=\"aFile.cancel()\" [disabled]=\"!aFile.isUploading\">\n                                    &lt;!&ndash;<span class=\"glyphicon glyphicon-ban-circle\"></span>&ndash;&gt;\n                                    <span class=\"ban-circle-white\"><img></span>\n                                    Cancelar\n                                </button>-->\n                                <button type=\"button\" class=\"btn btn-danger btn-xs btn-vehicle\"\n                                        (click)=\"aFile.remove()\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span> Eliminar\n                                </button>\n                            </td>\n                        </tr>\n                        <tr *ngIf=\"uploaderBulkLoad.queue?.length == 0\">\n                            <td colspan=\"4\" class=\"text-center\">No hay carga masiva pendiente</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                    <div>\n                        <div>\n                            <div class=\"progress\" style=\"\">\n                                <div class=\"progress-bar\" role=\"progressbar\"\n                                     [ngStyle]=\"{ 'width': uploaderBulkLoad.progress + '%' }\">\n                                </div>\n                            </div>\n                        </div>\n                        <button type=\"button\" class=\"btn btn-success btn-s\"\n                                (click)=\"enableLoading(); uploaderBulkLoad.uploadAll(); enableOneClickBulkload()\"\n                                [disabled]=\"oneClickBulkLoad || !uploaderBulkLoad.getNotUploadedItems().length\">\n                            <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                            <span class=\"upload-icon\"><img></span> Cargar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-warning btn-s\"\n                                (click)=\"disableLoading(); uploaderBulkLoad.cancelAll()\"\n                                [disabled]=\"!uploaderBulkLoad.isUploading\">\n                            <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                            <span class=\"ban-circle-white\"><img></span> Cancelar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-s\"\n                                (click)=\"disableLoading(); createUploaderBulkLoad()\"\n                                [disabled]=\"!uploaderBulkLoad.queue.length\">\n                            <!--uploaderBulkLoad.clearQueue()-->\n                            <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                            <span class=\"trash\"><img></span> Eliminar cola\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n            </div>\n            <div class=\"modal-body\">\n                &iquest;Est&aacute; seguro que desea eliminar el veh&iacute;culo\n                <strong>{{vehicleSelected?.patent}}</strong>?\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n                        (click)=\"removeItem(deleteModal)\">\n                    Aceptar\n                </button>\n                <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\" (click)=\"deleteModal.hide()\">\n                    Cancelar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #bulkLoadVehicleModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hideBulkLoadModal()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Carga masiva Vehículos</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"errorsBulkLoad\">{{errorsBulkLoad[0]}}</p>\n                <li *ngFor=\"let errorBL of errorsBulkLoad | slice:1\">{{errorBL}}</li>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 897 */
/***/ function(module, exports) {

	module.exports = "vehicles-panel .container {\n    display: inline;\n    float: none;\n}\n\n.table > caption + thead > tr:first-child > td,\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td button.btn,\n.table > tbody > tr > th button.btn,\n.table > tfoot > tr > td button.btn,\n.table > tfoot > tr > th button.btn,\n.table > thead > tr > td button.btn,\n.table > thead > tr > th button.btn {\n    padding: 5px;\n    font-size: 0;\n    height: 24px;\n    line-height: 15px;\n}\n\n.table > tbody > tr > td button.btn span,\n.table > tbody > tr > th button.btn span,\n.table > tfoot > tr > td button.btn span,\n.table > tfoot > tr > th button.btn span,\n.table > thead > tr > td button.btn span,\n.table > thead > tr > th button.btn span {\n    font-size: 0\n}\n\n.table > tbody > tr > td button.btn span img,\n.table > tbody > tr > th button.btn span img,\n.table > tfoot > tr > td button.btn span img,\n.table > tfoot > tr > th button.btn span img,\n.table > thead > tr > td button.btn span img,\n.table > thead > tr > th button.btn span img {\n    width: 12px;\n}\n\n.table > tbody > tr > td button.btn span.file-icon img,\n.table > tbody > tr > th button.btn span.file-icon img,\n.table > tfoot > tr > td button.btn span.file-icon img,\n.table > tfoot > tr > th button.btn span.file-icon img,\n.table > thead > tr > td button.btn span.file-icon img,\n.table > thead > tr > th button.btn span.file-icon img {\n    width: 10px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\n.btn-vehicle {\n    font-size: 12px !important;\n}\n\n.btn-vehicle img {\n    height: 17px;\n    padding-bottom: 5px;\n}\n\n#newEntity {\n    float: none;\n    padding: 0;\n}\n\n#bulkLoadContainer {\n    margin-top: 30px;\n    background-color: #d9edf7;\n    border-radius: 4px;\n    -webkit-margin-start: 0;\n    -webkit-margin-end: 0;\n    -webkit-padding-before: 0;\n    -webkit-padding-start: 0;\n    -webkit-padding-end: 0;\n    -webkit-padding-after: 0;\n}\n\n#bulkLoadContainer legend {\n    position: relative;\n    top: 30px;\n    padding-left: 15px;\n}\n\n#bulkLoadContainer .my-drop-zone {\n    margin-top: 20px;\n}\n\n.row.uploaderQueue {\n    background-color: #d9edf7;\n    position: relative;\n    top: -3px;\n}\n\n.row.uploaderQueue .noPadding {\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.row.uploaderQueue .noPadding table {\n    color: #333;\n}\n\n#bulkLoadContainer {\n    display: block;\n}"

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var navigation_service_1 = __webpack_require__(403);
	var contracts_service_1 = __webpack_require__(632);
	var bank_service_1 = __webpack_require__(631);
	var vehicle_1 = __webpack_require__(873);
	var contract_1 = __webpack_require__(874);
	var bank_1 = __webpack_require__(875);
	var login_service_1 = __webpack_require__(404);
	var ng2_file_upload_1 = __webpack_require__(889);
	var validators_1 = __webpack_require__(849);
	var ContractsPanelComponent = (function () {
	    function ContractsPanelComponent(router, contractsService, bankService, navigationService, loginService) {
	        var _this = this;
	        this.router = router;
	        this.contractsService = contractsService;
	        this.bankService = bankService;
	        this.navigationService = navigationService;
	        this.loginService = loginService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los bancos.');
	        });
	        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
	        /*this.form.valueChanges
	         .debounceTime(400)
	         .subscribe(this.find.bind(this));*/
	    }
	    ContractsPanelComponent.prototype.init = function () {
	        this.data = [];
	        this.filter = new vehicle_1.Vehicle();
	        this.form = new forms_1.FormGroup({
	            patent: new forms_1.FormControl(),
	            bank: new forms_1.FormControl(),
	            contractNumber: new forms_1.FormControl(),
	            cuit: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl()
	        });
	        this.banks = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        if (!this.filter.contract.bank.id) {
	            this.filter.contract.bank = this.bankTodos;
	        }
	        this.canEditVehicle = false;
	        this.canDeleteVehicle = false;
	        this.canViewVehicle = false;
	        this.canEditContract = false;
	        this.canDeleteContract = false;
	        this.canViewContract = false;
	        this.showFilters = false;
	        this.errorsBulkLoad = [];
	        this.createUploaderBulkLoad();
	        this.oneClickBulkLoad = false;
	    };
	    ContractsPanelComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.filter.contract.bank = banks[0];
	        }
	    };
	    ContractsPanelComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    ContractsPanelComponent.prototype.filterEmpty = function () {
	        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit ||
	            (this.filter.contract.bank && this.filter.contract.bank.id != ''));
	    };
	    ContractsPanelComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        if (this.itemsPerPage != null && this.itemsPerPage > 0) {
	            if (!this.filterEmpty()) {
	                this.loading = true;
	                this.contractsService.findContracts(this.filter, page, this.itemsPerPage)
	                    .subscribe(function (data) {
	                    _this.refreshData(data);
	                    _this.page = page;
	                }, function () {
	                    _this.bindError('Ocurrió un error al cargar los contratos.');
	                });
	            }
	        }
	        else {
	            this.bindError('Cantidad de ítems no válida.');
	        }
	    };
	    ContractsPanelComponent.prototype.refreshData = function (page) {
	        this.data = page.content.map(function (item) { return new contract_1.Contract(item); });
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    ContractsPanelComponent.prototype.getVehicles = function (item) {
	        var _this = this;
	        this.loading = true;
	        this.contractSelected = item;
	        this.vehiclesSelected = null;
	        this.contractsService.getVehicles(this.contractSelected.id)
	            .subscribe(function (data) {
	            if (data.length > 0) {
	                _this.vehiclesSelected = data;
	            }
	            _this.loading = false;
	            _this.deleteModal.show();
	        }, function () {
	            _this.bindError('Ocurrió un error al cargar los vehículos.');
	        });
	    };
	    ContractsPanelComponent.prototype.removeItem = function (deleteModal) {
	        var _this = this;
	        this.error = null;
	        this.contractsService.delete(this.contractSelected.id)
	            .subscribe(function () {
	            deleteModal.hide();
	            _this.removeItemFromView(_this.contractSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el contrato.');
	        });
	    };
	    ContractsPanelComponent.prototype.removeItemFromView = function (item) {
	        var index = this.data.indexOf(item);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.contractSelected = null;
	        this.vehiclesSelected = [];
	    };
	    ContractsPanelComponent.prototype.editItem = function (item) {
	        this.navigationService.setBackParameters({ tabSelected: 'contracts' });
	        this.router.navigate(['app/home/editContract', item.id]);
	    };
	    ContractsPanelComponent.prototype.create = function () {
	        this.navigationService.setBackParameters({ tabSelected: 'contracts' });
	        this.router.navigate(['app/home/createContract']);
	    };
	    ContractsPanelComponent.prototype.downloadFilterContracts = function () {
	        this.error = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.reportMessage = 'Creando reporte...';
	            /*
	             * Se exportan todos los contratos que cumplan con el filtro.
	             * Sólo los contratos de la página actual se descargan.
	             */
	            var url = window.location.origin +
	                contracts_service_1.ContractsService.getURLFilterContracts(this.filter, this.page, this.itemsPerPage);
	            window.location.href = url;
	            this.loading = false;
	        }
	    };
	    ContractsPanelComponent.prototype.close = function (saved) {
	        if (saved) {
	            this.find();
	        }
	    };
	    ContractsPanelComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    ContractsPanelComponent.prototype.ngOnInit = function () {
	        var userLogged = this.loginService.getUserLogged();
	        this.canEditVehicle = userLogged.isActionAllowed('CONTRACTS', 'EDIT', 'VEHICLES');
	        this.canDeleteVehicle = userLogged.isActionAllowed('CONTRACTS', 'DELETE', 'VEHICLES');
	        this.canViewVehicle = userLogged.isActionAllowed('CONTRACTS', 'VIEW', 'VEHICLES');
	        this.canEditContract = userLogged.isActionAllowed('CONTRACTS', 'EDIT', 'CONTRACTS');
	        this.canDeleteContract = userLogged.isActionAllowed('CONTRACTS', 'DELETE', 'CONTRACTS');
	        this.canViewContract = userLogged.isActionAllowed('CONTRACTS', 'VIEW', 'CONTRACTS');
	        if (userLogged.rol.client) {
	            if (userLogged.cuit) {
	                this.filter.contract.cuit = userLogged.username;
	            }
	            else {
	                this.filter.patent = userLogged.username;
	            }
	            this.filter.contract.bank.id = userLogged.bank.id;
	            this.showFilters = false;
	        }
	        else {
	            this.showFilters = true;
	        }
	    };
	    ContractsPanelComponent.prototype.createUploaderBulkLoad = function () {
	        var _this = this;
	        this.uploaderBulkLoad = new ng2_file_upload_1.FileUploader({
	            url: 'contract/bulkLoad',
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.hasBulkLoadDropZoneOver = false;
	        this.uploaderBulkLoad.onCompleteItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 200) {
	                var message = response.split("|");
	                _this.errorsBulkLoad = [];
	                _this.errorsBulkLoad[0] = message[0];
	                if (message.length > 1) {
	                    window.location.href = window.location.origin +
	                        contracts_service_1.ContractsService.getURLContractBulkload(message[1]);
	                }
	            }
	            else if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de contratos no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        contracts_service_1.ContractsService.getURLContractBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de contratos cancelada.");
	                }
	            }
	            _this.showBulkLoadModal();
	            _this.oneClickBulkLoad = false;
	        };
	    };
	    ContractsPanelComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        /*Limpieza de inputs al agregar a la cola el archivo*/
	        this.uploaderBulkLoad.onAfterAddingFile = (function (item) {
	            _this.bulkLoad.nativeElement.value = '';
	            _this.reportMessage = null;
	        });
	    };
	    ContractsPanelComponent.prototype.showBulkLoadModal = function () {
	        this.bulkLoadModal.show();
	        this.disableLoading();
	    };
	    ContractsPanelComponent.prototype.hideBulkLoadModal = function () {
	        this.bulkLoadModal.hide();
	        this.errorsBulkLoad = [];
	    };
	    ContractsPanelComponent.prototype.disableLoading = function () {
	        this.loading = false;
	        this.oneClickBulkLoad = false;
	    };
	    ContractsPanelComponent.prototype.enableLoading = function () {
	        this.loading = true;
	    };
	    ContractsPanelComponent.prototype.enableOneClickBulkload = function () {
	        this.oneClickBulkLoad = true;
	    };
	    ContractsPanelComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.ViewChild('deleteModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], ContractsPanelComponent.prototype, "deleteModal", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadContract'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ContractsPanelComponent.prototype, "bulkLoad", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadContractModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], ContractsPanelComponent.prototype, "bulkLoadModal", void 0);
	    ContractsPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'contracts-panel',
	            template: __webpack_require__(899),
	            styles: [__webpack_require__(900)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                /*DATEPICKER_DIRECTIVES,*/
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, contracts_service_1.ContractsService, bank_service_1.BankService, navigation_service_1.NavigationService, login_service_1.LoginService])
	    ], ContractsPanelComponent);
	    return ContractsPanelComponent;
	}());
	exports.ContractsPanelComponent = ContractsPanelComponent;


/***/ },
/* 899 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n        <form class=\"form\" [formGroup]=\"form\">\n            <!--Descomentar si se quiere filtrar en cuanto el formulario cambie (ngSubmit)=\"find()\"-->\n            <div class=\"panel panel-default\" *ngIf=\"showFilters\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"patentFilter\">Patente</label>\n                            <input type=\"text\" class=\"form-control\" id=\"patentFilter\"\n                                   formControlName=\"patent\" [(ngModel)]=\"filter.patent\" name=\"patent\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\"\n                                    [(ngModel)]=\"filter.contract.bank\" name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"contractFilter\">Nro. de Contrato</label>\n                            <input type=\"text\" class=\"form-control\" id=\"contractFilter\" placeholder=\"\"\n                                   formControlName=\"contractNumber\" [(ngModel)]=\"filter.contract.contractNumber\"\n                                   name=\"contractNumber\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cuitFilter\">CUIT</label>\n                            <input type=\"text\" class=\"form-control\" id=\"cuitFilter\" placeholder=\"\"\n                                   formControlName=\"cuit\" [(ngModel)]=\"filter.contract.cuit\" name=\"cuit\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\"\n                                [disabled]=\"!form.valid || filterEmpty()\" style=\"margin-top: 23px\">\n                            <!--<span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span>-->\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div class=\"col-xs-12\" *ngIf=\"filterEmpty()\">\n                        <div class=\"alert alert-info\">Ingrese alg&uacute;n filtro de b&uacute;squeda</div>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <legend>Descarga de Contratos</legend>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\" *ngIf=\"reportMessage\">\n                            <div class=\"alert alert-info\">{{reportMessage}}</div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <div class=\"form-group form-group-sm\">\n                                <div class=\"col-xs-3\">\n                                    <button type=\"button\" class=\"btn btn-primary\" (click)=\"downloadFilterContracts()\"\n                                            [disabled]=\"!form.valid || filterEmpty() || data.length == 0\"\n                                            style=\"margin-top: 23px\">\n                                        <!--<span class=\"glyphicon glyphicon-download-alt\" aria-hidden=\"true\"> Descargar</span>-->\n                                        <span class=\"download-alt\"><img>Descargar</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n\n        <div class=\"panel panel-default\">\n            <div class=\"panel-body table-responsive\">\n                <table class=\"table table-striped\">\n                    <thead>\n                    <tr>\n                        <th style=\"width: 10%\"></th>\n                        <th style=\"width: 10%\">\n                            Nro. de Contrato\n                        </th>\n                        <th style=\"width: 5%\">\n                            Banco\n                        </th>\n                        <th style=\"width: 10%\">\n                            Raz&oacute;n Social\n                        </th>\n                        <th style=\"width: 10%\">\n                            CUIT\n                        </th>\n                        <th style=\"width: 10%\">\n                            Tel&eacute;fono\n                        </th>\n                        <th style=\"width: 20%\">\n                            Direcci&oacute;n\n                        </th>\n                        <th style=\"width: 10%\">\n                            Nombre de Contacto\n                        </th>\n                        <th style=\"width: 10%\">\n                            Tel&eacute;fono de Contacto\n                        </th>\n                        <th style=\"width: 10%\">\n                            Email de Contacto\n                        </th>\n                        <th style=\"width: 5%\">\n                            Acciones\n                        </th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                        <td>\n                            <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"editItem(item)\"\n                                    *ngIf=\"canEditContract\">\n                                <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                                <span class=\"pencil\"><img></span>\n                            </button>\n                            <button class=\"btn btn-primary\" title=\"Ver\" (click)=\"editItem(item)\"\n                                    *ngIf=\"!canEditContract && canViewContract\">\n                                <!--<span class=\"glyphicon glyphicon-eye-open\"></span>-->\n                                <span class=\"eye-open\"><img></span>\n                            </button>\n                        </td>\n                        <td>{{item.contractNumber}}</td>\n                        <td>{{item.bank.name}}</td>\n                        <td>{{item.businessName}}</td>\n                        <td>{{item.cuit}}</td>\n                        <td>{{item.phone}}</td>\n                        <td>{{item.address?.toString()}}</td>\n                        <td>{{item.getContact()?.name}}</td>\n                        <td>{{item.getContact()?.phone}}</td>\n                        <td>{{item.getContact()?.email}}</td>\n                        <td>\n                            <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                    (click)=\"getVehicles(item)\" *ngIf=\"canDeleteContract\">\n                                <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                                <span class=\"remove\"><img></span>\n                            </button>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan=\"11\">\n                            <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"canEditContract\">\n        <div class=\"row\">\n            <div class=\"col-xs-2\" id=\"newEntity\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"create()\">\n                    <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n                    <span class=\"plus\"><img></span> Nuevo\n                </button>\n            </div>\n            <fieldset id=\"bulkLoadContainer\">\n                <legend>Carga masiva de contratos</legend>\n                <div class=\"col-xs-4\">\n                    <div ng2FileDrop\n                         [ngClass]=\"{'nv-file-over': hasBulkLoadDropZoneOver}\"\n                         (fileOver)=\"fileOverBulkLoad($event)\"\n                         [uploader]=\"uploaderBulkLoad\"\n                         class=\"well my-drop-zone\">Arrastre el Excel de contratos aquí\n                    </div>\n                    <label for=\"bulkLoadContract\" class=\"custom-file-upload\">\n                        <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                        <!--<i class=\"fa fa-cloud-upload\"></i> -->\n                    </label>\n                    <input #bulkLoadContract type=\"file\" id=\"bulkLoadContract\" ng2FileSelect\n                           [uploader]=\"uploaderBulkLoad\"/>\n                </div>\n                <div class=\"col-xs-1 spinLoading\">\n                    <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                        <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                    </div>\n                </div>\n            </fieldset>\n        </div>\n        <div class=\"row uploaderQueue\">\n            <div class=\"col-xs-12\" *ngIf=\"uploaderBulkLoad.queue?.length > 0\">\n                <div class=\"col-md-12 noPadding\">\n                    <table class=\"table\">\n                        <thead>\n                        <tr>\n                            <th width=\"50%\">Nombre</th>\n                            <th>Progreso</th>\n                            <th *ngIf=\"isBeforeUpload\">Eliminar</th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr *ngFor=\"let aFile of uploaderBulkLoad.queue\">\n                            <td>\n                                <strong>{{aFile.file.name}}</strong>\n                            </td>\n                            <td>\n                                <div class=\"progress\" style=\"margin-bottom: 0;\">\n                                    <div class=\"progress-bar\" role=\"progressbar\"\n                                         [ngStyle]=\"{ 'width': aFile.progress + '%' }\"></div>\n                                </div>\n                            </td>\n                            <td nowrap *ngIf=\"isBeforeUpload\">\n                                <button type=\"button\" class=\"btn btn-danger btn-xs\" (click)=\"aFile.remove()\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span> Eliminar\n                                </button>\n                            </td>\n                        </tr>\n                        <tr *ngIf=\"uploaderBulkLoad.queue?.length == 0\">\n                            <td colspan=\"4\" class=\"text-center\">No hay carga masiva pendiente</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                    <div>\n                        <div>\n                            <div class=\"progress\">\n                                <div class=\"progress-bar\" role=\"progressbar\"\n                                     [ngStyle]=\"{ 'width': uploaderBulkLoad.progress + '%' }\">\n                                </div>\n                            </div>\n                        </div>\n                        <button type=\"button\" class=\"btn btn-success btn-s\"\n                                (click)=\"enableLoading(); uploaderBulkLoad.uploadAll(); enableOneClickBulkload()\"\n                                [disabled]=\"oneClickBulkLoad || !uploaderBulkLoad.getNotUploadedItems().length\">\n                            <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                            <span class=\"upload-icon\"><img></span> Cargar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-warning btn-s\"\n                                (click)=\"disableLoading(); uploaderBulkLoad.cancelAll()\"\n                                [disabled]=\"!uploaderBulkLoad.isUploading\">\n                            <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                            <span class=\"ban-circle-white\"><img></span> Cancelar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-s\"\n                                (click)=\"disableLoading(); createUploaderBulkLoad()\"\n                                [disabled]=\"!uploaderBulkLoad.queue.length\">\n                            <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                            <span class=\"trash\"><img></span> Eliminar cola\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n            </div>\n            <div class=\"modal-body\">\n                &iquest;Est&aacute; seguro que desea eliminar el contracto\n                <strong>{{contractSelected?.contractNumber}}</strong>?\n                <br>\n                <span *ngIf=\"vehiclesSelected\">Tener en cuenta que se eliminarán también los siguientes vehículos\n                    asociados al contrato y, a su vez, las infracciones de los mismos:</span>\n                <li *ngFor=\"let vehicle of vehiclesSelected\">{{vehicle.patent}}</li>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n                        (click)=\"removeItem(deleteModal)\">Aceptar\n                </button>\n                <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\" (click)=\"deleteModal.hide()\">\n                    Cancelar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #bulkLoadContractModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hideBulkLoadModal()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Carga masiva Contratos</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"errorsBulkLoad\">{{errorsBulkLoad[0]}}</p>\n                <li *ngFor=\"let errorBL of errorsBulkLoad | slice:1\">{{errorBL}}</li>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 900 */
/***/ function(module, exports) {

	module.exports = "vehicles-panel .container {\n    display: inline;\n    float: none;\n}\n\n.table > caption + thead > tr:first-child > td,\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td a,\n.table > tbody > tr > th a,\n.table > tfoot > tr > td a,\n.table > tfoot > tr > th a,\n.table > thead > tr > td a,\n.table > thead > tr > th a {\n    padding: 5px;\n    font-size: 0;\n    height: 24px;\n    line-height: 15px;\n}\n\n.table > tbody > tr > td a span,\n.table > tbody > tr > th a span,\n.table > tfoot > tr > td a span,\n.table > tfoot > tr > th a span,\n.table > thead > tr > td a span,\n.table > thead > tr > th a span {\n    font-size: 0;\n}\n\n.table > tbody > tr > td a span img,\n.table > tbody > tr > th a span img,\n.table > tfoot > tr > td a span img,\n.table > tfoot > tr > th a span img,\n.table > thead > tr > td a span img,\n.table > thead > tr > th a span img {\n    width: 12px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\n#newEntity {\n    float: none;\n    padding: 0;\n}\n\n#bulkLoadContainer {\n    margin-top: 30px;\n    background-color: #d9edf7;\n    border-radius: 4px;\n    -webkit-margin-start: 0;\n    -webkit-margin-end: 0;\n    -webkit-padding-before: 0;\n    -webkit-padding-start: 0;\n    -webkit-padding-end: 0;\n    -webkit-padding-after: 0;\n}\n\n#bulkLoadContainer legend {\n    position: relative;\n    top: 30px;\n    padding-left: 15px;\n}\n\n#bulkLoadContainer .my-drop-zone {\n    margin-top: 20px;\n}\n\n.row.uploaderQueue {\n    background-color: #d9edf7;\n    position: relative;\n    top: -3px;\n}\n\n.row.uploaderQueue .noPadding {\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.row.uploaderQueue .noPadding table {\n    color: #333;\n}\n\n#bulkLoadContainer {\n    display: block;\n}"

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var Observable_1 = __webpack_require__(34);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var navigation_service_1 = __webpack_require__(403);
	var infractions_service_1 = __webpack_require__(634);
	var bank_service_1 = __webpack_require__(631);
	var cities_service_1 = __webpack_require__(633);
	var infraction_1 = __webpack_require__(902);
	var vehicle_1 = __webpack_require__(873);
	var address_1 = __webpack_require__(876);
	var bank_1 = __webpack_require__(875);
	var infractionState_1 = __webpack_require__(905);
	var login_service_1 = __webpack_require__(404);
	__webpack_require__(405);
	var ng2_file_upload_1 = __webpack_require__(889);
	var FileUploaderCustom_1 = __webpack_require__(907);
	var validators_1 = __webpack_require__(849);
	var tab_component_1 = __webpack_require__(859);
	var tabs_component_1 = __webpack_require__(857);
	var InfractionsPanelComponent = (function () {
	    function InfractionsPanelComponent(router, infractionsService, bankService, citiesService, navigationService, loginService) {
	        var _this = this;
	        this.router = router;
	        this.infractionsService = infractionsService;
	        this.bankService = bankService;
	        this.citiesService = citiesService;
	        this.navigationService = navigationService;
	        this.loginService = loginService;
	        /* this.myDatePickerOptions = {dateFormat: 'dd/mm/yyyy'};*/
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los bancos.');
	        });
	        infractionsService.getInfractionStates().subscribe(this.setStates.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los estados de infracciones.');
	        });
	        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
	        /*this.form.valueChanges
	         .debounceTime(400)
	         .subscribe(this.find.bind(this));*/
	        this.citiesDataSource = Observable_1.Observable.create(function (observer) {
	            // Runs on every search
	            observer.next(_this.city);
	        }).mergeMap(function (token) { return _this.citiesService.getCitiesByName(token); });
	    }
	    InfractionsPanelComponent.prototype.init = function () {
	        this.data = [];
	        this.sortMode = null;
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.stateTodos = new infractionState_1.InfractionState('', 'TODOS');
	        this.state = this.stateTodos;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        this.bank = this.bankTodos;
	        this.banks = [];
	        this.states = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.withActs = false;
	        this.canEditInfraction = false;
	        this.canViewInfractionAsClient = false;
	        this.canDeleteInfraction = false;
	        this.canViewInfraction = false;
	        this.isBankGalicia = false;
	        this.showFilters = false;
	        this.sendMailSuccess = false;
	        this.sendMailError = false;
	        this.createUploaderBulkLoad();
	        this.createUploaderBulkLoadPay();
	        this.createUploaderBulkLoadUpdate();
	        this.errorsBulkLoad = [];
	        this.form = new forms_1.FormGroup({
	            act: new forms_1.FormControl(),
	            patent: new forms_1.FormControl(),
	            bank: new forms_1.FormControl(),
	            city: new forms_1.FormControl(),
	            cuit: new forms_1.FormControl(),
	            state: new forms_1.FormControl(),
	            creationDateSince: new forms_1.FormControl(this.creationDateSince, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR, this.validateCreationDateSinceRequired.bind(this)]),
	            creationDateUntil: new forms_1.FormControl(this.creationDateUntil, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR, this.validateCreationDateUntilRequired.bind(this)]),
	            itemsPerPage: new forms_1.FormControl(),
	            withActs: new forms_1.FormControl()
	        });
	        this.isBeforeUpload = true;
	        this.oneClickBulkLoadPay = false;
	        this.oneClickBulkLoad = false;
	        this.oneClickBulkLoadUpdate = false;
	    };
	    InfractionsPanelComponent.prototype.validateCreationDateSinceRequired = function (group) {
	        if (!this.creationDateSince && this.creationDateUntil) {
	            this.form.controls['creationDateUntil'].updateValueAndValidity();
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    InfractionsPanelComponent.prototype.validateCreationDateUntilRequired = function (group) {
	        if (this.creationDateSince && !this.creationDateUntil) {
	            this.form.controls['creationDateSince'].updateValueAndValidity();
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    InfractionsPanelComponent.prototype.triggerCreateDateValidators = function () {
	        this.form.controls['creationDateSince'].updateValueAndValidity();
	        this.form.controls['creationDateUntil'].updateValueAndValidity();
	    };
	    InfractionsPanelComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.bank = banks[0];
	        }
	    };
	    InfractionsPanelComponent.prototype.setStates = function (states) {
	        this.states = states;
	        if (states.length == 1) {
	            this.state = states[0];
	        }
	    };
	    InfractionsPanelComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    InfractionsPanelComponent.prototype.createFilter = function () {
	        var filter = new infraction_1.Infraction();
	        filter.vehicle = new vehicle_1.Vehicle();
	        filter.actNumber = this.act;
	        filter.vehicle.patent = this.patent;
	        filter.vehicle.contract.cuit = this.cuit;
	        if (this.bankId) {
	            filter.vehicle.contract.bank.id = this.bankId;
	        }
	        else {
	            filter.vehicle.contract.bank = this.bank;
	        }
	        if (this.city && this.citySelected) {
	            filter.address = new address_1.Address(null);
	            filter.address.city = this.citySelected;
	        }
	        filter.state = this.state;
	        filter.creationDateSince = this.creationDateSince;
	        filter.creationDateUntil = this.creationDateUntil;
	        return filter;
	    };
	    InfractionsPanelComponent.prototype.filterEmpty = function () {
	        return !(this.act || this.patent || this.cuit || this.city || this.bank.id !== '' || this.state.id !== ''
	            || (this.creationDateSince && this.creationDateUntil));
	    };
	    InfractionsPanelComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        if (this.itemsPerPage != null && this.itemsPerPage > 0) {
	            if (!this.filterEmpty() && this.form.valid) {
	                this.loading = true;
	                this.infractionsService.findInfractions(this.createFilter(), page, this.itemsPerPage).subscribe(function (data) {
	                    console.log(data);
	                    _this.refreshData(data);
	                    if (_this.sortMode != null)
	                        _this.sortPage();
	                    _this.page = page;
	                }, function () {
	                    _this.bindError('Ocurrió un error al cargar las infracciones.');
	                });
	            }
	        }
	        else {
	            this.bindError('Cantidad de ítems no válida.');
	        }
	    };
	    InfractionsPanelComponent.prototype.refreshData = function (page) {
	        var _this = this;
	        this.data = page.content.map(function (infraction) {
	            var i = new infraction_1.Infraction(infraction);
	            if (i.hasBankGalicia) {
	                console.log("SI TIENE BANCO GALICIA");
	                _this.isBankGalicia = true;
	            }
	            return i;
	        });
	        /*page.content;*/
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    InfractionsPanelComponent.prototype.removeItem = function (deleteModal) {
	        var _this = this;
	        this.error = null;
	        this.infractionsService.delete(this.infractionSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeItemFromView(_this.infractionSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar infraccion.');
	        });
	    };
	    InfractionsPanelComponent.prototype.removeItemFromView = function (infraction) {
	        var index = this.data.indexOf(infraction);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.infractionSelected = null;
	    };
	    InfractionsPanelComponent.prototype.editItem = function (item, event) {
	        event.preventDefault();
	        this.navigationService.setBackParameters({ tabSelected: 'infractions' });
	        this.router.navigate(['app/home/editInfraction', item.id]);
	    };
	    InfractionsPanelComponent.prototype.create = function (event) {
	        event.preventDefault();
	        this.navigationService.setBackParameters({ tabSelected: 'infractions' });
	        this.router.navigate(['app/home/createInfraction']);
	    };
	    InfractionsPanelComponent.prototype.downloadClientInfractions = function () {
	        this.error = null;
	        this.loading = true;
	        this.reportMessage = 'Creando reporte...';
	        if (this.withActs) {
	            if (this.total < 3000) {
	                this.reportMessage = 'Creando reporte...';
	            }
	        }
	        var url = window.location.origin +
	            infractions_service_1.InfractionsService.getURLFilterInfractions(this.createFilter(), this.page, this.itemsPerPage, this.withActs);
	        window.location.href = url;
	        this.loading = false;
	    };
	    InfractionsPanelComponent.prototype.downloadFilterInfractions = function () {
	        this.error = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.reportMessage = 'Creando reporte...';
	            if (this.withActs) {
	                if (this.total < 3000) {
	                    /*TODO: muchas imágenes puede que rompa por timeout*/
	                    this.reportMessage = 'Creando reporte...';
	                }
	            }
	            /*
	             * Se exportan todos las infracciones que cumplan con el filtro.
	             * Sólo las infracciones de la página actual se descargan.
	             * Opcional: descarga de imágenes de actas.
	             */
	            var url = window.location.origin +
	                infractions_service_1.InfractionsService.getURLFilterInfractions(this.createFilter(), this.page, this.itemsPerPage, this.withActs);
	            window.location.href = url;
	            this.loading = false;
	        }
	    };
	    InfractionsPanelComponent.prototype.close = function (saved) {
	        if (saved) {
	            this.find();
	        }
	    };
	    InfractionsPanelComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    InfractionsPanelComponent.prototype.onCitySelected = function (city) {
	        this.citySelected = city.item;
	    };
	    InfractionsPanelComponent.prototype.changeCitiesTypeaheadNoResults = function (e) {
	        this.typeaheadCitiesNoResults = e;
	    };
	    InfractionsPanelComponent.prototype.ngOnInit = function () {
	        var userLogged = this.loginService.getUserLogged();
	        console.log("hola ");
	        this.canEditInfraction = userLogged.isActionAllowed('INFRACTIONS', 'EDIT', 'INFRACTIONS');
	        //this.canViewInfractionAsClient = userLogged.isClient();
	        this.canViewInfractionAsClient = userLogged.isPatent();
	        this.canDeleteInfraction = userLogged.isActionAllowed('INFRACTIONS', 'DELETE', 'INFRACTIONS');
	        this.canViewInfraction = userLogged.isActionAllowed('INFRACTIONS', 'VIEW', 'INFRACTIONS');
	        console.log(userLogged);
	        this.isBankGalicia = userLogged.isGaliciaBank();
	        if (userLogged.rol.client) {
	            if (userLogged.cuit) {
	                this.cuit = userLogged.username;
	            }
	            else {
	                this.patent = userLogged.username;
	            }
	            this.bankId = userLogged.bank.id;
	            this.showFilters = false;
	            this.find();
	        }
	        else {
	            this.showFilters = true;
	        }
	    };
	    InfractionsPanelComponent.prototype.createUploaderBulkLoad = function () {
	        var _this = this;
	        this.uploaderBulkLoad = new FileUploaderCustom_1.FileUploaderCustom({
	            url: 'infraction/bulkLoad',
	            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	             'image/jpeg', 'image/gif', 'image/png']*/
	            allowedMimeType: validators_1.VALID_MIME_TYPES,
	            maxFileSize: validators_1.FILE_MAX_SIZE
	        });
	        this.hasBulkLoadDropZoneOver = false;
	        this.uploaderBulkLoad.onErrorItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de infracciones no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        infractions_service_1.InfractionsService.getURLInfractionBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de infracciones cancelada.");
	                }
	            }
	            _this.oneClickBulkLoad = false;
	            _this.showBulkLoadModal();
	        };
	        this.uploaderBulkLoad.onSuccessItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 200) {
	                var message = response.split("|");
	                _this.errorsBulkLoad = [];
	                _this.errorsBulkLoad[0] = message[0];
	                if (message.length > 1) {
	                    window.location.href = window.location.origin +
	                        infractions_service_1.InfractionsService.getURLInfractionBulkload(message[1]);
	                }
	            }
	            else if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de infracciones no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        infractions_service_1.InfractionsService.getURLInfractionBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de infracciones cancelada.");
	                }
	            }
	            _this.showBulkLoadModal();
	            _this.oneClickBulkLoad = false;
	        };
	    };
	    InfractionsPanelComponent.prototype.createUploaderBulkLoadPay = function () {
	        var _this = this;
	        this.uploaderBulkLoadPay = new ng2_file_upload_1.FileUploader({
	            url: 'infraction/bulkLoadPay',
	            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	             'image/jpeg', 'image/gif', 'image/png']*/
	            allowedMimeType: validators_1.VALID_MIME_TYPES,
	            maxFileSize: validators_1.FILE_MAX_SIZE
	        });
	        this.hasBulkLoadPayDropZoneOver = false;
	        this.uploaderBulkLoadPay.onCompleteItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 200) {
	                var message = response.split("|");
	                _this.errorsBulkLoad = [];
	                _this.errorsBulkLoad[0] = message[0];
	                if (message.length > 1) {
	                    window.location.href = window.location.origin +
	                        infractions_service_1.InfractionsService.getURLInfractionBulkload(message[1]);
	                }
	            }
	            else if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de infracciones no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        infractions_service_1.InfractionsService.getURLInfractionBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de infracciones cancelada.");
	                }
	            }
	            _this.showBulkLoadPayModal();
	            _this.oneClickBulkLoadPay = false;
	        };
	    };
	    InfractionsPanelComponent.prototype.createUploaderBulkLoadUpdate = function () {
	        var _this = this;
	        this.uploaderBulkLoadUpdate = new FileUploaderCustom_1.FileUploaderCustom({
	            url: 'infraction/bulkLoadUpdate',
	            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	             'image/jpeg', 'image/gif', 'image/png']*/
	            allowedMimeType: validators_1.VALID_MIME_TYPES,
	            maxFileSize: validators_1.FILE_MAX_SIZE
	        });
	        this.hasBulkLoadUpdateDropZoneOver = false;
	        this.uploaderBulkLoadUpdate.onErrorItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de actualización de infracciones no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        infractions_service_1.InfractionsService.getURLInfractionBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de actualización de infracciones cancelada.");
	                }
	            }
	            _this.oneClickBulkLoadUpdate = false;
	            _this.showBulkLoadUpdateModal();
	        };
	        this.uploaderBulkLoadUpdate.onSuccessItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 200) {
	                var message = response.split("|");
	                _this.errorsBulkLoad = [];
	                _this.errorsBulkLoad[0] = message[0];
	                if (message.length > 1) {
	                    window.location.href = window.location.origin +
	                        infractions_service_1.InfractionsService.getURLInfractionBulkload(message[1]);
	                }
	            }
	            _this.loading = false;
	            _this.oneClickBulkLoadUpdate = false;
	            _this.showBulkLoadUpdateModal();
	        };
	    };
	    InfractionsPanelComponent.prototype.sendMail = function (item, event) {
	        var _this = this;
	        event.preventDefault();
	        this.sendMailSuccess = false;
	        this.sendMailError = false;
	        item.sendingMail = true;
	        this.infractionsService.sendMail(item).subscribe(function () {
	            item.sendingMail = false;
	            item.sent = true;
	            _this.sendMailSuccess = true;
	        }, function (error) {
	            if (error.status == 501) {
	                _this.bindError('Ocurrió un error al enviar mail.');
	            }
	            item.sendingMail = false;
	            _this.sendMailError = true;
	        });
	    };
	    InfractionsPanelComponent.prototype.fileOverBulkLoadPay = function (e) {
	        this.hasBulkLoadPayDropZoneOver = e;
	    };
	    InfractionsPanelComponent.prototype.fileOverBulkLoad = function (e) {
	        this.hasBulkLoadDropZoneOver = e;
	    };
	    InfractionsPanelComponent.prototype.enableMultipleFiles = function () {
	        return false;
	    };
	    InfractionsPanelComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        /*Limpieza de inputs al agregar a la cola el/los archivo/s*/
	        this.uploaderBulkLoadPay.onAfterAddingFile = (function () {
	            _this.bulkLoadInfractionPay.nativeElement.value = '';
	            _this.reportMessage = null;
	        });
	        this.uploaderBulkLoad.onAfterAddingFile = (function () {
	            _this.bulkLoadInfraction.nativeElement.value = '';
	            _this.reportMessage = null;
	        });
	        this.uploaderBulkLoadUpdate.onAfterAddingFile = (function () {
	            _this.bulkLoadUpdateInfraction.nativeElement.value = '';
	            _this.reportMessage = null;
	        });
	    };
	    InfractionsPanelComponent.prototype.showBulkLoadPayModal = function () {
	        this.bulkLoadInfractionPayModal.show();
	        this.disableLoading();
	    };
	    InfractionsPanelComponent.prototype.showBulkLoadModal = function () {
	        this.bulkLoadInfractionModal.show();
	        this.disableLoading();
	        this.isBeforeUpload = false;
	    };
	    InfractionsPanelComponent.prototype.showBulkLoadUpdateModal = function () {
	        this.bulkLoadUpdateInfractionModal.show();
	        this.disableLoading();
	        this.isBeforeUpload = false;
	    };
	    InfractionsPanelComponent.prototype.hideBulkLoadPayModal = function () {
	        this.bulkLoadInfractionPayModal.hide();
	        this.errorsBulkLoad = [];
	    };
	    InfractionsPanelComponent.prototype.hideBulkLoadModal = function () {
	        this.bulkLoadInfractionModal.hide();
	        this.errorsBulkLoad = [];
	        window.location.reload();
	    };
	    InfractionsPanelComponent.prototype.hideBulkLoadUpdateModal = function () {
	        this.bulkLoadUpdateInfractionModal.hide();
	        this.errorsBulkLoad = [];
	    };
	    /**
	     * MIGRACION
	     * */
	    InfractionsPanelComponent.prototype.migrateActs = function () {
	        var _this = this;
	        this.infractionsService.migrateActs().subscribe(function () {
	        }, function () {
	            _this.bindError('Ocurrió un error con la migracion.');
	        });
	    };
	    InfractionsPanelComponent.prototype.imageNotFound = function () {
	        this.infractionAct.nativeElement.setAttribute('src', this.imgNotFound.nativeElement.getAttribute('src'));
	        this.infractionAct.nativeElement.setAttribute('height', 150);
	        this.infractionAct.nativeElement.setAttribute('width', 150);
	    };
	    InfractionsPanelComponent.prototype.disableLoading = function () {
	        this.loading = false;
	        this.oneClickBulkLoad = false;
	        this.oneClickBulkLoadPay = false;
	        this.oneClickBulkLoadUpdate = false;
	    };
	    InfractionsPanelComponent.prototype.enableLoading = function () {
	        this.loading = true;
	    };
	    InfractionsPanelComponent.prototype.enableOneClickBulkload = function () {
	        this.oneClickBulkLoad = true;
	    };
	    InfractionsPanelComponent.prototype.enableOneClickBulkloadPay = function () {
	        this.oneClickBulkLoadPay = true;
	    };
	    InfractionsPanelComponent.prototype.enableOneClickBulkloadUpdate = function () {
	        this.oneClickBulkLoadUpdate = true;
	    };
	    InfractionsPanelComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    InfractionsPanelComponent.prototype.sortPage = function () {
	        var _this = this;
	        this.data.sort(function (a, b) {
	            if (_this.sortMode) {
	                //PAGA      -> 1
	                //NO PAGA   -> 2
	                //RESTO     -> 3
	                if ((a.state.id == '1' || a.state.id == '2' || a.state.id == '3'))
	                    _this.pA = 1;
	                else if (a.state.id == '5')
	                    _this.pA = 2;
	                else
	                    _this.pA = 3;
	                if ((b.state.id == '1' || b.state.id == '2' || b.state.id == '3'))
	                    _this.pB = 1;
	                else if (b.state.id == '5')
	                    _this.pB = 2;
	                else
	                    _this.pB = 3;
	                return _this.pA - _this.pB;
	            }
	            else {
	                //NO PAGA      -> 1
	                //PAGA         -> 2
	                //RESTO        -> 3
	                if ((a.state.id == '1' || a.state.id == '2' || a.state.id == '3'))
	                    _this.pA = 2;
	                else if (a.state.id == '5')
	                    _this.pA = 1;
	                else
	                    _this.pA = 3;
	                if ((b.state.id == '1' || b.state.id == '2' || b.state.id == '3'))
	                    _this.pB = 2;
	                else if (b.state.id == '5')
	                    _this.pB = 1;
	                else
	                    _this.pB = 3;
	                return _this.pA - _this.pB;
	            }
	        });
	    };
	    InfractionsPanelComponent.prototype.sortTable = function (sort) {
	        this.sortMode = sort;
	        this.sortPage();
	    };
	    __decorate([
	        core_1.ViewChild('bulkLoadInfractionPay'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionsPanelComponent.prototype, "bulkLoadInfractionPay", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadInfraction'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionsPanelComponent.prototype, "bulkLoadInfraction", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadUpdateInfraction'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionsPanelComponent.prototype, "bulkLoadUpdateInfraction", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadInfractionPayModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], InfractionsPanelComponent.prototype, "bulkLoadInfractionPayModal", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadInfractionModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], InfractionsPanelComponent.prototype, "bulkLoadInfractionModal", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadUpdateInfractionModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], InfractionsPanelComponent.prototype, "bulkLoadUpdateInfractionModal", void 0);
	    __decorate([
	        core_1.ViewChild('imgNotFound'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionsPanelComponent.prototype, "imgNotFound", void 0);
	    __decorate([
	        core_1.ViewChild('infractionActImage'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionsPanelComponent.prototype, "infractionAct", void 0);
	    __decorate([
	        core_1.ViewChild('download'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionsPanelComponent.prototype, "download", void 0);
	    InfractionsPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'infractions-panel',
	            template: __webpack_require__(908),
	            styles: [__webpack_require__(910)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                /*DATEPICKER_DIRECTIVES,*/
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp,
	                /*MyDatePicker,*/
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES,
	                tabs_component_1.Tabs,
	                tab_component_1.Tab
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [
	                ng2_pagination_1.PaginatePipe,
	                validators_1.AmountFormat
	            ],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, infractions_service_1.InfractionsService, bank_service_1.BankService, cities_service_1.CitiesService, navigation_service_1.NavigationService, login_service_1.LoginService])
	    ], InfractionsPanelComponent);
	    return InfractionsPanelComponent;
	}());
	exports.InfractionsPanelComponent = InfractionsPanelComponent;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var infractionType_1 = __webpack_require__(903);
	var address_1 = __webpack_require__(876);
	var vehicle_1 = __webpack_require__(873);
	var regulator_1 = __webpack_require__(904);
	var infractionState_1 = __webpack_require__(905);
	var infractionDocument_1 = __webpack_require__(906);
	var Infraction = (function () {
	    function Infraction(other) {
	        this.infractionType = new infractionType_1.InfractionType();
	        this.vehicle = new vehicle_1.Vehicle();
	        this.address = new address_1.Address(null);
	        this.comments = '';
	        this.sent = false;
	        this.sendingMail = false;
	        this.hasBankGalicia = false;
	        if (other) {
	            this.id = other.id;
	            this.tempId = other.tempId;
	            this.actNumber = other.actNumber;
	            this.infractionType = new infractionType_1.InfractionType(other.infractionType);
	            this.creationDate = other.creationDate;
	            this.creationDateSince = other.creationDateSince;
	            this.creationDateSince = other.creationDateUntil;
	            this.withSendMail = other.withSendMail;
	            this.vehicle = new vehicle_1.Vehicle(other.vehicle);
	            if (this.vehicle && this.vehicle.contract) {
	                if (this.vehicle.contract.bank.name === "BANCO GALICIA") {
	                    this.hasBankGalicia = true;
	                }
	            }
	            this.infractionDate = other.infractionDate;
	            this.infractionAmount = other.infractionAmount;
	            this.address = new address_1.Address(other.address);
	            this.regulator = new regulator_1.Regulator(other.regulator);
	            this.batch = other.batch;
	            this.state = new infractionState_1.InfractionState(other.state.id, other.state.description);
	            this.amountPaid = other.amountPaid;
	            this.paymentDate = other.paymentDate;
	            this.comments = other.comments;
	            this.act = new infractionDocument_1.InfractionDocument(other.act);
	            this.actPayReceipt = new infractionDocument_1.InfractionDocument(other.actPayReceipt);
	            this.discharge = new infractionDocument_1.InfractionDocument(other.discharge);
	            this.sent = other.sent;
	            this.sendingMail = other.sendingMail;
	            this.honorario = other.honorario;
	            this.mountTotal = other.mountTotal;
	        }
	    }
	    return Infraction;
	}());
	exports.Infraction = Infraction;


/***/ },
/* 903 */
/***/ function(module, exports) {

	"use strict";
	var InfractionType = (function () {
	    function InfractionType(other) {
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	            this.description = other.description;
	            this.order = other.order;
	        }
	    }
	    return InfractionType;
	}());
	exports.InfractionType = InfractionType;


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var address_1 = __webpack_require__(876);
	var Regulator = (function () {
	    function Regulator(other) {
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	            this.address = new address_1.Address(other.address);
	            this.hasAgreement = other.hasAgreement;
	            this.phone = other.phone;
	        }
	    }
	    return Regulator;
	}());
	exports.Regulator = Regulator;


/***/ },
/* 905 */
/***/ function(module, exports) {

	"use strict";
	var InfractionState = (function () {
	    function InfractionState(id, description) {
	        this.id = id;
	        this.description = description;
	    }
	    return InfractionState;
	}());
	exports.InfractionState = InfractionState;


/***/ },
/* 906 */
/***/ function(module, exports) {

	"use strict";
	var InfractionDocument = (function () {
	    function InfractionDocument(other) {
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	            this.contentType = other.contentType;
	            this.documentType = other.documentType;
	            this.entryDate = other.entryDate;
	        }
	    }
	    return InfractionDocument;
	}());
	exports.InfractionDocument = InfractionDocument;


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ng2_file_upload_1 = __webpack_require__(889);
	var FileUploaderCustom = (function (_super) {
	    __extends(FileUploaderCustom, _super);
	    function FileUploaderCustom(options) {
	        _super.call(this, options);
	    }
	    FileUploaderCustom.prototype.uploadAllFiles = function () {
	        var _this = this;
	        var xhr = new XMLHttpRequest();
	        var sendable = new FormData();
	        var fakeitem = null;
	        this.onBuildItemForm(fakeitem, sendable);
	        for (var _b = 0, _c = this.queue; _b < _c.length; _b++) {
	            var item = _c[_b];
	            item.isReady = true;
	            item.isUploading = true;
	            item.isUploaded = false;
	            item.isSuccess = false;
	            item.isCancel = false;
	            item.isError = false;
	            item.progress = 0;
	            if (typeof item._file.size !== 'number') {
	                throw new TypeError('The file specified is no longer valid');
	            }
	            sendable.append("files", item._file, item.file.name);
	        }
	        /*if (this.options.additionalParameter !== undefined) {
	         Object.keys(this.options.additionalParameter).forEach((key) => {
	         sendable.append(key, this.options.additionalParameter[key]);
	         });
	         }*/
	        xhr.onload = function () {
	            var gist = (xhr.status >= 200 && xhr.status < 300) || xhr.status === 304 ? 'Success' : 'Error';
	            var method = 'on' + gist + 'Item';
	            _this[method](fakeitem, xhr.response, xhr.status, null);
	        };
	        xhr.onerror = function () {
	            _this.onErrorItem(fakeitem, xhr.response, xhr.status, null);
	        };
	        xhr.onabort = function () {
	            _this.onErrorItem(fakeitem, xhr.response, xhr.status, null);
	        };
	        xhr.open("POST", this.options.url, true);
	        xhr.withCredentials = true;
	        if (this.options.headers) {
	            for (var _i = 0, _a = this.options.headers; _i < _a.length; _i++) {
	                var header = _a[_i];
	                xhr.setRequestHeader(header.name, header.value);
	            }
	        }
	        /*if (this.authToken) {
	         xhr.setRequestHeader(this.authTokenHeader, this.authToken);
	         }*/
	        xhr.send(sendable);
	    };
	    ;
	    return FileUploaderCustom;
	}(ng2_file_upload_1.FileUploader));
	exports.FileUploaderCustom = FileUploaderCustom;


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div>\n    <form class=\"form\" [formGroup]=\"form\">\n        <!--Descomentar si se quiere filtrar en cuanto el formulario cambie (ngSubmit)=\"find()\"-->\n        <div class=\"row\">\n            <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n            <div class=\"panel panel-default\" *ngIf=\"showFilters\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"actFilter\">Nro. Acta</label>\n                            <input type=\"text\" class=\"form-control\" id=\"actFilter\" placeholder=\"\"\n                                   formControlName=\"act\" [(ngModel)]=\"act\" name=\"act\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cuitFilter\">CUIT</label>\n                            <input type=\"text\" class=\"form-control\" id=\"cuitFilter\" placeholder=\"\"\n                                   formControlName=\"cuit\" [(ngModel)]=\"cuit\" name=\"cuit\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"patentFilter\">Patente</label>\n                            <input type=\"text\" class=\"form-control\" id=\"patentFilter\" placeholder=\"\"\n                                   formControlName=\"patent\" [(ngModel)]=\"patent\" name=\"patent\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cityFilter\">Localidad</label>\n                            <input [(ngModel)]=\"city\"\n                                   [value]=\"city?(city | uppercase):''\"\n                                   [typeahead]=\"citiesDataSource\"\n                                   (typeaheadOnSelect)=\"onCitySelected($event)\"\n                                   (typeaheadNoResults)=\"changeCitiesTypeaheadNoResults($event)\"\n                                   [typeaheadOptionField]=\"'completeName'\"\n                                   [typeaheadOptionsLimit]=\"10\"\n                                   [typeaheadMinLength]=\"3\"\n                                   class=\"form-control\" formControlName=\"city\" id=\"cityFilter\">\n                            <div *ngIf=\"typeaheadCitiesNoResults===true\" class=\"\" style=\"\">\n                                <!--<i class=\"glyphicon glyphicon-remove\"></i> No se encontraron resultados-->\n                                <span class=\"remove\"><img>No se encontraron resultados</span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-1\"></div>\n                    <div class=\"col-xs-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\" [(ngModel)]=\"bank\"\n                                    name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"stateFilter\">Estado</label>\n                            <select class=\"form-control\" id=\"stateFilter\" formControlName=\"state\" [(ngModel)]=\"state\"\n                                    name=\"state\">\n                                <option [ngValue]=\"stateTodos\">{{stateTodos.description}}</option>\n                                <option *ngFor=\"let state of states\" [ngValue]=\"state\">{{state.description}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm has-feedback\">\n                            <label for=\"creationDateSince\">Fecha de Alta (desde)</label>\n                            <div class=\"input-group\">\n                                <!--<span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>-->\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"creationDateSince\"\n                                       name=\"creationDateSince\" formControlName=\"creationDateSince\"\n                                       id=\"creationDateSince\" maxlength=\"10\" (change)=\"triggerCreateDateValidators()\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.creationDateSince.valid && form.controls.creationDateSince.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <div *ngIf=\"!form.controls.creationDateSince.valid && form.controls.creationDateSince.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.requiredDate}}\n                            </div>\n                            <!-- <my-date-picker [options]=\"myDatePickerOptions\" id=\"creationDateSince\"\n                                             (dateChanged)=\"changeCreationDate($event.formatted)\"\n                                             [selDate]=\"creationDateSince\"></my-date-picker>-->\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm has-feedback\">\n                            <label for=\"creationDateUntil\">Fecha de Alta (hasta)</label>\n                            <div class=\"input-group\">\n                                <!--<span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>-->\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"creationDateUntil\"\n                                       name=\"creationDateUntil\" formControlName=\"creationDateUntil\"\n                                       id=\"creationDateUntil\" maxlength=\"10\" (change)=\"triggerCreateDateValidators()\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.creationDateUntil.valid && form.controls.creationDateUntil.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <div *ngIf=\"!form.controls.creationDateUntil.valid && form.controls.creationDateUntil.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.requiredDate}}\n                            </div>\n                            <!-- <my-date-picker [options]=\"myDatePickerOptions\" id=\"creationDateUntil\"\n                                             (dateChanged)=\"changeCreationDate($event.formatted)\"\n                                             [selDate]=\"creationDateUntil\"></my-date-picker>-->\n                        </div>\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\"\n                                [disabled]=\"!form.valid || filterEmpty()\" style=\"margin-top: 23px\">\n                            <!--<span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span>-->\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div class=\"col-xs-12\" *ngIf=\"filterEmpty()\">\n                        <div class=\"alert alert-info\">Ingrese alg&uacute;n filtro de b&uacute;squeda</div>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <legend>Descarga de Infracciones</legend>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\" *ngIf=\"reportMessage\">\n                            <div class=\"alert alert-info\">{{reportMessage}}</div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <div class=\"form-group form-group-sm\">\n                                <div class=\"col-xs-9\">\n                                    <label class=\"hidden\" for=\"withActs\">Actas</label>\n                                    <label class=\"checkboxLabel\">\n                                        <input type=\"checkbox\" class=\"form-control checkbox\" id=\"withActs\"\n                                               formControlName=\"withActs\" [(ngModel)]=\"withActs\" name=\"withActs\"\n                                               [disabled]=\"data.length == 0\">\n                                        con descarga de actas</label>\n                                </div>\n                                <div class=\"col-xs-3\">\n                                    <button type=\"button\" class=\"btn btn-primary\" (click)=\"downloadFilterInfractions()\"\n                                            [disabled]=\"!form.valid || filterEmpty() || data.length == 0\"\n                                            style=\"margin-top: 23px\">\n                                        <!--<span class=\"glyphicon glyphicon-download-alt\" aria-hidden=\"true\"> Descargar</span>-->\n                                        <span class=\"download-alt\"><img>Descargar</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"panel panel-default\">\n                <div class=\"panel-body table-responsive noPadding\">\n                    <div class=\"form-group form-group-sm\">\n                        <div *ngIf=\"!canEditInfraction\">\n                            <div class=\"col-xs-2\">\n                                <label class=\"hidden\" for=\"withActs\">Actas</label>\n                                <label class=\"checkboxLabel\">\n                                    <input type=\"checkbox\" class=\"form-control checkbox\" id=\"withActsClient\"\n                                           formControlName=\"withActs\" [(ngModel)]=\"withActs\" name=\"withActs\"\n                                           [disabled]=\"data.length == 0\">\n                                    con descarga de actas</label>\n                            </div>\n                            <div class=\"col-xs-2\">\n                                <button type=\"button\" class=\"btn btn-primary\" (click)=\"downloadClientInfractions()\"\n                                        [disabled]=\"data.length == 0\"\n                                        style=\"margin-top: 19px; padding-left: 10px;\">\n                                    <span class=\"download-alt\"><img>Descargar</span>\n                                </button>\n                            </div>\n                            <div class=\"col-xs-4\">\n                                <label>Ordenar página según: </label>\n                                <div class=\"row\">\n                                    <div class=\"col-xs-3\">\n                                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"sortTable(true)\"\n                                                [disabled]=\"data.length == 0 || sortMode == true\"\n                                                style=\"margin-top: 19px; padding-left: 10px;\">Pagas\n                                        </button>\n                                    </div>\n                                    <div class=\"col-xs-3\">\n                                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"sortTable(false)\"\n                                                [disabled]=\"data.length == 0 || sortMode == false\"\n                                                style=\"margin-top: 19px; padding-left: 10px;\">No pagas\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"right\" style=\"padding-top: 10px\">\n                            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                            </div>\n                            <div class=\"pull-right\">\n                                <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                                <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\"\n                                       id=\"itemsPerPage\" name=\"itemsPerPage\"\n                                       formControlName=\"itemsPerPage\" maxlength=\"2\">\n                            </div>\n                        </div>\n                    </div>\n                    <table class=\"table table-striped\">\n                        <thead>\n                        <tr>\n                            <th style=\"width: 2.5%\"></th>\n                            <th style=\"width: 5%\">\n                                Nro. de Acta\n                            </th>\n                            <th style=\"width: 5% \">\n                                Patente\n                            </th>\n                            <th style=\"width: 5%\">\n                                Tipo\n                            </th>\n                            <th style=\"width: 7%\">\n                                Monto\n                            </th>\n                            <th style=\"width: 5%\"><!--*ngIf=\"canViewInfractionAsClient\" -->\n                                Comentarios\n                            </th>\n                            <th style=\"width: 5%\"><!--*ngIf=\"canViewInfractionAsClient\"-->\n                                Dirección\n                            </th>\n                            <th style=\"width: 5%\">\n                                Fecha Infracci&oacute;n\n                            </th>\n                            <th style=\"width: 5%\">\n                                Fecha de Alta\n                            </th>\n                            <th style=\"width: 7%\"><!--*ngIf=\"canViewInfractionAsClient\"-->\n                                Monto Abonado\n                            </th>\n                            <th style=\"width: 7%\" *ngIf=\"isBankGalicia\">\n                                Honorarios + Gastos\n                            </th>\n                             <th style=\"width: 7%\" *ngIf=\"isBankGalicia\"><!--*ngIf=\"canViewInfractionAsClient\"-->\n                                Monto Total\n                            </th>\n                            <th style=\"width: 5%\"> <!--*ngIf=\"canViewInfractionAsClient\"-->\n                                Fecha Pago\n                            </th>\n                            <th style=\"width: 5%\" *ngIf=\"!canViewInfractionAsClient\">\n                                Estado\n                            </th>\n                            <th *ngIf=\"canEditInfraction\" style=\"width: 5%\">\n                                Enviado\n                            </th>\n                            <th *ngIf=\"canEditInfraction || canDeleteInfraction\" style=\"width: 2.5%\">\n                                Acciones\n                            </th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                            <td style=\"font-size: 12px\">\n                                <a class=\"btn btn-primary\" title=\"Editar\" (click)=\"editItem(item,$event)\"\n                                   *ngIf=\"canEditInfraction\">\n                                    <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                                    <span class=\"pencil\"><img></span>\n                                </a>\n                                <a class=\"btn btn-primary\" title=\"Ver\" (click)=\"editItem(item,$event)\"\n                                   *ngIf=\"!canEditInfraction && canViewInfraction && !canViewInfractionAsClient\">\n                                    <!--<span class=\"glyphicon glyphicon-eye-open\"></span>-->\n                                    <span class=\"eye-open\"><img></span>\n                                </a>\n                                <a *ngIf=\"item.act\" class=\"btn btn-success\" title=\"Ver multa\"\n                                   (click)=\"infractionSelected=item;imageModal.show()\">\n                                    <!--<span class=\"glyphicon glyphicon glyphicon-picture\"></span>-->\n                                    <span class=\"picture\"><img></span>\n                                </a>\n                            </td>\n                            <td style=\"font-size: 12px\">{{item.actNumber}}</td>\n                            <td style=\"font-size: 12px\">{{item.vehicle.patent}}</td>\n                            <td style=\"font-size: 12px\">{{item.infractionType.name | uppercase}}</td>\n                            <td style=\"font-size: 12px\">{{item?.infractionAmount | amountFormat}}</td>\n                            <td style=\"font-size: 12px\">{{item.comments}}</td> <!--*ngIf=\"canViewInfractionAsClient\"-->\n                            <td style=\"font-size: 12px\">{{item?.address.toString()}}</td>\n                            <!--*ngIf=\"canViewInfractionAsClient\"-->\n                            <td style=\"font-size: 12px\">{{item.infractionDate}}</td>\n                            <td style=\"font-size: 12px\">{{item.creationDate}}</td>\n                            <td style=\"font-size: 12px\">{{item?.amountPaid | amountFormat}}</td>\n                            <td style=\"font-size: 12px\"  *ngIf=\"isBankGalicia\" >{{item?.honorario | amountFormat}}</td>\n                            <td style=\"font-size: 12px\"  *ngIf=\"isBankGalicia\">{{item?.mountTotal | amountFormat}}</td>\n                            <!--*ngIf=\"canViewInfractionAsClient\"-->\n                            <td style=\"font-size: 12px\">{{item?.paymentDate}}</td>\n                            <td style=\"font-size: 12px\" *ngIf=\"!canViewInfractionAsClient\">{{item.state?.description}}\n                            </td>\n                            <td style=\"font-size: 12px\" *ngIf=\"canEditInfraction\">{{(item.sent)?'SI':'NO'}}</td>\n                            <td style=\"font-size: 12px\">\n                                <a class=\"btn btn-success\" title=\"Enviar Mail\" (click)=\"sendMail(item,$event)\"\n                                   *ngIf=\"canEditInfraction\">\n                                    <!--<span class=\"glyphicon glyphicon-refresh\" *ngIf=\"!item.sendingMail\"></span>-->\n                                    <span class=\"refresh\" *ngIf=\"!item.sendingMail\"><img></span>\n                                    <span class=\"fa fa-spinner fa-spin\" *ngIf=\"item.sendingMail\"></span>\n                                </a>\n                                <a class=\"btn btn-danger\" title=\"Eliminar\"\n                                   (click)=\"infractionSelected=item;deleteModal.show();\" *ngIf=\"canDeleteInfraction\">\n                                    <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                                    <span class=\"remove\"><img></span>\n                                </a>\n                            </td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                        <tr>\n                            <td colspan=\"11\">\n                                <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                            </td>\n                        </tr>\n                        </tfoot>\n                    </table>\n                    <div class=\"alert alert-success\" *ngIf=\"sendMailSuccess\">El mail se envi&oacute; con &eacute;xito.\n                    </div>\n                    <div class=\"alert alert-danger\" *ngIf=\"sendMailError\">Ocurri&oacute; un error al enviar mail.</div>\n                </div>\n            </div>\n        </div>\n    </form>\n    <div *ngIf=\"canEditInfraction\">\n        <div class=\"row\">\n            <div class=\"col-xs-2\" id=\"newEntity\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"create($event)\">\n                    <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n                    <span class=\"plus\"><img></span>\n                    Nuevo\n                </button>\n            </div>\n        </div>\n        <tabs id=\"bulkLoadContainer\">\n            <tab [tabTitle]=\"'Carga masiva de pago de infracciones'\" [tabName]=\"'bulkloadPay'\">\n                <div class=\"row\">\n                    <div class=\"col-xs-4\">\n                        <div ng2FileDrop\n                             [ngClass]=\"{'nv-file-over': hasBulkLoadPayDropZoneOver}\"\n                             (fileOver)=\"fileOverBulkLoadPay($event)\"\n                             [uploader]=\"uploaderBulkLoadPay\"\n                             class=\"well my-drop-zone\">Arrastre el Excel de pago de infracciones aquí\n                        </div>\n                        <label for=\"bulkLoadInfractionPay\" class=\"custom-file-upload\">\n                            <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                        </label>\n                        <input #bulkLoadInfractionPay type=\"file\" id=\"bulkLoadInfractionPay\" ng2FileSelect\n                               [uploader]=\"uploaderBulkLoadPay\"/>\n                    </div>\n                    <div class=\"col-xs-1 spinLoading\">\n                        <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                            <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row uploaderQueue\">\n                    <div class=\"col-xs-12\" *ngIf=\"uploaderBulkLoadPay.queue?.length > 0\">\n                        <div class=\"col-md-12\">\n                            <table class=\"table\">\n                                <thead>\n                                <tr>\n                                    <th width=\"50%\">Nombre</th>\n                                    <th>Progreso</th>\n                                    <th *ngIf=\"isBeforeUpload\">Eliminar</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr *ngFor=\"let aFile of uploaderBulkLoadPay.queue\">\n                                    <td>\n                                        <strong>{{aFile.file.name}}</strong>\n                                    </td>\n                                    <td>\n                                        <div class=\"progress\" style=\"margin-bottom: 0;\">\n                                            <div class=\"progress-bar\" role=\"progressbar\"\n                                                 [ngStyle]=\"{ 'width': aFile.progress + '%' }\"></div>\n                                        </div>\n                                    </td>\n                                    <td nowrap *ngIf=\"isBeforeUpload\">\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\" (click)=\"aFile.remove()\">\n                                            <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                            <span class=\"trash\"><img></span> Eliminar\n                                        </button>\n                                    </td>\n                                </tr>\n                                <tr *ngIf=\"uploaderBulkLoadPay.queue?.length == 0\">\n                                    <td colspan=\"4\" class=\"text-center\">No hay carga masiva pendiente</td>\n                                </tr>\n                                </tbody>\n                            </table>\n                            <div>\n                                <div>\n                                    <div class=\"progress\">\n                                        <div class=\"progress-bar\" role=\"progressbar\"\n                                             [ngStyle]=\"{ 'width': uploaderBulkLoadPay.progress + '%' }\">\n                                        </div>\n                                    </div>\n                                </div>\n                                <button type=\"button\" class=\"btn btn-success btn-s\"\n                                        (click)=\"enableLoading(); uploaderBulkLoadPay.uploadAll(); enableOneClickBulkloadPay()\"\n                                        [disabled]=\"oneClickBulkLoadPay || !uploaderBulkLoadPay.getNotUploadedItems().length\">\n                                    <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                                    <span class=\"upload-icon\"><img></span> Cargar cola\n                                </button>\n                                <button type=\"button\" class=\"btn btn-warning btn-s\"\n                                        (click)=\"disableLoading(); uploaderBulkLoadPay.cancelAll()\"\n                                        [disabled]=\"!uploaderBulkLoadPay.isUploading\">\n                                    <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                    <span class=\"ban-circle-white\"><img></span> Cancelar cola\n                                </button>\n                                <button type=\"button\" class=\"btn btn-danger btn-s\"\n                                        (click)=\"disableLoading(); createUploaderBulkLoadPay()\"\n                                        [disabled]=\"!uploaderBulkLoadPay.queue.length\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span> Eliminar cola\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </tab>\n            <tab [tabTitle]=\"'Carga masiva de infracciones'\" [tabName]=\"'bulkload'\">\n                <div class=\"row\">\n                    <div class=\"col-xs-6\">\n                        <div ng2FileDrop\n                             [ngClass]=\"{'nv-file-over': hasBulkLoadDropZoneOver}\"\n                             (fileOver)=\"fileOverBulkLoad($event)\"\n                             [uploader]=\"uploaderBulkLoad\"\n                             class=\"well my-drop-zone\">Arrastre el Excel de alta de infracciones e imágenes de actas\n                            aquí\n                        </div>\n                        <label for=\"bulkLoadInfraction\" class=\"custom-file-upload\">\n                            <span class=\"upload-icon\"><img></span> Seleccionar archivo/s\n                            <!--<i class=\"fa fa-cloud-upload\"></i> -->\n                        </label>\n                        <input #bulkLoadInfraction type=\"file\" id=\"bulkLoadInfraction\" ng2FileSelect\n                               [uploader]=\"uploaderBulkLoad\" multiple [disabled]=\"enableMultipleFiles()\"/>\n                    </div>\n                    <div class=\"col-xs-1 spinLoading\">\n                        <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                            <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row uploaderQueue\">\n                    <div class=\"col-xs-12\" *ngIf=\"uploaderBulkLoad.queue?.length > 0\">\n                        <div class=\"col-md-12\">\n                            <table class=\"table\">\n                                <thead>\n                                <tr>\n                                    <th width=\"50%\">Nombre</th>\n                                    <th>Progreso</th>\n                                    <th *ngIf=\"isBeforeUpload\">Eliminar</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr *ngFor=\"let aFile of uploaderBulkLoad.queue\">\n                                    <td>\n                                        <strong>{{aFile.file.name}}</strong>\n                                    </td>\n                                    <td>\n                                        <div class=\"progress\" style=\"margin-bottom: 0;\">\n                                            <div class=\"progress-bar\" role=\"progressbar\"\n                                                 [ngStyle]=\"{ 'width': aFile.progress + '%' }\"></div>\n                                        </div>\n                                    </td>\n                                    <td nowrap *ngIf=\"isBeforeUpload\">\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"disableLoading(); aFile.remove()\">\n                                            <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                            <span class=\"trash\"><img></span> Eliminar\n                                        </button>\n                                    </td>\n                                </tr>\n                                <tr *ngIf=\"uploaderBulkLoad.queue?.length == 0\">\n                                    <td colspan=\"4\" class=\"text-center\">No hay carga masiva pendiente</td>\n                                </tr>\n                                </tbody>\n                            </table>\n                            <div>\n                                <div>\n                                    <div class=\"progress\">\n                                        <div class=\"progress-bar\" role=\"progressbar\"\n                                             [ngStyle]=\"{ 'width': uploaderBulkLoad.progress + '%' }\">\n                                        </div>\n                                    </div>\n                                </div>\n                                <button type=\"button\" class=\"btn btn-success btn-s\"\n                                        (click)=\"enableLoading(); uploaderBulkLoad.uploadAllFiles(); enableOneClickBulkload()\"\n                                        [disabled]=\"oneClickBulkLoad || !uploaderBulkLoad.getNotUploadedItems().length\">\n                                    <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                                    <span class=\"upload-icon\"><img></span> Cargar cola\n                                </button>\n                                <button type=\"button\" class=\"btn btn-warning btn-s\"\n                                        (click)=\"disableLoading(); uploaderBulkLoad.cancelAll()\"\n                                        [disabled]=\"!uploaderBulkLoad.isUploading\">\n                                    <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                    <span class=\"ban-circle-white\"><img></span> Cancelar cola\n                                </button>\n                                <button type=\"button\" class=\"btn btn-danger btn-s\"\n                                        (click)=\"disableLoading(); createUploaderBulkLoad()\"\n                                        [disabled]=\"!uploaderBulkLoad.queue.length\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span> Eliminar cola\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </tab>\n            <tab [tabTitle]=\"'Carga masiva de actualización de infracciones'\" [tabName]=\"'bulkloadUpdate'\"\n                 *ngIf=\"false\">\n                <div class=\"row\">\n                    <div class=\"col-xs-6\">\n                        <div ng2FileDrop\n                             [ngClass]=\"{'nv-file-over': hasBulkLoadUpdateDropZoneOver}\"\n                             (fileOver)=\"fileOverBulkLoadUpdate($event)\"\n                             [uploader]=\"uploaderBulkLoadUpdate\"\n                             class=\"well my-drop-zone\">Arrastre el Excel de actualización de infracciones e imágenes de\n                            actas\n                            aquí\n                        </div>\n                        <label for=\"bulkLoadUpdateInfraction\" class=\"custom-file-upload\">\n                            <span class=\"upload-icon\"><img></span> Seleccionar archivo/s\n                            <!--<i class=\"fa fa-cloud-upload\"></i> -->\n                        </label>\n                        <input #bulkLoadUpdateInfraction type=\"file\" id=\"bulkLoadUpdateInfraction\" ng2FileSelect\n                               [uploader]=\"uploaderBulkLoadUpdate\" multiple [disabled]=\"enableMultipleFiles()\"/>\n                    </div>\n                    <div class=\"col-xs-1 spinLoading\">\n                        <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                            <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row uploaderQueue\">\n                    <div class=\"col-xs-12\" *ngIf=\"uploaderBulkLoadUpdate.queue?.length > 0\">\n                        <div class=\"col-md-12\">\n                            <table class=\"table\">\n                                <thead>\n                                <tr>\n                                    <th width=\"50%\">Nombre</th>\n                                    <th>Progreso</th>\n                                    <th *ngIf=\"isBeforeUpload\">Eliminar</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr *ngFor=\"let aFile of uploaderBulkLoadUpdate.queue\">\n                                    <td>\n                                        <strong>{{aFile.file.name}}</strong>\n                                    </td>\n                                    <td>\n                                        <div class=\"progress\" style=\"margin-bottom: 0;\">\n                                            <div class=\"progress-bar\" role=\"progressbar\"\n                                                 [ngStyle]=\"{ 'width': aFile.progress + '%' }\"></div>\n                                        </div>\n                                    </td>\n                                    <td nowrap *ngIf=\"isBeforeUpload\">\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"disableLoading(); aFile.remove()\">\n                                            <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                            <span class=\"trash\"><img></span> Eliminar\n                                        </button>\n                                    </td>\n                                </tr>\n                                <tr *ngIf=\"uploaderBulkLoadUpdate.queue?.length == 0\">\n                                    <td colspan=\"4\" class=\"text-center\">No hay carga masiva pendiente</td>\n                                </tr>\n                                </tbody>\n                            </table>\n                            <div>\n                                <div>\n                                    <div class=\"progress\">\n                                        <div class=\"progress-bar\" role=\"progressbar\"\n                                             [ngStyle]=\"{ 'width': uploaderBulkLoadUpdate.progress + '%' }\">\n                                        </div>\n                                    </div>\n                                </div>\n                                <button type=\"button\" class=\"btn btn-success btn-s\"\n                                        (click)=\"enableLoading(); uploaderBulkLoadUpdate.uploadAllFiles(); enableOneClickBulkloadUpdate()\"\n                                        [disabled]=\"oneClickBulkLoadUpdate || !uploaderBulkLoadUpdate.getNotUploadedItems().length\">\n                                    <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                                    <span class=\"upload-icon\"><img></span> Cargar cola\n                                </button>\n                                <button type=\"button\" class=\"btn btn-warning btn-s\"\n                                        (click)=\"disableLoading(); uploaderBulkLoadUpdate.cancelAll()\"\n                                        [disabled]=\"!uploaderBulkLoad.isUploading\">\n                                    <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                    <span class=\"ban-circle-white\"><img></span> Cancelar cola\n                                </button>\n                                <button type=\"button\" class=\"btn btn-danger btn-s\"\n                                        (click)=\"disableLoading(); createUploaderBulkLoadUpdate()\"\n                                        [disabled]=\"!uploaderBulkLoadUpdate.queue.length\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span> Eliminar cola\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </tab>\n        </tabs>\n    </div>\n    <div bsModal #imageModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n         aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog modal-lg\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"imageModal.hide()\">\n                        <span aria-hidden=\"true\">&times;</span>\n                    </button>\n                    <h4 class=\"modal-title\">Imagen multa</h4>\n                </div>\n                <div *ngIf=\"infractionSelected\" class=\"modal-body\">\n                    <img #imgNotFound hidden src=\"" + __webpack_require__(909) + "\">\n                    <img #infractionActImage class=\"img-thumbnail img-responsive centered\"\n                         src=\"/infraction/{{infractionSelected.id}}/download/ACT\"\n                         (error)=\"imageNotFound($event)\">\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n            </div>\n            <div class=\"modal-body\">\n                &iquest;Est&aacute; seguro que desea eliminar la infracci&oacute;n <strong>{{infractionSelected?.actNumber}}</strong>?\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n                        (click)=\"removeItem(deleteModal)\">\n                    Aceptar\n                </button>\n                <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\" (click)=\"deleteModal.hide()\">\n                    Cancelar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #bulkLoadInfractionPayModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hideBulkLoadPayModal()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Carga masiva de pago de Infracciones</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"errorsBulkLoad\">{{errorsBulkLoad[0]}}</p>\n                <li *ngFor=\"let errorBL of errorsBulkLoad | slice:1\">{{errorBL}}</li>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #bulkLoadInfractionModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hideBulkLoadModal()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Carga masiva de Infracciones</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"errorsBulkLoad\">{{errorsBulkLoad[0]}}</p>\n                <li *ngFor=\"let errorBL of errorsBulkLoad | slice:1\">{{errorBL}}</li>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #bulkLoadUpdateInfractionModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hideBulkLoadUpdateModal()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Carga masiva de actualización de Infracciones</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"errorsBulkLoad\">{{errorsBulkLoad[0]}}</p>\n                <li *ngFor=\"let errorBL of errorsBulkLoad | slice:1\">{{errorBL}}</li>\n            </div>\n        </div>\n    </div>\n</div>\n<!-- MIGRACION\n<div>\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"migrateActs()\" style=\"margin-top: 23px; display: none\">\n        <span class=\"glyphicon glyphicon-folder-open\"></span>\n    </button>\n</div>-->\n";

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/image-not-found.1dd26afbbc2c0e3b0aab24628e2f04f3.png";

/***/ },
/* 910 */
/***/ function(module, exports) {

	module.exports = ".checkbox {\n    height: 20px;\n    width: 20px;\n    margin-left: 73px;\n}\n\n.checkboxLabel input.checkbox {\n    margin-right: 8px;\n    margin-left: 0;\n    float: left;\n}\n\n.centered {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.checkboxLabel {\n    display: inline-block;\n    margin-top: 18px;\n    float: left;\n}\n\n.table > caption + thead > tr:first-child > td,\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td a,\n.table > tbody > tr > th a,\n.table > tfoot > tr > td a,\n.table > tfoot > tr > th a,\n.table > thead > tr > td a,\n.table > thead > tr > th a {\n    padding: 5px;\n    font-size: 0;\n    height: 24px;\n    line-height: 15px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td a span,\n.table > tbody > tr > th a span,\n.table > tfoot > tr > td a span,\n.table > tfoot > tr > th a span,\n.table > thead > tr > td a span,\n.table > thead > tr > th a span {\n    font-size: 0;\n}\n\n.table > tbody > tr > td a span img,\n.table > tbody > tr > th a span img,\n.table > tfoot > tr > td a span img,\n.table > tfoot > tr > th a span img,\n.table > thead > tr > td a span img,\n.table > thead > tr > th a span img {\n    width: 12px;\n}\n\n.noPadding {\n    padding: 0;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\n#newEntity {\n    float: none;\n    padding: 0;\n}\n\n#bulkLoadContainer {\n    margin-top: 30px;\n    background-color: #d9edf7;\n    border-radius: 4px;\n    -webkit-margin-start: 0;\n    -webkit-margin-end: 0;\n    -webkit-padding-before: 0;\n    -webkit-padding-start: 0;\n    -webkit-padding-end: 0;\n    -webkit-padding-after: 0;\n}\n\n#bulkLoadContainer legend {\n    position: relative;\n    top: 30px;\n    padding-left: 15px;\n}\n\n#bulkLoadContainer .my-drop-zone {\n    margin-top: 20px;\n}\n\n.row.uploaderQueue {\n    background-color: #d9edf7;\n    position: relative;\n    top: -3px;\n}\n\n.row.uploaderQueue .noPadding {\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n#bulkLoadContainer {\n    display: block;\n}\n\n.row.uploaderQueue table {\n    color: #333;\n}"

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var vehicle_1 = __webpack_require__(873);
	var login_service_1 = __webpack_require__(404);
	var ng2_file_upload_1 = __webpack_require__(889);
	var kmHistory_service_1 = __webpack_require__(912);
	var bank_1 = __webpack_require__(875);
	var bank_service_1 = __webpack_require__(631);
	var validators_1 = __webpack_require__(849);
	var kmHistory_1 = __webpack_require__(884);
	var KmHistoryPanelComponent = (function () {
	    function KmHistoryPanelComponent(router, kmHistoryService, bankService, loginService) {
	        var _this = this;
	        this.router = router;
	        this.kmHistoryService = kmHistoryService;
	        this.bankService = bankService;
	        this.loginService = loginService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los bancos.');
	        });
	        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
	        /*this.form.valueChanges
	         .debounceTime(400)
	         .subscribe(this.find.bind(this));*/
	    }
	    KmHistoryPanelComponent.prototype.init = function () {
	        this.data = [];
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.banks = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        this.canEditKmHistory = false;
	        this.canViewKmHistory = false;
	        this.showFilters = false;
	        this.errorsBulkLoad = [];
	        this.createUploaderBulkLoad();
	        this.filter = new vehicle_1.Vehicle();
	        this.form = new forms_1.FormGroup({
	            patent: new forms_1.FormControl(),
	            bank: new forms_1.FormControl(),
	            contractNumber: new forms_1.FormControl(),
	            cuit: new forms_1.FormControl(),
	            loadDateSince: new forms_1.FormControl(this.loadDateSince, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR, this.validateLoadDateSinceRequired.bind(this)]),
	            loadDateUntil: new forms_1.FormControl(this.loadDateUntil, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR, this.validateLoadDateUntilRequired.bind(this)]),
	            itemsPerPage: new forms_1.FormControl()
	        });
	        if (!this.filter.contract.bank.id) {
	            this.filter.contract.bank = this.bankTodos;
	        }
	        this.filter.kmHistories = [];
	        this.filter.kmHistories[0] = new kmHistory_1.KmHistory(null);
	        this.oneClickBulkLoad = false;
	    };
	    KmHistoryPanelComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    KmHistoryPanelComponent.prototype.filterEmpty = function () {
	        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit
	            || (this.filter.contract.bank && this.filter.contract.bank.id != '')
	            || (this.loadDateSince && this.loadDateUntil));
	    };
	    KmHistoryPanelComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.filter.contract.bank = banks[0];
	        }
	    };
	    KmHistoryPanelComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            if (this.loadDateSince && this.loadDateUntil) {
	                if (this.filter.kmHistories.length == 0) {
	                    this.filter.kmHistories = [];
	                    this.filter.kmHistories[0] = new kmHistory_1.KmHistory(null);
	                }
	                this.filter.kmHistories[0].loadDateSince = this.loadDateSince;
	                this.filter.kmHistories[0].loadDateUntil = this.loadDateUntil;
	            }
	            this.kmHistoryService.findKmHistory(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	                _this.refreshData(data);
	                _this.page = page;
	            }, function () {
	                _this.bindError('Ocurrió un error al buscar los vehículos.');
	            });
	        }
	    };
	    KmHistoryPanelComponent.prototype.refreshData = function (page) {
	        this.data = page.content;
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    KmHistoryPanelComponent.prototype.editItem = function (item) {
	        this.router.navigate(['app/home/editKmHistory', item.id]);
	    };
	    KmHistoryPanelComponent.prototype.downloadFilterKmHistories = function () {
	        this.error = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.reportMessage = 'Creando reporte...';
	            if (this.loadDateSince && this.loadDateUntil) {
	                if (this.filter.kmHistories.length == 0) {
	                    this.filter.kmHistories = [];
	                    this.filter.kmHistories[0] = new kmHistory_1.KmHistory(null);
	                }
	                this.filter.kmHistories[0].loadDateSince = this.loadDateSince;
	                this.filter.kmHistories[0].loadDateUntil = this.loadDateUntil;
	            }
	            /*
	             * Se exportan todos los históricos de vehículos que cumplan con el filtro.
	             * Sólo los históricos de vehículos de la página actual se descargan.
	             */
	            window.location.href = window.location.origin +
	                kmHistory_service_1.KmHistoryService.getURLFilterKmHistories(this.filter, this.page, this.itemsPerPage);
	            this.loading = false;
	        }
	    };
	    KmHistoryPanelComponent.prototype.close = function (saved) {
	        if (saved) {
	            this.find();
	        }
	    };
	    KmHistoryPanelComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    KmHistoryPanelComponent.prototype.ngOnInit = function () {
	        this.userLogged = this.loginService.getUserLogged();
	        this.canEditKmHistory = this.userLogged.isActionAllowed('KM_HISTORY', 'EDIT', 'KM_HISTORY');
	        this.canViewKmHistory = this.userLogged.isActionAllowed('KM_HISTORY', 'VIEW', 'KM_HISTORY');
	        if (this.userLogged.rol.client) {
	            if (this.userLogged.cuit) {
	                this.filter.contract.cuit = this.userLogged.username;
	            }
	            else {
	                this.filter.patent = this.userLogged.username;
	            }
	            this.filter.contract.bank.id = this.userLogged.bank.id;
	            this.showFilters = false;
	        }
	        else {
	            this.showFilters = true;
	        }
	        this.getPage(1);
	    };
	    KmHistoryPanelComponent.prototype.createUploaderBulkLoad = function () {
	        var _this = this;
	        this.uploaderBulkLoad = new ng2_file_upload_1.FileUploader({
	            url: 'kmHistory/bulkLoad',
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.hasBulkLoadDropZoneOver = false;
	        this.uploaderBulkLoad.onCompleteItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 200) {
	                var message = response.split("|");
	                _this.errorsBulkLoad = [];
	                _this.errorsBulkLoad[0] = message[0];
	                if (message.length > 1) {
	                    window.location.href = window.location.origin +
	                        kmHistory_service_1.KmHistoryService.getURLKmHistoryBulkload(message[1]);
	                }
	            }
	            else if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de histórico de vehículos no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        kmHistory_service_1.KmHistoryService.getURLKmHistoryBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de histórico de vehículos cancelada.");
	                }
	            }
	            _this.showBulkLoadModal();
	            _this.oneClickBulkLoad = false;
	        };
	    };
	    KmHistoryPanelComponent.prototype.fileOverBulkLoad = function (e) {
	        this.hasBulkLoadDropZoneOver = e;
	    };
	    KmHistoryPanelComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        /*Limpieza de inputs al agregar a la cola el archivo*/
	        this.uploaderBulkLoad.onAfterAddingFile = (function (item) {
	            _this.bulkLoad.nativeElement.value = '';
	            _this.reportMessage = null;
	        });
	    };
	    KmHistoryPanelComponent.prototype.showBulkLoadModal = function () {
	        this.bulkLoadModal.show();
	        this.disableLoading();
	    };
	    KmHistoryPanelComponent.prototype.hideBulkLoadModal = function () {
	        this.bulkLoadModal.hide();
	        this.errorsBulkLoad = [];
	    };
	    KmHistoryPanelComponent.prototype.disableLoading = function () {
	        this.loading = false;
	        this.oneClickBulkLoad = false;
	    };
	    KmHistoryPanelComponent.prototype.enableLoading = function () {
	        this.loading = true;
	    };
	    KmHistoryPanelComponent.prototype.enableOneClickBulkload = function () {
	        this.oneClickBulkLoad = true;
	    };
	    KmHistoryPanelComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    KmHistoryPanelComponent.prototype.validateLoadDateSinceRequired = function (group) {
	        if (!this.loadDateSince && this.loadDateUntil) {
	            this.form.controls['loadDateUntil'].updateValueAndValidity();
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    KmHistoryPanelComponent.prototype.validateLoadDateUntilRequired = function (group) {
	        if (this.loadDateSince && !this.loadDateUntil) {
	            this.form.controls['loadDateSince'].updateValueAndValidity();
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    KmHistoryPanelComponent.prototype.triggerLoadDateValidators = function () {
	        this.form.controls['loadDateSince'].updateValueAndValidity();
	        this.form.controls['loadDateUntil'].updateValueAndValidity();
	    };
	    __decorate([
	        core_1.ViewChild('bulkLoadKmHistory'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], KmHistoryPanelComponent.prototype, "bulkLoad", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadKmHistoryModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], KmHistoryPanelComponent.prototype, "bulkLoadModal", void 0);
	    KmHistoryPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'kmHistory-panel',
	            template: __webpack_require__(913),
	            styles: [__webpack_require__(914)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe, validators_1.KmFormat],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, kmHistory_service_1.KmHistoryService, bank_service_1.BankService, login_service_1.LoginService])
	    ], KmHistoryPanelComponent);
	    return KmHistoryPanelComponent;
	}());
	exports.KmHistoryPanelComponent = KmHistoryPanelComponent;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var KmHistoryService = (function () {
	    function KmHistoryService(backendService) {
	        this.backendService = backendService;
	    }
	    KmHistoryService.prototype.findKmHistory = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        if (filter.kmHistories.length > 0) {
	            if (filter.kmHistories[0].loadDateSince && filter.kmHistories[0].loadDateUntil) {
	                params.set('kmHistories[0].loadDateSince', filter.kmHistories[0].loadDateSince);
	                params.set('kmHistories[0].loadDateUntil', filter.kmHistories[0].loadDateUntil);
	            }
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("km_histories", params);
	    };
	    KmHistoryService.prototype.getVehicle = function (vehicleId) {
	        return this.backendService.get("vehicle/" + vehicleId + "/kmHistory ", null);
	    };
	    KmHistoryService.prototype.save = function (vehicle) {
	        return this.backendService.post("vehicle/kmHistory", vehicle, null);
	    };
	    KmHistoryService.getURLKmHistoryBulkload = function (documentId) {
	        return "/kmHistoriesBulkloadDocument/" + documentId;
	    };
	    KmHistoryService.prototype.delete = function (kmHistoryId) {
	        return this.backendService.delete("kmHistory/" + kmHistoryId, null, null);
	    };
	    KmHistoryService.setParams = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        if (filter.kmHistories.length > 0) {
	            if (filter.kmHistories[0].loadDateSince && filter.kmHistories[0].loadDateUntil) {
	                params.set('kmHistories[0].loadDateSince', filter.kmHistories[0].loadDateSince);
	                params.set('kmHistories[0].loadDateUntil', filter.kmHistories[0].loadDateUntil);
	            }
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return params;
	    };
	    KmHistoryService.getURLFilterKmHistories = function (filter, page, itemsPerPage) {
	        return "/kmHistoriesReport?" + KmHistoryService.setParams(filter, page, itemsPerPage).toString();
	    };
	    KmHistoryService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], KmHistoryService);
	    return KmHistoryService;
	}());
	exports.KmHistoryService = KmHistoryService;


/***/ },
/* 913 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n        <form class=\"form\" [formGroup]=\"form\">\n            <!--Descomentar si se quiere filtrar en cuanto el formulario cambie (ngSubmit)=\"find()\"-->\n            <div class=\"panel panel-default\" *ngIf=\"showFilters\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"patentFilter\">Patente</label>\n                            <input type=\"text\" class=\"form-control\" id=\"patentFilter\"\n                                   formControlName=\"patent\" [(ngModel)]=\"filter.patent\" name=\"patent\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\"\n                                    [(ngModel)]=\"filter.contract.bank\" name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"contractFilter\">Nro. de Contrato</label>\n                            <input type=\"text\" class=\"form-control\" id=\"contractFilter\" placeholder=\"\"\n                                   formControlName=\"contractNumber\" [(ngModel)]=\"filter.contract.contractNumber\"\n                                   name=\"contractNumber\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cuitFilter\">CUIT</label>\n                            <input type=\"text\" class=\"form-control\" id=\"cuitFilter\" placeholder=\"\"\n                                   formControlName=\"cuit\" [(ngModel)]=\"filter.contract.cuit\" name=\"cuit\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm has-feedback\">\n                            <label for=\"loadDateSince\">Fecha de Carga (desde)</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"loadDateSince\"\n                                       name=\"loadDateSince\" formControlName=\"loadDateSince\"\n                                       id=\"loadDateSince\" maxlength=\"10\"\n                                       (change)=\"triggerLoadDateValidators()\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.loadDateSince.valid && form.controls.loadDateSince.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <div *ngIf=\"!form.controls.loadDateSince.valid && form.controls.loadDateSince.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.requiredDate}}\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm has-feedback\">\n                            <label for=\"loadDateUntil\">Fecha de Carga (hasta)</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"loadDateUntil\"\n                                       name=\"loadDateUntil\" formControlName=\"loadDateUntil\"\n                                       id=\"loadDateUntil\" maxlength=\"10\"\n                                       (change)=\"triggerLoadDateValidators()\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.loadDateUntil.valid && form.controls.loadDateUntil.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <div *ngIf=\"!form.controls.loadDateUntil.valid && form.controls.loadDateUntil.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.requiredDate}}\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-5\">\n                        <!--EMPTY-->\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\"\n                                [disabled]=\"!form.valid || filterEmpty()\" style=\"margin-top: 23px\">\n                            <!--<span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span>-->\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div class=\"col-xs-12\" *ngIf=\"filterEmpty()\">\n                        <div class=\"alert alert-info\">Ingrese alg&uacute;n filtro de b&uacute;squeda</div>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <legend>Descarga de Histórico de Vehículos</legend>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\" *ngIf=\"reportMessage\">\n                            <div class=\"alert alert-info\">{{reportMessage}}</div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <div class=\"form-group form-group-sm\">\n                                <div class=\"col-xs-3\">\n                                    <button type=\"button\" class=\"btn btn-primary\" (click)=\"downloadFilterKmHistories()\"\n                                            [disabled]=\"!form.valid || filterEmpty() || data.length == 0\"\n                                            style=\"margin-top: 23px\">\n                                        <span class=\"download-alt\"><img>Descargar</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n        <div class=\"panel panel-default\">\n            <div class=\"panel-body table-responsive\">\n                <table class=\"table table-striped\">\n                    <thead>\n                    <tr>\n                        <th style=\"width: 10%\"></th>\n                        <th style=\"width: 10%\">Última carga</th>\n                        <th style=\"width: 10%\">Patente</th>\n                        <th style=\"width: 10%\">Kilómetros</th>\n                        <th style=\"width: 15%\">Servicio</th>\n                        <th style=\"width: 15%\">Comentarios</th>\n                        <th style=\"width: 15%\" *ngIf=\"canEditKmHistory\">Nro. de Contrato</th>\n                        <th style=\"width: 5%\" *ngIf=\"canEditKmHistory\">Banco</th>\n                        <th style=\"width: 10%\" *ngIf=\"canEditKmHistory\">CUIT</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                        <td>\n                            <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"editItem(item)\"\n                                    *ngIf=\"canEditKmHistory\">\n                                <span class=\"pencil\"><img></span>\n                            </button>\n                            <!--<button class=\"btn btn-primary\" title=\"Ver\" (click)=\"editItem(item)\"\n                                    *ngIf=\"!canEditKmHistory && canViewKmHistory\">\n                                <span class=\"eye-open\"><img></span>\n                            </button>-->\n                        </td>\n                        <td>{{(item.kmHistory) ? item.kmHistory?.loadDate : '-'}}</td>\n                        <td>{{item.patent}}</td>\n                        <td>{{item?.kmHistory?.km | kmFormat}}</td>\n                        <td>{{(item.kmHistory) ? item.kmHistory?.service : '-'}}</td>\n                        <td>{{(item.kmHistory) ? item.kmHistory?.comments : '-'}}</td>\n                        <td *ngIf=\"canEditKmHistory\">{{item.contract.contractNumber}}</td>\n                        <td *ngIf=\"canEditKmHistory\">{{item.contract.bank.name}}</td>\n                        <td *ngIf=\"canEditKmHistory\">{{item.contract.cuit}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan=\"10\">\n                            <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"canEditKmHistory\">\n        <div class=\"row\">\n            <fieldset id=\"bulkLoadContainer\">\n                <legend>Carga masiva de histórico de kilómetros</legend>\n                <div class=\"col-xs-4\">\n                    <div ng2FileDrop\n                         [ngClass]=\"{'nv-file-over': hasBulkLoadDropZoneOver}\"\n                         (fileOver)=\"fileOverBulkLoad($event)\"\n                         [uploader]=\"uploaderBulkLoad\"\n                         class=\"well my-drop-zone\">Arrastre el Excel de histórico de vehículos aquí\n                    </div>\n                    <label for=\"bulkLoadKmHistory\" class=\"custom-file-upload\">\n                        <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                    </label>\n                    <input #bulkLoadKmHistory type=\"file\" id=\"bulkLoadKmHistory\" ng2FileSelect\n                           [uploader]=\"uploaderBulkLoad\"/>\n                </div>\n                <div class=\"col-xs-1 spinLoading\">\n                    <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                        <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                    </div>\n                </div>\n            </fieldset>\n        </div>\n\n        <div class=\"row uploaderQueue\">\n            <div class=\"col-xs-12\" *ngIf=\"uploaderBulkLoad.queue?.length > 0\">\n                <div class=\"col-md-12 noPadding\">\n                    <table class=\"table\">\n                        <thead>\n                        <tr>\n                            <th width=\"50%\">Nombre</th>\n                            <th>Progreso</th>\n                            <!--<th>Estado</th>-->\n                            <th *ngIf=\"isBeforeUpload\">Eliminar</th>\n                            <!--<th>Acciones</th>-->\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr *ngFor=\"let aFile of uploaderBulkLoad.queue\">\n                            <td>\n                                <strong>{{aFile.file.name}}</strong>\n                            </td>\n                            <td>\n                                <div class=\"progress\" style=\"margin-bottom: 0;\">\n                                    <div class=\"progress-bar\" role=\"progressbar\"\n                                         [ngStyle]=\"{ 'width': aFile.progress + '%' }\"></div>\n                                </div>\n                            </td>\n                            <td nowrap *ngIf=\"isBeforeUpload\">\n                                <button type=\"button\" class=\"btn btn-danger btn-xs btn-kmHistory\"\n                                        (click)=\"aFile.remove()\">\n                                    <span class=\"trash\"><img></span> Eliminar\n                                </button>\n                            </td>\n                        </tr>\n                        <tr *ngIf=\"uploaderBulkLoad.queue?.length == 0\">\n                            <td colspan=\"4\" class=\"text-center\">No hay carga masiva pendiente</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                    <div>\n                        <div>\n                            <div class=\"progress\" style=\"\">\n                                <div class=\"progress-bar\" role=\"progressbar\"\n                                     [ngStyle]=\"{ 'width': uploaderBulkLoad.progress + '%' }\">\n                                </div>\n                            </div>\n                        </div>\n                        <button type=\"button\" class=\"btn btn-success btn-s\"\n                                (click)=\"enableLoading(); uploaderBulkLoad.uploadAll(); enableOneClickBulkload()\"\n                                [disabled]=\"oneClickBulkLoad || !uploaderBulkLoad.getNotUploadedItems().length\">\n                            <span class=\"upload-icon\"><img></span> Cargar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-warning btn-s\"\n                                (click)=\"disableLoading(); uploaderBulkLoad.cancelAll()\"\n                                [disabled]=\"!uploaderBulkLoad.isUploading\">\n                            <span class=\"ban-circle-white\"><img></span> Cancelar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-s\"\n                                (click)=\"disableLoading(); createUploaderBulkLoad()\"\n                                [disabled]=\"!uploaderBulkLoad.queue.length\">\n                            <span class=\"trash\"><img></span> Eliminar cola\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #bulkLoadKmHistoryModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hideBulkLoadModal()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Carga masiva Histórico de Vehículos</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"errorsBulkLoad\">{{errorsBulkLoad[0]}}</p>\n                <li *ngFor=\"let errorBL of errorsBulkLoad | slice:1\">{{errorBL}}</li>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 914 */
/***/ function(module, exports) {

	module.exports = "kmHistory-panel.container {\n    display: inline;\n    float: none;\n}\n\n.table > caption + thead > tr:first-child > td,\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td button.btn,\n.table > tbody > tr > th button.btn,\n.table > tfoot > tr > td button.btn,\n.table > tfoot > tr > th button.btn,\n.table > thead > tr > td button.btn,\n.table > thead > tr > th button.btn,\n.table > tbody > tr > td a.btn,\n.table > tbody > tr > th a.btn,\n.table > tfoot > tr > td a.btn,\n.table > tfoot > tr > th a.btn,\n.table > thead > tr > td a.btn,\n.table > thead > tr > th a.btn {\n    padding: 5px;\n    font-size: 0;\n    height: 24px;\n    line-height: 15px;\n}\n\n.table > tbody > tr > td button.btn span,\n.table > tbody > tr > td a.btn span,\n.table > tbody > tr > th button.btn span,\n.table > tbody > tr > th a.btn span,\n.table > tfoot > tr > td button.btn span,\n.table > tfoot > tr > td a.btn span,\n.table > tfoot > tr > th button.btn span,\n.table > tfoot > tr > th a.btn span,\n.table > thead > tr > td button.btn span,\n.table > thead > tr > td a.btn span,\n.table > thead > tr > th button.btn span,\n.table > thead > tr > th a.btn span {\n    font-size: 0\n}\n\n.table > tbody > tr > td button.btn span img,\n.table > tbody > tr > th button.btn span img,\n.table > tfoot > tr > td button.btn span img,\n.table > tfoot > tr > th button.btn span img,\n.table > thead > tr > td button.btn span img,\n.table > thead > tr > th button.btn span img,\n.table > tbody > tr > td a.btn span img,\n.table > tbody > tr > th a.btn span img,\n.table > tfoot > tr > td a.btn span img,\n.table > tfoot > tr > th a.btn span img,\n.table > thead > tr > td a.btn span img,\n.table > thead > tr > th a.btn span img {\n    width: 12px;\n}\n\n.table > tbody > tr > td button.btn span.file-icon img,\n.table > tbody > tr > th button.btn span.file-icon img,\n.table > tfoot > tr > td button.btn span.file-icon img,\n.table > tfoot > tr > th button.btn span.file-icon img,\n.table > thead > tr > td button.btn span.file-icon img,\n.table > thead > tr > th button.btn span.file-icon img,\n.table > tbody > tr > td a.btn span.file-icon img,\n.table > tbody > tr > th a.btn span.file-icon img,\n.table > tfoot > tr > td a.btn span.file-icon img,\n.table > tfoot > tr > th a.btn span.file-icon img,\n.table > thead > tr > td a.btn span.file-icon img,\n.table > thead > tr > th a.btn span.file-icon img {\n    width: 10px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\n.btn-kmHistory {\n    font-size: 12px !important;\n}\n\n.btn-kmHistory img {\n    height: 17px;\n    padding-bottom: 5px;\n}\n\n#bulkLoadContainer {\n    margin-top: 30px;\n    background-color: #d9edf7;\n    border-radius: 4px;\n    -webkit-margin-start: 0;\n    -webkit-margin-end: 0;\n    -webkit-padding-before: 0;\n    -webkit-padding-start: 0;\n    -webkit-padding-end: 0;\n    -webkit-padding-after: 0;\n}\n\n#bulkLoadContainer legend {\n    position: relative;\n    top: 30px;\n    padding-left: 15px;\n}\n\n#bulkLoadContainer .my-drop-zone {\n    margin-top: 20px;\n}\n\n.row.uploaderQueue {\n    background-color: #d9edf7;\n    position: relative;\n    top: -3px;\n}\n\n.row.uploaderQueue .noPadding {\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.row.uploaderQueue .noPadding table {\n    color: #333;\n}\n\n#bulkLoadContainer {\n    display: block;\n}"

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var vehicle_1 = __webpack_require__(873);
	var login_service_1 = __webpack_require__(404);
	var ng2_file_upload_1 = __webpack_require__(889);
	var bank_1 = __webpack_require__(875);
	var bank_service_1 = __webpack_require__(631);
	var validators_1 = __webpack_require__(849);
	var procedure_service_1 = __webpack_require__(916);
	var FileUploaderCustom_1 = __webpack_require__(907);
	var navigation_service_1 = __webpack_require__(403);
	var ProceduresPanelComponent = (function () {
	    function ProceduresPanelComponent(router, procedureService, bankService, loginService, navigationService) {
	        var _this = this;
	        this.router = router;
	        this.procedureService = procedureService;
	        this.bankService = bankService;
	        this.loginService = loginService;
	        this.navigationService = navigationService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los bancos.');
	        });
	        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
	        /*this.form.valueChanges
	         .debounceTime(400)
	         .subscribe(this.find.bind(this));*/
	    }
	    ProceduresPanelComponent.prototype.init = function () {
	        var _this = this;
	        this.procedureService.getExpirationTypes().subscribe(function (data) {
	            _this.expirationsType = data;
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar los tipos de expiración.');
	        });
	        this.data = [];
	        this.banks = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        this.canEditProcedure = false;
	        this.canViewProcedure = false;
	        this.showFilters = false;
	        this.errorsBulkLoad = [];
	        this.createUploaderBulkLoad();
	        this.filter = new vehicle_1.Vehicle();
	        this.form = new forms_1.FormGroup({
	            patent: new forms_1.FormControl(),
	            bank: new forms_1.FormControl(),
	            contractNumber: new forms_1.FormControl(),
	            cuit: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl(),
	            withDocuments: new forms_1.FormControl()
	        });
	        if (!this.filter.contract.bank.id) {
	            this.filter.contract.bank = this.bankTodos;
	        }
	        this.oneClickBulkLoad = false;
	        this.withDocuments = false;
	        this.sendMailSuccess = false;
	        this.sendMailError = false;
	    };
	    ProceduresPanelComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    ProceduresPanelComponent.prototype.filterEmpty = function () {
	        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit
	            || (this.filter.contract.bank && this.filter.contract.bank.id != ''));
	    };
	    ProceduresPanelComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.filter.contract.bank = banks[0];
	        }
	    };
	    ProceduresPanelComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.procedureService.findProcedure(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	                _this.refreshData(data);
	                _this.page = page;
	            }, function () {
	                _this.bindError('Ocurrió un error al buscar los vehículos.');
	            });
	        }
	    };
	    ProceduresPanelComponent.prototype.refreshData = function (page) {
	        this.data = page.content;
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    ProceduresPanelComponent.prototype.editItem = function (item) {
	        this.router.navigate(['app/home/editProcedure', item.id]);
	    };
	    ProceduresPanelComponent.prototype.editProcedure = function (event, item) {
	        event.preventDefault();
	        this.navigationService.setBackParameters({ tabSelected: 'procedures' });
	        this.router.navigate(['app/home/editSingleProcedure', item.id]);
	    };
	    ProceduresPanelComponent.prototype.downloadFilterProcedures = function () {
	        this.error = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.reportMessage = 'Creando reporte...';
	            /*
	             * Se exportan todos las patentes de vehículos que cumplan con el filtro.
	             * Sólo las patentes de vehículos de la página actual se descargan.
	             */
	            window.location.href = window.location.origin +
	                procedure_service_1.ProcedureService.getURLFilterProcedures(this.filter, this.page, this.itemsPerPage, this.withDocuments);
	            this.loading = false;
	        }
	    };
	    ProceduresPanelComponent.prototype.close = function (saved) {
	        if (saved) {
	            this.find();
	        }
	    };
	    ProceduresPanelComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    ProceduresPanelComponent.prototype.ngOnInit = function () {
	        this.userLogged = this.loginService.getUserLogged();
	        this.canEditProcedure = this.userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');
	        this.canViewProcedure = this.userLogged.isActionAllowed('PROCEDURES', 'VIEW', 'PROCEDURES');
	        if (this.userLogged.rol.client) {
	            if (this.userLogged.cuit) {
	                this.filter.contract.cuit = this.userLogged.username;
	            }
	            else {
	                this.filter.patent = this.userLogged.username;
	            }
	            this.filter.contract.bank.id = this.userLogged.bank.id;
	            this.showFilters = false;
	        }
	        else {
	            this.showFilters = true;
	        }
	        this.getPage(1);
	    };
	    ProceduresPanelComponent.prototype.createUploaderBulkLoad = function () {
	        var _this = this;
	        this.uploaderBulkLoad = new FileUploaderCustom_1.FileUploaderCustom({
	            url: 'procedure/bulkLoad',
	            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	             'image/jpeg', 'image/gif', 'image/png']*/
	            allowedMimeType: validators_1.VALID_MIME_TYPES,
	            maxFileSize: validators_1.FILE_MAX_SIZE
	        });
	        this.hasBulkLoadDropZoneOver = false;
	        this.uploaderBulkLoad.onErrorItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de trámites de vehículos no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        procedure_service_1.ProcedureService.getURLProcedureBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de trámites de vehículos cancelada.");
	                }
	            }
	            _this.oneClickBulkLoad = false;
	            _this.showBulkLoadModal();
	        };
	        this.uploaderBulkLoad.onSuccessItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 200) {
	                var message = response.split("|");
	                _this.errorsBulkLoad = [];
	                _this.errorsBulkLoad[0] = message[0];
	                if (message.length > 1) {
	                    window.location.href = window.location.origin +
	                        procedure_service_1.ProcedureService.getURLProcedureBulkload(message[1]);
	                }
	            }
	            _this.loading = false;
	            _this.oneClickBulkLoad = false;
	            _this.showBulkLoadModal();
	        };
	    };
	    ProceduresPanelComponent.prototype.fileOverBulkLoad = function (e) {
	        this.hasBulkLoadDropZoneOver = e;
	    };
	    ProceduresPanelComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        /*Limpieza de inputs al agregar a la cola el archivo*/
	        this.uploaderBulkLoad.onAfterAddingFile = (function (item) {
	            _this.bulkLoad.nativeElement.value = '';
	            _this.reportMessage = null;
	        });
	    };
	    ProceduresPanelComponent.prototype.showBulkLoadModal = function () {
	        this.bulkLoadModal.show();
	        this.disableLoading();
	    };
	    ProceduresPanelComponent.prototype.hideBulkLoadModal = function () {
	        this.bulkLoadModal.hide();
	        this.errorsBulkLoad = [];
	    };
	    ProceduresPanelComponent.prototype.disableLoading = function () {
	        this.loading = false;
	        this.oneClickBulkLoad = false;
	    };
	    ProceduresPanelComponent.prototype.enableLoading = function () {
	        this.loading = true;
	    };
	    ProceduresPanelComponent.prototype.enableOneClickBulkload = function () {
	        this.oneClickBulkLoad = true;
	    };
	    ProceduresPanelComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ProceduresPanelComponent.prototype.enableMultipleFiles = function () {
	        return false;
	    };
	    ProceduresPanelComponent.prototype.createProcedure = function () {
	        this.router.navigate(['app/home/createProcedure']);
	    };
	    ProceduresPanelComponent.prototype.getState = function (procedure) {
	        return this.transform(procedure.done, procedure.customDate);
	    };
	    // No uso el validator porque cambian algunas cosas en este caso...TODO: Mover a una clase aparte (o agregar a validator), tambien se usa en procedures.editor
	    ProceduresPanelComponent.prototype.transform = function (done, date) {
	        if (done) {
	            return 'RESUELTO';
	        }
	        /*
	        if (unique) {
	            return 'A VENCER'; // Si es unico, y no esta resuelto, no vence nunca
	        }
	        */
	        var todayDate = new Date(Date.parse(Date()));
	        var expiratedDateStr;
	        var expiratedDate;
	        if (date !== undefined && date !== null) {
	            if (date.includes('/')) {
	                expiratedDateStr = date.split('/');
	                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
	            }
	            else if (date.includes('-')) {
	                expiratedDateStr = date.split('-');
	                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
	            }
	        }
	        return expiratedDate > todayDate ? 'A VENCER' : 'VENCIDO';
	    };
	    ProceduresPanelComponent.prototype.sendMail = function (item, event) {
	        var _this = this;
	        event.preventDefault();
	        this.sendMailSuccess = false;
	        this.sendMailError = false;
	        item.withSendMail = true;
	        this.procedureService.sendMail(item).subscribe(function () {
	            item.withSendMail = false;
	            item.sent = true;
	            _this.sendMailSuccess = true;
	        }, function (error) {
	            if (error.status == 501) {
	                _this.bindError('Ocurrió un error al enviar mail.');
	            }
	            item.withSendMail = false;
	            _this.sendMailError = true;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('bulkLoadProcedure'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ProceduresPanelComponent.prototype, "bulkLoad", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadProcedureModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], ProceduresPanelComponent.prototype, "bulkLoadModal", void 0);
	    ProceduresPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'procedures-panel',
	            template: __webpack_require__(917),
	            styles: [__webpack_require__(918)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe, validators_1.KmFormat, validators_1.IsExpirated],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, procedure_service_1.ProcedureService, bank_service_1.BankService, login_service_1.LoginService, navigation_service_1.NavigationService])
	    ], ProceduresPanelComponent);
	    return ProceduresPanelComponent;
	}());
	exports.ProceduresPanelComponent = ProceduresPanelComponent;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var ProcedureService = (function () {
	    function ProcedureService(backendService) {
	        this.backendService = backendService;
	    }
	    ProcedureService.prototype.findProcedure = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        if (filter.procedures.length > 0 && filter.procedures[0].id) {
	            params.set('procedures[0].type.id', filter.procedures[0].type.id);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("procedures", params);
	    };
	    ProcedureService.prototype.findPendingProcedure = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        if (filter.procedures.length > 0 && filter.procedures[0].id) {
	            params.set('procedures[0].type.id', filter.procedures[0].type.id);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("pendingProcedures", params);
	    };
	    ProcedureService.prototype.getVehicle = function (vehicleId) {
	        return this.backendService.get("vehicle/" + vehicleId + "/procedure", null);
	    };
	    ProcedureService.prototype.get = function (procedureId) {
	        return this.backendService.get("procedure/" + procedureId, null);
	    };
	    ProcedureService.prototype.save = function (vehicle) {
	        return this.backendService.post("vehicle/procedure", vehicle, null);
	    };
	    ProcedureService.prototype.delete = function (procedureId) {
	        return this.backendService.delete("procedure/" + procedureId, null, null);
	    };
	    ProcedureService.getURLProcedureBulkload = function (documentId) {
	        return "/proceduresBulkloadDocument/" + documentId;
	    };
	    ProcedureService.setParams = function (filter, page, itemsPerPage, withDocuments) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        /*Opcional: descarga de documentos*/
	        params.set('withDocuments', String(withDocuments));
	        return params;
	    };
	    ProcedureService.getURLFilterProcedures = function (filter, page, itemsPerPage, withDocuments) {
	        return "/proceduresReport?" + ProcedureService.setParams(filter, page, itemsPerPage, withDocuments).toString();
	    };
	    ProcedureService.prototype.getProcedureType = function (name) {
	        var params = new http_1.URLSearchParams();
	        params.set('name', name);
	        return this.backendService.get("procedureType", params);
	    };
	    ProcedureService.prototype.getExpirationTypes = function () {
	        return this.backendService.get("expirationTypes", null);
	    };
	    ProcedureService.prototype.generateProcedureTempId = function () {
	        return this.backendService.get("procedure/generateTempId", null);
	    };
	    ProcedureService.prototype.deleteTempProcedureDocument = function (procedureId) {
	        return this.backendService.delete("procedure/" + procedureId + "/documentTemp", null, null);
	    };
	    ProcedureService.prototype.getProcedureTypes = function () {
	        return this.backendService.get("procedureTypes", null);
	    };
	    ProcedureService.prototype.getContract = function (procedureId) {
	        return this.backendService.get("procedure/" + procedureId, null);
	    };
	    ProcedureService.prototype.setVehicleId = function (vehicleId, procedureId) {
	        return this.backendService.get("procedure/setVehicle/" + vehicleId + "/" + procedureId, null);
	    };
	    ProcedureService.prototype.updateProcedure = function (procedure) {
	        return this.backendService.post("procedure/updateProcedure", procedure, null);
	    };
	    ProcedureService.prototype.sendMail = function (procedure) {
	        return this.backendService.post("procedure/sendMail", procedure, null);
	    };
	    ProcedureService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], ProcedureService);
	    return ProcedureService;
	}());
	exports.ProcedureService = ProcedureService;


/***/ },
/* 917 */
/***/ function(module, exports) {

	module.exports = "<div xmlns:white-space=\"http://www.w3.org/1999/xhtml\" xmlns:overflow=\"http://www.w3.org/1999/xhtml\"\n     xmlns:text-overflow=\"http://www.w3.org/1999/xhtml\">\n    <div class=\"row\">\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n        <form class=\"form\" [formGroup]=\"form\">\n            <!--Descomentar si se quiere filtrar en cuanto el formulario cambie (ngSubmit)=\"find()\"-->\n            <div class=\"panel panel-default\" *ngIf=\"showFilters\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"patentFilter\">Patente</label>\n                            <input type=\"text\" class=\"form-control\" id=\"patentFilter\"\n                                   formControlName=\"patent\" [(ngModel)]=\"filter.patent\" name=\"patent\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\"\n                                    [(ngModel)]=\"filter.contract.bank\" name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"contractFilter\">Nro. de Contrato</label>\n                            <input type=\"text\" class=\"form-control\" id=\"contractFilter\" placeholder=\"\"\n                                   formControlName=\"contractNumber\" [(ngModel)]=\"filter.contract.contractNumber\"\n                                   name=\"contractNumber\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cuitFilter\">CUIT</label>\n                            <input type=\"text\" class=\"form-control\" id=\"cuitFilter\" placeholder=\"\"\n                                   formControlName=\"cuit\" [(ngModel)]=\"filter.contract.cuit\" name=\"cuit\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\"\n                                [disabled]=\"!form.valid || filterEmpty()\" style=\"margin-top: 23px\">\n                            <!--<span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span>-->\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div class=\"col-xs-12\" *ngIf=\"filterEmpty()\">\n                        <div class=\"alert alert-info\">Ingrese alg&uacute;n filtro de b&uacute;squeda</div>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <legend>Descarga de Trámites de Vehículos</legend>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\" *ngIf=\"reportMessage\">\n                            <div class=\"alert alert-info\">{{reportMessage}}</div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <div class=\"form-group form-group-sm\">\n                                <div class=\"col-xs-9\">\n                                    <label class=\"hidden\" for=\"withDocuments\">Documentos</label>\n                                    <label class=\"checkboxLabel\">\n                                        <input type=\"checkbox\" class=\"form-control checkbox\" id=\"withDocuments\"\n                                               formControlName=\"withDocuments\" [(ngModel)]=\"withDocuments\"\n                                               name=\"withDocuments\" [disabled]=\"data.length == 0\">\n                                        con descarga de documentos\n                                    </label>\n                                </div>\n                                <div class=\"col-xs-3\">\n                                    <button type=\"button\" class=\"btn btn-primary\"\n                                            (click)=\"downloadFilterProcedures()\"\n                                            [disabled]=\"!form.valid || filterEmpty() || data.length == 0\"\n                                            style=\"margin-top: 23px\">\n                                        <span class=\"download-alt\"><img>Descargar</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n        <div class=\"panel panel-default\">\n            <div class=\"panel-body table-responsive\">\n                <table style=\"table-layout: fixed\" class=\"table table-striped\">\n                    <thead>\n                    <tr>\n                        <th style=\"width: 4%\"></th>\n                        <th style=\"width: 9%\">Fecha de recepción</th>\n                        <th style=\"width: 9%\" *ngIf=\"userLogged.rol.client\">Estado</th>\n                        <th style=\"width: 9%\" *ngIf=\"userLogged.rol.client\">Fecha de vencimiento</th>\n                        <th style=\"width: 13%\">Tipo de trámite</th>\n                        <th style=\"width: 9%\" *ngIf=\"canEditProcedure || userLogged.rol.client\">Patente</th>\n                        <th style=\"width: 9%\" *ngIf=\"canEditProcedure\">Comentarios</th>\n                        <th style=\"width: 13%\" *ngIf=\"canEditProcedure || userLogged.rol.client\">Observaciones</th>\n                        <th style=\"width: 15%\" *ngIf=\"canEditProcedure || userLogged.rol.client\">Nro. de Contrato</th>\n                        <th style=\"width: 5%\" *ngIf=\"canEditProcedure\">Banco</th>\n                        <th style=\"width: 12%\" *ngIf=\"canEditProcedure\">CUIT</th>\n                        <th style=\"width: 4%\" *ngIf=\"canEditProcedure\">Acciones</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                        <td>\n                            <!--\n                            <button class=\"btn btn-primary\" title=\"EditarVehicle\" (click)=\"editItem(item)\"\n                                    *ngIf=\"canEditProcedure\">\n                                <span class=\"pencil\"><img></span>\n                            </button>\n                            -->\n                            <button class=\"btn btn-primary\" title=\"EditarProcedure\" (click)=\"editProcedure($event, item.procedure)\"\n                                    *ngIf=\"canEditProcedure\">\n                                <span class=\"pencil\"><img></span>\n                            </button>\n                            <!--<button class=\"btn btn-primary\" title=\"Ver\" (click)=\"editItem(item)\"\n                                    *ngIf=\"!canEditProcedure && canViewProcedure\">\n                                <span class=\"eye-open\"><img></span>\n                            </button>-->\n                            <a *ngIf=\"item.procedure && item.procedure.document && !canEditProcedure && canViewProcedure\"\n                               class=\"btn btn-success\" target=\"file\"\n                               title=\"Descargar archivo\" href=\"/procedureDocument/{{item.procedure.id}}/download\">\n                                <span class=\"file-icon\"><img></span>\n                            </a>\n                        </td>\n                        <td>{{(item.procedure) ? item.procedure?.creationDate : '-'}}</td>\n                        <td *ngIf=\"userLogged.rol.client\">\n                            {{(item.procedure) ? getState(item.procedure) : '-'}}\n                        </td>\n                        <td *ngIf=\"userLogged.rol.client\">{{(item.procedure)? item.procedure?.customDate : '-'}}</td>\n                        <td>{{(item.procedure) ? item.procedure?.type.description: '-'}}</td>\n                        <td *ngIf=\"canEditProcedure || userLogged.rol.client\">{{item.patent}}</td>\n                        <td class=\"cortar\" *ngIf=\"canEditProcedure\">{{(item.procedure) ? item.procedure?.comment:\n                            '-'}}\n                        </td>\n                        <td class=\"cortar\" *ngIf=\"canEditProcedure || userLogged.rol.client\">{{(item.procedure) ?\n                            item.procedure?.description: '-'}}\n                        </td>\n                        <td *ngIf=\"canEditProcedure || userLogged.rol.client\">{{item.contract.contractNumber}}</td>\n                        <td *ngIf=\"canEditProcedure\">{{item.contract.bank.name}}</td>\n                        <td *ngIf=\"canEditProcedure\">{{item.contract.cuit}}</td>\n                        <td style=\"font-size: 12px\" *ngIf=\"canEditInfraction\">{{(item.sent)?'SI':'NO'}}</td>\n                        <td style=\"font-size: 12px\">\n                            <a class=\"btn btn-success\" title=\"Enviar Mail\" (click)=\"sendMail(item.procedure,$event)\"\n                               *ngIf=\"canEditProcedure\">\n                                <!--<span class=\"glyphicon glyphicon-refresh\" *ngIf=\"!item.sendingMail\"></span>-->\n                                <span class=\"refresh\" *ngIf=\"!item.sendingMail\"><img></span>\n                                <span class=\"fa fa-spinner fa-spin\" *ngIf=\"item.sendingMail\"></span>\n                            </a>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan=\"10\">\n                            <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"canEditProcedure\">\n        <div class=\"row\">\n            <div class=\"col-xs-2\" id=\"newEntity\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"createProcedure()\">\n                    <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n                    <span class=\"plus\"><img></span> Nuevo\n                </button>\n            </div>\n        </div>\n        <div class=\"row\">\n            <fieldset id=\"bulkLoadContainer\">\n                <legend>Carga masiva de trámites</legend>\n                <div class=\"col-xs-4\">\n                    <div ng2FileDrop\n                         [ngClass]=\"{'nv-file-over': hasBulkLoadDropZoneOver}\"\n                         (fileOver)=\"fileOverBulkLoad($event)\"\n                         [uploader]=\"uploaderBulkLoad\"\n                         class=\"well my-drop-zone\">Arrastre el Excel de trámites aquí\n                    </div>\n                    <label for=\"bulkLoadProcedure\" class=\"custom-file-upload\">\n                        <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                    </label>\n                    <input #bulkLoadProcedure type=\"file\" id=\"bulkLoadProcedure\" ng2FileSelect\n                           [uploader]=\"uploaderBulkLoad\" multiple [disabled]=\"enableMultipleFiles()\"/>\n                </div>\n                <div class=\"col-xs-1 spinLoading\">\n                    <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                        <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                    </div>\n                </div>\n            </fieldset>\n        </div>\n\n        <div class=\"row uploaderQueue\">\n            <div class=\"col-xs-12\" *ngIf=\"uploaderBulkLoad.queue?.length > 0\">\n                <div class=\"col-md-12 noPadding\">\n                    <table class=\"table\">\n                        <thead>\n                        <tr>\n                            <th width=\"50%\">Nombre</th>\n                            <th>Progreso</th>\n                            <!--<th>Estado</th>-->\n                            <th *ngIf=\"isBeforeUpload\">Eliminar</th>\n                            <!--<th>Acciones</th>-->\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr *ngFor=\"let aFile of uploaderBulkLoad.queue\">\n                            <td>\n                                <strong>{{aFile.file.name}}</strong>\n                            </td>\n                            <td>\n                                <div class=\"progress\" style=\"margin-bottom: 0;\">\n                                    <div class=\"progress-bar\" role=\"progressbar\"\n                                         [ngStyle]=\"{ 'width': aFile.progress + '%' }\"></div>\n                                </div>\n                            </td>\n                            <td nowrap *ngIf=\"isBeforeUpload\">\n                                <button type=\"button\" class=\"btn btn-danger btn-xs btn-patentPayment\"\n                                        (click)=\"disableLoading(); aFile.remove()\">\n                                    <span class=\"trash\"><img></span> Eliminar\n                                </button>\n                            </td>\n                        </tr>\n                        <tr *ngIf=\"uploaderBulkLoad.queue?.length == 0\">\n                            <td colspan=\"4\" class=\"text-center\">No hay carga masiva pendiente</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                    <div>\n                        <div>\n                            <div class=\"progress\" style=\"\">\n                                <div class=\"progress-bar\" role=\"progressbar\"\n                                     [ngStyle]=\"{ 'width': uploaderBulkLoad.progress + '%' }\">\n                                </div>\n                            </div>\n                        </div>\n                        <button type=\"button\" class=\"btn btn-success btn-s\"\n                                (click)=\"enableLoading(); uploaderBulkLoad.uploadAllFiles(); enableOneClickBulkload()\"\n                                [disabled]=\"oneClickBulkLoad || !uploaderBulkLoad.getNotUploadedItems().length\">\n                            <span class=\"upload-icon\"><img></span> Cargar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-warning btn-s\"\n                                (click)=\"disableLoading(); uploaderBulkLoad.cancelAll()\"\n                                [disabled]=\"!uploaderBulkLoad.isUploading\">\n                            <span class=\"ban-circle-white\"><img></span> Cancelar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-s\"\n                                (click)=\"disableLoading(); createUploaderBulkLoad()\"\n                                [disabled]=\"!uploaderBulkLoad.queue.length\">\n                            <span class=\"trash\"><img></span> Eliminar cola\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #bulkLoadProcedureModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hideBulkLoadModal()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Carga masiva Trámites de Vehículos</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"errorsBulkLoad\">{{errorsBulkLoad[0]}}</p>\n                <li *ngFor=\"let errorBL of errorsBulkLoad | slice:1\">{{errorBL}}</li>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 918 */
/***/ function(module, exports) {

	module.exports = "procedures-panel.container {\n    display: inline;\n    float: none;\n}\n\n.checkboxLabel input.checkbox {\n    margin-right: 8px;\n    margin-left: 0;\n    float: left;\n}\n\n.checkbox {\n    height: 20px;\n    width: 20px;\n    margin-left: 73px;\n}\n\n.checkboxLabel {\n    display: inline-block;\n    margin-top: 18px;\n    float: left;\n}\n\n.centered {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.table > caption + thead > tr:first-child > td,\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td button.btn,\n.table > tbody > tr > th button.btn,\n.table > tfoot > tr > td button.btn,\n.table > tfoot > tr > th button.btn,\n.table > thead > tr > td button.btn,\n.table > thead > tr > th button.btn,\n.table > tbody > tr > td a.btn,\n.table > tbody > tr > th a.btn,\n.table > tfoot > tr > td a.btn,\n.table > tfoot > tr > th a.btn,\n.table > thead > tr > td a.btn,\n.table > thead > tr > th a.btn {\n    padding: 5px;\n    font-size: 0;\n    height: 24px;\n    line-height: 15px;\n}\n\n.table > tbody > tr > td button.btn span,\n.table > tbody > tr > td a.btn span,\n.table > tbody > tr > th button.btn span,\n.table > tbody > tr > th a.btn span,\n.table > tfoot > tr > td button.btn span,\n.table > tfoot > tr > td a.btn span,\n.table > tfoot > tr > th button.btn span,\n.table > tfoot > tr > th a.btn span,\n.table > thead > tr > td button.btn span,\n.table > thead > tr > td a.btn span,\n.table > thead > tr > th button.btn span,\n.table > thead > tr > th a.btn span {\n    font-size: 0\n}\n\n.table > tbody > tr > td button.btn span img,\n.table > tbody > tr > th button.btn span img,\n.table > tfoot > tr > td button.btn span img,\n.table > tfoot > tr > th button.btn span img,\n.table > thead > tr > td button.btn span img,\n.table > thead > tr > th button.btn span img,\n.table > tbody > tr > td a.btn span img,\n.table > tbody > tr > th a.btn span img,\n.table > tfoot > tr > td a.btn span img,\n.table > tfoot > tr > th a.btn span img,\n.table > thead > tr > td a.btn span img,\n.table > thead > tr > th a.btn span img {\n    width: 12px;\n}\n\n.table > tbody > tr > td button.btn span.file-icon img,\n.table > tbody > tr > th button.btn span.file-icon img,\n.table > tfoot > tr > td button.btn span.file-icon img,\n.table > tfoot > tr > th button.btn span.file-icon img,\n.table > thead > tr > td button.btn span.file-icon img,\n.table > thead > tr > th button.btn span.file-icon img,\n.table > tbody > tr > td a.btn span.file-icon img,\n.table > tbody > tr > th a.btn span.file-icon img,\n.table > tfoot > tr > td a.btn span.file-icon img,\n.table > tfoot > tr > th a.btn span.file-icon img,\n.table > thead > tr > td a.btn span.file-icon img,\n.table > thead > tr > th a.btn span.file-icon img {\n    width: 10px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\n.btn-procedure {\n    font-size: 12px !important;\n}\n\n.btn-procedure img {\n    height: 17px;\n    padding-bottom: 5px;\n}\n\n#bulkLoadContainer {\n    margin-top: 30px;\n    background-color: #d9edf7;\n    border-radius: 4px;\n    -webkit-margin-start: 0;\n    -webkit-margin-end: 0;\n    -webkit-padding-before: 0;\n    -webkit-padding-start: 0;\n    -webkit-padding-end: 0;\n    -webkit-padding-after: 0;\n}\n\n#bulkLoadContainer legend {\n    position: relative;\n    top: 30px;\n    padding-left: 15px;\n}\n\n#bulkLoadContainer .my-drop-zone {\n    margin-top: 20px;\n}\n\n.row.uploaderQueue {\n    background-color: #d9edf7;\n    position: relative;\n    top: -3px;\n}\n\n.row.uploaderQueue .noPadding {\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.row.uploaderQueue .noPadding table {\n    color: #333;\n}\n\n#bulkLoadContainer {\n    display: block;\n}\n\n.cortar {\n    width: 10%;\n    overflow:hidden;\n    white-space:nowrap;\n    text-overflow: ellipsis\n}\n\n.cortar:active {\n    overflow:visible;\n    white-space: initial;\n    cursor: pointer;\n}"

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var vehicle_1 = __webpack_require__(873);
	var login_service_1 = __webpack_require__(404);
	var ng2_file_upload_1 = __webpack_require__(889);
	var bank_1 = __webpack_require__(875);
	var bank_service_1 = __webpack_require__(631);
	var validators_1 = __webpack_require__(849);
	var patentPayment_service_1 = __webpack_require__(920);
	var procedure_1 = __webpack_require__(885);
	var procedure_service_1 = __webpack_require__(916);
	var FileUploaderCustom_1 = __webpack_require__(907);
	var PatentPaymentPanelComponent = (function () {
	    function PatentPaymentPanelComponent(router, patentPaymentService, procedureService, bankService, loginService) {
	        var _this = this;
	        this.router = router;
	        this.patentPaymentService = patentPaymentService;
	        this.procedureService = procedureService;
	        this.bankService = bankService;
	        this.loginService = loginService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los bancos.');
	        });
	        this.procedureService.getProcedureType('LICENSE_PLATE').subscribe(this.setProcedureType.bind(this), function () {
	            _this.bindError('Ocurrió un error al buscar el tipo de trámite.');
	        });
	        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
	        /*this.form.valueChanges
	         .debounceTime(400)
	         .subscribe(this.find.bind(this));*/
	    }
	    PatentPaymentPanelComponent.prototype.init = function () {
	        this.data = [];
	        this.banks = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        this.canEditPatentPayment = false;
	        this.canViewPatentPayment = false;
	        this.showFilters = false;
	        this.errorsBulkLoad = [];
	        this.createUploaderBulkLoad();
	        this.filter = new vehicle_1.Vehicle();
	        this.form = new forms_1.FormGroup({
	            patent: new forms_1.FormControl(),
	            bank: new forms_1.FormControl(),
	            contractNumber: new forms_1.FormControl(),
	            cuit: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl(),
	            withDocuments: new forms_1.FormControl()
	        });
	        if (!this.filter.contract.bank.id) {
	            this.filter.contract.bank = this.bankTodos;
	        }
	        this.oneClickBulkLoad = false;
	        this.withDocuments = false;
	    };
	    PatentPaymentPanelComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    PatentPaymentPanelComponent.prototype.filterEmpty = function () {
	        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit
	            || (this.filter.contract.bank && this.filter.contract.bank.id != ''));
	    };
	    PatentPaymentPanelComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.filter.contract.bank = banks[0];
	        }
	    };
	    PatentPaymentPanelComponent.prototype.setProcedureType = function (patentPayment) {
	        this.patentPaymentType = patentPayment;
	    };
	    PatentPaymentPanelComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            var patentPaymentFilter = new procedure_1.Procedure();
	            patentPaymentFilter.type = this.patentPaymentType;
	            this.filter.procedures.push(patentPaymentFilter);
	            this.patentPaymentService.findPatentPayment(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	                _this.refreshData(data);
	                _this.page = page;
	            }, function () {
	                _this.bindError('Ocurrió un error al buscar las patentes.');
	            });
	        }
	    };
	    PatentPaymentPanelComponent.prototype.refreshData = function (page) {
	        this.data = page.content;
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    PatentPaymentPanelComponent.prototype.editItem = function (item) {
	        this.router.navigate(['app/home/editPatentPayment', item.id]);
	    };
	    PatentPaymentPanelComponent.prototype.downloadFilterPatentPayments = function () {
	        this.error = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.reportMessage = 'Creando reporte...';
	            if (this.withDocuments) {
	                if (this.total < 3000) {
	                    /*TODO: muchos documentos puede que rompa por timeout*/
	                    this.reportMessage = 'Creando reporte...';
	                }
	            }
	            /*
	             * Se exportan todos las patentes de vehículos que cumplan con el filtro.
	             * Sólo las patentes de vehículos de la página actual se descargan.
	             */
	            window.location.href = window.location.origin +
	                patentPayment_service_1.PatentPaymentService.getURLFilterPatentPayments(this.filter, this.page, this.itemsPerPage, this.withDocuments);
	            this.loading = false;
	        }
	    };
	    PatentPaymentPanelComponent.prototype.close = function (saved) {
	        if (saved) {
	            this.find();
	        }
	    };
	    PatentPaymentPanelComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    PatentPaymentPanelComponent.prototype.ngOnInit = function () {
	        this.userLogged = this.loginService.getUserLogged();
	        this.canEditPatentPayment = this.userLogged.isActionAllowed('PATENT_PAYMENT', 'EDIT', 'PATENT_PAYMENT');
	        this.canViewPatentPayment = this.userLogged.isActionAllowed('PATENT_PAYMENT', 'VIEW', 'PATENT_PAYMENT');
	        if (this.userLogged.rol.client) {
	            if (this.userLogged.cuit) {
	                this.filter.contract.cuit = this.userLogged.username;
	            }
	            else {
	                this.filter.patent = this.userLogged.username;
	            }
	            this.filter.contract.bank.id = this.userLogged.bank.id;
	            this.showFilters = false;
	        }
	        else {
	            this.showFilters = true;
	        }
	        this.getPage(1);
	    };
	    PatentPaymentPanelComponent.prototype.createUploaderBulkLoad = function () {
	        var _this = this;
	        this.uploaderBulkLoad = new FileUploaderCustom_1.FileUploaderCustom({
	            url: 'patentPayment/bulkLoad',
	            /*allowedMimeType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	             'image/jpeg', 'image/gif', 'image/png']*/
	            allowedMimeType: validators_1.VALID_MIME_TYPES,
	            maxFileSize: validators_1.FILE_MAX_SIZE
	        });
	        this.hasBulkLoadDropZoneOver = false;
	        this.uploaderBulkLoad.onErrorItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 400) {
	                if (response == "") {
	                    _this.errorsBulkLoad = [];
	                    _this.errorsBulkLoad[0] = "Archivo de carga masiva de patente de vehículos no válido.";
	                }
	                else {
	                    _this.errorsBulkLoad = JSON.parse(response);
	                    window.location.href = window.location.origin +
	                        patentPayment_service_1.PatentPaymentService.getURLPatentPaymentBulkload(_this.errorsBulkLoad[_this.errorsBulkLoad.length - 1]);
	                    _this.errorsBulkLoad.splice(-1, 1);
	                    _this.errorsBulkLoad.unshift("Carga masiva de patente de vehículos cancelada.");
	                }
	            }
	            _this.oneClickBulkLoad = false;
	            _this.showBulkLoadModal();
	        };
	        this.uploaderBulkLoad.onSuccessItem = function (item, response, status, headers) {
	            _this.reportMessage = null;
	            if (status == 200) {
	                var message = response.split("|");
	                _this.errorsBulkLoad = [];
	                _this.errorsBulkLoad[0] = message[0];
	                if (message.length > 1) {
	                    window.location.href = window.location.origin +
	                        patentPayment_service_1.PatentPaymentService.getURLPatentPaymentBulkload(message[1]);
	                }
	            }
	            _this.loading = false;
	            _this.oneClickBulkLoad = false;
	            _this.showBulkLoadModal();
	        };
	    };
	    PatentPaymentPanelComponent.prototype.fileOverBulkLoad = function (e) {
	        this.hasBulkLoadDropZoneOver = e;
	    };
	    PatentPaymentPanelComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        /*Limpieza de inputs al agregar a la cola el archivo*/
	        this.uploaderBulkLoad.onAfterAddingFile = (function (item) {
	            _this.bulkLoad.nativeElement.value = '';
	            _this.reportMessage = null;
	        });
	    };
	    PatentPaymentPanelComponent.prototype.showBulkLoadModal = function () {
	        this.bulkLoadModal.show();
	        this.disableLoading();
	    };
	    PatentPaymentPanelComponent.prototype.hideBulkLoadModal = function () {
	        this.bulkLoadModal.hide();
	        this.errorsBulkLoad = [];
	    };
	    PatentPaymentPanelComponent.prototype.disableLoading = function () {
	        this.loading = false;
	        this.oneClickBulkLoad = false;
	    };
	    PatentPaymentPanelComponent.prototype.enableLoading = function () {
	        this.loading = true;
	    };
	    PatentPaymentPanelComponent.prototype.enableOneClickBulkload = function () {
	        this.oneClickBulkLoad = true;
	    };
	    PatentPaymentPanelComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    PatentPaymentPanelComponent.prototype.enableMultipleFiles = function () {
	        return false;
	    };
	    __decorate([
	        core_1.ViewChild('bulkLoadPatentPayment'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], PatentPaymentPanelComponent.prototype, "bulkLoad", void 0);
	    __decorate([
	        core_1.ViewChild('bulkLoadPatentPaymentModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], PatentPaymentPanelComponent.prototype, "bulkLoadModal", void 0);
	    PatentPaymentPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'patentPayment-panel',
	            template: __webpack_require__(921),
	            styles: [__webpack_require__(922)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [
	                ng2_pagination_1.PaginatePipe,
	                validators_1.IsExpirated
	            ]
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, patentPayment_service_1.PatentPaymentService, procedure_service_1.ProcedureService, bank_service_1.BankService, login_service_1.LoginService])
	    ], PatentPaymentPanelComponent);
	    return PatentPaymentPanelComponent;
	}());
	exports.PatentPaymentPanelComponent = PatentPaymentPanelComponent;


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var PatentPaymentService = (function () {
	    function PatentPaymentService(backendService) {
	        this.backendService = backendService;
	    }
	    PatentPaymentService.prototype.findPatentPayment = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("patent_payment", params);
	    };
	    PatentPaymentService.prototype.getVehicle = function (vehicleId) {
	        return this.backendService.get("vehicle/" + vehicleId + "/patentPayment ", null);
	    };
	    PatentPaymentService.prototype.save = function (vehicle) {
	        return this.backendService.post("vehicle/patentPayment", vehicle, null);
	    };
	    PatentPaymentService.getURLPatentPaymentBulkload = function (documentId) {
	        return "/patentPaymentsBulkloadDocument/" + documentId;
	    };
	    PatentPaymentService.prototype.delete = function (patentPaymentId) {
	        return this.backendService.delete("patentPayment/" + patentPaymentId, null, null);
	    };
	    PatentPaymentService.setParams = function (filter, page, itemsPerPage, withDocuments) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        if (filter.procedures.length > 0) {
	            params.set('procedures[0].type.id', filter.procedures[0].type.id);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        /*Opcional: descarga de documentos*/
	        params.set('withDocuments', String(withDocuments));
	        return params;
	    };
	    PatentPaymentService.getURLFilterPatentPayments = function (filter, page, itemsPerPage, withDocuments) {
	        return "/patentPaymentsReport?" + PatentPaymentService.setParams(filter, page, itemsPerPage, withDocuments).toString();
	    };
	    PatentPaymentService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], PatentPaymentService);
	    return PatentPaymentService;
	}());
	exports.PatentPaymentService = PatentPaymentService;


/***/ },
/* 921 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n        <form class=\"form\" [formGroup]=\"form\">\n            <!--Descomentar si se quiere filtrar en cuanto el formulario cambie (ngSubmit)=\"find()\"-->\n            <div class=\"panel panel-default\" *ngIf=\"showFilters\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"patentFilter\">Patente</label>\n                            <input type=\"text\" class=\"form-control\" id=\"patentFilter\"\n                                   formControlName=\"patent\" [(ngModel)]=\"filter.patent\" name=\"patent\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\"\n                                    [(ngModel)]=\"filter.contract.bank\" name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"contractFilter\">Nro. de Contrato</label>\n                            <input type=\"text\" class=\"form-control\" id=\"contractFilter\" placeholder=\"\"\n                                   formControlName=\"contractNumber\" [(ngModel)]=\"filter.contract.contractNumber\"\n                                   name=\"contractNumber\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cuitFilter\">CUIT</label>\n                            <input type=\"text\" class=\"form-control\" id=\"cuitFilter\" placeholder=\"\"\n                                   formControlName=\"cuit\" [(ngModel)]=\"filter.contract.cuit\" name=\"cuit\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\"\n                                [disabled]=\"!form.valid || filterEmpty()\" style=\"margin-top: 23px\">\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div class=\"col-xs-12\" *ngIf=\"filterEmpty()\">\n                        <div class=\"alert alert-info\">Ingrese alg&uacute;n filtro de b&uacute;squeda</div>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <legend>Descarga de Patentes de Vehículos</legend>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\" *ngIf=\"reportMessage\">\n                            <div class=\"alert alert-info\">{{reportMessage}}</div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <div class=\"form-group form-group-sm\">\n                                <div class=\"col-xs-9\">\n                                    <label class=\"hidden\" for=\"withDocuments\">Documentos</label>\n                                    <label class=\"checkboxLabel\">\n                                        <input type=\"checkbox\" class=\"form-control checkbox\" id=\"withDocuments\"\n                                               formControlName=\"withDocuments\" [(ngModel)]=\"withDocuments\"\n                                               name=\"withDocuments\" [disabled]=\"data.length == 0\">\n                                        con descarga de documentos\n                                    </label>\n                                </div>\n                                <div class=\"col-xs-3\">\n                                    <button type=\"button\" class=\"btn btn-primary\"\n                                            (click)=\"downloadFilterPatentPayments()\"\n                                            [disabled]=\"!form.valid || filterEmpty() || data.length == 0\"\n                                            style=\"margin-top: 23px\">\n                                        <span class=\"download-alt\"><img>Descargar</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n        <div class=\"panel panel-default\">\n            <div class=\"panel-body table-responsive\">\n                <table class=\"table table-striped\">\n                    <thead>\n                    <tr>\n                        <th style=\"width: 5%\"></th>\n                        <th style=\"width: 10%\">Última carga de documento</th>\n                        <th style=\"width: 10%\">Patente</th>\n                        <th style=\"width: 30%\">Comentarios del último documento</th>\n                        <th style=\"width: 10%\">Estado</th>\n                        <th style=\"width: 15%\" *ngIf=\"canEditPatentPayment\">Nro. de Contrato</th>\n                        <th style=\"width: 5%\" *ngIf=\"canEditPatentPayment\">Banco</th>\n                        <th style=\"width: 10%\" *ngIf=\"canEditPatentPayment\">CUIT</th>\n\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                        <td>\n                            <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"editItem(item)\"\n                                    *ngIf=\"canEditPatentPayment\">\n                                <span class=\"pencil\"><img></span>\n                            </button>\n                            <!--<button class=\"btn btn-primary\" title=\"Ver\" (click)=\"editItem(item)\"\n                                    *ngIf=\"!canEditPatentPayment && canViewPatentPayment\">\n                                <span class=\"eye-open\"><img></span>\n                            </button>-->\n                            <a *ngIf=\"item.patentPayment && item.patentPayment.document && !canEditPatentPayment && canViewPatentPayment\"\n                               class=\"btn btn-success\" target=\"file\"\n                               title=\"Descargar archivo\" href=\"/patentPaymentDocument/{{item.patentPayment.id}}/download\">\n                                <span class=\"file-icon\"><img></span>\n                            </a>\n                        </td>\n                        <td>{{(item.patentPayment) ? item.patentPayment?.creationDate : '-'}}</td>\n                        <td>{{item.patent}}</td>\n                        <td>{{(item.patentPayment) ? item.patentPayment?.description : '-'}}</td>\n                        <td>\n                            {{(item.patentPayment) ?\n                            (item.patentPayment?.done | isExpirated : item.patentPayment?.customDate) : '-'}}\n                        </td>\n                        <td *ngIf=\"canEditPatentPayment\">{{item.contract.contractNumber}}</td>\n                        <td *ngIf=\"canEditPatentPayment\">{{item.contract.bank.name}}</td>\n                        <td *ngIf=\"canEditPatentPayment\">{{item.contract.cuit}}</td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan=\"10\">\n                            <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"canEditPatentPayment\">\n        <div class=\"row\">\n            <fieldset id=\"bulkLoadContainer\">\n                <legend>Carga masiva de patentes de vehículos</legend>\n                <div class=\"col-xs-4\">\n                    <div ng2FileDrop\n                         [ngClass]=\"{'nv-file-over': hasBulkLoadDropZoneOver}\"\n                         (fileOver)=\"fileOverBulkLoad($event)\"\n                         [uploader]=\"uploaderBulkLoad\"\n                         class=\"well my-drop-zone\">Arrastre el Excel de patentes de vehículos aquí\n                    </div>\n                    <label for=\"bulkLoadPatentPayment\" class=\"custom-file-upload\">\n                        <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                    </label>\n                    <input #bulkLoadPatentPayment type=\"file\" id=\"bulkLoadPatentPayment\" ng2FileSelect\n                           [uploader]=\"uploaderBulkLoad\" multiple [disabled]=\"enableMultipleFiles()\"/>\n                </div>\n                <div class=\"col-xs-1 spinLoading\">\n                    <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                        <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                    </div>\n                </div>\n            </fieldset>\n        </div>\n\n        <div class=\"row uploaderQueue\">\n            <div class=\"col-xs-12\" *ngIf=\"uploaderBulkLoad.queue?.length > 0\">\n                <div class=\"col-md-12 noPadding\">\n                    <table class=\"table\">\n                        <thead>\n                        <tr>\n                            <th width=\"50%\">Nombre</th>\n                            <th>Progreso</th>\n                            <!--<th>Estado</th>-->\n                            <th *ngIf=\"isBeforeUpload\">Eliminar</th>\n                            <!--<th>Acciones</th>-->\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr *ngFor=\"let aFile of uploaderBulkLoad.queue\">\n                            <td>\n                                <strong>{{aFile.file.name}}</strong>\n                            </td>\n                            <td>\n                                <div class=\"progress\" style=\"margin-bottom: 0;\">\n                                    <div class=\"progress-bar\" role=\"progressbar\"\n                                         [ngStyle]=\"{ 'width': aFile.progress + '%' }\"></div>\n                                </div>\n                            </td>\n                            <td nowrap *ngIf=\"isBeforeUpload\">\n                                <button type=\"button\" class=\"btn btn-danger btn-xs btn-patentPayment\"\n                                        (click)=\"disableLoading(); aFile.remove()\">\n                                    <span class=\"trash\"><img></span> Eliminar\n                                </button>\n                            </td>\n                        </tr>\n                        <tr *ngIf=\"uploaderBulkLoad.queue?.length == 0\">\n                            <td colspan=\"4\" class=\"text-center\">No hay carga masiva pendiente</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                    <div>\n                        <div>\n                            <div class=\"progress\" style=\"\">\n                                <div class=\"progress-bar\" role=\"progressbar\"\n                                     [ngStyle]=\"{ 'width': uploaderBulkLoad.progress + '%' }\">\n                                </div>\n                            </div>\n                        </div>\n                        <button type=\"button\" class=\"btn btn-success btn-s\"\n                                (click)=\"enableLoading(); uploaderBulkLoad.uploadAllFiles(); enableOneClickBulkload()\"\n                                [disabled]=\"oneClickBulkLoad || !uploaderBulkLoad.getNotUploadedItems().length\">\n                            <span class=\"upload-icon\"><img></span> Cargar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-warning btn-s\"\n                                (click)=\"disableLoading(); uploaderBulkLoad.cancelAll()\"\n                                [disabled]=\"!uploaderBulkLoad.isUploading\">\n                            <span class=\"ban-circle-white\"><img></span> Cancelar cola\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-s\"\n                                (click)=\"disableLoading(); createUploaderBulkLoad()\"\n                                [disabled]=\"!uploaderBulkLoad.queue.length\">\n                            <span class=\"trash\"><img></span> Eliminar cola\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #bulkLoadPatentPaymentModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hideBulkLoadModal()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Carga masiva Patentes de Vehículos</h4>\n            </div>\n            <div class=\"modal-body\">\n                <p *ngIf=\"errorsBulkLoad\">{{errorsBulkLoad[0]}}</p>\n                <li *ngFor=\"let errorBL of errorsBulkLoad | slice:1\">{{errorBL}}</li>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 922 */
/***/ function(module, exports) {

	module.exports = "patentPayment-panel.container {\n    display: inline;\n    float: none;\n}\n\n.checkboxLabel input.checkbox {\n    margin-right: 8px;\n    margin-left: 0;\n    float: left;\n}\n\n.checkbox {\n    height: 20px;\n    width: 20px;\n    margin-left: 73px;\n}\n\n.checkboxLabel {\n    display: inline-block;\n    margin-top: 18px;\n    float: left;\n}\n\n.centered {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.table > caption + thead > tr:first-child > td,\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td button.btn,\n.table > tbody > tr > th button.btn,\n.table > tfoot > tr > td button.btn,\n.table > tfoot > tr > th button.btn,\n.table > thead > tr > td button.btn,\n.table > thead > tr > th button.btn,\n.table > tbody > tr > td a.btn,\n.table > tbody > tr > th a.btn,\n.table > tfoot > tr > td a.btn,\n.table > tfoot > tr > th a.btn,\n.table > thead > tr > td a.btn,\n.table > thead > tr > th a.btn {\n    padding: 5px;\n    font-size: 0;\n    height: 24px;\n    line-height: 15px;\n}\n\n.table > tbody > tr > td button.btn span,\n.table > tbody > tr > td a.btn span,\n.table > tbody > tr > th button.btn span,\n.table > tbody > tr > th a.btn span,\n.table > tfoot > tr > td button.btn span,\n.table > tfoot > tr > td a.btn span,\n.table > tfoot > tr > th button.btn span,\n.table > tfoot > tr > th a.btn span,\n.table > thead > tr > td button.btn span,\n.table > thead > tr > td a.btn span,\n.table > thead > tr > th button.btn span,\n.table > thead > tr > th a.btn span {\n    font-size: 0\n}\n\n.table > tbody > tr > td button.btn span img,\n.table > tbody > tr > th button.btn span img,\n.table > tfoot > tr > td button.btn span img,\n.table > tfoot > tr > th button.btn span img,\n.table > thead > tr > td button.btn span img,\n.table > thead > tr > th button.btn span img,\n.table > tbody > tr > td a.btn span img,\n.table > tbody > tr > th a.btn span img,\n.table > tfoot > tr > td a.btn span img,\n.table > tfoot > tr > th a.btn span img,\n.table > thead > tr > td a.btn span img,\n.table > thead > tr > th a.btn span img {\n    width: 12px;\n}\n\n.table > tbody > tr > td button.btn span.file-icon img,\n.table > tbody > tr > th button.btn span.file-icon img,\n.table > tfoot > tr > td button.btn span.file-icon img,\n.table > tfoot > tr > th button.btn span.file-icon img,\n.table > thead > tr > td button.btn span.file-icon img,\n.table > thead > tr > th button.btn span.file-icon img,\n.table > tbody > tr > td a.btn span.file-icon img,\n.table > tbody > tr > th a.btn span.file-icon img,\n.table > tfoot > tr > td a.btn span.file-icon img,\n.table > tfoot > tr > th a.btn span.file-icon img,\n.table > thead > tr > td a.btn span.file-icon img,\n.table > thead > tr > th a.btn span.file-icon img {\n    width: 10px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\n.btn-patentPayment {\n    font-size: 12px !important;\n}\n\n.btn-patentPayment img {\n    height: 17px;\n    padding-bottom: 5px;\n}\n\n#bulkLoadContainer {\n    margin-top: 30px;\n    background-color: #d9edf7;\n    border-radius: 4px;\n    -webkit-margin-start: 0;\n    -webkit-margin-end: 0;\n    -webkit-padding-before: 0;\n    -webkit-padding-start: 0;\n    -webkit-padding-end: 0;\n    -webkit-padding-after: 0;\n}\n\n#bulkLoadContainer legend {\n    position: relative;\n    top: 30px;\n    padding-left: 15px;\n}\n\n#bulkLoadContainer .my-drop-zone {\n    margin-top: 20px;\n}\n\n.row.uploaderQueue {\n    background-color: #d9edf7;\n    position: relative;\n    top: -3px;\n}\n\n.row.uploaderQueue .noPadding {\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.row.uploaderQueue .noPadding table {\n    color: #333;\n}\n\n#bulkLoadContainer {\n    display: block;\n}"

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var vehicle_1 = __webpack_require__(873);
	var login_service_1 = __webpack_require__(404);
	var ng2_file_upload_1 = __webpack_require__(889);
	var bank_1 = __webpack_require__(875);
	var bank_service_1 = __webpack_require__(631);
	var procedureType_1 = __webpack_require__(886);
	var procedure_1 = __webpack_require__(885);
	var procedure_service_1 = __webpack_require__(916);
	var agenda_service_1 = __webpack_require__(924);
	var validators_1 = __webpack_require__(849);
	var AgendaPanelComponent = (function () {
	    function AgendaPanelComponent(router, procedureService, agendaService, bankService, loginService) {
	        var _this = this;
	        this.router = router;
	        this.procedureService = procedureService;
	        this.agendaService = agendaService;
	        this.bankService = bankService;
	        this.loginService = loginService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los bancos.');
	        });
	        this.procedureService.getProcedureTypes().subscribe(this.setProcedureTypes.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los tipos de trámites.');
	        });
	        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
	        /*this.form.valueChanges
	         .debounceTime(400)
	         .subscribe(this.find.bind(this));*/
	    }
	    AgendaPanelComponent.prototype.init = function () {
	        this.data = [];
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.banks = [];
	        this.procedureTypes = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        this.typeTodos = new procedureType_1.ProcedureType();
	        this.typeTodos.id = '';
	        this.typeTodos.name = 'ALL';
	        this.typeTodos.description = 'TODOS';
	        this.canViewAgenda = false;
	        this.canEditAgenda = false;
	        this.showFilters = false;
	        this.filter = new vehicle_1.Vehicle();
	        this.form = new forms_1.FormGroup({
	            patent: new forms_1.FormControl(),
	            bank: new forms_1.FormControl(),
	            contractNumber: new forms_1.FormControl(),
	            cuit: new forms_1.FormControl(),
	            procedureType: new forms_1.FormControl(),
	            expirationDateSince: new forms_1.FormControl(this.expirationDateSince, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR, this.validateExpirationDateSinceRequired.bind(this)]),
	            expirationDateUntil: new forms_1.FormControl(this.expirationDateUntil, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR, this.validateExpirationDateUntilRequired.bind(this)]),
	            itemsPerPage: new forms_1.FormControl(),
	            withDocuments: new forms_1.FormControl()
	        });
	        if (!this.filter.contract.bank.id) {
	            this.filter.contract.bank = this.bankTodos;
	        }
	        this.filter.procedures = [];
	        this.filter.procedures[0] = new procedure_1.Procedure(null);
	        this.filter.procedures[0].type = this.typeTodos;
	        this.withDocuments = false;
	    };
	    AgendaPanelComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    AgendaPanelComponent.prototype.filterEmpty = function () {
	        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit
	            || (this.filter.contract.bank && this.filter.contract.bank.id != '')
	            || (this.filter.procedures.length > 0 && this.filter.procedures[0].type.id != '')
	            || (this.expirationDateSince && this.expirationDateUntil));
	    };
	    AgendaPanelComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.filter.contract.bank = banks[0];
	        }
	    };
	    AgendaPanelComponent.prototype.setProcedureTypes = function (procedureTypes) {
	        this.procedureTypes = procedureTypes;
	        if (procedureTypes.length == 1) {
	            this.filter.procedures = [];
	            this.filter.procedures[0] = new procedure_1.Procedure(null);
	            this.filter.procedures[0].type = procedureTypes[0];
	        }
	    };
	    AgendaPanelComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            if (this.expirationDateSince && this.expirationDateUntil) {
	                if (this.filter.procedures.length == 0) {
	                    this.filter.procedures = [];
	                    this.filter.procedures[0] = new procedure_1.Procedure(null);
	                }
	                this.filter.procedures[0].expirationDateSince = this.expirationDateSince;
	                this.filter.procedures[0].expirationDateUntil = this.expirationDateUntil;
	            }
	            this.agendaService.findProcedure(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	                _this.refreshData(data);
	                _this.page = page;
	            }, function () {
	                _this.bindError('Ocurrió un error al buscar los trámites.');
	            });
	        }
	    };
	    AgendaPanelComponent.prototype.refreshData = function (page) {
	        this.data = page.content;
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    AgendaPanelComponent.prototype.downloadFilterProcedures = function () {
	        this.error = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.reportMessage = 'Creando reporte...';
	            if (this.withDocuments) {
	                if (this.total < 3000) {
	                    /*TODO: muchos documentos puede que rompa por timeout*/
	                    this.reportMessage = 'Creando reporte...';
	                }
	            }
	            /*
	             * Se exportan todos los trámites de vehículos que cumplan con el filtro.
	             * Sólo los trámites de vehículos de la página actual se descargan.
	             */
	            window.location.href = window.location.origin +
	                agenda_service_1.AgendaService.getURLFilterProcedures(this.filter, this.page, this.itemsPerPage, this.withDocuments);
	            this.loading = false;
	        }
	    };
	    AgendaPanelComponent.prototype.close = function (saved) {
	        if (saved) {
	            this.find();
	        }
	    };
	    AgendaPanelComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    AgendaPanelComponent.prototype.ngOnInit = function () {
	        this.userLogged = this.loginService.getUserLogged();
	        this.canViewAgenda = this.userLogged.isActionAllowed('AGENDA', 'VIEW', 'AGENDA');
	        this.canEditAgenda = this.userLogged.isActionAllowed('AGENDA', 'EDIT', 'AGENDA');
	        if (this.userLogged.rol.client) {
	            if (this.userLogged.cuit) {
	                this.filter.contract.cuit = this.userLogged.username;
	            }
	            else {
	                this.filter.patent = this.userLogged.username;
	            }
	            this.filter.contract.bank.id = this.userLogged.bank.id;
	            this.showFilters = false;
	        }
	        else {
	            this.showFilters = true;
	        }
	        this.getPage(1);
	    };
	    AgendaPanelComponent.prototype.ngAfterViewInit = function () {
	    };
	    AgendaPanelComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    AgendaPanelComponent.prototype.resolveItem = function (item) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        this.loading = true;
	        this.agendaService.resolveProcedure(item.id).subscribe(function (procedure) {
	            if (procedure.id != '' && procedure.id != null) {
	                _this.reportMessage = 'Trámite ' + item.type.description + ' de vehículo '
	                    + item.vehicle.patent + ' resuelto correctamente.';
	                _this.removeItemFromView(item);
	            }
	            else {
	                _this.bindError('Ocurrió un error al resolver el trámite.');
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al resolver el trámite.');
	        });
	        this.loading = false;
	    };
	    AgendaPanelComponent.prototype.removeItemFromView = function (procedure) {
	        var index = this.data.indexOf(procedure);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	    };
	    AgendaPanelComponent.prototype.validateExpirationDateSinceRequired = function (group) {
	        if (!this.expirationDateSince && this.expirationDateUntil) {
	            this.form.controls['expirationDateUntil'].updateValueAndValidity();
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    AgendaPanelComponent.prototype.validateExpirationDateUntilRequired = function (group) {
	        if (this.expirationDateSince && !this.expirationDateUntil) {
	            this.form.controls['expirationDateSince'].updateValueAndValidity();
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    AgendaPanelComponent.prototype.triggerExpirationDateValidators = function () {
	        this.form.controls['expirationDateSince'].updateValueAndValidity();
	        this.form.controls['expirationDateUntil'].updateValueAndValidity();
	    };
	    AgendaPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'agenda-panel',
	            template: __webpack_require__(925),
	            styles: [__webpack_require__(926)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [
	                ng2_pagination_1.PaginatePipe,
	                validators_1.IsExpirated
	            ]
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, procedure_service_1.ProcedureService, agenda_service_1.AgendaService, bank_service_1.BankService, login_service_1.LoginService])
	    ], AgendaPanelComponent);
	    return AgendaPanelComponent;
	}());
	exports.AgendaPanelComponent = AgendaPanelComponent;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var AgendaService = (function () {
	    function AgendaService(backendService) {
	        this.backendService = backendService;
	    }
	    AgendaService.prototype.findProcedure = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        if (filter.procedures.length > 0) {
	            if (filter.procedures[0].type && filter.procedures[0].type.id) {
	                params.set('procedures[0].type.id', filter.procedures[0].type.id);
	            }
	            if (filter.procedures[0].expirationDateSince && filter.procedures[0].expirationDateUntil) {
	                params.set('procedures[0].expirationDateSince', filter.procedures[0].expirationDateSince);
	                params.set('procedures[0].expirationDateUntil', filter.procedures[0].expirationDateUntil);
	            }
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("agenda/procedures", params);
	    };
	    AgendaService.prototype.resolveProcedure = function (procedureId) {
	        return this.backendService.get("agenda/procedure/" + procedureId, null);
	    };
	    AgendaService.setParams = function (filter, page, itemsPerPage, withDocuments) {
	        var params = new http_1.URLSearchParams();
	        if (filter.patent) {
	            params.set('patent', filter.patent);
	        }
	        if (filter.contract.bank && filter.contract.bank.id) {
	            params.set('contract.bank.id', filter.contract.bank.id);
	        }
	        if (filter.contract.contractNumber) {
	            params.set('contract.contractNumber', filter.contract.contractNumber);
	        }
	        if (filter.contract.cuit) {
	            params.set('contract.cuit', filter.contract.cuit);
	        }
	        if (filter.procedures.length > 0 && filter.procedures[0].type && filter.procedures[0].type.id) {
	            params.set('procedures[0].type.id', filter.procedures[0].type.id);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        /*Opcional: descarga de documentos*/
	        params.set('withDocuments', String(withDocuments));
	        return params;
	    };
	    AgendaService.getURLFilterProcedures = function (filter, page, itemsPerPage, withDocuments) {
	        return "/agendaReport?" + AgendaService.setParams(filter, page, itemsPerPage, withDocuments).toString();
	    };
	    AgendaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], AgendaService);
	    return AgendaService;
	}());
	exports.AgendaService = AgendaService;


/***/ },
/* 925 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n        <form class=\"form\" [formGroup]=\"form\">\n            <!--Descomentar si se quiere filtrar en cuanto el formulario cambie (ngSubmit)=\"find()\"-->\n            <div class=\"panel panel-default\" *ngIf=\"showFilters\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"patentFilter\">Patente</label>\n                            <input type=\"text\" class=\"form-control\" id=\"patentFilter\"\n                                   formControlName=\"patent\" [(ngModel)]=\"filter.patent\" name=\"patent\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\"\n                                    [(ngModel)]=\"filter.contract.bank\" name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"contractFilter\">Nro. de Contrato</label>\n                            <input type=\"text\" class=\"form-control\" id=\"contractFilter\" placeholder=\"\"\n                                   formControlName=\"contractNumber\" [(ngModel)]=\"filter.contract.contractNumber\"\n                                   name=\"contractNumber\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cuitFilter\">CUIT</label>\n                            <input type=\"text\" class=\"form-control\" id=\"cuitFilter\" placeholder=\"\"\n                                   formControlName=\"cuit\" [(ngModel)]=\"filter.contract.cuit\" name=\"cuit\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"procedureTypeFilter\">Tipo de trámite</label>\n                            <select class=\"form-control\" id=\"procedureTypeFilter\" formControlName=\"procedureType\"\n                                    [(ngModel)]=\"filter.procedures[0].type\" name=\"procedureType\">\n                                <option [ngValue]=\"typeTodos\" *ngIf=\"procedureTypes.length > 1\">\n                                    {{typeTodos.description}}\n                                </option>\n                                <option *ngFor=\"let procedureType of procedureTypes\" [ngValue]=\"procedureType\">\n                                    {{procedureType.description}}\n                                </option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm has-feedback\">\n                            <label for=\"expirationDateSince\">Fecha de Vencimiento (desde)</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"expirationDateSince\"\n                                       name=\"expirationDateSince\" formControlName=\"expirationDateSince\"\n                                       id=\"expirationDateSince\" maxlength=\"10\"\n                                       (change)=\"triggerExpirationDateValidators()\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.expirationDateSince.valid && form.controls.expirationDateSince.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <div *ngIf=\"!form.controls.expirationDateSince.valid && form.controls.expirationDateSince.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.requiredDate}}\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm has-feedback\">\n                            <label for=\"expirationDateUntil\">Fecha de Vencimiento (hasta)</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"expirationDateUntil\"\n                                       name=\"expirationDateUntil\" formControlName=\"expirationDateUntil\"\n                                       id=\"expirationDateUntil\" maxlength=\"10\"\n                                       (change)=\"triggerExpirationDateValidators()\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.expirationDateUntil.valid && form.controls.expirationDateUntil.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <div *ngIf=\"!form.controls.expirationDateUntil.valid && form.controls.expirationDateUntil.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.requiredDate}}\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <!--EMPTY-->\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\"\n                                [disabled]=\"!form.valid || filterEmpty()\" style=\"margin-top: 23px\">\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div class=\"col-xs-12\" *ngIf=\"filterEmpty()\">\n                        <div class=\"alert alert-info\">Ingrese alg&uacute;n filtro de b&uacute;squeda</div>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <legend>Descarga de Agenda</legend>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\" *ngIf=\"reportMessage\">\n                            <div class=\"alert alert-info\">{{reportMessage}}</div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <div class=\"form-group form-group-sm\">\n                                <div class=\"col-xs-9\">\n                                    <label class=\"hidden\" for=\"withDocuments\">Documentos</label>\n                                    <label class=\"checkboxLabel\">\n                                        <input type=\"checkbox\" class=\"form-control checkbox\" id=\"withDocuments\"\n                                               formControlName=\"withDocuments\" [(ngModel)]=\"withDocuments\"\n                                               name=\"withDocuments\" [disabled]=\"data.length == 0\">\n                                        con descarga de documentos\n                                    </label>\n                                </div>\n                                <div class=\"col-xs-3\">\n                                    <button type=\"button\" class=\"btn btn-primary\"\n                                            (click)=\"downloadFilterProcedures()\"\n                                            [disabled]=\"!form.valid || filterEmpty() || data.length == 0\"\n                                            style=\"margin-top: 23px\">\n                                        <span class=\"download-alt\"><img>Descargar</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n        <div class=\"panel panel-default\">\n            <div class=\"panel-body table-responsive\">\n                <table class=\"table table-striped\">\n                    <thead>\n                    <tr>\n                        <th style=\"width: 10%\">Patente</th>\n                        <th style=\"width: 10%\">Tipo de trámite</th>\n                        <th style=\"width: 10%\">Tipo de Vencimiento</th>\n                        <th style=\"width: 10%\">Vencimiento</th>\n                        <th style=\"width: 10%\">Estado</th>\n                        <th style=\"width: 5%\">Nro. de Contrato</th>\n                        <th style=\"width: 5%\">Banco</th>\n                        <th style=\"width: 10%\">CUIT</th>\n                        <th style=\"width: 20%\">Documento</th>\n                        <th style=\"width: 10%\" *ngIf=\"canViewAgenda && canEditAgenda\">Acciones</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                        <td>{{item.vehicle.patent}}</td>\n                        <td>{{item.type.description}}</td>\n                        <td>{{(item.expirationType.description|uppercase)}}</td>\n                        <td>{{item.customDate}}</td>\n                        <td>\n                            {{item.done | isExpirated : item.customDate}}\n                        </td>\n                        <td>{{item.vehicle.contract.contractNumber}}</td>\n                        <td>{{item.vehicle.contract.bank.name}}</td>\n                        <td>{{item.vehicle.contract.cuit}}</td>\n                        <td>\n                            <a href=\"/procedure/{{item.id}}/download\" target=\"file\">\n                                <span class=\"paperclip\"><img></span>\n                                {{item.document.name}}\n                            </a>\n                        </td>\n                        <td *ngIf=\"canViewAgenda && canEditAgenda\">\n                            <button type=\"button\" class=\"btn btn-primary\" title=\"Marcar como resuelto\"\n                                    (click)=\"resolveItem(item)\">\n                                <span class=\"withText\">Marcar como resuelto</span>\n                            </button>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan=\"10\">\n                            <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 926 */
/***/ function(module, exports) {

	module.exports = "agenda-panel.container {\n    display: inline;\n    float: none;\n}\n\n.checkboxLabel input.checkbox {\n    margin-right: 8px;\n    margin-left: 0;\n    float: left;\n}\n\n.checkbox {\n    height: 20px;\n    width: 20px;\n    margin-left: 73px;\n}\n\n.checkboxLabel {\n    display: inline-block;\n    margin-top: 18px;\n    float: left;\n}\n\n.centered {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.table > caption + thead > tr:first-child > td,\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td button.btn,\n.table > tbody > tr > th button.btn,\n.table > tfoot > tr > td button.btn,\n.table > tfoot > tr > th button.btn,\n.table > thead > tr > td button.btn,\n.table > thead > tr > th button.btn {\n    padding: 5px;\n    font-size: 12px;\n    height: 24px;\n    line-height: 15px;\n}\n\n.table > tbody > tr > td button.btn span img,\n.table > tbody > tr > th button.btn span img,\n.table > tfoot > tr > td button.btn span img,\n.table > tfoot > tr > th button.btn span img,\n.table > thead > tr > td button.btn span img,\n.table > thead > tr > th button.btn span img {\n    width: 12px;\n}\n\n.table > tbody > tr > td button.btn span.file-icon img,\n.table > tbody > tr > th button.btn span.file-icon img,\n.table > tfoot > tr > td button.btn span.file-icon img,\n.table > tfoot > tr > th button.btn span.file-icon img,\n.table > thead > tr > td button.btn span.file-icon img,\n.table > thead > tr > th button.btn span.file-icon img {\n    width: 10px;\n}\n\n.btn-agenda {\n    font-size: 12px !important;\n}\n\n.btn-agenda img {\n    height: 17px;\n    padding-bottom: 5px;\n}"

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var vehicle_1 = __webpack_require__(873);
	var login_service_1 = __webpack_require__(404);
	var ng2_file_upload_1 = __webpack_require__(889);
	var bank_1 = __webpack_require__(875);
	var bank_service_1 = __webpack_require__(631);
	var validators_1 = __webpack_require__(849);
	var procedure_service_1 = __webpack_require__(916);
	var navigation_service_1 = __webpack_require__(403);
	var PendingProceduresPanelComponent = (function () {
	    function PendingProceduresPanelComponent(router, procedureService, bankService, loginService, navigationService) {
	        var _this = this;
	        this.router = router;
	        this.procedureService = procedureService;
	        this.bankService = bankService;
	        this.loginService = loginService;
	        this.navigationService = navigationService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los bancos.');
	        });
	        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
	        /*this.form.valueChanges
	         .debounceTime(400)
	         .subscribe(this.find.bind(this));*/
	    }
	    PendingProceduresPanelComponent.prototype.init = function () {
	        this.data = [];
	        this.banks = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        this.canEditProcedure = false;
	        this.canViewProcedure = false;
	        this.showFilters = false;
	        this.filter = new vehicle_1.Vehicle();
	        this.form = new forms_1.FormGroup({
	            bank: new forms_1.FormControl(),
	            contractNumber: new forms_1.FormControl(),
	            cuit: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl(),
	            withDocuments: new forms_1.FormControl()
	        });
	        if (!this.filter.contract.bank.id) {
	            this.filter.contract.bank = this.bankTodos;
	        }
	    };
	    PendingProceduresPanelComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    PendingProceduresPanelComponent.prototype.filterEmpty = function () {
	        return !((this.filter.contract.contractNumber || this.filter.contract.cuit)
	            || (this.filter.contract.bank && this.filter.contract.bank.id != ''));
	    };
	    PendingProceduresPanelComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.filter.contract.bank = banks[0];
	        }
	    };
	    PendingProceduresPanelComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.reportMessage = null;
	        if (!this.filterEmpty()) {
	            this.loading = true;
	            this.procedureService.findPendingProcedure(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	                _this.refreshData(data);
	                _this.page = page;
	            }, function () {
	                _this.bindError('Ocurrió un error al buscar los vehículos.');
	            });
	        }
	    };
	    PendingProceduresPanelComponent.prototype.refreshData = function (page) {
	        this.data = page.content;
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    PendingProceduresPanelComponent.prototype.editItem = function (item) {
	        this.navigationService.setBackParameters({ tabSelected: 'pendingProcedures' });
	        this.router.navigate(['app/home/editPendingProcedure', item.id]);
	    };
	    PendingProceduresPanelComponent.prototype.close = function (saved) {
	        if (saved) {
	            this.find();
	        }
	    };
	    PendingProceduresPanelComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    PendingProceduresPanelComponent.prototype.ngOnInit = function () {
	        this.userLogged = this.loginService.getUserLogged();
	        this.canEditProcedure = this.userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');
	        this.canViewProcedure = this.userLogged.isActionAllowed('PROCEDURES', 'VIEW', 'PROCEDURES');
	        if (this.userLogged.rol.client) {
	            if (this.userLogged.cuit) {
	                this.filter.contract.cuit = this.userLogged.username;
	            }
	            else {
	                this.filter.patent = this.userLogged.username;
	            }
	            this.filter.contract.bank.id = this.userLogged.bank.id;
	            this.showFilters = false;
	        }
	        else {
	            this.showFilters = true;
	        }
	        this.getPage(1);
	    };
	    PendingProceduresPanelComponent.prototype.ngAfterViewInit = function () {
	    };
	    PendingProceduresPanelComponent.prototype.disableLoading = function () {
	        this.loading = false;
	    };
	    PendingProceduresPanelComponent.prototype.enableLoading = function () {
	        this.loading = true;
	    };
	    PendingProceduresPanelComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    PendingProceduresPanelComponent = __decorate([
	        core_1.Component({
	            selector: 'pendingProcedures-panel',
	            template: __webpack_require__(928),
	            styles: [__webpack_require__(929)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe, validators_1.KmFormat],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, procedure_service_1.ProcedureService, bank_service_1.BankService, login_service_1.LoginService, navigation_service_1.NavigationService])
	    ], PendingProceduresPanelComponent);
	    return PendingProceduresPanelComponent;
	}());
	exports.PendingProceduresPanelComponent = PendingProceduresPanelComponent;


/***/ },
/* 928 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n        <form class=\"form\" [formGroup]=\"form\">\n            <!--Descomentar si se quiere filtrar en cuanto el formulario cambie (ngSubmit)=\"find()\"-->\n            <div class=\"panel panel-default\" *ngIf=\"showFilters\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\"\n                                    [(ngModel)]=\"filter.contract.bank\" name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-4\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"contractFilter\">Nro. de Contrato</label>\n                            <input type=\"text\" class=\"form-control\" id=\"contractFilter\" placeholder=\"\"\n                                   formControlName=\"contractNumber\" [(ngModel)]=\"filter.contract.contractNumber\"\n                                   name=\"contractNumber\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-4\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"cuitFilter\">CUIT</label>\n                            <input type=\"text\" class=\"form-control\" id=\"cuitFilter\" placeholder=\"\"\n                                   formControlName=\"cuit\" [(ngModel)]=\"filter.contract.cuit\" name=\"cuit\">\n                        </div>\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\"\n                                [disabled]=\"!form.valid || filterEmpty()\" style=\"margin-top: 23px\">\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div class=\"col-xs-12\" *ngIf=\"filterEmpty()\">\n                        <div class=\"alert alert-info\">Ingrese alg&uacute;n filtro de b&uacute;squeda</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n        <div class=\"panel panel-default\">\n            <div class=\"panel-body table-responsive\">\n                <table class=\"table table-striped\">\n                    <thead>\n                        <tr>\n                            <th style=\"width: 5%\" *ngIf=\"canEditProcedure\"></th>\n                            <th style=\"width: 10%\">CUIT</th>\n                            <th style=\"width: 20%\">Tipo de trámite</th>\n                            <th style=\"width: 20%\" *ngIf=\"canEditProcedure\">Nro. de Contrato</th>\n                            <th style=\"width: 20%\" *ngIf=\"canEditProcedure\">Banco</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n\n                        <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                            <td *ngIf=\"canEditProcedure\">\n                                <button class=\"btn btn-primary\" title=\"Seleccionar Tr&aacute;mite\" (click)=\"editItem(item)\">\n                                    <span class=\"pencil\"><img></span>\n                                </button>\n                            </td>\n                            <td>{{item.contract.cuit}}</td>\n                            <td>{{item.type.description}}</td>\n                            <td *ngIf=\"canEditProcedure\">{{item.contract.contractNumber}}</td>\n                            <td *ngIf=\"canEditProcedure\">{{item.contract.bank.name}}</td>\n                        </tr>\n                    </tbody>\n                    <tfoot>\n                        <tr>\n                            <td colspan=\"10\">\n                                <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                            </td>\n                        </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ },
/* 929 */
/***/ function(module, exports) {

	module.exports = "pendingProcedures-panel.container {\n    display: inline;\n    float: none;\n}\n\n.checkboxLabel input.checkbox {\n    margin-right: 8px;\n    margin-left: 0;\n    float: left;\n}\n\n.checkbox {\n    height: 20px;\n    width: 20px;\n    margin-left: 73px;\n}\n\n.checkboxLabel {\n    display: inline-block;\n    margin-top: 18px;\n    float: left;\n}\n\n.centered {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.table > caption + thead > tr:first-child > td,\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n    font-size: 12px;\n    margin-bottom: 5px;\n}\n\n.table > tbody > tr > td button.btn,\n.table > tbody > tr > th button.btn,\n.table > tfoot > tr > td button.btn,\n.table > tfoot > tr > th button.btn,\n.table > thead > tr > td button.btn,\n.table > thead > tr > th button.btn,\n.table > tbody > tr > td a.btn,\n.table > tbody > tr > th a.btn,\n.table > tfoot > tr > td a.btn,\n.table > tfoot > tr > th a.btn,\n.table > thead > tr > td a.btn,\n.table > thead > tr > th a.btn {\n    padding: 5px;\n    font-size: 0;\n    height: 24px;\n    line-height: 15px;\n}\n\n.table > tbody > tr > td button.btn span,\n.table > tbody > tr > td a.btn span,\n.table > tbody > tr > th button.btn span,\n.table > tbody > tr > th a.btn span,\n.table > tfoot > tr > td button.btn span,\n.table > tfoot > tr > td a.btn span,\n.table > tfoot > tr > th button.btn span,\n.table > tfoot > tr > th a.btn span,\n.table > thead > tr > td button.btn span,\n.table > thead > tr > td a.btn span,\n.table > thead > tr > th button.btn span,\n.table > thead > tr > th a.btn span {\n    font-size: 0\n}\n\n.table > tbody > tr > td button.btn span img,\n.table > tbody > tr > th button.btn span img,\n.table > tfoot > tr > td button.btn span img,\n.table > tfoot > tr > th button.btn span img,\n.table > thead > tr > td button.btn span img,\n.table > thead > tr > th button.btn span img,\n.table > tbody > tr > td a.btn span img,\n.table > tbody > tr > th a.btn span img,\n.table > tfoot > tr > td a.btn span img,\n.table > tfoot > tr > th a.btn span img,\n.table > thead > tr > td a.btn span img,\n.table > thead > tr > th a.btn span img {\n    width: 12px;\n}\n\n.table > tbody > tr > td button.btn span.file-icon img,\n.table > tbody > tr > th button.btn span.file-icon img,\n.table > tfoot > tr > td button.btn span.file-icon img,\n.table > tfoot > tr > th button.btn span.file-icon img,\n.table > thead > tr > td button.btn span.file-icon img,\n.table > thead > tr > th button.btn span.file-icon img,\n.table > tbody > tr > td a.btn span.file-icon img,\n.table > tbody > tr > th a.btn span.file-icon img,\n.table > tfoot > tr > td a.btn span.file-icon img,\n.table > tfoot > tr > th a.btn span.file-icon img,\n.table > thead > tr > td a.btn span.file-icon img,\n.table > thead > tr > th a.btn span.file-icon img {\n    width: 10px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\n.btn-procedure {\n    font-size: 12px !important;\n}\n\n.btn-procedure img {\n    height: 17px;\n    padding-bottom: 5px;\n}\n\n#bulkLoadContainer {\n    margin-top: 30px;\n    background-color: #d9edf7;\n    border-radius: 4px;\n    -webkit-margin-start: 0;\n    -webkit-margin-end: 0;\n    -webkit-padding-before: 0;\n    -webkit-padding-start: 0;\n    -webkit-padding-end: 0;\n    -webkit-padding-after: 0;\n}\n\n#bulkLoadContainer legend {\n    position: relative;\n    top: 30px;\n    padding-left: 15px;\n}\n\n#bulkLoadContainer .my-drop-zone {\n    margin-top: 20px;\n}\n\n.row.uploaderQueue {\n    background-color: #d9edf7;\n    position: relative;\n    top: -3px;\n}\n\n.row.uploaderQueue .noPadding {\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.row.uploaderQueue .noPadding table {\n    color: #333;\n}\n\n#bulkLoadContainer {\n    display: block;\n}"

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"wrapper\">\n    <!-- Navigation -->\n    <nav class=\"navbar navbar-default navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0\">\n        <div class=\"navbar-header\">\n            <button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\".navbar-collapse\">\n                <span class=\"sr-only\">Toggle navigation</span> <span\n                    class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span\n                    class=\"icon-bar\"></span>\n            </button>\n            <h2>\n                <img src=\"{{logoUrl}}\" *ngIf=\"logoUrl\" class=\"img-thumbnail img-responsive\" style=\"max-height: 80px;\"/>\n                <span *ngIf=\"!logoUrl && userLogged?.bank\">{{userLogged.bank.name}}</span>\n                <img src=\"" + __webpack_require__(931) + "\" class=\"img-thumbnail img-responsive\"\n                     style=\"max-height: 80px;\" alt=\"Servileasing\">\n                <!--Servileasing-->\n            </h2>\n        </div>\n\n        <!-- /.navbar-header -->\n        <ul class=\"nav navbar-top-links navbar-right\">\n            <li class=\"dropdown\" *ngIf=\"!userIsClient\">\n                <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"javascript:void(0);\" (click)=\"goToHome()\">\n                    <!--<i class=\"fa fa-home fa-fw\"></i>-->\n                    <span class=\"home\"><img></span>\n                    Home\n                </a>\n            </li>\n            <!-- /.dropdown -->\n            <li class=\"dropdown\" *ngIf=\"false\">\n                <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"javascript:void(0);\" (click)=\"goToReports()\"> <i\n                        class=\"fa fa-line-chart fa-fw\"></i>\n                </a>\n            </li>\n            <!-- /.dropdown -->\n            <li class=\"dropdown\" *ngIf=\"userIsAdmin || userIsBank\">\n                <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"javascript:void(0);\" (click)=\"goToConfig()\">\n                    <!--<i class=\"fa fa-gear fa-fw\"></i>-->\n                    <span class=\"gear\"><img></span>\n                </a>\n            </li>\n            <!-- /.dropdown -->\n            <li class=\"dropdown\" *ngIf=\"userIsAdmin\">\n                <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"javascript:void(0);\"\n                   (click)=\"goToConfigMails()\">\n                    <!--<i class=\"fa fa-envelope fa-fw\"></i>-->\n                    <span class=\"envelopeNavbar\"><img></span>\n                </a>\n            </li>\n            <!-- /.dropdown -->\n            <li class=\"dropdown\" dropdown>\n                <a class=\"dropdown-toggle\"\n                   data-toggle=\"dropdown\" href=\"javascript:void(0);\" dropdownToggle>\n                    <!--<i class=\"fa fa-user fa-fw\"></i>-->\n                    <span class=\"userNavbar\" *ngIf=\"userLogged\"><img> {{userLogged.username}}</span>\n                    <!--<i class=\"fa fa-caret-down\"></i>-->\n                    <span class=\"caret-down\"><img></span>\n                </a>\n                <ul class=\"dropdown-menu dropdown-user\" dropdownMenu>\n                    <li *ngIf=\"false\">\n                        <a href=\"#\">\n                            <!--<i class=\"fa fa-user fa-fw\"></i>-->\n                            <span class=\"user\"><img></span>\n                            User Profile\n                        </a>\n                    </li>\n                    <li class=\"divider\"></li>\n                    <li><a href=\"/logout\"><i class=\"fa fa-sign-out fa-fw\"></i>\n                        Salir</a></li>\n                </ul> <!-- /.dropdown-user --></li>\n            <!-- /.dropdown -->\n        </ul>\n        <!-- /.navbar-top-links -->\n\n        <!-- /.navbar-static-side -->\n    </nav>\n\n    <div id=\"page-wrapper\">\n        <router-outlet></router-outlet>\n    </div>\n    <!-- /#page-wrapper -->\n\n</div>";

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/servileasing_web.03890ffc2ab0ed83dbfa2632058c8afd.png";

/***/ },
/* 932 */
/***/ function(module, exports) {

	module.exports = "/*!\n * Start Bootstrap - SB Admin 2 Bootstrap Admin Theme (http://startbootstrap.com)\n * Code licensed under the Apache License v2.0.\n * For details, see http://www.apache.org/licenses/LICENSE-2.0.\n */\n\nbody {\n    background-color: #f8f8f8;\n}\n\n#wrapper {\n    width: 100%;\n}\n\n#page-wrapper {\n    padding: 0 15px;\n    min-height: 568px;\n    background-color: #fff;\n}\n\n@media (min-width: 768px) {\n    #page-wrapper {\n        position: inherit;\n        /*margin: 0 0 0 250px;*/\n        padding: 0 0px;\n        /*border-left: 1px solid #e7e7e7;*/\n    }\n}\n\n.navbar-top-links {\n    margin-right: 0;\n}\n\n.navbar-top-links li {\n    display: inline-block;\n}\n\n.navbar-top-links li:last-child {\n    margin-right: 15px;\n}\n\n.navbar-top-links li a {\n    padding: 15px;\n    min-height: 50px;\n}\n\n.navbar-top-links .dropdown-menu li {\n    display: block;\n}\n\n.navbar-top-links .dropdown-menu li:last-child {\n    margin-right: 0;\n}\n\n.navbar-top-links .dropdown-menu li a {\n    padding: 3px 20px;\n    min-height: 0;\n}\n\n.navbar-top-links .dropdown-menu li a div {\n    white-space: normal;\n}\n\n.navbar-top-links .dropdown-messages,\n.navbar-top-links .dropdown-tasks,\n.navbar-top-links .dropdown-alerts {\n    width: 310px;\n    min-width: 0;\n}\n\n.navbar-top-links .dropdown-messages {\n    margin-left: 5px;\n}\n\n.navbar-top-links .dropdown-tasks {\n    margin-left: -59px;\n}\n\n.navbar-top-links .dropdown-alerts {\n    margin-left: -123px;\n}\n\n.navbar-top-links .dropdown-user {\n    right: 0;\n    left: auto;\n}\n\n.sidebar .sidebar-nav.navbar-collapse {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.sidebar .sidebar-search {\n    padding: 15px;\n}\n\n.sidebar ul li {\n    border-bottom: 1px solid #e7e7e7;\n}\n\n.sidebar ul li a.active {\n    background-color: #eee;\n}\n\n.sidebar .arrow {\n    float: right;\n}\n\n.sidebar .fa.arrow:before {\n    content: \"\\f104\";\n}\n\n.sidebar .active > a > .fa.arrow:before {\n    content: \"\\f107\";\n}\n\n.sidebar .nav-second-level li,\n.sidebar .nav-third-level li {\n    border-bottom: 0 !important;\n}\n\n.sidebar .nav-second-level li a {\n    padding-left: 37px;\n}\n\n.sidebar .nav-third-level li a {\n    padding-left: 52px;\n}\n\n@media (min-width: 768px) {\n    .sidebar {\n        z-index: 1;\n        position: absolute;\n        width: 250px;\n        margin-top: 51px;\n    }\n\n    .navbar-top-links .dropdown-messages,\n    .navbar-top-links .dropdown-tasks,\n    .navbar-top-links .dropdown-alerts {\n        margin-left: auto;\n    }\n}\n\n.btn-outline {\n    color: inherit;\n    background-color: transparent;\n    transition: all .5s;\n}\n\n.btn-primary.btn-outline {\n    color: #428bca;\n}\n\n.btn-success.btn-outline {\n    color: #5cb85c;\n}\n\n.btn-info.btn-outline {\n    color: #5bc0de;\n}\n\n.btn-warning.btn-outline {\n    color: #f0ad4e;\n}\n\n.btn-danger.btn-outline {\n    color: #d9534f;\n}\n\n.btn-primary.btn-outline:hover,\n.btn-success.btn-outline:hover,\n.btn-info.btn-outline:hover,\n.btn-warning.btn-outline:hover,\n.btn-danger.btn-outline:hover {\n    color: #fff;\n}\n\n.chat {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.chat li {\n    margin-bottom: 10px;\n    padding-bottom: 5px;\n    border-bottom: 1px dotted #999;\n}\n\n.chat li.left .chat-body {\n    margin-left: 60px;\n}\n\n.chat li.right .chat-body {\n    margin-right: 60px;\n}\n\n.chat li .chat-body p {\n    margin: 0;\n}\n\n.panel .slidedown .glyphicon,\n.chat .glyphicon {\n    margin-right: 5px;\n}\n\n.chat-panel .panel-body {\n    height: 350px;\n    overflow-y: scroll;\n}\n\n.login-panel {\n    margin-top: 25%;\n}\n\n.flot-chart {\n    display: block;\n    height: 400px;\n}\n\n.flot-chart-content {\n    width: 100%;\n    height: 100%;\n}\n\n.dataTables_wrapper {\n    position: relative;\n    clear: both;\n}\n\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n    background: 0 0;\n}\n\ntable.dataTable thead .sorting_asc:after {\n    content: \"\\f0de\";\n    float: right;\n    font-family: fontawesome;\n}\n\ntable.dataTable thead .sorting_desc:after {\n    content: \"\\f0dd\";\n    float: right;\n    font-family: fontawesome;\n}\n\ntable.dataTable thead .sorting:after {\n    content: \"\\f0dc\";\n    float: right;\n    font-family: fontawesome;\n    color: rgba(50, 50, 50, .5);\n}\n\n.btn-circle {\n    width: 30px;\n    height: 30px;\n    padding: 6px 0;\n    border-radius: 15px;\n    text-align: center;\n    font-size: 12px;\n    line-height: 1.428571429;\n}\n\n.btn-circle.btn-lg {\n    width: 50px;\n    height: 50px;\n    padding: 10px 16px;\n    border-radius: 25px;\n    font-size: 18px;\n    line-height: 1.33;\n}\n\n.btn-circle.btn-xl {\n    width: 70px;\n    height: 70px;\n    padding: 10px 16px;\n    border-radius: 35px;\n    font-size: 24px;\n    line-height: 1.33;\n}\n\n.show-grid [class^=col-] {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border: 1px solid #ddd;\n    background-color: #eee !important;\n}\n\n.show-grid {\n    margin: 15px 0;\n}\n\n.huge {\n    font-size: 40px;\n}\n\n.panel-green {\n    border-color: #5cb85c;\n}\n\n.panel-green .panel-heading {\n    border-color: #5cb85c;\n    color: #fff;\n    background-color: #5cb85c;\n}\n\n.panel-green a {\n    color: #5cb85c;\n}\n\n.panel-green a:hover {\n    color: #3d8b3d;\n}\n\n.panel-red {\n    border-color: #d9534f;\n}\n\n.panel-red .panel-heading {\n    border-color: #d9534f;\n    color: #fff;\n    background-color: #d9534f;\n}\n\n.panel-red a {\n    color: #d9534f;\n}\n\n.panel-red a:hover {\n    color: #b52b27;\n}\n\n.panel-yellow {\n    border-color: #f0ad4e;\n}\n\n.panel-yellow .panel-heading {\n    border-color: #f0ad4e;\n    color: #fff;\n    background-color: #f0ad4e;\n}\n\n.panel-yellow a {\n    color: #f0ad4e;\n}\n\n.panel-yellow a:hover {\n    color: #df8a13;\n}\n\n.navbar-header img.img-thumbnail{\n    background: transparent;\n    border: 0;\n}"

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	exports.FaDirective = __webpack_require__(934).FaDirective;
	//exports.FaStackDirective = require('./lib/directives/fa-stack.directive').FaStackDirective;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var FaDirective = (function () {
	    function FaDirective(el) {
	        this.el = el.nativeElement;
	        this.el.classList.add('fa');
	    }
	    FaDirective.prototype.ngOnChanges = function (changes) {
	        for (var key in changes) {
	            var previousValue = changes[key].previousValue;
	            var currentValue = changes[key].currentValue;
	            switch (key) {
	                case 'name':
	                    if (typeof previousValue === 'string') {
	                        this.el.classList.remove("fa-" + previousValue);
	                    }
	                    this.el.classList.add("fa-" + currentValue);
	                    break;
	                case 'alt':
	                    break;
	                case 'size':
	                    if (FaDirective.sizeValidator.test(currentValue)) {
	                        if (previousValue === 1) {
	                            this.el.classList.remove('fa-lg');
	                        }
	                        else if (typeof previousValue === 'string') {
	                            this.el.classList.remove("fa-" + previousValue + "x");
	                        }
	                        if (currentValue === 1) {
	                            this.el.classList.add('fa-lg');
	                        }
	                        else {
	                            this.el.classList.add("fa-" + currentValue + "x");
	                        }
	                    }
	                    break;
	                case 'stack':
	                    if (FaDirective.sizeValidator.test(currentValue)) {
	                        if (typeof previousValue === 'string') {
	                            this.el.classList.remove("fa-stack-" + previousValue + "x");
	                        }
	                        this.el.classList.add("fa-stack-" + currentValue + "x");
	                    }
	                    break;
	                case 'flip':
	                    if (FaDirective.flipValidator.test(currentValue)) {
	                        if (typeof previousValue === 'string') {
	                            this.el.classList.remove("fa-flip-" + previousValue);
	                        }
	                        this.el.classList.add("fa-flip-" + currentValue);
	                    }
	                    break;
	                case 'pull':
	                    if (FaDirective.pullValidator.test(currentValue)) {
	                        if (typeof previousValue === 'string') {
	                            this.el.classList.remove("fa-pull-" + previousValue);
	                        }
	                        this.el.classList.add("fa-pull-" + currentValue);
	                    }
	                    break;
	                case 'rotate':
	                    if (FaDirective.rotateValidator.test(currentValue)) {
	                        if (typeof previousValue === 'string') {
	                            this.el.classList.remove("fa-rotate-" + previousValue);
	                        }
	                        this.el.classList.add("fa-rotate-" + currentValue);
	                    }
	                    break;
	                case 'border':
	                    if (currentValue) {
	                        this.el.classList.add('fa-border');
	                    }
	                    else if (typeof previousValue === 'string') {
	                        this.el.classList.remove('fa-border');
	                    }
	                    break;
	                case 'spin':
	                    if (currentValue) {
	                        this.el.classList.add('fa-spin');
	                    }
	                    else if (typeof previousValue === 'string') {
	                        this.el.classList.remove('fa-spin');
	                    }
	                    break;
	                case 'fw':
	                    if (currentValue) {
	                        this.el.classList.add('fa-fw');
	                    }
	                    else if (typeof previousValue === 'string') {
	                        this.el.classList.remove('fa-fw');
	                    }
	                    break;
	                case 'inverse':
	                    if (currentValue) {
	                        this.el.classList.add('fa-inverse');
	                    }
	                    else if (typeof previousValue === 'string') {
	                        this.el.classList.remove('fa-inverse');
	                    }
	                    break;
	            }
	        }
	    };
	    FaDirective.sizeValidator = /[1-5]/;
	    FaDirective.flipValidator = /['horizontal'|'vertical']/;
	    FaDirective.pullValidator = /['right'|'left']/;
	    FaDirective.rotateValidator = /[90|180|270]/;
	    FaDirective = __decorate([
	        core_1.Directive({
	            selector: '[fa]',
	            inputs: ['name', 'alt', 'size', 'stack', 'flip', 'pull', 'rotate', 'border', 'spin', 'fw', 'inverse']
	        }), 
	        __metadata('design:paramtypes', [core_1.ElementRef])
	    ], FaDirective);
	    return FaDirective;
	}());
	exports.FaDirective = FaDirective;
	//# sourceMappingURL=fa.directive.js.map

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var Observable_1 = __webpack_require__(34);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var vehicles_service_1 = __webpack_require__(630);
	var contracts_service_1 = __webpack_require__(632);
	var bank_service_1 = __webpack_require__(631);
	var vehicle_1 = __webpack_require__(873);
	var bank_1 = __webpack_require__(875);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var VehicleEditorComponent = (function () {
	    function VehicleEditorComponent(router, vehiclesService, contractsService, bankService, route, loginService) {
	        this.router = router;
	        this.vehiclesService = vehiclesService;
	        this.contractsService = contractsService;
	        this.bankService = bankService;
	        this.route = route;
	        this.loginService = loginService;
	        this.close = new core_1.EventEmitter();
	        this.canEditContract = false;
	        this.init();
	    }
	    VehicleEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.contractValid = false;
	        this.loading = false;
	        this.canEdit = false;
	        this.patentValid = false;
	        this.vehicle = new vehicle_1.Vehicle();
	        this.vehicle.contract.bank = new bank_1.Bank();
	    };
	    VehicleEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            patent: new forms_1.FormControl(this.vehicle.patent, [forms_1.Validators.required, this.validatePatentWithType.bind(this)]),
	            type: new forms_1.FormControl(this.vehicle.type.description, [forms_1.Validators.required]),
	            brand: new forms_1.FormControl(this.vehicle.brand.name, [forms_1.Validators.required]),
	            /*version: new FormControl(this.vehicle.version),*/
	            model: new forms_1.FormControl(this.vehicle.model, [forms_1.Validators.required]),
	            year: new forms_1.FormControl(this.vehicle.year, [validators_1.YEAR_VALIDATOR]),
	            engineNumber: new forms_1.FormControl(this.vehicle.engineNumber),
	            registrable: new forms_1.FormControl(this.vehicle.registrable),
	            center: new forms_1.FormControl(this.vehicle.center),
	            contractNumber: new forms_1.FormControl(this.vehicle.contract.contractNumber, [forms_1.Validators.required]),
	            cuit: new forms_1.FormControl(this.vehicle.contract.cuit),
	            bank: new forms_1.FormControl(this.vehicle.contract.bank.id, [forms_1.Validators.required]),
	            purchaseOrderEntryDate: new forms_1.FormControl(this.vehicle.purchaseOrderAmount, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            purchaseOrderAmount: new forms_1.FormControl(this.vehicle.purchaseOrderAmount, [validators_1.AMOUNT_VALIDATOR]),
	            purchaseOrderDueDate: new forms_1.FormControl(this.vehicle.purchaseOrderDueDate, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR])
	        });
	    };
	    VehicleEditorComponent.prototype.validatePatentWithType = function (c) {
	        if (this.vehicle.type.description == 'MAQUINARIA') {
	            return null;
	        }
	        var regexp = (this.vehicle.type.description == 'MOTO') ? new RegExp(validators_1.PATENT_VALIDATOR_MOTO_PATTERN) : new RegExp(validators_1.PATENT_VALIDATOR_AUTO_PATTERN);
	        return regexp.test(c.value) ? null : {
	            validatePatent: {
	                valid: false
	            }
	        };
	    };
	    VehicleEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var userLogged = this.loginService.getUserLogged();
	        this.canEdit = userLogged.isActionAllowed('VEHICLES', 'EDIT', 'VEHICLES');
	        /*this.myDatePickerOptions = {dateFormat: 'dd/mm/yyyy'};*/
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.contractId = params['contractId'];
	            _this.canEditContract = params['contractEdit'] == 'true';
	            var vehicleId = params['vehicleId'];
	            if (vehicleId) {
	                _this.vehicleId = vehicleId;
	                _this.createMode = false;
	            }
	            else {
	                _this.createMode = true;
	                _this.canEditContract = true;
	                _this.vehicleId = null;
	            }
	            _this.getData();
	        });
	    };
	    VehicleEditorComponent.prototype.ngAfterViewInit = function () {
	    };
	    VehicleEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        this.errorMessage = null;
	        var forkTasks = [];
	        forkTasks.push(this.vehiclesService.getVehiclesType());
	        forkTasks.push(this.vehiclesService.getVehiclesBrand());
	        forkTasks.push(this.bankService.getBanks());
	        if (this.vehicleId && this.contractId) {
	            forkTasks.push(this.vehiclesService.getVehicle(this.contractId, this.vehicleId));
	        }
	        else if (this.contractId) {
	            forkTasks.push(this.contractsService.getContract(this.contractId));
	        }
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los datos del vehículo.');
	        });
	    };
	    VehicleEditorComponent.prototype.setData = function (data) {
	        this.loading = false;
	        this.vehiclesType = data[0];
	        this.vehiclesBrand = data[1];
	        this.banks = data[2];
	        if (this.vehicleId) {
	            this.vehicle = data[data.length - 1];
	            this.contractValid = true;
	            if (this.vehicle.type) {
	                this.vehicleTypeId = this.vehicle.type.id;
	            }
	        }
	        else {
	            this.vehicle = new vehicle_1.Vehicle();
	            if (this.vehiclesType.length > 0) {
	                /*Siempre en la opción "AUTO"*/
	                this.vehicle.type = this.vehiclesType[1];
	                this.vehicleTypeId = this.vehiclesType[1].id;
	            }
	            if (this.contractId) {
	                this.vehicle.contract = data[data.length - 1];
	            }
	        }
	        this.validatePatent();
	        /*Si se va a crear un vehículo desde la pantalla Contrato:*/
	        if (this.vehicleId == null && this.contractId) {
	            this.canEditContract = false;
	            this.contractValid = true;
	        }
	    };
	    VehicleEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    VehicleEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    VehicleEditorComponent.prototype.updateVehiclesBrand = function (vehicle) {
	        var result = this.vehiclesBrand.filter(function (obj) {
	            return obj.name === vehicle.brand.name;
	        });
	        if (result.length == 0) {
	            this.vehiclesBrand.push(vehicle.brand);
	        }
	    };
	    VehicleEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        /*TODO: A la espera de si la columna "version" va a ser requerida*/
	        this.vehicle.version = null;
	        this.vehiclesService.save(this.vehicle).subscribe(function (saved) {
	            _this.loading = false;
	            _this.vehicle = saved;
	            _this.successMessage = 'El vehículo se guardó con éxito';
	            _this.updateVehiclesBrand(saved);
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar la información.');
	        });
	    };
	    VehicleEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.vehicle);
	        if (this.vehicleId == null && this.contractId == null) {
	            window.history.back();
	        }
	        else if (this.vehicleId == null && this.contractId) {
	            this.router.navigate(['app/home/editContract', this.contractId]);
	        }
	        else {
	            window.history.back();
	        }
	    };
	    VehicleEditorComponent.prototype.onBrandSelected = function (brand) {
	        this.vehicle.brand = brand.item;
	    };
	    /*onBankSelected(bank:Bank) {
	     this.vehicle.contract.bank = bank;
	     }
	
	     setPurchaseOrderEntryDate(date:string) {
	     this.vehicle.purchaseOrderEntryDate = date;
	     }*/
	    VehicleEditorComponent.prototype.enableContract = function (event) {
	        event.preventDefault();
	        this.canEditContract = true;
	    };
	    VehicleEditorComponent.prototype.validatePatent = function () {
	        var _this = this;
	        this.vehiclesService.getVehicleByPatent(this.vehicle.patent).subscribe(function (vehicle) {
	            if (vehicle && vehicle.id) {
	                _this.patentValid = (_this.vehicle.id == vehicle.id) ? true : false;
	            }
	            else {
	                _this.patentValid = true;
	            }
	        }, function () {
	            _this.patentValid = false;
	            _this.bindError('Ocurrió un error al validar patente de vehículo.');
	        });
	    };
	    VehicleEditorComponent.prototype.validateContract = function (event) {
	        var _this = this;
	        if (this.vehicle.contract.contractNumber && (event != null || this.vehicle.contract.bank.id)) {
	            if (event != null) {
	                this.vehicle.contract.bank = this.banks.find(function (bank) { return bank.id == event; });
	            }
	            this.contractsService.getContractByContractNumberAndBank(this.vehicle.contract.contractNumber, this.vehicle.contract.bank.id).subscribe(function (contract) {
	                if (contract && contract.id) {
	                    _this.contractValid = (_this.vehicle.contract.id == contract.id) ? true : false;
	                }
	                else {
	                    _this.contractValid = true;
	                }
	            }, function () {
	                _this.contractValid = false;
	                _this.bindError('Ocurrió un error al validar contrato.');
	            });
	        }
	    };
	    VehicleEditorComponent.prototype.cleanPatent = function (newValue) {
	        this.vehicle.patent = "";
	        var result = this.vehiclesType.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.vehicle.type = result[0];
	        }
	    };
	    VehicleEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', vehicle_1.Vehicle)
	    ], VehicleEditorComponent.prototype, "vehicle", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], VehicleEditorComponent.prototype, "close", void 0);
	    VehicleEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'vehicle-editor',
	            template: __webpack_require__(936),
	            styles: [__webpack_require__(937)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                /*MyDatePicker,*/
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, vehicles_service_1.VehiclesService, contracts_service_1.ContractsService, bank_service_1.BankService, router_1.ActivatedRoute, login_service_1.LoginService])
	    ], VehicleEditorComponent);
	    return VehicleEditorComponent;
	}());
	exports.VehicleEditorComponent = VehicleEditorComponent;


/***/ },
/* 936 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nuevo Veh&iacute;culo</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Veh&iacute;culo</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"vehicle\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"type\">Tipo</label>\n                        <select class=\"form-control\" formControlName=\"type\" [(ngModel)]=\"vehicleTypeId\"\n                                name=\"type\" id=\"type\" (change)=\"cleanPatent($event.target.value);\"\n                                [disabled]=\"!canEdit\">\n                            <option *ngFor=\"let type of vehiclesType\" value=\"{{type.id}}\">{{type.description}}</option>\n                        </select>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"patent\">Patente</label>\n                        <input type=\"text\" class=\"form-control\"\n                               [placeholder]=\"vehicle.type.description ==='AUTO'?'Formato: ABC123 o AB123CD': (vehicle.type.description ==='MOTO'?'Formato: 123ABC o A123BCD':'')\"\n                               [(ngModel)]=\"vehicle.patent\" name=\"patent\" formControlName=\"patent\" id=\"patent\"\n                               (change)=\"validatePatent()\" [disabled]=\"!canEdit\"/>\n                        <div *ngIf=\"!form.controls.patent.valid && form.controls.patent.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                        <div *ngIf=\"!form.controls.patent.valid && form.controls.patent.errors.validatePatent\"\n                             class=\"alert-danger\">\n                            {{errorMessages.invalidPattern}}\n                        </div>\n                        <div *ngIf=\"vehicle.patent && !patentValid\" class=\"alert-danger\">\n                            Ya existe un veh&iacute;culo con la patente ingresada\n                            <b>{{vehicle.patent}}</b>\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"brand\">Marca</label>\n                        <input [(ngModel)]=\"vehicle.brand.name\" id=\"brand\"\n                               [typeahead]=\"vehiclesBrand\"\n                               (typeaheadOnSelect)=\"onBrandSelected($event)\"\n                               [typeaheadOptionField]=\"'name'\"\n                               class=\"form-control\" formControlName=\"brand\" [disabled]=\"!canEdit\">\n                        <div *ngIf=\"!form.controls.brand.valid && form.controls.brand.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"model\">Modelo</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"model\"\n                               [(ngModel)]=\"vehicle.model\" name=\"model\" id=\"model\"\n                               [disabled]=\"!canEdit\">\n                        <div *ngIf=\"!form.controls.model.valid && form.controls.model.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <!--TODO: A la espera de si la columna \"version\" va a ser requerida-->\n                    <!--<div class=\"form-group form-group-sm col-sm-3\">\n                      <label>Versi&oacute;n</label>\n                      <input type=\"text\" class=\"form-control\" formControlName=\"version\" [(ngModel)]=\"vehicle.version\" name=\"patent\" [disabled]=\"!canEdit\">\n                    </div>-->\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"year\">A&ntilde;o</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"year\"\n                               [(ngModel)]=\"vehicle.year\" id=\"year\" name=\"year\"\n                               [disabled]=\"!canEdit\">\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"engineNumber\">Motor</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"engineNumber\"\n                               [(ngModel)]=\"vehicle.engineNumber\" id=\"engineNumber\" name=\"engineNumber\"\n                               [disabled]=\"!canEdit\">\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"registrable\">Registrable</label>\n                        <select class=\"form-control\" formControlName=\"registrable\"\n                                [(ngModel)]=\"vehicle.registrable\"\n                                id=\"registrable\" name=\"registrable\"\n                                [disabled]=\"!canEdit\">\n                            <option value=\"true\">SI</option>\n                            <option value=\"false\">NO</option>\n                        </select>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"center\">Centro</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"center\"\n                               [(ngModel)]=\"vehicle.center\" id=\"center\" name=\"center\"\n                               [disabled]=\"!canEdit\">\n                    </div>\n                </div>\n                <div class=\"row rowBorder\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"contractNumber\">Nro. de Contrato</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"contractNumber\"\n                               [(ngModel)]=\"vehicle.contract.contractNumber\" name=\"contractNumber\" id=\"contractNumber\"\n                               [disabled]=\"!canEdit || !canEditContract\" (change)=\"validateContract(null)\">\n                        <div *ngIf=\"!form.controls.contractNumber.valid && form.controls.contractNumber.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                        <div *ngIf=\"vehicle.contract.contractNumber && vehicle.contract.bank.id && !contractValid\"\n                             class=\"alert-warning\">\n                            Ya existe un contrato con el n&uacute;mero\n                            <b>{{vehicle.contract.contractNumber}}</b> para <b>{{vehicle.contract.bank.name}}</b>.\n                            Se agregará el vehículo al Contrato existente.\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"cuit\">CUIT</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"cuit\"\n                               [(ngModel)]=\"vehicle.contract.cuit\" name=\"cuit\" id=\"cuit\"\n                               [disabled]=\"!canEdit || !canEditContract || (vehicle.contract.contractNumber && vehicle.contract.bank.id && !contractValid)\">\n                        <div *ngIf=\"!form.controls.cuit.valid && form.controls.cuit.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"bank\">Banco</label>\n                        <select class=\"form-control\" formControlName=\"bank\"\n                                [(ngModel)]=\"vehicle.contract.bank.id\" name=\"bank\" id=\"bank\"\n                                [disabled]=\"!canEdit || !canEditContract\"\n                                (change)=\"validateContract($event.target.value)\">\n                            <option *ngFor=\"let bank of banks\" value=\"{{bank.id}}\">{{bank.name}}</option>\n                        </select>\n                        <div *ngIf=\"!form.controls.bank.valid && form.controls.bank.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <!--todo: Si se quiere modificar el Contrato de un vehiculo, descomentar-->\n                    <!--<div class=\"form-group form-group-sm col-sm-3 divButton\">\n                        <button id=\"editContract\" (click)=\"enableContract($event)\" class=\"btn btn-primary optionButton\">\n                            <i class=\"glyphicon glyphicon-pencil\"></i>\n                        </button>\n                    </div>-->\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3 has-feedback\">\n                        <label for=\"purchaseOrderEntryDate\">Alta de Opción de Compra</label>\n                        <div class=\"input-group\">\n                            <!--<span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>-->\n                            <span class=\"input-group-addon calendar\"><img></span>\n                            <input type=\"text\" class=\"form-control date-picker\"\n                                   [(ngModel)]=\"vehicle.purchaseOrderEntryDate\"\n                                   name=\"purchaseOrderEntryDate\" formControlName=\"purchaseOrderEntryDate\"\n                                   id=\"purchaseOrderEntryDate\"\n                                   [disabled]=\"!canEdit\" maxlength=\"10\"/>\n                        </div>\n                        <div *ngIf=\"!form.controls.purchaseOrderEntryDate.valid && form.controls.purchaseOrderEntryDate.errors.pattern\"\n                             class=\"alert-danger\">\n                            {{errorMessages.invalidDate}}\n                        </div>\n                        <!--<my-date-picker [options]=\"myDatePickerOptions\"\n                                        (dateChanged)=\"vehicle.purchaseOrderEntryDate=$event.formatted\"\n                                        [selDate]=\"vehicle.purchaseOrderEntryDate\"\n                                        [disabled]=\"!canEdit\"></my-date-picker>-->\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"purchaseOrderAmount\">Monto de Opción de Compra</label>\n                        <div class=\"input-group\">\n                                <span class=\"input-group-addon\">\n                                    <i class=\"fa fa-usd\" aria-hidden=\"true\"></i>\n                                </span>\n                            <input type=\"text\" class=\"form-control\" formControlName=\"purchaseOrderAmount\"\n                                   [(ngModel)]=\"vehicle.purchaseOrderAmount\" name=\"purchaseOrderAmount\"\n                                   id=\"purchaseOrderAmount\"\n                                   [disabled]=\"!canEdit\">\n                        </div>\n                        <div *ngIf=\"!form.controls.purchaseOrderAmount.valid && form.controls.purchaseOrderAmount.errors.pattern\"\n                             class=\"alert-danger\">\n                            {{errorMessages.invalidAmount}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3 has-feedback\">\n                        <label for=\"purchaseOrderDueDate\">Vencimiento de Opción de Compra</label>\n                        <div class=\"input-group\">\n                            <!--<span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>-->\n                            <span class=\"input-group-addon calendar\"><img></span>\n                            <input type=\"text\" class=\"form-control date-picker\"\n                                   [(ngModel)]=\"vehicle.purchaseOrderDueDate\"\n                                   name=\"purchaseOrderDueDate\" formControlName=\"purchaseOrderDueDate\"\n                                   id=\"purchaseOrderDueDate\"\n                                   [disabled]=\"!canEdit\" maxlength=\"10\"/>\n                        </div>\n                        <div *ngIf=\"!form.controls.purchaseOrderDueDate.valid && form.controls.purchaseOrderDueDate.errors.pattern\"\n                             class=\"alert-danger\">\n                            {{errorMessages.invalidDate}}\n                        </div>\n                        <!--<my-date-picker [options]=\"myDatePickerOptions\"\n                                        (dateChanged)=\"vehicle.purchaseOrderDueDate=$event.formatted\"\n                                        [selDate]=\"vehicle.purchaseOrderDueDate\" [disabled]=\"!canEdit\"></my-date-picker>-->\n                    </div>\n                </div>\n                <div class=\"col-sm-12\">\n                    <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"!form.valid || loading || !patentValid\"\n                            *ngIf=\"canEdit\">Guardar\n                    </button>\n                    <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 937 */
/***/ function(module, exports) {

	module.exports = ".divButton {\n    display: table;\n    text-align: left;\n    margin-top: 25px;\n    margin-bottom: 0;\n}\n\n.optionButton {\n    display: table-cell;\n    vertical-align: bottom;\n    height: 30px;\n}\n\n.rowBorder {\n    border: 1px double rgba(211, 211, 211, 0.12);\n    background: rgba(211, 211, 211, 0.12);\n}"

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var Observable_1 = __webpack_require__(34);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var contracts_service_1 = __webpack_require__(632);
	var vehicles_service_1 = __webpack_require__(630);
	var bank_service_1 = __webpack_require__(631);
	var cities_service_1 = __webpack_require__(633);
	var contract_1 = __webpack_require__(874);
	var contact_1 = __webpack_require__(879);
	var bank_1 = __webpack_require__(875);
	var address_1 = __webpack_require__(876);
	var city_1 = __webpack_require__(877);
	var state_1 = __webpack_require__(878);
	var validators_1 = __webpack_require__(849);
	var ng2_pagination_1 = __webpack_require__(867);
	var login_service_1 = __webpack_require__(404);
	var ContractEditorComponent = (function () {
	    function ContractEditorComponent(contractsService, vehiclesService, bankService, citiesService, router, route, loginService) {
	        this.contractsService = contractsService;
	        this.vehiclesService = vehiclesService;
	        this.bankService = bankService;
	        this.citiesService = citiesService;
	        this.router = router;
	        this.route = route;
	        this.loginService = loginService;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    ContractEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.loading = false;
	        this.contract = new contract_1.Contract(null);
	        this.contract.bank = new bank_1.Bank();
	        this.stateSelected = new state_1.State();
	        this.contact = new contact_1.Contact();
	        this.vehicles = [];
	        this.itemsPerPage = 5;
	        this.page = 1;
	        this.total = 0;
	        this.canEdit = false;
	        this.canEditVehicle = false;
	        this.canDeleteVehicle = false;
	        this.canViewVehicle = false;
	        this.contractValid = false;
	    };
	    ContractEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            contractNumber: new forms_1.FormControl(this.contract.contractNumber, [forms_1.Validators.required]),
	            cuit: new forms_1.FormControl(this.contract.cuit, [forms_1.Validators.required]),
	            bank: new forms_1.FormControl(this.contract.bank.id, [forms_1.Validators.required]),
	            businessName: new forms_1.FormControl(this.contract.businessName, [forms_1.Validators.required]),
	            phone: new forms_1.FormControl(this.contract.phone),
	            street: new forms_1.FormControl(this.contract.address.street),
	            number: new forms_1.FormControl(this.contract.address.number, [validators_1.INTEGER_VALIDATOR]),
	            floor: new forms_1.FormControl(this.contract.address.floor),
	            department: new forms_1.FormControl(this.contract.address.department),
	            zipCode: new forms_1.FormControl(this.contract.address.zipCode, [validators_1.INTEGER_VALIDATOR]),
	            city: new forms_1.FormControl(this.contract.address.city.name),
	            state: new forms_1.FormControl(this.stateSelected.name),
	            contactName: new forms_1.FormControl(this.contact.name),
	            contactPhone: new forms_1.FormControl(this.contact.phone),
	            contactEmail: new forms_1.FormControl(this.contact.email, [forms_1.Validators.required, validators_1.EMAIL_VALIDATOR]),
	            dueDate: new forms_1.FormControl(this.contract.dueDate, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR])
	        });
	    };
	    ContractEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var userLogged = this.loginService.getUserLogged();
	        this.canEdit = userLogged.isActionAllowed('CONTRACTS', 'EDIT', 'CONTRACTS');
	        this.canEditVehicle = userLogged.isActionAllowed('CONTRACTS', 'EDIT', 'VEHICLES');
	        this.canDeleteVehicle = userLogged.isActionAllowed('CONTRACTS', 'DELETE', 'VEHICLES');
	        this.canViewVehicle = userLogged.isActionAllowed('CONTRACTS', 'VIEW', 'VEHICLES');
	        /*this.myDatePickerOptions = {dateFormat: 'dd/mm/yyyy'};*/
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var contractId = params['contractId'];
	            if (contractId) {
	                _this.createMode = false;
	                _this.contractId = contractId;
	            }
	            else {
	                _this.createMode = true;
	            }
	            _this.getData();
	        });
	    };
	    ContractEditorComponent.prototype.ngAfterViewInit = function () {
	    };
	    ContractEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        var forkTasks = [];
	        forkTasks.push(this.bankService.getBanks());
	        forkTasks.push(this.citiesService.getStates());
	        if (this.contractId) {
	            forkTasks.push(this.contractsService.getContract(this.contractId));
	        }
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los datos del contrato.');
	        });
	        this.loading = false;
	    };
	    ContractEditorComponent.prototype.setData = function (data) {
	        this.banks = data[0];
	        this.states = data[1];
	        if (this.contractId) {
	            this.contract = data[data.length - 1];
	            if (!this.contract.contacts || this.contract.contacts.length == 0) {
	                this.contact = new contact_1.Contact();
	            }
	            else {
	                this.contact = this.contract.contacts[0];
	            }
	            if (!this.contract.bank) {
	                this.contract.bank = new bank_1.Bank(null);
	                this.contract.bank.id = '';
	            }
	            if (!this.contract.address) {
	                this.contract.address = new address_1.Address(null);
	                this.contract.address.street = '';
	            }
	            else if (this.contract.address.city && this.contract.address.city.state) {
	                this.contractStateSelectedId = this.contract.address.city.state.id;
	                this.contractCitySelectedId = this.contract.address.city.id;
	                this.loadCities(this.contract.address.city.state);
	            }
	            this.getVehicles(1);
	            this.contractValid = true;
	        }
	        else {
	            this.createContract();
	        }
	    };
	    ContractEditorComponent.prototype.createContract = function () {
	        this.contract = new contract_1.Contract();
	        this.contract.address.street = '';
	        this.contractStateSelectedId = null;
	        this.contractCitySelectedId = null;
	    };
	    ContractEditorComponent.prototype.updateViewAfterSave = function () {
	        if (this.createMode) {
	        }
	    };
	    ContractEditorComponent.prototype.loadCities = function (state) {
	        var _this = this;
	        if (state && state.id) {
	            this.loading = true;
	            this.citiesService.getCities(state.id)
	                .subscribe(function (data) {
	                _this.loading = false;
	                _this.cities = data;
	            }, function () {
	                _this.bindError('Ocurrió un error al cargar las ciudades.');
	            });
	        }
	    };
	    ContractEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    ContractEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    ContractEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.contract.contacts = [this.contact];
	        this.contractsService.save(this.contract).subscribe(function (saved) {
	            _this.loading = false;
	            _this.contract = saved;
	            _this.successMessage = 'El contrato se guardó con éxito';
	            _this.updateViewAfterSave();
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar la información.');
	        });
	    };
	    ContractEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.contract);
	        this.router.navigate(['app/home/']);
	        /*window.history.back();*/
	    };
	    ContractEditorComponent.prototype.clearCity = function (state) {
	        this.contract.address.city = new city_1.City(null);
	        this.contract.address.city.state = state;
	        /*this.address.city = new City(null);*/
	    };
	    ContractEditorComponent.prototype.getVehicles = function (page) {
	        var _this = this;
	        this.error = null;
	        if (this.contract.id) {
	            this.loading = true;
	            this.contractsService.getVehicles(this.contract.id, page, this.itemsPerPage)
	                .subscribe(function (data) {
	                _this.refreshVehicles(data);
	                _this.page = page;
	            }, function () {
	                _this.bindError('Ocurrió un error al obtener los vehículos.');
	            });
	        }
	    };
	    ContractEditorComponent.prototype.refreshVehicles = function (page) {
	        this.vehicles = page.content;
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    ContractEditorComponent.prototype.removeVehicle = function (deleteModal, event) {
	        var _this = this;
	        event.preventDefault();
	        this.error = null;
	        this.vehiclesService.delete(this.contract.id, this.vehicleSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeVehicleFromView(_this.vehicleSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar vehículo');
	        });
	    };
	    ContractEditorComponent.prototype.removeVehicleFromView = function (vehicle) {
	        var index = this.vehicles.indexOf(vehicle);
	        if (index > -1) {
	            this.vehicles.splice(index, 1);
	        }
	        this.vehicleSelected = null;
	    };
	    ContractEditorComponent.prototype.editVehicle = function (item, event) {
	        event.preventDefault();
	        this.router.navigate(['app/home/editVehicle', this.contract.id, item.id, true]);
	    };
	    ContractEditorComponent.prototype.createVehicle = function (event) {
	        event.preventDefault();
	        this.router.navigate(['app/home/createVehicle', this.contract.id]);
	    };
	    ContractEditorComponent.prototype.validateContract = function (event) {
	        var _this = this;
	        if (this.contract.contractNumber && (event != null || this.contract.bank.id)) {
	            if (event != null) {
	                this.contract.bank = this.banks.find(function (bank) { return bank.id == event; });
	            }
	            this.contractsService.getContractByContractNumberAndBank(this.contract.contractNumber, this.contract.bank.id)
	                .subscribe(function (contract) {
	                if (contract && contract.id) {
	                    _this.contractValid = (_this.contract.id == contract.id) ? true : false;
	                }
	                else {
	                    _this.contractValid = true;
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al validar contrato.');
	                _this.contractValid = false;
	            });
	        }
	    };
	    ContractEditorComponent.prototype.onStateSelected = function (newValue) {
	        var result = this.states.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.loadCities(result[0]);
	            this.clearCity(result[0]);
	        }
	    };
	    ContractEditorComponent.prototype.onCitySelected = function (newValue) {
	        var result = this.cities.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.contract.address.city = result[0];
	        }
	    };
	    ContractEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', contract_1.Contract)
	    ], ContractEditorComponent.prototype, "contract", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ContractEditorComponent.prototype, "close", void 0);
	    ContractEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'contract-editor',
	            template: __webpack_require__(939),
	            styles: [__webpack_require__(940)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                /*MyDatePicker,*/
	                ng2_pagination_1.PaginationControlsCmp,
	                ng2_bootstrap_1.MODAL_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService,
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS
	            ],
	            pipes: [ng2_pagination_1.PaginatePipe]
	        }), 
	        __metadata('design:paramtypes', [contracts_service_1.ContractsService, vehicles_service_1.VehiclesService, bank_service_1.BankService, cities_service_1.CitiesService, router_1.Router, router_1.ActivatedRoute, login_service_1.LoginService])
	    ], ContractEditorComponent);
	    return ContractEditorComponent;
	}());
	exports.ContractEditorComponent = ContractEditorComponent;


/***/ },
/* 939 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nuevo Contrato</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Contrato</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\"\n                  *ngIf=\"contract\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"contractNumber\">Nro. de Contrato</label>\n                        <input type=\"text\" id=\"contractNumber\"\n                               class=\"form-control\" formControlName=\"contractNumber\"\n                               [(ngModel)]=\"contract.contractNumber\"\n                               name=\"contractNumber\" [disabled]=\"!canEdit\"\n                               (change)=\"validateContract(null)\">\n                        <div *ngIf=\"!form.controls.contractNumber.valid && form.controls.contractNumber.errors.required\"\n                             class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                        <div *ngIf=\"contract.contractNumber && contract.bank.id && !contractValid\" class=\"alert-danger\">\n                            Ya existe un contrato con el n&uacute;mero\n                            <b>{{contract.contractNumber}}</b> para <b>{{contract.bank.name}}</b>.\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"bank\">Banco</label>\n                        <select class=\"form-control\" id=\"bank\"\n                                formControlName=\"bank\" [(ngModel)]=\"contract.bank.id\" name=\"bank\"\n                                [disabled]=\"!canEdit\"\n                                (change)=\"validateContract($event.target.value)\">\n                            <option *ngFor=\"let bank of banks\" value=\"{{bank.id}}\">{{bank.name}}</option>\n                        </select>\n\n                        <div *ngIf=\"!form.controls.bank.valid && form.controls.bank.errors.required\"\n                             class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"businessName\">Raz&oacute;n Social</label>\n                        <input type=\"text\" id=\"businessName\"\n                               class=\"form-control\" formControlName=\"businessName\"\n                               [(ngModel)]=\"contract.businessName\" name=\"cuit\" [disabled]=\"!canEdit\">\n\n                        <div *ngIf=\"!form.controls.businessName.valid && form.controls.businessName.errors.required\"\n                             class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"cuit\">CUIT</label>\n                        <input type=\"text\" class=\"form-control\" id=\"cuit\"\n                               formControlName=\"cuit\" [(ngModel)]=\"contract.cuit\" name=\"cuit\" [disabled]=\"!canEdit\">\n\n                        <div *ngIf=\"!form.controls.cuit.valid && form.controls.cuit.errors.required\"\n                             class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                    </div>\n                </div>\n                <fieldset>\n                    <legend>Contacto</legend>\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"contactEmail\">Email del Contacto</label>\n                            <input type=\"text\" id=\"contactEmail\"\n                                   class=\"form-control\" formControlName=\"contactEmail\"\n                                   [(ngModel)]=\"contact.email\" name=contactEmail placeholder=\"\" [disabled]=\"!canEdit\">\n\n                            <div *ngIf=\"!form.controls.contactEmail.valid && form.controls.contactEmail.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                            <div *ngIf=\"!form.controls.contactEmail.valid && form.controls.contactEmail.errors.pattern\"\n                                 class=\"alert-danger\">{{errorMessages.invalidPattern}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"contactName\">Nombre del Contacto</label>\n                            <input type=\"text\" id=\"contactName\"\n                                   class=\"form-control\" formControlName=\"contactName\"\n                                   [(ngModel)]=\"contact.name\" name=\"contactName\" placeholder=\"\"\n                                   [disabled]=\"!canEdit\">\n                            <div *ngIf=\"!form.controls.contactName.valid && form.controls.contactName.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"contactPhone\">Tel&eacute;fono del Contacto</label>\n                            <input type=\"text\" id=\"contactPhone\"\n                                   class=\"form-control\" formControlName=\"contactPhone\"\n                                   [(ngModel)]=\"contact.phone\" name=\"contactPhone\" placeholder=\"\"\n                                   [disabled]=\"!canEdit\">\n                            <div *ngIf=\"!form.controls.contactName.valid && form.controls.contactName.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                        </div>\n                    </div>\n                </fieldset>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3 has-feedback\">\n                        <label for=\"dueDate\">Fecha de Vencimiento de Contrato</label>\n                        <div class=\"input-group\">\n                            <!--<span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>-->\n                            <span class=\"input-group-addon calendar\"><img></span>\n                            <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"contract.dueDate\"\n                                   name=\"dueDate\" formControlName=\"dueDate\" id=\"dueDate\"\n                                   [disabled]=\"!canEdit\" maxlength=\"10\"/>\n                        </div>\n                        <div *ngIf=\"!form.controls.dueDate.valid && form.controls.dueDate.errors.pattern\"\n                             class=\"alert-danger\">\n                            {{errorMessages.invalidDate}}\n                        </div>\n                        <!--<my-date-picker [options]=\"myDatePickerOptions\" id=\"dueDate\"\n                                        (dateChanged)=\"contract.dueDate=$event.formatted\"\n                                        [selDate]=\"contract.dueDate\" [disabled]=\"!canEdit\"></my-date-picker>-->\n                    </div>\n                </div>\n                <fieldset>\n                    <legend>Dirección</legend>\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"street\">Calle</label>\n                            <input type=\"text\" id=\"street\"\n                                   class=\"form-control\" formControlName=\"street\"\n                                   [(ngModel)]=\"contract.address.street\" name=\"street\" placeholder=\"Calle\"\n                                   [value]=\"contract.address.street\"\n                                   [disabled]=\"!canEdit\">\n\n                            <div *ngIf=\"!form.controls.street.valid && form.controls.street.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-1\">\n                            <label for=\"number\">Altura</label>\n                            <input type=\"text\" id=\"number\"\n                                   class=\"form-control\" formControlName=\"number\"\n                                   [(ngModel)]=\"contract.address.number\" name=\"number\" placeholder=\"Altura\"\n                                   [disabled]=\"!canEdit\">\n\n                            <div *ngIf=\"!form.controls.number.valid && form.controls.number.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-1\">\n                            <label for=\"floor\">Piso</label>\n                            <input type=\"text\" id=\"floor\"\n                                   class=\"form-control\" formControlName=\"floor\"\n                                   [(ngModel)]=\"contract.address.floor\" name=\"floor\" placeholder=\"Piso\"\n                                   [disabled]=\"!canEdit\">\n\n                            <div *ngIf=\"!form.controls.floor.valid && form.controls.floor.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-1\">\n                            <label for=\"department\">Dpto.</label>\n                            <input type=\"text\" id=\"department\"\n                                   class=\"form-control\" formControlName=\"department\"\n                                   [(ngModel)]=\"contract.address.department\" name=\"department\" placeholder=\"Dpto.\"\n                                   [disabled]=\"!canEdit\">\n\n                            <div *ngIf=\"!form.controls.department.valid && form.controls.department.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"state\">Provincia</label>\n                            <select class=\"form-control\" id=\"state\" formControlName=\"state\"\n                                    [(ngModel)]=\"contractStateSelectedId\" name=\"state\"\n                                    (change)=\"onStateSelected($event.target.value)\"\n                                    [disabled]=\"!canEdit\">\n                                <option *ngFor=\"let state of states\" [value]=\"state.id\">\n                                    {{state.name | uppercase}}\n                                </option>\n                            </select>\n                            <!-- Descomentar si se necesitan inputs (typeahead) y reemplazarlos por los actuales\n                                   <input [(ngModel)]=\"stateSelected.name\" id=\"state\"\n                                   [typeahead]=\"states\"\n                                   (typeaheadOnSelect)=\"onStateSelected($event)\"\n                                   [typeaheadOptionField]=\"'name'\"\n                                   class=\"form-control\" formControlName=\"state\" [disabled]=\"!canEdit\">-->\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"city\">Ciudad</label>\n                            <select class=\"form-control\" id=\"city\" formControlName=\"city\"\n                                    [(ngModel)]=\"contractCitySelectedId\" name=\"city\"\n                                    (change)=\"onCitySelected($event.target.value)\" [disabled]=\"!canEdit\">\n                                <option *ngFor=\"let city of cities\" [value]=\"city.id\">\n                                    {{city.name | uppercase}}\n                                </option>\n                            </select>\n                            <!-- Descomentar si se necesitan inputs (typeahead) y reemplazarlos por los actuales\n                                   <input [(ngModel)]=\"address.city.name\" id=\"city\"\n                                   [typeahead]=\"cities\"\n                                   (typeaheadOnSelect)=\"onCitySelected($event)\"\n                                   [typeaheadOptionField]=\"'name'\"\n                                   class=\"form-control\" formControlName=\"city\" [disabled]=\"!canEdit\">-->\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"zipCode\">C&oacute;digo Postal</label>\n                            <input type=\"text\" id=\"zipCode\"\n                                   class=\"form-control\" formControlName=\"zipCode\"\n                                   [(ngModel)]=\"contract.address.zipCode\" name=\"zipCode\" [disabled]=\"!canEdit\">\n\n                            <div *ngIf=\"!form.controls.zipCode.valid && form.controls.zipCode.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"phone\">Tel&eacute;fono</label>\n                            <input type=\"text\" id=\"phone\"\n                                   class=\"form-control\" formControlName=\"phone\"\n                                   [(ngModel)]=\"contract.phone\" name=\"phone\" [disabled]=\"!canEdit\">\n\n                            <div *ngIf=\"!form.controls.phone.valid && form.controls.phone.errors.required\"\n                                 class=\"alert-danger\">{{errorMessages.required}}\n                            </div>\n                        </div>\n                    </div>\n                </fieldset>\n                <div *ngIf=\"contract.id\">\n                    <h4>Dominios</h4>\n                    <div class=\"panel panel-default\">\n                        <table class=\"table table-striped\">\n                            <thead>\n                            <tr>\n                                <th style=\"width: 10%\"></th>\n                                <th style=\"width: 10%\">\n                                    Patente\n                                </th>\n                                <th style=\"width: 10%\">\n                                    Tipo\n                                </th>\n                                <th style=\"width: 10%\">\n                                    Marca\n                                </th>\n                                <th style=\"width: 10%\">\n                                    Modelo\n                                </th>\n                                <th style=\"width: 10%\">\n                                    A&ntilde;o\n                                </th>\n                                <th style=\"width: 10%\">\n                                    Acciones\n                                </th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr *ngFor=\"let item of vehicles | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                                <td>\n                                    <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"editVehicle(item,$event)\"\n                                            *ngIf=\"canEditVehicle\">\n                                        <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                                        <span class=\"pencil\"><img></span>\n                                    </button>\n                                    <button class=\"btn btn-primary\" title=\"Ver\" (click)=\"editVehicle(item,$event)\"\n                                            *ngIf=\"!canEditVehicle && canViewVehicle\">\n                                        <!--<span class=\"glyphicon glyphicon-eye-open\"></span>-->\n                                        <span class=\"eye-open\"><img></span>\n                                    </button>\n                                </td>\n                                <td>{{item.patent}}</td>\n                                <td>{{item.type.description}}</td>\n                                <td>{{item.brand.name}}</td>\n                                <td>{{item.model}}</td>\n                                <td>{{item.year}}</td>\n                                <td>\n                                    <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                            (click)=\"vehicleSelected=item;deleteModal.show();\" *ngIf=\"canDeleteVehicle\">\n                                        <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                                        <span class=\"remove\"><img></span>\n                                    </button>\n                                </td>\n                            </tr>\n                            </tbody>\n                            <tfoot>\n                            <tr>\n                                <td colspan=\"10\">\n                                    <pagination-controls (pageChange)=\"getVehicles($event)\" id=\"server\">\n                                    </pagination-controls>\n                                </td>\n                            </tr>\n                            </tfoot>\n                        </table>\n                        <div class=\"form-group form-group-sm\">\n                            <button type=\"button\" class=\"btn btn-primary\" (click)=\"createVehicle($event)\"\n                                    *ngIf=\"canEditVehicle\">\n                                <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n                                <span class=\"plus\"><img></span>\n                                 Nuevo Veh&iacute;culo\n                            </button>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-md-12\">\n                    <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                    <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\n                </div>\n                <div class=\"col-sm-12\">\n                    <button type=\"submit\" class=\"btn btn-success\"\n                            [disabled]=\"!form.valid || loading || !contractValid\" *ngIf=\"canEdit\">Guardar\n                    </button>\n                    <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                </div>\n            </form>\n        </div>\n    </div>\n\n    <div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n         aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog modal-sm\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                        <span aria-hidden=\"true\">&times;</span>\n                    </button>\n                    <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n                </div>\n                <div class=\"modal-body\">\n                    &iquest;Est&aacute; seguro que desea eliminar el veh&iacute;culo\n                    <strong>{{vehicleSelected?.patent}}</strong>?\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n                            (click)=\"removeVehicle(deleteModal,$event)\">Aceptar\n                    </button>\n                    <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\" (click)=\"deleteModal.hide()\">\n                        Cancelar\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 940 */
/***/ function(module, exports) {

	module.exports = ""

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var Observable_1 = __webpack_require__(34);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_file_upload_1 = __webpack_require__(889);
	var infractions_service_1 = __webpack_require__(634);
	var cities_service_1 = __webpack_require__(633);
	var vehicles_service_1 = __webpack_require__(630);
	var infraction_1 = __webpack_require__(902);
	var address_1 = __webpack_require__(876);
	var state_1 = __webpack_require__(878);
	var city_1 = __webpack_require__(877);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var InfractionEditorComponent = (function () {
	    function InfractionEditorComponent(infractionsService, citiesService, vehiclesService, route, loginService) {
	        this.infractionsService = infractionsService;
	        this.citiesService = citiesService;
	        this.vehiclesService = vehiclesService;
	        this.route = route;
	        this.loginService = loginService;
	        this.close = new core_1.EventEmitter();
	        this.patentValid = false;
	        this.init();
	    }
	    InfractionEditorComponent.prototype.init = function () {
	        this.date = new Date();
	        this.infraction = new infraction_1.Infraction();
	        //this.infraction.withSendMail = true;
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.stateSelected = new state_1.State();
	        this.regulators = [];
	        this.loading = false;
	        this.uploaderAct = new ng2_file_upload_1.FileUploader({});
	        this.uploaderActPayReceipt = new ng2_file_upload_1.FileUploader({});
	        this.uploaderDischarge = new ng2_file_upload_1.FileUploader({});
	        this.hasActDropZoneOver = false;
	        this.hasActPayReceiptDropZoneOver = false;
	        this.hasDischargeDropZoneOver = false;
	        this.canEdit = false;
	        this.infraction.withSendMail = true;
	        this.isUploading = false;
	        this.actNumberValid = false;
	        this.oldActNumber = null;
	        this.oldInfractionStateSelectedId = null;
	    };
	    InfractionEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            actNumber: new forms_1.FormControl(this.infraction.actNumber, [forms_1.Validators.required]),
	            type: new forms_1.FormControl(this.infraction.infractionType, [forms_1.Validators.required]),
	            patent: new forms_1.FormControl(this.infraction.vehicle.patent, [forms_1.Validators.required]),
	            infractionDate: new forms_1.FormControl(this.infraction.infractionDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            infractionAmount: new forms_1.FormControl(this.infraction.infractionAmount, [forms_1.Validators.required, validators_1.AMOUNT_VALIDATOR]),
	            street: new forms_1.FormControl(this.infraction.address.street),
	            number: new forms_1.FormControl(this.infraction.address.number),
	            floor: new forms_1.FormControl(this.infraction.address.floor),
	            department: new forms_1.FormControl(this.infraction.address.department),
	            zipCode: new forms_1.FormControl(this.infraction.address.zipCode, [validators_1.INTEGER_VALIDATOR]),
	            city: new forms_1.FormControl(this.infraction.address.city.name, [forms_1.Validators.required]),
	            state: new forms_1.FormControl(this.infraction.address.city.state.name, [forms_1.Validators.required]),
	            regulator: new forms_1.FormControl(this.infraction.regulator),
	            batch: new forms_1.FormControl(this.infraction.batch, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            infractionState: new forms_1.FormControl(this.infraction.state),
	            amountPaid: new forms_1.FormControl(this.infraction.amountPaid, [validators_1.AMOUNT_VALIDATOR]),
	            paymentDate: new forms_1.FormControl(this.infraction.paymentDate, [validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            comments: new forms_1.FormControl(this.infraction.comments),
	            withSendMail: new forms_1.FormControl(this.infraction.withSendMail)
	        });
	    };
	    InfractionEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var userLogged = this.loginService.getUserLogged();
	        this.canEdit = userLogged.isActionAllowed('INFRACTIONS', 'EDIT', 'INFRACTIONS');
	        /*this.myDatePickerOptions = {
	         dateFormat: 'dd/mm/yyyy',
	         /!*Descomentar para obtener un clone de un input de tipo 'date'*!/
	         /!*inline: false,
	         indicateInvalidDate: true*!/
	         };*/
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var infractionId = params['infractionId'];
	            if (infractionId) {
	                _this.infractionId = infractionId;
	                _this.createMode = false;
	            }
	            else {
	                _this.createMode = true;
	                _this.infractionId = null;
	            }
	            _this.getData();
	        });
	    };
	    InfractionEditorComponent.prototype.ngAfterViewInit = function () {
	    };
	    InfractionEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        var forkTasks = [];
	        forkTasks.push(this.infractionsService.getInfractionTypes());
	        forkTasks.push(this.infractionsService.getInfractionStates());
	        forkTasks.push(this.citiesService.getStates());
	        if (this.infractionId) {
	            forkTasks.push(this.infractionsService.getInfraction(this.infractionId));
	        }
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los datos de infraccion.');
	        });
	    };
	    InfractionEditorComponent.prototype.createInfraction = function () {
	        var _this = this;
	        this.infraction = new infraction_1.Infraction();
	        this.stateSelected = new state_1.State();
	        this.patentValid = false;
	        this.infractionTypeSelectedId = null;
	        this.infractionStateSelectedId = null;
	        this.infractionStateAddressSelectedId = null;
	        this.infractionCitySelectedId = null;
	        if (this.infractionsType.length > 0) {
	            this.infraction.infractionType = this.infractionsType[0];
	            this.infractionTypeSelectedId = this.infraction.infractionType.id;
	        }
	        if (this.infractionsState.length > 0) {
	            this.infraction.state = this.infractionsState[5];
	            this.infractionStateSelectedId = this.infraction.state.id;
	        }
	        this.infractionsService.generateInfractionTempId()
	            .subscribe(function (response) {
	            _this.infraction.tempId = response.value;
	            _this.updateUploadersUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al crear infraccion.');
	        });
	        //this.infraction.withSendMail = true;
	    };
	    InfractionEditorComponent.prototype.setData = function (data) {
	        this.loading = false;
	        this.infractionsType = data[0];
	        this.infractionsState = data[1];
	        this.states = data[2];
	        if (this.infractionId) {
	            this.infraction = data[data.length - 1];
	            this.infraction.tempId = this.infraction.id;
	            this.patentValid = true;
	            if (!this.infraction.address) {
	                this.infraction.address = new address_1.Address(null);
	            }
	            else if (this.infraction.address.city && this.infraction.address.city.state) {
	                this.infractionStateAddressSelectedId = this.infraction.address.city.state.id;
	                this.infractionCitySelectedId = this.infraction.address.city.id;
	                this.loadCities(this.infraction.address.city.state);
	            }
	            if (this.infraction.infractionType) {
	                this.infractionTypeSelectedId = this.infraction.infractionType.id;
	            }
	            if (this.infraction.state) {
	                this.infractionStateSelectedId = this.infraction.state.id;
	            }
	            this.oldInfractionStateSelectedId = this.infractionStateAddressSelectedId;
	            this.oldActNumber = this.infraction.actNumber;
	            //this.infraction.withSendMail = false;
	            this.updateUploadersUrl();
	        }
	        else {
	            this.createInfraction();
	        }
	        if (!this.infraction.state) {
	            this.infraction.state = this.infractionsState[0];
	        }
	        this.validateActNumber();
	    };
	    InfractionEditorComponent.prototype.updateUploadersUrl = function () {
	        var fileOwnerId = this.infraction.tempId;
	        this.uploaderAct = new ng2_file_upload_1.FileUploader({
	            url: 'infraction/' + fileOwnerId + '/upload/ACT',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.uploaderActPayReceipt = new ng2_file_upload_1.FileUploader({
	            url: 'infraction/' + fileOwnerId + '/upload/ACT_PAY_RECEIPT',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.uploaderDischarge = new ng2_file_upload_1.FileUploader({
	            url: 'infraction/' + fileOwnerId + '/upload/ACT_DISCHARGE',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	    };
	    InfractionEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    InfractionEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    InfractionEditorComponent.prototype.isUploadingAFile = function () {
	        this.isUploading = false;
	        if (this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderAct.queue && this.uploaderAct.queue.length == 0) {
	            this.isUploading = true;
	        }
	        if (this.inputActPay && this.inputActPay.nativeElement && this.inputActPay.nativeElement.value != '' && this.uploaderActPayReceipt.queue && this.uploaderActPayReceipt.queue.length == 0) {
	            this.isUploading = true;
	        }
	        if (this.inputDischarge && this.inputDischarge.nativeElement && this.inputDischarge.nativeElement.value != '' && this.uploaderDischarge.queue && this.uploaderDischarge.queue.length == 0) {
	            this.isUploading = true;
	        }
	        if (this.uploaderAct.isUploading || this.uploaderActPayReceipt.isUploading || this.uploaderDischarge.isUploading) {
	            this.isUploading = true;
	        }
	    };
	    InfractionEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.isUploadingAFile();
	        if (!this.checkAllBeforeSave()) {
	            this.loading = true;
	            if (!this.infraction.withSendMail) {
	                this.infraction.withSendMail = false;
	            }
	            if (!this.infraction.address.city || !this.infraction.address.city.id) {
	                this.infraction.address.city.id = this.infractionCitySelectedId;
	            }
	            this.infractionsService.save(this.infraction).subscribe(function (saved) {
	                _this.loading = false;
	                _this.infraction = saved;
	                _this.successMessage = 'La infracción se guardó con éxito';
	                _this.updateViewAfterSave();
	            }, function (error) {
	                console.log(error);
	                if (error.status == 501) {
	                    _this.bindError('La infracción se guardó con éxito, pero falló al enviar mail.');
	                }
	                else if (error.status == 500) {
	                    if (error._body) {
	                        _this.bindError(error._body);
	                    }
	                    else {
	                        _this.bindError('Ocurrió un error al guardar la información.');
	                    }
	                }
	            });
	        }
	        else {
	            this.bindError('Hay archivos pendientes. Recuerde que el tamaño máximo del archivo a subir es de 10Mb.');
	        }
	    };
	    InfractionEditorComponent.prototype.checkAllBeforeSave = function () {
	        return this.isUploading || !this.form.valid || this.loading || !this.patentValid || !this.actNumberValid || !this.infraction.infractionDate ||
	            this.uploaderActPayReceipt.isUploading || this.uploaderAct.isUploading || this.uploaderDischarge.isUploading ||
	            !this.infractionStateAddressSelectedId || !this.infractionCitySelectedId;
	    };
	    InfractionEditorComponent.prototype.updateViewAfterSave = function () {
	        this.uploaderAct.clearQueue();
	        this.uploaderActPayReceipt.clearQueue();
	        this.uploaderDischarge.clearQueue();
	        if (this.createMode) {
	            this.createInfraction();
	        }
	        else {
	            this.infraction.tempId = this.infraction.id;
	        }
	    };
	    InfractionEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.infraction);
	        window.history.back();
	    };
	    InfractionEditorComponent.prototype.loadCities = function (state) {
	        var _this = this;
	        this.loading = true;
	        this.citiesService.getCities(state.id).subscribe(function (data) {
	            _this.loading = false;
	            _this.cities = data;
	            // Si no hay una seleccionada, o el array no incluye la seleccionada: selecciono la primera de la lista
	            if (!_this.infractionCitySelectedId || !data.some(function (city) { return city.id === _this.infractionCitySelectedId; })) {
	                _this.infractionCitySelectedId = data[0].id;
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al cargar las ciudades.');
	        });
	    };
	    InfractionEditorComponent.prototype.clearCity = function (state) {
	        this.infraction.address.city = new city_1.City(null);
	        this.infraction.address.city.state = state;
	    };
	    InfractionEditorComponent.prototype.onRegulatorSelected = function (regulator) {
	        this.infraction.regulator = regulator.item;
	    };
	    InfractionEditorComponent.prototype.fileOverAct = function (e) {
	        this.hasActDropZoneOver = e;
	    };
	    InfractionEditorComponent.prototype.fileOverActPayReceipt = function (e) {
	        this.hasActPayReceiptDropZoneOver = e;
	    };
	    InfractionEditorComponent.prototype.fileDischargeDischarge = function (e) {
	        this.hasDischargeDropZoneOver = e;
	    };
	    InfractionEditorComponent.prototype.removeAct = function () {
	        this.infraction.act = null;
	    };
	    InfractionEditorComponent.prototype.removeActPayReceipt = function () {
	        this.infraction.actPayReceipt = null;
	    };
	    InfractionEditorComponent.prototype.removeDischarge = function () {
	        this.infraction.discharge = null;
	    };
	    InfractionEditorComponent.prototype.removeActFromQuee = function (item) {
	        var _this = this;
	        this.infractionsService.deleteTempInfractionDocument(this.infraction.tempId, 'ACT').subscribe(function (result) { return item.remove(); }, function () {
	            _this.bindError('Ocurrió un error al eliminar acta de infraccion.');
	        });
	    };
	    InfractionEditorComponent.prototype.removeActPayReceiptFromQuee = function (item) {
	        var _this = this;
	        this.infractionsService.deleteTempInfractionDocument(this.infraction.tempId, 'ACT_PAY_RECEIPT').subscribe(function (result) { return item.remove(); }, function () {
	            _this.bindError('Ocurrió un error al eliminar comprobante de pago de infraccion.');
	        });
	    };
	    InfractionEditorComponent.prototype.removeDischargeFromQuee = function (item) {
	        var _this = this;
	        this.infractionsService.deleteTempInfractionDocument(this.infraction.tempId, 'ACT_DISCHARGE').subscribe(function (result) { return item.remove(); }, function () {
	            _this.bindError('Ocurrió un error al eliminar descargo de infraccion.');
	        });
	    };
	    InfractionEditorComponent.prototype.validatePatent = function () {
	        var _this = this;
	        this.vehiclesService.getVehicleByPatent(this.infraction.vehicle.patent).subscribe(function (vehicle) {
	            if (vehicle && vehicle.id) {
	                _this.infraction.vehicle = vehicle;
	                _this.patentValid = true;
	            }
	            else {
	                _this.infraction.vehicle.id = null;
	                _this.patentValid = false;
	            }
	        }, function () {
	            _this.infraction.vehicle.id = null;
	            _this.patentValid = false;
	            _this.bindError('Ocurrió un error al validar patente de vehículo.');
	        });
	    };
	    InfractionEditorComponent.prototype.infractionStateChange = function (newValue) {
	        var result = this.infractionsState.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.infraction.state = result[0];
	        }
	    };
	    InfractionEditorComponent.prototype.onStateSelected = function (newValue) {
	        var result = this.states.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.loadCities(result[0]);
	            this.clearCity(result[0]);
	        }
	        this.validateActNumber();
	    };
	    InfractionEditorComponent.prototype.onCitySelected = function (newValue) {
	        var result = this.cities.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.infraction.address.city = result[0];
	        }
	    };
	    InfractionEditorComponent.prototype.validateActNumber = function () {
	        var _this = this;
	        if (this.checkOldValues()) {
	            if (this.infraction.actNumber && this.infraction.address && this.infraction.address.city && this.infraction.address.city.state &&
	                this.infraction.address.city.state.id) {
	                this.infractionsService.getInfractionByActNumberAndState(this.infraction.actNumber, this.infraction.address.city.state.id).subscribe(function (infraction) {
	                    _this.actNumberValid = !(infraction && infraction.id);
	                }, function () {
	                    _this.actNumberValid = false;
	                    _this.bindError('Ocurrió un error al validar la infracción.');
	                });
	            }
	        }
	        else {
	            this.actNumberValid = true;
	        }
	    };
	    InfractionEditorComponent.prototype.checkOldValues = function () {
	        if (!this.oldInfractionStateSelectedId || !this.oldActNumber) {
	            return true;
	        }
	        return !(this.infractionStateAddressSelectedId == this.oldInfractionStateSelectedId && this.infraction.actNumber == this.oldActNumber);
	    };
	    InfractionEditorComponent.prototype.infractionTypeChange = function (newValue) {
	        var result = this.infractionsType.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.infraction.infractionType = result[0];
	        }
	    };
	    InfractionEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', infraction_1.Infraction)
	    ], InfractionEditorComponent.prototype, "infraction", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], InfractionEditorComponent.prototype, "close", void 0);
	    __decorate([
	        core_1.ViewChild('inputAct'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionEditorComponent.prototype, "inputAct", void 0);
	    __decorate([
	        core_1.ViewChild('inputActPay'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionEditorComponent.prototype, "inputActPay", void 0);
	    __decorate([
	        core_1.ViewChild('inputDischarge'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], InfractionEditorComponent.prototype, "inputDischarge", void 0);
	    InfractionEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'infraction-editor',
	            template: __webpack_require__(942),
	            styles: [__webpack_require__(943)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                /*MyDatePicker,*/
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES,
	                router_1.ROUTER_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	        }), 
	        __metadata('design:paramtypes', [infractions_service_1.InfractionsService, cities_service_1.CitiesService, vehicles_service_1.VehiclesService, router_1.ActivatedRoute, login_service_1.LoginService])
	    ], InfractionEditorComponent);
	    return InfractionEditorComponent;
	}());
	exports.InfractionEditorComponent = InfractionEditorComponent;


/***/ },
/* 942 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nueva Infracci&oacute;n</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Infracci&oacute;n</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"infraction\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div class=\"col-md-12\">\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-md-4\">\n                            <label for=\"actNumber\">Nro. de Acta</label>\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"infraction.actNumber\" name=\"actNumber\"\n                                   formControlName=\"actNumber\" id=\"actNumber\" (change)=\"validateActNumber()\"\n                                   [value]=\"(infraction.actNumber)?(infraction.actNumber | uppercase):''\"\n                                   [disabled]=\"!canEdit\"/>\n                            <div *ngIf=\"!form.controls.actNumber.valid && form.controls.actNumber.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                            <div *ngIf=\"infraction.actNumber && infraction.address && infraction.address.city &&\n                                infraction.address.city.state && infraction.address.city.state.id && !actNumberValid\"\n                                 class=\"alert-danger\">\n                                Ya existe una infracción con el nro de acta y provincia ingresada.\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-4\">\n                            <label for=\"type\">Tipo</label>\n                            <select class=\"form-control\" formControlName=\"type\" [(ngModel)]=\"infractionTypeSelectedId\"\n                                    name=\"type\" id=\"type\"\n                                    (change)=\"infractionTypeChange($event.target.value)\" [disabled]=\"!canEdit\">\n                                <option *ngFor=\"let type of infractionsType\" [value]=\"type.id\">\n                                    {{type.name | uppercase}}\n                                </option>\n                            </select>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-4\">\n                            <label for=\"patent\">Patente</label>\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"infraction.vehicle.patent\"\n                                   name=\"patent\" formControlName=\"patent\" id=\"patent\"\n                                   [value]=\"(infraction.vehicle && infraction.vehicle.patent)?(infraction.vehicle.patent | uppercase):''\"\n                                   (change)=\"validatePatent()\" [disabled]=\"!canEdit\"/>\n                            <div *ngIf=\"!form.controls.patent.valid && form.controls.patent.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                            <div *ngIf=\"!form.controls.patent.valid && form.controls.patent.errors.validatePatentWithType\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidPattern}}\n                            </div>\n                            <div *ngIf=\"infraction.vehicle.patent && !patentValid\" class=\"alert-danger\">\n                                El veh&iacute;culo con la patente <b>{{infraction.vehicle.patent}}</b>\n                                no est&aacute; registrado en el sistema. Puede crearlo desde\n                                <a routerLink=\"/app/home/createVehicle\" routerLinkActive=\"active\">Aqu&iacute;</a>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-md-4 has-feedback\">\n                            <label for=\"infractionDate\">Fecha Infracci&oacute;n</label>\n                            <div class=\"input-group\">\n                                <!--<span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>-->\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\"\n                                       [(ngModel)]=\"infraction.infractionDate\"\n                                       name=\"infractionDate\" formControlName=\"infractionDate\" id=\"infractionDate\"\n                                       [disabled]=\"!canEdit\" maxlength=\"10\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.infractionDate.valid && form.controls.infractionDate.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                            <div *ngIf=\"!form.controls.infractionDate.valid && form.controls.infractionDate.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <!--<div>\n                                <my-date-picker [options]=\"myDatePickerOptions\"\n                                                (dateChanged)=\"infraction.infractionDate=$event.formatted\"\n                                                [selDate]=\"infraction.infractionDate\"\n                                                [disabled]=\"!canEdit\"></my-date-picker>\n                            </div>\n                            <div class=\"row alert alert-danger\" *ngIf=\"!infraction.infractionDate\"\n                                 style=\"padding: initial; margin: initial; border: none;\">\n                                {{errorMessages.required}}\n                            </div>-->\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-4\">\n                            <label for=\"infractionAmount\">Monto Infracci&oacute;n</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon\">\n                                    <i class=\"fa fa-usd\" aria-hidden=\"true\"></i>\n                                </span>\n                                <input type=\"text\" class=\"form-control\" formControlName=\"infractionAmount\"\n                                       [(ngModel)]=\"infraction.infractionAmount\" name=\"infractionAmount\"\n                                       id=\"infractionAmount\" placeholder=\"0.00\"\n                                       [disabled]=\"!canEdit\">\n                            </div>\n                            <div *ngIf=\"!form.controls.infractionAmount.valid && form.controls.infractionAmount.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                            <div *ngIf=\"!form.controls.infractionAmount.valid && form.controls.infractionAmount.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidAmount}}\n                            </div>\n                        </div>\n                    </div>\n                    <fieldset>\n                        <legend>Dirección</legend>\n                        <div class=\"row\">\n                            <div class=\"form-group form-group-sm col-md-4\">\n                                <label for=\"street\">Calle</label>\n                                <input type=\"text\" class=\"form-control\" formControlName=\"street\" id=\"street\"\n                                       [(ngModel)]=\"infraction.address.street\" name=\"street\" placeholder=\"Calle\"\n                                       [value]=\"(infraction.address.street)?(infraction.address.street | uppercase):''\"\n                                       [disabled]=\"!canEdit\">\n                            </div>\n                            <div class=\"form-group form-group-sm col-md-2\">\n                                <label for=\"number\">Altura</label>\n                                <input type=\"text\" class=\"form-control\" formControlName=\"number\" id=\"number\"\n                                       [(ngModel)]=\"infraction.address.number\" name=\"number\" placeholder=\"Altura\"\n                                       [value]=\"(infraction.address.number)?(infraction.address.number | uppercase):''\"\n                                       [disabled]=\"!canEdit\">\n                            </div>\n                            <div class=\"form-group form-group-sm col-sm-1\">\n                                <label for=\"floor\">Piso</label>\n                                <input type=\"text\" class=\"form-control\" formControlName=\"floor\" id=\"floor\"\n                                       [(ngModel)]=\"infraction.address.floor\" name=\"floor\" placeholder=\"Piso\"\n                                       [value]=\"(infraction.address.floor)?(infraction.address.floor | uppercase):''\"\n                                       [disabled]=\"!canEdit\">\n                            </div>\n                            <div class=\"form-group form-group-sm col-sm-1\">\n                                <label for=\"department\">Dpto.</label>\n                                <input type=\"text\" class=\"form-control\" formControlName=\"department\" id=\"department\"\n                                       [(ngModel)]=\"infraction.address.department\" name=\"department\" placeholder=\"Dpto.\"\n                                       [value]=\"(infraction.address.department)?(infraction.address.department | uppercase):''\"\n                                       [disabled]=\"!canEdit\">\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"form-group form-group-sm col-sm-4\">\n                                <label for=\"zipCode\">C&oacute;digo Postal</label>\n                                <input type=\"text\" class=\"form-control\" formControlName=\"zipCode\" id=\"zipCode\"\n                                       [(ngModel)]=\"infraction.address.zipCode\" name=\"zipCode\"\n                                       [value]=\"(infraction.address.zipCode)?(infraction.address.zipCode | uppercase):''\"\n                                       [disabled]=\"!canEdit\">\n                            </div>\n                            <div class=\"form-group form-group-sm col-md-4\">\n                                <label for=\"state\">Provincia</label>\n                                <select class=\"form-control\" id=\"state\" formControlName=\"state\"\n                                        [(ngModel)]=\"infractionStateAddressSelectedId\" name=\"state\"\n                                        (change)=\"onStateSelected($event.target.value)\"\n                                        [disabled]=\"!canEdit\">\n                                    <option *ngFor=\"let state of states\" [value]=\"state.id\">\n                                        {{state.name | uppercase}}\n                                    </option>\n                                </select>\n                                <div *ngIf=\"!form.controls.state.valid && form.controls.state.errors.required\"\n                                     class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                                <div *ngIf=\"infraction.actNumber && infraction.address && infraction.address.city &&\n                                infraction.address.city.state && infraction.address.city.state.id && !actNumberValid\"\n                                     class=\"alert-danger\">\n                                    Ya existe una infracción con el nro de acta y provincia ingresada.\n                                </div>\n                                <!-- Descomentar si se necesitan inputs (typeahead) y reemplazarlos por los actuales\n                                       <input [(ngModel)]=\"stateSelected.name\"\n                                       [value]=\"(stateSelected && stateSelected.name)?(stateSelected.name | uppercase):''\"\n                                       [typeahead]=\"states\"\n                                       (typeaheadOnSelect)=\"onStateSelected($event)\"\n                                       [typeaheadOptionField]=\"'name'\"\n                                       class=\"form-control\" formControlName=\"state\" [disabled]=\"!canEdit\">-->\n                            </div>\n                            <div class=\"form-group form-group-sm col-md-4\">\n                                <label for=\"city\">Localidad</label>\n                                <select class=\"form-control\" id=\"city\" formControlName=\"city\"\n                                        [(ngModel)]=\"infractionCitySelectedId\" name=\"city\"\n                                        (change)=\"onCitySelected($event.target.value)\" [disabled]=\"!canEdit\">\n                                    <option *ngFor=\"let city of cities\" [value]=\"city.id\">\n                                        {{city.name | uppercase}}\n                                    </option>\n                                </select>\n                                <div *ngIf=\"!form.controls.city.valid && form.controls.city.errors.required\"\n                                     class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                                <!-- Descomentar si se necesitan inputs (typeahead) y reemplazarlos por los actuales\n                                       <input [(ngModel)]=\"address.city.name\"\n                                       [typeahead]=\"cities\"\n                                       (typeaheadOnSelect)=\"onCitySelected($event)\"\n                                       [typeaheadOptionField]=\"'name'\"\n                                       class=\"form-control\" formControlName=\"city\" [disabled]=\"!canEdit\">-->\n                            </div>\n                        </div>\n                    </fieldset>\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-md-4\" *ngIf=\"false\">\n                            <label for=\"regulatorName\">Ente Regulador</label>\n                            <input [(ngModel)]=\"regulatorName\" id=\"regulatorName\"\n                                   [typeahead]=\"regulators\"\n                                   (typeaheadOnSelect)=\"onRegulatorSelected($event)\"\n                                   [typeaheadOptionField]=\"'name'\"\n                                   class=\"form-control\" formControlName=\"regulator\" [disabled]=\"!canEdit\">\n                            <div *ngIf=\"!form.controls.regulator.valid && form.controls.regulator.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-4 has-feedback\">\n                            <label for=\"batch\">Lote</label>\n                            <div class=\"input-group\">\n                                <!--<span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>-->\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"infraction.batch\"\n                                       name=\"batch\" formControlName=\"batch\" id=\"batch\"\n                                       [disabled]=\"!canEdit\" maxlength=\"10\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.batch.valid && form.controls.batch.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <!--<div>\n                                <my-date-picker [options]=\"myDatePickerOptions\"\n                                                (dateChanged)=\"infraction.batch=$event.formatted\"\n                                                [selDate]=\"infraction.batch\" [disabled]=\"!canEdit\"></my-date-picker>\n                            </div>\n                            <div *ngIf=\"!form.controls.batch.valid && form.controls.batch.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>-->\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-md-4\">\n                            <label for=\"infractionState\">Estado</label>\n                            <select class=\"form-control\" formControlName=\"infractionState\" id=\"infractionState\"\n                                    [(ngModel)]=\"infractionStateSelectedId\" name=\"infractionState\"\n                                    (change)=\"infractionStateChange($event.target.value)\" [disabled]=\"!canEdit\">\n                                <option *ngFor=\"let state of infractionsState\" [value]=\"state.id\">\n                                    {{state.description}}\n                                </option>\n                            </select>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-4\">\n                            <label for=\"amountPaid\">Monto Abonado</label>\n                            <div class=\"input-group\">\n                                <span class=\"input-group-addon\">\n                                    <i class=\"fa fa-usd\" aria-hidden=\"true\"></i>\n                                </span>\n                                <input type=\"text\" class=\"form-control\" formControlName=\"amountPaid\"\n                                       id=\"amountPaid\" [(ngModel)]=\"infraction.amountPaid\" name=\"amountPaid\"\n                                       [disabled]=\"!canEdit\" placeholder=\"0.00\">\n                            </div>\n                            <div *ngIf=\"!form.controls.amountPaid.valid && form.controls.amountPaid.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                            <div *ngIf=\"!form.controls.amountPaid.valid && form.controls.amountPaid.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidAmount}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-4 has-feedback\">\n                            <label for=\"paymentDate\">Fecha de Abono</label>\n                            <div class=\"input-group\">\n                                <!--<span class=\"input-group-addon\"><i class=\"fa fa-calendar\"></i></span>-->\n                                <span class=\"input-group-addon calendar\"><img></span>\n                                <input type=\"text\" class=\"form-control date-picker\" [(ngModel)]=\"infraction.paymentDate\"\n                                       name=\"paymentDate\" formControlName=\"paymentDate\" id=\"paymentDate\"\n                                       [disabled]=\"!canEdit\" maxlength=\"10\"/>\n                            </div>\n                            <div *ngIf=\"!form.controls.paymentDate.valid && form.controls.paymentDate.errors.pattern\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.invalidDate}}\n                            </div>\n                            <!--<div>\n                                <my-date-picker [options]=\"myDatePickerOptions\"\n                                                (dateChanged)=\"infraction.paymentDate=$event.formatted\"\n                                                [selDate]=\"infraction.paymentDate\"\n                                                [disabled]=\"!canEdit\">\n                                </my-date-picker>\n                            </div>-->\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\">\n                            <h3>Acta</h3>\n                            <div *ngIf=\"infraction.act\">\n                                <a href=\"/infraction/{{infraction.id}}/download/ACT\" target=\"file\">\n                                    <!--<span class=\"glyphicon glyphicon-paperclip\"></span>-->\n                                    <span class=\"paperclip\"><img></span>\n                                    {{infraction.act.name}}\n                                </a>\n                                <button type=\"button\" class=\"btn btn-danger btn-xs\" (click)=\"removeAct()\"\n                                        *ngIf=\"canEdit\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span>\n                                    Eliminar\n                                </button>\n                            </div>\n                            <div *ngIf=\"canEdit && (!infraction.act && uploaderAct.queue.length == 0)\">\n                                <div ng2FileDrop\n                                     [ngClass]=\"{'nv-file-over': hasActDropZoneOver}\"\n                                     (fileOver)=\"fileOverAct($event)\"\n                                     [uploader]=\"uploaderAct\"\n                                     class=\"well my-drop-zone\">\n                                    Arrastre el archivo aqu&iacute;\n                                </div>\n                                <input type=\"file\" ng2FileSelect [uploader]=\"uploaderAct\" #inputAct/>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <h3>Comprobante de Pago</h3>\n                            <div *ngIf=\"infraction.actPayReceipt\">\n                                <a href=\"/infraction/{{infraction.id}}/download/ACT_PAY_RECEIPT\" target=\"file\">\n                                    <!--<span class=\"glyphicon glyphicon-paperclip\"></span>-->\n                                    <span class=\"paperclip\"><img></span>\n                                    {{infraction.actPayReceipt.name}}\n                                </a>\n                                <button type=\"button\" class=\"btn btn-danger btn-xs\" (click)=\"removeActPayReceipt()\"\n                                        *ngIf=\"canEdit\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span>\n                                    Eliminar\n                                </button>\n                            </div>\n                            <div *ngIf=\"canEdit && (!infraction.actPayReceipt && uploaderActPayReceipt.queue?.length == 0)\">\n                                <div ng2FileDrop\n                                     [ngClass]=\"{'nv-file-over': hasActPayReceiptDropZoneOver}\"\n                                     (fileOver)=\"fileOverActPayReceipt($event)\"\n                                     [uploader]=\"uploaderActPayReceipt\"\n                                     class=\"well my-drop-zone\">\n                                    Arrastre el archivo aqu&iacute;\n                                </div>\n                                <input type=\"file\" ng2FileSelect [uploader]=\"uploaderActPayReceipt\" #inputActPay/>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <h3>Descargo</h3>\n                            <div *ngIf=\"infraction.discharge\">\n                                <a href=\"/infraction/{{infraction.id}}/download/ACT_DISCHARGE\" target=\"file\">\n                                    <!--<span class=\"glyphicon glyphicon-paperclip\"></span>-->\n                                    <span class=\"paperclip\"><img></span>\n                                    {{infraction.discharge.name}}\n                                </a>\n                                <button type=\"button\" class=\"btn btn-danger btn-xs\" (click)=\"removeDischarge()\"\n                                        *ngIf=\"canEdit\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span>\n                                    Eliminar\n                                </button>\n                            </div>\n                            <div *ngIf=\"canEdit && (!infraction.discharge && uploaderDischarge.queue?.length == 0)\">\n                                <div ng2FileDrop\n                                     [ngClass]=\"{'nv-file-over': hasDischargeDropZoneOver}\"\n                                     (fileOver)=\"fileDischargeDischarge($event)\"\n                                     [uploader]=\"uploaderDischarge\"\n                                     class=\"well my-drop-zone\">\n                                    Arrastre el archivo aqu&iacute;\n                                </div>\n                                <input type=\"file\" ng2FileSelect [uploader]=\"uploaderDischarge\" #inputDischarge/>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\"\n                         *ngIf=\"uploaderAct.queue?.length > 0 || uploaderActPayReceipt.queue?.length > 0 ||\n                                uploaderDischarge.queue?.length > 0\">\n                        <div class=\"col-md-12\">\n                            <h4>Archivos pendientes de asociar a la infracci&oacute;n</h4>\n\n                            <table class=\"table\">\n                                <thead>\n                                <tr>\n                                    <th width=\"50%\">Nombre</th>\n                                    <th>Tipo</th>\n                                    <th>Estado</th>\n                                    <th>Acciones</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr *ngFor=\"let item of uploaderAct.queue\">\n                                    <td><strong>{{item.file.name}}</strong></td>\n                                    <td>ACTA</td>\n                                    <td class=\"text-center\">\n                                        <!--<span *ngIf=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                        <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                        <!--<span *ngIf=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                        <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                        <!--<span *ngIf=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n                                        <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                    </td>\n                                    <td nowrap>\n                                        <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                (click)=\"item.upload()\"\n                                                [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                            <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                                            <span class=\"upload-icon\"><img></span>\n                                            Subir\n                                        </button>\n                                        <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                            <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                            <span class=\"ban-circle-white\"><img></span>\n                                            Cancelar\n                                        </button>\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"removeActFromQuee(item)\">\n                                            <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                            <span class=\"trash\"><img></span>\n                                            Eliminar\n                                        </button>\n                                    </td>\n                                </tr>\n                                <tr *ngFor=\"let item of uploaderActPayReceipt.queue\">\n                                    <td><strong>{{item.file.name}}</strong></td>\n                                    <td>COMPROBANTE DE PAGO</td>\n                                    <td class=\"text-center\">\n                                        <!--<span *ngIf=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                        <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                        <!--<span *ngIf=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                        <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                        <!--<span *ngIf=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n                                        <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                    </td>\n                                    <td nowrap>\n                                        <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                (click)=\"item.upload()\"\n                                                [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                            <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                                            <span class=\"upload-icon\"><img></span>\n                                            Subir\n                                        </button>\n                                        <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                            <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                            <span class=\"ban-circle-white\"><img></span>\n                                            Cancelar\n                                        </button>\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"removeActPayReceiptFromQuee(item)\">\n                                            <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                            <span class=\"trash\"><img></span>\n                                            Eliminar\n                                        </button>\n                                    </td>\n                                </tr>\n                                <tr *ngFor=\"let item of uploaderDischarge.queue\">\n                                    <td><strong>{{item.file.name}}</strong></td>\n                                    <td>DESCARGO</td>\n                                    <td class=\"text-center\">\n                                        <!--<span *ngIf=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                        <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                        <!--<span *ngIf=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                        <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                        <!--<span *ngIf=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n                                        <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                    </td>\n                                    <td nowrap>\n                                        <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                (click)=\"item.upload()\"\n                                                [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                            <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                                            <span class=\"upload-icon\"><img></span>\n                                            Subir\n                                        </button>\n                                        <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                            <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                            <span class=\"ban-circle-white\"><img></span>\n                                            Cancelar\n                                        </button>\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"removeDischargeFromQuee(item)\">\n                                            <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                            <span class=\"trash\"><img></span>\n                                            Eliminar\n                                        </button>\n                                    </td>\n                                </tr>\n                                <tr *ngIf=\"uploaderAct.queue?.length == 0 && uploaderActPayReceipt.queue?.length == 0 && uploaderDischarge.queue?.length == 0\">\n                                    <td colspan=\"4\" class=\"text-center\">No hay archivos pendientes de asociar a\n                                        la\n                                        infracci&oacute;n\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-md-12\">\n                            <label for=\"comment\">Comentarios</label>\n                            <textarea class=\"form-control\" rows=\"5\" id=\"comment\"\n                                      [(ngModel)]=\"infraction.comments\"\n                                      name=\"comments\" [value]=\"infraction.comments\"\n                                      [disabled]=\"!canEdit\"></textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-md-12\">\n                    <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                    <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                </div>\n                <div class=\"col-md-12\">\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-md-1\">\n                            <button type=\"submit\" class=\"btn btn-success\"\n                                    [disabled]=\"(!form.valid || loading || !patentValid || !actNumberValid || !infraction.infractionDate || uploaderActPayReceipt.isUploading ||\n                                    uploaderAct.isUploading || uploaderDischarge.isUploading || !infractionStateAddressSelectedId || !infractionCitySelectedId)\"\n                                    *ngIf=\"canEdit\">Guardar\n                            </button>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-1\">\n                            <label class=\"hidden\" for=\"withSendMail\">Envío de Mail</label>\n                            <div class=\"input-group\">\n                                <input type=\"checkbox\" class=\"form-control checkbox\" id=\"withSendMail\"\n                                       formControlName=\"withSendMail\" [(ngModel)]=\"infraction.withSendMail\"\n                                       name=\"withSendMail\"\n                                       [disabled]=\"!canEdit\">\n                                <span class=\"input-group-addon checkIcon\">\n                                    <!--<i class=\"glyphicon glyphicon-envelope\"></i>-->\n                                    <span class=\"envelope\"><img></span>\n                                </span>\n                            </div>\n                            <div *ngIf=\"!form.controls.withSendMail.valid\" class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-1\">\n                            <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                        </div>\n                        <div class=\"col-md-2\">\n                            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 943 */
/***/ function(module, exports) {

	module.exports = ".checkbox {\n    height: 20px;\n    width: 20px;\n}\n\n.checkboxLabel {\n    display: inline-block;\n}\n\n.checkIcon {\n    background-color: white;\n    border: 0;\n}"

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var login_service_1 = __webpack_require__(404);
	var ConfigPanel = (function () {
	    /*private userCredentials:UserCredentials;*/
	    function ConfigPanel(/*private router:Router,*/ loginService) {
	        this.loginService = loginService;
	    }
	    ConfigPanel.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        if (!this.userLogged) {
	            this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	                _this.userLogged = userLogged;
	                _this.updateUserLogged();
	            }, function () {
	                //Do Nothing.
	            });
	        }
	        else {
	            this.updateUserLogged();
	        }
	    };
	    ConfigPanel.prototype.updateUserLogged = function () {
	        if (this.userLogged.isAdmin()) {
	            this.isAdmin = true;
	        }
	        if (this.userLogged.rol.name === "OPERADOR DE BANCO" || this.userLogged.rol.name === "Operador Banco Con Trámite") {
	            this.isBank = true;
	        }
	    };
	    ConfigPanel = __decorate([
	        core_1.Component({
	            selector: 'config-panel',
	            template: __webpack_require__(945),
	            directives: [router_1.ROUTER_DIRECTIVES],
	        }), 
	        __metadata('design:paramtypes', [login_service_1.LoginService])
	    ], ConfigPanel);
	    return ConfigPanel;
	}());
	exports.ConfigPanel = ConfigPanel;


/***/ },
/* 945 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\" role=\"navigation\">\n    <div class=\"col-md-2\">\n        <ul class=\"nav nav-list\" id=\"side-menu\">\n            <li><a routerLink=\"infractionTypes\" routerLinkActive=\"active\" *ngIf=\"isAdmin\">Infracciones</a></li>\n            <li><a routerLink=\"vehicleBrands\" routerLinkActive=\"active\" *ngIf=\"isAdmin\">Marcas Vehiculos</a></li>\n            <li><a routerLink=\"banks\" routerLinkActive=\"active\" *ngIf=\"isAdmin\">Bancos</a></li>\n            <li><a routerLink=\"permissions\" routerLinkActive=\"active\" *ngIf=\"isAdmin\">Roles y Permisos</a></li>\n            <li><a routerLink=\"operators\" routerLinkActive=\"active\" *ngIf=\"isAdmin\">Usuarios Operadores</a></li>\n            <li><a routerLink=\"states\" routerLinkActive=\"active\" *ngIf=\"isAdmin\">Provincias y Localidades</a></li>\n            <li><a routerLink=\"ocDocuments\" routerLinkActive=\"active\" *ngIf=\"false\">Documentos OC</a></li>\n            <li><a routerLink=\"entes\" routerLinkActive=\"active\" *ngIf=\"false\">Entes</a></li>\n            <li><a routerLink=\"clientDocuments\" routerLinkActive=\"active\" *ngIf=\"isAdmin || isBank\">Archivos Tomador</a></li>\n            <li><a routerLink=\"clientProcedureDocuments\" routerLinkActive=\"active\" *ngIf=\"isAdmin || isBank\">Archivos Tr&aacute;mites</a></li>\n            <li><a routerLink=\"clientKmDocuments\" routerLinkActive=\"active\" *ngIf=\"isAdmin || isBank\">Archivos Carga de km</a></li>\n            <li><a routerLink=\"clientPatentDocuments\" routerLinkActive=\"active\" *ngIf=\"isAdmin || isBank\">Archivos Pago de Patentes</a></li>\n        </ul>\n    </div>\n    <div class=\"col-md-10\">\n        <router-outlet></router-outlet>\n    </div>\n</div>";

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var unity_tinymce_ts_1 = __webpack_require__(947);
	var UnderConstruction = (function () {
	    function UnderConstruction() {
	    }
	    UnderConstruction.prototype.contentChanged = function (event) {
	        console.log(event);
	    };
	    UnderConstruction = __decorate([
	        core_1.Component({
	            selector: 'under-construction',
	            template: "\n      <h3>Seleccione un item del menu</h3>\n      <unity-tinymce [mceContent]=\"content\" (contentChanged)=\"contentChanged($event)\"></unity-tinymce>\n    ",
	            directives: [unity_tinymce_ts_1.UNITYTinyMCE]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], UnderConstruction);
	    return UnderConstruction;
	}());
	exports.UnderConstruction = UnderConstruction;


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(1);
	var UNITYTinyMCE = (function () {
	    function UNITYTinyMCE(elementRef) {
	        this.elementRef = elementRef;
	        var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
	        var uniqid = randLetter + Date.now();
	        this.elementID = 'tinymce' + uniqid;
	        this.contentChanged = new core_1.EventEmitter();
	    }
	    UNITYTinyMCE.prototype.ngAfterViewInit = function () {
	        //Clone base textarea
	        var baseTextArea = this.elementRef.nativeElement.querySelector("#baseTextArea");
	        var clonedTextArea = baseTextArea.cloneNode(true);
	        clonedTextArea.id = this.elementID;
	        var formGroup = this.elementRef.nativeElement.querySelector("#tinyFormGroup");
	        formGroup.appendChild(clonedTextArea);
	        //Attach tinyMCE to cloned textarea
	        tinymce.init({
	            mode: 'exact',
	            height: 500,
	            theme: 'modern',
	            plugins: [
	                'advlist autolink lists link image charmap print preview anchor',
	                'searchreplace visualblocks code fullscreen',
	                'insertdatetime media table contextmenu paste code'
	            ],
	            toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
	            elements: this.elementID,
	            setup: this.tinyMCESetup.bind(this)
	        });
	    };
	    UNITYTinyMCE.prototype.ngOnDestroy = function () {
	        //destroy cloned elements
	        tinymce.get(this.elementID).remove();
	        var elem = document.getElementById(this.elementID);
	        elem.parentElement.removeChild(elem);
	    };
	    UNITYTinyMCE.prototype.tinyMCESetup = function (ed) {
	        ed.on('keyup', this.tinyMCEOnKeyup.bind(this));
	    };
	    UNITYTinyMCE.prototype.tinyMCEOnKeyup = function (e) {
	        this.contentChanged.emit(tinymce.get(this.elementID).getContent());
	    };
	    Object.defineProperty(UNITYTinyMCE.prototype, "mceContent", {
	        set: function (content) {
	            this.htmlContent = content;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], UNITYTinyMCE.prototype, "contentChanged", void 0);
	    UNITYTinyMCE = __decorate([
	        core_1.Component({
	            selector: 'unity-tinymce',
	            moduleId: module.id,
	            template: __webpack_require__(948),
	            inputs: ['mceContent']
	        }),
	        __param(0, core_1.Inject(core_1.ElementRef)), 
	        __metadata('design:paramtypes', [core_1.ElementRef])
	    ], UNITYTinyMCE);
	    return UNITYTinyMCE;
	}());
	exports.UNITYTinyMCE = UNITYTinyMCE;


/***/ },
/* 948 */
/***/ function(module, exports) {

	module.exports = "<div id=\"tinyFormGroup\" class=\"form-group\">\n    <div class=\"hidden\">\n        <textarea id=\"baseTextArea\">{{htmlContent}}</textarea>\n    </div>\n</div>";

/***/ },
/* 949 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */
949,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */
949,
/* 985 */,
/* 986 */
949,
/* 987 */,
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_bootstrap_2 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var bank_service_1 = __webpack_require__(631);
	var bank_1 = __webpack_require__(875);
	var ConfigBanksComponent = (function () {
	    function ConfigBanksComponent(router, banksService) {
	        this.router = router;
	        this.banksService = banksService;
	        this.init();
	        this.form.valueChanges
	            .debounceTime(400)
	            .subscribe(this.find.bind(this));
	        /*Default: mostrar todos los bancos*/
	        this.find();
	    }
	    ConfigBanksComponent.prototype.init = function () {
	        this.data = [];
	        this.filter = "";
	        this.form = new forms_1.FormGroup({
	            search: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl()
	        });
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	    };
	    ConfigBanksComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    ConfigBanksComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        if (this.itemsPerPage != null && this.itemsPerPage > 0) {
	            if (this.filter) {
	                this.loading = true;
	                this.banksService.findBanks(this.filter, page, this.itemsPerPage)
	                    .subscribe(function (data) {
	                    _this.refreshData(data);
	                    _this.page = page;
	                }, function () {
	                    _this.bindError('Ocurrió un error al buscar los bancos.');
	                });
	            }
	            else {
	                this.banksService.listBanks(page, this.itemsPerPage)
	                    .subscribe(function (data) {
	                    _this.refreshData(data);
	                    _this.page = page;
	                }, function () {
	                    _this.bindError('Ocurrió un error al listar los bancos.');
	                });
	            }
	        }
	        else {
	            this.bindError('Cantidad de ítems no válida.');
	        }
	    };
	    ConfigBanksComponent.prototype.refreshData = function (page) {
	        this.data = page.content.map(function (bank) { return new bank_1.Bank(bank); });
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    ConfigBanksComponent.prototype.removeBank = function (deleteModal) {
	        var _this = this;
	        this.error = null;
	        this.banksService.delete(this.bankSelected.id)
	            .subscribe(function () {
	            deleteModal.hide();
	            _this.removeBankFromView(_this.bankSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el banco.');
	        });
	    };
	    ConfigBanksComponent.prototype.removeBankFromView = function (bank) {
	        var index = this.data.indexOf(bank);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.bankSelected = null;
	    };
	    ConfigBanksComponent.prototype.editBank = function (bank) {
	        this.router.navigate(['app/home/config/editBank', bank.id]);
	    };
	    ConfigBanksComponent.prototype.createBank = function () {
	        this.router.navigate(['app/home/config/createBank']);
	    };
	    ConfigBanksComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    ConfigBanksComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigBanksComponent = __decorate([
	        core_1.Component({
	            selector: 'config-banks',
	            template: __webpack_require__(989),
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_2.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_2.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, bank_service_1.BankService])
	    ], ConfigBanksComponent);
	    return ConfigBanksComponent;
	}());
	exports.ConfigBanksComponent = ConfigBanksComponent;


/***/ },
/* 989 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"col-xs-12\">\n        <h1>Bancos</h1>\n    </div>\n    <div class=\"col-xs-12\">\n        <form class=\"form-inline\" [formGroup]=\"form\" (ngSubmit)=\"find()\">\n            <div class=\"panel panel-default\">\n                <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n                <div class=\"form-group form-group-sm center\">\n                    <i class=\"fa fa-search\" style=\"font-size:24px\"></i>\n                    <input type=\"text\" class=\"form-control\" id=\"search\" placeholder=\"buscar banco...\"\n                           formControlName=\"search\" [(ngModel)]=\"filter\" name=\"search\">\n                </div>\n            </div>\n\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n\n        <div class=\"panel panel-default\">\n            <table class=\"table table-striped\">\n                <thead>\n                <tr>\n                    <th style=\"width: 10%\"></th>\n                    <th style=\"width: 10%\">\n                        Nombre\n                    </th>\n                    <th style=\"width: 10%\">\n                        Tel&eacute;fono\n                    </th>\n                    <th style=\"width: 30%\">\n                        Direcci&oacute;n\n                    </th>\n                    <th style=\"width: 10%\">\n                        Nombre Contacto\n                    </th>\n                    <th style=\"width: 10%\">\n                        Tel&eacute;fono Contacto\n                    </th>\n                    <th style=\"width: 10%\">\n                        Email Contacto\n                    </th>\n                    <th style=\"width: 10%\">\n                        Acciones\n                    </th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let bank of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                    <td>\n                        <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"editBank(bank)\">\n                            <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                            <span class=\"pencil\"><img></span>\n                        </button>\n                    </td>\n                    <td>{{bank.name}}</td>\n                    <td>{{bank.phone}}</td>\n                    <td>{{bank.address.toString()}}</td>\n                    <td>\n                        <table>\n                            <tr *ngFor=\"let contact of bank.contacts\">\n                                <td>{{contact.name}}</td>\n                            </tr>\n                        </table>\n                    </td>\n                    <td>\n                        <table>\n                            <tr *ngFor=\"let contact of bank.contacts\">\n                                <td>{{contact.phone}}</td>\n                            </tr>\n                        </table>\n                    <td>\n                        <table>\n                            <tr *ngFor=\"let contact of bank.contacts\">\n                                <td>{{contact.email}}</td>\n                            </tr>\n                        </table>\n                    </td>\n                    <td>\n                        <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                (click)=\"bankSelected=bank;deleteModal.show();\">\n                            <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                            <span class=\"remove\"><img></span>\n                        </button>\n                    </td>\n                </tr>\n                </tbody>\n                <tfoot>\n                <tr>\n                    <td colspan=\"10\">\n                        <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                    </td>\n                </tr>\n                </tfoot>\n            </table>\n        </div>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"createBank()\">\n            <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n            <span class=\"plus\"><img></span>\n             Nuevo\n        </button>\n    </div>\n</div>\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n            </div>\n            <div class=\"modal-body\">\n                &iquest;Est&aacute; seguro que desea eliminar el banco\n                <strong>{{bankSelected?.name}}</strong>?\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\" (click)=\"removeBank(deleteModal)\">\n                    Aceptar\n                </button>\n                <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\" (click)=\"deleteModal.hide()\">\n                    Cancelar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var Observable_1 = __webpack_require__(34);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var bank_service_1 = __webpack_require__(631);
	var bank_1 = __webpack_require__(875);
	var validators_1 = __webpack_require__(849);
	var contact_1 = __webpack_require__(879);
	var city_1 = __webpack_require__(877);
	var cities_service_1 = __webpack_require__(633);
	var address_1 = __webpack_require__(876);
	var common_1 = __webpack_require__(991);
	var ng2_file_upload_1 = __webpack_require__(889);
	var lookAndFeelBank_1 = __webpack_require__(880);
	/**
	 *.
	 * Created by jlado on 19/8/16.
	 */
	var BankEditorComponent = (function () {
	    function BankEditorComponent(bankService, citiesService, route) {
	        this.bankService = bankService;
	        this.citiesService = citiesService;
	        this.route = route;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    BankEditorComponent.prototype.init = function () {
	        this.fonts = common_1.FONTS_LIST;
	        this.defaultColorFont = common_1.BLACK_COLOR;
	        this.defaultColorBackground = common_1.SERVILEASING_COLOR;
	        this.defaultFont = common_1.FONTS_LIST[0].name;
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.bank = new bank_1.Bank();
	        this.newContact = new contact_1.Contact();
	        this.loading = false;
	        this.uploaderLogo = new ng2_file_upload_1.FileUploader({
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.hasLogoDropZoneOver = false;
	    };
	    BankEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var bankId = params['bankId'];
	            if (bankId) {
	                _this.bankId = bankId;
	                _this.createMode = false;
	            }
	            else {
	                _this.bankId = null;
	                _this.createMode = true;
	            }
	            _this.getData();
	        });
	    };
	    BankEditorComponent.prototype.createFormGroup = function () {
	        var group = {};
	        group['name'] = new forms_1.FormControl(this.bank.name, forms_1.Validators.required);
	        group['phone'] = new forms_1.FormControl(this.bank.phone);
	        group['street'] = new forms_1.FormControl(this.bank.address.street);
	        group['addressNumber'] = new forms_1.FormControl(this.bank.address.number);
	        group['state'] = new forms_1.FormControl(this.bank.address.city.state.name);
	        group['city'] = new forms_1.FormControl(this.bank.address.city.name);
	        group['floor'] = new forms_1.FormControl(this.bank.address.floor);
	        group['department'] = new forms_1.FormControl(this.bank.address.department);
	        group['zipCode'] = new forms_1.FormControl(this.bank.address.zipCode);
	        group['newContactName'] = new forms_1.FormControl(this.newContact.name);
	        group['newContactPhone'] = new forms_1.FormControl(this.newContact.phone);
	        group['newContactEmail'] = new forms_1.FormControl(this.newContact.email, [validators_1.EMAIL_VALIDATOR]);
	        group['font'] = new forms_1.FormControl(this.defaultFont);
	        group['fontColor'] = new forms_1.FormControl(this.defaultColorFont);
	        group['backgroundColor'] = new forms_1.FormControl(this.defaultColorBackground);
	        this.form = new forms_1.FormGroup(group);
	    };
	    BankEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        var forkTasks = [];
	        forkTasks.push(this.citiesService.getStates());
	        if (this.bankId) {
	            forkTasks.push(this.bankService.getBank(this.bankId));
	        }
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los datos del banco.');
	        });
	    };
	    BankEditorComponent.prototype.createBank = function () {
	        var _this = this;
	        this.bank = new bank_1.Bank();
	        this.initLookAndFeelBank();
	        this.bankStateSelectedId = null;
	        this.bankCitySelectedId = null;
	        this.bankService.generateBankTempId()
	            .subscribe(function (response) {
	            _this.bank.tempId = response.value;
	            _this.updateUploaderUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al crear template del banco.');
	        });
	    };
	    BankEditorComponent.prototype.setData = function (data) {
	        this.loading = false;
	        this.states = data[0];
	        if (this.bankId) {
	            this.bank = data[data.length - 1];
	            this.bank.tempId = this.bank.id;
	            if (!this.bank.address) {
	                this.bank.address = new address_1.Address(null);
	            }
	            else if (this.bank.address.city.id != null && this.bank.address.city.state.id != null) {
	                this.bankStateSelectedId = this.bank.address.city.state.id;
	                this.bankCitySelectedId = this.bank.address.city.id;
	                this.loadCities(this.bank.address.city.state);
	            }
	            if (!this.bank.lookAndFeelData) {
	                this.bank.lookAndFeelData = new lookAndFeelBank_1.LookAndFeelBank(null);
	                this.initLookAndFeelBank();
	            }
	            this.updateUploaderUrl();
	        }
	        else {
	            this.createBank();
	        }
	        this.addContactsControls();
	    };
	    BankEditorComponent.prototype.updateUploaderUrl = function () {
	        var fileOwnerId = this.bank.tempId;
	        this.uploaderLogo = new ng2_file_upload_1.FileUploader({
	            url: 'bank/' + fileOwnerId + '/upload',
	            autoUpload: true,
	            allowedMimeType: ['image/png', 'image/gif', 'image/jpeg'],
	            maxFileSize: validators_1.FILE_MAX_SIZE
	        });
	    };
	    BankEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    BankEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        /*Elimnar condición para carga de contactos múltiple*/
	        if (this.createMode) {
	            this.addNewContactToBank();
	        }
	        this.bankService.save(this.bank).subscribe(function (saved) {
	            _this.loading = false;
	            _this.bank = saved;
	            _this.successMessage = 'El banco se guardó con éxito';
	            _this.updateViewAfterSave();
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar los datos del banco.');
	        });
	    };
	    BankEditorComponent.prototype.checkBeforeSave = function () {
	        if (this.form.valid && !this.loading) {
	            if (this.bank && this.bank.address && this.bank.address.city.id) {
	                return this.bank.address.city.state.id == null;
	            }
	            else if (this.bank && this.bank.address && this.bank.address.city.state.id) {
	                return this.bank.address.city.id == null;
	            }
	            return false;
	        }
	        return true;
	    };
	    BankEditorComponent.prototype.updateViewAfterSave = function () {
	        this.uploaderLogo.clearQueue();
	        if (this.createMode) {
	            this.createBank();
	        }
	        else {
	            this.bank.tempId = this.bank.id;
	        }
	    };
	    BankEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.bank);
	        window.history.back();
	    };
	    BankEditorComponent.prototype.loadCities = function (state) {
	        var _this = this;
	        this.loading = true;
	        this.citiesService.getCities(state.id)
	            .subscribe(function (data) {
	            _this.loading = false;
	            _this.cities = data;
	        }, function () {
	            _this.bindError('Ocurrió un error al obtener las ciudades.');
	        });
	    };
	    BankEditorComponent.prototype.clearCity = function (state) {
	        this.bank.address.city = new city_1.City(null);
	        this.bank.address.city.state = state;
	    };
	    BankEditorComponent.prototype.addContactsControls = function () {
	        var form = this.form;
	        this.bank.contacts.forEach(function (contact, i) {
	            form.controls['contactName' + i] = new forms_1.FormControl(contact.name);
	            form.controls['contactPhone' + i] = new forms_1.FormControl(contact.phone);
	            form.controls['contactEmail' + i] = new forms_1.FormControl(contact.email, [validators_1.EMAIL_VALIDATOR]);
	        });
	    };
	    BankEditorComponent.prototype.initLookAndFeelBank = function () {
	        this.bank.lookAndFeelData.backgroundColor = this.defaultColorBackground;
	        this.bank.lookAndFeelData.fontColor = this.defaultColorFont;
	        this.bank.lookAndFeelData.font = this.defaultFont;
	    };
	    BankEditorComponent.prototype.addNewContactToBank = function () {
	        this.bank.contacts.push((JSON.parse(JSON.stringify(this.newContact))));
	        this.newContact = new contact_1.Contact();
	        /*Elimnar para carga de contactos múltiple*/
	        this.addContactsControls();
	    };
	    BankEditorComponent.prototype.fileOverLogo = function (e) {
	        this.hasLogoDropZoneOver = e;
	    };
	    BankEditorComponent.prototype.removeLogo = function () {
	        this.bank.logo = null;
	    };
	    BankEditorComponent.prototype.removeLogoFromQueue = function (logo) {
	        var _this = this;
	        this.bankService.deleteTempBankDocument(this.bank.tempId)
	            .subscribe(function (result) { return logo.remove(); }, function () {
	            _this.bindError('Ocurrió un error al eliminar el logo de la cola.');
	        });
	    };
	    BankEditorComponent.prototype.previewBankFile = function () {
	        var date = new Date();
	        this.previewToken = date.getTime().toString();
	    };
	    BankEditorComponent.prototype.onStateSelected = function (newValue) {
	        var result = this.states.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.loadCities(result[0]);
	            this.clearCity(result[0]);
	        }
	    };
	    BankEditorComponent.prototype.onCitySelected = function (newValue) {
	        var result = this.cities.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.bank.address.city = result[0];
	        }
	    };
	    BankEditorComponent.prototype.imageNotFound = function () {
	        if (this.createMode) {
	            this.bankImageCreation.nativeElement.setAttribute('src', this.imgNotFound.nativeElement.getAttribute('src'));
	            this.bankImageCreation.nativeElement.setAttribute('height', 150);
	            this.bankImageCreation.nativeElement.setAttribute('width', 150);
	        }
	        else {
	            this.bankImage.nativeElement.setAttribute('src', this.imgNotFound.nativeElement.getAttribute('src'));
	            this.bankImage.nativeElement.setAttribute('height', 150);
	            this.bankImage.nativeElement.setAttribute('width', 150);
	        }
	    };
	    BankEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    BankEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', bank_1.Bank)
	    ], BankEditorComponent.prototype, "bank", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], BankEditorComponent.prototype, "close", void 0);
	    __decorate([
	        core_1.ViewChild('imgNotFound'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], BankEditorComponent.prototype, "imgNotFound", void 0);
	    __decorate([
	        core_1.ViewChild('bankImageCreation'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], BankEditorComponent.prototype, "bankImageCreation", void 0);
	    __decorate([
	        core_1.ViewChild('bankImage'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], BankEditorComponent.prototype, "bankImage", void 0);
	    BankEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'bank-editor',
	            template: __webpack_require__(993),
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS
	            ],
	        }), 
	        __metadata('design:paramtypes', [bank_service_1.BankService, cities_service_1.CitiesService, router_1.ActivatedRoute])
	    ], BankEditorComponent);
	    return BankEditorComponent;
	}());
	exports.BankEditorComponent = BankEditorComponent;


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Font_1 = __webpack_require__(992);
	/**
	 *
	 * Created by jlado on 25/8/16.
	 */
	exports.FONTS_LIST = [
	    new Font_1.Font("Arial", "Arial"),
	    new Font_1.Font("Arial Black", "Arial Black"),
	    new Font_1.Font("Comic Sans MS", "Comic Sans MS"),
	    new Font_1.Font("Courier New", "Courier New"),
	    new Font_1.Font("Georgia", "Georgia"),
	    new Font_1.Font("Impact", "Impact"),
	    new Font_1.Font("Times New Roman", "Times New Roman"),
	    new Font_1.Font("Trebuchet MS", "Trebuchet MS"),
	    new Font_1.Font("Verdana", "Verdana"),
	];
	exports.BLACK_COLOR = "#000000";
	exports.SERVILEASING_COLOR = "#31708f";


/***/ },
/* 992 */
/***/ function(module, exports) {

	"use strict";
	/**
	 *
	 * Created by jlado on 25/8/16.
	 */
	var Font = (function () {
	    function Font(name, style) {
	        this.name = name;
	        this.style = style;
	    }
	    return Font;
	}());
	exports.Font = Font;


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nuevo Banco</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Banco</h2>\n        </div>\n\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"bank\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\n                <div class=\"row\">\n                    <div class=\"col-sm-4\">\n                        <div class=\"row\">\n                            <div class=\"form-group form-group-sm col-sm-12\">\n                                <label for=\"name\">Nombre</label>\n                                <input type=\"text\" class=\"form-control\" id=\"name\"\n                                       [(ngModel)]=\"bank.name\" name=\"name\" formControlName=\"name\"/>\n\n                                <div *ngIf=\"!form.controls.name.valid && form.controls.name.errors.required\"\n                                     class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"row\">\n                            <div class=\"form-group form-group-sm col-sm-12\">\n                                <label for=\"phone\">Teléfono</label>\n                                <input type=\"text\" class=\"form-control\" id=\"phone\"\n                                       [(ngModel)]=\"bank.phone\" name=\"phone\" formControlName=\"phone\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"col-sm-4\">\n                        <div class=\"form-group form-group-sm col-sm-12\">\n                            <h3>Logo</h3>\n                            <div *ngIf=\"bank.logo\">\n                                <a href=\"/bank/{{bank.id}}/download\" target=\"file\">\n                                    <!--<span class=\"glyphicon glyphicon-paperclip\"></span>-->\n                                    <span class=\"paperclip\"><img></span>\n                                     {{bank.logo.name}}\n                                </a>\n                                <button type=\"button\" class=\"btn btn-danger btn-xs\" (click)=\"removeLogo()\">\n                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                    <span class=\"trash\"><img></span>\n                                     Eliminar\n                                </button>\n                            </div>\n\n                            <div *ngIf=\"!bank.logo && uploaderLogo.queue.length == 0\">\n                                <label for=\"logo\" class=\"hidden\">Logo</label>\n                                <div ng2FileDrop\n                                     [ngClass]=\"{'nv-file-over': hasLogoDropZoneOver}\"\n                                     (fileOver)=\"fileOverLogo($event)\"\n                                     [uploader]=\"uploaderLogo\"\n                                     class=\"well my-drop-zone\">Arrastre el logo aquí\n                                </div>\n                                <input type=\"file\" id=\"logo\" ng2FileSelect [uploader]=\"uploaderLogo\"\n                                       (change)=\"previewBankFile()\"/><!--accept=\".jpg, .png, .gif\"-->\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-4\">\n                        <img #bankImage\n                             *ngIf=\"!createMode && (bank.logo || (uploaderLogo.queue?.length > 0 && uploaderLogo.queue[0].isSuccess))\"\n                             class=\"img-thumbnail img-responsive\" src=\"/bank/{{bankId}}/preview?token={{previewToken}}\"\n                             (error)=\"imageNotFound($event)\">\n                        <img #bankImageCreation\n                             *ngIf=\"createMode && uploaderLogo.queue?.length > 0 && uploaderLogo.queue[0].isSuccess\"\n                             class=\"img-thumbnail img-responsive\" (error)=\"imageNotFound($event)\"\n                             src=\"/bank/{{bank.tempId}}/preview?token={{previewToken}}\">\n                        <img #imgNotFound hidden src=\"" + __webpack_require__(909) + "\">\n                    </div>\n                </div>\n\n                <div class=\" row\" *ngIf=\"uploaderLogo.queue?.length > 0\">\n                    <div class=\"col-md-12\">\n                        <h4>Logo pendiente de asociar al banco</h4>\n\n                        <table class=\"table\">\n                            <thead>\n                            <tr>\n                                <th width=\"50%\">Nombre</th>\n                                <th>Tipo</th>\n                                <th>Estado</th>\n                                <th>Acciones</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr *ngFor=\"let logo of uploaderLogo.queue\">\n                                <td>\n                                    <strong>{{logo.file.name}}</strong>\n                                </td>\n                                <td>LOGO</td>\n                                <td class=\"text-center\">\n                                    <!--<span *ngIf=\"logo.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                    <span class=\"ok-icon\" *ngIf=\"logo.isSuccess\"><img></span>\n                                    <!--<span *ngIf=\"logo.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                    <span class=\"ban-circle\" *ngIf=\"logo.isCancel\"><img></span>\n                                    <!--<span *ngIf=\"logo.isError\">\n                                        <i class=\"glyphicon glyphicon-remove\"></i>\n                                    </span>-->\n                                    <span class=\"remove\" *ngIf=\"logo.isError\"><img></span>\n                                </td>\n                                <td nowrap>\n                                    <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                            (click)=\"logo.upload()\"\n                                            [disabled]=\"logo.isReady || logo.isUploading || logo.isSuccess\">\n                                        <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                                        <span class=\"upload-icon\"><img></span>\n                                         Subir\n                                    </button>\n                                    <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                            (click)=\"logo.cancel()\" [disabled]=\"!logo.isUploading\">\n                                        <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                        <span class=\"ban-circle-white\"><img></span>\n                                         Cancelar\n                                    </button>\n                                    <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                            (click)=\"removeLogoFromQueue(logo)\">\n                                        <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                        <span class=\"trash\"><img></span>\n                                         Eliminar\n                                    </button>\n                                </td>\n                            </tr>\n                            <tr *ngIf=\"uploaderLogo.queue?.length == 0\">\n                                <td colspan=\"4\" class=\"text-center\">No hay logo pendiente de asociar al banco</td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <fieldset>\n                    <legend>Dirección</legend>\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"street\">Calle</label>\n                            <input type=\"text\" class=\"form-control\" id=\"street\"\n                                   [(ngModel)]=\"bank.address.street\" name=\"street\"\n                                   formControlName=\"street\"/>\n                        </div>\n\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"addressNumber\">Altura</label>\n                            <input type=\"text\" class=\"form-control\" id=\"addressNumber\"\n                                   [(ngModel)]=\"bank.address.number\" name=\"addressNumber\"\n                                   formControlName=\"addressNumber\"/>\n                        </div>\n\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"state\">Provincia</label>\n                            <select class=\"form-control\" id=\"state\" formControlName=\"state\" name=\"state\"\n                                    [(ngModel)]=\"bankStateSelectedId\" (change)=\"onStateSelected($event.target.value)\">\n                                <option *ngFor=\"let state of states\" [value]=\"state.id\">\n                                    {{state.name | uppercase}}\n                                </option>\n                            </select>\n                            <!-- Descomentar si se necesitan inputs (typeahead) y reemplazarlos por los actuales\n                                   <input type=\"text\" id=\"state\" autocomplete=\"off\"\n                                   [(ngModel)]=\"bank.address.city.state.name\"\n                                   [typeahead]=\"states\"\n                                   (typeaheadOnSelect)=\"onStateSelected($event)\"\n                                   [typeaheadOptionField]=\"'name'\"\n                                   class=\"form-control\" formControlName=\"state\" placeholder=\"Provincia\"/>-->\n                        </div>\n\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"city\">Ciudad</label>\n                            <select class=\"form-control\" id=\"city\" formControlName=\"city\" name=\"city\"\n                                    [(ngModel)]=\"bankCitySelectedId\" (change)=\"onCitySelected($event.target.value)\">\n                                <option *ngFor=\"let city of cities\" [value]=\"city.id\">\n                                    {{city.name | uppercase}}\n                                </option>\n                            </select>\n                            <!-- Descomentar si se necesitan inputs (typeahead) y reemplazarlos por los actuales\n                                   <input type=\"text\" id=\"city\" autocomplete=\"off\"\n                                   [(ngModel)]=\"bank.address.city.name\"\n                                   [typeahead]=\"cities\"\n                                   (typeaheadOnSelect)=\"onCitySelected($event)\"\n                                   [typeaheadOptionField]=\"'name'\"\n                                   class=\"form-control\" formControlName=\"city\" placeholder=\"Ciudad\"/>-->\n                        </div>\n                    </div>\n                </fieldset>\n\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"floor\">Piso</label>\n                        <input type=\"text\" class=\"form-control\" id=\"floor\"\n                               [(ngModel)]=\"bank.address.floor\" name=\"floor\" formControlName=\"floor\"/>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"department\">Departamento</label>\n                        <input type=\"text\" class=\"form-control\" id=\"department\"\n                               [(ngModel)]=\"bank.address.department\" name=\"department\"\n                               formControlName=\"department\"/>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"zipCode\">Código Postal</label>\n                        <input type=\"text\" class=\"form-control\" id=\"zipCode\"\n                               [(ngModel)]=\"bank.address.zipCode\" name=\"zipCode\" formControlName=\"zipCode\"/>\n                    </div>\n                </div>\n\n                <div *ngFor=\"let contact of bank.contacts; let i = index\">\n                    <fieldset>\n                        <legend>Contacto</legend>\n                        <div class=\"row\">\n                            <div class=\"form-group form-group-sm col-sm-3\">\n                                <label attr.for=\"contactName{{i}}\" class=\"hidden\">Nombre del contacto</label>\n                                <input type=\"text\" class=\"form-control\" id=\"contactName{{i}}\"\n                                       [(ngModel)]=\"bank.contacts[i].name\" name=\"contactName{{i}}\"\n                                       formControlName=\"contactName{{i}}\" placeholder=\"Nombre del contacto\">\n                            </div>\n\n                            <div class=\"form-group form-group-sm col-sm-3\">\n                                <label attr.for=\"contactPhone{{i}}\" class=\"hidden\">Teléfono del contacto</label>\n                                <input type=\"text\" class=\"form-control\" id=\"contactPhone{{i}}\"\n                                       [(ngModel)]=\"bank.contacts[i].phone\" name=\"contactPhone{{i}}\"\n                                       formControlName=\"contactPhone{{i}}\" placeholder=\"Teléfono del contacto\">\n                            </div>\n\n                            <div class=\"form-group form-group-sm col-sm-3\">\n                                <label attr.for=\"contactEmail{{i}}\" class=\"hidden\">Email del contacto</label>\n                                <input type=\"text\" class=\"form-control\" id=\"contactEmail{{i}}\"\n                                       [(ngModel)]=\"bank.contacts[i].email\" name=\"contactEmail{{i}}\"\n                                       formControlName=\"contactEmail{{i}}\" placeholder=\"Email del contacto\">\n\n                                <div *ngIf=\"!form.controls['contactEmail' + i].valid\" class=\"alert-danger\">\n                                    {{errorMessages.invalidPattern}}\n                                </div>\n                            </div>\n\n                            <!--<div class=\"form-group form-group-sm col-sm-3\">\n                                <button (click)=\"deleteContact($event,i)\" class=\"btn btn-danger\">\n                                    <i class=\"fa fa-minus\"></i></button>\n                            </div>-->\n                        </div>\n                    </fieldset>\n                </div>\n\n                <fieldset *ngIf=\"bank.contacts.length == 0\">\n                    <!--Eliminar la condición, para ABM de múltiples contactos-->\n                    <legend>Contacto</legend>\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"newContactName\" class=\"hidden\">Nombre del contacto</label>\n                            <input type=\"text\" class=\"form-control\" id=\"newContactName\"\n                                   [(ngModel)]=\"newContact.name\" name=\"newContactName\"\n                                   formControlName=\"newContactName\" placeholder=\"Nombre del contacto\">\n                        </div>\n\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"newContactPhone\" class=\"hidden\">Teléfono del contacto</label>\n                            <input type=\"text\" class=\"form-control\" id=\"newContactPhone\"\n                                   [(ngModel)]=\"newContact.phone\" name=\"newContactPhone\"\n                                   formControlName=\"newContactPhone\" placeholder=\"Teléfono del contacto\">\n                        </div>\n\n                        <div class=\"form-group form-group-sm col-sm-3\">\n                            <label for=\"newContactEmail\" class=\"hidden\">Email del contacto</label>\n                            <input type=\"text\" class=\"form-control\" id=\"newContactEmail\"\n                                   [(ngModel)]=\"newContact.email\" name=\"newContactEmail\"\n                                   formControlName=\"newContactEmail\" placeholder=\"Email del contacto\">\n\n                            <div *ngIf=\"!form.controls.newContactEmail.valid\" class=\"alert-danger\">\n                                {{errorMessages.invalidPattern}}\n                            </div>\n                        </div>\n\n                        <!--<div class=\"form-group form-group-sm col-sm-3\">\n                            <button (click)=\"addNewContact($event)\" class=\"btn btn-success\">\n                                <i class=\"fa fa-plus\"></i>\n                            </button>\n                        </div>-->\n                    </div>\n                </fieldset>\n\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"font\">Fuente</label>\n                        <select class=\"form-control\" id=\"font\"\n                                [(ngModel)]=\"bank.lookAndFeelData.font\" value=\"{{defaultFont}}\"\n                                name=\"font\" formControlName=\"font\">\n                            <option *ngFor=\"let font of fonts\"\n                                    value=\"{{font.name}}\">{{font.name}}\n                            </option>\n                        </select>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"fontColor\">Color de Fuente</label>\n                        <input type=\"color\" class=\"form-control\" id=\"fontColor\"\n                               [(ngModel)]=\"bank.lookAndFeelData.fontColor\"\n                               name=\"fontColor\" formControlName=\"fontColor\"/>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"backgroundColor\">Color de Fondo</label>\n                        <input type=\"color\" class=\"form-control\" id=\"backgroundColor\"\n                               [(ngModel)]=\"bank.lookAndFeelData.backgroundColor\"\n                               name=\"backgroundColor\" formControlName=\"backgroundColor\"/>\n                    </div>\n                </div>\n\n                <div class=\"col-sm-12\">\n                    <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"checkBeforeSave()\">Guardar\n                    </button>\n                    <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_bootstrap_2 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var roles_service_1 = __webpack_require__(635);
	var rol_1 = __webpack_require__(995);
	var ConfigRolesComponent = (function () {
	    function ConfigRolesComponent(router, rolesService) {
	        this.router = router;
	        this.rolesService = rolesService;
	        this.init();
	        this.form.valueChanges
	            .debounceTime(400)
	            .subscribe(this.find.bind(this));
	        this.find();
	    }
	    ConfigRolesComponent.prototype.init = function () {
	        this.data = [];
	        this.filter = "";
	        this.form = new forms_1.FormGroup({
	            search: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl()
	        });
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	    };
	    ConfigRolesComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    ConfigRolesComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.loading = true;
	        this.rolesService.findRoles(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	            _this.refreshData(data);
	            _this.page = page;
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar los roles.');
	        });
	    };
	    ConfigRolesComponent.prototype.refreshData = function (page) {
	        this.data = page.content.map(function (rol) { return new rol_1.Rol(rol); });
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    ConfigRolesComponent.prototype.remove = function (deleteModal) {
	        var _this = this;
	        this.error = null;
	        this.rolesService.delete(this.rolSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeFromView(_this.rolSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el rol.');
	        });
	    };
	    ConfigRolesComponent.prototype.removeFromView = function (rol) {
	        var index = this.data.indexOf(rol);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.rolSelected = null;
	    };
	    ConfigRolesComponent.prototype.edit = function (rol) {
	        this.router.navigate(['app/home/config/editRol', rol.id]);
	    };
	    ConfigRolesComponent.prototype.create = function () {
	        this.router.navigate(['app/home/config/createRol']);
	    };
	    ConfigRolesComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    ConfigRolesComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigRolesComponent = __decorate([
	        core_1.Component({
	            selector: 'config-roles',
	            template: __webpack_require__(996),
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_2.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_2.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, roles_service_1.RolesService])
	    ], ConfigRolesComponent);
	    return ConfigRolesComponent;
	}());
	exports.ConfigRolesComponent = ConfigRolesComponent;


/***/ },
/* 995 */
/***/ function(module, exports) {

	"use strict";
	var Rol = (function () {
	    function Rol(other) {
	        this.admin = false;
	        this.client = false;
	        this.permissions = [];
	        if (other) {
	            this.id = other.id;
	            this.name = other.name;
	            this.description = other.description;
	            this.admin = other.admin;
	            this.permissions = other.permissions;
	            this.client = other.client;
	        }
	    }
	    return Rol;
	}());
	exports.Rol = Rol;


/***/ },
/* 996 */
/***/ function(module, exports) {

	module.exports = "<div>\n\t<div class=\"col-xs-12\">\n\t\t<h1>Roles y Permisos</h1>\n\t</div>\n    <div class=\"col-xs-12\">\n        <form class=\"form-inline\" [formGroup]=\"form\" (ngSubmit)=\"find()\">\n            <div class=\"panel panel-default\">\n                <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n                <div class=\"form-group form-group-sm center\">\n                    <i class=\"fa fa-search\" style=\"font-size:24px\"></i>\n                    <input type=\"text\" class=\"form-control\" id=\"search\" placeholder=\"buscar rol...\"\n                           formControlName=\"search\" [(ngModel)]=\"filter\" name=\"search\">\n                </div>\n            </div>\n\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n\n        <div class=\"panel panel-default\">\n            <table class=\"table table-striped\">\n                <thead>\n                <tr>\n                    <th style=\"width: 10%\"></th>\n                    <th style=\"width: 30%\">\n                        Nombre\n                    </th>\n                    <th style=\"width: 40%\">\n                        Descripci&oacute;n\n                    </th>\n                    <th style=\"width: 10%\">\n                        Administrador\n                    </th>\n                    <th style=\"width: 10%\">\n                        Acciones\n                    </th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let rol of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                    <td>\n                        <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"edit(rol)\">\n                            <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                            <span class=\"pencil\"><img></span>\n                        </button>\n                    </td>\n                    <td>{{rol.name}}</td>\n                    <td>{{rol.description}}</td>\n                    <td>{{(rol.admin)?'SI':'NO'}}</td>\n                    <td>\n                        <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                (click)=\"rolSelected=rol;deleteModal.show();\">\n                            <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                            <span class=\"remove\"><img></span>\n                        </button>\n                    </td>\n                </tr>\n                </tbody>\n                <tfoot>\n                <tr>\n                    <td colspan=\"10\">\n                        <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                    </td>\n                </tr>\n                </tfoot>\n            </table>\n        </div>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"create()\">\n            <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n            <span class=\"plus\"><img></span>\n             Nuevo\n        </button>\n    </div>\n\n    <div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n         aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog modal-sm\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                        <span aria-hidden=\"true\">&times;</span>\n                    </button>\n                    <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n                </div>\n                <div class=\"modal-body\">\n                    &iquest;Est&aacute; seguro que desea eliminar el rol\n                    <strong>{{rolSelected?.name}}</strong>?\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\" (click)=\"remove(deleteModal)\">\n                        Aceptar\n                    </button>\n                    <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\" (click)=\"deleteModal.hide()\">\n                        Cancelar\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var Observable_1 = __webpack_require__(34);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_bootstrap_2 = __webpack_require__(680);
	var roles_service_1 = __webpack_require__(635);
	var rol_1 = __webpack_require__(995);
	var rolPermission_1 = __webpack_require__(998);
	var validators_1 = __webpack_require__(849);
	var RolEditorComponent = (function () {
	    function RolEditorComponent(rolesService, route) {
	        this.rolesService = rolesService;
	        this.route = route;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    RolEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.loading = false;
	        this.actionsAllowed = [];
	        this.actionsSelected = [];
	        this.rol = new rol_1.Rol();
	        this.permissionSelected = new rolPermission_1.RolPermission();
	    };
	    RolEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var rolId = params['rolId'];
	            if (rolId) {
	                _this.rolId = rolId;
	                _this.createMode = false;
	            }
	            else {
	                _this.rolId = null;
	                _this.createMode = true;
	            }
	            _this.getData();
	        });
	    };
	    RolEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    RolEditorComponent.prototype.createFormGroup = function () {
	        var group = {};
	        group['name'] = new forms_1.FormControl(null, forms_1.Validators.required);
	        group['description'] = new forms_1.FormControl(null);
	        group['admin'] = new forms_1.FormControl(null);
	        group['permission'] = new forms_1.FormControl(null);
	        group['permissionSelectedVisible'] = new forms_1.FormControl(null);
	        group['actions'] = new forms_1.FormControl(null);
	        this.form = new forms_1.FormGroup(group);
	    };
	    RolEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        var forkTasks = [];
	        if (this.rolId) {
	            forkTasks.push(this.rolesService.getRol(this.rolId));
	        }
	        else {
	            forkTasks.push(this.rolesService.getNewRol());
	        }
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los datos del rol.');
	        });
	    };
	    RolEditorComponent.prototype.setData = function (data) {
	        this.loading = false;
	        this.rol = new rol_1.Rol(data[data.length - 1]);
	        if (this.rol.permissions.length > 0) {
	            this.permissionSelectedId = this.rol.permissions[0].appSection.id;
	            this.permissionSelected = this.rol.permissions[0];
	            this.setActionsSelected();
	            this.getActionsAllowed();
	        }
	    };
	    RolEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.rolesService.save(this.rol).subscribe(function (saved) {
	            _this.loading = false;
	            _this.rol = saved;
	            _this.successMessage = 'El rol se guardó con éxito';
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar los datos del rol.');
	        });
	    };
	    RolEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    RolEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.rol);
	        window.history.back();
	    };
	    RolEditorComponent.prototype.permissionChange = function (id) {
	        var result = this.rol.permissions.filter(function (obj) {
	            return obj.appSection.id == id;
	        });
	        if (result.length > 0) {
	            this.permissionSelected = result[0];
	            this.setActionsSelected();
	            this.getActionsAllowed();
	        }
	    };
	    RolEditorComponent.prototype.setActionsSelected = function () {
	        this.actionsSelected = this.permissionSelected.actions.map(function (action) { return action.id; });
	    };
	    RolEditorComponent.prototype.getActionsAllowed = function () {
	        var _this = this;
	        this.loading = true;
	        this.actionsAllowed = [];
	        if (this.permissionSelected) {
	            this.rolesService.getActionsAllowed(this.permissionSelected.appSection.id).subscribe(function (actions) {
	                _this.loading = false;
	                _this.actionsAllowed = actions;
	            }, function () {
	                _this.bindError('Ocurrió un error al buscar las acciones de permitidas.');
	            });
	        }
	    };
	    RolEditorComponent.prototype.updateActionsSelected = function (target) {
	        var _this = this;
	        this.permissionSelected.actions = Array.apply(null, this.actionsSelected) // convert to real Array
	            .map(function (value) { return _this.actionsAllowed.filter(function (action) {
	            return action.id == value;
	        })[0]; });
	    };
	    RolEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', rol_1.Rol)
	    ], RolEditorComponent.prototype, "rol", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], RolEditorComponent.prototype, "close", void 0);
	    RolEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'rol-editor',
	            template: __webpack_require__(999),
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_2.TYPEAHEAD_DIRECTIVES,
	                ng2_bootstrap_1.MODAL_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS
	            ],
	        }), 
	        __metadata('design:paramtypes', [roles_service_1.RolesService, router_1.ActivatedRoute])
	    ], RolEditorComponent);
	    return RolEditorComponent;
	}());
	exports.RolEditorComponent = RolEditorComponent;


/***/ },
/* 998 */
/***/ function(module, exports) {

	"use strict";
	var RolPermission = (function () {
	    function RolPermission(other) {
	        this.actions = [];
	        if (other) {
	            this.appSection = other.appSection;
	            this.visible = other.visible;
	            this.actions = other.actions;
	            this.appSection = other.appSection;
	        }
	    }
	    return RolPermission;
	}());
	exports.RolPermission = RolPermission;


/***/ },
/* 999 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nuevo Rol</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Rol</h2>\n        </div>\n\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"rol\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"name\">Nombre</label>\n                        <input type=\"text\" class=\"form-control\" id=\"name\"\n                               [(ngModel)]=\"rol.name\" name=\"name\" formControlName=\"name\"/>\n\n                        <div *ngIf=\"!form.controls.name.valid && form.controls.name.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-6\">\n                        <label for=\"description\">Descripci&oacute;n</label>\n                        <input type=\"text\" class=\"form-control\" id=\"description\"\n                               [(ngModel)]=\"rol.description\" name=\"description\" formControlName=\"description\"/>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n\t\t\t\t\t    <label>Administrador</label>\n\t\t\t\t\t    <div class=\"form-control\">\n\t\t\t\t\t\t    <input type=\"checkbox\" id=\"admin\" [(ngModel)]=\"rol.admin\" name=\"admin\" formControlName=\"admin\"/> \n\t\t\t\t\t    </div>\n                    </div>\n                </div>\n\t\t\t\t<div class=\"row\" *ngIf=\"!rol.admin\">\n\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-4\">\n\t\t\t\t\t\t<label>Permisos para la Pantalla:</label>\n\t\t\t\t\t\t\n\t\t\t\t\t   \t<select class=\"form-control\" formControlName=\"permission\" [(ngModel)]=\"permissionSelectedId\" name=\"type\" \n\t\t\t\t\t   \t\t(change)=\"permissionChange($event.target.value)\">\n\t\t\t\t\t\t  \t<option *ngFor=\"let permission of rol.permissions\" [value]=\"permission.appSection.id\">{{permission.appSection.description}}</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-2\">\n\t\t\t\t\t\t<label>Visible</label>\n\t\t\t\t\t\t<div class=\"form-control\">\n\t\t\t\t\t\t    <input type=\"checkbox\" [(ngModel)]=\"permissionSelected.visible\" name=\"permissionSelectedVisible\" formControlName=\"permissionSelectedVisible\"/>\n\t\t\t\t\t\t</div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-6\" *ngIf=\"permissionSelected.visible\">\n                    \t<label>Acciones Habilitadas</label>\n                    \t<div>\n\t\t\t\t            <select class=\"form-control\" formControlName=\"actions\" [(ngModel)]=\"actionsSelected\" name=\"actions\"\n\t\t\t\t            \tmultiple=\"multiple\" (change)=\"updateActionsSelected($event.target)\" style=\"height:100px\">\n\t\t\t\t\t\t  \t\t<option *ngFor=\"let action of actionsAllowed\" [value]=\"action.id\">{{action.text}}</option>\n\t\t\t\t\t\t\t</select>\n                    \t</div>\n                    </div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\" *ngIf=\"!rol.admin && permissionSelected && permissionSelected.visible\">\n        \t\t\t<h3>\n\t\t\t\t\t\tCampos visibles\n\t\t\t\t\t</h3>\n\t\t\t\t\t<table class=\"table table-striped\">\n\t\t                <thead>\n\t\t                <tr>\n\t\t                    <th style=\"width: 20%\">Ver</th>\n\t\t                    <th style=\"width: 80%\">\n\t\t                        Campo\n\t\t                    </th>\n\t\t                </tr>\n\t\t                </thead>\n\t\t                <tbody>\n\t\t                <tr *ngFor=\"let item of permissionSelected.sectionFields\">\n\t\t                    <td>\n\t\t                    \t<input type=\"checkbox\" [(ngModel)]=\"item.visible\" [ngModelOptions]=\"{standalone: true}\"/>\n                            </td>\n\t\t                    <td>{{item.fieldDescription}}</td>\n\t\t                </tr>\n\t\t                </tbody>\n\t\t            </table>\n\t\t        </div>\n                <div class=\"col-sm-12\">\n                    <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"!form.valid || loading\">Guardar</button>\n                    <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div><!--OK-->";

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var operators_service_1 = __webpack_require__(636);
	var user_1 = __webpack_require__(844);
	var login_service_1 = __webpack_require__(404);
	var ConfigOperatorsComponent = (function () {
	    function ConfigOperatorsComponent(router, operatorsService, loginService) {
	        this.router = router;
	        this.operatorsService = operatorsService;
	        this.loginService = loginService;
	        this.init();
	        this.form.valueChanges
	            .debounceTime(400)
	            .subscribe(this.find.bind(this));
	        this.find();
	    }
	    ConfigOperatorsComponent.prototype.init = function () {
	        this.data = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.filter = "";
	        this.form = new forms_1.FormGroup({
	            search: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl()
	        });
	    };
	    ConfigOperatorsComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    ConfigOperatorsComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.loading = true;
	        this.operatorsService.findUsers(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	            _this.refreshData(data);
	            _this.page = page;
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar los operadores.');
	        });
	        this.userLogged = this.loginService.getUserLogged();
	    };
	    ConfigOperatorsComponent.prototype.refreshData = function (page) {
	        this.data = page.content.map(function (user) { return new user_1.User(user); });
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    ConfigOperatorsComponent.prototype.remove = function (deleteModal) {
	        var _this = this;
	        this.error = null;
	        this.operatorsService.delete(this.userSelected.id)
	            .subscribe(function () {
	            deleteModal.hide();
	            _this.removeFromView(_this.userSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el operador.');
	        });
	    };
	    ConfigOperatorsComponent.prototype.removeFromView = function (user) {
	        var index = this.data.indexOf(user);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.userSelected = null;
	    };
	    ConfigOperatorsComponent.prototype.edit = function (user) {
	        this.router.navigate(['app/home/config/editOperator', user.id]);
	    };
	    ConfigOperatorsComponent.prototype.create = function () {
	        this.router.navigate(['app/home/config/createOperator']);
	    };
	    ConfigOperatorsComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    ConfigOperatorsComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigOperatorsComponent = __decorate([
	        core_1.Component({
	            selector: 'config-operators',
	            template: __webpack_require__(1001),
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, operators_service_1.OperatorsService, login_service_1.LoginService])
	    ], ConfigOperatorsComponent);
	    return ConfigOperatorsComponent;
	}());
	exports.ConfigOperatorsComponent = ConfigOperatorsComponent;


/***/ },
/* 1001 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"col-xs-12\">\n        <h1>Usuarios Operadores</h1>\n    </div>\n    <div class=\"col-xs-12\">\n        <form class=\"form-inline\" [formGroup]=\"form\" (ngSubmit)=\"find()\">\n            <div class=\"panel panel-default\">\n                <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n                <div class=\"form-group form-group-sm center\">\n                    <i class=\"fa fa-search\" style=\"font-size:24px\"></i>\n                    <input type=\"text\" class=\"form-control\" id=\"search\" placeholder=\"buscar operador...\"\n                           formControlName=\"search\" [(ngModel)]=\"filter\" name=\"search\">\n                </div>\n            </div>\n\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n        <div class=\"col-md-12\">\n            <div class=\"row\">\n                <div class=\"panel panel-default\">\n                    <table class=\"table table-striped\">\n                        <thead>\n                        <tr>\n                            <th style=\"width: 5%\"></th>\n                            <th style=\"width: 10%\">\n                                Usuario\n                            </th>\n                            <th style=\"width: 7%\">\n                                Nombre\n                            </th>\n                            <th style=\"width: 7%\">\n                                Apellido\n                            </th>\n                            <th style=\"width: 10%\">\n                                Banco\n                            </th>\n                            <th style=\"width: 15%\">\n                                Email\n                            </th>\n                            <th style=\"width: 10%\">\n                                Rol\n                            </th>\n                            <th style=\"width: 5%\">\n                                Habilitado\n                            </th>\n                            <th style=\"width: 5%\">\n                                Acciones\n                            </th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr *ngFor=\"let user of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                            <td>\n                                <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"edit(user)\">\n                                    <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                                    <span class=\"pencil\"><img></span>\n                                </button>\n                            </td>\n                            <td>{{user.username}}</td>\n                            <td>{{user.name}}</td>\n                            <td>{{user.surname}}</td>\n                            <td>{{(user.bank)?user.bank.name:'TODOS'}}</td>\n                            <td>{{user.email}}</td>\n                            <td>{{user.rol?.name}}</td>\n                            <td>{{(user.enabled)?'SI':'NO'}}</td>\n                            <td>\n                                <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                        (click)=\"userSelected=user;deleteModal.show();\"\n                                        [disabled]=\"user?.id===userLogged?.id\">\n                                    <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                                    <span class=\"remove\"><img></span>\n                                </button>\n                            </td>\n                        </tr>\n                        </tbody>\n                        <tfoot>\n                        <tr>\n                            <td colspan=\"10\">\n                                <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                            </td>\n                        </tr>\n                        </tfoot>\n                    </table>\n                </div>\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"create()\">\n                    <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n                    <span class=\"plus\"><img></span>\n                    Nuevo\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n         aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog modal-sm\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                        <span aria-hidden=\"true\">&times;</span>\n                    </button>\n                    <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n                </div>\n                <div class=\"modal-body\">\n                    &iquest;Est&aacute; seguro que desea eliminar el operador\n                    <strong>{{userSelected?.username}} - {{userSelected?.name}} {{userSelected?.surname}}</strong>?\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\" (click)=\"remove(deleteModal)\">\n                        Aceptar\n                    </button>\n                    <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\" (click)=\"deleteModal.hide()\">\n                        Cancelar\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var Observable_1 = __webpack_require__(34);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var roles_service_1 = __webpack_require__(635);
	var operators_service_1 = __webpack_require__(636);
	var bank_service_1 = __webpack_require__(631);
	var user_1 = __webpack_require__(844);
	var validators_1 = __webpack_require__(849);
	var OperatorEditorComponent = (function () {
	    function OperatorEditorComponent(rolesService, operatorsService, bankService, route) {
	        this.rolesService = rolesService;
	        this.operatorsService = operatorsService;
	        this.bankService = bankService;
	        this.route = route;
	        this.close = new core_1.EventEmitter();
	        this.loading = false;
	        this.init();
	    }
	    OperatorEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.user = new user_1.User();
	        this.bankSelectedId = '';
	        this.loading = false;
	        this.banks = [];
	        this.roles = [];
	        this.changePassword = false;
	        this.userLoaded = false;
	        this.usernameDuplicate = false;
	    };
	    OperatorEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var userId = params['userId'];
	            if (userId) {
	                _this.userId = userId;
	                _this.createMode = false;
	            }
	            else {
	                _this.userId = null;
	                _this.createMode = true;
	            }
	            _this.getData();
	        });
	    };
	    OperatorEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    OperatorEditorComponent.prototype.passwordAreEqual = function (group) {
	        if (!this.userLoaded || (this.user.id && !this.changePassword)) {
	            return null;
	        }
	        var val1 = this.user.password;
	        var val2 = this.user.repeatPassword;
	        if ((!val1 && !val2) || val1 === val2) {
	            return null;
	        }
	        return {
	            areEqual: true
	        };
	    };
	    OperatorEditorComponent.prototype.triggerPasswordValidators = function () {
	        this.form.controls['password'].updateValueAndValidity();
	        this.form.controls['repeatPassword'].updateValueAndValidity();
	    };
	    OperatorEditorComponent.prototype.validatePasswordRequired = function (group) {
	        if (!this.userLoaded || (this.user.id && !this.changePassword)) {
	            return null;
	        }
	        var val = group.value;
	        if (!val || val === '') {
	            return {
	                required: true
	            };
	        }
	        return null;
	    };
	    OperatorEditorComponent.prototype.validatePasswordMinLength = function (group) {
	        if (!this.userLoaded || (this.user.id && !this.changePassword)) {
	            return null;
	        }
	        var val = group.value;
	        if (val && val.length > 0 && val.length < 6) {
	            return {
	                minLength: true
	            };
	        }
	        return null;
	    };
	    OperatorEditorComponent.prototype.createFormGroup = function () {
	        var group = {};
	        group['username'] = new forms_1.FormControl(null, forms_1.Validators.required);
	        group['name'] = new forms_1.FormControl(null, forms_1.Validators.required);
	        group['surname'] = new forms_1.FormControl(null, forms_1.Validators.required);
	        group['email'] = new forms_1.FormControl(null, [forms_1.Validators.required, validators_1.EMAIL_VALIDATOR]);
	        group['rol'] = new forms_1.FormControl(null, forms_1.Validators.required);
	        group['bank'] = new forms_1.FormControl();
	        group['enabled'] = new forms_1.FormControl();
	        group['password'] = new forms_1.FormControl('', [this.validatePasswordRequired.bind(this), this.validatePasswordMinLength.bind(this), this.passwordAreEqual.bind(this)]);
	        group['repeatPassword'] = new forms_1.FormControl('', [this.validatePasswordRequired.bind(this), this.validatePasswordMinLength.bind(this), this.passwordAreEqual.bind(this)]);
	        this.form = new forms_1.FormGroup(group);
	    };
	    OperatorEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        var forkTasks = [];
	        forkTasks.push(this.rolesService.getRoles());
	        forkTasks.push(this.bankService.getBanks());
	        if (this.userId) {
	            forkTasks.push(this.operatorsService.getUser(this.userId));
	        }
	        else {
	            forkTasks.push(this.operatorsService.getNewUser());
	        }
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los datos del usuario.');
	        });
	    };
	    OperatorEditorComponent.prototype.setData = function (data) {
	        this.loading = false;
	        this.roles = data[0];
	        this.banks = data[1];
	        this.user = new user_1.User(data[data.length - 1]);
	        this.bankSelectedId = (this.user.bank) ? this.user.bank.id : '';
	        this.rolSelectedId = (this.user.rol) ? this.user.rol.id : null;
	        this.userLoaded = true;
	        this.user.password = '';
	        this.user.repeatPassword = '';
	        //this.form.controls['password'].value = '';
	        //this.form.controls['repeatPassword'].value = '';
	    };
	    OperatorEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        if (this.user.id && !this.changePassword) {
	            this.user.password = null;
	            this.user.repeatPassword = null;
	        }
	        this.operatorsService.save(this.user).subscribe(function (saved) {
	            _this.loading = false;
	            _this.user = saved;
	            _this.changePassword = false;
	            _this.successMessage = 'El usuario se guardó con éxito';
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar los datos del usuario.');
	        });
	    };
	    OperatorEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    OperatorEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.user);
	        window.history.back();
	    };
	    OperatorEditorComponent.prototype.updateRolSelected = function (target) {
	        var value = target.value;
	        if (value) {
	            this.user.rol = this.roles.filter(function (rol) {
	                return rol.id == value;
	            })[0];
	        }
	        else {
	            this.user.rol = null;
	        }
	    };
	    OperatorEditorComponent.prototype.updateBankSelected = function (target) {
	        var value = target.value;
	        if (value) {
	            this.user.bank = this.banks.filter(function (bank) {
	                return bank.id == value;
	            })[0];
	        }
	        else {
	            this.user.bank = null;
	        }
	    };
	    OperatorEditorComponent.prototype.validateUsername = function () {
	        var _this = this;
	        this.errorMessage = null;
	        this.operatorsService.getUserByUsername(this.user.username).subscribe(function (user) {
	            _this.usernameDuplicate = !!(user && user.username);
	        }, function (error) {
	            _this.bindError('Ocurrió un error al validar username existente.');
	            _this.usernameDuplicate = false;
	        });
	    };
	    OperatorEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', user_1.User)
	    ], OperatorEditorComponent.prototype, "user", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], OperatorEditorComponent.prototype, "close", void 0);
	    OperatorEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'operator-editor',
	            template: __webpack_require__(1003),
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_bootstrap_1.MODAL_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS
	            ],
	        }), 
	        __metadata('design:paramtypes', [roles_service_1.RolesService, operators_service_1.OperatorsService, bank_service_1.BankService, router_1.ActivatedRoute])
	    ], OperatorEditorComponent);
	    return OperatorEditorComponent;
	}());
	exports.OperatorEditorComponent = OperatorEditorComponent;


/***/ },
/* 1003 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nuevo Operador</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Operador</h2>\n        </div>\n\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"user\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"username\">Nombre de Usuario</label>\n                        <input type=\"text\" class=\"form-control\" id=\"username\"\n                               [(ngModel)]=\"user.username\" name=\"username\" formControlName=\"username\"\n                               (change)=\"validateUsername()\"/>\n\n                        <div *ngIf=\"!form.controls.username.valid && form.controls.username.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                        <div *ngIf=\"user.username && usernameDuplicate\" class=\"alert-danger\">\n                            El username <b>{{user.username}}</b> ya se encuentra registrado en el sistema.\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"name\">Nombre</label>\n                        <input type=\"text\" class=\"form-control\" id=\"name\"\n                               [(ngModel)]=\"user.name\" name=\"name\" formControlName=\"name\"/>\n\n                        <div *ngIf=\"!form.controls.name.valid && form.controls.name.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"surname\">Apellido</label>\n                        <input type=\"text\" class=\"form-control\" id=\"surname\"\n                               [(ngModel)]=\"user.surname\" name=\"surname\" formControlName=\"surname\"/>\n\n                        <div *ngIf=\"!form.controls.surname.valid && form.controls.surname.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"email\">Email</label>\n                        <input type=\"text\" id=\"email\"\n                               class=\"form-control\" formControlName=\"email\"\n                               [(ngModel)]=\"user.email\" name=email placeholder=\"\">\n                        <div\n                                *ngIf=\"!form.controls.email.valid && form.controls.email.errors.required\"\n                                class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                        <div\n                                *ngIf=\"!form.controls.email.valid && form.controls.email.errors.pattern\"\n                                class=\"alert-danger\">{{errorMessages.invalidPattern}}\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"bank\">Banco</label>\n                        <select class=\"form-control\" id=\"bank\"\n                                formControlName=\"bank\" [(ngModel)]=\"bankSelectedId\" name=\"bank\"\n                                (change)=\"updateBankSelected($event.target)\">\n                            <option value=\"\">TODOS</option>\n                            <option *ngFor=\"let bank of banks\" value=\"{{bank.id}}\">{{bank.name}}</option>\n                        </select>\n                        <div\n                                *ngIf=\"!form.controls.bank.valid && form.controls.bank.errors.required\"\n                                class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-6\">\n                        <label>Rol</label>\n                        <select class=\"form-control\"\n                                formControlName=\"rol\" [(ngModel)]=\"rolSelectedId\" name=\"rol\"\n                                (change)=\"updateRolSelected($event.target)\">\n                            <option *ngFor=\"let rol of roles\" value=\"{{rol.id}}\">{{rol.name}}</option>\n                        </select>\n                        <div\n                                *ngIf=\"!form.controls.rol.valid && form.controls.rol.errors.required\"\n                                class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label>Habilitado</label>\n                        <div class=\"form-control\">\n                            <input type=\"checkbox\" [(ngModel)]=\"user.enabled\" name=\"enabled\" formControlName=\"enabled\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\" *ngIf=\"user.id\">\n                    <div class=\"form-group col-sm-12\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"changePassword=true;\"\n                                *ngIf=\"!changePassword\">Cambiar contrase&ntilde;a\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger\" (click)=\"changePassword=false;\"\n                                *ngIf=\"changePassword\">Cancelar cambio de contrase&ntilde;a\n                        </button>\n                    </div>\n                </div>\n                <div class=\"row\" *ngIf=\"!user.id || changePassword\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"password\" *ngIf=\"user.id\">Nueva Contrase&ntilde;a</label>\n                        <label for=\"password\" *ngIf=\"!user.id\">Contrase&ntilde;a</label>\n                        <input class=\"form-control\" type=\"password\" [(ngModel)]=\"user.password\" name=\"password\"\n                               formControlName=\"password\" autocomplete=\"off\" id=\"password\"\n                               (change)=\"triggerPasswordValidators()\"/>\n                        <div *ngIf=\"!form.controls.password.valid && form.controls.password.errors.required\"\n                             class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                        <div *ngIf=\"!form.controls.password.valid && form.controls.password.errors.minLength\"\n                             class=\"alert-danger\">La contrase&ntilde;a debe tener al menos 6 caracteres\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"repeatPassword\">Reingrese la Contrase&ntilde;a</label>\n                        <input class=\"form-control\" type=\"password\" [(ngModel)]=\"user.repeatPassword\"\n                               id=\"repeatPassword\" name=\"repeatPassword\" formControlName=\"repeatPassword\"\n                               autocomplete=\"off\" (change)=\"triggerPasswordValidators()\"/>\n                        <div *ngIf=\"!form.controls.repeatPassword.valid && form.controls.repeatPassword.errors.required\"\n                             class=\"alert-danger\">{{errorMessages.required}}\n                        </div>\n                        <div *ngIf=\"!form.controls.repeatPassword.valid && form.controls.repeatPassword.errors.minLength\"\n                             class=\"alert-danger\">La contrase&ntilde;a debe tener al menos 6 caracteres\n                        </div>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-6\">\n                        <label></label>\n                        <div>\n\t\t                    <span *ngIf=\"(!form.controls.repeatPassword.valid && form.controls.repeatPassword.errors.areEqual) ||\n                                    (!form.controls.password.valid && form.controls.password.errors.areEqual)\"\n                                  class=\"alert alert-danger\">\n\t\t\t\t\t\t\t    Las contrase&ntilde;as no coinciden\n\t\t\t\t\t\t\t</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-sm-12\">\n                        <button type=\"submit\" class=\"btn btn-success\"\n                                [disabled]=\"!form.valid || loading || usernameDuplicate\">Guardar\n                        </button>\n                        <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var clientDocument_service_1 = __webpack_require__(1005);
	var client_service_1 = __webpack_require__(637);
	var Observable_1 = __webpack_require__(34);
	var navigation_service_1 = __webpack_require__(403);
	var tabSelected_service_1 = __webpack_require__(858);
	var core_2 = __webpack_require__(1);
	var login_service_1 = __webpack_require__(404);
	var ClientPanel = (function () {
	    function ClientPanel(navigationService, clientDocumentService, clientService, tabSelectedService, changeDetector, loginService) {
	        this.navigationService = navigationService;
	        this.clientDocumentService = clientDocumentService;
	        this.clientService = clientService;
	        this.tabSelectedService = tabSelectedService;
	        this.changeDetector = changeDetector;
	        this.loginService = loginService;
	        this.init();
	    }
	    ClientPanel.prototype.init = function () {
	        this.isPayReceiptActive = false;
	        this.showProcedureDocuments = false;
	        this.showInfractionDocuments = false;
	        this.showKmDocuments = false;
	        this.showPatentDocuments = false;
	    };
	    ClientPanel.prototype.ngOnInit = function () {
	        this.userLogged = this.loginService.getUserLogged();
	        this.getUser();
	    };
	    ClientPanel.prototype.getUser = function () {
	        var _this = this;
	        if (!this.userLogged) {
	            this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	                _this.userLogged = userLogged;
	                _this.updateUserLogged();
	                _this.getData();
	                _this.showDocuments();
	            }, function () {
	                //Do Nothing.
	            });
	        }
	        else {
	            this.updateUserLogged();
	            this.getData();
	            this.showDocuments();
	        }
	    };
	    ClientPanel.prototype.updateUserLogged = function () {
	        if (this.userLogged.rol.client) {
	            this.bankId = this.userLogged.bank.id.toString();
	        }
	    };
	    ClientPanel.prototype.showPayReceipt = function () {
	        return (this.isPayReceiptActive && this.showInfractionDocuments);
	    };
	    ClientPanel.prototype.showRequestProcedure = function () {
	        return this.showProcedureDocuments;
	    };
	    ClientPanel.prototype.ngAfterViewChecked = function () {
	        this.showDocuments();
	    };
	    ClientPanel.prototype.showDocuments = function () {
	        var tab = this.tabSelectedService.getActiveTab();
	        if (tab === 'kmHistory')
	            this.showKmDocs();
	        if (tab === 'infractions')
	            this.showInfractionDocs();
	        if (tab === 'procedures')
	            this.showProcedureDocs();
	        if (tab === 'patentPayment')
	            this.showPatentDocs();
	    };
	    ClientPanel.prototype.showInfractionDocs = function () {
	        this.showInfractionDocuments = true;
	        this.showProcedureDocuments = false;
	        this.showKmDocuments = false;
	        this.showPatentDocuments = false;
	        this.changeDetector.detectChanges();
	    };
	    ClientPanel.prototype.showProcedureDocs = function () {
	        this.showProcedureDocuments = true;
	        this.showInfractionDocuments = false;
	        this.showKmDocuments = false;
	        this.showPatentDocuments = false;
	        this.changeDetector.detectChanges();
	    };
	    ClientPanel.prototype.showKmDocs = function () {
	        this.showKmDocuments = true;
	        this.showProcedureDocuments = false;
	        this.showInfractionDocuments = false;
	        this.showPatentDocuments = false;
	        this.changeDetector.detectChanges();
	    };
	    ClientPanel.prototype.showPatentDocs = function () {
	        this.showPatentDocuments = true;
	        this.showProcedureDocuments = false;
	        this.showInfractionDocuments = false;
	        this.showKmDocuments = false;
	        this.changeDetector.detectChanges();
	    };
	    ClientPanel.prototype.getData = function () {
	        var forkTasks = [];
	        forkTasks.push(this.clientDocumentService.getClientDocumentsByBank(this.bankId));
	        forkTasks.push(this.clientService.isPayReceiptActive());
	        forkTasks.push(this.clientDocumentService.getClientKmDocumentsByBank(this.bankId));
	        forkTasks.push(this.clientDocumentService.getClientProcedureDocumentsByBank(this.bankId));
	        forkTasks.push(this.clientDocumentService.getClientPatentDocumentsByBank(this.bankId));
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            //this.bindError('Ocurrió un error al cargar los datos del cliente.');
	        });
	    };
	    ClientPanel.prototype.setData = function (data) {
	        this.clientInfractionDocuments = data[0];
	        this.isPayReceiptActive = data[1];
	        this.clientKmDocuments = data[2];
	        this.clientProcedureDocuments = data[3];
	        this.clientPatentDocuments = data[4];
	        // Para filtrar en vista
	        //        this.clientInfractionDocuments = this.filterByBank( this.clientInfractionDocuments );
	        //        this.clientKmDocuments = this.filterByBank( this.clientKmDocuments );
	        //        this.clientProcedureDocuments = this.filterByBank( this.clientProcedureDocuments );
	        //        this.clientPatentDocuments = this.filterByBank( this.clientPatentDocuments );
	    };
	    ClientPanel = __decorate([
	        core_1.Component({
	            selector: 'client-panel',
	            template: __webpack_require__(1006),
	            directives: [router_1.ROUTER_DIRECTIVES]
	        }), 
	        __metadata('design:paramtypes', [navigation_service_1.NavigationService, clientDocument_service_1.ClientDocumentService, client_service_1.ClientService, tabSelected_service_1.TabSelectedService, core_2.ChangeDetectorRef, login_service_1.LoginService])
	    ], ClientPanel);
	    return ClientPanel;
	}());
	exports.ClientPanel = ClientPanel;


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	/**
	 * .
	 * Created by jlado on 16/9/16.
	 */
	var ClientDocumentService = (function () {
	    function ClientDocumentService(backendService) {
	        this.backendService = backendService;
	    }
	    ClientDocumentService.prototype.getClientDocuments = function () {
	        return this.backendService.get("clientDocuments", null);
	    };
	    ClientDocumentService.prototype.save = function (clientDocument) {
	        return this.backendService.put("clientDocument/upload", clientDocument, null);
	    };
	    ClientDocumentService.prototype.saveAll = function (clientDocument) {
	        return this.backendService.post("clientDocuments", clientDocument, null);
	    };
	    ClientDocumentService.prototype.updateClientDocuments = function (clientDocument) {
	        return this.backendService.post("updateClientDocuments", clientDocument, null);
	    };
	    ClientDocumentService.prototype.saveKmAll = function (clientDocument) {
	        return this.backendService.post("clientKmDocuments", clientDocument, null);
	    };
	    ClientDocumentService.prototype.saveProcedureAll = function (clientDocument) {
	        return this.backendService.post("clientProcedureDocuments", clientDocument, null);
	    };
	    ClientDocumentService.prototype.savePatentAll = function (clientDocument) {
	        return this.backendService.post("clientPatentDocuments", clientDocument, null);
	    };
	    ClientDocumentService.prototype.saveKm = function (clientDocument) {
	        return this.backendService.put("clientKmDocument/upload", clientDocument, null);
	    };
	    ClientDocumentService.prototype.savePatent = function (clientDocument) {
	        return this.backendService.put("clientPatentDocument/upload", clientDocument, null);
	    };
	    ClientDocumentService.prototype.saveProcedure = function (clientDocument) {
	        return this.backendService.put("clientProcedureDocument/upload", clientDocument, null);
	    };
	    ClientDocumentService.prototype.getClientKmDocuments = function () {
	        return this.backendService.get("clientKmDocuments", null);
	    };
	    ClientDocumentService.prototype.getClientProcedureDocuments = function () {
	        return this.backendService.get("clientProcedureDocuments", null);
	    };
	    ClientDocumentService.prototype.getClientPatentDocuments = function () {
	        return this.backendService.get("clientPatentDocuments", null);
	    };
	    ClientDocumentService.prototype.delete = function (clientDocumentId) {
	        return this.backendService.delete("clientDocument/" + clientDocumentId, null, null);
	    };
	    ClientDocumentService.prototype.getClientDocumentsByBank = function (bankId) {
	        return this.backendService.post("clientDocumentsByBank", bankId, null);
	    };
	    ClientDocumentService.prototype.getClientKmDocumentsByBank = function (bankId) {
	        return this.backendService.post("clientKmDocumentsByBank", bankId, null);
	    };
	    ClientDocumentService.prototype.getClientProcedureDocumentsByBank = function (bankId) {
	        return this.backendService.post("clientProcedureDocumentsByBank", bankId, null);
	    };
	    ClientDocumentService.prototype.getClientPatentDocumentsByBank = function (bankId) {
	        return this.backendService.post("clientPatentDocumentsByBank", bankId, null);
	    };
	    ClientDocumentService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], ClientDocumentService);
	    return ClientDocumentService;
	}());
	exports.ClientDocumentService = ClientDocumentService;


/***/ },
/* 1006 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\" role=\"navigation\">\n    <div class=\"col-md-2\">\n        <ul class=\"nav nav-list\" id=\"side-menu\">\n            <li><a routerLink=\"home\" routerLinkActive=\"active\">Home</a></li>\n            <li><a routerLink=\"payReceipt\" routerLinkActive=\"active\" *ngIf=\"showPayReceipt()\">Enviar Comprobante de Pago</a></li>\n            <li><a routerLink=\"requestProcedure\" routerLinkActive=\"active\" *ngIf=\"showRequestProcedure()\">Solicitud de Trámite</a></li>\n            <li><a routerLink=\"myProfile\" routerLinkActive=\"active\" *ngIf=\"false\">Mis Datos</a></li>\n            <li><a routerLink=\"contact\" routerLinkActive=\"active\" *ngIf=\"false\">Contacto</a></li>\n        </ul>    \n        \n        <ul class=\"nav nav-list\" id=\"side-menu-infractionfiles\" \n        \t*ngFor=\"let clientDocument of clientInfractionDocuments\">\n            <li><a *ngIf=\"showInfractionDocuments\" href=\"/clientDocument/{{clientDocument.id}}/download\"\n                   target=\"file\" title=\"Descargar\">{{clientDocument.viewname}}</a></li>\n        </ul>\n        <ul class=\"nav nav-list\" id=\"side-menu-kmfiles\" \n        \t*ngFor=\"let clientDocument of clientKmDocuments\">\n            <li><a  *ngIf=\"showKmDocuments\"  href=\"/clientDocument/{{clientDocument.id}}/download\"\n                   target=\"file\" title=\"Descargar\">{{clientDocument.viewname}}</a></li>\n        </ul>\n        <ul class=\"nav nav-list\" id=\"side-menu-procedurefiles\" \n        \t*ngFor=\"let clientDocument of clientProcedureDocuments\">\n            <li><a  *ngIf=\"showProcedureDocuments\" href=\"/clientDocument/{{clientDocument.id}}/download\"\n                   target=\"file\" title=\"Descargar\">{{clientDocument.viewname}}</a></li>\n        </ul>\n        <ul class=\"nav nav-list\" id=\"side-menu-patentfiles\" \n        \t*ngFor=\"let clientDocument of clientPatentDocuments\">\n            <li><a *ngIf=\"showPatentDocuments\" href=\"/clientDocument/{{clientDocument.id}}/download\"\n                   target=\"file\" title=\"Descargar\">{{clientDocument.viewname}}</a></li>\n        </ul>\n        \n    </div>\n    <div class=\"col-md-10\">\n        <router-outlet></router-outlet>\n    </div>\n</div>\t";

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var ng2_file_upload_1 = __webpack_require__(889);
	var client_service_1 = __webpack_require__(637);
	var sendActPayReceiptForm_1 = __webpack_require__(1008);
	var validators_1 = __webpack_require__(849);
	var Observable_1 = __webpack_require__(34);
	var PayReceiptComponent = (function () {
	    function PayReceiptComponent(/*private loginService:LoginService,*/ clientService) {
	        this.clientService = clientService;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    PayReceiptComponent.prototype.init = function () {
	        this.loading = false;
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.sendActPayReceipt = new sendActPayReceiptForm_1.SendActPayReceiptForm();
	        this.uploaderActPayReceipt = new ng2_file_upload_1.FileUploader({});
	        this.hasActPayReceiptDropZoneOver = false;
	        this.infractions = [];
	    };
	    PayReceiptComponent.prototype.ngOnInit = function () {
	        /*let userLogged = this.loginService.getUserLogged();*/
	        this.createFormGroup();
	        this.uploaderActPayReceipt = new ng2_file_upload_1.FileUploader({
	            url: 'client/uploadActPayReceipt',
	            allowedMimeType: validators_1.VALID_MIME_TYPES,
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.getData();
	    };
	    PayReceiptComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            actNumber: new forms_1.FormControl('', [forms_1.Validators.required]),
	            comments: new forms_1.FormControl()
	        });
	    };
	    PayReceiptComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        var forkTasks = [];
	        forkTasks.push(this.clientService.getInfractionActNumbers());
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los datos de infracción.');
	        });
	    };
	    PayReceiptComponent.prototype.setData = function (data) {
	        this.loading = false;
	        this.infractions = data[0];
	    };
	    PayReceiptComponent.prototype.send = function () {
	        var _this = this;
	        this.loading = true;
	        this.clearMessages();
	        this.clientService.sendActPayReceipt(this.sendActPayReceipt).subscribe(function () {
	            _this.loading = false;
	            _this.successMessage = 'El comprobante se envió con éxito.';
	            _this.clearInputs();
	        }, function () {
	            _this.bindError('Ocurrió un error al enviar el comprobante.');
	        });
	    };
	    PayReceiptComponent.prototype.clearInputs = function () {
	        this.sendActPayReceipt = new sendActPayReceiptForm_1.SendActPayReceiptForm();
	        this.uploaderActPayReceipt.clearQueue();
	    };
	    PayReceiptComponent.prototype.removeActPayReceiptFromQuee = function (item) {
	        var _this = this;
	        this.clientService.deleteTempActPayReceipt().subscribe(function (result) { return _this.uploaderActPayReceipt.clearQueue(); }, function () {
	            _this.bindError('Ocurrió un error al remover el comprobante.');
	        });
	    };
	    PayReceiptComponent.prototype.fileOverActPayReceipt = function (e) {
	        this.hasActPayReceiptDropZoneOver = e;
	    };
	    PayReceiptComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    PayReceiptComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], PayReceiptComponent.prototype, "close", void 0);
	    PayReceiptComponent = __decorate([
	        core_1.Component({
	            selector: 'client-pay-receipt',
	            template: __webpack_require__(1009),
	            styles: [__webpack_require__(1010)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS]
	        }), 
	        __metadata('design:paramtypes', [client_service_1.ClientService])
	    ], PayReceiptComponent);
	    return PayReceiptComponent;
	}());
	exports.PayReceiptComponent = PayReceiptComponent;


/***/ },
/* 1008 */
/***/ function(module, exports) {

	"use strict";
	var SendActPayReceiptForm = (function () {
	    function SendActPayReceiptForm(other) {
	        this.comments = '';
	        if (other) {
	            this.actNumber = other.actNumber;
	            this.comments = other.comments;
	        }
	    }
	    return SendActPayReceiptForm;
	}());
	exports.SendActPayReceiptForm = SendActPayReceiptForm;


/***/ },
/* 1009 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\">Enviar Comprobante de Pago</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <div class=\"col-md-12\">\n                <div *ngIf=\"errorMessage\" class=\"alert alert-danger\">{{errorMessage}}</div>\n                <div *ngIf=\"successMessage\" class=\"alert alert-success\">{{successMessage}}</div>\n            </div>\n            <form role=\"form\" (ngSubmit)=\"send()\" [formGroup]=\"form\">\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <label for=\"actNumber\">N&uacute;mero de Acta</label>\n                        <!--<input type=\"text\" name=\"actNumber\" [(ngModel)]=\"sendActPayReceipt.actNumber\"\n                               formControlName=\"actNumber\" placeholder=\"Ingrese el Nro de Acta\"\n                               class=\"form-control\" id=\"actNumber\">-->\n                        <select class=\"form-control\" id=\"actNumber\" formControlName=\"actNumber\"\n                                [(ngModel)]=\"sendActPayReceipt.actNumber\" name=\"actNumber\">\n                            <option *ngFor=\"let infraction of infractions\" [ngValue]=\"infraction.actNumber\">\n                                {{infraction.actNumber}} - {{infraction.vehicle.patent}}\n                            </option>\n                        </select>\n                        <div *ngIf=\"!form.controls.actNumber.valid && form.controls.actNumber.errors.required\"\n                             class=\"alert alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"col-md-8\">\n                        <div class=\"form-group\">\n                            <label for=\"comments\">Comentarios</label>\n                            <textarea class=\"form-control\" rows=\"4\" [(ngModel)]=\"sendActPayReceipt.comments\"\n                                      name=\"comments\" [value]=\"sendActPayReceipt.comments\" id=\"comments\"></textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <div class=\"form-group\">\n                            <label for=\"uploaderActPayReceipt\">Adjuntar Comprobante</label>\n                            <div *ngIf=\"uploaderActPayReceipt.queue?.length == 0\" class=\"alert alert-danger\">\n                                Debe adjuntar un comprobante válido (imagen, PDF, DOC, XLS, ZIP, RAR)\n                            </div>\n                            <div *ngIf=\"uploaderActPayReceipt.queue?.length == 0\">\n                                <div ng2FileDrop id=\"uploaderActPayReceipt\"\n                                     [ngClass]=\"{'nv-file-over': hasActPayReceiptDropZoneOver}\"\n                                     (fileOver)=\"fileOverActPayReceipt($event)\"\n                                     [uploader]=\"uploaderActPayReceipt\"\n                                     class=\"well my-drop-zone\">\n                                    Arrastre el archivo aqu&iacute;\n                                </div>\n                                <input type=\"file\" ng2FileSelect [uploader]=\"uploaderActPayReceipt\"/>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-12\" *ngIf=\"uploaderActPayReceipt.queue?.length > 0\">\n                        <h4>Comprobante a enviar</h4>\n\n                        <table class=\"table\">\n                            <thead>\n                            <tr>\n                                <th width=\"50%\">Nombre</th>\n                                <th>Estado</th>\n                                <th>Acciones</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr *ngFor=\"let item of uploaderActPayReceipt.queue\">\n                                <td><strong>{{item.file.name}}</strong></td>\n                                <td class=\"text-center\">\n                                    <!--<span *ngIf=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                    <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                    <!--<span *ngIf=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                    <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                    <!--<span *ngIf=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n                                    <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                </td>\n                                <td nowrap>\n                                    <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                            (click)=\"item.upload()\"\n                                            [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                        <!--<span class=\"glyphicon glyphicon-upload\"></span>-->\n                                        <span class=\"upload-icon\"><img></span>\n                                        Subir\n                                    </button>\n                                    <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                            (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                        <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                        <span class=\"ban-circle-white\"><img></span>\n                                        Cancelar\n                                    </button>\n                                    <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                            (click)=\"removeActPayReceiptFromQuee(item)\">\n                                        <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                        <span class=\"trash\"><img></span>\n                                        Eliminar\n                                    </button>\n                                </td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <div class=\"text-center\">\n                        <button type=\"submit\" class=\"btn btn-primary\"\n                                [disabled]=\"loading || !form.valid || uploaderActPayReceipt.queue?.length == 0\">Enviar\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1010 */
/***/ function(module, exports) {

	module.exports = "textarea {\n    resize: vertical;\n}"

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var core_1 = __webpack_require__(1);
	var ng2_dragula_1 = __webpack_require__(1012);
	var router_1 = __webpack_require__(350);
	var infractionType_service_1 = __webpack_require__(1024);
	var login_service_1 = __webpack_require__(404);
	/**
	 * .
	 * Created by jlado on 1/9/16.
	 */
	var ConfigInfractionTypesComponent = (function () {
	    function ConfigInfractionTypesComponent(router, infractionTypesService, dragulaService, loginService) {
	        var _this = this;
	        this.router = router;
	        this.infractionTypesService = infractionTypesService;
	        this.dragulaService = dragulaService;
	        this.loginService = loginService;
	        this.init();
	        this.find();
	        dragulaService.setOptions('infractionTypes-bag', {
	            direction: 'vertical',
	            /*Elements in source can be reordered*/
	            copySortSource: true,
	        });
	        dragulaService.dropModel.subscribe(function () {
	            _this.updateOrder();
	        });
	    }
	    ConfigInfractionTypesComponent.prototype.init = function () {
	        this.data = [];
	        this.loading = false;
	        this.deleteMode = false;
	    };
	    ConfigInfractionTypesComponent.prototype.updateOrder = function () {
	        var _this = this;
	        this.data.map(function (infractionType) {
	            infractionType.order = _this.data.indexOf(infractionType) + 1;
	        });
	        this.save();
	    };
	    ConfigInfractionTypesComponent.prototype.find = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.infractionTypesService.getInfractionTypes().subscribe(function (data) { return _this.refreshData(data); }, function () {
	            _this.bindError('Ocurrió un error al buscar los tipos de infracciones.');
	        });
	    };
	    ConfigInfractionTypesComponent.prototype.refreshData = function (data) {
	        this.data = data;
	        this.loading = false;
	    };
	    ConfigInfractionTypesComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.infractionTypesService.saveAll(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            if (_this.deleteMode) {
	                _this.deleteMode = false;
	                _this.successMessage = 'El tipo de infracción se ha eliminado con éxito.';
	            }
	            else {
	                _this.successMessage = 'El nuevo orden de los tipo de infracciones se guardó con éxito.';
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar el nuevo orden de los tipos de infracciones.');
	        });
	    };
	    ConfigInfractionTypesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        if (!this.userLogged) {
	            this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	                _this.userLogged = userLogged;
	                _this.updateUserLogged();
	            }, function () {
	                //Do Nothing.
	            });
	        }
	        else {
	            this.updateUserLogged();
	        }
	    };
	    ConfigInfractionTypesComponent.prototype.updateUserLogged = function () {
	        if (this.userLogged.isAdmin()) {
	            this.isAdmin = true;
	        }
	    };
	    ConfigInfractionTypesComponent.prototype.removeInfractionType = function (deleteModal) {
	        var _this = this;
	        this.clearMessages();
	        this.infractionTypesService.delete(this.infractionTypeSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeInfractionTypeFromView(_this.infractionTypeSelected);
	            _this.deleteMode = true;
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el tipo de infracción.');
	        });
	    };
	    ConfigInfractionTypesComponent.prototype.removeInfractionTypeFromView = function (infractionType) {
	        var index = this.data.indexOf(infractionType);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.infractionTypeSelected = null;
	    };
	    ConfigInfractionTypesComponent.prototype.createInfractionType = function () {
	        this.router.navigate(['app/home/config/createInfractionType']);
	    };
	    ConfigInfractionTypesComponent.prototype.editInfractionType = function (infrationType) {
	        this.router.navigate(['app/home/config/editInfractionType', infrationType.id]);
	    };
	    ConfigInfractionTypesComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.error = null;
	    };
	    ConfigInfractionTypesComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigInfractionTypesComponent = __decorate([
	        core_1.Component({
	            selector: 'config-infractionTypes',
	            template: __webpack_require__(1025),
	            styles: [__webpack_require__(1026)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_dragula_1.Dragula
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	            viewProviders: [
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS,
	                ng2_dragula_1.DragulaService
	            ],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, infractionType_service_1.InfractionTypeService, ng2_dragula_1.DragulaService, login_service_1.LoginService])
	    ], ConfigInfractionTypesComponent);
	    return ConfigInfractionTypesComponent;
	}());
	exports.ConfigInfractionTypesComponent = ConfigInfractionTypesComponent;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var dragula_directive_1 = __webpack_require__(1013);
	var dragula_provider_1 = __webpack_require__(1014);
	__export(__webpack_require__(1013));
	__export(__webpack_require__(1014));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    directives: [dragula_directive_1.Dragula],
	    providers: [dragula_provider_1.DragulaService]
	};


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var dragula_provider_1 = __webpack_require__(1014);
	var dragula = __webpack_require__(1015);
	var Dragula = (function () {
	    function Dragula(el, dragulaService) {
	        this.el = el;
	        this.dragulaService = dragulaService;
	        this.container = el.nativeElement;
	    }
	    Dragula.prototype.ngOnInit = function () {
	        var _this = this;
	        // console.log(this.bag);
	        var bag = this.dragulaService.find(this.bag);
	        var checkModel = function () {
	            if (_this.dragulaModel) {
	                if (_this.drake.models) {
	                    _this.drake.models.push(_this.dragulaModel);
	                }
	                else {
	                    _this.drake.models = [_this.dragulaModel];
	                }
	            }
	        };
	        if (bag) {
	            this.drake = bag.drake;
	            checkModel();
	            this.drake.containers.push(this.container);
	        }
	        else {
	            this.drake = dragula({
	                containers: [this.container]
	            });
	            checkModel();
	            this.dragulaService.add(this.bag, this.drake);
	        }
	    };
	    Dragula.prototype.ngOnChanges = function (changes) {
	        // console.log('dragula.directive: ngOnChanges');
	        // console.log(changes);
	        if (changes && changes['dragulaModel']) {
	            if (this.drake) {
	                if (this.drake.models) {
	                    var modelIndex = this.drake.models.indexOf(changes['dragulaModel'].previousValue);
	                    this.drake.models.splice(modelIndex, 1, changes['dragulaModel'].currentValue);
	                }
	                else {
	                    this.drake.models = [changes['dragulaModel'].currentValue];
	                }
	            }
	        }
	    };
	    __decorate([
	        core_1.Input('dragula'), 
	        __metadata('design:type', String)
	    ], Dragula.prototype, "bag", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], Dragula.prototype, "dragulaModel", void 0);
	    Dragula = __decorate([
	        core_1.Directive({
	            selector: '[dragula]'
	        }), 
	        __metadata('design:paramtypes', [core_1.ElementRef, dragula_provider_1.DragulaService])
	    ], Dragula);
	    return Dragula;
	}());
	exports.Dragula = Dragula;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var dragula = __webpack_require__(1015);
	var core_1 = __webpack_require__(1);
	var DragulaService = (function () {
	    function DragulaService() {
	        this.cancel = new core_1.EventEmitter();
	        this.cloned = new core_1.EventEmitter();
	        this.drag = new core_1.EventEmitter();
	        this.dragend = new core_1.EventEmitter();
	        this.drop = new core_1.EventEmitter();
	        this.out = new core_1.EventEmitter();
	        this.over = new core_1.EventEmitter();
	        this.remove = new core_1.EventEmitter();
	        this.shadow = new core_1.EventEmitter();
	        this.dropModel = new core_1.EventEmitter();
	        this.removeModel = new core_1.EventEmitter();
	        this.events = [
	            'cancel',
	            'cloned',
	            'drag',
	            'dragend',
	            'drop',
	            'out',
	            'over',
	            'remove',
	            'shadow',
	            'dropModel',
	            'removeModel'
	        ];
	        this.bags = [];
	    }
	    DragulaService.prototype.add = function (name, drake) {
	        var bag = this.find(name);
	        if (bag) {
	            throw new Error('Bag named: "' + name + '" already exists.');
	        }
	        bag = {
	            name: name,
	            drake: drake
	        };
	        this.bags.push(bag);
	        if (drake.models) {
	            this.handleModels(name, drake);
	        }
	        if (!bag.initEvents) {
	            this.setupEvents(bag);
	        }
	        return bag;
	    };
	    DragulaService.prototype.find = function (name) {
	        for (var i = 0; i < this.bags.length; i++) {
	            if (this.bags[i].name === name) {
	                return this.bags[i];
	            }
	        }
	    };
	    DragulaService.prototype.destroy = function (name) {
	        var bag = this.find(name);
	        var i = this.bags.indexOf(bag);
	        this.bags.splice(i, 1);
	        bag.drake.destroy();
	    };
	    DragulaService.prototype.setOptions = function (name, options) {
	        var bag = this.add(name, dragula(options));
	        this.handleModels(name, bag.drake);
	    };
	    DragulaService.prototype.handleModels = function (name, drake) {
	        var _this = this;
	        var dragElm;
	        var dragIndex;
	        var dropIndex;
	        var sourceModel;
	        drake.on('remove', function (el, source) {
	            if (!drake.models) {
	                return;
	            }
	            sourceModel = drake.models[drake.containers.indexOf(source)];
	            sourceModel.splice(dragIndex, 1);
	            // console.log('REMOVE');
	            // console.log(sourceModel);
	            _this.removeModel.emit([name, el, source]);
	        });
	        drake.on('drag', function (el, source) {
	            dragElm = el;
	            dragIndex = _this.domIndexOf(el, source);
	        });
	        drake.on('drop', function (dropElm, target, source) {
	            if (!drake.models || !target) {
	                return;
	            }
	            dropIndex = _this.domIndexOf(dropElm, target);
	            sourceModel = drake.models[drake.containers.indexOf(source)];
	            // console.log('DROP');
	            // console.log(sourceModel);
	            if (target === source) {
	                sourceModel.splice(dropIndex, 0, sourceModel.splice(dragIndex, 1)[0]);
	            }
	            else {
	                var notCopy = dragElm === dropElm;
	                var targetModel = drake.models[drake.containers.indexOf(target)];
	                var dropElmModel = notCopy ? sourceModel[dragIndex] : JSON.parse(JSON.stringify(sourceModel[dragIndex]));
	                if (notCopy) {
	                    sourceModel.splice(dragIndex, 1);
	                }
	                targetModel.splice(dropIndex, 0, dropElmModel);
	                target.removeChild(dropElm); // element must be removed for ngFor to apply correctly
	            }
	            _this.dropModel.emit([name, dropElm, target, source]);
	        });
	    };
	    DragulaService.prototype.setupEvents = function (bag) {
	        bag.initEvents = true;
	        var that = this;
	        var emitter = function (type) {
	            function replicate() {
	                var args = Array.prototype.slice.call(arguments);
	                that[type].emit([bag.name].concat(args));
	            }
	            bag.drake.on(type, replicate);
	        };
	        this.events.forEach(emitter);
	    };
	    DragulaService.prototype.domIndexOf = function (child, parent) {
	        return Array.prototype.indexOf.call(parent.children, child);
	    };
	    DragulaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], DragulaService);
	    return DragulaService;
	}());
	exports.DragulaService = DragulaService;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var emitter = __webpack_require__(1016);
	var crossvent = __webpack_require__(1020);
	var classes = __webpack_require__(1023);
	var doc = document;
	var documentElement = doc.documentElement;
	
	function dragula (initialContainers, options) {
	  var len = arguments.length;
	  if (len === 1 && Array.isArray(initialContainers) === false) {
	    options = initialContainers;
	    initialContainers = [];
	  }
	  var _mirror; // mirror image
	  var _source; // source container
	  var _item; // item being dragged
	  var _offsetX; // reference x
	  var _offsetY; // reference y
	  var _moveX; // reference move x
	  var _moveY; // reference move y
	  var _initialSibling; // reference sibling when grabbed
	  var _currentSibling; // reference sibling now
	  var _copy; // item used for copying
	  var _renderTimer; // timer for setTimeout renderMirrorImage
	  var _lastDropTarget = null; // last container item was over
	  var _grabbed; // holds mousedown context until first mousemove
	
	  var o = options || {};
	  if (o.moves === void 0) { o.moves = always; }
	  if (o.accepts === void 0) { o.accepts = always; }
	  if (o.invalid === void 0) { o.invalid = invalidTarget; }
	  if (o.containers === void 0) { o.containers = initialContainers || []; }
	  if (o.isContainer === void 0) { o.isContainer = never; }
	  if (o.copy === void 0) { o.copy = false; }
	  if (o.copySortSource === void 0) { o.copySortSource = false; }
	  if (o.revertOnSpill === void 0) { o.revertOnSpill = false; }
	  if (o.removeOnSpill === void 0) { o.removeOnSpill = false; }
	  if (o.direction === void 0) { o.direction = 'vertical'; }
	  if (o.ignoreInputTextSelection === void 0) { o.ignoreInputTextSelection = true; }
	  if (o.mirrorContainer === void 0) { o.mirrorContainer = doc.body; }
	
	  var drake = emitter({
	    containers: o.containers,
	    start: manualStart,
	    end: end,
	    cancel: cancel,
	    remove: remove,
	    destroy: destroy,
	    canMove: canMove,
	    dragging: false
	  });
	
	  if (o.removeOnSpill === true) {
	    drake.on('over', spillOver).on('out', spillOut);
	  }
	
	  events();
	
	  return drake;
	
	  function isContainer (el) {
	    return drake.containers.indexOf(el) !== -1 || o.isContainer(el);
	  }
	
	  function events (remove) {
	    var op = remove ? 'remove' : 'add';
	    touchy(documentElement, op, 'mousedown', grab);
	    touchy(documentElement, op, 'mouseup', release);
	  }
	
	  function eventualMovements (remove) {
	    var op = remove ? 'remove' : 'add';
	    touchy(documentElement, op, 'mousemove', startBecauseMouseMoved);
	  }
	
	  function movements (remove) {
	    var op = remove ? 'remove' : 'add';
	    crossvent[op](documentElement, 'selectstart', preventGrabbed); // IE8
	    crossvent[op](documentElement, 'click', preventGrabbed);
	  }
	
	  function destroy () {
	    events(true);
	    release({});
	  }
	
	  function preventGrabbed (e) {
	    if (_grabbed) {
	      e.preventDefault();
	    }
	  }
	
	  function grab (e) {
	    _moveX = e.clientX;
	    _moveY = e.clientY;
	
	    var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
	    if (ignore) {
	      return; // we only care about honest-to-god left clicks and touch events
	    }
	    var item = e.target;
	    var context = canStart(item);
	    if (!context) {
	      return;
	    }
	    _grabbed = context;
	    eventualMovements();
	    if (e.type === 'mousedown') {
	      if (isInput(item)) { // see also: https://github.com/bevacqua/dragula/issues/208
	        item.focus(); // fixes https://github.com/bevacqua/dragula/issues/176
	      } else {
	        e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
	      }
	    }
	  }
	
	  function startBecauseMouseMoved (e) {
	    if (!_grabbed) {
	      return;
	    }
	    if (whichMouseButton(e) === 0) {
	      release({});
	      return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
	    }
	    // truthy check fixes #239, equality fixes #207
	    if (e.clientX !== void 0 && e.clientX === _moveX && e.clientY !== void 0 && e.clientY === _moveY) {
	      return;
	    }
	    if (o.ignoreInputTextSelection) {
	      var clientX = getCoord('clientX', e);
	      var clientY = getCoord('clientY', e);
	      var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
	      if (isInput(elementBehindCursor)) {
	        return;
	      }
	    }
	
	    var grabbed = _grabbed; // call to end() unsets _grabbed
	    eventualMovements(true);
	    movements();
	    end();
	    start(grabbed);
	
	    var offset = getOffset(_item);
	    _offsetX = getCoord('pageX', e) - offset.left;
	    _offsetY = getCoord('pageY', e) - offset.top;
	
	    classes.add(_copy || _item, 'gu-transit');
	    renderMirrorImage();
	    drag(e);
	  }
	
	  function canStart (item) {
	    if (drake.dragging && _mirror) {
	      return;
	    }
	    if (isContainer(item)) {
	      return; // don't drag container itself
	    }
	    var handle = item;
	    while (getParent(item) && isContainer(getParent(item)) === false) {
	      if (o.invalid(item, handle)) {
	        return;
	      }
	      item = getParent(item); // drag target should be a top element
	      if (!item) {
	        return;
	      }
	    }
	    var source = getParent(item);
	    if (!source) {
	      return;
	    }
	    if (o.invalid(item, handle)) {
	      return;
	    }
	
	    var movable = o.moves(item, source, handle, nextEl(item));
	    if (!movable) {
	      return;
	    }
	
	    return {
	      item: item,
	      source: source
	    };
	  }
	
	  function canMove (item) {
	    return !!canStart(item);
	  }
	
	  function manualStart (item) {
	    var context = canStart(item);
	    if (context) {
	      start(context);
	    }
	  }
	
	  function start (context) {
	    if (isCopy(context.item, context.source)) {
	      _copy = context.item.cloneNode(true);
	      drake.emit('cloned', _copy, context.item, 'copy');
	    }
	
	    _source = context.source;
	    _item = context.item;
	    _initialSibling = _currentSibling = nextEl(context.item);
	
	    drake.dragging = true;
	    drake.emit('drag', _item, _source);
	  }
	
	  function invalidTarget () {
	    return false;
	  }
	
	  function end () {
	    if (!drake.dragging) {
	      return;
	    }
	    var item = _copy || _item;
	    drop(item, getParent(item));
	  }
	
	  function ungrab () {
	    _grabbed = false;
	    eventualMovements(true);
	    movements(true);
	  }
	
	  function release (e) {
	    ungrab();
	
	    if (!drake.dragging) {
	      return;
	    }
	    var item = _copy || _item;
	    var clientX = getCoord('clientX', e);
	    var clientY = getCoord('clientY', e);
	    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
	    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
	    if (dropTarget && ((_copy && o.copySortSource) || (!_copy || dropTarget !== _source))) {
	      drop(item, dropTarget);
	    } else if (o.removeOnSpill) {
	      remove();
	    } else {
	      cancel();
	    }
	  }
	
	  function drop (item, target) {
	    var parent = getParent(item);
	    if (_copy && o.copySortSource && target === _source) {
	      parent.removeChild(_item);
	    }
	    if (isInitialPlacement(target)) {
	      drake.emit('cancel', item, _source, _source);
	    } else {
	      drake.emit('drop', item, target, _source, _currentSibling);
	    }
	    cleanup();
	  }
	
	  function remove () {
	    if (!drake.dragging) {
	      return;
	    }
	    var item = _copy || _item;
	    var parent = getParent(item);
	    if (parent) {
	      parent.removeChild(item);
	    }
	    drake.emit(_copy ? 'cancel' : 'remove', item, parent, _source);
	    cleanup();
	  }
	
	  function cancel (revert) {
	    if (!drake.dragging) {
	      return;
	    }
	    var reverts = arguments.length > 0 ? revert : o.revertOnSpill;
	    var item = _copy || _item;
	    var parent = getParent(item);
	    var initial = isInitialPlacement(parent);
	    if (initial === false && reverts) {
	      if (_copy) {
	        parent.removeChild(_copy);
	      } else {
	        _source.insertBefore(item, _initialSibling);
	      }
	    }
	    if (initial || reverts) {
	      drake.emit('cancel', item, _source, _source);
	    } else {
	      drake.emit('drop', item, parent, _source, _currentSibling);
	    }
	    cleanup();
	  }
	
	  function cleanup () {
	    var item = _copy || _item;
	    ungrab();
	    removeMirrorImage();
	    if (item) {
	      classes.rm(item, 'gu-transit');
	    }
	    if (_renderTimer) {
	      clearTimeout(_renderTimer);
	    }
	    drake.dragging = false;
	    if (_lastDropTarget) {
	      drake.emit('out', item, _lastDropTarget, _source);
	    }
	    drake.emit('dragend', item);
	    _source = _item = _copy = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
	  }
	
	  function isInitialPlacement (target, s) {
	    var sibling;
	    if (s !== void 0) {
	      sibling = s;
	    } else if (_mirror) {
	      sibling = _currentSibling;
	    } else {
	      sibling = nextEl(_copy || _item);
	    }
	    return target === _source && sibling === _initialSibling;
	  }
	
	  function findDropTarget (elementBehindCursor, clientX, clientY) {
	    var target = elementBehindCursor;
	    while (target && !accepted()) {
	      target = getParent(target);
	    }
	    return target;
	
	    function accepted () {
	      var droppable = isContainer(target);
	      if (droppable === false) {
	        return false;
	      }
	
	      var immediate = getImmediateChild(target, elementBehindCursor);
	      var reference = getReference(target, immediate, clientX, clientY);
	      var initial = isInitialPlacement(target, reference);
	      if (initial) {
	        return true; // should always be able to drop it right back where it was
	      }
	      return o.accepts(_item, target, _source, reference);
	    }
	  }
	
	  function drag (e) {
	    if (!_mirror) {
	      return;
	    }
	    e.preventDefault();
	
	    var clientX = getCoord('clientX', e);
	    var clientY = getCoord('clientY', e);
	    var x = clientX - _offsetX;
	    var y = clientY - _offsetY;
	
	    _mirror.style.left = x + 'px';
	    _mirror.style.top = y + 'px';
	
	    var item = _copy || _item;
	    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
	    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
	    var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
	    if (changed || dropTarget === null) {
	      out();
	      _lastDropTarget = dropTarget;
	      over();
	    }
	    var parent = getParent(item);
	    if (dropTarget === _source && _copy && !o.copySortSource) {
	      if (parent) {
	        parent.removeChild(item);
	      }
	      return;
	    }
	    var reference;
	    var immediate = getImmediateChild(dropTarget, elementBehindCursor);
	    if (immediate !== null) {
	      reference = getReference(dropTarget, immediate, clientX, clientY);
	    } else if (o.revertOnSpill === true && !_copy) {
	      reference = _initialSibling;
	      dropTarget = _source;
	    } else {
	      if (_copy && parent) {
	        parent.removeChild(item);
	      }
	      return;
	    }
	    if (
	      (reference === null && changed) ||
	      reference !== item &&
	      reference !== nextEl(item)
	    ) {
	      _currentSibling = reference;
	      dropTarget.insertBefore(item, reference);
	      drake.emit('shadow', item, dropTarget, _source);
	    }
	    function moved (type) { drake.emit(type, item, _lastDropTarget, _source); }
	    function over () { if (changed) { moved('over'); } }
	    function out () { if (_lastDropTarget) { moved('out'); } }
	  }
	
	  function spillOver (el) {
	    classes.rm(el, 'gu-hide');
	  }
	
	  function spillOut (el) {
	    if (drake.dragging) { classes.add(el, 'gu-hide'); }
	  }
	
	  function renderMirrorImage () {
	    if (_mirror) {
	      return;
	    }
	    var rect = _item.getBoundingClientRect();
	    _mirror = _item.cloneNode(true);
	    _mirror.style.width = getRectWidth(rect) + 'px';
	    _mirror.style.height = getRectHeight(rect) + 'px';
	    classes.rm(_mirror, 'gu-transit');
	    classes.add(_mirror, 'gu-mirror');
	    o.mirrorContainer.appendChild(_mirror);
	    touchy(documentElement, 'add', 'mousemove', drag);
	    classes.add(o.mirrorContainer, 'gu-unselectable');
	    drake.emit('cloned', _mirror, _item, 'mirror');
	  }
	
	  function removeMirrorImage () {
	    if (_mirror) {
	      classes.rm(o.mirrorContainer, 'gu-unselectable');
	      touchy(documentElement, 'remove', 'mousemove', drag);
	      getParent(_mirror).removeChild(_mirror);
	      _mirror = null;
	    }
	  }
	
	  function getImmediateChild (dropTarget, target) {
	    var immediate = target;
	    while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
	      immediate = getParent(immediate);
	    }
	    if (immediate === documentElement) {
	      return null;
	    }
	    return immediate;
	  }
	
	  function getReference (dropTarget, target, x, y) {
	    var horizontal = o.direction === 'horizontal';
	    var reference = target !== dropTarget ? inside() : outside();
	    return reference;
	
	    function outside () { // slower, but able to figure out any position
	      var len = dropTarget.children.length;
	      var i;
	      var el;
	      var rect;
	      for (i = 0; i < len; i++) {
	        el = dropTarget.children[i];
	        rect = el.getBoundingClientRect();
	        if (horizontal && (rect.left + rect.width / 2) > x) { return el; }
	        if (!horizontal && (rect.top + rect.height / 2) > y) { return el; }
	      }
	      return null;
	    }
	
	    function inside () { // faster, but only available if dropped inside a child element
	      var rect = target.getBoundingClientRect();
	      if (horizontal) {
	        return resolve(x > rect.left + getRectWidth(rect) / 2);
	      }
	      return resolve(y > rect.top + getRectHeight(rect) / 2);
	    }
	
	    function resolve (after) {
	      return after ? nextEl(target) : target;
	    }
	  }
	
	  function isCopy (item, container) {
	    return typeof o.copy === 'boolean' ? o.copy : o.copy(item, container);
	  }
	}
	
	function touchy (el, op, type, fn) {
	  var touch = {
	    mouseup: 'touchend',
	    mousedown: 'touchstart',
	    mousemove: 'touchmove'
	  };
	  var pointers = {
	    mouseup: 'pointerup',
	    mousedown: 'pointerdown',
	    mousemove: 'pointermove'
	  };
	  var microsoft = {
	    mouseup: 'MSPointerUp',
	    mousedown: 'MSPointerDown',
	    mousemove: 'MSPointerMove'
	  };
	  if (global.navigator.pointerEnabled) {
	    crossvent[op](el, pointers[type], fn);
	  } else if (global.navigator.msPointerEnabled) {
	    crossvent[op](el, microsoft[type], fn);
	  } else {
	    crossvent[op](el, touch[type], fn);
	    crossvent[op](el, type, fn);
	  }
	}
	
	function whichMouseButton (e) {
	  if (e.touches !== void 0) { return e.touches.length; }
	  if (e.which !== void 0 && e.which !== 0) { return e.which; } // see https://github.com/bevacqua/dragula/issues/261
	  if (e.buttons !== void 0) { return e.buttons; }
	  var button = e.button;
	  if (button !== void 0) { // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
	    return button & 1 ? 1 : button & 2 ? 3 : (button & 4 ? 2 : 0);
	  }
	}
	
	function getOffset (el) {
	  var rect = el.getBoundingClientRect();
	  return {
	    left: rect.left + getScroll('scrollLeft', 'pageXOffset'),
	    top: rect.top + getScroll('scrollTop', 'pageYOffset')
	  };
	}
	
	function getScroll (scrollProp, offsetProp) {
	  if (typeof global[offsetProp] !== 'undefined') {
	    return global[offsetProp];
	  }
	  if (documentElement.clientHeight) {
	    return documentElement[scrollProp];
	  }
	  return doc.body[scrollProp];
	}
	
	function getElementBehindPoint (point, x, y) {
	  var p = point || {};
	  var state = p.className;
	  var el;
	  p.className += ' gu-hide';
	  el = doc.elementFromPoint(x, y);
	  p.className = state;
	  return el;
	}
	
	function never () { return false; }
	function always () { return true; }
	function getRectWidth (rect) { return rect.width || (rect.right - rect.left); }
	function getRectHeight (rect) { return rect.height || (rect.bottom - rect.top); }
	function getParent (el) { return el.parentNode === doc ? null : el.parentNode; }
	function isInput (el) { return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || isEditable(el); }
	function isEditable (el) {
	  if (!el) { return false; } // no parents were editable
	  if (el.contentEditable === 'false') { return false; } // stop the lookup
	  if (el.contentEditable === 'true') { return true; } // found a contentEditable element in the chain
	  return isEditable(getParent(el)); // contentEditable is set to 'inherit'
	}
	
	function nextEl (el) {
	  return el.nextElementSibling || manually();
	  function manually () {
	    var sibling = el;
	    do {
	      sibling = sibling.nextSibling;
	    } while (sibling && sibling.nodeType !== 1);
	    return sibling;
	  }
	}
	
	function getEventHost (e) {
	  // on touchend event, we have to use `e.changedTouches`
	  // see http://stackoverflow.com/questions/7192563/touchend-event-properties
	  // see https://github.com/bevacqua/dragula/issues/34
	  if (e.targetTouches && e.targetTouches.length) {
	    return e.targetTouches[0];
	  }
	  if (e.changedTouches && e.changedTouches.length) {
	    return e.changedTouches[0];
	  }
	  return e;
	}
	
	function getCoord (coord, e) {
	  var host = getEventHost(e);
	  var missMap = {
	    pageX: 'clientX', // IE8
	    pageY: 'clientY' // IE8
	  };
	  if (coord in missMap && !(coord in host) && missMap[coord] in host) {
	    coord = missMap[coord];
	  }
	  return host[coord];
	}
	
	module.exports = dragula;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var atoa = __webpack_require__(1017);
	var debounce = __webpack_require__(1018);
	
	module.exports = function emitter (thing, options) {
	  var opts = options || {};
	  var evt = {};
	  if (thing === undefined) { thing = {}; }
	  thing.on = function (type, fn) {
	    if (!evt[type]) {
	      evt[type] = [fn];
	    } else {
	      evt[type].push(fn);
	    }
	    return thing;
	  };
	  thing.once = function (type, fn) {
	    fn._once = true; // thing.off(fn) still works!
	    thing.on(type, fn);
	    return thing;
	  };
	  thing.off = function (type, fn) {
	    var c = arguments.length;
	    if (c === 1) {
	      delete evt[type];
	    } else if (c === 0) {
	      evt = {};
	    } else {
	      var et = evt[type];
	      if (!et) { return thing; }
	      et.splice(et.indexOf(fn), 1);
	    }
	    return thing;
	  };
	  thing.emit = function () {
	    var args = atoa(arguments);
	    return thing.emitterSnapshot(args.shift()).apply(this, args);
	  };
	  thing.emitterSnapshot = function (type) {
	    var et = (evt[type] || []).slice(0);
	    return function () {
	      var args = atoa(arguments);
	      var ctx = this || thing;
	      if (type === 'error' && opts.throws !== false && !et.length) { throw args.length === 1 ? args[0] : args; }
	      et.forEach(function emitter (listen) {
	        if (opts.async) { debounce(listen, args, ctx); } else { listen.apply(ctx, args); }
	        if (listen._once) { thing.off(type, listen); }
	      });
	      return thing;
	    };
	  };
	  return thing;
	};


/***/ },
/* 1017 */
/***/ function(module, exports) {

	module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ticky = __webpack_require__(1019);
	
	module.exports = function debounce (fn, args, ctx) {
	  if (!fn) { return; }
	  ticky(function run () {
	    fn.apply(ctx || null, args || []);
	  });
	};


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {var si = typeof setImmediate === 'function', tick;
	if (si) {
	  tick = function (fn) { setImmediate(fn); };
	} else {
	  tick = function (fn) { setTimeout(fn, 0); };
	}
	
	module.exports = tick;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(586).setImmediate))

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var customEvent = __webpack_require__(1021);
	var eventmap = __webpack_require__(1022);
	var doc = global.document;
	var addEvent = addEventEasy;
	var removeEvent = removeEventEasy;
	var hardCache = [];
	
	if (!global.addEventListener) {
	  addEvent = addEventHard;
	  removeEvent = removeEventHard;
	}
	
	module.exports = {
	  add: addEvent,
	  remove: removeEvent,
	  fabricate: fabricateEvent
	};
	
	function addEventEasy (el, type, fn, capturing) {
	  return el.addEventListener(type, fn, capturing);
	}
	
	function addEventHard (el, type, fn) {
	  return el.attachEvent('on' + type, wrap(el, type, fn));
	}
	
	function removeEventEasy (el, type, fn, capturing) {
	  return el.removeEventListener(type, fn, capturing);
	}
	
	function removeEventHard (el, type, fn) {
	  var listener = unwrap(el, type, fn);
	  if (listener) {
	    return el.detachEvent('on' + type, listener);
	  }
	}
	
	function fabricateEvent (el, type, model) {
	  var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
	  if (el.dispatchEvent) {
	    el.dispatchEvent(e);
	  } else {
	    el.fireEvent('on' + type, e);
	  }
	  function makeClassicEvent () {
	    var e;
	    if (doc.createEvent) {
	      e = doc.createEvent('Event');
	      e.initEvent(type, true, true);
	    } else if (doc.createEventObject) {
	      e = doc.createEventObject();
	    }
	    return e;
	  }
	  function makeCustomEvent () {
	    return new customEvent(type, { detail: model });
	  }
	}
	
	function wrapperFactory (el, type, fn) {
	  return function wrapper (originalEvent) {
	    var e = originalEvent || global.event;
	    e.target = e.target || e.srcElement;
	    e.preventDefault = e.preventDefault || function preventDefault () { e.returnValue = false; };
	    e.stopPropagation = e.stopPropagation || function stopPropagation () { e.cancelBubble = true; };
	    e.which = e.which || e.keyCode;
	    fn.call(el, e);
	  };
	}
	
	function wrap (el, type, fn) {
	  var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
	  hardCache.push({
	    wrapper: wrapper,
	    element: el,
	    type: type,
	    fn: fn
	  });
	  return wrapper;
	}
	
	function unwrap (el, type, fn) {
	  var i = find(el, type, fn);
	  if (i) {
	    var wrapper = hardCache[i].wrapper;
	    hardCache.splice(i, 1); // free up a tad of memory
	    return wrapper;
	  }
	}
	
	function find (el, type, fn) {
	  var i, item;
	  for (i = 0; i < hardCache.length; i++) {
	    item = hardCache[i];
	    if (item.element === el && item.type === type && item.fn === fn) {
	      return i;
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1021 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	var NativeCustomEvent = global.CustomEvent;
	
	function useNative () {
	  try {
	    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
	    return  'cat' === p.type && 'bar' === p.detail.foo;
	  } catch (e) {
	  }
	  return false;
	}
	
	/**
	 * Cross-browser `CustomEvent` constructor.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
	 *
	 * @public
	 */
	
	module.exports = useNative() ? NativeCustomEvent :
	
	// IE >= 9
	'function' === typeof document.createEvent ? function CustomEvent (type, params) {
	  var e = document.createEvent('CustomEvent');
	  if (params) {
	    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
	  } else {
	    e.initCustomEvent(type, false, false, void 0);
	  }
	  return e;
	} :
	
	// IE <= 8
	function CustomEvent (type, params) {
	  var e = document.createEventObject();
	  e.type = type;
	  if (params) {
	    e.bubbles = Boolean(params.bubbles);
	    e.cancelable = Boolean(params.cancelable);
	    e.detail = params.detail;
	  } else {
	    e.bubbles = false;
	    e.cancelable = false;
	    e.detail = void 0;
	  }
	  return e;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1022 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var eventmap = [];
	var eventname = '';
	var ron = /^on/;
	
	for (eventname in global) {
	  if (ron.test(eventname)) {
	    eventmap.push(eventname.slice(2));
	  }
	}
	
	module.exports = eventmap;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1023 */
/***/ function(module, exports) {

	'use strict';
	
	var cache = {};
	var start = '(?:^|\\s)';
	var end = '(?:\\s|$)';
	
	function lookupClass (className) {
	  var cached = cache[className];
	  if (cached) {
	    cached.lastIndex = 0;
	  } else {
	    cache[className] = cached = new RegExp(start + className + end, 'g');
	  }
	  return cached;
	}
	
	function addClass (el, className) {
	  var current = el.className;
	  if (!current.length) {
	    el.className = className;
	  } else if (!lookupClass(className).test(current)) {
	    el.className += ' ' + className;
	  }
	}
	
	function rmClass (el, className) {
	  el.className = el.className.replace(lookupClass(className), ' ').trim();
	}
	
	module.exports = {
	  add: addClass,
	  rm: rmClass
	};


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	/**
	 * .
	 * Created by jlado on 1/9/16.
	 */
	var InfractionTypeService = (function () {
	    function InfractionTypeService(backendService) {
	        this.backendService = backendService;
	    }
	    InfractionTypeService.prototype.getInfractionTypes = function () {
	        return this.backendService.get("infractionTypes", null);
	    };
	    InfractionTypeService.prototype.getInfractionType = function (infractionTypeId) {
	        return this.backendService.get("infractionType/" + infractionTypeId, null);
	    };
	    InfractionTypeService.prototype.saveAll = function (infractionType) {
	        return this.backendService.post("infractionTypes", infractionType, null);
	    };
	    InfractionTypeService.prototype.save = function (infractionType) {
	        if (infractionType.id != null) {
	            return this.backendService.post("infractionType", infractionType, null);
	        }
	        else {
	            return this.backendService.put("infractionType", infractionType, null);
	        }
	    };
	    InfractionTypeService.prototype.delete = function (infractionTypeId) {
	        return this.backendService.delete("infractionType/" + infractionTypeId, null, null);
	    };
	    InfractionTypeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], InfractionTypeService);
	    return InfractionTypeService;
	}());
	exports.InfractionTypeService = InfractionTypeService;


/***/ },
/* 1025 */
/***/ function(module, exports) {

	module.exports = "<div *ngIf=\"isAdmin\">\n    <div class=\"col-xs-12\">\n        <h1>Infracciones</h1>\n    </div>\n    <div class=\"col-xs-12\">\n        <form class=\"form-inline\">\n            <div class=\"panel panel-default\">\n                <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n            </div>\n\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n            </div>\n        </form>\n\n        <div class='wrapper'>\n            <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-12 col-md-12 infractionTypeRowHeader\">\n                    <div class=\"col-xs-1 col-sm-1 col-md-1\">\n                        <p class=\"infractionTypeHeader\"></p>\n                    </div>\n                    <div class=\"col-xs-4 col-sm-4 col-md-4\">\n                        <p class=\"infractionTypeHeader\">Tipo de infracción</p>\n                    </div>\n                    <div class=\"col-xs-5 col-sm-5 col-md-5\">\n                        <p class=\"infractionTypeHeader\">Descripción</p>\n                    </div>\n                    <div class=\"col-xs-2 col-sm-2 col-md-2\">\n                        <p class=\"infractionTypeHeader\">Acciones</p>\n                    </div>\n                </div>\n            </div>\n            <div>\n                <div class=\"list-group\" [dragula]='\"infractionTypes-bag\"' [dragulaModel]='data'>\n                    <div class=\"list-group-item\" *ngFor=\"let infractionType of data\">\n                        <div class=\"row handable\">\n                            <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                                <div class=\"col-xs-1 col-sm-1 col-md-1\">\n                                    <p class=\"infractionTypeItem\">{{infractionType.order}}</p>\n                                </div>\n                                <div class=\"col-xs-4 col-sm-4 col-md-4\">\n                                    <p class=\"infractionTypeItem\">{{infractionType.name}}</p>\n                                </div>\n                                <div class=\"col-xs-5 col-sm-5 col-md-5\">\n                                    <p class=\"infractionTypeItem\">{{infractionType.description}}</p>\n                                </div>\n                                <div class=\"col-xs-2 col-sm-2 col-md-2 infractionTypeActions\">\n                                    <button class=\"btn btn-primary\" title=\"Editar\"\n                                            (click)=\"editInfractionType(infractionType)\"\n                                            [disabled]=\" infractionType?.name==='Sin tipo'\">\n                                        <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                                        <span class=\"pencil\"><img></span>\n                                    </button>\n                                    <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                            (click)=\"infractionTypeSelected=infractionType;deleteModal.show();\"\n                                            [disabled]=\" infractionType?.name==='Sin tipo'\">\n                                        <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                                        <span class=\"remove\"><img></span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <form class=\"form-inline\">\n            <div class=\"panel panel-default\">\n                <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n            </div>\n\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n            </div>\n        </form>\n\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"createInfractionType()\">\n            <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n            <span class=\"plus\"><img></span>\n             Nuevo\n        </button>\n    </div>\n</div>\n\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n            </div>\n            <div class=\"modal-body\">\n                ¿Está seguro que desea eliminar el tipo de infracción\n                <strong>{{infractionTypeSelected?.name}}</strong>?\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n                        (click)=\"removeInfractionType(deleteModal)\">Aceptar\n                </button>\n                <button type=\"button\" class=\"btn btn-default\" aria-label=\"Cancelar\"\n                        (click)=\"deleteModal.hide()\">Cancelar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1026 */
/***/ function(module, exports) {

	module.exports = ".header {\n    height: 30px;\n    padding-left: 5px;\n    padding-top: 2px;\n    text-align: center;\n}\n\n.left {\n    border-right: 1px solid #000000;\n    padding: 0px;\n    overflow: scroll;\n}\n\n.right {\n    padding: 0px;\n    overflow: scroll;\n}\n\n.gu-mirror {\n    position: fixed !important;\n    margin: 0 !important;\n    z-index: 9999 !important;\n    opacity: 0.8;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n    filter: alpha(opacity=80);\n}\n\n.gu-hide {\n    display: none !important;\n}\n\n.gu-unselectable {\n    -webkit-user-select: none !important;\n    -moz-user-select: none !important;\n    -ms-user-select: none !important;\n    user-select: none !important;\n}\n\n.gu-transit {\n    opacity: 0.2;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n    filter: alpha(opacity=20);\n}\n\n.infractionTypeItem {\n    padding-top: 5px;\n    text-align: center;\n    white-space: normal;\n}\n\n.infractionTypeHeader {\n    padding-bottom: 5px;\n    text-align: center;\n}\n\n.infractionTypeActions {\n    text-align: end;\n}\n\n.infractionTypeRowHeader {\n    font-weight: bold;\n}\n\n.handable {\n    cursor: pointer;\n}"

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var core_1 = __webpack_require__(1);
	var infractionType_1 = __webpack_require__(903);
	var validators_1 = __webpack_require__(849);
	var infractionType_service_1 = __webpack_require__(1024);
	var router_1 = __webpack_require__(350);
	var async_1 = __webpack_require__(1028);
	/**
	 * .
	 * Created by jlado on 5/9/16.
	 */
	var InfractionTypeEditorComponent = (function () {
	    function InfractionTypeEditorComponent(infractionTypeService, route) {
	        this.infractionTypeService = infractionTypeService;
	        this.route = route;
	        this.close = new async_1.EventEmitter();
	        this.init();
	    }
	    InfractionTypeEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.loading = false;
	        this.infractionType = new infractionType_1.InfractionType();
	    };
	    InfractionTypeEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var infractionTypeId = params['infractionTypeId'];
	            if (infractionTypeId) {
	                _this.infractionTypeId = infractionTypeId;
	                _this.createMode = false;
	            }
	            else {
	                _this.infractionTypeId = null;
	                _this.createMode = true;
	            }
	            _this.getData();
	        });
	    };
	    InfractionTypeEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    InfractionTypeEditorComponent.prototype.createFormGroup = function () {
	        var group = {};
	        group['name'] = new forms_1.FormControl(this.infractionType.name);
	        /* Validators.required*/
	        group['description'] = new forms_1.FormControl(this.infractionType.description);
	        this.form = new forms_1.FormGroup(group);
	    };
	    InfractionTypeEditorComponent.prototype.getData = function () {
	        var _this = this;
	        if (this.infractionTypeId) {
	            this.loading = true;
	            this.infractionTypeService.getInfractionType(this.infractionTypeId).subscribe(function (data) {
	                _this.setData(data);
	            }, function () {
	                _this.bindError('Ocurrió un error al obtener los datos del tipo de infracción.');
	            });
	        }
	    };
	    InfractionTypeEditorComponent.prototype.setData = function (data) {
	        this.loading = false;
	        if (this.infractionTypeId) {
	            this.infractionType = data;
	        }
	        else {
	            this.infractionType = new infractionType_1.InfractionType();
	        }
	    };
	    InfractionTypeEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.infractionTypeService.save(this.infractionType).subscribe(function (saved) {
	            _this.loading = false;
	            _this.infractionType = saved;
	            _this.successMessage = 'El tipo de infracción se guardó con éxito';
	            _this.updateViewAfterSave();
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar los datos del tipo de infracción.');
	        });
	    };
	    InfractionTypeEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    InfractionTypeEditorComponent.prototype.updateViewAfterSave = function () {
	        if (this.createMode) {
	            this.infractionType = new infractionType_1.InfractionType();
	        }
	    };
	    InfractionTypeEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.infractionType);
	        window.history.back();
	    };
	    InfractionTypeEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', infractionType_1.InfractionType)
	    ], InfractionTypeEditorComponent.prototype, "infractionType", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], InfractionTypeEditorComponent.prototype, "close", void 0);
	    InfractionTypeEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'infractionType-editor',
	            template: __webpack_require__(1031),
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS
	            ],
	        }), 
	        __metadata('design:paramtypes', [infractionType_service_1.InfractionTypeService, router_1.ActivatedRoute])
	    ], InfractionTypeEditorComponent);
	    return InfractionTypeEditorComponent;
	}());
	exports.InfractionTypeEditorComponent = InfractionTypeEditorComponent;


/***/ },
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nuevo Tipo de Infracción</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Tipo de Infracción</h2>\n        </div>\n\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"infractionType\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\n                <div class=\"row\">\n                    <div class=\"col-sm-4\">\n                        <div class=\"row\">\n                            <div class=\"form-group form-group-sm col-sm-12\">\n                                <label for=\"name\">Nombre</label>\n                                <input type=\"text\" class=\"form-control\" id=\"name\"\n                                       [(ngModel)]=\"infractionType.name\" name=\"name\" formControlName=\"name\"/>\n\n                                <div *ngIf=\"!form.controls.name.valid && form.controls.name.errors.required\"\n                                     class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                            </div>\n\n                            <div class=\"form-group form-group-sm col-sm-12\">\n                                <label for=\"description\">Descripción</label>\n                                <input type=\"text\" class=\"form-control\" id=\"description\"\n                                       [(ngModel)]=\"infractionType.description\" name=\"description\"\n                                       formControlName=\"description\"/>\n\n                                <div *ngIf=\"!form.controls.description.valid && form.controls.description.errors.required\"\n                                     class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"col-sm-12\">\n                    <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"!form.valid || loading\">Guardar\n                    </button>\n                    <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_dragula_1 = __webpack_require__(1012);
	var clientDocument_service_1 = __webpack_require__(1005);
	var ng2_file_upload_1 = __webpack_require__(889);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var core_2 = __webpack_require__(1);
	/**
	 * .
	 * Created by jlado on 6/9/16.
	 */
	var ConfigClientDocumentsComponent = (function () {
	    function ConfigClientDocumentsComponent(clientDocumentService, dragulaService, loginService, changeDetector) {
	        var _this = this;
	        this.clientDocumentService = clientDocumentService;
	        this.dragulaService = dragulaService;
	        this.loginService = loginService;
	        this.changeDetector = changeDetector;
	        this.init();
	        this.find();
	        dragulaService.setOptions('clientDocuments-bag', {
	            direction: 'vertical',
	            /*Elements in source can be reordered*/
	            copySortSource: true
	        });
	        dragulaService.dropModel.subscribe(function () {
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al ordenar los archivos.');
	        });
	    }
	    ConfigClientDocumentsComponent.prototype.init = function () {
	        this.pageHeader = "Archivos de Tomador";
	        this.data = [];
	        this.uploaderClientDocument = new ng2_file_upload_1.FileUploader({
	            url: 'clientDocument/upload',
	            removeAfterUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.hasClientDocumentDropZoneOver = false;
	        this.loading = false;
	        this.uploading = false;
	        this.deleteMode = false;
	    };
	    ConfigClientDocumentsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        if (!this.userLogged) {
	            this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	                _this.userLogged = userLogged;
	                _this.updateUserLogged();
	            }, function () {
	                //Do Nothing.
	            });
	        }
	        else {
	            this.updateUserLogged();
	        }
	    };
	    ConfigClientDocumentsComponent.prototype.updateUserLogged = function () {
	        if (this.userLogged.isAdmin()) {
	            this.isAdmin = true;
	        }
	        if (this.userLogged.rol.name === "OPERADOR DE BANCO" || this.userLogged.rol.name === "Operador Banco Con Trámite") {
	            this.isBank = true;
	        }
	    };
	    ConfigClientDocumentsComponent.prototype.setCheckedDocs = function () {
	        var _this = this;
	        this.bankId = this.userLogged.bank.id;
	        for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
	            var doc = _a[_i];
	            if (doc.bankIds.length > 0) {
	                if (doc.bankIds.some(function (x) { return x === _this.bankId.toString(); })) {
	                    doc.enabled = true;
	                }
	                else {
	                    doc.enabled = false;
	                }
	            }
	        }
	    };
	    ConfigClientDocumentsComponent.prototype.enableOrDisableDocument = function () {
	        var _this = this;
	        this.disableCheckbox = true;
	        var isEnabled = this.clientDocumentSelected.enabled;
	        if (isEnabled) {
	            this.clientDocumentSelected.enabled = false;
	            this.clientDocumentSelected.bankIds = this.clientDocumentSelected.bankIds.filter(function (id) { return id !== _this.bankId.toString(); });
	            setTimeout(function () {
	                _this.disableCheckbox = false;
	            }, 150);
	            this.setCheckedDocs();
	        }
	        else if (!isEnabled) {
	            this.clientDocumentSelected.enabled = true;
	            this.clientDocumentSelected.bankIds.push(this.bankId.toString());
	            setTimeout(function () {
	                _this.disableCheckbox = false;
	            }, 150);
	            this.setCheckedDocs();
	        }
	    };
	    ConfigClientDocumentsComponent.prototype.updateAllEnabled = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.updateClientDocuments(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            _this.successMessage = 'Se habilitaron los archivos con éxito.';
	            _this.setCheckedDocs();
	        }, function () {
	            _this.bindError('Ocurrió un error al habilitar los archivos.');
	        });
	    };
	    ConfigClientDocumentsComponent.prototype.find = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.getClientDocuments().subscribe(function (data) {
	            _this.refreshData(data);
	            if (_this.uploading) {
	                _this.successMessage = 'Se guardaron con éxito el/los nuevo/s archivo/s.';
	                _this.uploading = false;
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar los archivos.');
	        });
	    };
	    ConfigClientDocumentsComponent.prototype.updateOrder = function () {
	        var _this = this;
	        this.data.map(function (clientDocument) {
	            clientDocument.order = _this.data.indexOf(clientDocument) + 1;
	        });
	        this.saveOrder();
	    };
	    ConfigClientDocumentsComponent.prototype.saveOrder = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.saveAll(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            if (_this.deleteMode) {
	                _this.deleteMode = false;
	                _this.successMessage = 'El archivo se ha eliminado con éxito.';
	            }
	            else {
	                _this.successMessage = 'El nuevo orden de los archivos se guardó con éxito.';
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar el nuevo orden de los archivos.');
	        });
	    };
	    ConfigClientDocumentsComponent.prototype.waitClientDocumentUploaded = function () {
	        if (this.clientDocumentUploading.isSuccess) {
	            this.find();
	        }
	        else {
	            setTimeout(this.waitClientDocumentUploaded.bind(this), 3000);
	        }
	    };
	    ConfigClientDocumentsComponent.prototype.save = function () {
	        var _this = this;
	        if (this.uploaderClientDocument.queue.length > 0) {
	            this.clearMessages();
	            this.loading = true;
	            this.uploaderClientDocument.queue.map(function (clientDocument) {
	                clientDocument.upload();
	                _this.clientDocumentUploading = clientDocument;
	                _this.uploading = true;
	                _this.waitClientDocumentUploaded();
	            });
	            this.find();
	            if (!this.uploaderClientDocument.isUploading) {
	                this.bindError('Ocurrió un error al guardar el/los archivo/s.');
	            }
	            this.loading = false;
	        }
	    };
	    ConfigClientDocumentsComponent.prototype.refreshData = function (data) {
	        this.data = data;
	        if (this.isBank) {
	            this.setCheckedDocs();
	        }
	        this.loading = false;
	    };
	    ConfigClientDocumentsComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.error = null;
	    };
	    ConfigClientDocumentsComponent.prototype.removeClientDocument = function (deleteModal) {
	        var _this = this;
	        this.clearMessages();
	        this.clientDocumentService.delete(this.clientDocumentSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeClientDocumentFromView(_this.clientDocumentSelected);
	            _this.deleteMode = true;
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el archivo.');
	        });
	    };
	    ConfigClientDocumentsComponent.prototype.removeClientDocumentFromView = function (clientDocument) {
	        var index = this.data.indexOf(clientDocument);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.clientDocumentSelected = null;
	    };
	    ConfigClientDocumentsComponent.prototype.fileOverClientDocument = function (e) {
	        this.hasClientDocumentDropZoneOver = e;
	    };
	    ConfigClientDocumentsComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigClientDocumentsComponent = __decorate([
	        core_1.Component({
	            selector: 'config-clientDocuments',
	            template: __webpack_require__(1033),
	            styles: [__webpack_require__(1034)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES,
	                ng2_dragula_1.Dragula
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	            viewProviders: [
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS,
	                ng2_dragula_1.DragulaService
	            ],
	        }), 
	        __metadata('design:paramtypes', [clientDocument_service_1.ClientDocumentService, ng2_dragula_1.DragulaService, login_service_1.LoginService, core_2.ChangeDetectorRef])
	    ], ConfigClientDocumentsComponent);
	    return ConfigClientDocumentsComponent;
	}());
	exports.ConfigClientDocumentsComponent = ConfigClientDocumentsComponent;


/***/ },
/* 1033 */
/***/ function(module, exports) {

	module.exports = "<div>\n\t<div class=\"col-xs-12\">\n\t\t<h1>{{pageHeader}}</h1>\n\t</div>\n\t<div class=\"col-xs-12\">\n\t\t<form class=\"form-inline\">\n\t\t\t<div class=\"panel panel-default\">\n\t\t\t\t<div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n\t\t\t\t<div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n\t\t\t\t\t<i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"text-center\" [ngClass]=\"{ 'hidden': !uploading }\">\n\t\t\t\t\t<i class=\"fa fa-floppy-o\" style=\"font-size: 24px\"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\n\t\t<div class='wrapper'\n\t\t\t*ngIf=\"uploaderClientDocument.getNotUploadedItems().length == 0 && !uploading\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12 clientDocumentRowHeader\">\n\t\t\t\t\t<div class=\"col-xs-2 col-sm-2 col-md-2\">\n\t\t\t\t\t\t<p class=\"clientDocumentHeader\"></p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-xs-6 col-sm-6 col-md-6\">\n\t\t\t\t\t\t<p class=\"clientDocumentHeader\">Nombre</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div *ngIf=\"isAdmin\" class=\"col-xs-4 col-sm-4 col-md-4\">\n\t\t\t\t\t\t<p class=\"clientDocumentActionsHeader\">Acciones</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div *ngIf=\"isBank\">\n\t\t\t\t\t\t<button\n\t\t\t\t\t\t\tclass=\"btn btn-success clientDocumentActions buttonSaveCheckbox\"\n\t\t\t\t\t\t\ttitle=\"Guardar cambios\" (click)=\"updateAllEnabled();\">Guardar\n\t\t\t\t\t\t\tcambios</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div *ngIf=\"isAdmin\" class=\"list-group\"\n\t\t\t\t[dragula]='\"clientDocuments-bag\"' [(dragulaModel)]='data'>\n\t\t\t\t<div class=\"list-group-item\" *ngFor=\"let clientDocument of data\">\n\t\t\t\t\t<div class=\"row handable\">\n\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\n\t\t\t\t\t\t\t<div class=\"col-xs-2 col-sm-2 col-md-2\">\n\t\t\t\t\t\t\t\t<p class=\"clientDocumentItem\">{{clientDocument.order}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-xs-6 col-sm-6 col-md-6\">\n\t\t\t\t\t\t\t\t<p class=\"clientDocumentItem\">{{clientDocument.viewname}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\tclass=\"col-xs-4 col-sm-4 col-md-4 clientDocumentActions\">\n\t\t\t\t\t\t\t\t<a class=\"btn\"\n\t\t\t\t\t\t\t\t\thref=\"/clientDocument/{{clientDocument.id}}/download\"\n\t\t\t\t\t\t\t\t\ttarget=\"file\" title=\"Descargar\"> <!--<span class=\"glyphicon glyphicon-download-alt\"></span>-->\n\t\t\t\t\t\t\t\t\t<span class=\"download-alt\"><img></span>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<button class=\"btn btn-danger\" title=\"Eliminar\"\n\t\t\t\t\t\t\t\t\t(click)=\"clientDocumentSelected=clientDocument;deleteModal.show();\">\n\t\t\t\t\t\t\t\t\t<span class=\"remove\"><img></span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div *ngIf=\"isBank\" class=\"list-group\">\n\t\t\t\t<div class=\"list-group-item\" *ngFor=\"let clientDocument of data\">\n\t\t\t\t\t<div class=\"row handable\">\n\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\n\t\t\t\t\t\t\t<div class=\"col-xs-2 col-sm-2 col-md-2\">\n\t\t\t\t\t\t\t\t<p class=\"clientDocumentItem\">{{clientDocument.order}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-xs-6 col-sm-6 col-md-6\">\n\t\t\t\t\t\t\t\t<p class=\"clientDocumentItem\">{{clientDocument.viewname}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\tclass=\"col-xs-4 col-sm-4 col-md-4 clientDocumentActions\">\n\t\t\t\t\t\t\t\t<a class=\"btn downloadButtonMargin\"\n\t\t\t\t\t\t\t\t\thref=\"/clientDocument/{{clientDocument.id}}/download\"\n\t\t\t\t\t\t\t\t\ttarget=\"file\" title=\"Descargar\"> <span class=\"download-alt\"><img></span>\n\t\t\t\t\t\t\t\t</a> <label> <input class=\"checkboxHandable\" type=\"checkbox\"\n\t\t\t\t\t\t\t\t\tname=\"clientDocumentEnableOptions\" [disabled]=\"loading\"\n\t\t\t\t\t\t\t\t\t[checked]=\"clientDocument.enabled\"\n\t\t\t\t\t\t\t\t\t(change)=\"clientDocumentSelected=clientDocument;enableOrDisableDocument();\">\n\t\t\t\t\t\t\t\t\t&nbsp;Habilitar\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div *ngIf=\"isAdmin\" class=\"row\">\n\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\n\t\t\t\t<div class=\"col-xs-10 col-sm-10 col-md-10 fileUploader\">\n\t\t\t\t\t<label class=\"hidden\" for=\"clientDocument\">Nuevo Archivo\n\t\t\t\t\t\tTomador</label>\n\t\t\t\t\t<div ng2FileDrop\n\t\t\t\t\t\t[ngClass]=\"{'nv-file-over': hasClientDocumentDropZoneOver}\"\n\t\t\t\t\t\t(fileOver)=\"fileOverClientDocument($event)\"\n\t\t\t\t\t\t[uploader]=\"uploaderClientDocument\" class=\"well my-drop-zone\">Arrastre\n\t\t\t\t\t\tel archivo tomador aquí</div>\n\t\t\t\t\t<input type=\"file\" id=\"clientDocument\" ng2FileSelect\n\t\t\t\t\t\t[uploader]=\"uploaderClientDocument\" multiple />\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-xs-2 col-sm-2 col-md-2 saveContainer\">\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-success\"\n\t\t\t\t\t\t[disabled]=\"uploaderClientDocument.queue.length == 0 || loading || uploading\"\n\t\t\t\t\t\t(click)=\"save()\">Guardar</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"row\" *ngIf=\"uploaderClientDocument.queue?.length > 0\">\n\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\n\t\t\t\t<h4>Archivos Tomador pendientes de confirmación</h4>\n\n\t\t\t\t<table class=\"table\">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th width=\"50%\">Nombre</th>\n\t\t\t\t\t\t\t<th>Tipo</th>\n\t\t\t\t\t\t\t<th>Estado</th>\n\t\t\t\t\t\t\t<th>Acciones</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr *ngFor=\"let clientDocument of uploaderClientDocument.queue\">\n\t\t\t\t\t\t\t<td><strong>{{clientDocument.file.name}}</strong></td>\n\t\t\t\t\t\t\t<td><strong>{{clientDocument.file.type}}</strong></td>\n\t\t\t\t\t\t\t<td class=\"text-center\">\n\t\t\t\t\t\t\t\t<!--<span *ngIf=\"clientDocument.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n\t\t\t\t\t\t\t\t<span class=\"ok-icon\" *ngIf=\"clientDocument.isSuccess\"><img></span>\n\t\t\t\t\t\t\t\t<!--<span *ngIf=\"clientDocument.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n\t\t\t\t\t\t\t\t<span class=\"remove\" *ngIf=\"clientDocument.isError\"><img></span>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t<td nowrap>\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-danger btn-xs\"\n\t\t\t\t\t\t\t\t\t(click)=clientDocument.remove()\n\t\t\t\t\t\t\t\t\t[disabled]=\"clientDocument.isUploading || clientDocument.isSuccess\">\n\t\t\t\t\t\t\t\t\t<!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n\t\t\t\t\t\t\t\t\t<span class=\"trash\"><img></span> Eliminar\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t<tr *ngIf=\"uploaderClientDocument.queue?.length == 0\">\n\t\t\t\t\t\t\t<td colspan=\"4\" class=\"text-center\">No hay archivos tomador\n\t\t\t\t\t\t\t\tpendientes de confirmación</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\"\n\trole=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n\t<div class=\"modal-dialog modal-sm\">\n\t\t<div class=\"modal-content\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<button type=\"button\" class=\"close\" aria-label=\"Close\"\n\t\t\t\t\t(click)=\"deleteModal.hide()\">\n\t\t\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t\t\t</button>\n\t\t\t\t<h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n\t\t\t</div>\n\t\t\t<div class=\"modal-body\">\n\t\t\t\t¿Está seguro que desea eliminar el archivo tomador <strong>{{clientDocumentSelected?.name}}</strong>?\n\t\t\t</div>\n\t\t\t<div class=\"modal-footer\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n\t\t\t\t\t(click)=\"removeClientDocument(deleteModal)\">Aceptar</button>\n\t\t\t\t<button type=\"button\" class=\"btn btn-default\" aria-label=\"Cancelar\"\n\t\t\t\t\t(click)=\"deleteModal.hide()\">Cancelar</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>";

/***/ },
/* 1034 */
/***/ function(module, exports) {

	module.exports = ".header {\n\theight: 30px;\n\tpadding-left: 5px;\n\tpadding-top: 2px;\n\ttext-align: center;\n}\n\n.left {\n\tborder-right: 1px solid #000000;\n\tpadding: 0px;\n\toverflow: scroll;\n}\n\n.right {\n\tpadding: 0px;\n\toverflow: scroll;\n}\n\n.gu-mirror {\n\tposition: fixed !important;\n\tmargin: 0 !important;\n\tz-index: 9999 !important;\n\topacity: 0.8;\n\t-ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n\tfilter: alpha(opacity = 80);\n}\n\n.gu-hide {\n\tdisplay: none !important;\n}\n\n.gu-unselectable {\n\t-webkit-user-select: none !important;\n\t-moz-user-select: none !important;\n\t-ms-user-select: none !important;\n\tuser-select: none !important;\n}\n\n.gu-transit {\n\topacity: 0.2;\n\t-ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n\tfilter: alpha(opacity = 20);\n}\n\n.clientDocumentItem {\n\tpadding-top: 5px;\n\ttext-align: center;\n\twhite-space: normal;\n}\n\n.clientDocumentHeader {\n\tpadding-bottom: 5px;\n\ttext-align: center;\n}\n\n.clientDocumentActionsHeader {\n\ttext-align: end;\n}\n\n.clientDocumentActions {\n\ttext-align: end;\n}\n\n.clientDocumentRowHeader {\n\tfont-weight: bold;\n}\n\n.handable {\n\tcursor: pointer;\n}\n\n.checkboxHandable {\n\twidth: 15px;\n\theight: 15px;\n\tcursor: pointer;\n\tmargin-top: 6px;\n}\n\n.fileUploader {\n\tmin-height: 100px;\n}\n\n.saveContainer {\n\ttext-align: center;\n\tmargin-top: 30px;\n}\n\n/* .checkboxLabel { */\n/* \tborder: 1px solid #ccc; */\n/* \tpadding: 10px; */\n/* \tmargin: 0 0 10px; */\n/* \tdisplay: block; */\n/* } */\n\n/* .checkboxLabel:hover { */\n/* \tbackground: #eee; */\n/* \tcursor: pointer; */\n/* } */\n\n.downloadButtonMargin {\n\tmargin-bottom: 15px;\n}\n\n.buttonSaveCheckbox {\n\tmargin-left: 170px;\n\tmargin-bottom: 10px;\n}"

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var bank_1 = __webpack_require__(875);
	var bank_service_1 = __webpack_require__(631);
	var mailTemplate_1 = __webpack_require__(1036);
	var mailTemplate_service_1 = __webpack_require__(1039);
	var actionTrigger_1 = __webpack_require__(1037);
	var actionTrigger_service_1 = __webpack_require__(1040);
	/**
	 * .
	 * Created by jlado on 13/9/16.
	 */
	var ConfigMailTemplatesComponent = (function () {
	    function ConfigMailTemplatesComponent(router, mailTemplateService, actionTriggerService, bankService) {
	        var _this = this;
	        this.router = router;
	        this.mailTemplateService = mailTemplateService;
	        this.actionTriggerService = actionTriggerService;
	        this.bankService = bankService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los bancos.');
	        });
	        actionTriggerService.getActionTriggers().subscribe(this.setActionTriggers.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar las acciones disparadoras.');
	        });
	        this.form.valueChanges
	            .debounceTime(400)
	            .subscribe(this.find.bind(this));
	        /*Default: mostrar todos los templates de mail*/
	        this.find();
	    }
	    ConfigMailTemplatesComponent.prototype.init = function () {
	        this.data = [];
	        this.banks = [];
	        this.actionTriggers = [];
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	        this.bankTodos = new bank_1.Bank();
	        this.bankTodos.id = '';
	        this.bankTodos.name = 'TODOS';
	        this.actionTriggerTodos = new actionTrigger_1.ActionTrigger();
	        this.actionTriggerTodos.id = '';
	        this.actionTriggerTodos.description = 'TODOS';
	        this.filter = new mailTemplate_1.MailTemplate();
	        this.form = new forms_1.FormGroup({
	            actionTrigger: new forms_1.FormControl(),
	            bank: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl()
	        });
	        this.filter.bank = this.bankTodos;
	        this.filter.action = this.actionTriggerTodos;
	    };
	    ConfigMailTemplatesComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	        if (banks.length == 1) {
	            this.filter.bank = banks[0];
	        }
	    };
	    ConfigMailTemplatesComponent.prototype.setActionTriggers = function (actionTriggers) {
	        this.actionTriggers = actionTriggers;
	        if (actionTriggers.length == 1) {
	            this.filter.action = actionTriggers[0];
	        }
	    };
	    ConfigMailTemplatesComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    ConfigMailTemplatesComponent.prototype.filterEmpty = function () {
	        return !(this.filter.bank.id != '' || this.filter.action.id != '');
	    };
	    ConfigMailTemplatesComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        //if (!this.filterEmpty()) {
	        this.loading = true;
	        this.mailTemplateService.findMailTemplates(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	            _this.refreshData(data);
	            _this.page = page;
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar los correos.');
	        });
	        //}
	    };
	    ConfigMailTemplatesComponent.prototype.refreshData = function (page) {
	        this.data = page.content;
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    ConfigMailTemplatesComponent.prototype.removeItem = function (deleteModal) {
	        var _this = this;
	        this.error = null;
	        this.mailTemplateService.delete(this.mailTemplateSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeItemFromView(_this.mailTemplateSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el correo.');
	        });
	    };
	    ConfigMailTemplatesComponent.prototype.removeItemFromView = function (mailTemplate) {
	        var index = this.data.indexOf(mailTemplate);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.mailTemplateSelected = null;
	    };
	    ConfigMailTemplatesComponent.prototype.editItem = function (mailTemplate) {
	        this.router.navigate(['app/home/editMailTemplate', mailTemplate.id]);
	    };
	    ConfigMailTemplatesComponent.prototype.createMailTemplate = function () {
	        this.router.navigate(['app/home/createMailTemplate']);
	    };
	    ConfigMailTemplatesComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    ConfigMailTemplatesComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigMailTemplatesComponent.prototype.createPreviewMailTemplate = function (templateBody) {
	        var _this = this;
	        this.loading = true;
	        if (templateBody.length == 0) {
	            templateBody = "VACÍO.";
	        }
	        this.mailTemplateService.previewMailTemplate(templateBody).subscribe(function (mailTemplateTraduced) {
	            _this.loading = false;
	            _this.mailTemplateTraduced = mailTemplateTraduced.templateBody.toString();
	            _this.bodyMailModal.show();
	        }, function () {
	            _this.bindError('Ocurrió un error al generar la vista previa.');
	            _this.loading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('bodyMailModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], ConfigMailTemplatesComponent.prototype, "bodyMailModal", void 0);
	    ConfigMailTemplatesComponent = __decorate([
	        core_1.Component({
	            selector: 'config-mailTemplates',
	            template: __webpack_require__(1041),
	            styles: [__webpack_require__(1042)],
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_1.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, mailTemplate_service_1.MailTemplateService, actionTrigger_service_1.ActionTriggerService, bank_service_1.BankService])
	    ], ConfigMailTemplatesComponent);
	    return ConfigMailTemplatesComponent;
	}());
	exports.ConfigMailTemplatesComponent = ConfigMailTemplatesComponent;


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var bank_1 = __webpack_require__(875);
	var actionTrigger_1 = __webpack_require__(1037);
	var mailReceiverType_1 = __webpack_require__(1038);
	/**
	 * .
	 * Created by jlado on 13/9/16.
	 */
	var MailTemplate = (function () {
	    function MailTemplate(other) {
	        this.action = new actionTrigger_1.ActionTrigger(null);
	        this.receivers = [];
	        this.bank = new bank_1.Bank(null);
	        if (other) {
	            this.id = other.id;
	            this.action = new actionTrigger_1.ActionTrigger(other.action);
	            this.copyTo = other.copyTo;
	            this.receivers = other.receivers.map(function (receiverType) { return new mailReceiverType_1.MailReceiverType(receiverType); });
	            this.description = other.description;
	            this.periodicity = other.periodicity;
	            this.templateBody = other.templateBody;
	            this.templateSubject = other.templateSubject;
	            this.bank = new bank_1.Bank(other.bank);
	        }
	    }
	    return MailTemplate;
	}());
	exports.MailTemplate = MailTemplate;


/***/ },
/* 1037 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * .
	 * Created by jlado on 13/9/16.
	 */
	var ActionTrigger = (function () {
	    function ActionTrigger(other) {
	        if (other) {
	            this.id = other.id;
	            this.description = other.description;
	        }
	    }
	    ActionTrigger.prototype.toString = function () {
	        return this.description;
	    };
	    return ActionTrigger;
	}());
	exports.ActionTrigger = ActionTrigger;


/***/ },
/* 1038 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * .
	 * Created by jlado on 13/9/16.
	 */
	var MailReceiverType = (function () {
	    function MailReceiverType(other) {
	        if (other) {
	            this.id = other.id;
	            this.description = other.description;
	        }
	    }
	    MailReceiverType.prototype.toString = function () {
	        return this.description;
	    };
	    return MailReceiverType;
	}());
	exports.MailReceiverType = MailReceiverType;
	/*Necesario para el selector multiple*/
	var MailReceiverTypeOption = (function () {
	    function MailReceiverTypeOption(other) {
	        if (other) {
	            this.id = other.id;
	            this.text = other.description;
	        }
	    }
	    MailReceiverTypeOption.prototype.toString = function () {
	        return this.text;
	    };
	    return MailReceiverTypeOption;
	}());
	exports.MailReceiverTypeOption = MailReceiverTypeOption;


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	/**
	 * .
	 * Created by jlado on 13/9/16.
	 */
	var MailTemplateService = (function () {
	    function MailTemplateService(backendService) {
	        this.backendService = backendService;
	    }
	    MailTemplateService.prototype.findMailTemplates = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter.action && filter.action.id) {
	            params.set('action.id', filter.action.id);
	        }
	        if (filter.bank && filter.bank.id) {
	            params.set('bank.id', filter.bank.id);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("mailTemplates", params);
	    };
	    MailTemplateService.prototype.getMailTemplate = function (mailTemplateId) {
	        return this.backendService.get("mailTemplate/" + mailTemplateId, null);
	    };
	    MailTemplateService.prototype.save = function (mailTemplate) {
	        return mailTemplate.id != null
	            ? this.backendService.post("mailTemplate", mailTemplate, null)
	            : this.backendService.put("mailTemplate", mailTemplate, null);
	    };
	    MailTemplateService.prototype.delete = function (mailTemplateId) {
	        return this.backendService.delete("mailTemplate/" + mailTemplateId, null, null);
	    };
	    MailTemplateService.prototype.previewMailTemplate = function (mailTemplateBody) {
	        return this.backendService.post("previewMailTemplate", mailTemplateBody, null);
	    };
	    MailTemplateService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], MailTemplateService);
	    return MailTemplateService;
	}());
	exports.MailTemplateService = MailTemplateService;


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	/**
	 * .
	 * Created by jlado on 13/9/16.
	 */
	var ActionTriggerService = (function () {
	    function ActionTriggerService(backendService) {
	        this.backendService = backendService;
	    }
	    /*Por ahora, las Acciones Disparadoras son estáticas: no hay ABM*/
	    ActionTriggerService.prototype.getActionTriggers = function () {
	        return this.backendService.get("actionTriggers", null);
	    };
	    ActionTriggerService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], ActionTriggerService);
	    return ActionTriggerService;
	}());
	exports.ActionTriggerService = ActionTriggerService;


/***/ },
/* 1041 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"col-xs-12 col-md-12\">\n        <h1>Correo</h1>\n    </div>\n    <div class=\"row\">\n        <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n        <form class=\"form-inline\" [formGroup]=\"form\" (ngSubmit)=\"find()\">\n            <div class=\"panel panel-default\">\n                <div class=\"panel-body\">\n                    <div class=\"col-xs-6\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"actionTriggerFilter\">Acción Disparadora</label>\n                            <select class=\"form-control\" id=\"actionTriggerFilter\" formControlName=\"actionTrigger\"\n                                    [(ngModel)]=\"filter.action\" name=\"actionTrigger\">\n                                <option [ngValue]=\"actionTriggerTodos\" *ngIf=\"actionTriggers.length > 1\">\n                                    {{actionTriggerTodos.description}}\n                                </option>\n                                <option *ngFor=\"let actionTrigger of actionTriggers\" [ngValue]=\"actionTrigger\">\n                                    {{actionTrigger.description}}\n                                </option>\n                            </select>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-3\">\n                        <div class=\"form-group form-group-sm\">\n                            <label for=\"bankFilter\">Banco</label>\n                            <select class=\"form-control\" id=\"bankFilter\" formControlName=\"bank\"\n                                    [(ngModel)]=\"filter.bank\" name=\"bank\">\n                                <option [ngValue]=\"bankTodos\" *ngIf=\"banks.length > 1\">{{bankTodos.name}}</option>\n                                <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n\n        <div class=\"panel panel-default\">\n            <div class=\"panel-body table-responsive\">\n                <table class=\"table table-striped\">\n                    <thead>\n                    <tr>\n                        <th style=\"width: 10%\"></th>\n                        <th style=\"width: 20%\">\n                            Acción Disparadora\n                        </th>\n                        <th style=\"width: 15%\">\n                            Receptores\n                        </th>\n                        <th style=\"width: 15%\">\n                            Banco\n                        </th>\n                        <th style=\"width: 15%\">\n                            Vista Previa\n                        </th>\n                        <th style=\"width: 10%\">\n                            Periodicidad\n                        </th>\n                        <th style=\"width: 15%\">\n                            Acciones\n                        </th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr *ngFor=\"let item of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                        <td>\n                            <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"editItem(item)\">\n                                <span class=\"pencil\"><img></span>\n                            </button>\n                        </td>\n                        <td>{{item.action.description}}</td>\n                        <td>\n                            <table>\n                                <tr *ngFor=\"let receiver of item.receivers\">\n                                    <td>{{receiver.description}}</td>\n                                </tr>\n                            </table>\n                        </td>\n                        <td>{{item.bank.name}}</td>\n                        <td>\n                            <a style=\"cursor:pointer\" (click)=\"createPreviewMailTemplate(item.templateBody)\">\n                                Ver Vista Previa\n                            </a>\n                        </td>\n                        <td>{{item.periodicity == \"0\" || item.periodicity == null ? \"Al instante\" : item.periodicity +\n                            \" días\"}}\n                        </td>\n                        <td>\n                            <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                    (click)=\"mailTemplateSelected=item;deleteModal.show();\">\n                                <span class=\"remove\"><img></span>\n                            </button>\n                        </td>\n                    </tr>\n                    </tbody>\n                    <tfoot>\n                    <tr>\n                        <td colspan=\"10\">\n                            <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                        </td>\n                    </tr>\n                    </tfoot>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-2\" id=\"newEntity\">\n            <button type=\"button\" class=\"btn btn-primary\" (click)=\"createMailTemplate()\">\n                <span class=\"plus\"><img></span> Nuevo\n            </button>\n        </div>\n    </div>\n</div>\n\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Confirmación</h4>\n            </div>\n            <div class=\"modal-body\">\n                ¿Está seguro que desea eliminar el template de mail\n                \"<strong>{{mailTemplateSelected?.action?.description}}</strong>\"?\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n                        (click)=\"removeItem(deleteModal)\">Aceptar\n                </button>\n                <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\"\n                        (click)=\"deleteModal.hide()\">Cancelar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div bsModal #bodyMailModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"bodyMailModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Vista Previa</h4>\n            </div>\n            <div class=\"modal-body\">\n                <div [innerHTML]=\"mailTemplateTraduced\"></div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1042 */
940,
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var Observable_1 = __webpack_require__(34);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var mailTemplate_1 = __webpack_require__(1036);
	var actionTrigger_1 = __webpack_require__(1037);
	var actionTrigger_service_1 = __webpack_require__(1040);
	var mailTemplate_service_1 = __webpack_require__(1039);
	var validators_1 = __webpack_require__(849);
	var bank_service_1 = __webpack_require__(631);
	var bank_1 = __webpack_require__(875);
	var mailReceiverType_service_1 = __webpack_require__(1044);
	var mailReceiverType_1 = __webpack_require__(1038);
	var ng2_select_1 = __webpack_require__(1045);
	var mailTemplateProperty_1 = __webpack_require__(1052);
	var mailTemplateProperty_service_1 = __webpack_require__(1053);
	var mailTemplateTag_service_1 = __webpack_require__(1054);
	var mailTemplateTag_1 = __webpack_require__(1055);
	/**
	 * .
	 * Created by jlado on 13/9/16.
	 */
	var MailTemplateEditorComponent = (function () {
	    function MailTemplateEditorComponent(mailTemplateService, bankService, actionTriggerService, mailReceiverTypeService, mailTemplatePropertyService, mailTemplateTagService, route) {
	        this.mailTemplateService = mailTemplateService;
	        this.bankService = bankService;
	        this.actionTriggerService = actionTriggerService;
	        this.mailReceiverTypeService = mailReceiverTypeService;
	        this.mailTemplatePropertyService = mailTemplatePropertyService;
	        this.mailTemplateTagService = mailTemplateTagService;
	        this.route = route;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    MailTemplateEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.loading = false;
	        this.mailReceiverTypeOptions = [];
	        this.mailReceiverTypeOptionsSelected = [];
	        this.mailTemplate = new mailTemplate_1.MailTemplate();
	        this.mailTemplateProperty = new mailTemplateProperty_1.MailTemplateProperty();
	        this.mailTemplateTag = new mailTemplateTag_1.MailTemplateTag();
	        this.mailTemplateTraduced = "";
	        if (this.mailTemplate.templateBody == undefined) {
	            this.mailTemplate.templateBody = "";
	        }
	    };
	    MailTemplateEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            action: new forms_1.FormControl(this.mailTemplate.action, forms_1.Validators.required),
	            bank: new forms_1.FormControl(this.mailTemplate.bank.name, forms_1.Validators.required),
	            receivers: new forms_1.FormControl(this.mailTemplate.receivers, forms_1.Validators.required),
	            description: new forms_1.FormControl(this.mailTemplate.description),
	            periodicity: new forms_1.FormControl(this.mailTemplate.periodicity, validators_1.INTEGER_VALIDATOR),
	            templateSubject: new forms_1.FormControl(this.mailTemplate.templateSubject, forms_1.Validators.required),
	            copyTo: new forms_1.FormControl(this.mailTemplate.copyTo, [validators_1.EMAIL_VALIDATOR]),
	            templateBody: new forms_1.FormControl(this.mailTemplate.templateBody, forms_1.Validators.required),
	            property: new forms_1.FormControl(this.mailTemplateProperty),
	            tag: new forms_1.FormControl(this.mailTemplateTag)
	        });
	    };
	    MailTemplateEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var mailTemplateId = params['mailTemplateId'];
	            if (mailTemplateId) {
	                _this.mailTemplateId = mailTemplateId;
	                _this.createMode = false;
	            }
	            else {
	                _this.mailTemplateId = null;
	                _this.createMode = true;
	            }
	            _this.getData();
	        });
	    };
	    MailTemplateEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        this.errorMessage = null;
	        var forkTasks = [];
	        forkTasks.push(this.bankService.getBanks());
	        forkTasks.push(this.actionTriggerService.getActionTriggers());
	        forkTasks.push(this.mailReceiverTypeService.getMailReceiverTypes());
	        forkTasks.push(this.mailTemplatePropertyService.getMailTemplateProperties());
	        forkTasks.push(this.mailTemplateTagService.getMailTemplateTags());
	        if (this.mailTemplateId) {
	            forkTasks.push(this.mailTemplateService.getMailTemplate(this.mailTemplateId));
	        }
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los datos del correo.');
	        });
	    };
	    MailTemplateEditorComponent.prototype.setData = function (data) {
	        var _this = this;
	        this.loading = false;
	        this.banks = data[0];
	        this.actionTriggers = data[1];
	        data[2].map(function (mailReceiverType) { return _this.mailReceiverTypeOptions
	            .push(new mailReceiverType_1.MailReceiverTypeOption(mailReceiverType)); });
	        this.properties = data[3];
	        this.tags = data[4];
	        if (this.mailTemplateId) {
	            this.mailTemplate = data[data.length - 1];
	            if (!this.mailTemplate.action) {
	                this.mailTemplate.action = new actionTrigger_1.ActionTrigger(null);
	            }
	            if (!this.mailTemplate.bank) {
	                this.mailTemplate.bank = new bank_1.Bank(null);
	            }
	            if (this.mailTemplate.receivers) {
	                this.mailTemplate.receivers
	                    .forEach(function (mailReceiverType) { return _this.mailReceiverTypeOptionsSelected
	                    .push(new mailReceiverType_1.MailReceiverTypeOption(mailReceiverType)); });
	            }
	        }
	        else {
	            this.mailTemplate = new mailTemplate_1.MailTemplate();
	        }
	    };
	    MailTemplateEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    MailTemplateEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    MailTemplateEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.mailTemplateService.save(this.mailTemplate).subscribe(function (saved) {
	            _this.loading = false;
	            _this.mailTemplate = saved;
	            _this.successMessage = 'El correo se guardó con éxito';
	            _this.updateViewAfterSave();
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar los datos del correo.');
	        });
	    };
	    MailTemplateEditorComponent.prototype.updateViewAfterSave = function () {
	        if (this.createMode) {
	            this.mailTemplate = new mailTemplate_1.MailTemplate();
	            this.mailReceiverTypeOptionsSelected = [];
	            if (this.selectMailReceiverTypes) {
	                this.selectMailReceiverTypes.active = [];
	            }
	        }
	    };
	    MailTemplateEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.mailTemplate);
	        window.history.back();
	    };
	    MailTemplateEditorComponent.prototype.mailReceiverTypesSelected = function (mailReceiverType) {
	        this.mailTemplate.receivers.push(mailReceiverType);
	    };
	    MailTemplateEditorComponent.prototype.mailReceiverTypesRemoved = function (mailReceiverType) {
	        var index = this.mailTemplate.receivers.map(function (mailReceiverType) {
	            return mailReceiverType.id;
	        }).indexOf(mailReceiverType.id);
	        if (index > -1) {
	            this.mailTemplate.receivers.splice(index, 1);
	        }
	    };
	    MailTemplateEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    MailTemplateEditorComponent.prototype.setPropertyToTemplateBody = function () {
	        if (this.mailTemplate.templateBody == undefined) {
	            this.mailTemplate.templateBody = "";
	        }
	        if (this.mailTemplateProperty.tag != undefined) {
	            this.mailTemplate.templateBody = this.mailTemplate.templateBody + this.mailTemplateProperty.tag;
	        }
	    };
	    MailTemplateEditorComponent.prototype.setTagToTemplateBody = function () {
	        if (this.mailTemplate.templateBody == undefined) {
	            this.mailTemplate.templateBody = "";
	        }
	        if (this.mailTemplateTag.startTag != undefined && this.mailTemplateTag.finishTag != undefined) {
	            this.mailTemplate.templateBody = this.mailTemplate.templateBody + this.mailTemplateTag.startTag + this.mailTemplateTag.finishTag;
	        }
	    };
	    MailTemplateEditorComponent.prototype.createPreviewMailTemplate = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        var templateBody = this.mailTemplate.templateBody;
	        if (templateBody.length == 0 || templateBody == undefined) {
	            templateBody = "VACÍO.";
	        }
	        this.mailTemplateService.previewMailTemplate(templateBody).subscribe(function (mailTemplateTraduced) {
	            _this.loading = false;
	            _this.mailTemplateTraduced = mailTemplateTraduced.templateBody.toString();
	            _this.previewMailModal.show();
	        }, function () {
	            _this.bindError('Ocurrió un error al generar la vista previa.');
	            _this.loading = false;
	        });
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', mailTemplate_1.MailTemplate)
	    ], MailTemplateEditorComponent.prototype, "mailTemplate", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], MailTemplateEditorComponent.prototype, "close", void 0);
	    __decorate([
	        core_1.ViewChild('selectMailReceiverTypes'), 
	        __metadata('design:type', ng2_select_1.SelectComponent)
	    ], MailTemplateEditorComponent.prototype, "selectMailReceiverTypes", void 0);
	    __decorate([
	        core_1.ViewChild('previewMailModal'), 
	        __metadata('design:type', ng2_bootstrap_1.ModalDirective)
	    ], MailTemplateEditorComponent.prototype, "previewMailModal", void 0);
	    MailTemplateEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'mailTemplate-editor',
	            template: __webpack_require__(1056),
	            styles: [__webpack_require__(1057)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_select_1.SELECT_DIRECTIVES
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS
	            ],
	        }), 
	        __metadata('design:paramtypes', [mailTemplate_service_1.MailTemplateService, bank_service_1.BankService, actionTrigger_service_1.ActionTriggerService, mailReceiverType_service_1.MailReceiverTypeService, mailTemplateProperty_service_1.MailTemplatePropertyService, mailTemplateTag_service_1.MailTemplateTagService, router_1.ActivatedRoute])
	    ], MailTemplateEditorComponent);
	    return MailTemplateEditorComponent;
	}());
	exports.MailTemplateEditorComponent = MailTemplateEditorComponent;


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	/**
	 * .
	 * Created by jlado on 15/9/16.
	 */
	var MailReceiverTypeService = (function () {
	    function MailReceiverTypeService(backendService) {
	        this.backendService = backendService;
	    }
	    /*Por ahora, los Tipos de Receptores son estáticos: no hay ABM*/
	    MailReceiverTypeService.prototype.getMailReceiverTypes = function () {
	        return this.backendService.get("mailReceiverTypes", null);
	    };
	    MailReceiverTypeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], MailReceiverTypeService);
	    return MailReceiverTypeService;
	}());
	exports.MailReceiverTypeService = MailReceiverTypeService;


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var select_1 = __webpack_require__(1046);
	__export(__webpack_require__(1047));
	__export(__webpack_require__(1046));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = {
	    directives: [
	        select_1.SELECT_DIRECTIVES
	    ]
	};


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var select_1 = __webpack_require__(1047);
	exports.SELECT_DIRECTIVES = [select_1.SelectComponent];


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var select_item_1 = __webpack_require__(1048);
	var select_pipes_1 = __webpack_require__(1049);
	var common_1 = __webpack_require__(1050);
	var off_click_1 = __webpack_require__(1051);
	var optionsTemplate = "\n    <ul *ngIf=\"optionsOpened && options && options.length > 0 && !firstItemHasChildren\"\n        class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\">\n      <li class=\"ui-select-choices-group\">\n        <div *ngFor=\"let o of options\"\n             class=\"ui-select-choices-row\"\n             [class.active]=\"isActive(o)\"\n             (mouseenter)=\"selectActive(o)\"\n             (click)=\"selectMatch(o, $event)\">\n          <a href=\"javascript:void(0)\" class=\"ui-select-choices-row-inner\">\n            <div [innerHtml]=\"o.text | highlight:inputValue\"></div>\n          </a>\n        </div>\n      </li>\n    </ul>\n\n    <ul *ngIf=\"optionsOpened && options && options.length > 0 && firstItemHasChildren\"\n        class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\">\n      <li *ngFor=\"let c of options; let index=index\" class=\"ui-select-choices-group\">\n        <div class=\"divider\" *ngIf=\"index > 0\"></div>\n        <div class=\"ui-select-choices-group-label dropdown-header\">{{c.text}}</div>\n\n        <div *ngFor=\"let o of c.children\"\n             class=\"ui-select-choices-row\"\n             [class.active]=\"isActive(o)\"\n             (mouseenter)=\"selectActive(o)\"\n             (click)=\"selectMatch(o, $event)\"\n             [ngClass]=\"{'active': isActive(o)}\">\n          <a href=\"javascript:void(0)\" class=\"ui-select-choices-row-inner\">\n            <div [innerHtml]=\"o.text | highlight:inputValue\"></div>\n          </a>\n        </div>\n      </li>\n    </ul>\n";
	var SelectComponent = (function () {
	    function SelectComponent(element) {
	        this.allowClear = false;
	        this.placeholder = '';
	        this.initData = [];
	        this.multiple = false;
	        this.data = new core_1.EventEmitter();
	        this.selected = new core_1.EventEmitter();
	        this.removed = new core_1.EventEmitter();
	        this.typed = new core_1.EventEmitter();
	        this.options = [];
	        this.itemObjects = [];
	        this.active = [];
	        this.inputMode = false;
	        this.optionsOpened = false;
	        this.inputValue = '';
	        this._items = [];
	        this._disabled = false;
	        this.element = element;
	        this.clickedOutside = this.clickedOutside.bind(this);
	    }
	    Object.defineProperty(SelectComponent.prototype, "items", {
	        set: function (value) {
	            this._items = value;
	            this.itemObjects = this._items.map(function (item) { return new select_item_1.SelectItem(item); });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SelectComponent.prototype, "disabled", {
	        set: function (value) {
	            this._disabled = value;
	            if (this._disabled === true) {
	                this.hideOptions();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SelectComponent.prototype.inputEvent = function (e, isUpMode) {
	        if (isUpMode === void 0) { isUpMode = false; }
	        // tab
	        if (e.keyCode === 9) {
	            return;
	        }
	        if (isUpMode && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 38 ||
	            e.keyCode === 40 || e.keyCode === 13)) {
	            e.preventDefault();
	            return;
	        }
	        // backspace
	        if (!isUpMode && e.keyCode === 8) {
	            var el = this.element.nativeElement
	                .querySelector('div.ui-select-container > input');
	            if (!el.value || el.value.length <= 0) {
	                if (this.active.length > 0) {
	                    this.remove(this.active[this.active.length - 1]);
	                }
	                e.preventDefault();
	            }
	        }
	        // esc
	        if (!isUpMode && e.keyCode === 27) {
	            this.hideOptions();
	            this.element.nativeElement.children[0].focus();
	            e.preventDefault();
	            return;
	        }
	        // del
	        if (!isUpMode && e.keyCode === 46) {
	            if (this.active.length > 0) {
	                this.remove(this.active[this.active.length - 1]);
	            }
	            e.preventDefault();
	        }
	        // left
	        if (!isUpMode && e.keyCode === 37 && this._items.length > 0) {
	            this.behavior.first();
	            e.preventDefault();
	            return;
	        }
	        // right
	        if (!isUpMode && e.keyCode === 39 && this._items.length > 0) {
	            this.behavior.last();
	            e.preventDefault();
	            return;
	        }
	        // up
	        if (!isUpMode && e.keyCode === 38) {
	            this.behavior.prev();
	            e.preventDefault();
	            return;
	        }
	        // down
	        if (!isUpMode && e.keyCode === 40) {
	            this.behavior.next();
	            e.preventDefault();
	            return;
	        }
	        // enter
	        if (!isUpMode && e.keyCode === 13) {
	            if (this.active.indexOf(this.activeOption) === -1) {
	                this.selectActiveMatch();
	                this.behavior.next();
	            }
	            e.preventDefault();
	            return;
	        }
	        if (e.srcElement) {
	            this.inputValue = e.srcElement.value;
	            this.behavior.filter(new RegExp(common_1.escapeRegexp(this.inputValue), 'ig'));
	            this.doEvent('typed', this.inputValue);
	        }
	    };
	    SelectComponent.prototype.ngOnInit = function () {
	        this.behavior = (this.firstItemHasChildren) ?
	            new ChildrenBehavior(this) : new GenericBehavior(this);
	        if (this.initData) {
	            this.active = this.initData.map(function (data) { return new select_item_1.SelectItem(data); });
	            this.data.emit(this.active);
	        }
	    };
	    SelectComponent.prototype.remove = function (item) {
	        if (this._disabled === true) {
	            return;
	        }
	        if (this.multiple === true && this.active) {
	            var index = this.active.indexOf(item);
	            this.active.splice(index, 1);
	            this.data.next(this.active);
	            this.doEvent('removed', item);
	        }
	        if (this.multiple === false) {
	            this.active = [];
	            this.data.next(this.active);
	            this.doEvent('removed', item);
	        }
	    };
	    SelectComponent.prototype.doEvent = function (type, value) {
	        if (this[type] && value) {
	            this[type].next(value);
	        }
	    };
	    SelectComponent.prototype.clickedOutside = function () {
	        this.inputMode = false;
	        this.optionsOpened = false;
	    };
	    Object.defineProperty(SelectComponent.prototype, "firstItemHasChildren", {
	        get: function () {
	            return this.itemObjects[0] && this.itemObjects[0].hasChildren();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SelectComponent.prototype.matchClick = function (e) {
	        if (this._disabled === true) {
	            return;
	        }
	        this.inputMode = !this.inputMode;
	        if (this.inputMode === true && ((this.multiple === true && e) || this.multiple === false)) {
	            this.focusToInput();
	            this.open();
	        }
	    };
	    SelectComponent.prototype.mainClick = function (event) {
	        if (this.inputMode === true || this._disabled === true) {
	            return;
	        }
	        if (event.keyCode === 46) {
	            event.preventDefault();
	            this.inputEvent(event);
	            return;
	        }
	        if (event.keyCode === 8) {
	            event.preventDefault();
	            this.inputEvent(event, true);
	            return;
	        }
	        if (event.keyCode === 9 || event.keyCode === 13 ||
	            event.keyCode === 27 || (event.keyCode >= 37 && event.keyCode <= 40)) {
	            event.preventDefault();
	            return;
	        }
	        this.inputMode = true;
	        var value = String
	            .fromCharCode(96 <= event.keyCode && event.keyCode <= 105 ? event.keyCode - 48 : event.keyCode)
	            .toLowerCase();
	        this.focusToInput(value);
	        this.open();
	        event.srcElement.value = value;
	        this.inputEvent(event);
	    };
	    SelectComponent.prototype.selectActive = function (value) {
	        this.activeOption = value;
	    };
	    SelectComponent.prototype.isActive = function (value) {
	        return this.activeOption.text === value.text;
	    };
	    SelectComponent.prototype.focusToInput = function (value) {
	        var _this = this;
	        if (value === void 0) { value = ''; }
	        setTimeout(function () {
	            var el = _this.element.nativeElement.querySelector('div.ui-select-container > input');
	            if (el) {
	                el.focus();
	                el.value = value;
	            }
	        }, 0);
	    };
	    SelectComponent.prototype.open = function () {
	        var _this = this;
	        this.options = this.itemObjects
	            .filter(function (option) { return (_this.multiple === false ||
	            _this.multiple === true &&
	                !_this.active.find(function (o) { return option.text === o.text; })); });
	        if (this.options.length > 0) {
	            this.behavior.first();
	        }
	        this.optionsOpened = true;
	    };
	    SelectComponent.prototype.hideOptions = function () {
	        this.inputMode = false;
	        this.optionsOpened = false;
	    };
	    SelectComponent.prototype.selectActiveMatch = function () {
	        this.selectMatch(this.activeOption);
	    };
	    SelectComponent.prototype.selectMatch = function (value, e) {
	        if (e === void 0) { e = void 0; }
	        if (e) {
	            e.stopPropagation();
	            e.preventDefault();
	        }
	        if (this.options.length <= 0) {
	            return;
	        }
	        if (this.multiple === true) {
	            this.active.push(value);
	            this.data.next(this.active);
	        }
	        if (this.multiple === false) {
	            this.active[0] = value;
	            this.data.next(this.active[0]);
	        }
	        this.doEvent('selected', value);
	        this.hideOptions();
	        if (this.multiple === true) {
	            this.focusToInput('');
	        }
	        else {
	            this.focusToInput(select_pipes_1.stripTags(value.text));
	            this.element.nativeElement.querySelector('.ui-select-container').focus();
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], SelectComponent.prototype, "allowClear", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], SelectComponent.prototype, "placeholder", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], SelectComponent.prototype, "initData", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], SelectComponent.prototype, "multiple", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array), 
	        __metadata('design:paramtypes', [Array])
	    ], SelectComponent.prototype, "items", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean), 
	        __metadata('design:paramtypes', [Boolean])
	    ], SelectComponent.prototype, "disabled", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], SelectComponent.prototype, "data", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], SelectComponent.prototype, "selected", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], SelectComponent.prototype, "removed", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', core_1.EventEmitter)
	    ], SelectComponent.prototype, "typed", void 0);
	    SelectComponent = __decorate([
	        core_1.Component({
	            selector: 'ng-select',
	            directives: [off_click_1.OffClickDirective],
	            pipes: [select_pipes_1.HighlightPipe],
	            template: "\n  <div tabindex=\"0\"\n     *ngIf=\"multiple === false\"\n     (keyup)=\"mainClick($event)\"\n     [offClick]=\"clickedOutside\"\n     class=\"ui-select-container ui-select-bootstrap dropdown open\">\n    <div [ngClass]=\"{'ui-disabled': disabled}\"></div>\n    <div class=\"ui-select-match\"\n         *ngIf=\"!inputMode\">\n      <span tabindex=\"-1\"\n          class=\"btn btn-default btn-secondary form-control ui-select-toggle\"\n          (click)=\"matchClick($event)\"\n          style=\"outline: 0;\">\n        <span *ngIf=\"active.length <= 0\" class=\"ui-select-placeholder text-muted\">{{placeholder}}</span>\n        <span *ngIf=\"active.length > 0\" class=\"ui-select-match-text pull-left\"\n              [ngClass]=\"{'ui-select-allow-clear': allowClear && active.length > 0}\"\n              [innerHTML]=\"active[0].text\"></span>\n        <i class=\"dropdown-toggle pull-right\"></i>\n        <i class=\"caret pull-right\"></i>\n        <a *ngIf=\"allowClear && active.length>0\" style=\"margin-right: 10px; padding: 0;\"\n          (click)=\"remove(activeOption)\" class=\"btn btn-xs btn-link pull-right\">\n          <i class=\"glyphicon glyphicon-remove\"></i>\n        </a>\n      </span>\n    </div>\n    <input type=\"text\" autocomplete=\"false\" tabindex=\"-1\"\n           (keydown)=\"inputEvent($event)\"\n           (keyup)=\"inputEvent($event, true)\"\n           [disabled]=\"disabled\"\n           class=\"form-control ui-select-search\"\n           *ngIf=\"inputMode\"\n           placeholder=\"{{active.length <= 0 ? placeholder : ''}}\">\n      " + optionsTemplate + "\n  </div>\n\n  <div tabindex=\"0\"\n     *ngIf=\"multiple === true\"\n     (keyup)=\"mainClick($event)\"\n     (focus)=\"focusToInput('')\"\n     class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control open\">\n    <div [ngClass]=\"{'ui-disabled': disabled}\"></div>\n    <span class=\"ui-select-match\">\n        <span *ngFor=\"let a of active\">\n            <span class=\"ui-select-match-item btn btn-default btn-secondary btn-xs\"\n                  tabindex=\"-1\"\n                  type=\"button\"\n                  [ngClass]=\"{'btn-default': true}\">\n               <a class=\"close ui-select-match-close\"\n                  (click)=\"remove(a)\">&nbsp;&times;</a>\n               <span>{{a.text}}</span>\n           </span>\n        </span>\n    </span>\n    <input type=\"text\"\n           (keydown)=\"inputEvent($event)\"\n           (keyup)=\"inputEvent($event, true)\"\n           (click)=\"matchClick($event)\"\n           [disabled]=\"disabled\"\n           autocomplete=\"false\"\n           autocorrect=\"off\"\n           autocapitalize=\"off\"\n           spellcheck=\"false\"\n           class=\"ui-select-search input-xs\"\n           placeholder=\"{{active.length <= 0 ? placeholder : ''}}\"\n           role=\"combobox\">\n    " + optionsTemplate + "\n  </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [core_1.ElementRef])
	    ], SelectComponent);
	    return SelectComponent;
	}());
	exports.SelectComponent = SelectComponent;
	var Behavior = (function () {
	    function Behavior(actor) {
	        this.optionsMap = new Map();
	        this.actor = actor;
	    }
	    Behavior.prototype.fillOptionsMap = function () {
	        var _this = this;
	        this.optionsMap.clear();
	        var startPos = 0;
	        this.actor.itemObjects
	            .map(function (item) {
	            startPos = item.fillChildrenHash(_this.optionsMap, startPos);
	        });
	    };
	    Behavior.prototype.ensureHighlightVisible = function (optionsMap) {
	        if (optionsMap === void 0) { optionsMap = void 0; }
	        var container = this.actor.element.nativeElement.querySelector('.ui-select-choices-content');
	        if (!container) {
	            return;
	        }
	        var choices = container.querySelectorAll('.ui-select-choices-row');
	        if (choices.length < 1) {
	            return;
	        }
	        var activeIndex = this.getActiveIndex(optionsMap);
	        if (activeIndex < 0) {
	            return;
	        }
	        var highlighted = choices[activeIndex];
	        if (!highlighted) {
	            return;
	        }
	        var posY = highlighted.offsetTop + highlighted.clientHeight - container.scrollTop;
	        var height = container.offsetHeight;
	        if (posY > height) {
	            container.scrollTop += posY - height;
	        }
	        else if (posY < highlighted.clientHeight) {
	            container.scrollTop -= highlighted.clientHeight - posY;
	        }
	    };
	    Behavior.prototype.getActiveIndex = function (optionsMap) {
	        if (optionsMap === void 0) { optionsMap = void 0; }
	        var ai = this.actor.options.indexOf(this.actor.activeOption);
	        if (ai < 0 && optionsMap !== void 0) {
	            ai = optionsMap.get(this.actor.activeOption.id);
	        }
	        return ai;
	    };
	    return Behavior;
	}());
	exports.Behavior = Behavior;
	var GenericBehavior = (function (_super) {
	    __extends(GenericBehavior, _super);
	    function GenericBehavior(actor) {
	        _super.call(this, actor);
	    }
	    GenericBehavior.prototype.first = function () {
	        this.actor.activeOption = this.actor.options[0];
	        _super.prototype.ensureHighlightVisible.call(this);
	    };
	    GenericBehavior.prototype.last = function () {
	        this.actor.activeOption = this.actor.options[this.actor.options.length - 1];
	        _super.prototype.ensureHighlightVisible.call(this);
	    };
	    GenericBehavior.prototype.prev = function () {
	        var index = this.actor.options.indexOf(this.actor.activeOption);
	        this.actor.activeOption = this.actor
	            .options[index - 1 < 0 ? this.actor.options.length - 1 : index - 1];
	        _super.prototype.ensureHighlightVisible.call(this);
	    };
	    GenericBehavior.prototype.next = function () {
	        var index = this.actor.options.indexOf(this.actor.activeOption);
	        this.actor.activeOption = this.actor
	            .options[index + 1 > this.actor.options.length - 1 ? 0 : index + 1];
	        _super.prototype.ensureHighlightVisible.call(this);
	    };
	    GenericBehavior.prototype.filter = function (query) {
	        var _this = this;
	        var options = this.actor.itemObjects
	            .filter(function (option) {
	            return select_pipes_1.stripTags(option.text).match(query) &&
	                (_this.actor.multiple === false ||
	                    (_this.actor.multiple === true && _this.actor.active.indexOf(option) < 0));
	        });
	        this.actor.options = options;
	        if (this.actor.options.length > 0) {
	            this.actor.activeOption = this.actor.options[0];
	            _super.prototype.ensureHighlightVisible.call(this);
	        }
	    };
	    return GenericBehavior;
	}(Behavior));
	exports.GenericBehavior = GenericBehavior;
	var ChildrenBehavior = (function (_super) {
	    __extends(ChildrenBehavior, _super);
	    function ChildrenBehavior(actor) {
	        _super.call(this, actor);
	    }
	    ChildrenBehavior.prototype.first = function () {
	        this.actor.activeOption = this.actor.options[0].children[0];
	        this.fillOptionsMap();
	        this.ensureHighlightVisible(this.optionsMap);
	    };
	    ChildrenBehavior.prototype.last = function () {
	        this.actor.activeOption =
	            this.actor
	                .options[this.actor.options.length - 1]
	                .children[this.actor.options[this.actor.options.length - 1].children.length - 1];
	        this.fillOptionsMap();
	        this.ensureHighlightVisible(this.optionsMap);
	    };
	    ChildrenBehavior.prototype.prev = function () {
	        var _this = this;
	        var indexParent = this.actor.options
	            .findIndex(function (option) { return _this.actor.activeOption.parent && _this.actor.activeOption.parent.id === option.id; });
	        var index = this.actor.options[indexParent].children
	            .findIndex(function (option) { return _this.actor.activeOption && _this.actor.activeOption.id === option.id; });
	        this.actor.activeOption = this.actor.options[indexParent].children[index - 1];
	        if (!this.actor.activeOption) {
	            if (this.actor.options[indexParent - 1]) {
	                this.actor.activeOption = this.actor
	                    .options[indexParent - 1]
	                    .children[this.actor.options[indexParent - 1].children.length - 1];
	            }
	        }
	        if (!this.actor.activeOption) {
	            this.last();
	        }
	        this.fillOptionsMap();
	        this.ensureHighlightVisible(this.optionsMap);
	    };
	    ChildrenBehavior.prototype.next = function () {
	        var _this = this;
	        var indexParent = this.actor.options
	            .findIndex(function (option) { return _this.actor.activeOption.parent && _this.actor.activeOption.parent.id === option.id; });
	        var index = this.actor.options[indexParent].children
	            .findIndex(function (option) { return _this.actor.activeOption && _this.actor.activeOption.id === option.id; });
	        this.actor.activeOption = this.actor.options[indexParent].children[index + 1];
	        if (!this.actor.activeOption) {
	            if (this.actor.options[indexParent + 1]) {
	                this.actor.activeOption = this.actor.options[indexParent + 1].children[0];
	            }
	        }
	        if (!this.actor.activeOption) {
	            this.first();
	        }
	        this.fillOptionsMap();
	        this.ensureHighlightVisible(this.optionsMap);
	    };
	    ChildrenBehavior.prototype.filter = function (query) {
	        var options = [];
	        var optionsMap = new Map();
	        var startPos = 0;
	        for (var _i = 0, _a = this.actor.itemObjects; _i < _a.length; _i++) {
	            var si = _a[_i];
	            var children = si.children.filter(function (option) { return query.test(option.text); });
	            startPos = si.fillChildrenHash(optionsMap, startPos);
	            if (children.length > 0) {
	                var newSi = si.getSimilar();
	                newSi.children = children;
	                options.push(newSi);
	            }
	        }
	        this.actor.options = options;
	        if (this.actor.options.length > 0) {
	            this.actor.activeOption = this.actor.options[0].children[0];
	            _super.prototype.ensureHighlightVisible.call(this, optionsMap);
	        }
	    };
	    return ChildrenBehavior;
	}(Behavior));
	exports.ChildrenBehavior = ChildrenBehavior;


/***/ },
/* 1048 */
/***/ function(module, exports) {

	"use strict";
	var SelectItem = (function () {
	    function SelectItem(source) {
	        var _this = this;
	        if (typeof source === 'string') {
	            this.id = this.text = source;
	        }
	        if (typeof source === 'object') {
	            this.id = source.id || source.text;
	            this.text = source.text;
	            if (source.children && source.text) {
	                this.children = source.children.map(function (c) {
	                    var r = new SelectItem(c);
	                    r.parent = _this;
	                    return r;
	                });
	                this.text = source.text;
	            }
	        }
	    }
	    SelectItem.prototype.fillChildrenHash = function (optionsMap, startIndex) {
	        var i = startIndex;
	        this.children.map(function (child) {
	            optionsMap.set(child.id, i++);
	        });
	        return i;
	    };
	    SelectItem.prototype.hasChildren = function () {
	        return this.children && this.children.length > 0;
	    };
	    SelectItem.prototype.getSimilar = function () {
	        var r = new SelectItem(false);
	        r.id = this.id;
	        r.text = this.text;
	        r.parent = this.parent;
	        return r;
	    };
	    return SelectItem;
	}());
	exports.SelectItem = SelectItem;


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var common_1 = __webpack_require__(1050);
	var HighlightPipe = (function () {
	    function HighlightPipe() {
	    }
	    HighlightPipe.prototype.transform = function (value, args) {
	        if (args.length < 1) {
	            return value;
	        }
	        var query = args[0];
	        if (query) {
	            var tagRE = new RegExp('<[^<>]*>', 'ig');
	            // get ist of tags
	            var tagList = value.match(tagRE);
	            // Replace tags with token
	            var tmpValue = value.replace(tagRE, '$!$');
	            // Replace search words
	            value = tmpValue.replace(new RegExp(common_1.escapeRegexp(query), 'gi'), '<strong>$&</strong>');
	            // Reinsert HTML
	            for (var i = 0; value.indexOf('$!$') > -1; i++) {
	                value = value.replace('$!$', tagList[i]);
	            }
	        }
	        return value;
	    };
	    HighlightPipe = __decorate([
	        core_1.Pipe({ name: 'highlight' }), 
	        __metadata('design:paramtypes', [])
	    ], HighlightPipe);
	    return HighlightPipe;
	}());
	exports.HighlightPipe = HighlightPipe;
	function stripTags(input) {
	    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
	    var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
	    return input.replace(commentsAndPhpTags, '').replace(tags, '');
	}
	exports.stripTags = stripTags;


/***/ },
/* 1050 */
/***/ function(module, exports) {

	"use strict";
	function escapeRegexp(queryToEscape) {
	    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	}
	exports.escapeRegexp = escapeRegexp;


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var OffClickDirective = (function () {
	    function OffClickDirective() {
	    }
	    /* tslint:enable */
	    OffClickDirective.prototype.onClick = function ($event) {
	        $event.stopPropagation();
	    };
	    OffClickDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        setTimeout(function () { document.addEventListener('click', _this.offClickHandler); }, 0);
	    };
	    OffClickDirective.prototype.ngOnDestroy = function () {
	        document.removeEventListener('click', this.offClickHandler);
	    };
	    __decorate([
	        core_1.Input('offClick'), 
	        __metadata('design:type', Object)
	    ], OffClickDirective.prototype, "offClickHandler", void 0);
	    __decorate([
	        core_1.HostListener('click', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [MouseEvent]), 
	        __metadata('design:returntype', void 0)
	    ], OffClickDirective.prototype, "onClick", null);
	    OffClickDirective = __decorate([
	        core_1.Directive({
	            selector: '[offClick]'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OffClickDirective);
	    return OffClickDirective;
	}());
	exports.OffClickDirective = OffClickDirective;


/***/ },
/* 1052 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * .
	 * Created by jlado on 8/2/18.
	 */
	var MailTemplateProperty = (function () {
	    function MailTemplateProperty(other) {
	        if (other) {
	            this.code = other.code;
	            this.tag = other.tag;
	            this.description = other.description;
	        }
	    }
	    MailTemplateProperty.prototype.toString = function () {
	        return this.description;
	    };
	    return MailTemplateProperty;
	}());
	exports.MailTemplateProperty = MailTemplateProperty;


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	/**
	 * .
	 * Created by jlado on 8/2/18.
	 */
	var MailTemplatePropertyService = (function () {
	    function MailTemplatePropertyService(backendService) {
	        this.backendService = backendService;
	    }
	    MailTemplatePropertyService.prototype.getMailTemplateProperties = function () {
	        return this.backendService.get("mailTemplateProperties", null);
	    };
	    MailTemplatePropertyService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], MailTemplatePropertyService);
	    return MailTemplatePropertyService;
	}());
	exports.MailTemplatePropertyService = MailTemplatePropertyService;


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	/**
	 * .
	 * Created by jlado on 8/2/18.
	 */
	var MailTemplateTagService = (function () {
	    function MailTemplateTagService(backendService) {
	        this.backendService = backendService;
	    }
	    MailTemplateTagService.prototype.getMailTemplateTags = function () {
	        return this.backendService.get("mailTemplateTags", null);
	    };
	    MailTemplateTagService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], MailTemplateTagService);
	    return MailTemplateTagService;
	}());
	exports.MailTemplateTagService = MailTemplateTagService;


/***/ },
/* 1055 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * .
	 * Created by jlado on 8/2/18.
	 */
	var MailTemplateTag = (function () {
	    function MailTemplateTag(other) {
	        if (other) {
	            this.code = other.code;
	            this.startTag = other.startTag;
	            this.finishTag = other.finishTag;
	            this.description = other.description;
	        }
	    }
	    MailTemplateTag.prototype.toString = function () {
	        return this.description;
	    };
	    return MailTemplateTag;
	}());
	exports.MailTemplateTag = MailTemplateTag;


/***/ },
/* 1056 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nuevo Correo</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Correo</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"mailTemplate\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-4\">\n                        <label for=\"action\">Acción Disparadora</label>\n                        <select class=\"form-control\" formControlName=\"action\" [(ngModel)]=\"mailTemplate.action.id\"\n                                name=\"action\" id=\"action\">\n                            <option *ngFor=\"let actionTrigger of actionTriggers\" [value]=\"actionTrigger.id\">\n                                {{actionTrigger.description}}\n                            </option>\n                        </select>\n\n                        <div *ngIf=\"!form.controls.action.valid && form.controls.action.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"bank\">Banco</label>\n                        <select class=\"form-control\" formControlName=\"bank\"\n                                [(ngModel)]=\"mailTemplate.bank.id\"\n                                name=\"bank\" id=\"bank\">\n                            <option *ngFor=\"let bank of banks\" [value]=\"bank.id\">{{bank.name}}</option>\n                        </select>\n\n                        <div *ngIf=\"!form.controls.bank.valid && form.controls.bank.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"periodicity\">Periodicidad</label>\n                        <input type=\"text\" class=\"form-control\" id=\"periodicity\"\n                               [(ngModel)]=\"mailTemplate.periodicity\" name=\"periodicity\"\n                               formControlName=\"periodicity\"/>\n\n                        <div *ngIf=\"!form.controls.periodicity.valid\" class=\"alert-danger\">\n                            {{errorMessages.invalidPattern}}\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-4\" *ngIf=\"mailReceiverTypeOptions.length > 0\">\n                        <label>Receptores</label>\n                        <ng-select #selectMailReceiverTypes style=\"width: 200px\" id=\"mailReceiverTypeOptions\"\n                                   [items]=\"mailReceiverTypeOptions\"\n                                   [initData]=\"mailReceiverTypeOptionsSelected\"\n                                   [value]=\"mailTemplate.receivers\"\n                                   [multiple]=\"true\"\n                                   (selected)=\"mailReceiverTypesSelected($event)\"\n                                   (removed)=\"mailReceiverTypesRemoved($event)\">\n                        </ng-select>\n\n                        <div *ngIf=\"mailTemplate.receivers.length == 0\" class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-6\">\n                        <label for=\"description\">Descripción</label>\n                        <input type=\"text\" class=\"form-control\" id=\"description\"\n                               [(ngModel)]=\"mailTemplate.description\" name=\"description\"\n                               formControlName=\"description\"/>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-10\">\n                        <label for=\"templateSubject\">Asunto:</label>\n                        <input type=\"text\" class=\"form-control\" id=\"templateSubject\"\n                               [(ngModel)]=\"mailTemplate.templateSubject\" name=\"templateSubject\"\n                               formControlName=\"templateSubject\"/>\n\n                        <div *ngIf=\"!form.controls.templateSubject.valid && form.controls.templateSubject.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-10\">\n                        <label for=\"copyTo\">Copiar a</label>\n                        <input type=\"text\" class=\"form-control\" id=\"copyTo\" [(ngModel)]=\"mailTemplate.copyTo\"\n                               name=\"copyTo\" placeholder=\"Separe los emails con un espacio\" formControlName=\"copyTo\"/>\n\n                        <div *ngIf=\"!form.controls.copyTo.valid && form.controls.copyTo.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                        <div *ngIf=\"!form.controls.copyTo.valid && form.controls.copyTo.errors.pattern\"\n                             class=\"alert-danger\">{{errorMessages.groupEmailPattern}}\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row rowBorder\">\n                    <div class=\"panel-heading\">\n                        <h2 class=\"panel-title\">Parámetros de email</h2>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"property\">Campos</label>\n                        <select class=\"form-control\" [(ngModel)]=\"mailTemplateProperty\" id=\"property\"\n                                formControlName=\"property\" name=\"property\" (click)=\"setPropertyToTemplateBody()\">\n                            <option *ngFor=\"let property of properties\" [ngValue]=\"property\">\n                                {{property.description}} - {{property.tag}}\n                            </option>\n                        </select>\n                    </div>\n\n                    <div class=\"form-group form-group-sm col-sm-4\">\n                        <label for=\"tag\">Etiquetas</label>\n                        <select class=\"form-control\" [(ngModel)]=\"mailTemplateTag\" id=\"tag\"\n                                formControlName=\"tag\" name=\"tag\" (click)=\"setTagToTemplateBody()\">\n                            <option *ngFor=\"let tag of tags\" [ngValue]=\"tag\">\n                                {{tag.description}} - {{tag.startTag}}{{tag.finishTag}}\n                            </option>\n                        </select>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <button type=\"button\" class=\"btn btn-success\" id=\"previewButton\"\n                                (click)=\"createPreviewMailTemplate()\">\n                            Vista previa\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"row rowBorder\">\n                    <div class=\"form-group form-group-sm col-sm-10\">\n                        <label for=\"templateBody\">Cuerpo</label>\n                        <textarea class=\"form-control\" id=\"templateBody\" [(ngModel)]=\"mailTemplate.templateBody\"\n                                  name=\"templateBody\" formControlName=\"templateBody\" rows=\"20\"></textarea>\n\n                        <div *ngIf=\"!form.controls.templateBody.valid && form.controls.templateBody.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"col-sm-12\">\n                        <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"!form.valid || loading\">\n                            Guardar\n                            <div [ngClass]=\"{ 'hidden': !loading }\"><i class=\"fa fa-spinner fa-spin\"\n                                                                       style=\"font-size:24px\"></i></div>\n                        </button>\n                        <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                    </div>\n                </div>\n\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n            </form>\n        </div>\n    </div>\n</div>\n\n<div bsModal #previewMailModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"previewMailModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Vista Previa</h4>\n            </div>\n            <div class=\"modal-body\">\n                <div [innerHTML]=\"mailTemplateTraduced\"></div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1057 */
/***/ function(module, exports) {

	module.exports = ".rowBorder {\n    border: 1px double rgba(211, 211, 211, 0.12);\n    background: rgba(211, 211, 211, 0.12);\n}\n\n#previewButton {\n    margin-top: 21px;\n}"

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var core_1 = __webpack_require__(1);
	var ng2_dragula_1 = __webpack_require__(1012);
	var router_1 = __webpack_require__(350);
	var cities_service_1 = __webpack_require__(633);
	/**
	 * .
	 * Created by jlado on 23/1/17.
	 */
	var ConfigStateComponent = (function () {
	    function ConfigStateComponent(router, citiesService, dragulaService) {
	        this.router = router;
	        this.citiesService = citiesService;
	        this.dragulaService = dragulaService;
	        this.init();
	        this.find();
	        dragulaService.setOptions('states-bag', {
	            direction: 'vertical',
	            /*Elements in source cant be reordered*/
	            copySortSource: false,
	            moves: function () {
	                return false;
	            }
	        });
	    }
	    ConfigStateComponent.prototype.init = function () {
	        this.states = [];
	        this.cities = [];
	        this.loading = false;
	        this.deleteMode = false;
	    };
	    ConfigStateComponent.prototype.find = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.citiesService.getStates().subscribe(function (data) { return _this.refreshData(data); }, function () {
	            _this.bindError('Ocurrió un error al buscar las provincias.');
	        });
	    };
	    ConfigStateComponent.prototype.showCities = function (state) {
	        var _this = this;
	        this.stateSelected = state;
	        if (this.stateSelected != null) {
	            this.citiesService.getCities(this.stateSelected.id).subscribe(function (data) { return _this.cities = data; }, function () {
	                _this.bindError('Ocurrió un error al buscar las localidades.');
	            });
	        }
	    };
	    ConfigStateComponent.prototype.refreshData = function (states) {
	        this.states = states;
	        this.loading = false;
	    };
	    ConfigStateComponent.prototype.removeState = function (deleteModal) {
	        var _this = this;
	        this.clearMessages();
	        this.citiesService.deleteState(this.stateSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeStateFromView(_this.stateSelected);
	            _this.deleteMode = true;
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar la provincia.');
	        });
	    };
	    ConfigStateComponent.prototype.removeStateFromView = function (state) {
	        var index = this.states.indexOf(state);
	        if (index > -1) {
	            this.states.splice(index, 1);
	        }
	        this.stateSelected = null;
	    };
	    ConfigStateComponent.prototype.createState = function () {
	        this.router.navigate(['app/home/config/createState']);
	    };
	    ConfigStateComponent.prototype.editState = function (state) {
	        this.router.navigate(['app/home/config/editState', state.id]);
	    };
	    ConfigStateComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.error = null;
	    };
	    ConfigStateComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigStateComponent = __decorate([
	        core_1.Component({
	            selector: 'config-state',
	            template: __webpack_require__(1059),
	            styles: [__webpack_require__(1060)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_dragula_1.Dragula
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	            viewProviders: [
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS,
	                ng2_dragula_1.DragulaService
	            ],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, cities_service_1.CitiesService, ng2_dragula_1.DragulaService])
	    ], ConfigStateComponent);
	    return ConfigStateComponent;
	}());
	exports.ConfigStateComponent = ConfigStateComponent;


/***/ },
/* 1059 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"col-xs-12\">\n        <h1>Provincias y Localidades</h1>\n    </div>\n    <div class=\"col-xs-12\">\n        <form class=\"form-inline\">\n            <div class=\"panel panel-default\">\n                <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n            </div>\n\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n            </div>\n        </form>\n\n        <div class='wrapper'>\n            <div class=\"row\">\n                <div class=\"col-xs-12 col-sm-12 col-md-12 stateRowHeader\">\n                    <div class=\"col-xs-3 col-sm-3 col-md-3\">\n                        <p class=\"stateHeader\">Provincia</p>\n                    </div>\n                    <div class=\"col-xs-7 col-sm-7 col-md-7\">\n                        <p class=\"stateHeader\">Localidades</p>\n                    </div>\n                    <div class=\"col-xs-2 col-sm-2 col-md-2\">\n                        <p class=\"stateHeader\">Acciones</p>\n                    </div>\n                </div>\n            </div>\n            <div>\n                <div class=\"list-group\" [dragula]='\"states-bag\"' [dragulaModel]='states'>\n                    <div class=\"list-group-item\" *ngFor=\"let state of states\">\n                        <div class=\"row handable\">\n                            <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                                <div class=\"col-xs-3 col-sm-3 col-md-3\">\n                                    <p class=\"stateItem\">{{state.name}}</p>\n                                </div>\n                                <div class=\"col-xs-7 col-sm-7 col-md-7 citiesBox\">\n                                    <button class=\"btn btn-primary\" title=\"Ver localidades\"\n                                            (click)=\"showCities(state);cityModal.show();\"\n                                            [disabled]=\" state?.name==='NO ASIGNADO'\">\n                                        Ver localidades\n                                    </button>\n                                </div>\n                                <div class=\"col-xs-2 col-sm-2 col-md-2 stateActions\">\n                                    <button class=\"btn btn-primary\" title=\"Editar\"\n                                            (click)=\"editState(state)\"\n                                            [disabled]=\" state?.name==='NO ASIGNADO'\">\n                                        <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                                        <span class=\"pencil\"><img></span>\n                                    </button>\n                                    <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                            (click)=\"stateSelected=state;deleteModal.show();\"\n                                            [disabled]=\" state?.name==='NO ASIGNADO'\">\n                                        <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                                        <span class=\"remove\"><img></span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <form class=\"form-inline\">\n            <div class=\"panel panel-default\">\n                <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n            </div>\n\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n            </div>\n        </form>\n\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"createState()\">\n            <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n            <span class=\"plus\"><img></span>\n             Nuevo\n        </button>\n    </div>\n</div>\n\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n            </div>\n            <div class=\"modal-body\">\n                ¿Está seguro que desea eliminar la provincia\n                <strong>{{stateSelected?.name}}</strong>\n                ? Con ella, se eliminarán todas las localidades asociadas y se asignará 'NO ASIGNADO' a las direcciones.\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n                        (click)=\"removeState(deleteModal)\">Aceptar\n                </button>\n                <button type=\"button\" class=\"btn btn-default\" aria-label=\"Cancelar\"\n                        (click)=\"deleteModal.hide()\">Cancelar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #cityModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cityModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Localidades de <strong>{{stateSelected?.name}}</strong></h4>\n            </div>\n            <div class=\"modal-body\">\n                <li *ngFor=\"let city of cities\">{{city.name}}</li>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1060 */
/***/ function(module, exports) {

	module.exports = ".header {\n    height: 30px;\n    padding-left: 5px;\n    padding-top: 2px;\n    text-align: center;\n}\n\n.left {\n    border-right: 1px solid #000000;\n    padding: 0px;\n    overflow: scroll;\n}\n\n.right {\n    padding: 0px;\n    overflow: scroll;\n}\n\n.gu-mirror {\n    position: fixed !important;\n    margin: 0 !important;\n    z-index: 9999 !important;\n    opacity: 0.8;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n    filter: alpha(opacity=80);\n}\n\n.gu-hide {\n    display: none !important;\n}\n\n.gu-unselectable {\n    -webkit-user-select: none !important;\n    -moz-user-select: none !important;\n    -ms-user-select: none !important;\n    user-select: none !important;\n}\n\n.gu-transit {\n    opacity: 0.2;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n    filter: alpha(opacity=20);\n}\n\n.stateItem {\n    padding-top: 5px;\n    text-align: center;\n    white-space: normal;\n}\n\n.stateHeader {\n    padding-bottom: 5px;\n    text-align: center;\n}\n\n.stateActions {\n    text-align: end;\n}\n\n.stateRowHeader {\n    font-weight: bold;\n}\n\n.handable {\n    cursor: pointer;\n}\n\n.citiesBox {\n    padding-left: 25%;\n    padding-right: 25%;\n}"

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var core_1 = __webpack_require__(1);
	var validators_1 = __webpack_require__(849);
	var router_1 = __webpack_require__(350);
	var async_1 = __webpack_require__(1028);
	var state_1 = __webpack_require__(878);
	var cities_service_1 = __webpack_require__(633);
	var city_1 = __webpack_require__(877);
	var ng2_dragula_1 = __webpack_require__(1012);
	/**
	 * .
	 * Created by jlado on 1/23/17.
	 */
	var StateEditorComponent = (function () {
	    function StateEditorComponent(citiesService, route, dragulaService) {
	        this.citiesService = citiesService;
	        this.route = route;
	        this.dragulaService = dragulaService;
	        this.close = new async_1.EventEmitter();
	        this.init();
	        dragulaService.setOptions('cities-bag', {
	            direction: 'vertical',
	            /*Elements in source cant be reordered*/
	            copySortSource: false,
	            moves: function () {
	                return false;
	            }
	        });
	    }
	    StateEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.loading = false;
	        this.deleteMode = false;
	        this.editMode = false;
	        this.state = new state_1.State();
	        this.cities = [];
	        this.newCity = new city_1.City(null);
	        this.citySelected = new city_1.City(null);
	    };
	    StateEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.createStateFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var stateId = params['stateId'];
	            if (stateId) {
	                _this.stateId = stateId;
	                _this.createMode = false;
	            }
	            else {
	                _this.stateId = null;
	                _this.createMode = true;
	            }
	            _this.getData();
	        });
	    };
	    StateEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    StateEditorComponent.prototype.createStateFormGroup = function () {
	        var group = {};
	        group['nameState'] = new forms_1.FormControl(this.state.name, [forms_1.Validators.required]);
	        this.stateForm = new forms_1.FormGroup(group);
	        group = {};
	        group['nameNewCity'] = new forms_1.FormControl(this.newCity.name, [forms_1.Validators.required]);
	        this.newCityForm = new forms_1.FormGroup(group);
	    };
	    StateEditorComponent.prototype.createCityFormGroup = function () {
	        var group = {};
	        group['nameCity'] = new forms_1.FormControl(this.citySelected.name, [forms_1.Validators.required]);
	        this.cityForm = new forms_1.FormGroup(group);
	    };
	    StateEditorComponent.prototype.getData = function () {
	        var _this = this;
	        if (this.stateId) {
	            this.loading = true;
	            this.citiesService.getCities(this.stateId).subscribe(function (data) {
	                _this.setData(data[0].state);
	                _this.cities = data;
	                _this.newCity.state = data[0].state;
	            }, function () {
	                _this.bindError('Ocurrió un error al obtener los datos y localidades de la provincia.');
	            });
	        }
	    };
	    StateEditorComponent.prototype.setData = function (data) {
	        this.loading = false;
	        if (this.stateId) {
	            this.state = data;
	        }
	        else {
	            this.state = new state_1.State();
	        }
	    };
	    StateEditorComponent.prototype.saveState = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.citiesService.saveState(this.state).subscribe(function (saved) {
	            _this.loading = false;
	            _this.state = saved;
	            _this.createMode = false;
	            _this.stateId = saved.id;
	            _this.successMessage = 'La provincia se guardó con éxito';
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar los datos de la provincia.');
	        });
	    };
	    StateEditorComponent.prototype.saveCity = function (city) {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        city.state = this.state;
	        this.citiesService.saveCity(city).subscribe(function () {
	            _this.loading = false;
	            _this.editMode = false;
	            _this.citySelected = null;
	            _this.getData();
	            _this.successMessage = 'La localidad se guardó con éxito';
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar los datos de la localidad.');
	        });
	    };
	    StateEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    StateEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.state);
	        window.history.back();
	    };
	    StateEditorComponent.prototype.removeCity = function (deleteModal) {
	        var _this = this;
	        this.clearMessages();
	        this.citiesService.deleteCity(this.citySelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeStateFromView(_this.citySelected);
	            _this.deleteMode = true;
	            _this.successMessage = 'La localidad se eliminó con éxito.';
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar la localidad.');
	        });
	    };
	    StateEditorComponent.prototype.removeStateFromView = function (city) {
	        var index = this.cities.indexOf(city);
	        if (index > -1) {
	            this.cities.splice(index, 1);
	        }
	        this.citySelected = null;
	    };
	    StateEditorComponent.prototype.editCity = function (city) {
	        this.citySelected = city;
	        this.createCityFormGroup();
	        this.editMode = true;
	        this.divToScroll.nativeElement.scrollIntoView(false);
	    };
	    StateEditorComponent.prototype.cancelCity = function () {
	        this.citySelected = null;
	        this.editMode = false;
	    };
	    StateEditorComponent.prototype.addNewCity = function () {
	        this.newCity.state = this.state;
	        this.saveCity(this.newCity);
	        this.newCity = new city_1.City(null);
	        this.getData();
	    };
	    StateEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', state_1.State)
	    ], StateEditorComponent.prototype, "state", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], StateEditorComponent.prototype, "close", void 0);
	    __decorate([
	        core_1.ViewChild('scrollMe'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], StateEditorComponent.prototype, "divToScroll", void 0);
	    StateEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'state-editor',
	            template: __webpack_require__(1062),
	            styles: [__webpack_require__(1063)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_dragula_1.Dragula
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS,
	                ng2_dragula_1.DragulaService
	            ],
	        }), 
	        __metadata('design:paramtypes', [cities_service_1.CitiesService, router_1.ActivatedRoute, ng2_dragula_1.DragulaService])
	    ], StateEditorComponent);
	    return StateEditorComponent;
	}());
	exports.StateEditorComponent = StateEditorComponent;


/***/ },
/* 1062 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nueva Provincia</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Provincia</h2>\n        </div>\n\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n\n        <div #scrollMe class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"stateForm\" (ngSubmit)=\"saveState()\" *ngIf=\"state\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\n                <div class=\"row parentDiv\">\n                    <div class=\"form-group form-group-sm col-sm-5 form-group-fix\">\n                        <label for=\"nameState\">Nombre</label>\n                        <input type=\"text\" class=\"form-control\" id=\"nameState\"\n                               [(ngModel)]=\"state.name\" name=\"nameState\" formControlName=\"nameState\"/>\n\n                        <div *ngIf=\"!stateForm.controls.nameState.valid && stateForm.controls.nameState.errors.required\"\n                             class=\"alert-danger\">\n                            {{errorMessages.required}}\n                        </div>\n                    </div>\n                    <div class=\"col-sm-5 childDiv\">\n                        <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"!stateForm.valid || loading\">\n                            Guardar provincia\n                        </button>\n                        <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                    </div>\n                </div>\n            </form>\n            <div *ngIf=\"!createMode\">\n                <legend>Nueva Localidad</legend>\n                <form role=\"form\" [formGroup]=\"newCityForm\" (ngSubmit)=\"addNewCity()\">\n                    <div class=\"row parentDiv\">\n                        <div class=\"form-group form-group-sm col-sm-5 form-group-fix\">\n                            <label for=\"nameNewCity\">Nombre</label>\n                            <input type=\"text\" class=\"form-control\" id=\"nameNewCity\"\n                                   [(ngModel)]=\"newCity.name\" name=\"nameNewCity\" formControlName=\"nameNewCity\"/>\n\n                            <div *ngIf=\"!newCityForm.controls.nameNewCity.valid && newCityForm.controls.nameNewCity.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"col-sm-5 childDiv\">\n                            <button type=\"submit\" class=\"btn btn-success\"\n                                    [disabled]=\"!newCityForm.valid || loading\">\n                                <i class=\"fa fa-plus\"></i>\n                                Agregar localidad\n                            </button>\n                        </div>\n                    </div>\n                </form>\n                <legend>Localidades</legend>\n                <div class='wrapper'>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12 col-sm-12 col-md-12 cityRowHeader\">\n                            <div class=\"col-xs-10 col-sm-10 col-md-10\">\n                                <p class=\"cityHeader\">Localidad</p>\n                            </div>\n                            <div class=\"col-xs-2 col-sm-2 col-md-2\">\n                                <p class=\"cityHeader\">Acciones</p>\n                            </div>\n                        </div>\n                    </div>\n                    <div>\n                        <div class=\"list-group\" [dragula]='\"cities-bag\"' [dragulaModel]='cities'>\n                            <div class=\"list-group-item\" *ngFor=\"let city of cities\">\n                                <div class=\"row handable\">\n                                    <div class=\"col-xs-12 col-sm-12 col-md-12\">\n                                        <div class=\"col-xs-10 col-sm-5 col-md-10\">\n                                            <p class=\"cityItem\">{{city.name}}</p>\n                                        </div>\n                                        <div class=\"col-xs-2 col-sm-2 col-md-2 cityActions\">\n                                            <button class=\"btn btn-primary\" title=\"Editar\"\n                                                    (click)=\"editCity(city)\"\n                                                    [disabled]=\"city?.name==='NO ASIGNADO'\">\n                                                <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                                                <span class=\"pencil\"><img></span>\n                                            </button>\n                                            <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                                    (click)=\"citySelected=city;deleteModal.show();\"\n                                                    [disabled]=\" city?.name==='NO ASIGNADO'\">\n                                                <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                                                <span class=\"remove\"><img></span>\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\n                <form role=\"form\" [formGroup]=\"cityForm\" (ngSubmit)=\"saveCity(citySelected)\" *ngIf=\"editMode\">\n                    <legend>Editar localidad</legend>\n                    <div class=\"row parentDiv\">\n                        <div class=\"form-group form-group-sm col-sm-5 form-group-fix\">\n                            <label for=\"nameCity\">Nombre</label>\n                            <input type=\"text\" class=\"form-control\" id=\"nameCity\"\n                                   [(ngModel)]=\"citySelected.name\" name=\"nameCity\"\n                                   formControlName=\"nameCity\"/>\n\n                            <div *ngIf=\"!cityForm.controls.nameCity.valid && cityForm.controls.nameCity.errors.required\"\n                                 class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"col-sm-5 childDiv\">\n                            <button type=\"submit\" class=\"btn btn-success\"\n                                    [disabled]=\"!cityForm.valid || loading\">Guardar localidad\n                            </button>\n                            <button (click)=\"cancelCity()\" class=\"btn btn-default\">Cancelar edición\n                            </button>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n<div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n     aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n            </div>\n            <div class=\"modal-body\">\n                ¿Está seguro que desea eliminar la localidad\n                <strong>{{citySelected?.name}}</strong>\n                ? Se asignará 'NO ASIGNADO' a las direcciones que la contenga.\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\"\n                        (click)=\"removeCity(deleteModal)\">Aceptar\n                </button>\n                <button type=\"button\" class=\"btn btn-default\" aria-label=\"Cancelar\"\n                        (click)=\"deleteModal.hide()\">Cancelar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1063 */
/***/ function(module, exports) {

	module.exports = ".header {\n    height: 30px;\n    padding-left: 5px;\n    padding-top: 2px;\n    text-align: center;\n}\n\n.left {\n    border-right: 1px solid #000000;\n    padding: 0;\n    overflow: scroll;\n}\n\n.right {\n    padding: 0;\n    overflow: scroll;\n}\n\n.gu-mirror {\n    position: fixed !important;\n    margin: 0 !important;\n    z-index: 9999 !important;\n    opacity: 0.8;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=80)\";\n    filter: alpha(opacity=80);\n}\n\n.gu-hide {\n    display: none !important;\n}\n\n.gu-unselectable {\n    -webkit-user-select: none !important;\n    -moz-user-select: none !important;\n    -ms-user-select: none !important;\n    user-select: none !important;\n}\n\n.gu-transit {\n    opacity: 0.2;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";\n    filter: alpha(opacity=20);\n}\n\n.cityItem {\n    padding-top: 5px;\n    text-align: center;\n    white-space: normal;\n}\n\n.cityHeader {\n    padding-bottom: 5px;\n    text-align: center;\n}\n\n.cityActions {\n    text-align: end;\n}\n\n.cityRowHeader {\n    font-weight: bold;\n}\n\n.handable {\n    cursor: pointer;\n}\n\n.rowRelative {\n    position: relative;\n}\n\n.parentDiv {\n    position: relative;\n}\n\n.childDiv {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n\n.form-group-fix {\n    margin-bottom: 0;\n}\n\nlegend {\n    padding-left: 10px;\n}"

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var vehicle_1 = __webpack_require__(873);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var kmHistory_1 = __webpack_require__(884);
	var kmHistory_service_1 = __webpack_require__(912);
	var KmHistoryEditorComponent = (function () {
	    function KmHistoryEditorComponent(router, kmHistoryService, route, loginService) {
	        this.router = router;
	        this.kmHistoryService = kmHistoryService;
	        this.route = route;
	        this.loginService = loginService;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    KmHistoryEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.newKmHistory = new kmHistory_1.KmHistory();
	        this.loading = false;
	        this.canEdit = false;
	        var dateStrParts = new Date();
	        this.todayStr = this.padLeft(dateStrParts.getDate().toString(), '0', 2) + '/' +
	            this.padLeft((dateStrParts.getMonth() + 1).toString(), '0', 2) + '/' + dateStrParts.getFullYear();
	        this.newKmHistory.loadDate = this.todayStr;
	        this.vehicle = new vehicle_1.Vehicle();
	    };
	    KmHistoryEditorComponent.prototype.padLeft = function (text, padChar, size) {
	        return (String(padChar).repeat(size) + text).substr((size * -1), size);
	    };
	    KmHistoryEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            type: new forms_1.FormControl(this.vehicle.type.description),
	            patent: new forms_1.FormControl(this.vehicle.patent),
	            brand: new forms_1.FormControl(this.vehicle.brand.name),
	            model: new forms_1.FormControl(this.vehicle.model),
	            year: new forms_1.FormControl(this.vehicle.year),
	            engineNumber: new forms_1.FormControl(this.vehicle.engineNumber),
	            newKmHistoryDate: new forms_1.FormControl(this.newKmHistory.loadDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            newKmHistoryKm: new forms_1.FormControl(this.newKmHistory.km, [forms_1.Validators.required, validators_1.INTEGER_VALIDATOR]),
	            newKmHistoryService: new forms_1.FormControl(this.newKmHistory.service),
	            newKmHistoryComments: new forms_1.FormControl(this.newKmHistory.comments)
	        });
	    };
	    KmHistoryEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var userLogged = this.loginService.getUserLogged();
	        this.canEdit = userLogged.isActionAllowed('KM_HISTORY', 'EDIT', 'KM_HISTORY');
	        this.createFormGroup();
	        this.newKmHistory.service = '';
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.vehicleId = params['vehicleId'];
	            _this.getData();
	        });
	    };
	    KmHistoryEditorComponent.prototype.ngAfterViewInit = function () {
	    };
	    KmHistoryEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        this.errorMessage = null;
	        this.kmHistoryService.getVehicle(this.vehicleId).subscribe(function (vehicle) {
	            if (vehicle && vehicle.id) {
	                _this.vehicle = vehicle;
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al obtener el vehículo.');
	        });
	        this.loading = false;
	    };
	    KmHistoryEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    KmHistoryEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	        this.warningMessage = null;
	    };
	    KmHistoryEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.kmHistoryService.save(this.vehicle).subscribe(function (saved) {
	            _this.loading = false;
	            _this.vehicle = saved;
	            _this.successMessage = 'La carga de kilómetros se guardó con éxito';
	            if (_this.checkPreSaveKmHistories()) {
	                _this.bindWarning('Existen Históricos de kilómetros sin guardar.');
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar la información.');
	        });
	    };
	    KmHistoryEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.vehicle);
	        window.history.back();
	    };
	    KmHistoryEditorComponent.prototype.addNewKmHistoryToVehicle = function () {
	        this.vehicle.kmHistories.push((JSON.parse(JSON.stringify(this.newKmHistory))));
	        this.newKmHistory = new kmHistory_1.KmHistory();
	        this.newKmHistory.loadDate = this.todayStr;
	        this.newKmHistory.service = '';
	    };
	    KmHistoryEditorComponent.prototype.addNewKmHistory = function (event) {
	        event.preventDefault();
	        this.addNewKmHistoryToVehicle();
	        this.clearMessages();
	        this.bindWarning('Existen Históricos de kilómetros sin guardar.');
	    };
	    KmHistoryEditorComponent.prototype.deleteKmHistory = function (event, index, id) {
	        var _this = this;
	        event.preventDefault();
	        this.clearMessages();
	        this.loading = true;
	        if (id != undefined && id != null) {
	            this.kmHistoryService.delete(id).subscribe(function () {
	                _this.loading = false;
	                _this.successMessage = 'La carga de kilómetros se eliminó con éxito';
	                _this.loading = false;
	                _this.vehicle.kmHistories.splice(index, 1);
	                if (_this.checkPreSaveKmHistories()) {
	                    _this.bindWarning('Existen Históricos de kilómetros sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al eliminar el histórico.');
	            });
	        }
	        else {
	            this.loading = false;
	            this.vehicle.kmHistories.splice(index, 1);
	            if (this.checkPreSaveKmHistories()) {
	                this.bindWarning('Existen Históricos de kilómetros sin guardar.');
	            }
	        }
	    };
	    KmHistoryEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    KmHistoryEditorComponent.prototype.bindWarning = function (messageWarning) {
	        this.loading = false;
	        if (this.warningMessage == null) {
	            this.warningMessage = messageWarning;
	        }
	        else {
	            this.warningMessage = this.warningMessage.toString() + ' ' + messageWarning;
	        }
	    };
	    KmHistoryEditorComponent.prototype.checkPreSaveKmHistories = function () {
	        var hasPreSaveKmHistories = false;
	        this.vehicle.kmHistories.forEach(function (kmHistory) {
	            if (kmHistory.id === undefined || kmHistory.id === null) {
	                hasPreSaveKmHistories = true;
	            }
	        });
	        return hasPreSaveKmHistories;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', vehicle_1.Vehicle)
	    ], KmHistoryEditorComponent.prototype, "vehicle", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], KmHistoryEditorComponent.prototype, "close", void 0);
	    KmHistoryEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'kmHistory-editor',
	            template: __webpack_require__(1065),
	            styles: [__webpack_require__(1066)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, kmHistory_service_1.KmHistoryService, router_1.ActivatedRoute, login_service_1.LoginService])
	    ], KmHistoryEditorComponent);
	    return KmHistoryEditorComponent;
	}());
	exports.KmHistoryEditorComponent = KmHistoryEditorComponent;


/***/ },
/* 1065 */
/***/ function(module, exports) {

	module.exports = "<div>\n\t<div class=\"panel panel-default\">\n\t\t<div class=\"panel-heading\">\n\t\t\t<h2 class=\"panel-title\">Carga de kilómetros</h2>\n\t\t</div>\n\t\t<div class=\"col-md-12\">\n\t\t\t<div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n\t\t\t\t<i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\"></i>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"panel-body\">\n\t\t\t<form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\"\n\t\t\t\t*ngIf=\"vehicle\">\n\t\t\t\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n\t\t\t\t<div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-3\">\n\t\t\t\t\t\t<label for=\"type\">Tipo</label> <input type=\"text\"\n\t\t\t\t\t\t\tclass=\"form-control\" [(ngModel)]=\"vehicle.type.description\"\n\t\t\t\t\t\t\tname=\"type\" formControlName=\"type\" id=\"type\" [disabled]=\"true\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-3\">\n\t\t\t\t\t\t<label for=\"patent\">Patente</label> <input type=\"text\"\n\t\t\t\t\t\t\tclass=\"form-control\" [(ngModel)]=\"vehicle.patent\" name=\"patent\"\n\t\t\t\t\t\t\tformControlName=\"patent\" id=\"patent\" [disabled]=\"true\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-3\">\n\t\t\t\t\t\t<label for=\"brand\">Marca</label> <input\n\t\t\t\t\t\t\t[(ngModel)]=\"vehicle.brand.name\" id=\"brand\" class=\"form-control\"\n\t\t\t\t\t\t\tformControlName=\"brand\" [disabled]=\"true\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-3\">\n\t\t\t\t\t\t<label for=\"model\">Modelo</label> <input type=\"text\"\n\t\t\t\t\t\t\tclass=\"form-control\" formControlName=\"model\"\n\t\t\t\t\t\t\t[(ngModel)]=\"vehicle.model\" name=\"model\" id=\"model\"\n\t\t\t\t\t\t\t[disabled]=\"true\">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-3\">\n\t\t\t\t\t\t<label for=\"year\">A&ntilde;o</label> <input type=\"text\"\n\t\t\t\t\t\t\tclass=\"form-control\" formControlName=\"year\"\n\t\t\t\t\t\t\t[(ngModel)]=\"vehicle.year\" id=\"year\" name=\"year\"\n\t\t\t\t\t\t\t[disabled]=\"true\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-3\">\n\t\t\t\t\t\t<label for=\"engineNumber\">Motor</label> <input type=\"text\"\n\t\t\t\t\t\t\tclass=\"form-control\" formControlName=\"engineNumber\"\n\t\t\t\t\t\t\t[(ngModel)]=\"vehicle.engineNumber\" id=\"engineNumber\"\n\t\t\t\t\t\t\tname=\"engineNumber\" [disabled]=\"true\">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div *ngIf=\"vehicle.id\">\n\t\t\t\t\t<h4 *ngIf=\"canEdit\">Nuevo Histórico de kilómetros</h4>\n\t\t\t\t\t<div class=\"panel panel-default\" *ngIf=\"canEdit\">\n\t\t\t\t\t\t<div class=\"panel-body\">\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-3\">\n\t\t\t\t\t\t\t\t\t<label for=\"newKmHistoryDate\">Fecha de Carga</label>\n\t\t\t\t\t\t\t\t\t<div class=\"input-group\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"input-group-addon calendar\"><img></span> <input\n\t\t\t\t\t\t\t\t\t\t\ttype=\"text\" class=\"form-control  date-picker\"\n\t\t\t\t\t\t\t\t\t\t\tformControlName=\"newKmHistoryDate\"\n\t\t\t\t\t\t\t\t\t\t\t[(ngModel)]=\"newKmHistory.loadDate\" id=\"newKmHistoryDate\"\n\t\t\t\t\t\t\t\t\t\t\tmaxlength=\"10\" name=\"newKmHistoryDate\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\t\t\t*ngIf=\"!form.controls.newKmHistoryDate.valid && form.controls.newKmHistoryDate.errors.required\"\n\t\t\t\t\t\t\t\t\t\tclass=\"alert-danger\">{{errorMessages.required}}</div>\n\t\t\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\t\t\t*ngIf=\"!form.controls.newKmHistoryDate.valid && form.controls.newKmHistoryDate.errors.pattern\"\n\t\t\t\t\t\t\t\t\t\tclass=\"alert-danger\">{{errorMessages.invalidDate}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-2\">\n\t\t\t\t\t\t\t\t\t<label for=\"newKmHistoryKm\">Km</label> <input type=\"text\"\n\t\t\t\t\t\t\t\t\t\tclass=\"form-control\" formControlName=\"newKmHistoryKm\"\n\t\t\t\t\t\t\t\t\t\t[(ngModel)]=\"newKmHistory.km\" id=\"newKmHistoryKm\"\n\t\t\t\t\t\t\t\t\t\tname=\"newKmHistoryKm\">\n\t\t\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\t\t\t*ngIf=\"!form.controls.newKmHistoryKm.valid && form.controls.newKmHistoryKm.errors.pattern\"\n\t\t\t\t\t\t\t\t\t\tclass=\"alert-danger\">{{errorMessages.invalidAmount}}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-5\">\n\t\t\t\t\t\t\t\t\t<label for=\"newKmHistoryService\">Servicio</label> <select\n\t\t\t\t\t\t\t\t\t\ttype=\"text\" class=\"form-control\"\n\t\t\t\t\t\t\t\t\t\tformControlName=\"newKmHistoryService\"\n\t\t\t\t\t\t\t\t\t\t[(ngModel)]=\"newKmHistory.service\" id=\"newKmHistoryService\"\n\t\t\t\t\t\t\t\t\t\tname=\"newKmHistoryService\">\n\t\t\t\t\t\t\t\t\t\t<option value=\"\" hidden>Seleccione una\n\t\t\t\t\t\t\t\t\t\t\topci&oacute;n...</option>\n\t\t\t\t\t\t\t\t\t\t<option value=\"Cambio de aceite\">Cambio de aceite</option>\n\t\t\t\t\t\t\t\t\t\t<option value=\"Service\">Service</option>\n\t\t\t\t\t\t\t\t\t\t<option value=\"Rotación de cubiertas\">Rotaci&oacute;n\n\t\t\t\t\t\t\t\t\t\t\tde cubiertas</option>\n\t\t\t\t\t\t\t\t\t\t<option value=\"Taller\">Taller</option>\n\t\t\t\t\t\t\t\t\t\t<option value=\"Cambio de correa\">Cambio de correa</option>\n\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-5\">\n\t\t\t\t\t\t\t\t\t<label for=\"newKmHistoryComments\">Comentarios</label>\n\t\t\t\t\t\t\t\t\t<textarea type=\"text\" class=\"form-control\"\n\t\t\t\t\t\t\t\t\t\tformControlName=\"newKmHistoryComments\"\n\t\t\t\t\t\t\t\t\t\t[(ngModel)]=\"newKmHistory.comments\" id=\"newKmHistoryComments\"\n\t\t\t\t\t\t\t\t\t\tname=\"newKmHistoryComments\" rows=\"2\"></textarea>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"form-group form-group-sm col-sm-1\">\n\t\t\t\t\t\t\t\t\t<button (click)=\"addNewKmHistory($event)\"\n\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-success kmHistoryOption\"\n\t\t\t\t\t\t\t\t\t\t[disabled]=\"!form.valid\">\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h4>Histórico de kilómetros</h4>\n\t\t\t\t\t<div *ngIf=\"vehicle.kmHistories.length == 0\" class=\"row\">\n\t\t\t\t\t\t<div class=\"alert alert-info\">Sin histórico de kilómetros</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div *ngIf=\"vehicle.kmHistories.length != 0\"\n\t\t\t\t\t\tclass=\"panel panel-default\">\n\t\t\t\t\t\t<div class=\"panel-body table-responsive\">\n\t\t\t\t\t\t\t<div class=\"alert alert-warning\" *ngIf=\"warningMessage\">{{warningMessage}}</div>\n\t\t\t\t\t\t\t<table class=\"table table-striped\">\n\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th style=\"width: 20%\">Fecha de carga</th>\n\t\t\t\t\t\t\t\t\t\t<th style=\"width: 20%\">Kilómetros</th>\n\t\t\t\t\t\t\t\t\t\t<th style=\"width: 25%\">Servicio</th>\n\t\t\t\t\t\t\t\t\t\t<th style=\"width: 15%\">Comentarios</th>\n\t\t\t\t\t\t\t\t\t\t<th *ngIf=\"canEdit\" style=\"width: 10%\">Acciones</th>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t<tr *ngFor=\"let item of vehicle.kmHistories; let i = index\">\n\t\t\t\t\t\t\t\t\t\t<td>{{item.loadDate}}</td>\n\t\t\t\t\t\t\t\t\t\t<td>{{item.km}} km</td>\n\t\t\t\t\t\t\t\t\t\t<td>{{item.service}}</td>\n\t\t\t\t\t\t\t\t\t\t<td>{{item.comments}}</td>\n\t\t\t\t\t\t\t\t\t\t<td *ngIf=\"canEdit\">\n\t\t\t\t\t\t\t\t\t\t\t<button (click)=\"deleteKmHistory($event, i, item.id)\"\n\t\t\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-danger\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-minus\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-sm-12\">\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t<button type=\"submit\" class=\"btn btn-success\" [disabled]=\"loading\"\n\t\t\t\t\t\t\t*ngIf=\"canEdit\">Guardar</button>\n\t\t\t\t\t\t<button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"row\" style=\"margin-top: 10px\">\n\t\t\t\t\t\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n\t\t\t\t\t\t<div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>";

/***/ },
/* 1066 */
/***/ function(module, exports) {

	module.exports = "textarea {\n    resize: none;\n}\n\n.btn.kmHistoryOption {\n    margin-top: 22px;\n}"

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var vehicle_1 = __webpack_require__(873);
	var router_deprecated_1 = __webpack_require__(1068);
	var patentPayment_service_1 = __webpack_require__(920);
	var procedure_1 = __webpack_require__(885);
	var Observable_1 = __webpack_require__(34);
	var procedure_service_1 = __webpack_require__(916);
	var ng2_file_upload_1 = __webpack_require__(889);
	var ProcedureDocument_1 = __webpack_require__(887);
	var AddPatentPayment_1 = __webpack_require__(888);
	var PatentPaymentEditorComponent = (function () {
	    function PatentPaymentEditorComponent(router, patentPaymentService, procedureService, route, loginService) {
	        var _this = this;
	        this.router = router;
	        this.patentPaymentService = patentPaymentService;
	        this.procedureService = procedureService;
	        this.route = route;
	        this.loginService = loginService;
	        this.close = new core_1.EventEmitter();
	        this.procedureService.getProcedureType('LICENSE_PLATE').subscribe(this.setProcedureType.bind(this), function () {
	            _this.bindError('Ocurrió un error al buscar el tipo de trámite.');
	        });
	        this.init();
	    }
	    PatentPaymentEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.newPatentPayment = new procedure_1.Procedure();
	        this.loading = false;
	        this.canEdit = false;
	        var dateStrParts = new Date();
	        this.todayStr = this.padLeft(dateStrParts.getDate().toString(), '0', 2) + '/' +
	            this.padLeft((dateStrParts.getMonth() + 1).toString(), '0', 2) + '/' + dateStrParts.getFullYear();
	        this.newPatentPayment.customDate = this.todayStr;
	        this.vehicle = new vehicle_1.Vehicle();
	        this.uploaderDocument = new ng2_file_upload_1.FileUploader({});
	        this.hasDocumentDropZoneOver = false;
	        this.isUploading = false;
	        this.expirationTypeUniqueStr = 'UNIQUE';
	    };
	    PatentPaymentEditorComponent.prototype.padLeft = function (text, padChar, size) {
	        return (String(padChar).repeat(size) + text).substr((size * -1), size);
	    };
	    PatentPaymentEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            type: new forms_1.FormControl(this.vehicle.type.description),
	            patent: new forms_1.FormControl(this.vehicle.patent),
	            brand: new forms_1.FormControl(this.vehicle.brand.name),
	            model: new forms_1.FormControl(this.vehicle.model),
	            year: new forms_1.FormControl(this.vehicle.year),
	            engineNumber: new forms_1.FormControl(this.vehicle.engineNumber),
	            newPatentPaymentDescription: new forms_1.FormControl(this.newPatentPayment.description),
	            newPatentPaymentExpirationType: new forms_1.FormControl(this.newPatentPayment.expirationType, [forms_1.Validators.required]),
	            newPatentPaymentCustomDate: new forms_1.FormControl(this.newPatentPayment.customDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            newPatentPaymentSolicitudeDate: new forms_1.FormControl(this.newPatentPayment.patentPayment.solicitudeDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            newPatentPaymentSolicitudePerson: new forms_1.FormControl(this.newPatentPayment.patentPayment.solicitudePerson, [forms_1.Validators.required])
	        });
	    };
	    PatentPaymentEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var userLogged = this.loginService.getUserLogged();
	        this.canEdit = userLogged.isActionAllowed('PATENT_PAYMENT', 'EDIT', 'PATENT_PAYMENT');
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.vehicleId = params['vehicleId'];
	            _this.getData();
	        });
	    };
	    PatentPaymentEditorComponent.prototype.ngAfterViewInit = function () {
	    };
	    PatentPaymentEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        this.errorMessage = null;
	        var forkTasks = [];
	        forkTasks.push(this.procedureService.getExpirationTypes());
	        forkTasks.push(this.patentPaymentService.getVehicle(this.vehicleId));
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los datos de patentes.');
	        });
	    };
	    PatentPaymentEditorComponent.prototype.setData = function (data) {
	        var _this = this;
	        this.loading = false;
	        this.expirationsType = data[0];
	        this.expirationTypeUnique = this.expirationsType.filter(function (expirationType) { return expirationType.id == (1).toString(); })[0];
	        this.vehicle = data[data.length - 1];
	        this.expirationTypeSelectedId = null;
	        if (this.expirationsType.length > 0) {
	            this.newPatentPayment.expirationType = this.expirationsType[0];
	            this.expirationTypeSelectedId = this.expirationsType[0].id;
	        }
	        this.newPatentPayment.type = this.patentPaymentType;
	        this.updateUploaderUrl();
	        this.procedureService.generateProcedureTempId()
	            .subscribe(function (response) {
	            _this.newPatentPayment.tempId = response.value;
	            _this.updateUploaderUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al generar una patente.');
	        });
	    };
	    PatentPaymentEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    PatentPaymentEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	        this.warningMessage = null;
	    };
	    PatentPaymentEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.isUploadingAFile();
	        if (!this.checkAllBeforeSave()) {
	            this.loading = true;
	            this.patentPaymentService.save(this.vehicle).subscribe(function (saved) {
	                _this.loading = false;
	                _this.vehicle = saved;
	                _this.successMessage = 'La carga de patente se guardó con éxito';
	                _this.updateViewAfterSave();
	                if (_this.checkPreSavePatentPayments()) {
	                    _this.bindWarning('Existen Históricos de kilómetros sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al guardar la información.');
	            });
	        }
	        else {
	            this.bindError('Existe un archivo pendiente de subida. Recuerde que el tamaño máximo del archivo a subir es de 10Mb.');
	        }
	    };
	    PatentPaymentEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.vehicle);
	        window.history.back();
	    };
	    PatentPaymentEditorComponent.prototype.addNewPatentPaymentToVehicle = function () {
	        var _this = this;
	        this.uploaderDocument.queue.forEach(function (item) {
	            _this.newPatentPayment.document = new ProcedureDocument_1.ProcedureDocument();
	            _this.newPatentPayment.document.id = "temp/" + _this.newPatentPayment.tempId;
	            _this.newPatentPayment.document.name = item.file.name;
	        });
	        this.vehicle.procedures.push((JSON.parse(JSON.stringify(this.newPatentPayment))));
	        this.newPatentPayment = new procedure_1.Procedure();
	        this.newPatentPayment.customDate = this.todayStr;
	        this.newPatentPayment.type = this.patentPaymentType;
	        this.newPatentPayment.patentPayment = new AddPatentPayment_1.AddPatentPayment();
	        if (this.expirationsType.length > 0) {
	            this.newPatentPayment.expirationType = this.expirationsType[0];
	            this.expirationTypeSelectedId = this.expirationsType[0].id;
	        }
	        this.procedureService.generateProcedureTempId()
	            .subscribe(function (response) {
	            _this.newPatentPayment.tempId = response.value;
	            _this.updateUploaderUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al generar una patente.');
	        });
	        this.uploaderDocument.clearQueue();
	    };
	    PatentPaymentEditorComponent.prototype.addNewPatentPayment = function (event) {
	        event.preventDefault();
	        this.addNewPatentPaymentToVehicle();
	        this.clearMessages();
	        this.bindWarning('Existen Pago de Patentes sin guardar.');
	    };
	    PatentPaymentEditorComponent.prototype.deletePatentPayment = function (event, index, id, idTemp) {
	        var _this = this;
	        event.preventDefault();
	        this.clearMessages();
	        this.loading = true;
	        var notPending = false;
	        if (id != undefined && id != null) {
	            notPending = true;
	            this.patentPaymentService.delete(id).subscribe(function () {
	                _this.loading = false;
	                _this.successMessage = 'La carga de patente se eliminó con éxito';
	                _this.loading = false;
	                _this.vehicle.procedures.splice(index, 1);
	                if (_this.checkPreSavePatentPayments()) {
	                    _this.clearMessages();
	                    _this.bindWarning('Existen Pago de Patentes sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al eliminar la patente.');
	            });
	        }
	        if (idTemp != undefined && idTemp != null) {
	            notPending = true;
	            this.procedureService.deleteTempProcedureDocument(idTemp).subscribe(function () {
	                _this.loading = false;
	                _this.successMessage = 'La carga de patente se eliminó con éxito';
	                _this.loading = false;
	                _this.vehicle.procedures.splice(index, 1);
	                if (_this.checkPreSavePatentPayments()) {
	                    _this.clearMessages();
	                    _this.bindWarning('Existen Pago de Patentes sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al eliminar la patente.');
	            });
	        }
	        if (!notPending) {
	            this.loading = false;
	            this.vehicle.procedures.splice(index, 1);
	            if (this.checkPreSavePatentPayments()) {
	                this.bindWarning('Existen Pago de patentes sin guardar.');
	            }
	        }
	    };
	    PatentPaymentEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    PatentPaymentEditorComponent.prototype.bindWarning = function (messageWarning) {
	        this.loading = false;
	        if (this.warningMessage == null) {
	            this.warningMessage = messageWarning;
	        }
	        else {
	            this.warningMessage = this.warningMessage.toString() + ' ' + messageWarning;
	        }
	    };
	    PatentPaymentEditorComponent.prototype.expirationTypeChange = function (newValue) {
	        var result = this.expirationsType.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.newPatentPayment.expirationType = result[0];
	        }
	        if (this.isUniqueExpirationDate()) {
	            this.newPatentPayment.customDate = null;
	        }
	        else {
	            this.newPatentPayment.customDate = this.todayStr;
	        }
	    };
	    PatentPaymentEditorComponent.prototype.isUniqueExpirationDate = function () {
	        return this.newPatentPayment.expirationType.id !== this.expirationTypeUnique.id;
	    };
	    PatentPaymentEditorComponent.prototype.removeDocument = function () {
	        this.newPatentPayment.document = null;
	    };
	    PatentPaymentEditorComponent.prototype.updateUploaderUrl = function () {
	        var fileOwnerId = this.newPatentPayment.tempId;
	        this.uploaderDocument = new ng2_file_upload_1.FileUploader({
	            url: 'procedure/' + fileOwnerId + '/upload',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	    };
	    PatentPaymentEditorComponent.prototype.isUploadingAFile = function () {
	        this.isUploading = this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderDocument.queue && this.uploaderDocument.queue.length == 0;
	    };
	    PatentPaymentEditorComponent.prototype.fileOverDocument = function (e) {
	        this.hasDocumentDropZoneOver = e;
	    };
	    PatentPaymentEditorComponent.prototype.removeDocumentFromQuee = function (item) {
	        var _this = this;
	        this.procedureService.deleteTempProcedureDocument(this.newPatentPayment.tempId).subscribe(function (result) { return item.remove(); }, function () {
	            _this.bindError('Ocurrió un error al eliminar el documento de patente.');
	        });
	    };
	    PatentPaymentEditorComponent.prototype.checkAllBeforeSave = function () {
	        return this.isUploading || this.loading || this.uploaderDocument.isUploading;
	    };
	    PatentPaymentEditorComponent.prototype.updateViewAfterSave = function () {
	        var _this = this;
	        this.uploaderDocument.clearQueue();
	        this.vehicle.procedures.forEach(function (procedure, index) {
	            if (procedure.id == undefined || procedure.id == null) {
	                _this.vehicle.procedures.splice(index, 1);
	            }
	        });
	    };
	    PatentPaymentEditorComponent.prototype.setProcedureType = function (patentPayment) {
	        this.patentPaymentType = patentPayment;
	    };
	    PatentPaymentEditorComponent.prototype.checkIfNotValid = function () {
	        if (!this.form.controls["newPatentPaymentCustomDate"].valid &&
	            this.newPatentPayment.expirationType.id === this.expirationTypeUnique.id) {
	            return true;
	        }
	        /*!this.form.valid ||*/
	        return this.loading || this.uploaderDocument.isUploading || this.uploaderDocument.queue.length == 0;
	    };
	    PatentPaymentEditorComponent.prototype.checkPreSavePatentPayments = function () {
	        var hasPreSavePatentPayments = false;
	        this.vehicle.procedures.forEach(function (patentPayment) {
	            if (patentPayment.id === undefined || patentPayment.id === null) {
	                hasPreSavePatentPayments = true;
	            }
	        });
	        return hasPreSavePatentPayments;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', vehicle_1.Vehicle)
	    ], PatentPaymentEditorComponent.prototype, "vehicle", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], PatentPaymentEditorComponent.prototype, "close", void 0);
	    __decorate([
	        core_1.ViewChild('inputDocument'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], PatentPaymentEditorComponent.prototype, "inputAct", void 0);
	    PatentPaymentEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'patentPayment-editor',
	            template: __webpack_require__(1097),
	            styles: [__webpack_require__(1098)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                router_1.ROUTER_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS, router_deprecated_1.ROUTER_PROVIDERS],
	            pipes: [
	                validators_1.IsExpirated
	            ]
	        }), 
	        __metadata('design:paramtypes', [router_deprecated_1.Router, patentPayment_service_1.PatentPaymentService, procedure_service_1.ProcedureService, router_1.ActivatedRoute, login_service_1.LoginService])
	    ], PatentPaymentEditorComponent);
	    return PatentPaymentEditorComponent;
	}());
	exports.PatentPaymentEditorComponent = PatentPaymentEditorComponent;


/***/ },
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\">Carga de patentes</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"vehicle\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"type\">Tipo</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"vehicle.type.description\" name=\"type\"\n                               formControlName=\"type\" id=\"type\" [disabled]=\"true\"/>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"patent\">Patente</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"vehicle.patent\" name=\"patent\"\n                               formControlName=\"patent\" id=\"patent\" [disabled]=\"true\"/>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"brand\">Marca</label>\n                        <input [(ngModel)]=\"vehicle.brand.name\" id=\"brand\" class=\"form-control\" formControlName=\"brand\"\n                               [disabled]=\"true\">\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"model\">Modelo</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"model\" [(ngModel)]=\"vehicle.model\"\n                               name=\"model\" id=\"model\" [disabled]=\"true\">\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"year\">A&ntilde;o</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"year\" [(ngModel)]=\"vehicle.year\"\n                               id=\"year\" name=\"year\" [disabled]=\"true\">\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"engineNumber\">Motor</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"engineNumber\"\n                               [(ngModel)]=\"vehicle.engineNumber\" id=\"engineNumber\" name=\"engineNumber\"\n                               [disabled]=\"true\">\n                    </div>\n                </div>\n\n                <div *ngIf=\"vehicle.id\">\n                    <h4 *ngIf=\"canEdit\">Nuevo Pago de Patente</h4>\n                    <div class=\"panel panel-default\" *ngIf=\"canEdit\">\n                        <div class=\"panel-body\">\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-md-3\">\n                                    <label for=\"type\">Tipo de vencimiento</label>\n                                    <select class=\"form-control\" formControlName=\"newPatentPaymentExpirationType\"\n                                            [(ngModel)]=\"expirationTypeSelectedId\"\n                                            name=\"newPatentPaymentExpirationType\"\n                                            id=\"newPatentPaymentExpirationType\"\n                                            (change)=\"expirationTypeChange($event.target.value)\">\n                                        <option *ngFor=\"let type of expirationsType\" [value]=\"type.id\">\n                                            {{type.description | uppercase}}\n                                        </option>\n                                    </select>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-3\" [hidden]=\"isUniqueExpirationDate()\">\n                                    <label for=\"newPatentPaymentCustomDate\">Fecha única</label>\n                                    <input type=\"text\" class=\"form-control\"\n                                           formControlName=\"newPatentPaymentCustomDate\"\n                                           [(ngModel)]=\"newPatentPayment.customDate\" id=\"newPatentPaymentCustomDate\"\n                                           name=\"newPatentPaymentCustomDate\">\n                                    <div *ngIf=\"!form.controls.newPatentPaymentCustomDate.valid && form.controls.newPatentPaymentCustomDate.errors.pattern\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.invalidDate}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-6\">\n                                    <label for=\"newPatentPaymentDescription\">Comentarios</label>\n                                    <textarea type=\"text\" class=\"form-control\"\n                                              formControlName=\"newPatentPaymentDescription\"\n                                              [(ngModel)]=\"newPatentPayment.description\"\n                                              id=\"newPatentPaymentDescription\"\n                                              name=\"newPatentPaymentDescription\" rows=\"2\"></textarea>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newPatentPaymentSolicitudeDate\">Fecha de solicitud</label>\n                                    <input type=\"text\" class=\"form-control\"\n                                           formControlName=\"newPatentPaymentSolicitudeDate\"\n                                           [(ngModel)]=\"newPatentPayment.patentPayment.solicitudeDate\"\n                                           id=\"newPatentPaymentSolicitudeDate\"\n                                           name=\"newPatentPaymentSolicitudeDate\">\n                                    <div *ngIf=\"!form.controls.newPatentPaymentSolicitudeDate.valid && form.controls.newPatentPaymentSolicitudeDate.errors.pattern\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.invalidDate}}\n                                    </div>\n                                    <div *ngIf=\"!form.controls.newPatentPaymentSolicitudeDate.valid && form.controls.newPatentPaymentSolicitudeDate.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-md-3\">\n                                    <label for=\"newPatentPaymentSolicitudePerson\">Persona / Sector</label>\n                                    <input type=\"text\" class=\"form-control\"\n                                           formControlName=\"newPatentPaymentSolicitudePerson\"\n                                           [(ngModel)]=\"newPatentPayment.patentPayment.solicitudePerson\"\n                                           id=\"newPatentPaymentSolicitudePerson\"\n                                           name=\"newPatentPaymentSolicitudePerson\"/>\n                                    <div *ngIf=\"!form.controls.newPatentPaymentSolicitudePerson.valid && form.controls.newPatentPaymentSolicitudePerson.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <h3 class=\"titleUploader\">Patente</h3>\n                                    <div *ngIf=\"newPatentPayment.document\">\n                                        <a href=\"/procedure/{{newPatentPayment.id}}/download\" target=\"file\">\n                                            <span class=\"paperclip\"><img></span>\n                                            {{newPatentPayment.document.name}}\n                                        </a>\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"removeDocument()\"\n                                                *ngIf=\"canEdit\">\n                                            <span class=\"trash\"><img></span>\n                                            Eliminar\n                                        </button>\n                                    </div>\n                                    <div *ngIf=\"canEdit && (!newPatentPayment.document && uploaderDocument.queue.length == 0)\">\n                                        <div ng2FileDrop\n                                             [ngClass]=\"{'nv-file-over': hasDocumentDropZoneOver}\"\n                                             (fileOver)=\"fileOverDocument($event)\"\n                                             [uploader]=\"uploaderDocument\"\n                                             class=\"well my-drop-zone\">\n                                            Arrastre el archivo aqu&iacute;\n                                        </div>\n                                        <label for=\"inputDocument\" class=\"custom-file-upload\">\n                                            <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                                        </label>\n                                        <input id=\"inputDocument\" type=\"file\" ng2FileSelect\n                                               [uploader]=\"uploaderDocument\" #inputDocument/>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\" *ngIf=\"uploaderDocument.queue?.length > 0\">\n                                <div class=\"col-md-12\">\n                                    <h4>Archivo pendiente a asociar a la patente</h4>\n                                    <table class=\"table\">\n                                        <thead>\n                                        <tr>\n                                            <th width=\"50%\">Nombre</th>\n                                            <th>Tipo</th>\n                                            <th>Estado</th>\n                                            <th>Acciones</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr *ngFor=\"let item of uploaderDocument.queue\">\n                                            <td><strong>{{item.file.name}}</strong></td>\n                                            <td>PATENTE</td>\n                                            <td class=\"text-center\">\n                                                <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                                <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                                <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                            </td>\n                                            <td nowrap>\n                                                <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                        (click)=\"item.upload()\"\n                                                        [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                    <span class=\"upload-icon\"><img></span>\n                                                    Subir\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                        (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                                    <span class=\"ban-circle-white\"><img></span>\n                                                    Cancelar\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                        (click)=\"removeDocumentFromQuee(item)\">\n                                                    <span class=\"trash\"><img></span>\n                                                    Eliminar\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        <tr *ngIf=\"uploaderDocument.queue?.length == 0\">\n                                            <td colspan=\"4\" class=\"text-center\">\n                                                No hay archivos pendientes de asociar a la patente\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-1\">\n                                    <button (click)=\"addNewPatentPayment($event)\"\n                                            class=\"btn btn-success patentPaymentOption\"\n                                            [disabled]=\"checkIfNotValid()\">\n                                        <i class=\"fa fa-plus\"> Cargar patente</i>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <h4>Patentes</h4>\n                    <div *ngIf=\"vehicle.procedures.length == 0\" class=\"row\">\n                        <div class=\"alert alert-info\">Sin patentes cargadas</div>\n                    </div>\n                    <div *ngIf=\"vehicle.procedures.length != 0\" class=\"panel panel-default\">\n                        <div class=\"panel-body table-responsive\">\n                            <div class=\"alert alert-warning\" *ngIf=\"warningMessage\">{{warningMessage}}</div>\n                            <table class=\"table table-striped\">\n                                <thead>\n                                <tr>\n                                    <th style=\"width: 15%\">Fecha de carga</th>\n                                    <th style=\"width: 20%\">Comentarios</th>\n                                    <th style=\"width: 10%\">Vencimiento</th>\n                                    <th style=\"width: 10%\">Estado</th>\n                                    <th style=\"width: 10%\">Fecha de Solicitud</th>\n                                    <th style=\"width: 10%\">Persona / Sector</th>\n                                    <th style=\"width: 20%\">Documento</th>\n                                    <th *ngIf=\"canEdit\" style=\"width: 5%\">Acciones</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr *ngFor=\"let item of vehicle.procedures; let i = index\">\n                                    <td>{{item.creationDate}}</td>\n                                    <td>{{item.description}}</td>\n                                    <td>\n                                        {{(item.expirationType.description|uppercase)}}\n                                        {{item.customDate}}\n                                    </td>\n                                    <td>\n                                        {{item.done | isExpirated : item.customDate}}\n                                    </td>\n                                    <td>\n                                        {{item.patentPayment?.solicitudeDate}}\n                                    </td>\n                                    <td>\n                                        {{item.patentPayment?.solicitudePerson}}\n                                    </td>\n                                    <td>\n                                        <a href=\"/procedure/{{(item.id) ? item.id : item.document.id}}/download\"\n                                           target=\"file\">\n                                            <span class=\"paperclip\"><img></span>\n                                            {{item.document.name}}\n                                        </a>\n                                    </td>\n                                    <td *ngIf=\"canEdit\">\n                                        <button (click)=\"deletePatentPayment($event, i, item.id, item.tempId)\"\n                                                class=\"btn btn-danger\">\n                                            <i class=\"fa fa-minus\"></i>\n                                        </button>\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"col-sm-12\">\n                    <div class=\"row\">\n                        <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"loading\" *ngIf=\"canEdit\">\n                            Guardar\n                        </button>\n                        <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                    </div>\n                    <div class=\"row\" style=\"margin-top: 10px\">\n                        <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                        <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1098 */
/***/ function(module, exports) {

	module.exports = "textarea {\n    resize: none;\n}\n\n.btn.patentPaymentOption {\n    margin-top: 22px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\nh3.titleUploader {\n    margin-top: 0;\n}"

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var observableBackend_service_1 = __webpack_require__(402);
	var http_1 = __webpack_require__(111);
	var VehicleBrandService = (function () {
	    function VehicleBrandService(backendService) {
	        this.backendService = backendService;
	    }
	    VehicleBrandService.prototype.findVehicleBrands = function (filter, page, itemsPerPage) {
	        var params = new http_1.URLSearchParams();
	        if (filter) {
	            params.set('name', filter);
	        }
	        params.set('length', String(itemsPerPage));
	        params.set('pageNumber', String(page));
	        return this.backendService.get("vehicleBrands", params);
	    };
	    VehicleBrandService.prototype.getVehicleBrand = function (vehicleBrandId) {
	        return this.backendService.get("vehicleBrand/" + vehicleBrandId, null);
	    };
	    VehicleBrandService.prototype.getNewVehicleBrand = function () {
	        return this.backendService.get("vehicleBrand/new", null);
	    };
	    VehicleBrandService.prototype.getVehicleBrands = function () {
	        return this.backendService.get("listVehicleBrands/", null);
	    };
	    VehicleBrandService.prototype.save = function (vehicleBrand) {
	        return vehicleBrand.id != null
	            ? this.backendService.post("vehicleBrand", vehicleBrand, null)
	            : this.backendService.put("vehicleBrand", vehicleBrand, null);
	    };
	    VehicleBrandService.prototype.delete = function (vehicleBrandId) {
	        return this.backendService.delete("vehicleBrand/" + vehicleBrandId, null, null);
	    };
	    VehicleBrandService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [observableBackend_service_1.ObservableBackendService])
	    ], VehicleBrandService);
	    return VehicleBrandService;
	}());
	exports.VehicleBrandService = VehicleBrandService;


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var core_1 = __webpack_require__(1);
	var vehicleBrand_1 = __webpack_require__(882);
	var validators_1 = __webpack_require__(849);
	var vehicleBrand_service_1 = __webpack_require__(1099);
	var router_1 = __webpack_require__(350);
	var async_1 = __webpack_require__(1028);
	/**
	 * .
	 * Created by jlado on 5/9/16.
	 */
	var VehicleBrandEditorComponent = (function () {
	    function VehicleBrandEditorComponent(vehicleBrandService, route) {
	        this.vehicleBrandService = vehicleBrandService;
	        this.route = route;
	        this.close = new async_1.EventEmitter();
	        this.init();
	    }
	    VehicleBrandEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.loading = false;
	        this.vehicleBrand = new vehicleBrand_1.VehicleBrand();
	    };
	    VehicleBrandEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            var vehicleBrandId = params['vehicleBrandId'];
	            if (vehicleBrandId) {
	                _this.vehicleBrandId = vehicleBrandId;
	                _this.createMode = false;
	            }
	            else {
	                _this.vehicleBrandId = null;
	                _this.createMode = true;
	            }
	            _this.getData();
	        });
	    };
	    VehicleBrandEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    VehicleBrandEditorComponent.prototype.createFormGroup = function () {
	        var group = {};
	        group['name'] = new forms_1.FormControl(this.vehicleBrand.name);
	        this.form = new forms_1.FormGroup(group);
	    };
	    VehicleBrandEditorComponent.prototype.getData = function () {
	        var _this = this;
	        if (this.vehicleBrandId) {
	            this.loading = true;
	            this.vehicleBrandService.getVehicleBrand(this.vehicleBrandId).subscribe(function (data) {
	                _this.setData(data);
	            }, function () {
	                _this.bindError('Ocurrió un error al obtener los datos de la marca del vehículo.');
	            });
	        }
	    };
	    VehicleBrandEditorComponent.prototype.setData = function (data) {
	        this.loading = false;
	        if (this.vehicleBrandId) {
	            this.vehicleBrand = data;
	        }
	        else {
	            this.vehicleBrand = new vehicleBrand_1.VehicleBrand();
	        }
	    };
	    VehicleBrandEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.vehicleBrandService.save(this.vehicleBrand).subscribe(function (saved) {
	            _this.loading = false;
	            _this.vehicleBrand = saved;
	            _this.successMessage = 'La marca de vehículo se guardó con éxito';
	            _this.updateViewAfterSave();
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar los datos de la marca de vehículo.');
	        });
	    };
	    VehicleBrandEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    VehicleBrandEditorComponent.prototype.updateViewAfterSave = function () {
	        if (this.createMode) {
	            this.vehicleBrand = new vehicleBrand_1.VehicleBrand();
	        }
	    };
	    VehicleBrandEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.vehicleBrand);
	        window.history.back();
	    };
	    VehicleBrandEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', vehicleBrand_1.VehicleBrand)
	    ], VehicleBrandEditorComponent.prototype, "vehicleBrand", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], VehicleBrandEditorComponent.prototype, "close", void 0);
	    VehicleBrandEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'vehicleBrand-editor',
	            template: __webpack_require__(1101),
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS
	            ],
	        }), 
	        __metadata('design:paramtypes', [vehicleBrand_service_1.VehicleBrandService, router_1.ActivatedRoute])
	    ], VehicleBrandEditorComponent);
	    return VehicleBrandEditorComponent;
	}());
	exports.VehicleBrandEditorComponent = VehicleBrandEditorComponent;


/***/ },
/* 1101 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" *ngIf=\"createMode===true\">Nueva Marca de Vehículo</h2>\n            <h2 class=\"panel-title\" *ngIf=\"createMode===false\">Marca de Vehículo</h2>\n        </div>\n\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"vehicleBrand\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n\n                <div class=\"row\">\n                    <div class=\"col-sm-4\">\n                        <div class=\"row\">\n                            <div class=\"form-group form-group-sm col-sm-12\">\n                                <label for=\"name\">Nombre</label>\n                                <input type=\"text\" class=\"form-control\" id=\"name\"\n                                       [(ngModel)]=\"vehicleBrand.name\" name=\"name\" formControlName=\"name\"/>\n\n                                <div *ngIf=\"!form.controls.name.valid && form.controls.name.errors.required\"\n                                     class=\"alert-danger\">\n                                    {{errorMessages.required}}\n                                </div>\n                            </div>                           \n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"col-sm-12\">\n                    <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"!form.valid || loading\">Guardar\n                    </button>\n                    <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var datatable_1 = __webpack_require__(861);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_bootstrap_2 = __webpack_require__(680);
	var ng2_pagination_1 = __webpack_require__(867);
	var vehicleBrand_service_1 = __webpack_require__(1099);
	var vehicleBrand_1 = __webpack_require__(882);
	var ConfigVehicleBrandsComponent = (function () {
	    function ConfigVehicleBrandsComponent(router, vehicleBrandService) {
	        this.router = router;
	        this.vehicleBrandService = vehicleBrandService;
	        this.init();
	        this.form.valueChanges
	            .debounceTime(400)
	            .subscribe(this.find.bind(this));
	        this.find();
	    }
	    ConfigVehicleBrandsComponent.prototype.init = function () {
	        this.data = [];
	        this.filter = "";
	        this.form = new forms_1.FormGroup({
	            search: new forms_1.FormControl(),
	            itemsPerPage: new forms_1.FormControl()
	        });
	        this.itemsPerPage = 10;
	        this.loading = false;
	        this.page = 1;
	        this.total = 0;
	    };
	    ConfigVehicleBrandsComponent.prototype.find = function () {
	        this.getData(1);
	    };
	    ConfigVehicleBrandsComponent.prototype.getData = function (page) {
	        var _this = this;
	        this.error = null;
	        this.loading = true;
	        this.vehicleBrandService.findVehicleBrands(this.filter, page, this.itemsPerPage).subscribe(function (data) {
	            _this.refreshData(data);
	            _this.page = page;
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar las marcas.');
	        });
	    };
	    ConfigVehicleBrandsComponent.prototype.refreshData = function (page) {
	        this.data = page.content.map(function (vehicleBrand) { return new vehicleBrand_1.VehicleBrand(vehicleBrand); });
	        this.currentPage = page;
	        this.total = page.totalElements;
	        this.loading = false;
	    };
	    ConfigVehicleBrandsComponent.prototype.remove = function (deleteModal) {
	        var _this = this;
	        this.error = null;
	        this.vehicleBrandService.delete(this.vehicleBrandSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeFromView(_this.vehicleBrandSelected);
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar la marca.');
	        });
	    };
	    ConfigVehicleBrandsComponent.prototype.removeFromView = function (vehicleBrand) {
	        var index = this.data.indexOf(vehicleBrand);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.vehicleBrandSelected = null;
	    };
	    ConfigVehicleBrandsComponent.prototype.edit = function (vehicleBrand) {
	        this.router.navigate(['app/home/config/editVehicleBrand', vehicleBrand.id]);
	    };
	    ConfigVehicleBrandsComponent.prototype.create = function () {
	        this.router.navigate(['app/home/config/createVehicleBrand']);
	    };
	    ConfigVehicleBrandsComponent.prototype.getPage = function (page) {
	        this.getData(page);
	    };
	    ConfigVehicleBrandsComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigVehicleBrandsComponent = __decorate([
	        core_1.Component({
	            selector: 'config-vehicleBrands',
	            template: __webpack_require__(1103),
	            directives: [
	                datatable_1.DataTableDirectives,
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_2.MODAL_DIRECTIVES,
	                ng2_pagination_1.PaginationControlsCmp
	            ],
	            providers: [
	                forms_1.FORM_PROVIDERS,
	                ng2_pagination_1.PaginationService
	            ],
	            viewProviders: [ng2_bootstrap_2.BS_VIEW_PROVIDERS],
	            pipes: [ng2_pagination_1.PaginatePipe],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, vehicleBrand_service_1.VehicleBrandService])
	    ], ConfigVehicleBrandsComponent);
	    return ConfigVehicleBrandsComponent;
	}());
	exports.ConfigVehicleBrandsComponent = ConfigVehicleBrandsComponent;


/***/ },
/* 1103 */
/***/ function(module, exports) {

	module.exports = "<div>\n\t<div class=\"col-xs-12\">\n\t\t<h1>Marcas de veh&iacute;culos</h1>\n\t</div>\n    <div class=\"col-xs-12\">\n        <form class=\"form-inline\" [formGroup]=\"form\" (ngSubmit)=\"find()\">\n            <div class=\"panel panel-default\">\n                <div class=\"alert alert-danger\" *ngIf=\"error\">{{error}}</div>\n\n                <div class=\"form-group form-group-sm center\">\n                    <i class=\"fa fa-search\" style=\"font-size:24px\"></i>\n                    <input type=\"text\" class=\"form-control\" id=\"search\" placeholder=\"buscar marca...\"\n                           formControlName=\"search\" [(ngModel)]=\"filter\" name=\"search\">\n                </div>\n            </div>\n\n            <div class=\"col-md-12\">\n                <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                    <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n                </div>\n\n                <div class=\"pull-right\">\n                    <label for=\"itemsPerPage\">Items por p&aacute;gina</label>\n                    <input type=\"number\" class=\"input\" min=\"1\" [(ngModel)]=\"itemsPerPage\" name=\"itemsPerPage\"\n                           formControlName=\"itemsPerPage\" maxlength=\"2\" id=\"itemsPerPage\">\n                </div>\n            </div>\n        </form>\n\n        <div class=\"panel panel-default\">\n            <table class=\"table table-striped\">\n                <thead>\n                <tr>\n                    <th style=\"width: 10%\"></th>\n                    <th style=\"width: 30%\">\n                        Nombre\n                    </th>                    \n                    <th style=\"width: 10%\">\n                        Acciones\n                    </th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let brand of data | paginate: { id: 'server', itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }\">\n                    <td>\n                        <button class=\"btn btn-primary\" title=\"Editar\" (click)=\"edit(brand)\">\n                            <!--<span class=\"glyphicon glyphicon-pencil\"></span>-->\n                            <span class=\"pencil\"><img></span>\n                        </button>\n                    </td>\n                    <td>{{brand.name}}</td>\n                    <td>\n                        <button class=\"btn btn-danger\" title=\"Eliminar\"\n                                (click)=\"vehicleBrandSelected=brand;deleteModal.show();\">\n                            <!--<span class=\"glyphicon glyphicon-remove\"></span>-->\n                            <span class=\"remove\"><img></span>\n                        </button>\n                    </td>\n                </tr>\n                </tbody>\n                <tfoot>\n                <tr>\n                    <td colspan=\"10\">\n                        <pagination-controls (pageChange)=\"getPage($event)\" id=\"server\"></pagination-controls>\n                    </td>\n                </tr>\n                </tfoot>\n            </table>\n        </div>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"create()\">\n            <!--<span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>-->\n            <span class=\"plus\"><img></span>\n             Nuevo\n        </button>\n    </div>\n\n    <div bsModal #deleteModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"\n         aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\">\n        <div class=\"modal-dialog modal-sm\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"deleteModal.hide()\">\n                        <span aria-hidden=\"true\">&times;</span>\n                    </button>\n                    <h4 class=\"modal-title\">Confirmaci&oacute;n</h4>\n                </div>\n                <div class=\"modal-body\">\n                    &iquest;Est&aacute; seguro que desea eliminar la marca \n                    <strong>{{vehicleBrandSelected?.name}}</strong>?\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-danger\" aria-label=\"Aceptar\" (click)=\"remove(deleteModal)\">\n                        Aceptar\n                    </button>\n                    <button type=\"button\" class=\"btn btn-default\" aria-label=\"Aceptar\" (click)=\"deleteModal.hide()\">\n                        Cancelar\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_dragula_1 = __webpack_require__(1012);
	var clientDocument_service_1 = __webpack_require__(1005);
	var ng2_file_upload_1 = __webpack_require__(889);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var core_2 = __webpack_require__(1);
	/**
	 * .
	 * Created by jlado on 6/9/16.
	 */
	var ConfigClientProcedureDocumentsComponent = (function () {
	    function ConfigClientProcedureDocumentsComponent(clientDocumentService, dragulaService, loginService, changeDetector) {
	        var _this = this;
	        this.clientDocumentService = clientDocumentService;
	        this.dragulaService = dragulaService;
	        this.loginService = loginService;
	        this.changeDetector = changeDetector;
	        this.init();
	        this.find();
	        dragulaService.setOptions('clientDocuments-bag', {
	            direction: 'vertical',
	            /*Elements in source can be reordered*/
	            copySortSource: true
	        });
	        dragulaService.dropModel.subscribe(function () {
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al ordenar los archivos.');
	        });
	    }
	    ConfigClientProcedureDocumentsComponent.prototype.init = function () {
	        this.pageHeader = "Archivos de Trámites";
	        this.data = [];
	        this.uploaderClientDocument = new ng2_file_upload_1.FileUploader({
	            url: 'clientProcedureDocument/upload',
	            removeAfterUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.hasClientDocumentDropZoneOver = false;
	        this.loading = false;
	        this.uploading = false;
	        this.deleteMode = false;
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        if (!this.userLogged) {
	            this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	                _this.userLogged = userLogged;
	                _this.updateUserLogged();
	            }, function () {
	                //Do Nothing.
	            });
	        }
	        else {
	            this.updateUserLogged();
	        }
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.updateUserLogged = function () {
	        if (this.userLogged.isAdmin()) {
	            this.isAdmin = true;
	        }
	        if (this.userLogged.rol.name === "OPERADOR DE BANCO" || this.userLogged.rol.name === "Operador Banco Con Trámite") {
	            this.isBank = true;
	        }
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.setCheckedDocs = function () {
	        var _this = this;
	        this.bankId = this.userLogged.bank.id;
	        for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
	            var doc = _a[_i];
	            if (doc.bankIds.length > 0) {
	                if (doc.bankIds.some(function (x) { return x === _this.bankId.toString(); })) {
	                    doc.enabled = true;
	                }
	                else {
	                    doc.enabled = false;
	                }
	            }
	        }
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.enableOrDisableDocument = function () {
	        var _this = this;
	        this.disableCheckbox = true;
	        var isEnabled = this.clientDocumentSelected.enabled;
	        if (isEnabled) {
	            this.clientDocumentSelected.enabled = false;
	            this.clientDocumentSelected.bankIds = this.clientDocumentSelected.bankIds.filter(function (id) { return id !== _this.bankId.toString(); });
	            setTimeout(function () {
	                _this.disableCheckbox = false;
	            }, 150);
	            this.setCheckedDocs();
	        }
	        else if (!isEnabled) {
	            this.clientDocumentSelected.enabled = true;
	            this.clientDocumentSelected.bankIds.push(this.bankId.toString());
	            setTimeout(function () {
	                _this.disableCheckbox = false;
	            }, 150);
	            this.setCheckedDocs();
	        }
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.updateAllEnabled = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.updateClientDocuments(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            _this.successMessage = 'Se habilitaron los archivos con éxito.';
	            _this.setCheckedDocs();
	        }, function () {
	            _this.bindError('Ocurrió un error al habilitar los archivos.');
	        });
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.find = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.getClientProcedureDocuments().subscribe(function (data) {
	            _this.refreshData(data);
	            if (_this.uploading) {
	                _this.successMessage = 'Se guardaron con éxito el/los nuevo/s archivo/s.';
	                _this.uploading = false;
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar los archivos.');
	        });
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.updateOrder = function () {
	        var _this = this;
	        this.data.map(function (clientDocument) {
	            clientDocument.order = _this.data.indexOf(clientDocument) + 1;
	        });
	        this.saveOrder();
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.saveOrder = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.saveProcedureAll(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            if (_this.deleteMode) {
	                _this.deleteMode = false;
	                _this.successMessage = 'El archivo se ha eliminado con éxito.';
	            }
	            else {
	                _this.successMessage = 'El nuevo orden de los archivos se guardó con éxito.';
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar el nuevo orden de los archivos.');
	        });
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.waitClientDocumentUploaded = function () {
	        if (this.clientDocumentUploading.isSuccess) {
	            this.find();
	        }
	        else {
	            setTimeout(this.waitClientDocumentUploaded.bind(this), 3000);
	        }
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.save = function () {
	        var _this = this;
	        if (this.uploaderClientDocument.queue.length > 0) {
	            this.clearMessages();
	            this.loading = true;
	            this.uploaderClientDocument.queue.map(function (clientDocument) {
	                clientDocument.upload();
	                _this.clientDocumentUploading = clientDocument;
	                _this.uploading = true;
	                _this.waitClientDocumentUploaded();
	            });
	            this.find();
	            if (!this.uploaderClientDocument.isUploading) {
	                this.bindError('Ocurrió un error al guardar el/los archivo/s.');
	            }
	            this.loading = false;
	        }
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.refreshData = function (data) {
	        this.data = data;
	        if (this.isBank) {
	            this.setCheckedDocs();
	        }
	        this.loading = false;
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.error = null;
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.removeClientDocument = function (deleteModal) {
	        var _this = this;
	        this.clearMessages();
	        this.clientDocumentService.delete(this.clientDocumentSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeClientDocumentFromView(_this.clientDocumentSelected);
	            _this.deleteMode = true;
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el archivo.');
	        });
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.removeClientDocumentFromView = function (clientDocument) {
	        var index = this.data.indexOf(clientDocument);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.clientDocumentSelected = null;
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.fileOverClientDocument = function (e) {
	        this.hasClientDocumentDropZoneOver = e;
	    };
	    ConfigClientProcedureDocumentsComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigClientProcedureDocumentsComponent = __decorate([
	        core_1.Component({
	            selector: 'config-clientProcedureDocuments',
	            template: __webpack_require__(1033),
	            styles: [__webpack_require__(1034)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES,
	                ng2_dragula_1.Dragula
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	            viewProviders: [
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS,
	                ng2_dragula_1.DragulaService
	            ],
	        }), 
	        __metadata('design:paramtypes', [clientDocument_service_1.ClientDocumentService, ng2_dragula_1.DragulaService, login_service_1.LoginService, core_2.ChangeDetectorRef])
	    ], ConfigClientProcedureDocumentsComponent);
	    return ConfigClientProcedureDocumentsComponent;
	}());
	exports.ConfigClientProcedureDocumentsComponent = ConfigClientProcedureDocumentsComponent;


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_dragula_1 = __webpack_require__(1012);
	var clientDocument_service_1 = __webpack_require__(1005);
	var ng2_file_upload_1 = __webpack_require__(889);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var core_2 = __webpack_require__(1);
	/**
	 * .
	 * Created by jlado on 6/9/16.
	 */
	var ConfigClientKmDocumentsComponent = (function () {
	    function ConfigClientKmDocumentsComponent(clientDocumentService, dragulaService, loginService, changeDetector) {
	        var _this = this;
	        this.clientDocumentService = clientDocumentService;
	        this.dragulaService = dragulaService;
	        this.loginService = loginService;
	        this.changeDetector = changeDetector;
	        this.init();
	        this.find();
	        dragulaService.setOptions('clientDocuments-bag', {
	            direction: 'vertical',
	            /*Elements in source can be reordered*/
	            copySortSource: true
	        });
	        dragulaService.dropModel.subscribe(function () {
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al ordenar los archivos.');
	        });
	    }
	    ConfigClientKmDocumentsComponent.prototype.init = function () {
	        this.pageHeader = "Archivos de KM";
	        this.data = [];
	        this.uploaderClientDocument = new ng2_file_upload_1.FileUploader({
	            url: 'clientKmDocument/upload',
	            removeAfterUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.hasClientDocumentDropZoneOver = false;
	        this.loading = false;
	        this.uploading = false;
	        this.deleteMode = false;
	    };
	    ConfigClientKmDocumentsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        if (!this.userLogged) {
	            this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	                _this.userLogged = userLogged;
	                _this.updateUserLogged();
	            }, function () {
	                //Do Nothing.
	            });
	        }
	        else {
	            this.updateUserLogged();
	        }
	    };
	    ConfigClientKmDocumentsComponent.prototype.updateUserLogged = function () {
	        if (this.userLogged.isAdmin()) {
	            this.isAdmin = true;
	        }
	        if (this.userLogged.rol.name === "OPERADOR DE BANCO" || this.userLogged.rol.name === "Operador Banco Con Trámite") {
	            this.isBank = true;
	        }
	    };
	    ConfigClientKmDocumentsComponent.prototype.setCheckedDocs = function () {
	        var _this = this;
	        this.bankId = this.userLogged.bank.id;
	        for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
	            var doc = _a[_i];
	            if (doc.bankIds.length > 0) {
	                if (doc.bankIds.some(function (x) { return x === _this.bankId.toString(); })) {
	                    doc.enabled = true;
	                }
	                else {
	                    doc.enabled = false;
	                }
	            }
	        }
	    };
	    ConfigClientKmDocumentsComponent.prototype.enableOrDisableDocument = function () {
	        var _this = this;
	        this.disableCheckbox = true;
	        var isEnabled = this.clientDocumentSelected.enabled;
	        if (isEnabled) {
	            this.clientDocumentSelected.enabled = false;
	            this.clientDocumentSelected.bankIds = this.clientDocumentSelected.bankIds.filter(function (id) { return id !== _this.bankId.toString(); });
	            setTimeout(function () {
	                _this.disableCheckbox = false;
	            }, 150);
	            this.setCheckedDocs();
	        }
	        else if (!isEnabled) {
	            this.clientDocumentSelected.enabled = true;
	            this.clientDocumentSelected.bankIds.push(this.bankId.toString());
	            setTimeout(function () {
	                _this.disableCheckbox = false;
	            }, 150);
	            this.setCheckedDocs();
	        }
	    };
	    ConfigClientKmDocumentsComponent.prototype.updateAllEnabled = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.updateClientDocuments(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            _this.successMessage = 'Se habilitaron los archivos con éxito.';
	            _this.setCheckedDocs();
	        }, function () {
	            _this.bindError('Ocurrió un error al habilitar los archivos.');
	        });
	    };
	    ConfigClientKmDocumentsComponent.prototype.find = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.getClientKmDocuments().subscribe(function (data) {
	            _this.refreshData(data);
	            if (_this.uploading) {
	                _this.successMessage = 'Se guardaron con éxito el/los nuevo/s archivo/s.';
	                _this.uploading = false;
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar los archivos.');
	        });
	    };
	    ConfigClientKmDocumentsComponent.prototype.updateOrder = function () {
	        var _this = this;
	        this.data.map(function (clientDocument) {
	            clientDocument.order = _this.data.indexOf(clientDocument) + 1;
	        });
	        this.saveOrder();
	    };
	    ConfigClientKmDocumentsComponent.prototype.saveOrder = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.saveKmAll(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            if (_this.deleteMode) {
	                _this.deleteMode = false;
	                _this.successMessage = 'El archivo se ha eliminado con éxito.';
	            }
	            else {
	                _this.successMessage = 'El nuevo orden de los archivos se guardó con éxito.';
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar el nuevo orden de los archivos.');
	        });
	    };
	    ConfigClientKmDocumentsComponent.prototype.waitClientDocumentUploaded = function () {
	        if (this.clientDocumentUploading.isSuccess) {
	            this.find();
	        }
	        else {
	            setTimeout(this.waitClientDocumentUploaded.bind(this), 3000);
	        }
	    };
	    ConfigClientKmDocumentsComponent.prototype.save = function () {
	        var _this = this;
	        if (this.uploaderClientDocument.queue.length > 0) {
	            this.clearMessages();
	            this.loading = true;
	            this.uploaderClientDocument.queue.map(function (clientDocument) {
	                clientDocument.upload();
	                _this.clientDocumentUploading = clientDocument;
	                _this.uploading = true;
	                _this.waitClientDocumentUploaded();
	            });
	            this.find();
	            if (!this.uploaderClientDocument.isUploading) {
	                this.bindError('Ocurrió un error al guardar el/los archivo/s.');
	            }
	            this.loading = false;
	        }
	    };
	    ConfigClientKmDocumentsComponent.prototype.refreshData = function (data) {
	        this.data = data;
	        if (this.isBank) {
	            this.setCheckedDocs();
	        }
	        this.loading = false;
	    };
	    ConfigClientKmDocumentsComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.error = null;
	    };
	    ConfigClientKmDocumentsComponent.prototype.removeClientDocument = function (deleteModal) {
	        var _this = this;
	        this.clearMessages();
	        this.clientDocumentService.delete(this.clientDocumentSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeClientDocumentFromView(_this.clientDocumentSelected);
	            _this.deleteMode = true;
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el archivo.');
	        });
	    };
	    ConfigClientKmDocumentsComponent.prototype.removeClientDocumentFromView = function (clientDocument) {
	        var index = this.data.indexOf(clientDocument);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.clientDocumentSelected = null;
	    };
	    ConfigClientKmDocumentsComponent.prototype.fileOverClientDocument = function (e) {
	        this.hasClientDocumentDropZoneOver = e;
	    };
	    ConfigClientKmDocumentsComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigClientKmDocumentsComponent = __decorate([
	        core_1.Component({
	            selector: 'config-clientKmDocuments',
	            template: __webpack_require__(1033),
	            styles: [__webpack_require__(1034)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES,
	                ng2_dragula_1.Dragula
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	            viewProviders: [
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS,
	                ng2_dragula_1.DragulaService
	            ],
	        }), 
	        __metadata('design:paramtypes', [clientDocument_service_1.ClientDocumentService, ng2_dragula_1.DragulaService, login_service_1.LoginService, core_2.ChangeDetectorRef])
	    ], ConfigClientKmDocumentsComponent);
	    return ConfigClientKmDocumentsComponent;
	}());
	exports.ConfigClientKmDocumentsComponent = ConfigClientKmDocumentsComponent;


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var ng2_dragula_1 = __webpack_require__(1012);
	var clientDocument_service_1 = __webpack_require__(1005);
	var ng2_file_upload_1 = __webpack_require__(889);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var core_2 = __webpack_require__(1);
	/**
	 * .
	 * Created by jlado on 6/9/16.
	 */
	var ConfigClientPatentDocumentsComponent = (function () {
	    function ConfigClientPatentDocumentsComponent(clientDocumentService, dragulaService, loginService, changeDetector) {
	        var _this = this;
	        this.clientDocumentService = clientDocumentService;
	        this.dragulaService = dragulaService;
	        this.loginService = loginService;
	        this.changeDetector = changeDetector;
	        this.init();
	        this.find();
	        dragulaService.setOptions('clientDocuments-bag', {
	            direction: 'vertical',
	            /*Elements in source can be reordered*/
	            copySortSource: true
	        });
	        dragulaService.dropModel.subscribe(function () {
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al ordenar los archivos.');
	        });
	    }
	    ConfigClientPatentDocumentsComponent.prototype.init = function () {
	        this.pageHeader = "Archivos de Pago de Patentes";
	        this.data = [];
	        this.uploaderClientDocument = new ng2_file_upload_1.FileUploader({
	            url: 'clientPatentDocument/upload',
	            removeAfterUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.hasClientDocumentDropZoneOver = false;
	        this.loading = false;
	        this.uploading = false;
	        this.deleteMode = false;
	    };
	    ConfigClientPatentDocumentsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        if (!this.userLogged) {
	            this.loginService.getUserLoggedSubject().subscribe(function (userLogged) {
	                _this.userLogged = userLogged;
	                _this.updateUserLogged();
	            }, function () {
	                //Do Nothing.
	            });
	        }
	        else {
	            this.updateUserLogged();
	        }
	    };
	    ConfigClientPatentDocumentsComponent.prototype.updateUserLogged = function () {
	        if (this.userLogged.isAdmin()) {
	            this.isAdmin = true;
	        }
	        if (this.userLogged.rol.name === "OPERADOR DE BANCO" || this.userLogged.rol.name === "Operador Banco Con Trámite") {
	            this.isBank = true;
	        }
	    };
	    ConfigClientPatentDocumentsComponent.prototype.setCheckedDocs = function () {
	        var _this = this;
	        this.bankId = this.userLogged.bank.id;
	        for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
	            var doc = _a[_i];
	            if (doc.bankIds.length > 0) {
	                if (doc.bankIds.some(function (x) { return x === _this.bankId.toString(); })) {
	                    doc.enabled = true;
	                }
	                else {
	                    doc.enabled = false;
	                }
	            }
	        }
	    };
	    ConfigClientPatentDocumentsComponent.prototype.enableOrDisableDocument = function () {
	        var _this = this;
	        this.disableCheckbox = true;
	        var isEnabled = this.clientDocumentSelected.enabled;
	        if (isEnabled) {
	            this.clientDocumentSelected.enabled = false;
	            this.clientDocumentSelected.bankIds = this.clientDocumentSelected.bankIds.filter(function (id) { return id !== _this.bankId.toString(); });
	            setTimeout(function () {
	                _this.disableCheckbox = false;
	            }, 150);
	            this.setCheckedDocs();
	        }
	        else if (!isEnabled) {
	            this.clientDocumentSelected.enabled = true;
	            this.clientDocumentSelected.bankIds.push(this.bankId.toString());
	            setTimeout(function () {
	                _this.disableCheckbox = false;
	            }, 150);
	            this.setCheckedDocs();
	        }
	    };
	    ConfigClientPatentDocumentsComponent.prototype.updateAllEnabled = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.updateClientDocuments(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            _this.successMessage = 'Se habilitaron los archivos con éxito.';
	            _this.setCheckedDocs();
	        }, function () {
	            _this.bindError('Ocurrió un error al habilitar los archivos.');
	        });
	    };
	    ConfigClientPatentDocumentsComponent.prototype.find = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.getClientPatentDocuments().subscribe(function (data) {
	            _this.refreshData(data);
	            if (_this.uploading) {
	                _this.successMessage = 'Se guardaron con éxito el/los nuevo/s archivo/s.';
	                _this.uploading = false;
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al buscar los archivos.');
	        });
	    };
	    ConfigClientPatentDocumentsComponent.prototype.updateOrder = function () {
	        var _this = this;
	        this.data.map(function (clientDocument) {
	            clientDocument.order = _this.data.indexOf(clientDocument) + 1;
	        });
	        this.saveOrder();
	    };
	    ConfigClientPatentDocumentsComponent.prototype.saveOrder = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        this.clientDocumentService.savePatentAll(this.data).subscribe(function (saved) {
	            _this.loading = false;
	            _this.data = saved;
	            if (_this.deleteMode) {
	                _this.deleteMode = false;
	                _this.successMessage = 'El archivo se ha eliminado con éxito.';
	            }
	            else {
	                _this.successMessage = 'El nuevo orden de los archivos se guardó con éxito.';
	            }
	        }, function () {
	            _this.bindError('Ocurrió un error al guardar el nuevo orden de los archivos.');
	        });
	    };
	    ConfigClientPatentDocumentsComponent.prototype.waitClientDocumentUploaded = function () {
	        if (this.clientDocumentUploading.isSuccess) {
	            this.find();
	        }
	        else {
	            setTimeout(this.waitClientDocumentUploaded.bind(this), 3000);
	        }
	    };
	    ConfigClientPatentDocumentsComponent.prototype.save = function () {
	        var _this = this;
	        if (this.uploaderClientDocument.queue.length > 0) {
	            this.clearMessages();
	            this.loading = true;
	            this.uploaderClientDocument.queue.map(function (clientDocument) {
	                clientDocument.upload();
	                _this.clientDocumentUploading = clientDocument;
	                _this.uploading = true;
	                _this.waitClientDocumentUploaded();
	            });
	            this.find();
	            if (!this.uploaderClientDocument.isUploading) {
	                this.bindError('Ocurrió un error al guardar el/los archivo/s.');
	            }
	            this.loading = false;
	        }
	    };
	    ConfigClientPatentDocumentsComponent.prototype.refreshData = function (data) {
	        this.data = data;
	        if (this.isBank) {
	            this.setCheckedDocs();
	        }
	        this.loading = false;
	    };
	    ConfigClientPatentDocumentsComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.error = null;
	    };
	    ConfigClientPatentDocumentsComponent.prototype.removeClientDocument = function (deleteModal) {
	        var _this = this;
	        this.clearMessages();
	        this.clientDocumentService.delete(this.clientDocumentSelected.id).subscribe(function () {
	            deleteModal.hide();
	            _this.removeClientDocumentFromView(_this.clientDocumentSelected);
	            _this.deleteMode = true;
	            _this.updateOrder();
	        }, function () {
	            _this.bindError('Ocurrió un error al eliminar el archivo.');
	        });
	    };
	    ConfigClientPatentDocumentsComponent.prototype.removeClientDocumentFromView = function (clientDocument) {
	        var index = this.data.indexOf(clientDocument);
	        if (index > -1) {
	            this.data.splice(index, 1);
	        }
	        this.clientDocumentSelected = null;
	    };
	    ConfigClientPatentDocumentsComponent.prototype.fileOverClientDocument = function (e) {
	        this.hasClientDocumentDropZoneOver = e;
	    };
	    ConfigClientPatentDocumentsComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.error == null) {
	            this.error = messageError;
	        }
	        else {
	            this.error = this.error.toString() + ' ' + messageError;
	        }
	    };
	    ConfigClientPatentDocumentsComponent = __decorate([
	        core_1.Component({
	            selector: 'config-clientPatentDocuments',
	            template: __webpack_require__(1033),
	            styles: [__webpack_require__(1034)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.MODAL_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES,
	                ng2_dragula_1.Dragula
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	            viewProviders: [
	                ng2_bootstrap_1.BS_VIEW_PROVIDERS,
	                ng2_dragula_1.DragulaService
	            ],
	        }), 
	        __metadata('design:paramtypes', [clientDocument_service_1.ClientDocumentService, ng2_dragula_1.DragulaService, login_service_1.LoginService, core_2.ChangeDetectorRef])
	    ], ConfigClientPatentDocumentsComponent);
	    return ConfigClientPatentDocumentsComponent;
	}());
	exports.ConfigClientPatentDocumentsComponent = ConfigClientPatentDocumentsComponent;


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var procedure_1 = __webpack_require__(885);
	var ng2_file_upload_1 = __webpack_require__(889);
	var router_1 = __webpack_require__(350);
	var procedure_service_1 = __webpack_require__(916);
	var login_service_1 = __webpack_require__(404);
	var navigation_service_1 = __webpack_require__(403);
	var validators_1 = __webpack_require__(849);
	var rxjs_1 = __webpack_require__(405);
	var ProcedureDocument_1 = __webpack_require__(887);
	var ng2_file_upload_2 = __webpack_require__(889);
	var SingleProcedureEditorComponent = (function () {
	    function SingleProcedureEditorComponent(router, procedureService, route, loginService, navigationService) {
	        this.router = router;
	        this.procedureService = procedureService;
	        this.route = route;
	        this.loginService = loginService;
	        this.navigationService = navigationService;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    SingleProcedureEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.loading = false;
	        this.canEdit = false;
	        this.uploaderDocument = new ng2_file_upload_1.FileUploader({});
	        this.hasDocumentDropZoneOver = false;
	        this.isUploading = false;
	        this.expirationTypeUniqueStr = 'UNIQUE';
	    };
	    SingleProcedureEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            procedureDescription: new forms_1.FormControl(this.procedure.description),
	            procedureCustomDate: new forms_1.FormControl(this.procedure.customDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            procedureComment: new forms_1.FormControl(this.procedure.comment),
	        });
	    };
	    SingleProcedureEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var userLogged = this.loginService.getUserLogged();
	        this.canEdit = userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.procedureId = params['procedureId'];
	            _this.getData();
	        });
	    };
	    SingleProcedureEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    SingleProcedureEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        var forkTasks = [];
	        if (this.procedureId) {
	            forkTasks.push(this.procedureService.get(this.procedureId));
	        }
	        forkTasks.push(this.procedureService.getExpirationTypes());
	        rxjs_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los datos del trámite.');
	        });
	    };
	    SingleProcedureEditorComponent.prototype.setData = function (data) {
	        var _this = this;
	        if (data[0] && data[0].id && data[0].id.toString() === this.procedureId) {
	            this.procedure = data[0]; // Comentarios, Fecha de vencimiento y archivo adjunto
	        }
	        if (data[1]) {
	            this.expirationType = data[1];
	            this.expirationType = this.expirationType.filter(function (obj) {
	                return obj.description == 'UNICO';
	            });
	            this.expirationTypeUnique = this.expirationType.filter(function (expirationType) { return expirationType.id == (1).toString(); })[0];
	        }
	        this.procedureService.generateProcedureTempId()
	            .subscribe(function (response) {
	            _this.procedure.tempId = response.value;
	            _this.updateUploaderUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al generar un trámite.');
	        });
	        this.createFormGroup();
	        this.loading = false;
	    };
	    SingleProcedureEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    SingleProcedureEditorComponent.prototype.saveExistingProcedure = function (event) {
	        var _this = this;
	        this.uploaderDocument.queue.forEach(function (item) {
	            _this.procedure.document = new ProcedureDocument_1.ProcedureDocument();
	            _this.procedure.document.id = "temp/" + _this.procedure.tempId;
	            _this.procedure.document.name = item.file.name;
	        });
	        this.isUploadingAFile();
	        if (!this.checkAllBeforeSave()) {
	            this.loading = true;
	            this.procedureService.updateProcedure(this.procedure).subscribe(function (saved) {
	                _this.loading = false;
	                _this.procedure = saved;
	                _this.successMessage = 'El trámite se guardó con éxito';
	            }, function () {
	                _this.bindError('Ocurrió un error al guardar el trámite.');
	            });
	        }
	        this.uploaderDocument.clearQueue();
	    };
	    SingleProcedureEditorComponent.prototype.removeDocument = function () {
	        this.procedure.document = null;
	    };
	    SingleProcedureEditorComponent.prototype.updateUploaderUrl = function () {
	        if (this.procedure.document) {
	            var fileOwnerId = this.procedure.tempId;
	            this.uploaderDocument = new ng2_file_upload_1.FileUploader({
	                url: 'procedure/' + fileOwnerId + '/upload',
	                autoUpload: true,
	                maxFileSize: validators_1.FILE_MAX_SIZE,
	            });
	        }
	    };
	    SingleProcedureEditorComponent.prototype.isUploadingAFile = function () {
	        this.isUploading = this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderDocument.queue && this.uploaderDocument.queue.length == 0;
	    };
	    SingleProcedureEditorComponent.prototype.fileOverDocument = function (e) {
	        this.hasDocumentDropZoneOver = e;
	    };
	    SingleProcedureEditorComponent.prototype.removeDocumentFromQuee = function (item) {
	        var _this = this;
	        this.procedureService.deleteTempProcedureDocument(this.procedure.id).subscribe(function (result) { return item.remove(); }, function () {
	            _this.bindError('Ocurrió un error al eliminar el documento de trámite.');
	        });
	    };
	    SingleProcedureEditorComponent.prototype.checkAllBeforeSave = function () {
	        return this.isUploading || !this.form.valid || this.loading || this.uploaderDocument.isUploading;
	    };
	    SingleProcedureEditorComponent.prototype.updateViewAfterSave = function () {
	        this.uploaderDocument.clearQueue();
	    };
	    SingleProcedureEditorComponent.prototype.checkIfNotValid = function () {
	        if (!this.form.controls["procedureCustomDate"].valid &&
	            this.procedure.expirationType.id === this.expirationTypeUnique.id) {
	            return true;
	        }
	        /*!this.form.valid ||*/
	        return this.loading || this.uploaderDocument.isUploading;
	    };
	    SingleProcedureEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.procedure);
	        window.history.back();
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', procedure_1.Procedure)
	    ], SingleProcedureEditorComponent.prototype, "procedure", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], SingleProcedureEditorComponent.prototype, "close", void 0);
	    __decorate([
	        core_1.ViewChild('inputDocument'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], SingleProcedureEditorComponent.prototype, "inputAct", void 0);
	    SingleProcedureEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'simpleProcedures-editor',
	            template: __webpack_require__(1108),
	            styles: [__webpack_require__(1109)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_file_upload_2.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, procedure_service_1.ProcedureService, router_1.ActivatedRoute, login_service_1.LoginService, navigation_service_1.NavigationService])
	    ], SingleProcedureEditorComponent);
	    return SingleProcedureEditorComponent;
	}());
	exports.SingleProcedureEditorComponent = SingleProcedureEditorComponent;


/***/ },
/* 1108 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\">Editar tr&aacute;mite</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"saveExistingProcedure()\" *ngIf=\"procedure\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div>\n                    <h4 *ngIf=\"canEdit\">Editar Trámite</h4>\n                    <div class=\"panel panel-default\" *ngIf=\"canEdit\">\n                        <div class=\"panel-body\">\n                            <div class=\"row\">\n                                <!--<div class=\"form-group form-group-sm col-sm-3\" [hidden]=\"isUniqueExpirationDate()\">-->\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"procedureCustomDate\">Fecha de Vencimiento</label>\n                                    <input type=\"text\" class=\"form-control\" formControlName=\"procedureCustomDate\"\n                                           [(ngModel)]=\"procedure.customDate\" id=\"procedureCustomDate\"\n                                           name=\"procedureCustomDate\">\n                                    <div *ngIf=\"!form.controls.procedureCustomDate.valid && form.controls.procedureCustomDate.errors.pattern\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.invalidDate}}\n                                    </div>\n                                    <div *ngIf=\"!form.controls.procedureCustomDate.valid && form.controls.procedureCustomDate.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-6\">\n                                    <label for=\"procedureDescription\">Observaciones</label>\n                                    <textarea type=\"text\" class=\"form-control\" formControlName=\"procedureDescription\"\n                                              [(ngModel)]=\"procedure.description\" id=\"procedureDescription\"\n                                              name=\"procedureDescription\" rows=\"2\"></textarea>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-6\">\n                                    <label for=\"procedureComment\">Comentarios</label>\n                                    <textarea type=\"text\" class=\"form-control\" formControlName=\"procedureComment\"\n                                              [(ngModel)]=\"procedure.comment\" id=\"procedureComment\"\n                                              name=\"procedureComment\" rows=\"2\"></textarea>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <h3 class=\"titleUploader\">Trámite</h3>\n                                    <div *ngIf=\"procedure.document\">\n                                        <a href=\"/procedure/{{procedure.id}}/download\" target=\"file\">\n                                            <span class=\"paperclip\"><img></span>\n                                            {{procedure.document.name}}\n                                        </a>\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"removeDocument()\"\n                                                *ngIf=\"canEdit\">\n                                            <span class=\"trash\"><img></span>\n                                            Eliminar\n                                        </button>\n                                    </div>\n                                    <div *ngIf=\"canEdit && (!procedure.document && uploaderDocument.queue.length == 0)\">\n                                        <div ng2FileDrop id=\"uploaderProcedureDocument\"\n                                             [ngClass]=\"{'nv-file-over': hasDocumentDropZoneOver}\"\n                                             (fileOver)=\"fileOverDocument($event)\"\n                                             [uploader]=\"uploaderDocument\"\n                                             class=\"well my-drop-zone\">\n                                            Arrastre el archivo aqu&iacute;\n                                        </div>\n                                        <label for=\"inputDocument\" class=\"custom-file-upload\">\n                                            <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                                        </label>\n                                        <input id=\"inputDocument\" type=\"file\" ng2FileSelect\n                                               [uploader]=\"uploaderDocument\" #inputDocument/>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\" *ngIf=\"uploaderDocument.queue?.length > 0\">\n                                <div class=\"col-md-12\">\n                                    <h4>Archivo pendiente a asociar al trámite</h4>\n                                    <table class=\"table\">\n                                        <thead>\n                                        <tr>\n                                            <th width=\"50%\">Nombre</th>\n                                            <th>Tipo</th>\n                                            <th>Estado</th>\n                                            <th>Acciones</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr *ngFor=\"let item of uploaderDocument.queue\">\n                                            <td><strong>{{item.file.name}}</strong></td>\n                                            <td>TRÁMITE</td>\n                                            <td class=\"text-center\">\n                                                <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                                <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                                <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                            </td>\n                                            <td nowrap>\n                                                <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                        (click)=\"item.upload()\"\n                                                        [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                    <span class=\"upload-icon\"><img></span>\n                                                    Subir\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                        (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                                    <span class=\"ban-circle-white\"><img>Cancelar</span>\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                        (click)=\"removeDocumentFromQuee(item)\">\n                                                    <span class=\"trash\"><img></span> Eliminar\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        <tr *ngIf=\"uploaderDocument.queue?.length == 0\">\n                                            <td colspan=\"4\" class=\"text-center\">\n                                                No hay archivos pendientes de asociar al trámite\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div *ngIf=\"procedure\" class=\"form-group form-group-sm col-sm-1\">\n                                    <button (click)=\"saveExistingProcedure($event)\"\n                                            class=\"btn btn-success procedureOption\"\n                                            [disabled]=\"checkIfNotValid()\">\n                                        <i class=\"fa fa-save\"> Guardar trámite</i>\n                                    </button>\n                                    <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1109 */
/***/ function(module, exports) {

	module.exports = ".divButton {\n    display: table;\n    text-align: left;\n    margin-top: 25px;\n    margin-bottom: 0;\n}\n\n.optionButton {\n    display: table-cell;\n    vertical-align: bottom;\n    height: 30px;\n}\n\n.rowBorder {\n    border: 1px double rgba(211, 211, 211, 0.12);\n    background: rgba(211, 211, 211, 0.12);\n}\n\ntextarea {\n    resize: none;\n}\n\n.btn.procedureOption {\n    margin-top: 22px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\nh3.titleUploader {\n    margin-top: 0;\n}"

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var vehicle_1 = __webpack_require__(873);
	var validators_1 = __webpack_require__(849);
	var login_service_1 = __webpack_require__(404);
	var procedure_1 = __webpack_require__(885);
	var procedure_service_1 = __webpack_require__(916);
	var Observable_1 = __webpack_require__(34);
	var ng2_file_upload_1 = __webpack_require__(889);
	var ProcedureDocument_1 = __webpack_require__(887);
	var navigation_service_1 = __webpack_require__(403);
	var ProcedureEditorComponent = (function () {
	    function ProcedureEditorComponent(router, procedureService, route, loginService, navigationService) {
	        this.router = router;
	        this.procedureService = procedureService;
	        this.route = route;
	        this.loginService = loginService;
	        this.navigationService = navigationService;
	        this.close = new core_1.EventEmitter();
	        this.init();
	    }
	    ProcedureEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.newProcedure = new procedure_1.Procedure();
	        this.loading = false;
	        this.canEdit = false;
	        var dateStrParts = new Date();
	        this.todayStr = this.padLeft(dateStrParts.getDate().toString(), '0', 2) + '/' +
	            this.padLeft((dateStrParts.getMonth() + 1).toString(), '0', 2) + '/' + dateStrParts.getFullYear();
	        this.newProcedure.creationDate = this.todayStr;
	        this.newProcedure.customDate = this.todayStr;
	        this.vehicle = new vehicle_1.Vehicle();
	        this.uploaderDocument = new ng2_file_upload_1.FileUploader({});
	        this.hasDocumentDropZoneOver = false;
	        this.isUploading = false;
	    };
	    ProcedureEditorComponent.prototype.padLeft = function (text, padChar, size) {
	        return (String(padChar).repeat(size) + text).substr((size * -1), size);
	    };
	    ProcedureEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            type: new forms_1.FormControl(this.vehicle.type.description),
	            patent: new forms_1.FormControl(this.vehicle.patent),
	            brand: new forms_1.FormControl(this.vehicle.brand.name),
	            model: new forms_1.FormControl(this.vehicle.model),
	            year: new forms_1.FormControl(this.vehicle.year),
	            engineNumber: new forms_1.FormControl(this.vehicle.engineNumber),
	            newProcedureDate: new forms_1.FormControl(this.newProcedure.creationDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            newProcedureExpirationType: new forms_1.FormControl(this.newProcedure.expirationType, [forms_1.Validators.required]),
	            newProcedureType: new forms_1.FormControl(this.newProcedure.type, [forms_1.Validators.required]),
	            newProcedureDescription: new forms_1.FormControl(this.newProcedure.description),
	            newProcedureComment: new forms_1.FormControl(this.newProcedure.comment),
	            newProcedureCustomDate: new forms_1.FormControl(this.newProcedure.customDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	        });
	    };
	    ProcedureEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var userLogged = this.loginService.getUserLogged();
	        this.canEdit = userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');
	        this.createFormGroup();
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.vehicleId = params['vehicleId'];
	            _this.getData();
	        });
	    };
	    ProcedureEditorComponent.prototype.ngAfterViewInit = function () {
	    };
	    ProcedureEditorComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        this.errorMessage = null;
	        var forkTasks = [];
	        forkTasks.push(this.procedureService.getProcedureTypes());
	        forkTasks.push(this.procedureService.getExpirationTypes());
	        forkTasks.push(this.procedureService.getVehicle(this.vehicleId));
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this), function () {
	            _this.bindError('Ocurrió un error al obtener los datos del vehículo.');
	        });
	    };
	    ProcedureEditorComponent.prototype.setData = function (data) {
	        var _this = this;
	        this.loading = false;
	        this.procedureType = data[0];
	        this.expirationType = data[1];
	        this.vehicle = data[2];
	        this.expirationType = this.expirationType.filter(function (obj) {
	            return obj.description != 'NO VENCE';
	        });
	        this.procedureType = this.procedureType.filter(function (obj) {
	            return obj.name != 'LICENSE_PLATE';
	        });
	        this.expirationTypeSelectedId = this.expirationType[0].id;
	        this.procedureTypeSelectedId = this.procedureType[0].id;
	        this.expirationTypeChange(this.expirationTypeSelectedId);
	        this.procedureTypeChange(this.procedureTypeSelectedId);
	        this.updateUploaderUrl();
	        this.procedureService.generateProcedureTempId()
	            .subscribe(function (response) {
	            _this.newProcedure.tempId = response.value;
	            _this.updateUploaderUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al generar un trámite.');
	        });
	    };
	    ProcedureEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    ProcedureEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	        this.warningMessage = null;
	    };
	    ProcedureEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.isUploadingAFile();
	        if (!this.checkAllBeforeSave()) {
	            this.loading = true;
	            this.procedureService.save(this.vehicle).subscribe(function (saved) {
	                _this.loading = false;
	                _this.vehicle = saved;
	                _this.successMessage = 'El trámite se guardó con éxito';
	                _this.updateViewAfterSave();
	                if (_this.checkPreSaveProcedures()) {
	                    _this.bindWarning('Existen Trámites sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al guardar la información.');
	            });
	        }
	        else {
	            this.bindError('Existe un archivo pendiente de subida. Recuerde que el tamaño máximo del archivo a subir es de 10Mb.');
	        }
	    };
	    ProcedureEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        this.close.emit(this.vehicle);
	        window.history.back();
	    };
	    ProcedureEditorComponent.prototype.addNewProcedureToVehicle = function () {
	        var _this = this;
	        this.uploaderDocument.queue.forEach(function (item) {
	            _this.newProcedure.document = new ProcedureDocument_1.ProcedureDocument();
	            _this.newProcedure.document.id = "temp/" + _this.newProcedure.tempId;
	            _this.newProcedure.document.name = item.file.name;
	        });
	        this.vehicle.procedures.push((JSON.parse(JSON.stringify(this.newProcedure))));
	        this.newProcedure = new procedure_1.Procedure();
	        this.newProcedure.creationDate = this.todayStr;
	        this.newProcedure.customDate = this.todayStr;
	        this.expirationTypeSelectedId = this.expirationType[0].id;
	        this.procedureTypeSelectedId = this.procedureType[0].id;
	        this.expirationTypeChange(this.expirationTypeSelectedId);
	        this.procedureTypeChange(this.procedureTypeSelectedId);
	        this.procedureService.generateProcedureTempId()
	            .subscribe(function (response) {
	            _this.newProcedure.tempId = response.value;
	            _this.updateUploaderUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al generar un trámite.');
	        });
	        this.uploaderDocument.clearQueue();
	    };
	    ProcedureEditorComponent.prototype.addNewProcedure = function (event) {
	        event.preventDefault();
	        this.addNewProcedureToVehicle();
	        this.clearMessages();
	        this.bindWarning('Existen Trámites sin guardar.');
	    };
	    ProcedureEditorComponent.prototype.deleteProcedure = function (event, index, id, idTemp) {
	        var _this = this;
	        event.preventDefault();
	        this.clearMessages();
	        this.loading = true;
	        var notPending = false;
	        if (id != undefined && id != null) {
	            notPending = true;
	            this.procedureService.delete(id).subscribe(function () {
	                _this.loading = false;
	                _this.successMessage = 'El trámite se eliminó con éxito';
	                _this.loading = false;
	                _this.vehicle.procedures.splice(index, 1);
	                if (_this.checkPreSaveProcedures()) {
	                    _this.clearMessages();
	                    _this.bindWarning('Existen Trámites sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al eliminar el trámite.');
	            });
	        }
	        if (idTemp != undefined && idTemp != null) {
	            notPending = true;
	            this.procedureService.deleteTempProcedureDocument(idTemp).subscribe(function () {
	                _this.loading = false;
	                _this.successMessage = 'La carga de trámite se eliminó con éxito';
	                _this.loading = false;
	                _this.vehicle.procedures.splice(index, 1);
	                if (_this.checkPreSaveProcedures()) {
	                    _this.clearMessages();
	                    _this.bindWarning('Existen Trámites sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al eliminar el trámite.');
	            });
	        }
	        if (!notPending) {
	            this.loading = false;
	            this.vehicle.procedures.splice(index, 1);
	            if (this.checkPreSaveProcedures()) {
	                this.bindWarning('Existen Trámites sin guardar.');
	            }
	        }
	    };
	    ProcedureEditorComponent.prototype.editProcedure = function (event, item) {
	        event.preventDefault();
	        this.navigationService.setBackParameters({ tabSelected: 'procedures' });
	        this.router.navigate(['app/home/editSingleProcedure', item.id]); // Ya existia editProcedure, que lleva a esta vista en realidad
	    };
	    ProcedureEditorComponent.prototype.expirationTypeChange = function (newValue) {
	        var result = this.expirationType.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.newProcedure.expirationType = result[0];
	        }
	    };
	    ProcedureEditorComponent.prototype.procedureTypeChange = function (newValue) {
	        var result = this.procedureType.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.newProcedure.type = result[0];
	        }
	    };
	    ProcedureEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    ProcedureEditorComponent.prototype.bindWarning = function (messageWarning) {
	        this.loading = false;
	        if (this.warningMessage == null) {
	            this.warningMessage = messageWarning;
	        }
	        else {
	            this.warningMessage = this.warningMessage.toString() + ' ' + messageWarning;
	        }
	    };
	    ProcedureEditorComponent.prototype.removeDocument = function () {
	        this.newProcedure.document = null;
	    };
	    ProcedureEditorComponent.prototype.updateUploaderUrl = function () {
	        var fileOwnerId = this.newProcedure.tempId;
	        this.uploaderDocument = new ng2_file_upload_1.FileUploader({
	            url: 'procedure/' + fileOwnerId + '/upload',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	    };
	    ProcedureEditorComponent.prototype.isUploadingAFile = function () {
	        this.isUploading = this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderDocument.queue && this.uploaderDocument.queue.length == 0;
	    };
	    ProcedureEditorComponent.prototype.fileOverDocument = function (e) {
	        this.hasDocumentDropZoneOver = e;
	    };
	    ProcedureEditorComponent.prototype.removeDocumentFromQuee = function (item) {
	        var _this = this;
	        this.procedureService.deleteTempProcedureDocument(this.newProcedure.tempId).subscribe(function (result) { return item.remove(); }, function () {
	            _this.bindError('Ocurrió un error al eliminar el documento de trámite.');
	        });
	    };
	    ProcedureEditorComponent.prototype.checkAllBeforeSave = function () {
	        return this.isUploading || !this.form.valid || this.loading || this.uploaderDocument.isUploading;
	    };
	    ProcedureEditorComponent.prototype.updateViewAfterSave = function () {
	        var _this = this;
	        this.uploaderDocument.clearQueue();
	        this.vehicle.procedures.forEach(function (procedure, index) {
	            if (procedure.id == undefined || procedure.id == null) {
	                _this.vehicle.procedures.splice(index, 1);
	            }
	        });
	    };
	    ProcedureEditorComponent.prototype.checkIfNotValid = function () {
	        if (!this.form.controls["newProcedureCustomDate"].valid) {
	            return true;
	        }
	        /*!this.form.valid ||*/
	        return this.loading || this.uploaderDocument.isUploading || this.uploaderDocument.queue.length == 0;
	    };
	    ProcedureEditorComponent.prototype.checkPreSaveProcedures = function () {
	        var hasPreSaveProcedures = false;
	        this.vehicle.procedures.forEach(function (procedure) {
	            if (procedure.id === undefined || procedure.id === null) {
	                hasPreSaveProcedures = true;
	            }
	        });
	        return hasPreSaveProcedures;
	    };
	    ProcedureEditorComponent.prototype.getState = function (procedure) {
	        return this.transform(procedure.done, procedure.customDate);
	    };
	    ProcedureEditorComponent.prototype.transform = function (done, date) {
	        if (done) {
	            return 'RESUELTO';
	        }
	        /*
	        if (unique) {
	            return 'A VENCER';
	        }
	        */
	        var todayDate = new Date(Date.parse(Date()));
	        var expiratedDateStr;
	        var expiratedDate;
	        if (date !== undefined && date !== null) {
	            if (date.includes('/')) {
	                expiratedDateStr = date.split('/');
	                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
	            }
	            else if (date.includes('-')) {
	                expiratedDateStr = date.split('-');
	                expiratedDate = new Date(+expiratedDateStr[2], +expiratedDateStr[1] - 1, +expiratedDateStr[0]);
	            }
	        }
	        return expiratedDate > todayDate ? 'A VENCER' : 'VENCIDO';
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', vehicle_1.Vehicle)
	    ], ProcedureEditorComponent.prototype, "vehicle", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ProcedureEditorComponent.prototype, "close", void 0);
	    __decorate([
	        core_1.ViewChild('inputDocument'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ProcedureEditorComponent.prototype, "inputAct", void 0);
	    ProcedureEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'procedures-editor',
	            template: __webpack_require__(1111),
	            styles: [__webpack_require__(1112)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, procedure_service_1.ProcedureService, router_1.ActivatedRoute, login_service_1.LoginService, navigation_service_1.NavigationService])
	    ], ProcedureEditorComponent);
	    return ProcedureEditorComponent;
	}());
	exports.ProcedureEditorComponent = ProcedureEditorComponent;


/***/ },
/* 1111 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\">Carga de trámites</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"vehicle\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"type\">Tipo</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"vehicle.type.description\" name=\"type\"\n                               formControlName=\"type\" id=\"type\" [disabled]=\"true\"/>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"patent\">Patente</label>\n                        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"vehicle.patent\" name=\"patent\"\n                               formControlName=\"patent\" id=\"patent\" [disabled]=\"true\"/>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"brand\">Marca</label>\n                        <input [(ngModel)]=\"vehicle.brand.name\" id=\"brand\" class=\"form-control\" formControlName=\"brand\"\n                               [disabled]=\"true\">\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"model\">Modelo</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"model\" [(ngModel)]=\"vehicle.model\"\n                               name=\"model\" id=\"model\" [disabled]=\"true\">\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"year\">A&ntilde;o</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"year\" [(ngModel)]=\"vehicle.year\"\n                               id=\"year\" name=\"year\" [disabled]=\"true\">\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"engineNumber\">Motor</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"engineNumber\"\n                               [(ngModel)]=\"vehicle.engineNumber\" id=\"engineNumber\" name=\"engineNumber\"\n                               [disabled]=\"true\">\n                    </div>\n                </div>\n\n                <div *ngIf=\"vehicle.id\">\n                    <h4 *ngIf=\"canEdit\">Nuevo Trámite</h4>\n                    <div class=\"panel panel-default\" *ngIf=\"canEdit\">\n                        <div class=\"panel-body\">\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newProcedureDate\">Fecha de Carga</label>\n                                    <div class=\"input-group\">\n                                        <span class=\"input-group-addon calendar\"><img></span>\n                                        <input type=\"text\" class=\"form-control  date-picker\"\n                                               formControlName=\"newProcedureDate\"\n                                               [(ngModel)]=\"newProcedure.creationDate\" id=\"newProcedureDate\"\n                                               maxlength=\"10\"\n                                               name=\"newProcedureDate\">\n                                    </div>\n                                    <div *ngIf=\"!form.controls.newProcedureDate.valid && form.controls.newProcedureDate.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                    <div *ngIf=\"!form.controls.newProcedureDate.valid && form.controls.newProcedureDate.errors.pattern\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.invalidDate}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newProcedureType\">Tipo</label>\n                                    <select class=\"form-control\" formControlName=\"newProcedureType\"\n                                            [(ngModel)]=\"procedureTypeSelectedId\"\n                                            name=\"newProcedureType\" id=\"newProcedureType\"\n                                            (change)=\"procedureTypeChange($event.target.value)\">\n                                        <option *ngFor=\"let type of procedureType\" [value]=\"type.id\">\n                                            {{type.description | uppercase}}\n                                        </option>\n                                    </select>\n                                    <div *ngIf=\"!form.controls.newProcedureType.valid && form.controls.newProcedureType.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newProcedureExpirationType\">Tipo de Vencimiento</label>\n                                    <select class=\"form-control\" formControlName=\"newProcedureExpirationType\"\n                                            [(ngModel)]=\"expirationTypeSelectedId\"\n                                            name=\"newProcedureExpirationType\" id=\"newProcedureExpirationType\"\n                                            (change)=\"expirationTypeChange($event.target.value)\">\n                                        <option *ngFor=\"let type of expirationType\" [value]=\"type.id\">\n                                            {{type.description | uppercase}}\n                                        </option>\n                                    </select>\n                                    <div *ngIf=\"!form.controls.newProcedureExpirationType.valid && form.controls.newProcedureExpirationType.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newProcedureCustomDate\">Fecha de Vencimiento</label>\n                                    <input type=\"text\" class=\"form-control\" formControlName=\"newProcedureCustomDate\"\n                                           [(ngModel)]=\"newProcedure.customDate\" id=\"newProcedureCustomDate\"\n                                           name=\"newProcedureCustomDate\">\n                                    <div *ngIf=\"!form.controls.newProcedureCustomDate.valid && form.controls.newProcedureCustomDate.errors.pattern\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.invalidDate}}\n                                    </div>\n                                    <div *ngIf=\"!form.controls.newProcedureCustomDate.valid && form.controls.newProcedureCustomDate.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-6\">\n                                    <label for=\"newProcedureDescription\">Observaciones</label>\n                                    <textarea type=\"text\" class=\"form-control\" formControlName=\"newProcedureDescription\"\n                                              [(ngModel)]=\"newProcedure.description\" id=\"newProcedureDescription\"\n                                              name=\"newProcedureDescription\" rows=\"2\"></textarea>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-6\">\n                                    <label for=\"newProcedureComment\">Comentarios</label>\n                                    <textarea type=\"text\" class=\"form-control\" formControlName=\"newProcedureComment\"\n                                              [(ngModel)]=\"newProcedure.comment\" id=\"newProcedureComment\"\n                                              name=\"newProcedureComment\" rows=\"2\"></textarea>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <h3 class=\"titleUploader\">Trámite</h3>\n                                    <div *ngIf=\"newProcedure.document\">\n                                        <a href=\"/procedure/{{newProcedure.id}}/download\" target=\"file\">\n                                            <span class=\"paperclip\"><img></span>\n                                            {{newProcedure.document.name}}\n                                        </a>\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"removeDocument()\"\n                                                *ngIf=\"canEdit\">\n                                            <span class=\"trash\"><img></span>\n                                            Eliminar\n                                        </button>\n                                    </div>\n                                    <div *ngIf=\"canEdit && (!newProcedure.document && uploaderDocument.queue.length == 0)\">\n                                        <div ng2FileDrop\n                                             [ngClass]=\"{'nv-file-over': hasDocumentDropZoneOver}\"\n                                             (fileOver)=\"fileOverDocument($event)\"\n                                             [uploader]=\"uploaderDocument\"\n                                             class=\"well my-drop-zone\">\n                                            Arrastre el archivo aqu&iacute;\n                                        </div>\n                                        <label for=\"inputDocument\" class=\"custom-file-upload\">\n                                            <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                                        </label>\n                                        <input id=\"inputDocument\" type=\"file\" ng2FileSelect\n                                               [uploader]=\"uploaderDocument\" #inputDocument/>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\" *ngIf=\"uploaderDocument.queue?.length > 0\">\n                                <div class=\"col-md-12\">\n                                    <h4>Archivo pendiente a asociar al trámite</h4>\n                                    <table class=\"table\">\n                                        <thead>\n                                        <tr>\n                                            <th width=\"50%\">Nombre</th>\n                                            <th>Tipo</th>\n                                            <th>Estado</th>\n                                            <th>Acciones</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr *ngFor=\"let item of uploaderDocument.queue\">\n                                            <td><strong>{{item.file.name}}</strong></td>\n                                            <td>TRÁMITE</td>\n                                            <td class=\"text-center\">\n                                                <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                                <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                                <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                            </td>\n                                            <td nowrap>\n                                                <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                        (click)=\"item.upload()\"\n                                                        [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                    <span class=\"upload-icon\"><img></span>\n                                                    Subir\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                        (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                                    <span class=\"ban-circle-white\"><img>Cancelar</span>\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                        (click)=\"removeDocumentFromQuee(item)\">\n                                                    <span class=\"trash\"><img></span> Eliminar\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        <tr *ngIf=\"uploaderDocument.queue?.length == 0\">\n                                            <td colspan=\"4\" class=\"text-center\">\n                                                No hay archivos pendientes de asociar al trámite\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-1\">\n                                    <button (click)=\"addNewProcedure($event)\"\n                                            class=\"btn btn-success procedureOption\"\n                                            [disabled]=\"checkIfNotValid()\">\n                                        <i class=\"fa fa-plus\"> Cargar trámite</i>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <h4>Trámites</h4>\n                <div *ngIf=\"vehicle.procedures.length == 0\" class=\"row\">\n                    <div class=\"alert alert-info\">Sin trámites</div>\n                </div>\n                <div *ngIf=\"vehicle.procedures.length != 0\" class=\"panel panel-default\">\n                    <div class=\"panel-body table-responsive\">\n                        <div class=\"alert alert-warning\" *ngIf=\"warningMessage\">{{warningMessage}}</div>\n                        <table style=\"table-layout: fixed\" class=\"table table-striped\">\n                            <thead>\n                            <tr>\n                                <th style=\"width: 15%\">Fecha de carga</th>\n                                <th style=\"width: 10%\">Estado</th>\n                                <th style=\"width: 20%\">Tipo</th>\n                                <th style=\"width: 15%\">Tipo de Vencimiento</th>\n                                <th style=\"width: 10%\">Vencimiento</th>\n                                <th style=\"width: 15%\">Comentarios</th>\n                                <th style=\"width: 15%\">Observaciones</th>\n                                <th style=\"width: 20%\">Documento</th>\n                                <th *ngIf=\"canEdit\" style=\"width: 5%\">Editar</th>\n                                <th *ngIf=\"canEdit\" style=\"width: 5%\">Eliminar</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr *ngFor=\"let item of vehicle.procedures; let i = index\">\n                                <td>{{item.creationDate}}</td>\n                                <td>\n                                    {{(item) ? getState(item) : '-'}}\n                                </td>\n                                <td>{{item.type.description}}</td>\n                                <td>{{item.expirationType.description}}</td>\n                                <td>{{item.customDate}}</td>\n                                <td class=\"cortar\">{{item.comment}}</td>\n                                <td class=\"cortar\">{{item.description}}</td>\n                                <td>\n                                    <a href=\"/procedure/{{(item.id) ? item.id : item.document.id}}/download\"\n                                       target=\"file\">\n                                        <span class=\"paperclip\"><img></span>\n                                        {{item.document.name}}\n                                    </a>\n                                </td>\n                                <td *ngIf=\"canEdit\">\n                                    <button (click)=\"editProcedure($event, item)\"\n                                            class=\"btn btn-primary\">\n                                        <span class=\"pencil\"><img></span>\n                                    </button>\n                                </td>\n                                <td *ngIf=\"canEdit\">\n                                    <button (click)=\"deleteProcedure($event, i, item.id, item.tempId)\"\n                                            class=\"btn btn-danger\">\n                                        <i class=\"fa fa-minus\"></i>\n                                    </button>\n                                </td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <div class=\"col-sm-12\">\n                    <div class=\"row\">\n                        <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"loading\" *ngIf=\"canEdit\">\n                            Guardar\n                        </button>\n                        <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                    </div>\n                    <div class=\"row\" style=\"margin-top: 10px\">\n                        <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                        <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1112 */
/***/ function(module, exports) {

	module.exports = "textarea {\n    resize: none;\n}\n\n.btn.procedureOption {\n    margin-top: 22px;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}\n\nh3.titleUploader {\n    margin-top: 0;\n}\n\n.cortar {\n    width: 10%;\n    overflow:hidden;\n    white-space:nowrap;\n    text-overflow: ellipsis\n}\n\n.cortar:active {\n    overflow:visible;\n    white-space: initial;\n    cursor: pointer;\n}"

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var vehicle_1 = __webpack_require__(873);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var contracts_service_1 = __webpack_require__(632);
	var procedure_1 = __webpack_require__(885);
	var validators_1 = __webpack_require__(849);
	var Observable_1 = __webpack_require__(34);
	var procedure_service_1 = __webpack_require__(916);
	var ng2_file_upload_1 = __webpack_require__(889);
	var ProcedureDocument_1 = __webpack_require__(887);
	var router_1 = __webpack_require__(350);
	var navigation_service_1 = __webpack_require__(403);
	var login_service_1 = __webpack_require__(404);
	var bank_service_1 = __webpack_require__(631);
	var ProcedureNewComponent = (function () {
	    function ProcedureNewComponent(contractsService, procedureService, bankService, router, navigationService, loginService) {
	        var _this = this;
	        this.contractsService = contractsService;
	        this.procedureService = procedureService;
	        this.bankService = bankService;
	        this.router = router;
	        this.navigationService = navigationService;
	        this.loginService = loginService;
	        this.init();
	        bankService.getBanks().subscribe(this.setBanks.bind(this), function () {
	            _this.bindError('Ocurrió un error al cargar los bancos.');
	        });
	    }
	    ProcedureNewComponent.prototype.setBanks = function (banks) {
	        this.banks = banks;
	    };
	    ProcedureNewComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.showVehicle = false;
	        this.canNew = false;
	        this.filter = new vehicle_1.Vehicle();
	        this.newProcedure = new procedure_1.Procedure();
	        this.banks = [];
	        var dateStrParts = new Date();
	        this.todayStr = this.padLeft(dateStrParts.getDate().toString(), '0', 2) + '/' +
	            this.padLeft((dateStrParts.getMonth() + 1).toString(), '0', 2) + '/' + dateStrParts.getFullYear();
	        this.newProcedure.creationDate = this.todayStr;
	        this.newProcedure.customDate = this.todayStr;
	        this.uploaderDocument = new ng2_file_upload_1.FileUploader({});
	        this.hasDocumentDropZoneOver = false;
	        this.isUploading = false;
	        this.loading = false;
	        this.SelectedVehicle = false;
	    };
	    ProcedureNewComponent.prototype.ngOnInit = function () {
	        var userLogged = this.loginService.getUserLogged();
	        this.canNew = userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');
	        this.createFormGroup();
	    };
	    ProcedureNewComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            vehicleId: new forms_1.FormControl(),
	            contractNumber: new forms_1.FormControl(),
	            bankSelected: new forms_1.FormControl(),
	            newProcedureDate: new forms_1.FormControl(this.newProcedure.creationDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            newProcedureExpirationType: new forms_1.FormControl(this.newProcedure.expirationType, [forms_1.Validators.required]),
	            newProcedureType: new forms_1.FormControl(this.newProcedure.type, [forms_1.Validators.required]),
	            newProcedureDescription: new forms_1.FormControl(this.newProcedure.description),
	            newProcedureComment: new forms_1.FormControl(this.newProcedure.comment),
	            newProcedureCustomDate: new forms_1.FormControl(this.newProcedure.customDate, [forms_1.Validators.required, validators_1.DATE_VALID_CHARACTERS, validators_1.DATE_VALIDATOR]),
	            withSendMail: new forms_1.FormControl(this.newProcedure.withSendMail)
	        });
	    };
	    ProcedureNewComponent.prototype.find = function () {
	        this.getData();
	    };
	    ProcedureNewComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        window.history.back();
	    };
	    ProcedureNewComponent.prototype.getData = function () {
	        var _this = this;
	        this.errorMessage = null;
	        this.vehicleId = null;
	        if (this.filter.contract.contractNumber) {
	            this.contractsService.getContractByContractNumberAndBank(this.filter.contract.contractNumber, this.bankSelected.id)
	                .subscribe(function (data) {
	                _this.contract = data;
	                if (_this.contract) {
	                    _this.contractsService.getVehicles(_this.contract.id, 1, 10000) //TODO: Test, anda, pero el 1,10000 estan como de mas
	                        .subscribe(function (data) {
	                        _this.vehicles = data.content;
	                        //this.createFormGroup();
	                        if (_this.vehicles.length > 0) {
	                            _this.showVehicle = true;
	                        }
	                    }, function () {
	                        _this.bindError('Ocurrió un error al obtener los vehículos asociados al contrato.');
	                    });
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al obtener el contrato asociado a los datos ingresados.');
	            });
	        }
	        var forkTasks = [];
	        forkTasks.push(this.procedureService.getProcedureTypes());
	        forkTasks.push(this.procedureService.getExpirationTypes());
	        //forkTasks.push(this.procedureService.getVehicle(this.vehicleId));
	        Observable_1.Observable.forkJoin(forkTasks).subscribe(this.setData.bind(this));
	    };
	    ProcedureNewComponent.prototype.setData = function (data) {
	        var _this = this;
	        this.procedureType = data[0];
	        this.expirationType = data[1];
	        this.expirationType = this.expirationType.filter(function (obj) {
	            return obj.description != 'NO VENCE';
	        });
	        this.procedureType = this.procedureType.filter(function (obj) {
	            return obj.name != 'LICENSE_PLATE';
	        });
	        this.expirationTypeSelectedId = this.expirationType[0].id;
	        this.procedureTypeSelectedId = this.procedureType[0].id;
	        this.expirationTypeChange(this.expirationTypeSelectedId);
	        this.procedureTypeChange(this.procedureTypeSelectedId);
	        this.updateUploaderUrl();
	        this.procedureService.generateProcedureTempId()
	            .subscribe(function (response) {
	            _this.newProcedure.tempId = response.value;
	            _this.updateUploaderUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al generar un trámite.');
	        });
	    };
	    ProcedureNewComponent.prototype.addNewProcedure = function (event) {
	        event.preventDefault();
	        if (!this.SelectedVehicle) {
	            this.searchVehicle();
	            this.SelectedVehicle = true;
	        }
	        else {
	            this.addNewProcedureToVehicle();
	            this.clearMessages();
	            this.bindWarning('Existen Trámites sin guardar.');
	        }
	    };
	    ProcedureNewComponent.prototype.searchVehicle = function () {
	        var _this = this;
	        this.procedureService.getVehicle(this.vehicleId).subscribe(function (data) {
	            _this.vehicle = data;
	            _this.addNewProcedureToVehicle();
	            _this.clearMessages();
	            _this.bindWarning('Existen Trámites sin guardar.');
	        }, function () {
	            _this.bindError('Ocurrió un error al obtener el vehículo asociado a la patente ingresada.');
	        });
	    };
	    ProcedureNewComponent.prototype.addNewProcedureToVehicle = function () {
	        var _this = this;
	        this.uploaderDocument.queue.forEach(function (item) {
	            _this.newProcedure.document = new ProcedureDocument_1.ProcedureDocument();
	            _this.newProcedure.document.id = "temp/" + _this.newProcedure.tempId;
	            _this.newProcedure.document.name = item.file.name;
	        });
	        if (this.vehicle) {
	            this.vehicle.procedures.push((JSON.parse(JSON.stringify(this.newProcedure))));
	            this.newProcedure = new procedure_1.Procedure();
	            this.newProcedure.creationDate = this.todayStr;
	            this.newProcedure.customDate = this.todayStr;
	            this.expirationTypeSelectedId = this.expirationType[0].id;
	            this.procedureTypeSelectedId = this.procedureType[0].id;
	            this.expirationTypeChange(this.expirationTypeSelectedId);
	            this.procedureTypeChange(this.procedureTypeSelectedId);
	            this.procedureService.generateProcedureTempId()
	                .subscribe(function (response) {
	                _this.newProcedure.tempId = response.value;
	                _this.loading = true;
	                _this.updateUploaderUrl();
	            }, function () {
	                _this.bindError('Ocurrió un error al generar un trámite.');
	            });
	            this.uploaderDocument.clearQueue();
	        }
	    };
	    ProcedureNewComponent.prototype.checkIfNotValid = function () {
	        if (!this.form.controls["newProcedureCustomDate"].valid) {
	            return true;
	        }
	        /*!this.form.valid ||*/
	        return this.uploaderDocument.isUploading || this.uploaderDocument.queue.length == 0;
	    };
	    ProcedureNewComponent.prototype.procedureTypeChange = function (newValue) {
	        var result = this.procedureType.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.newProcedure.type = result[0];
	        }
	    };
	    ProcedureNewComponent.prototype.expirationTypeChange = function (newValue) {
	        var result = this.expirationType.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.newProcedure.expirationType = result[0];
	        }
	    };
	    ProcedureNewComponent.prototype.updateUploaderUrl = function () {
	        var fileOwnerId = this.newProcedure.tempId;
	        this.uploaderDocument = new ng2_file_upload_1.FileUploader({
	            url: 'procedure/' + fileOwnerId + '/upload',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	    };
	    ProcedureNewComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.isUploadingAFile();
	        if (!this.checkAllBeforeSave()) {
	            this.procedureService.save(this.vehicle).subscribe(function (saved) {
	                _this.vehicle = saved;
	                _this.successMessage = 'El trámite se guardó con éxito';
	                _this.updateViewAfterSave();
	                if (_this.checkPreSaveProcedures()) {
	                    _this.bindWarning('Existen Trámites sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al guardar la información.');
	            });
	        }
	        else {
	            this.bindError('Existe un archivo pendiente de subida. Recuerde que el tamaño máximo del archivo a subir es de 10Mb.');
	        }
	    };
	    ProcedureNewComponent.prototype.isUploadingAFile = function () {
	        this.isUploading = this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderDocument.queue && this.uploaderDocument.queue.length == 0;
	    };
	    ProcedureNewComponent.prototype.checkAllBeforeSave = function () {
	        return this.isUploading || !this.form.valid || this.uploaderDocument.isUploading;
	    };
	    ProcedureNewComponent.prototype.updateViewAfterSave = function () {
	        var _this = this;
	        this.uploaderDocument.clearQueue();
	        this.vehicle.procedures.forEach(function (procedure, index) {
	            if (procedure.id == undefined || procedure.id == null) {
	                _this.vehicle.procedures.splice(index, 1);
	            }
	        });
	    };
	    ProcedureNewComponent.prototype.checkPreSaveProcedures = function () {
	        var hasPreSaveProcedures = false;
	        this.vehicle.procedures.forEach(function (procedure) {
	            if (procedure.id === undefined || procedure.id === null) {
	                hasPreSaveProcedures = true;
	            }
	        });
	        return hasPreSaveProcedures;
	    };
	    ProcedureNewComponent.prototype.editProcedure = function (event, item) {
	        event.preventDefault();
	        this.navigationService.setBackParameters({ tabSelected: 'procedures' });
	        this.router.navigate(['app/home/editSingleProcedure', item.id]); // Ya existia editProcedure, que lleva a esta vista en realidad
	    };
	    ProcedureNewComponent.prototype.deleteProcedure = function (event, index, id, idTemp) {
	        var _this = this;
	        event.preventDefault();
	        this.clearMessages();
	        var notPending = false;
	        if (id != undefined && id != null) {
	            notPending = true;
	            this.procedureService.delete(id).subscribe(function () {
	                _this.successMessage = 'El trámite se eliminó con éxito';
	                _this.vehicle.procedures.splice(index, 1);
	                if (_this.checkPreSaveProcedures()) {
	                    _this.clearMessages();
	                    _this.bindWarning('Existen Trámites sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al eliminar el trámite.');
	            });
	        }
	        if (idTemp != undefined && idTemp != null) {
	            notPending = true;
	            this.procedureService.deleteTempProcedureDocument(idTemp).subscribe(function () {
	                _this.successMessage = 'La carga de trámite se eliminó con éxito';
	                _this.vehicle.procedures.splice(index, 1);
	                if (_this.checkPreSaveProcedures()) {
	                    _this.clearMessages();
	                    _this.bindWarning('Existen Trámites sin guardar.');
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al eliminar el trámite.');
	            });
	        }
	        if (!notPending) {
	            this.vehicle.procedures.splice(index, 1);
	            if (this.checkPreSaveProcedures()) {
	                this.bindWarning('Existen Trámites sin guardar.');
	            }
	        }
	    };
	    ProcedureNewComponent.prototype.removeDocument = function () {
	        this.newProcedure.document = null;
	    };
	    ProcedureNewComponent.prototype.removeDocumentFromQuee = function (item) {
	        var _this = this;
	        this.procedureService.deleteTempProcedureDocument(this.newProcedure.tempId).subscribe(function (result) { return item.remove(); }, function () {
	            _this.bindError('Ocurrió un error al eliminar el documento de trámite.');
	        });
	    };
	    ProcedureNewComponent.prototype.fileOverDocument = function (e) {
	        this.hasDocumentDropZoneOver = e;
	    };
	    ProcedureNewComponent.prototype.bindError = function (messageError) {
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    ProcedureNewComponent.prototype.bindWarning = function (messageWarning) {
	        if (this.warningMessage == null) {
	            this.warningMessage = messageWarning;
	        }
	        else {
	            this.warningMessage = this.warningMessage.toString() + ' ' + messageWarning;
	        }
	    };
	    ProcedureNewComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	        this.warningMessage = null;
	    };
	    ProcedureNewComponent.prototype.padLeft = function (text, padChar, size) {
	        return (String(padChar).repeat(size) + text).substr((size * -1), size);
	    };
	    __decorate([
	        core_1.ViewChild('inputDocument'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ProcedureNewComponent.prototype, "inputAct", void 0);
	    ProcedureNewComponent = __decorate([
	        core_1.Component({
	            selector: 'procedures-new',
	            template: __webpack_require__(1114),
	            styles: [__webpack_require__(1115)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                /*MyDatePicker,*/
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	        }), 
	        __metadata('design:paramtypes', [contracts_service_1.ContractsService, procedure_service_1.ProcedureService, bank_service_1.BankService, router_1.Router, navigation_service_1.NavigationService, login_service_1.LoginService])
	    ], ProcedureNewComponent);
	    return ProcedureNewComponent;
	}());
	exports.ProcedureNewComponent = ProcedureNewComponent;


/***/ },
/* 1114 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\" Nuevo Trámite></h2>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"contractNumber\">Nro. de Contrato</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"contractNumber\"\n                               name=\"contractNumber\" [(ngModel)]=\"filter.contract.contractNumber\" id=\"contractNumber\">\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"bankSelected\">Banco</label>\n                        <select class=\"form-control\" id=\"bankSelected\" formControlName=\"bankSelected\"\n                                [(ngModel)]=\"bankSelected\" name=\"bank\">\n                            <option *ngFor=\"let bank of banks\" [ngValue]=\"bank\">{{bank.name}}</option>\n                        </select>\n                    </div>\n                    <div class=\"form-group form-group-sm col-sm-2\">\n                        <button type=\"button\" class=\"btn btn-primary\" (click)=\"find()\" style=\"margin-top: 23px\">\n                            <span class=\"search\"><img></span>\n                        </button>\n                    </div>\n                    <div *ngIf=\"showVehicle\" class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"vehicleId\">Patentes asociadas al Contrato</label>\n                        <select class=\"form-control\" [(ngModel)]=\"vehicleId\" name=\"vehicleId\" id=\"vehicleId\">\n                            <option *ngFor=\"let vehicle of vehicles\" [ngValue]=\"vehicle.id\">{{vehicle.patent}}</option>\n                        </select>\n                    </div>\n                    <div *ngIf=\"!showVehicle\" class=\"form-group form-group-sm col-sm-3\">\n                        <p>No hay ningún vehículo asociado a este contrato</p>\n                    </div>\n                </div>\n\n                <div *ngIf=\"vehicleId\">\n                    <h4 *ngIf=\"canNew\">Carga de Trámite</h4>\n                    <div class=\"panel panel-default\" *ngIf=\"canNew\">\n                        <div class=\"panel-body\">\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newProcedureDate\">Fecha de Carga</label>\n                                    <div class=\"input-group\">\n                                        <span class=\"input-group-addon calendar\"><img></span>\n                                        <input type=\"text\" class=\"form-control  date-picker\"\n                                               formControlName=\"newProcedureDate\"\n                                               [(ngModel)]=\"newProcedure.creationDate\" id=\"newProcedureDate\"\n                                               maxlength=\"10\"\n                                               name=\"newProcedureDate\">\n                                    </div>\n                                    <div *ngIf=\"!form.controls.newProcedureDate.valid && form.controls.newProcedureDate.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                    <div *ngIf=\"!form.controls.newProcedureDate.valid && form.controls.newProcedureDate.errors.pattern\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.invalidDate}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newProcedureType\">Tipo</label>\n                                    <select class=\"form-control\" formControlName=\"newProcedureType\"\n                                            [(ngModel)]=\"procedureTypeSelectedId\"\n                                            name=\"newProcedureType\" id=\"newProcedureType\"\n                                            (change)=\"procedureTypeChange($event.target.value)\">\n                                        <option *ngFor=\"let type of procedureType\" [value]=\"type.id\">\n                                            {{type.description | uppercase}}\n                                        </option>\n                                    </select>\n                                    <div *ngIf=\"!form.controls.newProcedureType.valid && form.controls.newProcedureType.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newProcedureExpirationType\">Tipo de Vencimiento</label>\n                                    <select class=\"form-control\" formControlName=\"newProcedureExpirationType\"\n                                            [(ngModel)]=\"expirationTypeSelectedId\"\n                                            name=\"newProcedureExpirationType\" id=\"newProcedureExpirationType\"\n                                            (change)=\"expirationTypeChange($event.target.value)\">\n                                        <option *ngFor=\"let type of expirationType\" [value]=\"type.id\">\n                                            {{type.description | uppercase}}\n                                        </option>\n                                    </select>\n                                    <div *ngIf=\"!form.controls.newProcedureExpirationType.valid && form.controls.newProcedureExpirationType.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-3\">\n                                    <label for=\"newProcedureCustomDate\">Fecha de Vencimiento</label>\n                                    <input type=\"text\" class=\"form-control\" formControlName=\"newProcedureCustomDate\"\n                                           [(ngModel)]=\"newProcedure.customDate\" id=\"newProcedureCustomDate\"\n                                           name=\"newProcedureCustomDate\">\n                                    <div *ngIf=\"!form.controls.newProcedureCustomDate.valid && form.controls.newProcedureCustomDate.errors.pattern\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.invalidDate}}\n                                    </div>\n                                    <div *ngIf=\"!form.controls.newProcedureCustomDate.valid && form.controls.newProcedureCustomDate.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-6\">\n                                    <label for=\"newProcedureDescription\">Observaciones</label>\n                                    <textarea type=\"text\" class=\"form-control\" formControlName=\"newProcedureDescription\"\n                                              [(ngModel)]=\"newProcedure.description\" id=\"newProcedureDescription\"\n                                              name=\"newProcedureDescription\" rows=\"2\"></textarea>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-6\">\n                                    <label for=\"newProcedureComment\">Comentarios</label>\n                                    <textarea type=\"text\" class=\"form-control\" formControlName=\"newProcedureComment\"\n                                              [(ngModel)]=\"newProcedure.comment\" id=\"newProcedureComment\"\n                                              name=\"newProcedureComment\" rows=\"2\"></textarea>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <h3 class=\"titleUploader\">Trámite</h3>\n                                    <div *ngIf=\"newProcedure.document\">\n                                        <a href=\"/procedure/{{newProcedure.id}}/download\" target=\"file\">\n                                            <span class=\"paperclip\"><img></span>\n                                            {{newProcedure.document.name}}\n                                        </a>\n                                        <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                (click)=\"removeDocument()\"\n                                                *ngIf=\"canNew\">\n                                            <span class=\"trash\"><img></span>\n                                            Eliminar\n                                        </button>\n                                    </div>\n                                    <div *ngIf=\"canNew && (!newProcedure.document && uploaderDocument.queue.length == 0)\">\n                                        <div ng2FileDrop\n                                             [ngClass]=\"{'nv-file-over': hasDocumentDropZoneOver}\"\n                                             (fileOver)=\"fileOverDocument($event)\"\n                                             [uploader]=\"uploaderDocument\"\n                                             class=\"well my-drop-zone\">\n                                            Arrastre el archivo aqu&iacute;\n                                        </div>\n                                        <label for=\"inputDocument\" class=\"custom-file-upload\">\n                                            <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                                        </label>\n                                        <input id=\"inputDocument\" type=\"file\" ng2FileSelect\n                                               [uploader]=\"uploaderDocument\" #inputDocument/>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\" *ngIf=\"uploaderDocument.queue?.length > 0\">\n                                <div class=\"col-md-12\">\n                                    <h4>Archivo pendiente a asociar al trámite</h4>\n                                    <table class=\"table\">\n                                        <thead>\n                                        <tr>\n                                            <th width=\"50%\">Nombre</th>\n                                            <th>Tipo</th>\n                                            <th>Estado</th>\n                                            <th>Acciones</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr *ngFor=\"let item of uploaderDocument.queue\">\n                                            <td><strong>{{item.file.name}}</strong></td>\n                                            <td>TRÁMITE</td>\n                                            <td class=\"text-center\">\n                                                <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                                <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                                <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                            </td>\n                                            <td nowrap>\n                                                <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                        (click)=\"item.upload()\"\n                                                        [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                    <span class=\"upload-icon\"><img></span>\n                                                    Subir\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                        (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                                    <span class=\"ban-circle-white\"><img>Cancelar</span>\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                        (click)=\"removeDocumentFromQuee(item)\">\n                                                    <span class=\"trash\"><img></span> Eliminar\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        <tr *ngIf=\"uploaderDocument.queue?.length == 0\">\n                                            <td colspan=\"4\" class=\"text-center\">\n                                                No hay archivos pendientes de asociar al trámite\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-1\">\n                                    <button (click)=\"addNewProcedure($event)\"\n                                            class=\"btn btn-success procedureOption\"\n                                            [disabled]=\"checkIfNotValid()\">\n                                        <i class=\"fa fa-plus\"> Cargar trámite</i>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div *ngIf=\"vehicleId && loading\">\n                    <h4>Trámites</h4>\n                    <div *ngIf=\"vehicle?.procedures.length == 0\" class=\"row\">\n                        <div class=\"alert alert-info\">Sin trámites</div>\n                    </div>\n                    <div *ngIf=\"vehicle?.procedures.length != 0\" class=\"panel panel-default\">\n                        <div class=\"panel-body table-responsive\">\n                            <div class=\"alert alert-warning\" *ngIf=\"warningMessage\">{{warningMessage}}</div>\n                            <table class=\"table table-striped\">\n                                <thead>\n                                <tr>\n                                    <th style=\"width: 15%\">Fecha de carga</th>\n                                    <th style=\"width: 20%\">Tipo</th>\n                                    <th style=\"width: 10%\">Vencimiento</th>\n                                    <th style=\"width: 20%\">Comentarios</th>\n                                    <th style=\"width: 30%\">Documento</th>\n                                    <th *ngIf=\"canNew\" style=\"width: 5%\">Editar</th>\n                                    <th *ngIf=\"canNew\" style=\"width: 5%\">Eliminar</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr *ngFor=\"let item of vehicle.procedures; let i = index\">\n                                    <td>{{item.creationDate}}</td>\n                                    <td>{{item.type.description}}</td>\n                                    <td>{{item.customDate}}</td>\n                                    <td>{{item.description}}</td>\n                                    <td>\n                                        <a href=\"/procedure/{{(item.id) ? item.id : item.document.id}}/download\"\n                                           target=\"file\">\n                                            <span class=\"paperclip\"><img></span>\n                                            {{item.document.name}}\n                                        </a>\n                                    </td>\n                                    <td *ngIf=\"canNew\">\n                                        <button (click)=\"editProcedure($event, item)\"\n                                                class=\"btn btn-primary\">\n                                            <span class=\"pencil\"><img></span>\n                                        </button>\n                                    </td>\n                                    <td *ngIf=\"canNew\">\n                                        <button (click)=\"deleteProcedure($event, i, item.id, item.tempId)\"\n                                                class=\"btn btn-danger\">\n                                            <i class=\"fa fa-minus\"></i>\n                                        </button>\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"col-sm-12\">\n                    <div class=\"row\">\n                        <div class=\"form-group form-group-sm col-md-1\">\n                            <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"(!form.valid || !loading)\">\n                                Guardar\n                            </button>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-1\">\n                            <label class=\"hidden\" for=\"withSendMail\">Envío de Mail</label>\n                            <div class=\"input-group\">\n                                <input type=\"checkbox\" class=\"form-control checkbox\" id=\"withSendMail\"\n                                       formControlName=\"withSendMail\" [(ngModel)]=\"newProcedure.withSendMail\"\n                                       name=\"withSendMail\"\n                                       [disabled]=\"!canNew\">\n                                <span class=\"input-group-addon checkIcon\">\n                                    <!--<i class=\"glyphicon glyphicon-envelope\"></i>-->\n                                    <span class=\"envelope\"><img></span>\n                                </span>\n                            </div>\n                            <div *ngIf=\"!form.controls.withSendMail.valid\" class=\"alert-danger\">\n                                {{errorMessages.required}}\n                            </div>\n                        </div>\n                        <div class=\"form-group form-group-sm col-md-1\">\n                            <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                        </div>\n                    </div>\n                    <div class=\"row\" style=\"margin-top: 10px\">\n                        <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                        <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1115 */
1109,
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(643);
	var ng2_file_upload_1 = __webpack_require__(889);
	var client_service_1 = __webpack_require__(637);
	var vehicle_1 = __webpack_require__(873);
	var procedure_service_1 = __webpack_require__(916);
	var validators_1 = __webpack_require__(849);
	var procedure_1 = __webpack_require__(885);
	var sendRequestProcedureForm_1 = __webpack_require__(1117);
	var login_service_1 = __webpack_require__(404);
	var RequestProcedureComponent = (function () {
	    function RequestProcedureComponent(clientService, procedureService, loginService) {
	        this.clientService = clientService;
	        this.procedureService = procedureService;
	        this.loginService = loginService;
	        this.init();
	    }
	    RequestProcedureComponent.prototype.init = function () {
	        this.loading = false;
	        this.showVehicle = false;
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.newProcedure = new procedure_1.Procedure();
	        this.uploaderTitle = new ng2_file_upload_1.FileUploader({});
	        this.uploaderDNI = new ng2_file_upload_1.FileUploader({});
	        this.uploaderGreenCard = new ng2_file_upload_1.FileUploader({});
	        this.uploaderOther = new ng2_file_upload_1.FileUploader({});
	        this.hasTitleDropZoneOver = false;
	        this.hasDNIDropZoneOver = false;
	        this.hasGreenCardDropZoneOver = false;
	        this.hasOtherDropZoneOver = false;
	        this.sendRequestProcedure = new sendRequestProcedureForm_1.SendRequestProcedureForm();
	        this.vehicle = new vehicle_1.Vehicle();
	    };
	    RequestProcedureComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        this.createFormGroup();
	        if (this.userLogged.cuit) {
	            this.sendRequestProcedure.cuitNumber = this.userLogged.username;
	        }
	        else {
	            this.sendRequestProcedure.vehicleId = this.userLogged.username;
	            this.showVehicle = true;
	        }
	        this.find();
	        this.procedureService.generateProcedureTempId()
	            .subscribe(function (response) {
	            _this.sendRequestProcedure.tempId = response.value;
	            _this.updateUploadersUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al crear la solicitud de trámite.');
	        });
	    };
	    RequestProcedureComponent.prototype.updateUploadersUrl = function () {
	        var fileOwnerId = this.sendRequestProcedure.tempId;
	        this.uploaderTitle = new ng2_file_upload_1.FileUploader({
	            url: 'client/' + fileOwnerId + '/upload/TITLE',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.uploaderDNI = new ng2_file_upload_1.FileUploader({
	            url: 'client/' + fileOwnerId + '/upload/DNI',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.uploaderGreenCard = new ng2_file_upload_1.FileUploader({
	            url: 'client/' + fileOwnerId + '/upload/GREEN_CARD',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	        this.uploaderOther = new ng2_file_upload_1.FileUploader({
	            url: 'client/' + fileOwnerId + '/upload/OTHER',
	            autoUpload: true,
	            maxFileSize: validators_1.FILE_MAX_SIZE,
	        });
	    };
	    RequestProcedureComponent.prototype.createFormGroup = function () {
	        if (this.userLogged.cuit) {
	            this.form = new forms_1.FormGroup({
	                cuitNumber: new forms_1.FormControl('', [forms_1.Validators.required]),
	                vehicleId: new forms_1.FormControl('', [forms_1.Validators.required]),
	                newProcedureType: new forms_1.FormControl(this.newProcedure.type, [forms_1.Validators.required]),
	                newProcedureDescription: new forms_1.FormControl(this.newProcedure.description),
	            });
	        }
	        else if (this.userLogged.patent) {
	            this.form = new forms_1.FormGroup({
	                cuitNumber: new forms_1.FormControl('', [forms_1.Validators.required, validators_1.CUIT_VALIDATOR]),
	                patent: new forms_1.FormControl('', [forms_1.Validators.required]),
	                newProcedureType: new forms_1.FormControl(this.newProcedure.type, [forms_1.Validators.required]),
	                newProcedureDescription: new forms_1.FormControl(this.newProcedure.description),
	            });
	        }
	    };
	    RequestProcedureComponent.prototype.find = function () {
	        this.clearMessages();
	        this.getData();
	    };
	    RequestProcedureComponent.prototype.getData = function () {
	        var _this = this;
	        this.loading = true;
	        this.errorMessage = null;
	        if (this.sendRequestProcedure.cuitNumber) {
	            this.clientService.getVehiclesByCUIT(this.sendRequestProcedure.cuitNumber).subscribe(function (data) {
	                _this.vehicles = data;
	                if (_this.vehicles.length > 0) {
	                    _this.showVehicle = true;
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al obtener los vehículos asociados al CUIT.');
	            });
	        }
	        this.procedureService.getProcedureTypes().subscribe(function (data) {
	            _this.setData(data);
	        });
	    };
	    RequestProcedureComponent.prototype.setData = function (data) {
	        this.loading = false;
	        this.procedureType = data;
	        this.procedureType = this.procedureType.filter(function (obj) {
	            return obj.name == 'GREEN_CARD' ||
	                obj.name == 'BLUE_CARD' ||
	                obj.name == 'OTHER' ||
	                obj.name == 'PLATE_DUPLICATED' ||
	                obj.name == 'TITLE_DUPLICATED';
	        });
	    };
	    RequestProcedureComponent.prototype.checkNotValid = function () {
	        return false;
	        //TODO: En caso de que los documentos sean obligatorios
	        /*
	        if (this.newProcedure.type.name == 'GREEN_CARD' && this.uploaderTitle.queue.length == 1)
	            return false;
	        else if (this.newProcedure.type.name == 'BLUE_CARD' && this.uploaderTitle.queue.length == 1 && this.uploaderDNI.queue.length == 1)
	            return false;
	        else if (this.newProcedure.type.name == 'TITLE_DUPLICATED' && this.uploaderGreenCard.queue.length == 1)
	            return false;
	        else if (this.newProcedure.type.name == 'PLATE_DUPLICATED' && this.uploaderTitle.queue.length == 1)
	            return false;
	        else if (this.newProcedure.type.name == 'OTHER' && this.uploaderOther.queue.length == 1)
	            return false;
	
	        return true;
	        */
	    };
	    RequestProcedureComponent.prototype.procedureTypeChange = function (newValue) {
	        //Si cambio de tramite, tengo que volver a cargar documentos necesarios. Eliminando los ya cargados
	        //Evitamos el caso de cambiar a un tipo de tramite que no requiere dicho documento previamente cargado
	        this.uploaderTitle.clearQueue();
	        this.uploaderDNI.clearQueue();
	        this.uploaderGreenCard.clearQueue();
	        this.uploaderOther.clearQueue();
	        this.clearMessages();
	        var result = this.procedureType.filter(function (obj) {
	            return obj.id == newValue;
	        });
	        if (result.length > 0) {
	            this.newProcedure.type = result[0];
	            this.sendRequestProcedure.procedureType = result[0].description;
	        }
	    };
	    RequestProcedureComponent.prototype.send = function () {
	        var _this = this;
	        this.loading = true;
	        this.clearMessages();
	        this.clientService.sendRequestProcedure(this.sendRequestProcedure).subscribe(function () {
	            _this.loading = false;
	            _this.successMessage = 'La solicitud se envió con éxito.';
	            _this.clearInputs();
	            _this.updateAfterSave();
	        }, function () {
	            _this.bindError('Ocurrió un error al enviar la solicitud.');
	        });
	    };
	    RequestProcedureComponent.prototype.updateAfterSave = function () {
	        var _this = this;
	        this.procedureService.generateProcedureTempId()
	            .subscribe(function (response) {
	            _this.sendRequestProcedure.tempId = response.value;
	            _this.updateUploadersUrl();
	        }, function () {
	            _this.bindError('Ocurrió un error al crear la solicitud de trámite.');
	        });
	    };
	    RequestProcedureComponent.prototype.clearInputs = function () {
	        this.procedureTypeSelected = null;
	        this.contract = null;
	        this.newProcedure = new procedure_1.Procedure();
	        this.sendRequestProcedure.comments = '';
	        if (this.userLogged.patent)
	            this.sendRequestProcedure.cuitNumber = '';
	        this.uploaderTitle.clearQueue();
	        this.uploaderDNI.clearQueue();
	        this.uploaderGreenCard.clearQueue();
	        this.uploaderOther.clearQueue();
	    };
	    RequestProcedureComponent.prototype.removeTitleFromQuee = function (item) {
	        var _this = this;
	        this.clientService.deleteTempRequestProcedure(this.sendRequestProcedure.tempId, 'TITLE').subscribe(function (result) { return _this.uploaderTitle.removeFromQueue(item); }, function () {
	            _this.bindError('Ocurrió un error al remover el título.');
	        });
	    };
	    RequestProcedureComponent.prototype.removeDNIFromQuee = function (item) {
	        var _this = this;
	        this.clientService.deleteTempRequestProcedure(this.sendRequestProcedure.tempId, 'DNI').subscribe(function (result) { return _this.uploaderDNI.removeFromQueue(item); }, function () {
	            _this.bindError('Ocurrió un error al remover la copia del DNI.');
	        });
	    };
	    RequestProcedureComponent.prototype.removeGreenCardFromQuee = function (item) {
	        var _this = this;
	        this.clientService.deleteTempRequestProcedure(this.sendRequestProcedure.tempId, 'GREEN_CARD').subscribe(function (result) { return _this.uploaderGreenCard.removeFromQueue(item); }, function () {
	            _this.bindError('Ocurrió un error al remover el escaneo de la cédula verde.');
	        });
	    };
	    RequestProcedureComponent.prototype.removeOtherFromQuee = function (item) {
	        var _this = this;
	        this.clientService.deleteTempRequestProcedure(this.sendRequestProcedure.tempId, 'OTHER').subscribe(function (result) { return _this.uploaderOther.removeFromQueue(item); }, function () {
	            _this.bindError('Ocurrió un error al remover el documento.');
	        });
	    };
	    RequestProcedureComponent.prototype.fileOverTitle = function (e) {
	        this.hasTitleDropZoneOver = e;
	    };
	    RequestProcedureComponent.prototype.fileOverDNI = function (e) {
	        this.hasDNIDropZoneOver = e;
	    };
	    RequestProcedureComponent.prototype.fileOverGreenCard = function (e) {
	        this.hasGreenCardDropZoneOver = e;
	    };
	    RequestProcedureComponent.prototype.fileOverOther = function (e) {
	        this.hasOtherDropZoneOver = e;
	    };
	    RequestProcedureComponent.prototype.bindError = function (messageError) {
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    RequestProcedureComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    RequestProcedureComponent = __decorate([
	        core_1.Component({
	            selector: 'client-request-procedure',
	            template: __webpack_require__(1118),
	            styles: [__webpack_require__(1119)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_file_upload_1.FILE_UPLOAD_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS]
	        }), 
	        __metadata('design:paramtypes', [client_service_1.ClientService, procedure_service_1.ProcedureService, login_service_1.LoginService])
	    ], RequestProcedureComponent);
	    return RequestProcedureComponent;
	}());
	exports.RequestProcedureComponent = RequestProcedureComponent;


/***/ },
/* 1117 */
/***/ function(module, exports) {

	"use strict";
	var SendRequestProcedureForm = (function () {
	    function SendRequestProcedureForm(other) {
	        this.comments = '';
	        if (other) {
	            this.tempId = other.tempId;
	            this.cuitNumber = other.cuitNumber;
	            this.comments = other.comments;
	            this.procedureType = other.procedureType;
	            this.vehicleId = other.vehicleId;
	        }
	    }
	    return SendRequestProcedureForm;
	}());
	exports.SendRequestProcedureForm = SendRequestProcedureForm;


/***/ },
/* 1118 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\">Solicitud de Trámite</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <div class=\"col-md-12\">\n                <div *ngIf=\"errorMessage\" class=\"alert alert-danger\">{{errorMessage}}</div>\n                <div *ngIf=\"successMessage\" class=\"alert alert-success\">{{successMessage}}</div>\n            </div>\n            <form role=\"form\" (ngSubmit)=\"send()\" [formGroup]=\"form\">\n\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"cuitNumber\">Nro. de CUIT</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"cuitNumber\"\n                               name=\"cuitNumber\" [(ngModel)]=\"sendRequestProcedure.cuitNumber\"\n                               id=\"cuitNumber\" [disabled]=\"userLogged.cuit\">\n                        <div *ngIf=\"userLogged.patent && !form.controls.cuitNumber.valid && form.controls.cuitNumber.errors.pattern\"\n                             class=\"alert-danger\">\n                            {{errorMessages.invalidCuit}}\n                        </div>\n                    </div>\n\n                    <div *ngIf=\"(showVehicle && userLogged.cuit)\" class=\"form-group form-group-sm col-sm-3\">\n                        <label *ngIf=\"userLogged.cuit\" for=\"vehicleId\">Patentes asociadas al CUIT</label>\n                        <select class=\"form-control\" [(ngModel)]=\"sendRequestProcedure.vehicleId\" name=\"vehicleId\" id=\"vehicleId\">\n                            <option *ngFor=\"let vehicle of vehicles\" [ngValue]=\"vehicle.patent\">{{vehicle.patent}}</option>\n                        </select>\n                    </div>\n                    <div *ngIf=\"(!showVehicle && userLogged.cuit)\" class=\"form-group form-group-sm col-sm-3\">\n                        <p>No hay ningún vehículo asociado a este CUIT</p>\n                    </div>\n\n                    <div *ngIf=\"(showVehicle && userLogged.patent)\" class=\"form-group form-group-sm col-sm-3\">\n                        <label *ngIf=\"userLogged.patent\" for=\"vehicleId\">Nro. de Patente</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"patent\"\n                               name=\"patent\" [(ngModel)]=\"sendRequestProcedure.vehicleId\"\n                               id=\"patent\" [disabled]=\"userLogged.patent\">\n                    </div>\n\n                </div>\n\n                <div *ngIf=\"sendRequestProcedure?.vehicleId\">\n                    <h4>Solicitud de Trámite</h4>\n                    <div class=\"panel panel-default\">\n                        <div class=\"panel-body\">\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-4\">\n                                    <label for=\"newProcedureType\">Tipo</label>\n                                    <select class=\"form-control\" formControlName=\"newProcedureType\"\n                                            [(ngModel)]=\"procedureTypeSelected\"\n                                            name=\"newProcedureType\" id=\"newProcedureType\"\n                                            (change)=\"procedureTypeChange($event.target.value)\">\n                                        <option *ngFor=\"let type of procedureType\" [value]=\"type.id\">\n                                            {{type.description | uppercase}}\n                                        </option>\n                                    </select>\n                                    <div *ngIf=\"!form.controls.newProcedureType.valid && form.controls.newProcedureType.errors.required\"\n                                         class=\"alert-danger\">\n                                        {{errorMessages.required}}\n                                    </div>\n                                </div>\n                                <div class=\"form-group form-group-sm col-sm-8\">\n                                    <label for=\"newProcedureDescription\">Comentarios</label>\n                                    <textarea type=\"text\" class=\"form-control\" formControlName=\"newProcedureDescription\"\n                                              [(ngModel)]=\"sendRequestProcedure.comments\" id=\"newProcedureDescription\"\n                                              name=\"newProcedureDescription\" rows=\"2\"></textarea>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-12\">\n                                    <div *ngIf=\"(newProcedure.type.description==='CEDULA VERDE' ||\n                                                 newProcedure.type.description==='CEDULA AZUL' ||\n                                                 newProcedure.type.description==='DUPLICADO DE CHAPAS'\n                                                 )\">\n                                        <div *ngIf=\"uploaderTitle.queue?.length == 0\">\n                                            <label for=\"uploaderTitle\">Adjuntar Título</label>\n                                            <div ng2FileDrop\n                                                 [ngClass]=\"{'nv-file-over': hasTitleDropZoneOver}\"\n                                                 (fileOver)=\"fileOverTitle($event)\"\n                                                 [uploader]=\"uploaderTitle\"\n                                                 class=\"well my-drop-zone\">\n                                                Arrastre el archivo aqu&iacute;\n                                            </div>\n                                            <label for=\"inputDocument1\" class=\"custom-file-upload\">\n                                                <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                                            </label>\n                                            <input id=\"inputDocument1\" type=\"file\" ng2FileSelect\n                                                   [uploader]=\"uploaderTitle\" #inputDocument/>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-12\">\n                                    <div *ngIf=\"(newProcedure.type.description==='CEDULA AZUL')\">\n                                        <div *ngIf=\"uploaderDNI.queue?.length == 0\">\n                                            <label for=\"uploaderDNI\">Adjuntar Copia DNI</label>\n                                            <div ng2FileDrop\n                                                 [ngClass]=\"{'nv-file-over': hasDNIDropZoneOver}\"\n                                                 (fileOver)=\"fileOverDNI($event)\"\n                                                 [uploader]=\"uploaderDNI\"\n                                                 class=\"well my-drop-zone\">\n                                                Arrastre el archivo aqu&iacute;\n                                            </div>\n                                            <label for=\"inputDocument2\" class=\"custom-file-upload\">\n                                                <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                                            </label>\n                                            <input id=\"inputDocument2\" type=\"file\" ng2FileSelect\n                                                   [uploader]=\"uploaderDNI\" #inputDocument/>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-12\">\n                                    <div *ngIf=\"(newProcedure.type.description==='DUPLICADO DE TÍTULO')\">\n                                        <div *ngIf=\"uploaderGreenCard.queue?.length == 0\">\n                                            <label for=\"uploaderGreenCard\">Adjuntar Escaneo Cédula Verde</label>\n                                            <div ng2FileDrop\n                                                 [ngClass]=\"{'nv-file-over': hasGreenCardDropZoneOver}\"\n                                                 (fileOver)=\"fileOverGreenCard($event)\"\n                                                 [uploader]=\"uploaderGreenCard\"\n                                                 class=\"well my-drop-zone\">\n                                                Arrastre el archivo aqu&iacute;\n                                            </div>\n                                            <label for=\"inputDocument3\" class=\"custom-file-upload\">\n                                                <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                                            </label>\n                                            <input id=\"inputDocument3\" type=\"file\" ng2FileSelect\n                                                   [uploader]=\"uploaderGreenCard\" #inputDocument/>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"form-group form-group-sm col-sm-12\">\n                                    <div *ngIf=\"(newProcedure.type.description==='OTRO')\">\n                                        <div *ngIf=\"uploaderOther.queue?.length == 0\">\n                                            <label for=\"uploaderOther\">Adjuntar Documento</label>\n                                            <div ng2FileDrop\n                                                 [ngClass]=\"{'nv-file-over': hasOtherDropZoneOver}\"\n                                                 (fileOver)=\"fileOverOther($event)\"\n                                                 [uploader]=\"uploaderOther\"\n                                                 class=\"well my-drop-zone\">\n                                                Arrastre el archivo aqu&iacute;\n                                            </div>\n                                            <label for=\"inputDocument4\" class=\"custom-file-upload\">\n                                                <span class=\"upload-icon\"><img></span> Seleccionar archivo\n                                            </label>\n                                            <input id=\"inputDocument4\" type=\"file\" ng2FileSelect\n                                                   [uploader]=\"uploaderOther\" #inputDocument/>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-md-12\" *ngIf=\"(uploaderTitle.queue?.length > 0 || uploaderDNI.queue?.length > 0\n                                                               || uploaderGreenCard.queue?.length > 0 || uploaderDNI.queue?.length > 0\n                                                               || uploaderOther.queue?.length > 0)\">\n                                    <h4>Comprobante/s a enviar</h4>\n\n                                    <table class=\"table\">\n                                        <thead>\n                                        <tr>\n                                            <th width=\"50%\">Nombre</th>\n                                            <th>Estado</th>\n                                            <th>Acciones</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr *ngFor=\"let item of uploaderTitle.queue\">\n                                            <td><strong>{{item.file.name}}</strong></td>\n                                            <td class=\"text-center\">\n                                                <!--<span *ngIf=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                                <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                                <!--<span *ngIf=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                                <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                                <!--<span *ngIf=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n                                                <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                            </td>\n                                            <td nowrap>\n                                                <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                        (click)=\"item.upload()\"\n                                                        [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                    <span class=\"upload-icon\"><img></span>\n                                                    Subir\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                        (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                                    <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                                    <span class=\"ban-circle-white\"><img></span>\n                                                    Cancelar\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                        (click)=\"removeTitleFromQuee(item)\">\n                                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                                    <span class=\"trash\"><img></span>\n                                                    Eliminar\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        <tr *ngFor=\"let item of uploaderDNI.queue\">\n                                            <td><strong>{{item.file.name}}</strong></td>\n                                            <td class=\"text-center\">\n                                                <!--<span *ngIf=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                                <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                                <!--<span *ngIf=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                                <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                                <!--<span *ngIf=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n                                                <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                            </td>\n                                            <td nowrap>\n                                                <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                        (click)=\"item.upload()\"\n                                                        [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                    <span class=\"upload-icon\"><img></span>\n                                                    Subir\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                        (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                                    <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                                    <span class=\"ban-circle-white\"><img></span>\n                                                    Cancelar\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                        (click)=\"removeDNIFromQuee(item)\">\n                                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                                    <span class=\"trash\"><img></span>\n                                                    Eliminar\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        <tr *ngFor=\"let item of uploaderGreenCard.queue\">\n                                            <td><strong>{{item.file.name}}</strong></td>\n                                            <td class=\"text-center\">\n                                                <!--<span *ngIf=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                                <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                                <!--<span *ngIf=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                                <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                                <!--<span *ngIf=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n                                                <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                            </td>\n                                            <td nowrap>\n                                                <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                        (click)=\"item.upload()\"\n                                                        [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                    <span class=\"upload-icon\"><img></span>\n                                                    Subir\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                        (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                                    <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                                    <span class=\"ban-circle-white\"><img></span>\n                                                    Cancelar\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                        (click)=\"removeGreenCardFromQuee(item)\">\n                                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                                    <span class=\"trash\"><img></span>\n                                                    Eliminar\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        <tr *ngFor=\"let item of uploaderOther.queue\">\n                                            <td><strong>{{item.file.name}}</strong></td>\n                                            <td class=\"text-center\">\n                                                <!--<span *ngIf=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>-->\n                                                <span class=\"ok-icon\" *ngIf=\"item.isSuccess\"><img></span>\n                                                <!--<span *ngIf=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>-->\n                                                <span class=\"ban-circle\" *ngIf=\"item.isCancel\"><img></span>\n                                                <!--<span *ngIf=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>-->\n                                                <span class=\"remove\" *ngIf=\"item.isError\"><img></span>\n                                            </td>\n                                            <td nowrap>\n                                                <button type=\"button\" class=\"btn btn-success btn-xs\"\n                                                        (click)=\"item.upload()\"\n                                                        [disabled]=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                    <span class=\"upload-icon\"><img></span>\n                                                    Subir\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-warning btn-xs\"\n                                                        (click)=\"item.cancel()\" [disabled]=\"!item.isUploading\">\n                                                    <!--<span class=\"glyphicon glyphicon-ban-circle\"></span>-->\n                                                    <span class=\"ban-circle-white\"><img></span>\n                                                    Cancelar\n                                                </button>\n                                                <button type=\"button\" class=\"btn btn-danger btn-xs\"\n                                                        (click)=\"removeOtherFromQuee(item)\">\n                                                    <!--<span class=\"glyphicon glyphicon-trash\"></span>-->\n                                                    <span class=\"trash\"><img></span>\n                                                    Eliminar\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <div class=\"text-center\">\n                        <button type=\"submit\" class=\"btn btn-primary\"\n                                [disabled]=\"loading || !form.valid || checkNotValid()\">Enviar\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1119 */
/***/ function(module, exports) {

	module.exports = "textarea {\n    resize: vertical;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    border: 1px solid #ccc;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    background-color: #337ab7;\n    color: white;\n    border-radius: 4px;\n}"

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(350);
	var home_component_1 = __webpack_require__(855);
	var index_component_1 = __webpack_require__(638);
	var home_panel_component_1 = __webpack_require__(856);
	var vehicle_editor_component_1 = __webpack_require__(935);
	var contract_editor_component_1 = __webpack_require__(938);
	var infraction_editor_component_1 = __webpack_require__(941);
	var config_panel_component_1 = __webpack_require__(944);
	var under_construction_component_1 = __webpack_require__(946);
	var config_banks_component_1 = __webpack_require__(988);
	var bank_editor_component_1 = __webpack_require__(990);
	var config_roles_component_1 = __webpack_require__(994);
	var rol_editor_component_1 = __webpack_require__(997);
	var config_operators_component_1 = __webpack_require__(1000);
	var operator_editor_component_1 = __webpack_require__(1002);
	var config_infractionTypes_component_1 = __webpack_require__(1011);
	var infractionType_editor_component_1 = __webpack_require__(1027);
	var client_panel_component_1 = __webpack_require__(1004);
	var payReceipt_component_1 = __webpack_require__(1007);
	var config_clientDocuments_component_1 = __webpack_require__(1032);
	var config_mailTemplates_component_1 = __webpack_require__(1035);
	var mailTemplate_editor_component_1 = __webpack_require__(1043);
	var config_state_component_1 = __webpack_require__(1058);
	var state_editor_component_1 = __webpack_require__(1061);
	var kmHistory_editor_component_1 = __webpack_require__(1064);
	var procedures_editor_component_1 = __webpack_require__(1110);
	var patentPayment_editor_component_1 = __webpack_require__(1067);
	var vehicleBrand_editor_component_1 = __webpack_require__(1100);
	var config_vehicleBrands_component_1 = __webpack_require__(1102);
	var config_clientProcedureDocuments_component_1 = __webpack_require__(1104);
	var config_clientKmDocuments_component_1 = __webpack_require__(1105);
	var config_clientPatentDocuments_component_1 = __webpack_require__(1106);
	var pendingProcedures_editor_component_1 = __webpack_require__(1121);
	var singleProcedures_editor_component_1 = __webpack_require__(1107);
	var procedures_new_component_1 = __webpack_require__(1113);
	var bankSelector_component_1 = __webpack_require__(845);
	var requestProcedure_component_ts_1 = __webpack_require__(1116);
	var routes = [
	    { path: '', redirectTo: 'login', pathMatch: 'full' },
	    { path: 'login', component: index_component_1.IndexComponent },
	    {
	        path: 'app/home', component: home_component_1.HomeComponent,
	        children: [
	            { path: '', redirectTo: 'adminHome', pathMatch: 'full' },
	            { path: 'adminHome', component: home_panel_component_1.HomePanel },
	            { path: 'editVehicle/:contractId/:vehicleId/:contractEdit', component: vehicle_editor_component_1.VehicleEditorComponent },
	            { path: 'createVehicle', component: vehicle_editor_component_1.VehicleEditorComponent },
	            { path: 'createVehicle/:contractId', component: vehicle_editor_component_1.VehicleEditorComponent },
	            { path: 'editContract/:contractId', component: contract_editor_component_1.ContractEditorComponent },
	            { path: 'createContract', component: contract_editor_component_1.ContractEditorComponent },
	            { path: 'editInfraction/:infractionId', component: infraction_editor_component_1.InfractionEditorComponent },
	            { path: 'createInfraction', component: infraction_editor_component_1.InfractionEditorComponent },
	            { path: 'editKmHistory/:vehicleId', component: kmHistory_editor_component_1.KmHistoryEditorComponent },
	            { path: 'editProcedure/:vehicleId', component: procedures_editor_component_1.ProcedureEditorComponent },
	            { path: 'editSingleProcedure/:procedureId', component: singleProcedures_editor_component_1.SingleProcedureEditorComponent },
	            { path: 'editPendingProcedure/:procedureId', component: pendingProcedures_editor_component_1.PendingProcedureEditorComponent },
	            { path: 'editPatentPayment/:vehicleId', component: patentPayment_editor_component_1.PatentPaymentEditorComponent },
	            { path: 'createProcedure', component: procedures_new_component_1.ProcedureNewComponent },
	            {
	                path: 'config', component: config_panel_component_1.ConfigPanel,
	                children: [
	                    { path: '', redirectTo: 'infractionTypes', pathMatch: 'full' },
	                    { path: 'infractionTypes', component: config_infractionTypes_component_1.ConfigInfractionTypesComponent },
	                    { path: 'editInfractionType/:infractionTypeId', component: infractionType_editor_component_1.InfractionTypeEditorComponent },
	                    { path: 'createInfractionType', component: infractionType_editor_component_1.InfractionTypeEditorComponent },
	                    { path: 'states', component: config_state_component_1.ConfigStateComponent },
	                    { path: 'editState/:stateId', component: state_editor_component_1.StateEditorComponent },
	                    { path: 'createState', component: state_editor_component_1.StateEditorComponent },
	                    { path: 'operators', component: config_operators_component_1.ConfigOperatorsComponent },
	                    { path: 'editOperator/:userId', component: operator_editor_component_1.OperatorEditorComponent },
	                    { path: 'createOperator', component: operator_editor_component_1.OperatorEditorComponent },
	                    { path: 'cities', component: under_construction_component_1.UnderConstruction },
	                    { path: 'ocDocuments', component: under_construction_component_1.UnderConstruction },
	                    { path: 'banks', component: config_banks_component_1.ConfigBanksComponent },
	                    { path: 'editBank/:bankId', component: bank_editor_component_1.BankEditorComponent },
	                    { path: 'createBank', component: bank_editor_component_1.BankEditorComponent },
	                    { path: 'permissions', component: config_roles_component_1.ConfigRolesComponent },
	                    { path: 'editRol/:rolId', component: rol_editor_component_1.RolEditorComponent },
	                    { path: 'createRol', component: rol_editor_component_1.RolEditorComponent },
	                    { path: 'entes', component: under_construction_component_1.UnderConstruction },
	                    { path: 'clientDocuments', component: config_clientDocuments_component_1.ConfigClientDocumentsComponent },
	                    { path: 'vehicleBrands', component: config_vehicleBrands_component_1.ConfigVehicleBrandsComponent },
	                    { path: 'editVehicleBrand/:vehicleBrandId', component: vehicleBrand_editor_component_1.VehicleBrandEditorComponent },
	                    { path: 'createVehicleBrand', component: vehicleBrand_editor_component_1.VehicleBrandEditorComponent },
	                    { path: 'clientProcedureDocuments', component: config_clientProcedureDocuments_component_1.ConfigClientProcedureDocumentsComponent },
	                    { path: 'clientKmDocuments', component: config_clientKmDocuments_component_1.ConfigClientKmDocumentsComponent },
	                    { path: 'clientPatentDocuments', component: config_clientPatentDocuments_component_1.ConfigClientPatentDocumentsComponent }
	                ]
	            },
	            {
	                path: 'client', component: client_panel_component_1.ClientPanel,
	                children: [
	                    { path: '', redirectTo: 'home', pathMatch: 'full' },
	                    { path: 'home', component: home_panel_component_1.HomePanel },
	                    { path: 'payReceipt', component: payReceipt_component_1.PayReceiptComponent },
	                    { path: 'myProfile', component: under_construction_component_1.UnderConstruction },
	                    { path: 'contact', component: under_construction_component_1.UnderConstruction },
	                    { path: 'bankSelector', component: bankSelector_component_1.BankSelectorComponent },
	                    { path: 'requestProcedure', component: requestProcedure_component_ts_1.RequestProcedureComponent }
	                ]
	            },
	            { path: 'mailTemplateConfig', component: config_mailTemplates_component_1.ConfigMailTemplatesComponent },
	            { path: 'editMailTemplate/:mailTemplateId', component: mailTemplate_editor_component_1.MailTemplateEditorComponent },
	            { path: 'createMailTemplate', component: mailTemplate_editor_component_1.MailTemplateEditorComponent },
	        ]
	    },
	];
	exports.APP_ROUTER_PROVIDERS = [
	    router_1.provideRouter(routes)
	];


/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var router_1 = __webpack_require__(350);
	var forms_1 = __webpack_require__(643);
	var ng2_bootstrap_1 = __webpack_require__(680);
	var vehicles_service_1 = __webpack_require__(630);
	var contracts_service_1 = __webpack_require__(632);
	var procedure_service_1 = __webpack_require__(916);
	var bank_service_1 = __webpack_require__(631);
	var validators_1 = __webpack_require__(849);
	var navigation_service_1 = __webpack_require__(403);
	var user_1 = __webpack_require__(844);
	var login_service_1 = __webpack_require__(404);
	var PendingProcedureEditorComponent = (function () {
	    function PendingProcedureEditorComponent(router, vehiclesService, contractsService, bankService, route, procedureService, loginService, navigationService) {
	        this.router = router;
	        this.vehiclesService = vehiclesService;
	        this.contractsService = contractsService;
	        this.bankService = bankService;
	        this.route = route;
	        this.procedureService = procedureService;
	        this.loginService = loginService;
	        this.navigationService = navigationService;
	        this.showCreateVehicleButton = false;
	        this.canEditContract = false;
	        this.init();
	    }
	    PendingProcedureEditorComponent.prototype.init = function () {
	        this.errorMessages = validators_1.DEFAULT_ERROR_MESSAGES;
	        this.contractValid = false;
	        this.loading = false;
	        this.canEdit = false;
	    };
	    PendingProcedureEditorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.userLogged = this.loginService.getUserLogged();
	        this.loginService.getUserCredentials().subscribe(function (user) {
	            _this.userLogged = new user_1.User(user);
	            _this.userIsAdmin = _this.userLogged.isAdmin();
	            _this.loginService.setUserLogged(_this.userLogged);
	        }, function () {
	        });
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.procedureId = params['procedureId'];
	            _this.getData();
	        });
	    };
	    PendingProcedureEditorComponent.prototype.getData = function () {
	        this.getVehicles(1);
	    };
	    PendingProcedureEditorComponent.prototype.createFormGroup = function () {
	        this.form = new forms_1.FormGroup({
	            vehicleId: new forms_1.FormControl(this.vehicleId, [forms_1.Validators.required]),
	            contractNumber: new forms_1.FormControl(this.contract.contractNumber, [forms_1.Validators.required])
	        });
	    };
	    PendingProcedureEditorComponent.prototype.getVehicles = function (page) {
	        var _this = this;
	        this.errorMessage = null;
	        if (this.procedureId) {
	            this.loading = true;
	            this.procedureService.getContract(this.procedureId).subscribe(function (data) {
	                _this.contract = data.contract;
	                if (_this.contract) {
	                    _this.contractsService.getVehicles(_this.contract.id, 1, 10000) //TODO: Test, anda, pero el 1,10000 estan como de mas
	                        .subscribe(function (data) {
	                        _this.vehicles = data.content;
	                        _this.loading = false;
	                        _this.contractValid = true;
	                        _this.canEditVehicle = true;
	                        _this.canEditContract = false;
	                        _this.createFormGroup();
	                        //TODO: Mostrar que si no tiene ningun vehiculo en ese contrato, un mensaje para cargar (o mostrarlo siempre, como prefieran)
	                        if (_this.vehicles.length == 0 && _this.userIsAdmin) {
	                            _this.showCreateVehicleButton = true;
	                        }
	                    }, function () {
	                        _this.bindError('Ocurrió un error al obtener los vehículos asociados al contrato.');
	                    });
	                }
	            }, function () {
	                _this.bindError('Ocurrió un error al obtener el contrato asociado al trámite.');
	            });
	        }
	    };
	    PendingProcedureEditorComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    PendingProcedureEditorComponent.prototype.clearMessages = function () {
	        this.successMessage = null;
	        this.errorMessage = null;
	    };
	    PendingProcedureEditorComponent.prototype.save = function () {
	        var _this = this;
	        this.clearMessages();
	        this.loading = true;
	        if (this.vehicleId) {
	            // Asocia el vehiculo al tramite, desasocia el contrato del tramite, y guarda el tramite
	            this.procedureService.setVehicleId(this.vehicleId, this.procedureId).subscribe(function (data) {
	                _this.loading = false;
	                _this.canEditVehicle = false;
	                _this.successMessage = 'El vehículo se asoció al trámite con éxito';
	            }, function () {
	                _this.bindError('Ocurrió un error al asociar el vehículo al trámite.');
	            });
	        }
	    };
	    PendingProcedureEditorComponent.prototype.goBack = function (event) {
	        event.preventDefault();
	        window.history.back();
	    };
	    PendingProcedureEditorComponent.prototype.editItem = function (item) {
	        if (item.id != null && !isNaN(parseInt(item.id))) {
	            this.router.navigate(['app/home/editContract', item.id]);
	        }
	    };
	    PendingProcedureEditorComponent.prototype.bindError = function (messageError) {
	        this.loading = false;
	        if (this.errorMessage == null) {
	            this.errorMessage = messageError;
	        }
	        else {
	            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
	        }
	    };
	    PendingProcedureEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'pendingProcedures-editor',
	            template: __webpack_require__(1122),
	            styles: [__webpack_require__(1123)],
	            directives: [
	                forms_1.FORM_DIRECTIVES,
	                forms_1.REACTIVE_FORM_DIRECTIVES,
	                ng2_bootstrap_1.AlertComponent,
	                /*MyDatePicker,*/
	                ng2_bootstrap_1.TYPEAHEAD_DIRECTIVES
	            ],
	            providers: [forms_1.FORM_PROVIDERS],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, vehicles_service_1.VehiclesService, contracts_service_1.ContractsService, bank_service_1.BankService, router_1.ActivatedRoute, procedure_service_1.ProcedureService, login_service_1.LoginService, navigation_service_1.NavigationService])
	    ], PendingProcedureEditorComponent);
	    return PendingProcedureEditorComponent;
	}());
	exports.PendingProcedureEditorComponent = PendingProcedureEditorComponent;


/***/ },
/* 1122 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h2 class=\"panel-title\">Asociar veh&iacute;culo al tr&aacute;mite</h2>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"text-center\" [ngClass]=\"{ 'hidden': !loading }\">\n                <i class=\"fa fa-spinner fa-spin\" style=\"font-size:24px\"></i>\n            </div>\n        </div>\n        <div class=\"panel-body\">\n            <form role=\"form\" [formGroup]=\"form\" (ngSubmit)=\"save()\" *ngIf=\"contractValid\">\n                <div class=\"alert alert-danger\" *ngIf=\"errorMessage\">{{errorMessage}}</div>\n                <div class=\"alert alert-success\" *ngIf=\"successMessage\">{{successMessage}}</div>\n                <div class=\"row\">\n                    <div class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"contractNumber\">Nro. de Contrato</label>\n                        <input type=\"text\" class=\"form-control\" formControlName=\"contractNumber\"\n                               [(ngModel)]=\"contract.contractNumber\" name=\"contractNumber\" id=\"contractNumber\"\n                               [disabled]=\"!canEditContract\">\n                        <!--Si quieren poder editar el contrato desde esta ventana: descomentar (revisar permisos)-->\n                        <!--<div *ngIf=\"!showCreateVehicleButton\">-->\n                            <!--<button (click)=\"editItem(contract)\" class=\"btn btn-info\" id=\"editContract\">Editar-->\n                                <!--Contrato-->\n                            <!--</button>-->\n                        <!--</div>-->\n                    </div>\n                    <div *ngIf=\"!showCreateVehicleButton\" class=\"form-group form-group-sm col-sm-3\">\n                        <label for=\"vehicleId\">Patentes asociadas al Contrato</label>\n                        <select class=\"form-control\" [(ngModel)]=\"vehicleId\" name=\"vehicleId\" id=\"vehicleId\">\n                            <option *ngFor=\"let vehicle of vehicles\" [ngValue]=\"vehicle.id\">{{vehicle.patent}}</option>\n                        </select>\n                    </div>\n                    <div *ngIf=\"showCreateVehicleButton\" class=\"form-group form-group-sm col-sm-3\">\n                        <p>No hay ning&uacute;n veh&iacute;culo asociado a este contrato</p>\n                        <button (click)=\"editItem(contract)\" class=\"btn btn-info\">Editar contrato</button>\n                    </div>\n                </div>\n                <div class=\"col-sm-12\">\n                    <button type=\"submit\" class=\"btn btn-success\" [disabled]=\"!form.valid || loading\">Guardar\n                    </button>\n                    <button (click)=\"goBack($event)\" class=\"btn btn-default\">Volver</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>";

/***/ },
/* 1123 */
937
]);


/** WEBPACK FOOTER **
 ** js/app.75375a17f0bfd1a4154a.js
 **/